var __create = Object.create, __defProp = Object.defineProperty, __getOwnPropDesc = Object.getOwnPropertyDescriptor, __getOwnPropNames = Object.getOwnPropertyNames, __getProtoOf = Object.getPrototypeOf, __hasOwnProp = Object.prototype.hasOwnProperty, __esmMin = (e, b) => () => (e && (b = e(e = 0)), b), __commonJSMin = (e, b) => () => (b || e((b = { exports: {} }).exports, b), b.exports), __export = (e) => {
	let x = {};
	for (var S in e) __defProp(x, S, {
		get: e[S],
		enumerable: !0
	});
	return x;
}, __copyProps = (e, C, T, E) => {
	if (C && typeof C == "object" || typeof C == "function") for (var D = __getOwnPropNames(C), O = 0, k = D.length, A; O < k; O++) A = D[O], !__hasOwnProp.call(e, A) && A !== T && __defProp(e, A, {
		get: ((e) => C[e]).bind(null, A),
		enumerable: !(E = __getOwnPropDesc(C, A)) || E.enumerable
	});
	return e;
}, __toESM = (x, S, w) => (w = x == null ? {} : __create(__getProtoOf(x)), __copyProps(S || !x || !x.__esModule ? __defProp(w, "default", {
	value: x,
	enumerable: !0
}) : w, x)), __toCommonJS = (e) => __copyProps(__defProp({}, "__esModule", { value: !0 }), e);
function asyncGeneratorStep(e, b, x, S, C, w, T) {
	try {
		var E = e[w](T), D = E.value;
	} catch (e) {
		x(e);
		return;
	}
	E.done ? b(D) : Promise.resolve(D).then(S, C);
}
function _asyncToGenerator(e) {
	return function() {
		var b = this, x = arguments;
		return new Promise(function(S, C) {
			var w = e.apply(b, x);
			function T(e) {
				asyncGeneratorStep(w, S, C, T, E, "next", e);
			}
			function E(e) {
				asyncGeneratorStep(w, S, C, T, E, "throw", e);
			}
			T(void 0);
		});
	};
}
function _typeof$8(e) {
	"@babel/helpers - typeof";
	return _typeof$8 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
		return typeof e;
	} : function(e) {
		return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
	}, _typeof$8(e);
}
function toPrimitive(e, b) {
	if (_typeof$8(e) != "object" || !e) return e;
	var x = e[Symbol.toPrimitive];
	if (x !== void 0) {
		var S = x.call(e, b || "default");
		if (_typeof$8(S) != "object") return S;
		throw TypeError("@@toPrimitive must return a primitive value.");
	}
	return (b === "string" ? String : Number)(e);
}
function toPropertyKey(e) {
	var b = toPrimitive(e, "string");
	return _typeof$8(b) == "symbol" ? b : b + "";
}
function _defineProperty(e, b, x) {
	return (b = toPropertyKey(b)) in e ? Object.defineProperty(e, b, {
		value: x,
		enumerable: !0,
		configurable: !0,
		writable: !0
	}) : e[b] = x, e;
}
var data_exports = /* @__PURE__ */ __export({
	I: () => "l",
	default: () => data_default,
	m: () => "rn",
	µ: () => "μ",
	Æ: () => "AE",
	Ç: () => "C̦",
	Ð: () => "D̵",
	Ø: () => "O̸",
	æ: () => "ae",
	ç: () => "c̦",
	ð: () => ð,
	ö: () => "ة",
	ø: () => "o̸",
	Đ: () => "D̵",
	đ: () => "d̵",
	Ě: () => "Ĕ",
	ě: () => "ĕ",
	Ħ: () => "H̵",
	ħ: () => "h̵",
	ı: () => "i",
	Ĳ: () => "lJ",
	ĳ: () => "ij",
	Ŀ: () => "l·",
	ŀ: () => "l·",
	Ł: () => "L̸",
	ł: () => "l̸",
	ņ: () => "ɲ",
	ŉ: () => "'n",
	Ő: () => "Ö",
	Œ: () => "OE",
	œ: () => "oe",
	ţ: () => "ƫ",
	Ŧ: () => "T̵",
	ŧ: () => "t̵",
	ſ: () => "f",
	ƀ: () => "b̵",
	Ɓ: () => "'B",
	Ƃ: () => "b̄",
	ƃ: () => "b̄",
	Ƅ: () => "b",
	Ƈ: () => "C'",
	Ɖ: () => "D̵",
	Ɗ: () => "'D",
	ƌ: () => "d̄",
	ƍ: () => "g",
	Ƒ: () => "F̦",
	ƒ: () => "f̦",
	Ɠ: () => "G'",
	Ɩ: () => "l",
	Ɨ: () => "l̵",
	Ƙ: () => "K'",
	ƙ: () => "k̔",
	ƚ: () => "l̵",
	Ɲ: () => "N̦",
	ƞ: () => "n̩",
	Ɵ: () => "O̵",
	Ơ: () => "O'",
	ơ: () => "o'",
	Ƥ: () => "'P",
	ƥ: () => "p̔",
	Ʀ: () => "R",
	Ƨ: () => "2",
	Ƭ: () => "'T",
	ƭ: () => "t̔",
	Ʈ: () => "T̨",
	Ƴ: () => "'Y",
	ƴ: () => "y̔",
	Ƶ: () => "Z̵",
	ƶ: () => "z̵",
	Ʒ: () => "3",
	ƻ: () => "2̵",
	Ƽ: () => "5",
	ƽ: () => "s",
	ƿ: () => "þ",
	ǀ: () => "l",
	ǁ: () => "ll",
	ǃ: () => "!",
	Ǆ: () => "DŽ",
	ǅ: () => "Dž",
	ǆ: () => "dž",
	Ǉ: () => "LJ",
	ǈ: () => "Lj",
	ǉ: () => "lj",
	Ǌ: () => "NJ",
	ǋ: () => "Nj",
	ǌ: () => "nj",
	Ǎ: () => "Ă",
	ǎ: () => "ă",
	Ǐ: () => "Ĭ",
	ǐ: () => "ĭ",
	Ǒ: () => "Ŏ",
	ǒ: () => "ŏ",
	Ǔ: () => "Ŭ",
	ǔ: () => "ŭ",
	Ǥ: () => "G̵",
	ǥ: () => "g̵",
	Ǧ: () => "Ğ",
	ǧ: () => "ğ",
	Ǳ: () => "DZ",
	ǲ: () => "Dz",
	ǳ: () => "dz",
	ǵ: () => "ģ",
	Ǿ: () => Ǿ,
	Ț: () => "Ţ",
	ț: () => "ƫ",
	Ȝ: () => "3",
	Ȣ: () => "8",
	ȣ: () => "8",
	Ȥ: () => "Z̦",
	ȥ: () => "z̦",
	Ȧ: () => "Å",
	ȧ: () => "å",
	ȼ: () => "c̸",
	Ⱦ: () => "T̸",
	Ɂ: () => "?",
	Ʉ: () => "U̵",
	Ɇ: () => "E̸",
	ɇ: () => "e̸",
	Ɉ: () => "J̵",
	ɉ: () => "j̵",
	ɍ: () => "r̵",
	Ɏ: () => "Y̵",
	ɏ: () => "y̵",
	ɑ: () => "a",
	ɓ: () => "b̔",
	ɖ: () => "d̨",
	ɗ: () => "d̔",
	ə: () => "ǝ",
	ɚ: () => ɚ,
	ɛ: () => "ꞓ",
	ɠ: () => "g̔",
	ɡ: () => "g",
	ɣ: () => "y",
	ɦ: () => "h̔",
	ɨ: () => "i̵",
	ɩ: () => "i",
	ɪ: () => "i",
	ɫ: () => "l̴",
	ɭ: () => "l̨",
	ɮ: () => "lȝ",
	ɯ: () => "w",
	ɱ: () => ɱ,
	ɳ: () => "n̨",
	ɵ: () => "o̵",
	ɶ: () => ɶ,
	ɼ: () => "r̩",
	ɽ: () => "r̨",
	ʂ: () => "s̨",
	ʋ: () => "u",
	ʏ: () => "y",
	ʐ: () => "z̨",
	ʒ: () => "ȝ",
	ʔ: () => "?",
	ʠ: () => "q̔",
	ʣ: () => "dz",
	ʤ: () => "dȝ",
	ʥ: () => "dʑ",
	ʦ: () => "ts",
	ʧ: () => "tʃ",
	ʨ: () => "tɕ",
	ʩ: () => "fŋ",
	ʪ: () => "ls",
	ʫ: () => "lz",
	ʳ: () => "ᣴ",
	ʹ: () => "'",
	ʺ: () => "''",
	ʻ: () => "'",
	ʼ: () => "'",
	ʽ: () => "'",
	ʾ: () => "'",
	ʿ: () => "ՙ",
	ˆ: () => "^",
	ˈ: () => "'",
	ˊ: () => "'",
	ˋ: () => "'",
	ː: () => ":",
	ˡ: () => "ᣳ",
	ˢ: () => "ᣵ",
	ˤ: () => "ˁ",
	ˮ: () => "''",
	Ͱ: () => "Ⱶ",
	ʹ: () => "'",
	Ͷ: () => "И",
	ͷ: () => "ᴎ",
	ͺ: () => "i",
	ͻ: () => "ɔ",
	ͽ: () => "ꜿ",
	Ϳ: () => "J",
	Α: () => "A",
	Β: () => "B",
	Ε: () => "E",
	Ζ: () => "Z",
	Η: () => "H",
	Θ: () => "O̵",
	Ι: () => "l",
	Κ: () => "K",
	Λ: () => "Ʌ",
	Μ: () => "M",
	Ν: () => "N",
	Ο: () => "O",
	Ρ: () => "P",
	Σ: () => "Ʃ",
	Τ: () => "T",
	Υ: () => "Y",
	Χ: () => "X",
	α: () => "a",
	β: () => "ß",
	γ: () => "y",
	δ: () => "ẟ",
	ε: () => "ꞓ",
	η: () => "n̩",
	θ: () => "O̵",
	ι: () => "i",
	κ: () => "ĸ",
	ν: () => "v",
	ο: () => "o",
	ρ: () => "p",
	σ: () => "o",
	τ: () => "ᴛ",
	υ: () => "u",
	φ: () => "ɸ",
	ϐ: () => "ß",
	ϑ: () => "O̵",
	ϒ: () => "Y",
	ϕ: () => "ɸ",
	ϖ: () => "π",
	ϛ: () => "ς",
	Ϝ: () => "F",
	Ϩ: () => "2",
	ϩ: () => "ƨ",
	ϰ: () => "ĸ",
	ϱ: () => "p",
	ϲ: () => "c",
	ϳ: () => "j",
	ϴ: () => "O̵",
	ϵ: () => "ꞓ",
	Ϸ: () => "Þ",
	ϸ: () => "þ",
	Ϲ: () => "C",
	Ϻ: () => "M",
	Ͻ: () => "Ɔ",
	Ͽ: () => "Ꜿ",
	Є: () => "Ꞓ",
	Ѕ: () => "S",
	І: () => "l",
	Ј: () => "J",
	А: () => "A",
	Б: () => "b̄",
	В: () => "B",
	Г: () => "Γ",
	Е: () => "E",
	З: () => "3",
	Й: () => "Ѝ",
	К: () => "K",
	Л: () => "Ʌ",
	М: () => "M",
	Н: () => "H",
	О: () => "O",
	П: () => "Π",
	Р: () => "P",
	С: () => "C",
	Т: () => "T",
	У: () => "Y",
	Ф: () => "Φ",
	Х: () => "X",
	Ы: () => "bl",
	Ь: () => "b",
	Ю: () => "lO",
	а: () => "a",
	б: () => "6",
	в: () => "ʙ",
	г: () => "r",
	е: () => "e",
	з: () => "ɜ",
	и: () => "ᴎ",
	к: () => "ĸ",
	м: () => "ʍ",
	н: () => "ʜ",
	о: () => "o",
	п: () => "π",
	р: () => "p",
	с: () => "c",
	т: () => "ᴛ",
	у: () => "y",
	ф: () => "ɸ",
	х: () => "x",
	ъ: () => "ˉb",
	ы: () => "ƅi",
	ь: () => "ƅ",
	я: () => "ᴙ",
	є: () => "ꞓ",
	ѕ: () => "s",
	і: () => "i",
	ј: () => "j",
	ћ: () => "h̵",
	ѝ: () => "й",
	ѡ: () => "w",
	Ѣ: () => "b̵",
	ѣ: () => "b̵",
	Ѱ: () => "Ψ",
	ѱ: () => "ψ",
	Ѳ: () => "O̵",
	ѳ: () => "o̵",
	Ѵ: () => "V",
	ѵ: () => "v",
	Ѽ: () => Ѽ,
	ѽ: () => ѽ,
	Ҋ: () => Ҋ,
	ҋ: () => ҋ,
	Ҍ: () => "b̵",
	ҍ: () => "b̵",
	Ґ: () => "Γ'",
	ґ: () => "r'",
	Ғ: () => Ғ,
	ғ: () => "r̵",
	Җ: () => Җ,
	җ: () => җ,
	Ҙ: () => "3̦",
	ҙ: () => ҙ,
	Қ: () => "K̩",
	қ: () => қ,
	Ҟ: () => "K̵",
	ҟ: () => ҟ,
	Ң: () => "H̩",
	ң: () => ң,
	Ҫ: () => "C̦",
	ҫ: () => "c̦",
	Ҭ: () => "T̩",
	ҭ: () => ҭ,
	Ү: () => "Y",
	ү: () => "y",
	Ұ: () => "Y̵",
	ұ: () => "y̵",
	Ҳ: () => "X̩",
	һ: () => "h",
	ҽ: () => "e",
	Ҿ: () => Ҿ,
	ҿ: () => "ę",
	Ӏ: () => "l",
	Ӆ: () => Ӆ,
	ӆ: () => ӆ,
	Ӈ: () => "H̦",
	ӈ: () => ӈ,
	Ӊ: () => "H̦",
	ӊ: () => ӊ,
	Ӌ: () => "Ҷ",
	ӌ: () => "ҷ",
	Ӎ: () => "M̦",
	ӎ: () => ӎ,
	ӏ: () => "i",
	Ӕ: () => "AE",
	ӕ: () => "ae",
	Ә: () => "Ə",
	ә: () => "ǝ",
	Ӡ: () => "3",
	ӡ: () => "ȝ",
	Ө: () => "O̵",
	ө: () => "o̵",
	ԁ: () => "d",
	Ԋ: () => "Ƕ",
	Ԍ: () => "G",
	ԍ: () => "ɢ",
	Ԑ: () => "Ɛ",
	ԑ: () => "ꞓ",
	ԛ: () => "q",
	Ԝ: () => "W",
	ԝ: () => "w",
	Ի: () => "ኮ",
	Մ: () => "ሆ",
	Պ: () => "ጣ",
	Ռ: () => "ቡ",
	Ս: () => "U",
	Տ: () => "S",
	Փ: () => "Φ",
	Օ: () => "O",
	ա: () => "w",
	գ: () => "q",
	զ: () => "q",
	ծ: () => "ẟ",
	հ: () => "h",
	յ: () => "ȷ",
	ո: () => "n",
	պ: () => "ɰ",
	ռ: () => "n",
	ս: () => "u",
	ց: () => "g",
	ք: () => "f",
	օ: () => "o",
	և: () => և,
	ו: () => "l",
	ט: () => "v",
	י: () => "'",
	ן: () => "l",
	ס: () => "o",
	װ: () => "ll",
	ױ: () => "l'",
	ײ: () => "''",
	أ: () => "lٴ",
	ؤ: () => ؤ,
	إ: () => "lٕ",
	ئ: () => ئ,
	ا: () => "l",
	ث: () => ث,
	ش: () => ش,
	ؽ: () => ؽ,
	ؿ: () => ؿ,
	ه: () => "o",
	ي: () => "ى",
	ٮ: () => "ى",
	ٯ: () => "ڡ",
	ٲ: () => "lٴ",
	ٳ: () => "lٕ",
	ٵ: () => "lٴ",
	ٶ: () => ٶ,
	ٷ: () => ٷ,
	ٸ: () => ٸ,
	ٹ: () => ٹ,
	پ: () => پ,
	ځ: () => ځ,
	څ: () => څ,
	ڈ: () => ڈ,
	ڋ: () => ڋ,
	ڎ: () => ڎ,
	ڑ: () => ڑ,
	ڒ: () => ڒ,
	ژ: () => ژ,
	ڞ: () => ڞ,
	ڟ: () => ڟ,
	ڤ: () => ڤ,
	ڧ: () => "ف",
	ڨ: () => ڨ,
	ک: () => "ك",
	ڪ: () => "ك",
	ڭ: () => ڭ,
	ڴ: () => ڴ,
	ڵ: () => ڵ,
	ڷ: () => ڷ,
	ں: () => "ى",
	ڻ: () => ڻ,
	ڽ: () => ڽ,
	ھ: () => "o",
	ہ: () => "o",
	ۂ: () => "ۀ",
	ۃ: () => "ة",
	ۆ: () => ۆ,
	ۇ: () => ۇ,
	ۈ: () => ۈ,
	ۉ: () => ۉ,
	ۋ: () => ۋ,
	ی: () => "ى",
	ێ: () => ێ,
	ې: () => "ٻ",
	ۑ: () => ۑ,
	ے: () => "ى",
	ە: () => "o",
	ۮ: () => ۮ,
	ۯ: () => ۯ,
	ۿ: () => "ô",
	ݑ: () => ݑ,
	ݖ: () => ݖ,
	ݢ: () => "ڬ",
	ݣ: () => ݣ,
	ݧ: () => "ݔ",
	ݨ: () => ݨ,
	ݩ: () => ݩ,
	ݬ: () => ݬ,
	ݱ: () => ݱ,
	ݲ: () => ݲ,
	ݾ: () => ݾ,
	ߊ: () => "l",
	ߴ: () => "'",
	ߵ: () => "'",
	ߺ: () => "_",
	ࢡ: () => ࢡ,
	ࢤ: () => ࢤ,
	ࢧ: () => ࢧ,
	ࢨ: () => ࢨ,
	ࢩ: () => "ݔ",
	ࢮ: () => ࢮ,
	ࢯ: () => ࢯ,
	ࢰ: () => "گ",
	ࢱ: () => "و",
	ࢲ: () => ࢲ,
	ࢶ: () => ࢶ,
	ࢷ: () => ࢷ,
	ࢹ: () => ࢹ,
	ࢺ: () => ࢺ,
	ࢻ: () => "ڡ",
	ࢼ: () => "ڡ",
	ࢽ: () => "ى",
	ऄ: () => ऄ,
	आ: () => आ,
	ई: () => ई,
	ऍ: () => ऍ,
	ऎ: () => ऎ,
	ऐ: () => ऐ,
	ऑ: () => ऑ,
	ऒ: () => ऒ,
	ओ: () => ओ,
	औ: () => औ,
	ॽ: () => "?",
	আ: () => আ,
	ৠ: () => ৠ,
	ৡ: () => ৡ,
	ਆ: () => ਆ,
	ਇ: () => ਇ,
	ਈ: () => ਈ,
	ਉ: () => ਉ,
	ਊ: () => ਊ,
	ਏ: () => ਏ,
	ਐ: () => ਐ,
	ਔ: () => ਔ,
	આ: () => આ,
	ઍ: () => ઍ,
	એ: () => એ,
	ઐ: () => ઐ,
	ઑ: () => ઑ,
	ઓ: () => ઓ,
	ઔ: () => ઔ,
	ઽ: () => "ऽ",
	ଆ: () => ଆ,
	ଠ: () => "O",
	ஊ: () => ஊ,
	ஜ: () => "ஐ",
	ர: () => "ஈ",
	ఓ: () => ఓ,
	ఔ: () => ఔ,
	ఠ: () => ఠ,
	ఢ: () => ఢ,
	థ: () => థ,
	భ: () => భ,
	మ: () => మ,
	ష: () => ష,
	హ: () => హ,
	ౠ: () => ౠ,
	ౡ: () => ౡ,
	ಅ: () => "అ",
	ಆ: () => "ఆ",
	ಇ: () => "ఇ",
	ಒ: () => "ఒ",
	ಓ: () => ಓ,
	ಔ: () => ಔ,
	ಜ: () => "జ",
	ಞ: () => "ఞ",
	ಣ: () => "ణ",
	ಯ: () => "య",
	ಱ: () => "ఱ",
	ಲ: () => "ల",
	ೡ: () => ೡ,
	ഈ: () => ഈ,
	ഉ: () => "உ",
	ഊ: () => ഊ,
	ഌ: () => ഌ,
	ഐ: () => ഐ,
	ഓ: () => ഓ,
	ഔ: () => ഔ,
	ങ: () => ങ,
	ജ: () => "ஐ",
	ഠ: () => "o",
	ണ: () => "ண",
	റ: () => "ര",
	ഴ: () => "ழ",
	ശ: () => "ஶ",
	ഺ: () => ഺ,
	ൎ: () => "ॱ",
	ൟ: () => ൟ,
	ൡ: () => "ഞ",
	ൻ: () => ൻ,
	ർ: () => ർ,
	ฃ: () => "ข",
	ซ: () => "ช",
	ฏ: () => "ฎ",
	ด: () => "ค",
	ต: () => "ค",
	ท: () => "ฑ",
	ม: () => "ฆ",
	ฦ: () => "ภ",
	ำ: () => ำ,
	แ: () => แ,
	ๅ: () => "า",
	ຈ: () => "จ",
	ຍ: () => "ย",
	ບ: () => "บ",
	ປ: () => "ป",
	ຝ: () => "ฝ",
	ພ: () => "พ",
	ຟ: () => "ฟ",
	ຳ: () => ຳ,
	ໜ: () => ໜ,
	ໝ: () => ໝ,
	ༀ: () => ༀ,
	ཪ: () => "ར",
	က: () => က,
	တ: () => တ,
	ဝ: () => "o",
	ဟ: () => ဟ,
	ဩ: () => ဩ,
	ဪ: () => ဪ,
	ၥ: () => "၁",
	ၦ: () => ၦ,
	ၯ: () => ၯ,
	ၰ: () => ၰ,
	ၾ: () => ၾ,
	ႁ: () => ႁ,
	Ⴀ: () => "Ꞇ",
	ყ: () => "y",
	ჳ: () => "ȝ",
	ჿ: () => "o",
	ᄁ: () => ᄁ,
	ᄄ: () => ᄄ,
	ᄈ: () => ᄈ,
	ᄊ: () => ᄊ,
	ᄍ: () => ᄍ,
	ᄓ: () => ᄓ,
	ᄔ: () => ᄔ,
	ᄕ: () => ᄕ,
	ᄖ: () => ᄖ,
	ᄗ: () => ᄗ,
	ᄘ: () => ᄘ,
	ᄙ: () => ᄙ,
	ᄚ: () => ᄚ,
	ᄛ: () => ᄛ,
	ᄜ: () => ᄜ,
	ᄝ: () => ᄝ,
	ᄞ: () => ᄞ,
	ᄟ: () => ᄟ,
	ᄠ: () => ᄠ,
	ᄡ: () => ᄡ,
	ᄢ: () => ᄢ,
	ᄣ: () => ᄣ,
	ᄤ: () => ᄤ,
	ᄥ: () => ᄥ,
	ᄦ: () => ᄦ,
	ᄧ: () => ᄧ,
	ᄨ: () => ᄨ,
	ᄩ: () => ᄩ,
	ᄪ: () => ᄪ,
	ᄫ: () => ᄫ,
	ᄬ: () => ᄬ,
	ᄭ: () => ᄭ,
	ᄮ: () => ᄮ,
	ᄯ: () => ᄯ,
	ᄰ: () => ᄰ,
	ᄱ: () => ᄱ,
	ᄲ: () => ᄲ,
	ᄳ: () => ᄳ,
	ᄴ: () => ᄴ,
	ᄵ: () => ᄵ,
	ᄶ: () => ᄶ,
	ᄷ: () => ᄷ,
	ᄸ: () => ᄸ,
	ᄹ: () => ᄹ,
	ᄺ: () => ᄺ,
	ᄻ: () => ᄻ,
	ᄽ: () => ᄽ,
	ᄿ: () => ᄿ,
	ᅁ: () => ᅁ,
	ᅂ: () => ᅂ,
	ᅃ: () => ᅃ,
	ᅄ: () => ᅄ,
	ᅅ: () => ᅅ,
	ᅆ: () => ᅆ,
	ᅇ: () => ᅇ,
	ᅈ: () => ᅈ,
	ᅉ: () => ᅉ,
	ᅊ: () => ᅊ,
	ᅋ: () => ᅋ,
	ᅍ: () => ᅍ,
	ᅏ: () => ᅏ,
	ᅑ: () => ᅑ,
	ᅒ: () => ᅒ,
	ᅓ: () => ᅓ,
	ᅖ: () => ᅖ,
	ᅗ: () => ᅗ,
	ᅘ: () => ᅘ,
	ᅚ: () => ᅚ,
	ᅛ: () => ᅛ,
	ᅜ: () => ᅜ,
	ᅝ: () => ᅝ,
	ᅞ: () => ᅞ,
	ᅢ: () => ᅢ,
	ᅤ: () => ᅤ,
	ᅦ: () => ᅦ,
	ᅨ: () => ᅨ,
	ᅪ: () => ᅪ,
	ᅫ: () => ᅫ,
	ᅬ: () => ᅬ,
	ᅯ: () => ᅯ,
	ᅰ: () => ᅰ,
	ᅱ: () => ᅱ,
	ᅳ: () => "ー",
	ᅴ: () => ᅴ,
	ᅵ: () => "丨",
	ᅶ: () => ᅶ,
	ᅷ: () => ᅷ,
	ᅸ: () => ᅸ,
	ᅹ: () => ᅹ,
	ᅺ: () => ᅺ,
	ᅻ: () => ᅻ,
	ᅼ: () => ᅼ,
	ᅽ: () => ᅽ,
	ᅾ: () => ᅾ,
	ᅿ: () => ᅿ,
	ᆀ: () => ᆀ,
	ᆁ: () => ᆁ,
	ᆂ: () => ᆂ,
	ᆃ: () => ᆃ,
	ᆄ: () => ᆄ,
	ᆅ: () => ᆅ,
	ᆆ: () => ᆆ,
	ᆇ: () => ᆇ,
	ᆈ: () => ᆈ,
	ᆉ: () => ᆉ,
	ᆊ: () => ᆊ,
	ᆋ: () => ᆋ,
	ᆌ: () => ᆌ,
	ᆍ: () => ᆍ,
	ᆎ: () => ᆎ,
	ᆏ: () => ᆏ,
	ᆐ: () => ᆐ,
	ᆑ: () => ᆑ,
	ᆒ: () => ᆒ,
	ᆓ: () => ᆓ,
	ᆔ: () => ᆔ,
	ᆕ: () => ᆕ,
	ᆖ: () => ᆖ,
	ᆗ: () => ᆗ,
	ᆘ: () => ᆘ,
	ᆙ: () => ᆙ,
	ᆚ: () => ᆚ,
	ᆛ: () => ᆛ,
	ᆜ: () => ᆜ,
	ᆝ: () => ᆝ,
	ᆟ: () => ᆟ,
	ᆠ: () => ᆠ,
	ᆡ: () => ᆡ,
	ᆢ: () => ᆢ,
	ᆣ: () => ᆣ,
	ᆤ: () => ᆤ,
	ᆥ: () => ᆥ,
	ᆦ: () => ᆦ,
	ᆧ: () => ᆧ,
	ᆨ: () => "ᄀ",
	ᆩ: () => ᆩ,
	ᆪ: () => ᆪ,
	ᆫ: () => "ᄂ",
	ᆬ: () => ᆬ,
	ᆭ: () => ᆭ,
	ᆮ: () => "ᄃ",
	ᆯ: () => "ᄅ",
	ᆰ: () => ᆰ,
	ᆱ: () => ᆱ,
	ᆲ: () => ᆲ,
	ᆳ: () => ᆳ,
	ᆴ: () => ᆴ,
	ᆵ: () => ᆵ,
	ᆶ: () => ᆶ,
	ᆷ: () => "ᄆ",
	ᆸ: () => "ᄇ",
	ᆹ: () => ᆹ,
	ᆺ: () => "ᄉ",
	ᆻ: () => ᆻ,
	ᆼ: () => "ᄋ",
	ᆽ: () => "ᄌ",
	ᆾ: () => "ᄎ",
	ᆿ: () => "ᄏ",
	ᇀ: () => "ᄐ",
	ᇁ: () => "ᄑ",
	ᇂ: () => "ᄒ",
	ᇃ: () => ᇃ,
	ᇄ: () => ᇄ,
	ᇅ: () => ᇅ,
	ᇆ: () => ᇆ,
	ᇇ: () => ᇇ,
	ᇈ: () => ᇈ,
	ᇉ: () => ᇉ,
	ᇊ: () => ᇊ,
	ᇋ: () => ᇋ,
	ᇌ: () => ᇌ,
	ᇍ: () => ᇍ,
	ᇎ: () => ᇎ,
	ᇏ: () => ᇏ,
	ᇐ: () => ᇐ,
	ᇑ: () => ᇑ,
	ᇒ: () => ᇒ,
	ᇓ: () => ᇓ,
	ᇔ: () => ᇔ,
	ᇕ: () => ᇕ,
	ᇖ: () => ᇖ,
	ᇗ: () => ᇗ,
	ᇘ: () => ᇘ,
	ᇙ: () => ᇙ,
	ᇚ: () => ᇚ,
	ᇛ: () => ᇛ,
	ᇜ: () => ᇜ,
	ᇝ: () => ᇝ,
	ᇞ: () => ᇞ,
	ᇟ: () => ᇟ,
	ᇠ: () => ᇠ,
	ᇡ: () => ᇡ,
	ᇢ: () => ᇢ,
	ᇣ: () => ᇣ,
	ᇤ: () => ᇤ,
	ᇥ: () => ᇥ,
	ᇦ: () => ᇦ,
	ᇧ: () => ᇧ,
	ᇨ: () => ᇨ,
	ᇩ: () => ᇩ,
	ᇪ: () => ᇪ,
	ᇫ: () => "ᅀ",
	ᇬ: () => ᇬ,
	ᇭ: () => ᇭ,
	ᇮ: () => ᇮ,
	ᇯ: () => ᇯ,
	ᇰ: () => "ᅌ",
	ᇱ: () => ᇱ,
	ᇲ: () => ᇲ,
	ᇳ: () => ᇳ,
	ᇴ: () => ᇴ,
	ᇵ: () => ᇵ,
	ᇶ: () => ᇶ,
	ᇷ: () => ᇷ,
	ᇸ: () => ᇸ,
	ᇹ: () => "ᅙ",
	ᇺ: () => ᇺ,
	ᇻ: () => ᇻ,
	ᇼ: () => ᇼ,
	ᇽ: () => ᇽ,
	ᇾ: () => ᇾ,
	ᇿ: () => ᇿ,
	ሀ: () => "U",
	ሣ: () => "ɰ",
	ቀ: () => "Φ",
	በ: () => "Ո",
	ኔ: () => "ձ",
	ዐ: () => "O",
	Ꭰ: () => "D",
	Ꭱ: () => "R",
	Ꭲ: () => "T",
	Ꭴ: () => "O'",
	Ꭵ: () => "i",
	Ꭸ: () => "Ⱶ",
	Ꭹ: () => "Y",
	Ꭺ: () => "A",
	Ꭻ: () => "J",
	Ꭼ: () => "E",
	Ꭾ: () => "?",
	Ꮀ: () => "Ⱶ",
	Ꮁ: () => "Γ",
	Ꮃ: () => "W",
	Ꮇ: () => "M",
	Ꮋ: () => "H",
	Ꮍ: () => "Y",
	Ꮎ: () => "O̵",
	Ꮏ: () => "ƫ",
	Ꮐ: () => "G",
	Ꮒ: () => "h",
	Ꮓ: () => "Z",
	Ꮗ: () => "Ѡ",
	Ꮛ: () => "Ɛ",
	Ꮜ: () => "U̵",
	Ꮞ: () => "4",
	Ꮟ: () => "b",
	Ꮢ: () => "R",
	Ꮤ: () => "W",
	Ꮥ: () => "S",
	Ꮩ: () => "V",
	Ꮪ: () => "S",
	Ꮮ: () => "L",
	Ꮯ: () => "C",
	Ꮲ: () => "P",
	Ꮶ: () => "K",
	Ꮷ: () => "d",
	Ꮻ: () => "O̵",
	Ꮾ: () => "6",
	Ᏸ: () => "ß",
	Ᏺ: () => "h̔",
	Ᏻ: () => "G",
	Ᏼ: () => "B",
	ᏻ: () => "ɢ",
	ᏼ: () => "ʙ",
	ᐃ: () => "Δ",
	ᐌ: () => ᐌ,
	ᐍ: () => ᐍ,
	ᐎ: () => ᐎ,
	ᐏ: () => ᐏ,
	ᐐ: () => ᐐ,
	ᐑ: () => ᐑ,
	ᐒ: () => ᐒ,
	ᐓ: () => ᐓ,
	ᐔ: () => ᐔ,
	ᐕ: () => ᐕ,
	ᐗ: () => ᐗ,
	ᐘ: () => ᐘ,
	ᐙ: () => ᐙ,
	ᐚ: () => ᐚ,
	ᐧ: () => "·",
	ᐫ: () => ᐫ,
	ᐬ: () => ᐬ,
	ᐭ: () => ᐭ,
	ᐮ: () => ᐮ,
	ᐯ: () => "V",
	ᐱ: () => "Ʌ",
	ᐳ: () => ">",
	ᐷ: () => "·>",
	ᐸ: () => "<",
	ᐺ: () => "·V",
	ᐻ: () => "V·",
	ᐼ: () => ᐼ,
	ᐽ: () => ᐽ,
	ᐾ: () => ᐾ,
	ᐿ: () => ᐿ,
	ᑀ: () => "·>",
	ᑁ: () => ">·",
	ᑂ: () => ᑂ,
	ᑃ: () => ᑃ,
	ᑄ: () => "·<",
	ᑅ: () => "<·",
	ᑆ: () => ᑆ,
	ᑇ: () => ᑇ,
	ᑊ: () => "'",
	ᑌ: () => "U",
	ᑎ: () => "Ո",
	ᑔ: () => ᑔ,
	ᑗ: () => "·U",
	ᑘ: () => "U·",
	ᑙ: () => ᑙ,
	ᑚ: () => ᑚ,
	ᑛ: () => ᑛ,
	ᑜ: () => ᑜ,
	ᑝ: () => ᑝ,
	ᑞ: () => ᑞ,
	ᑟ: () => ᑟ,
	ᑠ: () => ᑠ,
	ᑡ: () => ᑡ,
	ᑢ: () => ᑢ,
	ᑣ: () => ᑣ,
	ᑤ: () => ᑤ,
	ᑧ: () => "U'",
	ᑨ: () => "Ո'",
	ᑩ: () => ᑩ,
	ᑪ: () => ᑪ,
	ᑭ: () => "P",
	ᑯ: () => "d",
	ᑲ: () => "b",
	ᑳ: () => "ḃ",
	ᑴ: () => ᑴ,
	ᑵ: () => ᑵ,
	ᑶ: () => "·P",
	ᑷ: () => "p·",
	ᑸ: () => ᑸ,
	ᑹ: () => ᑹ,
	ᑺ: () => "·d",
	ᑻ: () => "d·",
	ᑼ: () => ᑼ,
	ᑽ: () => ᑽ,
	ᑾ: () => "·b",
	ᑿ: () => "b·",
	ᒀ: () => ᒀ,
	ᒁ: () => ᒁ,
	ᒅ: () => ᒅ,
	ᒆ: () => "P'",
	ᒇ: () => "d'",
	ᒈ: () => "b'",
	ᒍ: () => "J",
	ᒒ: () => ᒒ,
	ᒓ: () => ᒓ,
	ᒔ: () => ᒔ,
	ᒕ: () => ᒕ,
	ᒖ: () => ᒖ,
	ᒗ: () => ᒗ,
	ᒘ: () => "·J",
	ᒙ: () => "J·",
	ᒚ: () => ᒚ,
	ᒛ: () => ᒛ,
	ᒜ: () => ᒜ,
	ᒝ: () => ᒝ,
	ᒞ: () => ᒞ,
	ᒟ: () => ᒟ,
	ᒥ: () => "Γ",
	ᒪ: () => "L",
	ᒬ: () => ᒬ,
	ᒭ: () => ᒭ,
	ᒮ: () => ᒮ,
	ᒯ: () => ᒯ,
	ᒰ: () => ᒰ,
	ᒱ: () => ᒱ,
	ᒲ: () => ᒲ,
	ᒳ: () => ᒳ,
	ᒴ: () => ᒴ,
	ᒵ: () => ᒵ,
	ᒶ: () => "·L",
	ᒷ: () => "l·",
	ᒸ: () => ᒸ,
	ᒹ: () => ᒹ,
	ᒿ: () => "2",
	ᓉ: () => ᓉ,
	ᓊ: () => ᓊ,
	ᓋ: () => ᓋ,
	ᓌ: () => ᓌ,
	ᓍ: () => ᓍ,
	ᓎ: () => ᓎ,
	ᓑ: () => "ᐡ",
	ᓜ: () => ᓜ,
	ᓝ: () => ᓝ,
	ᓞ: () => ᓞ,
	ᓟ: () => ᓟ,
	ᓠ: () => ᓠ,
	ᓡ: () => ᓡ,
	ᓢ: () => ᓢ,
	ᓣ: () => ᓣ,
	ᓤ: () => ᓤ,
	ᓥ: () => ᓥ,
	ᓦ: () => ᓦ,
	ᓧ: () => ᓧ,
	ᓨ: () => ᓨ,
	ᓩ: () => ᓩ,
	ᓶ: () => ᓶ,
	ᓷ: () => ᓷ,
	ᓸ: () => ᓸ,
	ᓹ: () => ᓹ,
	ᓺ: () => ᓺ,
	ᓻ: () => ᓻ,
	ᓼ: () => ᓼ,
	ᓽ: () => ᓽ,
	ᓾ: () => ᓾ,
	ᓿ: () => ᓿ,
	ᔀ: () => ᔀ,
	ᔁ: () => ᔁ,
	ᔂ: () => ᔂ,
	ᔃ: () => ᔃ,
	ᔌ: () => ᔌ,
	ᔍ: () => ᔍ,
	ᔎ: () => ᔎ,
	ᔏ: () => ᔏ,
	ᔗ: () => ᔗ,
	ᔘ: () => ᔘ,
	ᔙ: () => ᔙ,
	ᔚ: () => ᔚ,
	ᔛ: () => ᔛ,
	ᔜ: () => ᔜ,
	ᔝ: () => ᔝ,
	ᔞ: () => ᔞ,
	ᔟ: () => ᔟ,
	ᔠ: () => ᔠ,
	ᔡ: () => ᔡ,
	ᔢ: () => ᔢ,
	ᔣ: () => ᔣ,
	ᔤ: () => ᔤ,
	ᔯ: () => "·4",
	ᔰ: () => "4·",
	ᔱ: () => ᔱ,
	ᔲ: () => ᔲ,
	ᔳ: () => ᔳ,
	ᔴ: () => ᔴ,
	ᔵ: () => ᔵ,
	ᔶ: () => ᔶ,
	ᔷ: () => ᔷ,
	ᔸ: () => ᔸ,
	ᔹ: () => ᔹ,
	ᔺ: () => ᔺ,
	ᔻ: () => ᔻ,
	ᔼ: () => ᔼ,
	ᕀ: () => "ᐩ",
	ᕁ: () => "x",
	ᕎ: () => ᕎ,
	ᕏ: () => ᕏ,
	ᕛ: () => ᕛ,
	ᕜ: () => ᕜ,
	ᕨ: () => ᕨ,
	ᕩ: () => ᕩ,
	ᕷ: () => "ẟ",
	ᕼ: () => "H",
	ᕽ: () => "x",
	ᕾ: () => ᕾ,
	ᕿ: () => ᕿ,
	ᖀ: () => ᖀ,
	ᖁ: () => ᖁ,
	ᖂ: () => ᖂ,
	ᖃ: () => ᖃ,
	ᖄ: () => ᖄ,
	ᖅ: () => ᖅ,
	ᖇ: () => "R",
	ᖎ: () => ᖎ,
	ᖏ: () => ᖏ,
	ᖐ: () => ᖐ,
	ᖑ: () => ᖑ,
	ᖒ: () => ᖒ,
	ᖓ: () => ᖓ,
	ᖔ: () => ᖔ,
	ᖯ: () => "b",
	ᖴ: () => "F",
	ᖵ: () => "Ⅎ",
	ᖷ: () => "ꟻ",
	ᗄ: () => "Ɐ",
	ᗅ: () => "A",
	ᗞ: () => "D",
	ᗪ: () => "D",
	ᗯ: () => "Ѡ",
	ᗰ: () => "M",
	ᗷ: () => "B",
	ᘂ: () => "ᒐ",
	ᘃ: () => "ᒉ",
	ᘄ: () => "ᓓ",
	ᘇ: () => "ᓚ",
	ᘢ: () => "ᕃ",
	ᘣ: () => "ᕆ",
	ᘤ: () => "ᕊ",
	ᘮ: () => "Ʊ",
	ᘯ: () => "Ω",
	ᘴ: () => "Ʊ",
	ᘵ: () => "Ω",
	ᙯ: () => ᙯ,
	ᙰ: () => ᙰ,
	ᙱ: () => ᙱ,
	ᙲ: () => ᙲ,
	ᙳ: () => ᙳ,
	ᙴ: () => ᙴ,
	ᙵ: () => ᙵ,
	ᙶ: () => ᙶ,
	ᙷ: () => ᙷ,
	ᙸ: () => ᙸ,
	ᙹ: () => ᙹ,
	ᙺ: () => ᙺ,
	ᙻ: () => ᙻ,
	ᙼ: () => ᙼ,
	ᙽ: () => ᙽ,
	ᚲ: () => "<",
	ᚷ: () => "X",
	ᛁ: () => "l",
	ᛂ: () => "ᚽ",
	ᛌ: () => "'",
	ᛕ: () => "K",
	ᛖ: () => "M",
	ᛘ: () => "Ψ",
	ᛡ: () => "ᚼ",
	ᛰ: () => "Φ",
	ឣ: () => "អ",
	ᡕ: () => "ᠵ",
	ᢖ: () => "ᡜ",
	ᢳ: () => ᢳ,
	ᢶ: () => ᢶ,
	ᢹ: () => ᢹ,
	ᣂ: () => ᣂ,
	ᣆ: () => ᣆ,
	ᣇ: () => ᣇ,
	ᣈ: () => ᣈ,
	ᣉ: () => ᣉ,
	ᣊ: () => ᣊ,
	ᣋ: () => ᣋ,
	ᣌ: () => ᣌ,
	ᣍ: () => ᣍ,
	ᣎ: () => ᣎ,
	ᣏ: () => ᣏ,
	ᣐ: () => ᣐ,
	ᣑ: () => ᣑ,
	ᣒ: () => ᣒ,
	ᣓ: () => ᣓ,
	ᣛ: () => "ᣵ",
	ᣜ: () => ᣜ,
	ᣝ: () => ᣝ,
	ᣠ: () => ᣠ,
	ᣣ: () => ᣣ,
	ᣤ: () => ᣤ,
	ᣥ: () => ᣥ,
	ᣨ: () => ᣨ,
	ᣪ: () => ᣪ,
	ᣭ: () => ᣭ,
	ᣰ: () => ᣰ,
	ᣲ: () => ᣲ,
	ᴄ: () => "c",
	ᴈ: () => "ɜ",
	ᴋ: () => "ĸ",
	ᴍ: () => "ʍ",
	ᴏ: () => "o",
	ᴐ: () => "ɔ",
	ᴑ: () => "o",
	ᴔ: () => "ǝo",
	ᴜ: () => "u",
	ᴠ: () => "v",
	ᴡ: () => "w",
	ᴢ: () => "z",
	ᴤ: () => "ƨ",
	ᴦ: () => "r",
	ᴧ: () => "ʌ",
	ᴨ: () => "π",
	ᴩ: () => "ᴘ",
	ᴫ: () => "л",
	ᴾ: () => "ᣖ",
	ᵒ: () => "º",
	ᵫ: () => "ue",
	ᵮ: () => "f̴",
	ᵯ: () => ᵯ,
	ᵰ: () => "n̴",
	ᵲ: () => "r̴",
	ᵳ: () => ᵳ,
	ᵴ: () => "s̴",
	ᵵ: () => "t̴",
	ᵶ: () => "z̴",
	ᵸ: () => "ᴴ",
	ᵻ: () => "i̵",
	ᵼ: () => "i̵",
	ᵽ: () => "p̵",
	ᵾ: () => "u̵",
	ᵿ: () => ᵿ,
	ᶃ: () => "g",
	ᶌ: () => "y",
	ᶐ: () => "ɋ",
	ᶟ: () => "ᵋ",
	ᶢ: () => "ᵍ",
	ᶺ: () => "ᣔ",
	ᶻ: () => "ᙆ",
	ṃ: () => "ꭑ",
	ẚ: () => "ả",
	ẝ: () => "f",
	ỿ: () => "y",
	ώ: () => "ῴ",
	ι: () => "i",
	ῶ: () => "Ꮿ",
	ℂ: () => "C",
	ℇ: () => "Ɛ",
	ℊ: () => "g",
	ℋ: () => "H",
	ℌ: () => "H",
	ℍ: () => "H",
	ℎ: () => "h",
	ℏ: () => "h̵",
	ℐ: () => "l",
	ℑ: () => "l",
	ℒ: () => "L",
	ℓ: () => "l",
	ℕ: () => "N",
	ℙ: () => "P",
	ℚ: () => "Q",
	ℛ: () => "R",
	ℜ: () => "R",
	ℝ: () => "R",
	ℤ: () => "Z",
	Ω: () => "Ω",
	ℨ: () => "Z",
	K: () => "K",
	ℬ: () => "B",
	ℭ: () => "C",
	℮: () => "e",
	ℯ: () => "e",
	ℰ: () => "E",
	ℱ: () => "F",
	ℳ: () => "M",
	ℴ: () => "o",
	ℵ: () => "א",
	ℶ: () => "ב",
	ℷ: () => "ג",
	ℸ: () => "ד",
	ℹ: () => "i",
	ℼ: () => "π",
	ℽ: () => "y",
	ℾ: () => "Γ",
	ℿ: () => "Π",
	ⅅ: () => "D",
	ⅆ: () => "d",
	ⅇ: () => "e",
	ⅈ: () => "i",
	ⅉ: () => "j",
	Ⅰ: () => "l",
	Ⅱ: () => "ll",
	Ⅲ: () => "lll",
	Ⅳ: () => "lV",
	Ⅴ: () => "V",
	Ⅵ: () => "Vl",
	Ⅶ: () => "Vll",
	Ⅷ: () => Ⅷ,
	Ⅸ: () => "lX",
	Ⅹ: () => "X",
	Ⅺ: () => "Xl",
	Ⅻ: () => "Xll",
	Ⅼ: () => "L",
	Ⅽ: () => "C",
	Ⅾ: () => "D",
	Ⅿ: () => "M",
	ⅰ: () => "i",
	ⅱ: () => "ii",
	ⅲ: () => "iii",
	ⅳ: () => "iv",
	ⅴ: () => "v",
	ⅵ: () => "vi",
	ⅶ: () => "vii",
	ⅷ: () => ⅷ,
	ⅸ: () => "ix",
	ⅹ: () => "x",
	ⅺ: () => "xi",
	ⅻ: () => "xii",
	ⅼ: () => "l",
	ⅽ: () => "c",
	ⅾ: () => "d",
	ⅿ: () => "rn",
	Ↄ: () => "Ɔ",
	ↄ: () => "ɔ",
	Ⱨ: () => "H̩",
	Ⱪ: () => "K̩",
	Ⲅ: () => "Γ",
	ⲅ: () => "r",
	Ⲇ: () => "Δ",
	Ⲉ: () => "Ꞓ",
	ⲉ: () => "ꞓ",
	Ⲏ: () => "H",
	Ⲓ: () => "l",
	Ⲕ: () => "K",
	ⲕ: () => "ĸ",
	Ⲗ: () => "λ",
	Ⲙ: () => "M",
	Ⲛ: () => "N",
	Ⲟ: () => "O",
	ⲟ: () => "o",
	Ⲡ: () => "Π",
	Ⲣ: () => "P",
	ⲣ: () => "p",
	Ⲥ: () => "C",
	ⲥ: () => "c",
	Ⲧ: () => "T",
	Ⲩ: () => "Y",
	Ⲫ: () => "Φ",
	ⲫ: () => "ɸ",
	Ⲭ: () => "X",
	ⲭ: () => "χ",
	Ⲯ: () => "Ψ",
	ⲱ: () => "ω",
	Ⲵ: () => "<·",
	Ⲻ: () => "-",
	Ⲽ: () => "Ш",
	ⲽ: () => "ш",
	Ⳇ: () => "/",
	Ⳋ: () => "9",
	Ⳍ: () => "3",
	ⳍ: () => "ȝ",
	Ⳑ: () => "L",
	ⳑ: () => "ʟ",
	Ⳓ: () => "6",
	Ⳝ: () => "Ϭ",
	ⳤ: () => "ϗ",
	ⴱ: () => "O̵",
	ⴷ: () => "Ʌ",
	ⴸ: () => "V",
	ⴹ: () => "E",
	ⴺ: () => "Ǝ",
	ⵁ: () => "O̸",
	ⵈ: () => ⵈ,
	ⵉ: () => "Ʃ",
	ⵏ: () => "l",
	ⵑ: () => "!",
	ⵔ: () => "O",
	ⵕ: () => "Q",
	ⵙ: () => "ʘ",
	ⵝ: () => "X",
	ⵠ: () => "Δ",
	ⵣ: () => "ᛯ",
	〇: () => "O",
	〳: () => "/",
	〸: () => "十",
	〹: () => "卄",
	〺: () => "卅",
	く: () => "❬",
	゛: () => "ﾞ",
	゜: () => "ﾟ",
	イ: () => "亻",
	エ: () => "工",
	カ: () => "力",
	タ: () => "夕",
	ト: () => "卜",
	ニ: () => "二",
	ノ: () => "/",
	ハ: () => "八",
	ヘ: () => "へ",
	ロ: () => "口",
	ㄱ: () => "ᄀ",
	ㄲ: () => ㄲ,
	ㄳ: () => ㄳ,
	ㄴ: () => "ᄂ",
	ㄵ: () => ㄵ,
	ㄶ: () => ㄶ,
	ㄷ: () => "ᄃ",
	ㄸ: () => ㄸ,
	ㄹ: () => "ᄅ",
	ㄺ: () => ㄺ,
	ㄻ: () => ㄻ,
	ㄼ: () => ㄼ,
	ㄽ: () => ㄽ,
	ㄾ: () => ㄾ,
	ㄿ: () => ㄿ,
	ㅀ: () => ㅀ,
	ㅁ: () => "ᄆ",
	ㅂ: () => "ᄇ",
	ㅃ: () => ㅃ,
	ㅄ: () => ㅄ,
	ㅅ: () => "ᄉ",
	ㅆ: () => ㅆ,
	ㅇ: () => "ᄋ",
	ㅈ: () => "ᄌ",
	ㅉ: () => ㅉ,
	ㅊ: () => "ᄎ",
	ㅋ: () => "ᄏ",
	ㅌ: () => "ᄐ",
	ㅍ: () => "ᄑ",
	ㅎ: () => "ᄒ",
	ㅏ: () => "ᅡ",
	ㅐ: () => ㅐ,
	ㅑ: () => "ᅣ",
	ㅒ: () => ㅒ,
	ㅓ: () => "ᅥ",
	ㅔ: () => ㅔ,
	ㅕ: () => "ᅧ",
	ㅖ: () => ㅖ,
	ㅗ: () => "ᅩ",
	ㅘ: () => ㅘ,
	ㅙ: () => ㅙ,
	ㅚ: () => ㅚ,
	ㅛ: () => "ᅭ",
	ㅜ: () => "ᅮ",
	ㅝ: () => ㅝ,
	ㅞ: () => ㅞ,
	ㅟ: () => ㅟ,
	ㅠ: () => "ᅲ",
	ㅡ: () => "ー",
	ㅢ: () => ㅢ,
	ㅣ: () => "丨",
	ㅤ: () => "ᅠ",
	ㅥ: () => ㅥ,
	ㅦ: () => ㅦ,
	ㅧ: () => ㅧ,
	ㅨ: () => ㅨ,
	ㅩ: () => ㅩ,
	ㅪ: () => ㅪ,
	ㅫ: () => ㅫ,
	ㅬ: () => ㅬ,
	ㅭ: () => ㅭ,
	ㅮ: () => ㅮ,
	ㅯ: () => ㅯ,
	ㅰ: () => ㅰ,
	ㅱ: () => ㅱ,
	ㅲ: () => ㅲ,
	ㅳ: () => ㅳ,
	ㅴ: () => ㅴ,
	ㅵ: () => ㅵ,
	ㅶ: () => ㅶ,
	ㅷ: () => ㅷ,
	ㅸ: () => ㅸ,
	ㅹ: () => ㅹ,
	ㅺ: () => ㅺ,
	ㅻ: () => ㅻ,
	ㅼ: () => ㅼ,
	ㅽ: () => ㅽ,
	ㅾ: () => ㅾ,
	ㅿ: () => "ᅀ",
	ㆀ: () => ㆀ,
	ㆁ: () => "ᅌ",
	ㆂ: () => ㆂ,
	ㆃ: () => ㆃ,
	ㆄ: () => ㆄ,
	ㆅ: () => ㆅ,
	ㆆ: () => "ᅙ",
	ㆇ: () => ㆇ,
	ㆈ: () => ㆈ,
	ㆉ: () => ㆉ,
	ㆊ: () => ㆊ,
	ㆋ: () => ㆋ,
	ㆌ: () => ㆌ,
	ㆍ: () => "ᆞ",
	ㆎ: () => ㆎ,
	㦳: () => "㘽",
	䎛: () => "㖈",
	䐠: () => "㬻",
	一: () => "ー",
	丶: () => "\\",
	丿: () => "/",
	倂: () => "併",
	值: () => "値",
	啟: () => "啓",
	囗: () => "口",
	填: () => "塡",
	士: () => "土",
	壿: () => "墫",
	嬀: () => "媯",
	帲: () => "帡",
	幐: () => "㬺",
	戸: () => "戶",
	搉: () => "㩁",
	晣: () => "䀿",
	晩: () => "晚",
	曶: () => "㫚",
	朦: () => "䑃",
	柿: () => "杮",
	槩: () => "㮣",
	樧: () => "榝",
	潙: () => "溈",
	硏: () => "研",
	絶: () => "絕",
	肦: () => "朌",
	胊: () => "朐",
	胐: () => "朏",
	胶: () => "㬵",
	脁: () => "朓",
	脧: () => "朘",
	腁: () => "胼",
	膧: () => "朣",
	蔿: () => "蒍",
	虁: () => "蘷",
	訞: () => "䚶",
	詽: () => "訮",
	讏: () => "讆",
	豣: () => "豜",
	趆: () => "赿",
	跺: () => "跥",
	躛: () => "躗",
	輧: () => "軿",
	郞: () => "郎",
	鎮: () => "鎭",
	隸: () => "隷",
	鹃: () => "鹂",
	黒: () => "黑",
	鿃: () => "䀹",
	ꓐ: () => "B",
	ꓑ: () => "P",
	ꓒ: () => "d",
	ꓓ: () => "D",
	ꓔ: () => "T",
	ꓖ: () => "G",
	ꓗ: () => "K",
	ꓙ: () => "J",
	ꓚ: () => "C",
	ꓛ: () => "Ɔ",
	ꓜ: () => "Z",
	ꓝ: () => "F",
	ꓞ: () => "Ⅎ",
	ꓟ: () => "M",
	ꓠ: () => "N",
	ꓡ: () => "L",
	ꓢ: () => "S",
	ꓣ: () => "R",
	ꓥ: () => "Ʌ",
	ꓦ: () => "V",
	ꓧ: () => "H",
	ꓪ: () => "W",
	ꓫ: () => "X",
	ꓬ: () => "Y",
	ꓭ: () => "ᙠ",
	ꓮ: () => "A",
	ꓯ: () => "Ɐ",
	ꓰ: () => "E",
	ꓱ: () => "Ǝ",
	ꓲ: () => "l",
	ꓳ: () => "O",
	ꓴ: () => "U",
	ꓵ: () => "Ո",
	ꓷ: () => "ᗡ",
	ꓸ: () => ".",
	ꓹ: () => ",",
	ꓺ: () => "..",
	ꓻ: () => ".,",
	ꓽ: () => ":",
	Ꙅ: () => "2",
	ꙅ: () => "ƨ",
	ꙇ: () => "i",
	ꙍ: () => "ω",
	Ꙑ: () => "Ъl",
	ꙑ: () => ꙑ,
	Ꙩ: () => "ʘ",
	ꚕ: () => "h̔",
	Ꚙ: () => "OO",
	ꚙ: () => "oo",
	Ꚛ: () => Ꚛ,
	ꚡ: () => "И",
	ꚰ: () => "ᚹ",
	ꚱ: () => "Ⱶ",
	ꛍ: () => "ʡ",
	ꛎ: () => "Ʌ",
	ꛛ: () => "Π",
	ꛟ: () => "V",
	ꛫ: () => "?",
	ꛯ: () => "2",
	Ꜩ: () => "T3",
	ꜩ: () => "tȝ",
	ꜱ: () => "s",
	Ꜳ: () => "AA",
	ꜳ: () => "aa",
	Ꜵ: () => "AO",
	ꜵ: () => "ao",
	Ꜷ: () => "AU",
	ꜷ: () => "au",
	Ꜹ: () => "AV",
	ꜹ: () => "av",
	Ꜻ: () => "AV",
	ꜻ: () => "av",
	Ꜽ: () => "AY",
	ꜽ: () => "ay",
	Ꝁ: () => "K̵",
	Ꝋ: () => "O̵",
	ꝋ: () => "o̵",
	Ꝏ: () => "OO",
	ꝏ: () => "oo",
	Ꝛ: () => "2",
	ꝡ: () => "w̦",
	Ꝫ: () => "3",
	ꝫ: () => "ȝ",
	Ꝯ: () => "9",
	ꝷ: () => "tf",
	ꝸ: () => "&",
	ꝺ: () => "Ꝺ",
	ꞌ: () => "'",
	ꞏ: () => "·",
	ꞕ: () => "ꜧ",
	Ꞙ: () => "F",
	ꞙ: () => "f",
	Ꞛ: () => Ꞛ,
	ꞛ: () => ꞛ,
	ꞝ: () => "ʚ",
	Ꞟ: () => "ꓤ",
	ꞟ: () => "u",
	Ɜ: () => "3",
	Ʇ: () => "ꓕ",
	Ʝ: () => "J",
	Ꭓ: () => "X",
	Ꞵ: () => "B",
	ꞵ: () => "ß",
	Ꞷ: () => "Ꙍ",
	ꞷ: () => "ω",
	ꟷ: () => "ー",
	ꥠ: () => ꥠ,
	ꥡ: () => ꥡ,
	ꥢ: () => ꥢ,
	ꥣ: () => ꥣ,
	ꥤ: () => ꥤ,
	ꥥ: () => ꥥ,
	ꥦ: () => ꥦ,
	ꥧ: () => ꥧ,
	ꥨ: () => ꥨ,
	ꥩ: () => ꥩ,
	ꥪ: () => ꥪ,
	ꥫ: () => ꥫ,
	ꥬ: () => ꥬ,
	ꥭ: () => ꥭ,
	ꥮ: () => ꥮ,
	ꥯ: () => ꥯ,
	ꥰ: () => ꥰ,
	ꥱ: () => ꥱ,
	ꥲ: () => ꥲ,
	ꥳ: () => ꥳ,
	ꥴ: () => ꥴ,
	ꥵ: () => ꥵ,
	ꥶ: () => ꥶ,
	ꥷ: () => ꥷ,
	ꥸ: () => ꥸ,
	ꥹ: () => ꥹ,
	ꥺ: () => ꥺ,
	ꥻ: () => ꥻ,
	ꥼ: () => ꥼ,
	ꦒ: () => "ⰿ",
	ꦣ: () => "ꦝ",
	ꧏ: () => "٢",
	ꬲ: () => "e",
	ꬵ: () => "f",
	ꬽ: () => "o",
	ꬾ: () => "o̸",
	ꬿ: () => ꬿ,
	ꭁ: () => ꭁ,
	ꭂ: () => ꭂ,
	ꭇ: () => "r",
	ꭈ: () => "r",
	ꭍ: () => "ʃ",
	ꭎ: () => "u",
	ꭒ: () => "u",
	ꭓ: () => "χ",
	ꭕ: () => "χ",
	ꭚ: () => "y",
	ꭠ: () => "љ",
	ꭢ: () => "ɔe",
	ꭣ: () => "uo",
	ꭰ: () => "ᴅ",
	ꭱ: () => "ʀ",
	ꭲ: () => "ᴛ",
	ꭴ: () => "ơ",
	ꭵ: () => "i",
	ꭺ: () => "ᴀ",
	ꭻ: () => "ᴊ",
	ꭼ: () => "ᴇ",
	ꭾ: () => "ɂ",
	ꮀ: () => "ⱶ",
	ꮁ: () => "r",
	ꮃ: () => "w",
	ꮇ: () => "ʍ",
	ꮋ: () => "ʜ",
	ꮎ: () => "o̵",
	ꮐ: () => "ɢ",
	ꮓ: () => "z",
	ꮛ: () => "ꞓ",
	ꮜ: () => "u̵",
	ꮟ: () => "ƅ",
	ꮢ: () => "ʀ",
	ꮩ: () => "v",
	ꮪ: () => "s",
	ꮮ: () => "ʟ",
	ꮯ: () => "c",
	ꮲ: () => "ᴘ",
	ꮶ: () => "ĸ",
	ꮻ: () => "o̵",
	ힰ: () => ힰ,
	ힱ: () => ힱ,
	ힲ: () => ힲ,
	ힳ: () => ힳ,
	ힴ: () => ힴ,
	ힵ: () => ힵ,
	ힶ: () => ힶ,
	ힷ: () => ힷ,
	ힸ: () => ힸ,
	ힹ: () => ힹ,
	ힺ: () => ힺ,
	ힻ: () => ힻ,
	ힼ: () => ힼ,
	ힽ: () => ힽ,
	ힾ: () => ힾ,
	ힿ: () => ힿ,
	ퟀ: () => ퟀ,
	ퟁ: () => ퟁ,
	ퟂ: () => ퟂ,
	ퟃ: () => ퟃ,
	ퟄ: () => ퟄ,
	ퟅ: () => ퟅ,
	ퟆ: () => ퟆ,
	ퟋ: () => ퟋ,
	ퟌ: () => ퟌ,
	ퟍ: () => ퟍ,
	ퟎ: () => ퟎ,
	ퟏ: () => ퟏ,
	ퟐ: () => ퟐ,
	ퟑ: () => ퟑ,
	ퟒ: () => ퟒ,
	ퟓ: () => ퟓ,
	ퟔ: () => ퟔ,
	ퟕ: () => ퟕ,
	ퟖ: () => ퟖ,
	ퟗ: () => ퟗ,
	ퟘ: () => ퟘ,
	ퟙ: () => ퟙ,
	ퟚ: () => ퟚ,
	ퟛ: () => ퟛ,
	ퟜ: () => ퟜ,
	ퟝ: () => ퟝ,
	ퟞ: () => ퟞ,
	ퟟ: () => ퟟ,
	ퟠ: () => ퟠ,
	ퟡ: () => ퟡ,
	ퟢ: () => ퟢ,
	ퟣ: () => ퟣ,
	ퟤ: () => ퟤ,
	ퟥ: () => ퟥ,
	ퟦ: () => ퟦ,
	ퟧ: () => ퟧ,
	ퟨ: () => ퟨ,
	ퟩ: () => ퟩ,
	ퟪ: () => ퟪ,
	ퟫ: () => ퟫ,
	ퟬ: () => ퟬ,
	ퟭ: () => ퟭ,
	ퟮ: () => ퟮ,
	ퟯ: () => ퟯ,
	ퟰ: () => ퟰ,
	ퟱ: () => ퟱ,
	ퟲ: () => ퟲ,
	ퟳ: () => ퟳ,
	ퟴ: () => ퟴ,
	ퟵ: () => ퟵ,
	ퟶ: () => ퟶ,
	ퟷ: () => ퟷ,
	ퟸ: () => ퟸ,
	ퟹ: () => ퟹ,
	ퟺ: () => ퟺ,
	ퟻ: () => ퟻ,
	豈: () => "豈",
	更: () => "更",
	車: () => "車",
	賈: () => "賈",
	滑: () => "滑",
	串: () => "串",
	句: () => "句",
	龜: () => "龜",
	龜: () => "龜",
	契: () => "契",
	金: () => "金",
	喇: () => "喇",
	奈: () => "奈",
	懶: () => "懶",
	癩: () => "癩",
	羅: () => "羅",
	蘿: () => "蘿",
	螺: () => "螺",
	裸: () => "裸",
	邏: () => "邏",
	樂: () => "樂",
	洛: () => "洛",
	烙: () => "烙",
	珞: () => "珞",
	落: () => "落",
	酪: () => "酪",
	駱: () => "駱",
	亂: () => "亂",
	卵: () => "卵",
	欄: () => "欄",
	爛: () => "爛",
	蘭: () => "蘭",
	鸞: () => "鸞",
	嵐: () => "嵐",
	濫: () => "濫",
	藍: () => "藍",
	襤: () => "襤",
	拉: () => "拉",
	臘: () => "臘",
	蠟: () => "蠟",
	廊: () => "廊",
	朗: () => "朗",
	浪: () => "浪",
	狼: () => "狼",
	郎: () => "郎",
	來: () => "來",
	冷: () => "冷",
	勞: () => "勞",
	擄: () => "擄",
	櫓: () => "櫓",
	爐: () => "爐",
	盧: () => "盧",
	老: () => "老",
	蘆: () => "蘆",
	虜: () => "虜",
	路: () => "路",
	露: () => "露",
	魯: () => "魯",
	鷺: () => "鷺",
	碌: () => "碌",
	祿: () => "祿",
	綠: () => "綠",
	菉: () => "菉",
	錄: () => "錄",
	鹿: () => "鹿",
	論: () => "論",
	壟: () => "壟",
	弄: () => "弄",
	籠: () => "籠",
	聾: () => "聾",
	牢: () => "牢",
	磊: () => "磊",
	賂: () => "賂",
	雷: () => "雷",
	壘: () => "壘",
	屢: () => "屢",
	樓: () => "樓",
	淚: () => "淚",
	漏: () => "漏",
	累: () => "累",
	縷: () => "縷",
	陋: () => "陋",
	勒: () => "勒",
	肋: () => "肋",
	凜: () => "凜",
	凌: () => "凌",
	稜: () => "稜",
	綾: () => "綾",
	菱: () => "菱",
	陵: () => "陵",
	讀: () => "讀",
	拏: () => "拏",
	樂: () => "樂",
	諾: () => "諾",
	丹: () => "丹",
	寧: () => "寧",
	怒: () => "怒",
	率: () => "率",
	異: () => "異",
	北: () => "北",
	磻: () => "磻",
	便: () => "便",
	復: () => "復",
	不: () => "不",
	泌: () => "泌",
	數: () => "數",
	索: () => "索",
	參: () => "參",
	塞: () => "塞",
	省: () => "省",
	葉: () => "葉",
	說: () => "說",
	殺: () => "殺",
	辰: () => "辰",
	沈: () => "沈",
	拾: () => "拾",
	若: () => "若",
	掠: () => "掠",
	略: () => "略",
	亮: () => "亮",
	兩: () => "兩",
	凉: () => "凉",
	梁: () => "梁",
	糧: () => "糧",
	良: () => "良",
	諒: () => "諒",
	量: () => "量",
	勵: () => "勵",
	呂: () => "呂",
	女: () => "女",
	廬: () => "廬",
	旅: () => "旅",
	濾: () => "濾",
	礪: () => "礪",
	閭: () => "閭",
	驪: () => "驪",
	麗: () => "麗",
	黎: () => "黎",
	力: () => "力",
	曆: () => "曆",
	歷: () => "歷",
	轢: () => "轢",
	年: () => "年",
	憐: () => "憐",
	戀: () => "戀",
	撚: () => "撚",
	漣: () => "漣",
	煉: () => "煉",
	璉: () => "璉",
	秊: () => "秊",
	練: () => "練",
	聯: () => "聯",
	輦: () => "輦",
	蓮: () => "蓮",
	連: () => "連",
	鍊: () => "鍊",
	列: () => "列",
	劣: () => "劣",
	咽: () => "咽",
	烈: () => "烈",
	裂: () => "裂",
	說: () => "說",
	廉: () => "廉",
	念: () => "念",
	捻: () => "捻",
	殮: () => "殮",
	簾: () => "簾",
	獵: () => "獵",
	令: () => "令",
	囹: () => "囹",
	寧: () => "寧",
	嶺: () => "嶺",
	怜: () => "怜",
	玲: () => "玲",
	瑩: () => "瑩",
	羚: () => "羚",
	聆: () => "聆",
	鈴: () => "鈴",
	零: () => "零",
	靈: () => "靈",
	領: () => "領",
	例: () => "例",
	禮: () => "禮",
	醴: () => "醴",
	隸: () => "隷",
	惡: () => "惡",
	了: () => "了",
	僚: () => "僚",
	寮: () => "寮",
	尿: () => "尿",
	料: () => "料",
	樂: () => "樂",
	燎: () => "燎",
	療: () => "療",
	蓼: () => "蓼",
	遼: () => "遼",
	龍: () => "龍",
	暈: () => "暈",
	阮: () => "阮",
	劉: () => "劉",
	杻: () => "杻",
	柳: () => "柳",
	流: () => "流",
	溜: () => "溜",
	琉: () => "琉",
	留: () => "留",
	硫: () => "硫",
	紐: () => "紐",
	類: () => "類",
	六: () => "六",
	戮: () => "戮",
	陸: () => "陸",
	倫: () => "倫",
	崙: () => "崙",
	淪: () => "淪",
	輪: () => "輪",
	律: () => "律",
	慄: () => "慄",
	栗: () => "栗",
	率: () => "率",
	隆: () => "隆",
	利: () => "利",
	吏: () => "吏",
	履: () => "履",
	易: () => "易",
	李: () => "李",
	梨: () => "梨",
	泥: () => "泥",
	理: () => "理",
	痢: () => "痢",
	罹: () => "罹",
	裏: () => "裏",
	裡: () => "裡",
	里: () => "里",
	離: () => "離",
	匿: () => "匿",
	溺: () => "溺",
	吝: () => "吝",
	燐: () => "燐",
	璘: () => "璘",
	藺: () => "藺",
	隣: () => "隣",
	鱗: () => "鱗",
	麟: () => "麟",
	林: () => "林",
	淋: () => "淋",
	臨: () => "臨",
	立: () => "立",
	笠: () => "笠",
	粒: () => "粒",
	狀: () => "狀",
	炙: () => "炙",
	識: () => "識",
	什: () => "什",
	茶: () => "茶",
	刺: () => "刺",
	切: () => "切",
	度: () => "度",
	拓: () => "拓",
	糖: () => "糖",
	宅: () => "宅",
	洞: () => "洞",
	暴: () => "暴",
	輻: () => "輻",
	行: () => "行",
	降: () => "降",
	見: () => "見",
	廓: () => "廓",
	兀: () => "兀",
	嗀: () => "嗀",
	塚: () => "塚",
	晴: () => "晴",
	凞: () => "凞",
	猪: () => "猪",
	益: () => "益",
	礼: () => "礼",
	神: () => "神",
	祥: () => "祥",
	福: () => "福",
	靖: () => "靖",
	精: () => "精",
	羽: () => "羽",
	蘒: () => "蘒",
	諸: () => "諸",
	逸: () => "逸",
	都: () => "都",
	飯: () => "飯",
	飼: () => "飼",
	館: () => "館",
	鶴: () => "鶴",
	郞: () => "郎",
	隷: () => "隷",
	侮: () => "侮",
	僧: () => "僧",
	免: () => "免",
	勉: () => "勉",
	勤: () => "勤",
	卑: () => "卑",
	喝: () => "喝",
	嘆: () => "嘆",
	器: () => "器",
	塀: () => "塀",
	墨: () => "墨",
	層: () => "層",
	屮: () => "屮",
	悔: () => "悔",
	慨: () => "慨",
	憎: () => "憎",
	懲: () => "懲",
	敏: () => "敏",
	既: () => "既",
	暑: () => "暑",
	梅: () => "梅",
	海: () => "海",
	渚: () => "渚",
	漢: () => "漢",
	煮: () => "煮",
	爫: () => "爫",
	琢: () => "琢",
	碑: () => "碑",
	社: () => "社",
	祉: () => "祉",
	祈: () => "祈",
	祐: () => "祐",
	祖: () => "祖",
	祝: () => "祝",
	禍: () => "禍",
	禎: () => "禎",
	穀: () => "穀",
	突: () => "突",
	節: () => "節",
	練: () => "練",
	縉: () => "縉",
	繁: () => "繁",
	署: () => "署",
	者: () => "者",
	臭: () => "臭",
	艹: () => "艹",
	艹: () => "艹",
	著: () => "著",
	褐: () => "褐",
	視: () => "視",
	謁: () => "謁",
	謹: () => "謹",
	賓: () => "賓",
	贈: () => "贈",
	辶: () => "辶",
	逸: () => "逸",
	難: () => "難",
	響: () => "響",
	頻: () => "頻",
	恵: () => "恵",
	𤋮: () => 𤋮,
	舘: () => "舘",
	並: () => "並",
	况: () => "况",
	全: () => "全",
	侀: () => "侀",
	充: () => "充",
	冀: () => "冀",
	勇: () => "勇",
	勺: () => "勺",
	喝: () => "喝",
	啕: () => "啕",
	喙: () => "喙",
	嗢: () => "嗢",
	塚: () => "塚",
	墳: () => "墳",
	奄: () => "奄",
	奔: () => "奔",
	婢: () => "婢",
	嬨: () => "嬨",
	廒: () => "廒",
	廙: () => "廙",
	彩: () => "彩",
	徭: () => "徭",
	惘: () => "惘",
	慎: () => "慎",
	愈: () => "愈",
	憎: () => "憎",
	慠: () => "慠",
	懲: () => "懲",
	戴: () => "戴",
	揄: () => "揄",
	搜: () => "搜",
	摒: () => "摒",
	敖: () => "敖",
	晴: () => "晴",
	朗: () => "朗",
	望: () => "望",
	杖: () => "杖",
	歹: () => "歹",
	殺: () => "殺",
	流: () => "流",
	滛: () => "滛",
	滋: () => "滋",
	漢: () => "漢",
	瀞: () => "瀞",
	煮: () => "煮",
	瞧: () => "瞧",
	爵: () => "爵",
	犯: () => "犯",
	猪: () => "猪",
	瑱: () => "瑱",
	甆: () => "甆",
	画: () => "画",
	瘝: () => "瘝",
	瘟: () => "瘟",
	益: () => "益",
	盛: () => "盛",
	直: () => "直",
	睊: () => "睊",
	着: () => "着",
	磌: () => "磌",
	窱: () => "窱",
	節: () => "節",
	类: () => "类",
	絛: () => "絛",
	練: () => "練",
	缾: () => "缾",
	者: () => "者",
	荒: () => "荒",
	華: () => "華",
	蝹: () => "蝹",
	襁: () => "襁",
	覆: () => "覆",
	視: () => "視",
	調: () => "調",
	諸: () => "諸",
	請: () => "請",
	謁: () => "謁",
	諾: () => "諾",
	諭: () => "諭",
	謹: () => "謹",
	變: () => "變",
	贈: () => "贈",
	輸: () => "輸",
	遲: () => "遲",
	醙: () => "醙",
	鉶: () => "鉶",
	陼: () => "陼",
	難: () => "難",
	靖: () => "靖",
	韛: () => "韛",
	響: () => "響",
	頋: () => "頋",
	頻: () => "頻",
	鬒: () => "鬒",
	龜: () => "龜",
	𢡊: () => 𢡊,
	𢡄: () => 𢡄,
	𣏕: () => 𣏕,
	㮝: () => "㮝",
	䀘: () => "䀘",
	䀹: () => "䀹",
	𥉉: () => 𥉉,
	𥳐: () => 𥳐,
	𧻓: () => 𧻓,
	齃: () => "齃",
	龎: () => "龎",
	ﬀ: () => "ff",
	ﬁ: () => "fi",
	ﬂ: () => "fl",
	ﬃ: () => "ffi",
	ﬄ: () => "ffl",
	ﬆ: () => "st",
	ﬓ: () => ﬓ,
	ﬔ: () => ﬔ,
	ﬕ: () => ﬕ,
	ﬖ: () => ﬖ,
	ﬗ: () => ﬗ,
	ﬠ: () => "ע",
	ﬡ: () => "א",
	ﬢ: () => "ד",
	ﬣ: () => "ה",
	ﬤ: () => "כ",
	ﬥ: () => "ל",
	ﬦ: () => "ם",
	ﬧ: () => "ר",
	ﬨ: () => "ת",
	שׂ: () => "שׁ",
	שּׂ: () => "שּׁ",
	אָ: () => "אַ",
	אּ: () => "אַ",
	יּ: () => "יִ",
	שּ: () => "שׁ",
	ﭏ: () => ﭏ,
	ﭐ: () => "ٱ",
	ﭑ: () => "ٱ",
	ﭒ: () => "ٻ",
	ﭓ: () => "ٻ",
	ﭔ: () => "ٻ",
	ﭕ: () => "ٻ",
	ﭖ: () => ﭖ,
	ﭗ: () => ﭗ,
	ﭘ: () => ﭘ,
	ﭙ: () => ﭙ,
	ﭚ: () => "ڀ",
	ﭛ: () => "ڀ",
	ﭜ: () => "ڀ",
	ﭝ: () => "ڀ",
	ﭞ: () => "ٺ",
	ﭟ: () => "ٺ",
	ﭠ: () => "ٺ",
	ﭡ: () => "ٺ",
	ﭢ: () => "ٿ",
	ﭣ: () => "ٿ",
	ﭤ: () => "ٿ",
	ﭥ: () => "ٿ",
	ﭦ: () => ﭦ,
	ﭧ: () => ﭧ,
	ﭨ: () => ﭨ,
	ﭩ: () => ﭩ,
	ﭪ: () => ﭪ,
	ﭫ: () => ﭫ,
	ﭬ: () => ﭬ,
	ﭭ: () => ﭭ,
	ﭮ: () => "ڦ",
	ﭯ: () => "ڦ",
	ﭰ: () => "ڦ",
	ﭱ: () => "ڦ",
	ﭲ: () => "ڄ",
	ﭳ: () => "ڄ",
	ﭴ: () => "ڄ",
	ﭵ: () => "ڄ",
	ﭶ: () => "ڃ",
	ﭷ: () => "ڃ",
	ﭸ: () => "ڃ",
	ﭹ: () => "ڃ",
	ﭺ: () => "چ",
	ﭻ: () => "چ",
	ﭼ: () => "چ",
	ﭽ: () => "چ",
	ﭾ: () => "ڇ",
	ﭿ: () => "ڇ",
	ﮀ: () => "ڇ",
	ﮁ: () => "ڇ",
	ﮂ: () => "ڍ",
	ﮃ: () => "ڍ",
	ﮄ: () => "ڌ",
	ﮅ: () => "ڌ",
	ﮆ: () => ﮆ,
	ﮇ: () => ﮇ,
	ﮈ: () => ﮈ,
	ﮉ: () => ﮉ,
	ﮊ: () => ﮊ,
	ﮋ: () => ﮋ,
	ﮌ: () => ﮌ,
	ﮍ: () => ﮍ,
	ﮎ: () => "ك",
	ﮏ: () => "ك",
	ﮐ: () => "ك",
	ﮑ: () => "ك",
	ﮒ: () => "گ",
	ﮓ: () => "گ",
	ﮔ: () => "گ",
	ﮕ: () => "گ",
	ﮖ: () => "ڳ",
	ﮗ: () => "ڳ",
	ﮘ: () => "ڳ",
	ﮙ: () => "ڳ",
	ﮚ: () => "ڱ",
	ﮛ: () => "ڱ",
	ﮜ: () => "ڱ",
	ﮝ: () => "ڱ",
	ﮞ: () => "ى",
	ﮟ: () => "ى",
	ﮠ: () => ﮠ,
	ﮡ: () => ﮡ,
	ﮢ: () => ﮢ,
	ﮣ: () => ﮣ,
	ﮤ: () => "ۀ",
	ﮥ: () => "ۀ",
	ﮦ: () => "o",
	ﮧ: () => "o",
	ﮨ: () => "o",
	ﮩ: () => "o",
	ﮪ: () => "o",
	ﮫ: () => "o",
	ﮬ: () => "o",
	ﮭ: () => "o",
	ﮮ: () => "ى",
	ﮯ: () => "ى",
	ﮰ: () => "ۓ",
	ﮱ: () => "ۓ",
	ﯓ: () => ﯓ,
	ﯔ: () => ﯔ,
	ﯕ: () => ﯕ,
	ﯖ: () => ﯖ,
	ﯗ: () => ﯗ,
	ﯘ: () => ﯘ,
	ﯙ: () => ﯙ,
	ﯚ: () => ﯚ,
	ﯛ: () => ﯛ,
	ﯜ: () => ﯜ,
	ﯝ: () => ﯝ,
	ﯞ: () => ﯞ,
	ﯟ: () => ﯟ,
	ﯠ: () => "ۅ",
	ﯡ: () => "ۅ",
	ﯢ: () => ﯢ,
	ﯣ: () => ﯣ,
	ﯤ: () => "ٻ",
	ﯥ: () => "ٻ",
	ﯦ: () => "ٻ",
	ﯧ: () => "ٻ",
	ﯨ: () => "ى",
	ﯩ: () => "ى",
	ﯪ: () => ﯪ,
	ﯫ: () => ﯫ,
	ﯬ: () => ﯬ,
	ﯭ: () => ﯭ,
	ﯮ: () => ﯮ,
	ﯯ: () => ﯯ,
	ﯰ: () => ﯰ,
	ﯱ: () => ﯱ,
	ﯲ: () => ﯲ,
	ﯳ: () => ﯳ,
	ﯴ: () => ﯴ,
	ﯵ: () => ﯵ,
	ﯶ: () => ﯶ,
	ﯷ: () => ﯷ,
	ﯸ: () => ﯸ,
	ﯹ: () => ﯹ,
	ﯺ: () => ﯺ,
	ﯻ: () => ﯻ,
	ﯼ: () => "ى",
	ﯽ: () => "ى",
	ﯾ: () => "ى",
	ﯿ: () => "ى",
	ﰀ: () => ﰀ,
	ﰁ: () => ﰁ,
	ﰂ: () => ﰂ,
	ﰃ: () => ﰃ,
	ﰄ: () => ﰄ,
	ﰅ: () => ﰅ,
	ﰆ: () => ﰆ,
	ﰇ: () => ﰇ,
	ﰈ: () => ﰈ,
	ﰉ: () => ﰉ,
	ﰊ: () => ﰊ,
	ﰋ: () => ﰋ,
	ﰌ: () => ﰌ,
	ﰍ: () => ﰍ,
	ﰎ: () => ﰎ,
	ﰏ: () => ﰏ,
	ﰐ: () => ﰐ,
	ﰑ: () => ﰑ,
	ﰒ: () => ﰒ,
	ﰓ: () => ﰓ,
	ﰔ: () => ﰔ,
	ﰕ: () => ﰕ,
	ﰖ: () => ﰖ,
	ﰗ: () => ﰗ,
	ﰘ: () => ﰘ,
	ﰙ: () => ﰙ,
	ﰚ: () => ﰚ,
	ﰛ: () => ﰛ,
	ﰜ: () => ﰜ,
	ﰝ: () => ﰝ,
	ﰞ: () => ﰞ,
	ﰟ: () => ﰟ,
	ﰠ: () => ﰠ,
	ﰡ: () => ﰡ,
	ﰢ: () => ﰢ,
	ﰣ: () => ﰣ,
	ﰤ: () => ﰤ,
	ﰥ: () => ﰥ,
	ﰦ: () => ﰦ,
	ﰧ: () => ﰧ,
	ﰨ: () => ﰨ,
	ﰩ: () => ﰩ,
	ﰪ: () => ﰪ,
	ﰫ: () => ﰫ,
	ﰬ: () => ﰬ,
	ﰭ: () => ﰭ,
	ﰮ: () => ﰮ,
	ﰯ: () => ﰯ,
	ﰰ: () => ﰰ,
	ﰱ: () => ﰱ,
	ﰲ: () => ﰲ,
	ﰳ: () => ﰳ,
	ﰴ: () => ﰴ,
	ﰵ: () => ﰵ,
	ﰶ: () => ﰶ,
	ﰷ: () => "كl",
	ﰸ: () => ﰸ,
	ﰹ: () => ﰹ,
	ﰺ: () => ﰺ,
	ﰻ: () => ﰻ,
	ﰼ: () => ﰼ,
	ﰽ: () => ﰽ,
	ﰾ: () => ﰾ,
	ﰿ: () => ﰿ,
	ﱀ: () => ﱀ,
	ﱁ: () => ﱁ,
	ﱂ: () => ﱂ,
	ﱃ: () => ﱃ,
	ﱄ: () => ﱄ,
	ﱅ: () => ﱅ,
	ﱆ: () => ﱆ,
	ﱇ: () => ﱇ,
	ﱈ: () => ﱈ,
	ﱉ: () => ﱉ,
	ﱊ: () => ﱊ,
	ﱋ: () => ﱋ,
	ﱌ: () => ﱌ,
	ﱍ: () => ﱍ,
	ﱎ: () => ﱎ,
	ﱏ: () => ﱏ,
	ﱐ: () => ﱐ,
	ﱑ: () => "oج",
	ﱒ: () => "oم",
	ﱓ: () => "oى",
	ﱔ: () => "oى",
	ﱕ: () => ﱕ,
	ﱖ: () => ﱖ,
	ﱗ: () => ﱗ,
	ﱘ: () => ﱘ,
	ﱙ: () => ﱙ,
	ﱚ: () => ﱚ,
	ﱛ: () => ﱛ,
	ﱜ: () => ﱜ,
	ﱝ: () => ﱝ,
	ﱞ: () => ﱞ,
	ﱟ: () => ﱟ,
	ﱠ: () => ﱠ,
	ﱡ: () => ﱡ,
	ﱢ: () => ﱢ,
	ﱣ: () => ﱣ,
	ﱤ: () => ﱤ,
	ﱥ: () => ﱥ,
	ﱦ: () => ﱦ,
	ﱧ: () => ﱧ,
	ﱨ: () => ﱨ,
	ﱩ: () => ﱩ,
	ﱪ: () => ﱪ,
	ﱫ: () => ﱫ,
	ﱬ: () => ﱬ,
	ﱭ: () => ﱭ,
	ﱮ: () => ﱮ,
	ﱯ: () => ﱯ,
	ﱰ: () => ﱰ,
	ﱱ: () => ﱱ,
	ﱲ: () => ﱲ,
	ﱳ: () => ﱳ,
	ﱴ: () => ﱴ,
	ﱵ: () => ﱵ,
	ﱶ: () => ﱶ,
	ﱷ: () => ﱷ,
	ﱸ: () => ﱸ,
	ﱹ: () => ﱹ,
	ﱺ: () => ﱺ,
	ﱻ: () => ﱻ,
	ﱼ: () => ﱼ,
	ﱽ: () => ﱽ,
	ﱾ: () => ﱾ,
	ﱿ: () => ﱿ,
	ﲀ: () => "كl",
	ﲁ: () => ﲁ,
	ﲂ: () => ﲂ,
	ﲃ: () => ﲃ,
	ﲄ: () => ﲄ,
	ﲅ: () => ﲅ,
	ﲆ: () => ﲆ,
	ﲇ: () => ﲇ,
	ﲈ: () => "مl",
	ﲉ: () => ﲉ,
	ﲊ: () => ﲊ,
	ﲋ: () => ﲋ,
	ﲌ: () => ﲌ,
	ﲍ: () => ﲍ,
	ﲎ: () => ﲎ,
	ﲏ: () => ﲏ,
	ﲐ: () => ﲐ,
	ﲑ: () => ﲑ,
	ﲒ: () => ﲒ,
	ﲓ: () => ﲓ,
	ﲔ: () => ﲔ,
	ﲕ: () => ﲕ,
	ﲖ: () => ﲖ,
	ﲗ: () => ﲗ,
	ﲘ: () => ﲘ,
	ﲙ: () => ﲙ,
	ﲚ: () => ﲚ,
	ﲛ: () => ﲛ,
	ﲜ: () => ﲜ,
	ﲝ: () => ﲝ,
	ﲞ: () => ﲞ,
	ﲟ: () => ﲟ,
	ﲠ: () => "بo",
	ﲡ: () => ﲡ,
	ﲢ: () => ﲢ,
	ﲣ: () => ﲣ,
	ﲤ: () => ﲤ,
	ﲥ: () => "تo",
	ﲦ: () => ﲦ,
	ﲧ: () => ﲧ,
	ﲨ: () => ﲨ,
	ﲩ: () => ﲩ,
	ﲪ: () => ﲪ,
	ﲫ: () => ﲫ,
	ﲬ: () => ﲬ,
	ﲭ: () => ﲭ,
	ﲮ: () => ﲮ,
	ﲯ: () => ﲯ,
	ﲰ: () => ﲰ,
	ﲱ: () => ﲱ,
	ﲲ: () => ﲲ,
	ﲳ: () => ﲳ,
	ﲴ: () => ﲴ,
	ﲵ: () => ﲵ,
	ﲶ: () => ﲶ,
	ﲷ: () => ﲷ,
	ﲸ: () => ﲸ,
	ﲹ: () => ﲹ,
	ﲺ: () => ﲺ,
	ﲻ: () => ﲻ,
	ﲼ: () => ﲼ,
	ﲽ: () => ﲽ,
	ﲾ: () => ﲾ,
	ﲿ: () => ﲿ,
	ﳀ: () => ﳀ,
	ﳁ: () => ﳁ,
	ﳂ: () => ﳂ,
	ﳃ: () => ﳃ,
	ﳄ: () => ﳄ,
	ﳅ: () => ﳅ,
	ﳆ: () => ﳆ,
	ﳇ: () => ﳇ,
	ﳈ: () => ﳈ,
	ﳉ: () => ﳉ,
	ﳊ: () => ﳊ,
	ﳋ: () => ﳋ,
	ﳌ: () => ﳌ,
	ﳍ: () => "لo",
	ﳎ: () => ﳎ,
	ﳏ: () => ﳏ,
	ﳐ: () => ﳐ,
	ﳑ: () => ﳑ,
	ﳒ: () => ﳒ,
	ﳓ: () => ﳓ,
	ﳔ: () => ﳔ,
	ﳕ: () => ﳕ,
	ﳖ: () => "نo",
	ﳗ: () => "oج",
	ﳘ: () => "oم",
	ﳙ: () => "oٰ",
	ﳚ: () => ﳚ,
	ﳛ: () => ﳛ,
	ﳜ: () => ﳜ,
	ﳝ: () => ﳝ,
	ﳞ: () => "ىo",
	ﳟ: () => ﳟ,
	ﳠ: () => ﳠ,
	ﳡ: () => ﳡ,
	ﳢ: () => "بo",
	ﳣ: () => ﳣ,
	ﳤ: () => "تo",
	ﳥ: () => ﳥ,
	ﳦ: () => ﳦ,
	ﳧ: () => ﳧ,
	ﳨ: () => "سo",
	ﳩ: () => ﳩ,
	ﳪ: () => ﳪ,
	ﳫ: () => ﳫ,
	ﳬ: () => ﳬ,
	ﳭ: () => ﳭ,
	ﳮ: () => ﳮ,
	ﳯ: () => "نo",
	ﳰ: () => ﳰ,
	ﳱ: () => "ىo",
	ﳲ: () => ﳲ,
	ﳳ: () => ﳳ,
	ﳴ: () => ﳴ,
	ﳵ: () => ﳵ,
	ﳶ: () => ﳶ,
	ﳷ: () => ﳷ,
	ﳸ: () => ﳸ,
	ﳹ: () => ﳹ,
	ﳺ: () => ﳺ,
	ﳻ: () => ﳻ,
	ﳼ: () => ﳼ,
	ﳽ: () => ﳽ,
	ﳾ: () => ﳾ,
	ﳿ: () => ﳿ,
	ﴀ: () => ﴀ,
	ﴁ: () => ﴁ,
	ﴂ: () => ﴂ,
	ﴃ: () => ﴃ,
	ﴄ: () => ﴄ,
	ﴅ: () => ﴅ,
	ﴆ: () => ﴆ,
	ﴇ: () => ﴇ,
	ﴈ: () => ﴈ,
	ﴉ: () => ﴉ,
	ﴊ: () => ﴊ,
	ﴋ: () => ﴋ,
	ﴌ: () => ﴌ,
	ﴍ: () => ﴍ,
	ﴎ: () => ﴎ,
	ﴏ: () => ﴏ,
	ﴐ: () => ﴐ,
	ﴑ: () => ﴑ,
	ﴒ: () => ﴒ,
	ﴓ: () => ﴓ,
	ﴔ: () => ﴔ,
	ﴕ: () => ﴕ,
	ﴖ: () => ﴖ,
	ﴗ: () => ﴗ,
	ﴘ: () => ﴘ,
	ﴙ: () => ﴙ,
	ﴚ: () => ﴚ,
	ﴛ: () => ﴛ,
	ﴜ: () => ﴜ,
	ﴝ: () => ﴝ,
	ﴞ: () => ﴞ,
	ﴟ: () => ﴟ,
	ﴠ: () => ﴠ,
	ﴡ: () => ﴡ,
	ﴢ: () => ﴢ,
	ﴣ: () => ﴣ,
	ﴤ: () => ﴤ,
	ﴥ: () => ﴥ,
	ﴦ: () => ﴦ,
	ﴧ: () => ﴧ,
	ﴨ: () => ﴨ,
	ﴩ: () => ﴩ,
	ﴪ: () => ﴪ,
	ﴫ: () => ﴫ,
	ﴬ: () => ﴬ,
	ﴭ: () => ﴭ,
	ﴮ: () => ﴮ,
	ﴯ: () => ﴯ,
	ﴰ: () => ﴰ,
	ﴱ: () => "سo",
	ﴲ: () => ﴲ,
	ﴳ: () => ﴳ,
	ﴴ: () => ﴴ,
	ﴵ: () => ﴵ,
	ﴶ: () => ﴶ,
	ﴷ: () => ﴷ,
	ﴸ: () => ﴸ,
	ﴹ: () => ﴹ,
	ﴺ: () => ﴺ,
	ﴻ: () => ﴻ,
	ﴼ: () => "l̋",
	ﴽ: () => "l̋",
	ﵐ: () => ﵐ,
	ﵑ: () => ﵑ,
	ﵒ: () => ﵒ,
	ﵓ: () => ﵓ,
	ﵔ: () => ﵔ,
	ﵕ: () => ﵕ,
	ﵖ: () => ﵖ,
	ﵗ: () => ﵗ,
	ﵘ: () => ﵘ,
	ﵙ: () => ﵙ,
	ﵚ: () => ﵚ,
	ﵛ: () => ﵛ,
	ﵜ: () => ﵜ,
	ﵝ: () => ﵝ,
	ﵞ: () => ﵞ,
	ﵟ: () => ﵟ,
	ﵠ: () => ﵠ,
	ﵡ: () => ﵡ,
	ﵢ: () => ﵢ,
	ﵣ: () => ﵣ,
	ﵤ: () => ﵤ,
	ﵥ: () => ﵥ,
	ﵦ: () => ﵦ,
	ﵧ: () => ﵧ,
	ﵨ: () => ﵨ,
	ﵩ: () => ﵩ,
	ﵪ: () => ﵪ,
	ﵫ: () => ﵫ,
	ﵬ: () => ﵬ,
	ﵭ: () => ﵭ,
	ﵮ: () => ﵮ,
	ﵯ: () => ﵯ,
	ﵰ: () => ﵰ,
	ﵱ: () => ﵱ,
	ﵲ: () => ﵲ,
	ﵳ: () => ﵳ,
	ﵴ: () => ﵴ,
	ﵵ: () => ﵵ,
	ﵶ: () => ﵶ,
	ﵷ: () => ﵷ,
	ﵸ: () => ﵸ,
	ﵹ: () => ﵹ,
	ﵺ: () => ﵺ,
	ﵻ: () => ﵻ,
	ﵼ: () => ﵼ,
	ﵽ: () => ﵽ,
	ﵾ: () => ﵾ,
	ﵿ: () => ﵿ,
	ﶀ: () => ﶀ,
	ﶁ: () => ﶁ,
	ﶂ: () => ﶂ,
	ﶃ: () => ﶃ,
	ﶄ: () => ﶄ,
	ﶅ: () => ﶅ,
	ﶆ: () => ﶆ,
	ﶇ: () => ﶇ,
	ﶈ: () => ﶈ,
	ﶉ: () => ﶉ,
	ﶊ: () => ﶊ,
	ﶋ: () => ﶋ,
	ﶌ: () => ﶌ,
	ﶍ: () => ﶍ,
	ﶎ: () => ﶎ,
	ﶏ: () => ﶏ,
	ﶒ: () => ﶒ,
	ﶓ: () => ﶓ,
	ﶔ: () => ﶔ,
	ﶕ: () => ﶕ,
	ﶖ: () => ﶖ,
	ﶗ: () => ﶗ,
	ﶘ: () => ﶘ,
	ﶙ: () => ﶙ,
	ﶚ: () => ﶚ,
	ﶛ: () => ﶛ,
	ﶜ: () => ﶜ,
	ﶝ: () => ﶝ,
	ﶞ: () => ﶞ,
	ﶟ: () => ﶟ,
	ﶠ: () => ﶠ,
	ﶡ: () => ﶡ,
	ﶢ: () => ﶢ,
	ﶣ: () => ﶣ,
	ﶤ: () => ﶤ,
	ﶥ: () => ﶥ,
	ﶦ: () => ﶦ,
	ﶧ: () => ﶧ,
	ﶨ: () => ﶨ,
	ﶩ: () => ﶩ,
	ﶪ: () => ﶪ,
	ﶫ: () => ﶫ,
	ﶬ: () => ﶬ,
	ﶭ: () => ﶭ,
	ﶮ: () => ﶮ,
	ﶯ: () => ﶯ,
	ﶰ: () => ﶰ,
	ﶱ: () => ﶱ,
	ﶲ: () => ﶲ,
	ﶳ: () => ﶳ,
	ﶴ: () => ﶴ,
	ﶵ: () => ﶵ,
	ﶶ: () => ﶶ,
	ﶷ: () => ﶷ,
	ﶸ: () => ﶸ,
	ﶹ: () => ﶹ,
	ﶺ: () => ﶺ,
	ﶻ: () => ﶻ,
	ﶼ: () => ﶼ,
	ﶽ: () => ﶽ,
	ﶾ: () => ﶾ,
	ﶿ: () => ﶿ,
	ﷀ: () => ﷀ,
	ﷁ: () => ﷁ,
	ﷂ: () => ﷂ,
	ﷃ: () => ﷃ,
	ﷄ: () => ﷄ,
	ﷅ: () => ﷅ,
	ﷆ: () => ﷆ,
	ﷇ: () => ﷇ,
	ﷰ: () => ﷰ,
	ﷱ: () => ﷱ,
	ﷲ: () => ﷲ,
	ﷳ: () => ﷳ,
	ﷴ: () => ﷴ,
	ﷵ: () => ﷵ,
	ﷶ: () => ﷶ,
	ﷷ: () => ﷷ,
	ﷸ: () => ﷸ,
	ﷹ: () => ﷹ,
	ﷺ: () => ﷺ,
	ﷻ: () => ﷻ,
	ﺀ: () => "ء",
	ﺁ: () => "آ",
	ﺂ: () => "آ",
	ﺃ: () => "lٴ",
	ﺄ: () => "lٴ",
	ﺅ: () => ﺅ,
	ﺆ: () => ﺆ,
	ﺇ: () => "lٕ",
	ﺈ: () => "lٕ",
	ﺉ: () => ﺉ,
	ﺊ: () => ﺊ,
	ﺋ: () => ﺋ,
	ﺌ: () => ﺌ,
	ﺍ: () => "l",
	ﺎ: () => "l",
	ﺏ: () => "ب",
	ﺐ: () => "ب",
	ﺑ: () => "ب",
	ﺒ: () => "ب",
	ﺓ: () => "ة",
	ﺔ: () => "ة",
	ﺕ: () => "ت",
	ﺖ: () => "ت",
	ﺗ: () => "ت",
	ﺘ: () => "ت",
	ﺙ: () => ﺙ,
	ﺚ: () => ﺚ,
	ﺛ: () => ﺛ,
	ﺜ: () => ﺜ,
	ﺝ: () => "ج",
	ﺞ: () => "ج",
	ﺟ: () => "ج",
	ﺠ: () => "ج",
	ﺡ: () => "ح",
	ﺢ: () => "ح",
	ﺣ: () => "ح",
	ﺤ: () => "ح",
	ﺥ: () => "خ",
	ﺦ: () => "خ",
	ﺧ: () => "خ",
	ﺨ: () => "خ",
	ﺩ: () => "د",
	ﺪ: () => "د",
	ﺫ: () => "ذ",
	ﺬ: () => "ذ",
	ﺭ: () => "ر",
	ﺮ: () => "ر",
	ﺯ: () => "ز",
	ﺰ: () => "ز",
	ﺱ: () => "س",
	ﺲ: () => "س",
	ﺳ: () => "س",
	ﺴ: () => "س",
	ﺵ: () => ﺵ,
	ﺶ: () => ﺶ,
	ﺷ: () => ﺷ,
	ﺸ: () => ﺸ,
	ﺹ: () => "ص",
	ﺺ: () => "ص",
	ﺻ: () => "ص",
	ﺼ: () => "ص",
	ﺽ: () => "ض",
	ﺾ: () => "ض",
	ﺿ: () => "ض",
	ﻀ: () => "ض",
	ﻁ: () => "ط",
	ﻂ: () => "ط",
	ﻃ: () => "ط",
	ﻄ: () => "ط",
	ﻅ: () => "ظ",
	ﻆ: () => "ظ",
	ﻇ: () => "ظ",
	ﻈ: () => "ظ",
	ﻉ: () => "ع",
	ﻊ: () => "ع",
	ﻋ: () => "ع",
	ﻌ: () => "ع",
	ﻍ: () => "غ",
	ﻎ: () => "غ",
	ﻏ: () => "غ",
	ﻐ: () => "غ",
	ﻑ: () => "ف",
	ﻒ: () => "ف",
	ﻓ: () => "ف",
	ﻔ: () => "ف",
	ﻕ: () => "ق",
	ﻖ: () => "ق",
	ﻗ: () => "ق",
	ﻘ: () => "ق",
	ﻙ: () => "ك",
	ﻚ: () => "ك",
	ﻛ: () => "ك",
	ﻜ: () => "ك",
	ﻝ: () => "ل",
	ﻞ: () => "ل",
	ﻟ: () => "ل",
	ﻠ: () => "ل",
	ﻡ: () => "م",
	ﻢ: () => "م",
	ﻣ: () => "م",
	ﻤ: () => "م",
	ﻥ: () => "ن",
	ﻦ: () => "ن",
	ﻧ: () => "ن",
	ﻨ: () => "ن",
	ﻩ: () => "o",
	ﻪ: () => "o",
	ﻫ: () => "o",
	ﻬ: () => "o",
	ﻭ: () => "و",
	ﻮ: () => "و",
	ﻯ: () => "ى",
	ﻰ: () => "ى",
	ﻱ: () => "ى",
	ﻲ: () => "ى",
	ﻳ: () => "ى",
	ﻴ: () => "ى",
	ﻵ: () => ﻵ,
	ﻶ: () => ﻶ,
	ﻷ: () => ﻷ,
	ﻸ: () => ﻸ,
	ﻹ: () => ﻹ,
	ﻺ: () => ﻺ,
	ﻻ: () => "لl",
	ﻼ: () => "لl",
	Ａ: () => "A",
	Ｂ: () => "B",
	Ｃ: () => "C",
	Ｅ: () => "E",
	Ｈ: () => "H",
	Ｉ: () => "l",
	Ｊ: () => "J",
	Ｋ: () => "K",
	Ｍ: () => "M",
	Ｎ: () => "N",
	Ｏ: () => "O",
	Ｐ: () => "P",
	Ｓ: () => "S",
	Ｔ: () => "T",
	Ｘ: () => "X",
	Ｙ: () => "Y",
	Ｚ: () => "Z",
	ａ: () => "a",
	ｃ: () => "c",
	ｅ: () => "e",
	ｇ: () => "g",
	ｈ: () => "h",
	ｉ: () => "i",
	ｊ: () => "j",
	ｌ: () => "l",
	ｏ: () => "o",
	ｐ: () => "p",
	ｓ: () => "s",
	ｖ: () => "v",
	ｘ: () => "x",
	ｙ: () => "y",
	𐊂: () => "B",
	𐊅: () => "Δ",
	𐊆: () => "E",
	𐊇: () => "F",
	𐊊: () => "l",
	𐊍: () => "Ʌ",
	𐊐: () => "X",
	𐊒: () => "O",
	𐊔: () => "ᛜ",
	𐊕: () => "P",
	𐊖: () => "S",
	𐊗: () => "T",
	𐊛: () => "+",
	𐊠: () => "A",
	𐊡: () => "B",
	𐊢: () => "C",
	𐊣: () => "Δ",
	𐊥: () => "F",
	𐊫: () => "O",
	𐊭: () => "Ϙ",
	𐊰: () => "M",
	𐊱: () => "T",
	𐊲: () => "Y",
	𐊳: () => "Φ",
	𐊴: () => "X",
	𐊵: () => "Ψ",
	𐊶: () => "Ω",
	𐊸: () => "ⵀ",
	𐋏: () => "H",
	𐌁: () => "B",
	𐌂: () => "C",
	𐌉: () => "l",
	𐌑: () => "M",
	𐌒: () => "Ϙ",
	𐌕: () => "T",
	𐌗: () => "X",
	𐌚: () => "8",
	𐌟: () => "*",
	𐏑: () => 𐏑,
	𐏓: () => 𐏓,
	𐐁: () => "Ɛ",
	𐐄: () => "O",
	𐐑: () => "ꓶ",
	𐐕: () => "C",
	𐐛: () => "L",
	𐐟: () => "Ɒ",
	𐐠: () => "S",
	𐐣: () => "Ɔ",
	𐐥: () => "И",
	𐐩: () => "ꞓ",
	𐐪: () => "ʚ",
	𐐬: () => "o",
	𐐽: () => "c",
	𐐿: () => "ɷ",
	𐑂: () => "ɞ",
	𐑃: () => "ʟ",
	𐑈: () => "s",
	𐑋: () => "ɔ",
	𐑍: () => "ᴎ",
	𐒰: () => "Ʌ",
	𐒴: () => "R",
	𐒼: () => "Ӄ",
	𐓂: () => "O",
	𐓃: () => "ʘ",
	𐓄: () => "Þ",
	𐓍: () => "Ћ",
	𐓎: () => "U",
	𐓐: () => "ᛦ",
	𐓑: () => "Ψ",
	𐓒: () => "7",
	𐓘: () => "ʌ",
	𐓛: () => "λ",
	𐓪: () => "o",
	𐓫: () => "ꙩ",
	𐓶: () => "u",
	𐓹: () => "ψ",
	𐔓: () => "N",
	𐔖: () => "O",
	𐔘: () => "K",
	𐔜: () => "C",
	𐔝: () => "V",
	𐔥: () => "F",
	𐔦: () => "L",
	𐔧: () => "X",
	𑇜: () => "ꣻ",
	𑐓: () => 𑐓,
	𑐙: () => 𑐙,
	𑐤: () => 𑐤,
	𑐪: () => 𑐪,
	𑐭: () => 𑐭,
	𑐯: () => 𑐯,
	𑒒: () => "ঘ",
	𑒔: () => "চ",
	𑒖: () => "জ",
	𑒘: () => "ঞ",
	𑒙: () => "ট",
	𑒛: () => "ড",
	𑒝: () => "ল",
	𑒞: () => "ত",
	𑒟: () => "থ",
	𑒠: () => "দ",
	𑒡: () => "ধ",
	𑒢: () => "ন",
	𑒣: () => "প",
	𑒧: () => "ম",
	𑒨: () => "য",
	𑒩: () => "ব",
	𑒪: () => "ণ",
	𑒫: () => "র",
	𑒭: () => "ষ",
	𑒮: () => "স",
	𑓄: () => "ঽ",
	𑓅: () => "ẇ",
	𑗘: () => 𑗘,
	𑗙: () => 𑗙,
	𑗚: () => 𑗚,
	𑗛: () => 𑗛,
	𑜀: () => "rn",
	𑜆: () => "v",
	𑜊: () => "w",
	𑜎: () => "w",
	𑜏: () => "w",
	𑢠: () => "V",
	𑢢: () => "F",
	𑢣: () => "L",
	𑢤: () => "Y",
	𑢦: () => "E",
	𑢨: () => "∇",
	𑢩: () => "Z",
	𑢬: () => "9",
	𑢮: () => "E",
	𑢯: () => "4",
	𑢲: () => "L",
	𑢵: () => "O",
	𑢷: () => "ᛜ",
	𑢸: () => "U",
	𑢻: () => "5",
	𑢼: () => "T",
	𑣀: () => "v",
	𑣁: () => "s",
	𑣂: () => "F",
	𑣃: () => "i",
	𑣄: () => "z",
	𑣆: () => "7",
	𑣈: () => "o",
	𑣊: () => "3",
	𑣌: () => "9",
	𑣎: () => "ꞓ",
	𑣕: () => "6",
	𑣖: () => "9",
	𑣗: () => "o",
	𑣘: () => "u",
	𑣜: () => "y",
	𑫦: () => 𑫦,
	𑫧: () => 𑫧,
	𑫨: () => 𑫨,
	𑫩: () => 𑫩,
	𑫪: () => 𑫪,
	𑫬: () => 𑫬,
	𑫭: () => 𑫭,
	𑫮: () => 𑫮,
	𑫴: () => 𑫴,
	𑫵: () => 𑫵,
	𑫶: () => 𑫶,
	𑫷: () => 𑫷,
	𑫸: () => 𑫸,
	𒀸: () => 𒀸,
	𓋹: () => 𓋹,
	𖼇: () => "Γ",
	𖼈: () => "V",
	𖼊: () => "T",
	𖼖: () => "L",
	𖼚: () => "Δ",
	𖼜: () => "Ꙙ",
	𖼦: () => "ꓶ",
	𖼨: () => "l",
	𖼭: () => "Ɛ",
	𖼵: () => "R",
	𖼺: () => "S",
	𖼻: () => "3",
	𖼽: () => "Ʌ",
	𖼿: () => ">",
	𖽀: () => "A",
	𖽂: () => "U",
	𖽃: () => "Y",
	𝐀: () => "A",
	𝐁: () => "B",
	𝐂: () => "C",
	𝐃: () => "D",
	𝐄: () => "E",
	𝐅: () => "F",
	𝐆: () => "G",
	𝐇: () => "H",
	𝐈: () => "l",
	𝐉: () => "J",
	𝐊: () => "K",
	𝐋: () => "L",
	𝐌: () => "M",
	𝐍: () => "N",
	𝐎: () => "O",
	𝐏: () => "P",
	𝐐: () => "Q",
	𝐑: () => "R",
	𝐒: () => "S",
	𝐓: () => "T",
	𝐔: () => "U",
	𝐕: () => "V",
	𝐖: () => "W",
	𝐗: () => "X",
	𝐘: () => "Y",
	𝐙: () => "Z",
	𝐚: () => "a",
	𝐛: () => "b",
	𝐜: () => "c",
	𝐝: () => "d",
	𝐞: () => "e",
	𝐟: () => "f",
	𝐠: () => "g",
	𝐡: () => "h",
	𝐢: () => "i",
	𝐣: () => "j",
	𝐤: () => "k",
	𝐥: () => "l",
	𝐦: () => "rn",
	𝐧: () => "n",
	𝐨: () => "o",
	𝐩: () => "p",
	𝐪: () => "q",
	𝐫: () => "r",
	𝐬: () => "s",
	𝐭: () => "t",
	𝐮: () => "u",
	𝐯: () => "v",
	𝐰: () => "w",
	𝐱: () => "x",
	𝐲: () => "y",
	𝐳: () => "z",
	𝐴: () => "A",
	𝐵: () => "B",
	𝐶: () => "C",
	𝐷: () => "D",
	𝐸: () => "E",
	𝐹: () => "F",
	𝐺: () => "G",
	𝐻: () => "H",
	𝐼: () => "l",
	𝐽: () => "J",
	𝐾: () => "K",
	𝐿: () => "L",
	𝑀: () => "M",
	𝑁: () => "N",
	𝑂: () => "O",
	𝑃: () => "P",
	𝑄: () => "Q",
	𝑅: () => "R",
	𝑆: () => "S",
	𝑇: () => "T",
	𝑈: () => "U",
	𝑉: () => "V",
	𝑊: () => "W",
	𝑋: () => "X",
	𝑌: () => "Y",
	𝑍: () => "Z",
	𝑎: () => "a",
	𝑏: () => "b",
	𝑐: () => "c",
	𝑑: () => "d",
	𝑒: () => "e",
	𝑓: () => "f",
	𝑔: () => "g",
	𝑖: () => "i",
	𝑗: () => "j",
	𝑘: () => "k",
	𝑙: () => "l",
	𝑚: () => "rn",
	𝑛: () => "n",
	𝑜: () => "o",
	𝑝: () => "p",
	𝑞: () => "q",
	𝑟: () => "r",
	𝑠: () => "s",
	𝑡: () => "t",
	𝑢: () => "u",
	𝑣: () => "v",
	𝑤: () => "w",
	𝑥: () => "x",
	𝑦: () => "y",
	𝑧: () => "z",
	𝑨: () => "A",
	𝑩: () => "B",
	𝑪: () => "C",
	𝑫: () => "D",
	𝑬: () => "E",
	𝑭: () => "F",
	𝑮: () => "G",
	𝑯: () => "H",
	𝑰: () => "l",
	𝑱: () => "J",
	𝑲: () => "K",
	𝑳: () => "L",
	𝑴: () => "M",
	𝑵: () => "N",
	𝑶: () => "O",
	𝑷: () => "P",
	𝑸: () => "Q",
	𝑹: () => "R",
	𝑺: () => "S",
	𝑻: () => "T",
	𝑼: () => "U",
	𝑽: () => "V",
	𝑾: () => "W",
	𝑿: () => "X",
	𝒀: () => "Y",
	𝒁: () => "Z",
	𝒂: () => "a",
	𝒃: () => "b",
	𝒄: () => "c",
	𝒅: () => "d",
	𝒆: () => "e",
	𝒇: () => "f",
	𝒈: () => "g",
	𝒉: () => "h",
	𝒊: () => "i",
	𝒋: () => "j",
	𝒌: () => "k",
	𝒍: () => "l",
	𝒎: () => "rn",
	𝒏: () => "n",
	𝒐: () => "o",
	𝒑: () => "p",
	𝒒: () => "q",
	𝒓: () => "r",
	𝒔: () => "s",
	𝒕: () => "t",
	𝒖: () => "u",
	𝒗: () => "v",
	𝒘: () => "w",
	𝒙: () => "x",
	𝒚: () => "y",
	𝒛: () => "z",
	𝒜: () => "A",
	𝒞: () => "C",
	𝒟: () => "D",
	𝒢: () => "G",
	𝒥: () => "J",
	𝒦: () => "K",
	𝒩: () => "N",
	𝒪: () => "O",
	𝒫: () => "P",
	𝒬: () => "Q",
	𝒮: () => "S",
	𝒯: () => "T",
	𝒰: () => "U",
	𝒱: () => "V",
	𝒲: () => "W",
	𝒳: () => "X",
	𝒴: () => "Y",
	𝒵: () => "Z",
	𝒶: () => "a",
	𝒷: () => "b",
	𝒸: () => "c",
	𝒹: () => "d",
	𝒻: () => "f",
	𝒽: () => "h",
	𝒾: () => "i",
	𝒿: () => "j",
	𝓀: () => "k",
	𝓁: () => "l",
	𝓂: () => "rn",
	𝓃: () => "n",
	𝓅: () => "p",
	𝓆: () => "q",
	𝓇: () => "r",
	𝓈: () => "s",
	𝓉: () => "t",
	𝓊: () => "u",
	𝓋: () => "v",
	𝓌: () => "w",
	𝓍: () => "x",
	𝓎: () => "y",
	𝓏: () => "z",
	𝓐: () => "A",
	𝓑: () => "B",
	𝓒: () => "C",
	𝓓: () => "D",
	𝓔: () => "E",
	𝓕: () => "F",
	𝓖: () => "G",
	𝓗: () => "H",
	𝓘: () => "l",
	𝓙: () => "J",
	𝓚: () => "K",
	𝓛: () => "L",
	𝓜: () => "M",
	𝓝: () => "N",
	𝓞: () => "O",
	𝓟: () => "P",
	𝓠: () => "Q",
	𝓡: () => "R",
	𝓢: () => "S",
	𝓣: () => "T",
	𝓤: () => "U",
	𝓥: () => "V",
	𝓦: () => "W",
	𝓧: () => "X",
	𝓨: () => "Y",
	𝓩: () => "Z",
	𝓪: () => "a",
	𝓫: () => "b",
	𝓬: () => "c",
	𝓭: () => "d",
	𝓮: () => "e",
	𝓯: () => "f",
	𝓰: () => "g",
	𝓱: () => "h",
	𝓲: () => "i",
	𝓳: () => "j",
	𝓴: () => "k",
	𝓵: () => "l",
	𝓶: () => "rn",
	𝓷: () => "n",
	𝓸: () => "o",
	𝓹: () => "p",
	𝓺: () => "q",
	𝓻: () => "r",
	𝓼: () => "s",
	𝓽: () => "t",
	𝓾: () => "u",
	𝓿: () => "v",
	𝔀: () => "w",
	𝔁: () => "x",
	𝔂: () => "y",
	𝔃: () => "z",
	𝔄: () => "A",
	𝔅: () => "B",
	𝔇: () => "D",
	𝔈: () => "E",
	𝔉: () => "F",
	𝔊: () => "G",
	𝔍: () => "J",
	𝔎: () => "K",
	𝔏: () => "L",
	𝔐: () => "M",
	𝔑: () => "N",
	𝔒: () => "O",
	𝔓: () => "P",
	𝔔: () => "Q",
	𝔖: () => "S",
	𝔗: () => "T",
	𝔘: () => "U",
	𝔙: () => "V",
	𝔚: () => "W",
	𝔛: () => "X",
	𝔜: () => "Y",
	𝔞: () => "a",
	𝔟: () => "b",
	𝔠: () => "c",
	𝔡: () => "d",
	𝔢: () => "e",
	𝔣: () => "f",
	𝔤: () => "g",
	𝔥: () => "h",
	𝔦: () => "i",
	𝔧: () => "j",
	𝔨: () => "k",
	𝔩: () => "l",
	𝔪: () => "rn",
	𝔫: () => "n",
	𝔬: () => "o",
	𝔭: () => "p",
	𝔮: () => "q",
	𝔯: () => "r",
	𝔰: () => "s",
	𝔱: () => "t",
	𝔲: () => "u",
	𝔳: () => "v",
	𝔴: () => "w",
	𝔵: () => "x",
	𝔶: () => "y",
	𝔷: () => "z",
	𝔸: () => "A",
	𝔹: () => "B",
	𝔻: () => "D",
	𝔼: () => "E",
	𝔽: () => "F",
	𝔾: () => "G",
	𝕀: () => "l",
	𝕁: () => "J",
	𝕂: () => "K",
	𝕃: () => "L",
	𝕄: () => "M",
	𝕆: () => "O",
	𝕊: () => "S",
	𝕋: () => "T",
	𝕌: () => "U",
	𝕍: () => "V",
	𝕎: () => "W",
	𝕏: () => "X",
	𝕐: () => "Y",
	𝕒: () => "a",
	𝕓: () => "b",
	𝕔: () => "c",
	𝕕: () => "d",
	𝕖: () => "e",
	𝕗: () => "f",
	𝕘: () => "g",
	𝕙: () => "h",
	𝕚: () => "i",
	𝕛: () => "j",
	𝕜: () => "k",
	𝕝: () => "l",
	𝕞: () => "rn",
	𝕟: () => "n",
	𝕠: () => "o",
	𝕡: () => "p",
	𝕢: () => "q",
	𝕣: () => "r",
	𝕤: () => "s",
	𝕥: () => "t",
	𝕦: () => "u",
	𝕧: () => "v",
	𝕨: () => "w",
	𝕩: () => "x",
	𝕪: () => "y",
	𝕫: () => "z",
	𝕬: () => "A",
	𝕭: () => "B",
	𝕮: () => "C",
	𝕯: () => "D",
	𝕰: () => "E",
	𝕱: () => "F",
	𝕲: () => "G",
	𝕳: () => "H",
	𝕴: () => "l",
	𝕵: () => "J",
	𝕶: () => "K",
	𝕷: () => "L",
	𝕸: () => "M",
	𝕹: () => "N",
	𝕺: () => "O",
	𝕻: () => "P",
	𝕼: () => "Q",
	𝕽: () => "R",
	𝕾: () => "S",
	𝕿: () => "T",
	𝖀: () => "U",
	𝖁: () => "V",
	𝖂: () => "W",
	𝖃: () => "X",
	𝖄: () => "Y",
	𝖅: () => "Z",
	𝖆: () => "a",
	𝖇: () => "b",
	𝖈: () => "c",
	𝖉: () => "d",
	𝖊: () => "e",
	𝖋: () => "f",
	𝖌: () => "g",
	𝖍: () => "h",
	𝖎: () => "i",
	𝖏: () => "j",
	𝖐: () => "k",
	𝖑: () => "l",
	𝖒: () => "rn",
	𝖓: () => "n",
	𝖔: () => "o",
	𝖕: () => "p",
	𝖖: () => "q",
	𝖗: () => "r",
	𝖘: () => "s",
	𝖙: () => "t",
	𝖚: () => "u",
	𝖛: () => "v",
	𝖜: () => "w",
	𝖝: () => "x",
	𝖞: () => "y",
	𝖟: () => "z",
	𝖠: () => "A",
	𝖡: () => "B",
	𝖢: () => "C",
	𝖣: () => "D",
	𝖤: () => "E",
	𝖥: () => "F",
	𝖦: () => "G",
	𝖧: () => "H",
	𝖨: () => "l",
	𝖩: () => "J",
	𝖪: () => "K",
	𝖫: () => "L",
	𝖬: () => "M",
	𝖭: () => "N",
	𝖮: () => "O",
	𝖯: () => "P",
	𝖰: () => "Q",
	𝖱: () => "R",
	𝖲: () => "S",
	𝖳: () => "T",
	𝖴: () => "U",
	𝖵: () => "V",
	𝖶: () => "W",
	𝖷: () => "X",
	𝖸: () => "Y",
	𝖹: () => "Z",
	𝖺: () => "a",
	𝖻: () => "b",
	𝖼: () => "c",
	𝖽: () => "d",
	𝖾: () => "e",
	𝖿: () => "f",
	𝗀: () => "g",
	𝗁: () => "h",
	𝗂: () => "i",
	𝗃: () => "j",
	𝗄: () => "k",
	𝗅: () => "l",
	𝗆: () => "rn",
	𝗇: () => "n",
	𝗈: () => "o",
	𝗉: () => "p",
	𝗊: () => "q",
	𝗋: () => "r",
	𝗌: () => "s",
	𝗍: () => "t",
	𝗎: () => "u",
	𝗏: () => "v",
	𝗐: () => "w",
	𝗑: () => "x",
	𝗒: () => "y",
	𝗓: () => "z",
	𝗔: () => "A",
	𝗕: () => "B",
	𝗖: () => "C",
	𝗗: () => "D",
	𝗘: () => "E",
	𝗙: () => "F",
	𝗚: () => "G",
	𝗛: () => "H",
	𝗜: () => "l",
	𝗝: () => "J",
	𝗞: () => "K",
	𝗟: () => "L",
	𝗠: () => "M",
	𝗡: () => "N",
	𝗢: () => "O",
	𝗣: () => "P",
	𝗤: () => "Q",
	𝗥: () => "R",
	𝗦: () => "S",
	𝗧: () => "T",
	𝗨: () => "U",
	𝗩: () => "V",
	𝗪: () => "W",
	𝗫: () => "X",
	𝗬: () => "Y",
	𝗭: () => "Z",
	𝗮: () => "a",
	𝗯: () => "b",
	𝗰: () => "c",
	𝗱: () => "d",
	𝗲: () => "e",
	𝗳: () => "f",
	𝗴: () => "g",
	𝗵: () => "h",
	𝗶: () => "i",
	𝗷: () => "j",
	𝗸: () => "k",
	𝗹: () => "l",
	𝗺: () => "rn",
	𝗻: () => "n",
	𝗼: () => "o",
	𝗽: () => "p",
	𝗾: () => "q",
	𝗿: () => "r",
	𝘀: () => "s",
	𝘁: () => "t",
	𝘂: () => "u",
	𝘃: () => "v",
	𝘄: () => "w",
	𝘅: () => "x",
	𝘆: () => "y",
	𝘇: () => "z",
	𝘈: () => "A",
	𝘉: () => "B",
	𝘊: () => "C",
	𝘋: () => "D",
	𝘌: () => "E",
	𝘍: () => "F",
	𝘎: () => "G",
	𝘏: () => "H",
	𝘐: () => "l",
	𝘑: () => "J",
	𝘒: () => "K",
	𝘓: () => "L",
	𝘔: () => "M",
	𝘕: () => "N",
	𝘖: () => "O",
	𝘗: () => "P",
	𝘘: () => "Q",
	𝘙: () => "R",
	𝘚: () => "S",
	𝘛: () => "T",
	𝘜: () => "U",
	𝘝: () => "V",
	𝘞: () => "W",
	𝘟: () => "X",
	𝘠: () => "Y",
	𝘡: () => "Z",
	𝘢: () => "a",
	𝘣: () => "b",
	𝘤: () => "c",
	𝘥: () => "d",
	𝘦: () => "e",
	𝘧: () => "f",
	𝘨: () => "g",
	𝘩: () => "h",
	𝘪: () => "i",
	𝘫: () => "j",
	𝘬: () => "k",
	𝘭: () => "l",
	𝘮: () => "rn",
	𝘯: () => "n",
	𝘰: () => "o",
	𝘱: () => "p",
	𝘲: () => "q",
	𝘳: () => "r",
	𝘴: () => "s",
	𝘵: () => "t",
	𝘶: () => "u",
	𝘷: () => "v",
	𝘸: () => "w",
	𝘹: () => "x",
	𝘺: () => "y",
	𝘻: () => "z",
	𝘼: () => "A",
	𝘽: () => "B",
	𝘾: () => "C",
	𝘿: () => "D",
	𝙀: () => "E",
	𝙁: () => "F",
	𝙂: () => "G",
	𝙃: () => "H",
	𝙄: () => "l",
	𝙅: () => "J",
	𝙆: () => "K",
	𝙇: () => "L",
	𝙈: () => "M",
	𝙉: () => "N",
	𝙊: () => "O",
	𝙋: () => "P",
	𝙌: () => "Q",
	𝙍: () => "R",
	𝙎: () => "S",
	𝙏: () => "T",
	𝙐: () => "U",
	𝙑: () => "V",
	𝙒: () => "W",
	𝙓: () => "X",
	𝙔: () => "Y",
	𝙕: () => "Z",
	𝙖: () => "a",
	𝙗: () => "b",
	𝙘: () => "c",
	𝙙: () => "d",
	𝙚: () => "e",
	𝙛: () => "f",
	𝙜: () => "g",
	𝙝: () => "h",
	𝙞: () => "i",
	𝙟: () => "j",
	𝙠: () => "k",
	𝙡: () => "l",
	𝙢: () => "rn",
	𝙣: () => "n",
	𝙤: () => "o",
	𝙥: () => "p",
	𝙦: () => "q",
	𝙧: () => "r",
	𝙨: () => "s",
	𝙩: () => "t",
	𝙪: () => "u",
	𝙫: () => "v",
	𝙬: () => "w",
	𝙭: () => "x",
	𝙮: () => "y",
	𝙯: () => "z",
	𝙰: () => "A",
	𝙱: () => "B",
	𝙲: () => "C",
	𝙳: () => "D",
	𝙴: () => "E",
	𝙵: () => "F",
	𝙶: () => "G",
	𝙷: () => "H",
	𝙸: () => "l",
	𝙹: () => "J",
	𝙺: () => "K",
	𝙻: () => "L",
	𝙼: () => "M",
	𝙽: () => "N",
	𝙾: () => "O",
	𝙿: () => "P",
	𝚀: () => "Q",
	𝚁: () => "R",
	𝚂: () => "S",
	𝚃: () => "T",
	𝚄: () => "U",
	𝚅: () => "V",
	𝚆: () => "W",
	𝚇: () => "X",
	𝚈: () => "Y",
	𝚉: () => "Z",
	𝚊: () => "a",
	𝚋: () => "b",
	𝚌: () => "c",
	𝚍: () => "d",
	𝚎: () => "e",
	𝚏: () => "f",
	𝚐: () => "g",
	𝚑: () => "h",
	𝚒: () => "i",
	𝚓: () => "j",
	𝚔: () => "k",
	𝚕: () => "l",
	𝚖: () => "rn",
	𝚗: () => "n",
	𝚘: () => "o",
	𝚙: () => "p",
	𝚚: () => "q",
	𝚛: () => "r",
	𝚜: () => "s",
	𝚝: () => "t",
	𝚞: () => "u",
	𝚟: () => "v",
	𝚠: () => "w",
	𝚡: () => "x",
	𝚢: () => "y",
	𝚣: () => "z",
	𝚤: () => "i",
	𝚥: () => "ȷ",
	𝚨: () => "A",
	𝚩: () => "B",
	𝚪: () => "Γ",
	𝚫: () => "Δ",
	𝚬: () => "E",
	𝚭: () => "Z",
	𝚮: () => "H",
	𝚯: () => "O̵",
	𝚰: () => "l",
	𝚱: () => "K",
	𝚲: () => "Ʌ",
	𝚳: () => "M",
	𝚴: () => "N",
	𝚵: () => "Ξ",
	𝚶: () => "O",
	𝚷: () => "Π",
	𝚸: () => "P",
	𝚹: () => "O̵",
	𝚺: () => "Ʃ",
	𝚻: () => "T",
	𝚼: () => "Y",
	𝚽: () => "Φ",
	𝚾: () => "X",
	𝚿: () => "Ψ",
	𝛀: () => "Ω",
	𝛂: () => "a",
	𝛃: () => "ß",
	𝛄: () => "y",
	𝛅: () => "ẟ",
	𝛆: () => "ꞓ",
	𝛇: () => "ζ",
	𝛈: () => "n̩",
	𝛉: () => "O̵",
	𝛊: () => "i",
	𝛋: () => "ĸ",
	𝛌: () => "λ",
	𝛍: () => "μ",
	𝛎: () => "v",
	𝛏: () => "ξ",
	𝛐: () => "o",
	𝛑: () => "π",
	𝛒: () => "p",
	𝛓: () => "ς",
	𝛔: () => "o",
	𝛕: () => "ᴛ",
	𝛖: () => "u",
	𝛗: () => "ɸ",
	𝛘: () => "χ",
	𝛙: () => "ψ",
	𝛚: () => "ω",
	𝛜: () => "ꞓ",
	𝛝: () => "O̵",
	𝛞: () => "ĸ",
	𝛟: () => "ɸ",
	𝛠: () => "p",
	𝛡: () => "π",
	𝛢: () => "A",
	𝛣: () => "B",
	𝛤: () => "Γ",
	𝛥: () => "Δ",
	𝛦: () => "E",
	𝛧: () => "Z",
	𝛨: () => "H",
	𝛩: () => "O̵",
	𝛪: () => "l",
	𝛫: () => "K",
	𝛬: () => "Ʌ",
	𝛭: () => "M",
	𝛮: () => "N",
	𝛯: () => "Ξ",
	𝛰: () => "O",
	𝛱: () => "Π",
	𝛲: () => "P",
	𝛳: () => "O̵",
	𝛴: () => "Ʃ",
	𝛵: () => "T",
	𝛶: () => "Y",
	𝛷: () => "Φ",
	𝛸: () => "X",
	𝛹: () => "Ψ",
	𝛺: () => "Ω",
	𝛼: () => "a",
	𝛽: () => "ß",
	𝛾: () => "y",
	𝛿: () => "ẟ",
	𝜀: () => "ꞓ",
	𝜁: () => "ζ",
	𝜂: () => "n̩",
	𝜃: () => "O̵",
	𝜄: () => "i",
	𝜅: () => "ĸ",
	𝜆: () => "λ",
	𝜇: () => "μ",
	𝜈: () => "v",
	𝜉: () => "ξ",
	𝜊: () => "o",
	𝜋: () => "π",
	𝜌: () => "p",
	𝜍: () => "ς",
	𝜎: () => "o",
	𝜏: () => "ᴛ",
	𝜐: () => "u",
	𝜑: () => "ɸ",
	𝜒: () => "χ",
	𝜓: () => "ψ",
	𝜔: () => "ω",
	𝜖: () => "ꞓ",
	𝜗: () => "O̵",
	𝜘: () => "ĸ",
	𝜙: () => "ɸ",
	𝜚: () => "p",
	𝜛: () => "π",
	𝜜: () => "A",
	𝜝: () => "B",
	𝜞: () => "Γ",
	𝜟: () => "Δ",
	𝜠: () => "E",
	𝜡: () => "Z",
	𝜢: () => "H",
	𝜣: () => "O̵",
	𝜤: () => "l",
	𝜥: () => "K",
	𝜦: () => "Ʌ",
	𝜧: () => "M",
	𝜨: () => "N",
	𝜩: () => "Ξ",
	𝜪: () => "O",
	𝜫: () => "Π",
	𝜬: () => "P",
	𝜭: () => "O̵",
	𝜮: () => "Ʃ",
	𝜯: () => "T",
	𝜰: () => "Y",
	𝜱: () => "Φ",
	𝜲: () => "X",
	𝜳: () => "Ψ",
	𝜴: () => "Ω",
	𝜶: () => "a",
	𝜷: () => "ß",
	𝜸: () => "y",
	𝜹: () => "ẟ",
	𝜺: () => "ꞓ",
	𝜻: () => "ζ",
	𝜼: () => "n̩",
	𝜽: () => "O̵",
	𝜾: () => "i",
	𝜿: () => "ĸ",
	𝝀: () => "λ",
	𝝁: () => "μ",
	𝝂: () => "v",
	𝝃: () => "ξ",
	𝝄: () => "o",
	𝝅: () => "π",
	𝝆: () => "p",
	𝝇: () => "ς",
	𝝈: () => "o",
	𝝉: () => "ᴛ",
	𝝊: () => "u",
	𝝋: () => "ɸ",
	𝝌: () => "χ",
	𝝍: () => "ψ",
	𝝎: () => "ω",
	𝝐: () => "ꞓ",
	𝝑: () => "O̵",
	𝝒: () => "ĸ",
	𝝓: () => "ɸ",
	𝝔: () => "p",
	𝝕: () => "π",
	𝝖: () => "A",
	𝝗: () => "B",
	𝝘: () => "Γ",
	𝝙: () => "Δ",
	𝝚: () => "E",
	𝝛: () => "Z",
	𝝜: () => "H",
	𝝝: () => "O̵",
	𝝞: () => "l",
	𝝟: () => "K",
	𝝠: () => "Ʌ",
	𝝡: () => "M",
	𝝢: () => "N",
	𝝣: () => "Ξ",
	𝝤: () => "O",
	𝝥: () => "Π",
	𝝦: () => "P",
	𝝧: () => "O̵",
	𝝨: () => "Ʃ",
	𝝩: () => "T",
	𝝪: () => "Y",
	𝝫: () => "Φ",
	𝝬: () => "X",
	𝝭: () => "Ψ",
	𝝮: () => "Ω",
	𝝰: () => "a",
	𝝱: () => "ß",
	𝝲: () => "y",
	𝝳: () => "ẟ",
	𝝴: () => "ꞓ",
	𝝵: () => "ζ",
	𝝶: () => "n̩",
	𝝷: () => "O̵",
	𝝸: () => "i",
	𝝹: () => "ĸ",
	𝝺: () => "λ",
	𝝻: () => "μ",
	𝝼: () => "v",
	𝝽: () => "ξ",
	𝝾: () => "o",
	𝝿: () => "π",
	𝞀: () => "p",
	𝞁: () => "ς",
	𝞂: () => "o",
	𝞃: () => "ᴛ",
	𝞄: () => "u",
	𝞅: () => "ɸ",
	𝞆: () => "χ",
	𝞇: () => "ψ",
	𝞈: () => "ω",
	𝞊: () => "ꞓ",
	𝞋: () => "O̵",
	𝞌: () => "ĸ",
	𝞍: () => "ɸ",
	𝞎: () => "p",
	𝞏: () => "π",
	𝞐: () => "A",
	𝞑: () => "B",
	𝞒: () => "Γ",
	𝞓: () => "Δ",
	𝞔: () => "E",
	𝞕: () => "Z",
	𝞖: () => "H",
	𝞗: () => "O̵",
	𝞘: () => "l",
	𝞙: () => "K",
	𝞚: () => "Ʌ",
	𝞛: () => "M",
	𝞜: () => "N",
	𝞝: () => "Ξ",
	𝞞: () => "O",
	𝞟: () => "Π",
	𝞠: () => "P",
	𝞡: () => "O̵",
	𝞢: () => "Ʃ",
	𝞣: () => "T",
	𝞤: () => "Y",
	𝞥: () => "Φ",
	𝞦: () => "X",
	𝞧: () => "Ψ",
	𝞨: () => "Ω",
	𝞪: () => "a",
	𝞫: () => "ß",
	𝞬: () => "y",
	𝞭: () => "ẟ",
	𝞮: () => "ꞓ",
	𝞯: () => "ζ",
	𝞰: () => "n̩",
	𝞱: () => "O̵",
	𝞲: () => "i",
	𝞳: () => "ĸ",
	𝞴: () => "λ",
	𝞵: () => "μ",
	𝞶: () => "v",
	𝞷: () => "ξ",
	𝞸: () => "o",
	𝞹: () => "π",
	𝞺: () => "p",
	𝞻: () => "ς",
	𝞼: () => "o",
	𝞽: () => "ᴛ",
	𝞾: () => "u",
	𝞿: () => "ɸ",
	𝟀: () => "χ",
	𝟁: () => "ψ",
	𝟂: () => "ω",
	𝟄: () => "ꞓ",
	𝟅: () => "O̵",
	𝟆: () => "ĸ",
	𝟇: () => "ɸ",
	𝟈: () => "p",
	𝟉: () => "π",
	𝟊: () => "F",
	𝟋: () => "ϝ",
	𞸀: () => "l",
	𞸁: () => "ب",
	𞸂: () => "ج",
	𞸃: () => "د",
	𞸅: () => "و",
	𞸆: () => "ز",
	𞸇: () => "ح",
	𞸈: () => "ط",
	𞸉: () => "ى",
	𞸊: () => "ك",
	𞸋: () => "ل",
	𞸌: () => "م",
	𞸍: () => "ن",
	𞸎: () => "س",
	𞸏: () => "ع",
	𞸐: () => "ف",
	𞸑: () => "ص",
	𞸒: () => "ق",
	𞸓: () => "ر",
	𞸔: () => 𞸔,
	𞸕: () => "ت",
	𞸖: () => 𞸖,
	𞸗: () => "خ",
	𞸘: () => "ذ",
	𞸙: () => "ض",
	𞸚: () => "ظ",
	𞸛: () => "غ",
	𞸜: () => "ى",
	𞸝: () => "ى",
	𞸞: () => "ڡ",
	𞸟: () => "ڡ",
	𞸡: () => "ب",
	𞸢: () => "ج",
	𞸤: () => "o",
	𞸧: () => "ح",
	𞸩: () => "ى",
	𞸪: () => "ك",
	𞸫: () => "ل",
	𞸬: () => "م",
	𞸭: () => "ن",
	𞸮: () => "س",
	𞸯: () => "ع",
	𞸰: () => "ف",
	𞸱: () => "ص",
	𞸲: () => "ق",
	𞸴: () => 𞸴,
	𞸵: () => "ت",
	𞸶: () => 𞸶,
	𞸷: () => "خ",
	𞸹: () => "ض",
	𞸻: () => "غ",
	𞹂: () => "ج",
	𞹇: () => "ح",
	𞹉: () => "ى",
	𞹋: () => "ل",
	𞹍: () => "ن",
	𞹎: () => "س",
	𞹏: () => "ع",
	𞹑: () => "ص",
	𞹒: () => "ق",
	𞹔: () => 𞹔,
	𞹗: () => "خ",
	𞹙: () => "ض",
	𞹛: () => "غ",
	𞹝: () => "ى",
	𞹟: () => "ڡ",
	𞹡: () => "ب",
	𞹢: () => "ج",
	𞹤: () => "o",
	𞹧: () => "ح",
	𞹨: () => "ط",
	𞹩: () => "ى",
	𞹪: () => "ك",
	𞹬: () => "م",
	𞹭: () => "ن",
	𞹮: () => "س",
	𞹯: () => "ع",
	𞹰: () => "ف",
	𞹱: () => "ص",
	𞹲: () => "ق",
	𞹴: () => 𞹴,
	𞹵: () => "ت",
	𞹶: () => 𞹶,
	𞹷: () => "خ",
	𞹹: () => "ض",
	𞹺: () => "ظ",
	𞹻: () => "غ",
	𞹼: () => "ى",
	𞹾: () => "ڡ",
	𞺀: () => "l",
	𞺁: () => "ب",
	𞺂: () => "ج",
	𞺃: () => "د",
	𞺄: () => "o",
	𞺅: () => "و",
	𞺆: () => "ز",
	𞺇: () => "ح",
	𞺈: () => "ط",
	𞺉: () => "ى",
	𞺋: () => "ل",
	𞺌: () => "م",
	𞺍: () => "ن",
	𞺎: () => "س",
	𞺏: () => "ع",
	𞺐: () => "ف",
	𞺑: () => "ص",
	𞺒: () => "ق",
	𞺓: () => "ر",
	𞺔: () => 𞺔,
	𞺕: () => "ت",
	𞺖: () => 𞺖,
	𞺗: () => "خ",
	𞺘: () => "ذ",
	𞺙: () => "ض",
	𞺚: () => "ظ",
	𞺛: () => "غ",
	𞺡: () => "ب",
	𞺢: () => "ج",
	𞺣: () => "د",
	𞺥: () => "و",
	𞺦: () => "ز",
	𞺧: () => "ح",
	𞺨: () => "ط",
	𞺩: () => "ى",
	𞺫: () => "ل",
	𞺬: () => "م",
	𞺭: () => "ن",
	𞺮: () => "س",
	𞺯: () => "ع",
	𞺰: () => "ف",
	𞺱: () => "ص",
	𞺲: () => "ق",
	𞺳: () => "ر",
	𞺴: () => 𞺴,
	𞺵: () => "ت",
	𞺶: () => 𞺶,
	𞺷: () => "خ",
	𞺸: () => "ذ",
	𞺹: () => "ض",
	𞺺: () => "ظ",
	𞺻: () => "غ",
	𡿨: () => "❬",
	丽: () => "丽",
	丸: () => "丸",
	乁: () => "乁",
	𠄢: () => 𠄢,
	你: () => "你",
	侮: () => "侮",
	侻: () => "侻",
	倂: () => "併",
	偺: () => "偺",
	備: () => "備",
	僧: () => "僧",
	像: () => "像",
	㒞: () => "㒞",
	𠘺: () => 𠘺,
	免: () => "免",
	兔: () => "兔",
	兤: () => "兤",
	具: () => "具",
	𠔜: () => 𠔜,
	㒹: () => "㒹",
	內: () => "內",
	再: () => "再",
	𠕋: () => 𠕋,
	冗: () => "冗",
	冤: () => "冤",
	仌: () => "仌",
	冬: () => "冬",
	况: () => "况",
	𩇟: () => 𩇟,
	凵: () => "凵",
	刃: () => "刃",
	㓟: () => "㓟",
	刻: () => "刻",
	剆: () => "剆",
	割: () => "割",
	剷: () => "剷",
	㔕: () => "㔕",
	勇: () => "勇",
	勉: () => "勉",
	勤: () => "勤",
	勺: () => "勺",
	包: () => "包",
	匆: () => "匆",
	北: () => "北",
	卉: () => "卉",
	卑: () => "卑",
	博: () => "博",
	即: () => "即",
	卽: () => "卽",
	卿: () => "卿",
	卿: () => "卿",
	卿: () => "卿",
	𠨬: () => 𠨬,
	灰: () => "灰",
	及: () => "及",
	叟: () => "叟",
	𠭣: () => 𠭣,
	叫: () => "叫",
	叱: () => "叱",
	吆: () => "吆",
	咞: () => "咞",
	吸: () => "吸",
	呈: () => "呈",
	周: () => "周",
	咢: () => "咢",
	哶: () => "哶",
	唐: () => "唐",
	啓: () => "啓",
	啣: () => "啣",
	善: () => "善",
	善: () => "善",
	喙: () => "喙",
	喫: () => "喫",
	喳: () => "喳",
	嗂: () => "嗂",
	圖: () => "圖",
	嘆: () => "嘆",
	圗: () => "圗",
	噑: () => "噑",
	噴: () => "噴",
	切: () => "切",
	壮: () => "壮",
	城: () => "城",
	埴: () => "埴",
	堍: () => "堍",
	型: () => "型",
	堲: () => "堲",
	報: () => "報",
	墬: () => "墬",
	𡓤: () => 𡓤,
	売: () => "売",
	壷: () => "壷",
	夆: () => "夆",
	多: () => "多",
	夢: () => "夢",
	奢: () => "奢",
	𡚨: () => 𡚨,
	𡛪: () => 𡛪,
	姬: () => "姬",
	娛: () => "娛",
	娧: () => "娧",
	姘: () => "姘",
	婦: () => "婦",
	㛮: () => "㛮",
	㛼: () => "㛼",
	嬈: () => "嬈",
	嬾: () => "嬾",
	嬾: () => "嬾",
	𡧈: () => 𡧈,
	寃: () => "寃",
	寘: () => "寘",
	寧: () => "寧",
	寳: () => "寳",
	𡬘: () => 𡬘,
	寿: () => "寿",
	将: () => "将",
	当: () => "当",
	尢: () => "尢",
	㞁: () => "㞁",
	屠: () => "屠",
	屮: () => "屮",
	峀: () => "峀",
	岍: () => "岍",
	𡷤: () => 𡷤,
	嵃: () => "嵃",
	𡷦: () => 𡷦,
	嵮: () => "嵮",
	嵫: () => "嵫",
	嵼: () => "嵼",
	巡: () => "巡",
	巢: () => "巢",
	㠯: () => "㠯",
	巽: () => "巽",
	帨: () => "帨",
	帽: () => "帽",
	幩: () => "幩",
	㡢: () => "㡢",
	𢆃: () => 𢆃,
	㡼: () => "㡼",
	庰: () => "庰",
	庳: () => "庳",
	庶: () => "庶",
	廊: () => "廊",
	𪎒: () => 𪎒,
	廾: () => "廾",
	𢌱: () => 𢌱,
	𢌱: () => 𢌱,
	舁: () => "舁",
	弢: () => "弢",
	弢: () => "弢",
	㣇: () => "㣇",
	𣊸: () => 𣊸,
	𦇚: () => 𦇚,
	形: () => "形",
	彫: () => "彫",
	㣣: () => "㣣",
	徚: () => "徚",
	忍: () => "忍",
	志: () => "志",
	忹: () => "忹",
	悁: () => "悁",
	㤺: () => "㤺",
	㤜: () => "㤜",
	悔: () => "悔",
	𢛔: () => 𢛔,
	惇: () => "惇",
	慈: () => "慈",
	慌: () => "慌",
	慎: () => "慎",
	慌: () => "慌",
	慺: () => "慺",
	憎: () => "憎",
	憲: () => "憲",
	憤: () => "憤",
	憯: () => "憯",
	懞: () => "懞",
	懲: () => "懲",
	懶: () => "懶",
	成: () => "成",
	戛: () => "戛",
	扝: () => "扝",
	抱: () => "抱",
	拔: () => "拔",
	捐: () => "捐",
	𢬌: () => 𢬌,
	挽: () => "挽",
	拼: () => "拼",
	捨: () => "捨",
	掃: () => "掃",
	揤: () => "揤",
	𢯱: () => 𢯱,
	搢: () => "搢",
	揅: () => "揅",
	掩: () => "掩",
	㨮: () => "㨮",
	摩: () => "摩",
	摾: () => "摾",
	撝: () => "撝",
	摷: () => "摷",
	㩬: () => "㩬",
	敏: () => "敏",
	敬: () => "敬",
	𣀊: () => 𣀊,
	旣: () => "旣",
	書: () => "書",
	晉: () => "晉",
	㬙: () => "㬙",
	暑: () => "暑",
	㬈: () => "㬈",
	㫤: () => "㫤",
	冒: () => "冒",
	冕: () => "冕",
	最: () => "最",
	暜: () => "暜",
	肭: () => "肭",
	䏙: () => "䏙",
	朗: () => "朗",
	望: () => "望",
	朡: () => "朡",
	杞: () => "杞",
	杓: () => "杓",
	𣏃: () => 𣏃,
	㭉: () => "㭉",
	柺: () => "柺",
	枅: () => "枅",
	桒: () => "桒",
	梅: () => "梅",
	𣑭: () => 𣑭,
	梎: () => "梎",
	栟: () => "栟",
	椔: () => "椔",
	㮝: () => "㮝",
	楂: () => "楂",
	榣: () => "榣",
	槪: () => "槪",
	檨: () => "檨",
	𣚣: () => 𣚣,
	櫛: () => "櫛",
	㰘: () => "㰘",
	次: () => "次",
	𣢧: () => 𣢧,
	歔: () => "歔",
	㱎: () => "㱎",
	歲: () => "歲",
	殟: () => "殟",
	殺: () => "殺",
	殻: () => "殻",
	𣪍: () => 𣪍,
	𡴋: () => 𡴋,
	𣫺: () => 𣫺,
	汎: () => "汎",
	𣲼: () => 𣲼,
	沿: () => "沿",
	泍: () => "泍",
	汧: () => "汧",
	洖: () => "洖",
	派: () => "派",
	海: () => "海",
	流: () => "流",
	浩: () => "浩",
	浸: () => "浸",
	涅: () => "涅",
	𣴞: () => 𣴞,
	洴: () => "洴",
	港: () => "港",
	湮: () => "湮",
	㴳: () => "㴳",
	滋: () => "滋",
	滇: () => "滇",
	𣻑: () => 𣻑,
	淹: () => "淹",
	潮: () => "潮",
	𣽞: () => 𣽞,
	𣾎: () => 𣾎,
	濆: () => "濆",
	瀹: () => "瀹",
	瀞: () => "瀞",
	瀛: () => "瀛",
	㶖: () => "㶖",
	灊: () => "灊",
	災: () => "災",
	灷: () => "灷",
	炭: () => "炭",
	𠔥: () => 𠔥,
	煅: () => "煅",
	𤉣: () => 𤉣,
	熜: () => "熜",
	𤎫: () => 𤎫,
	爨: () => "爨",
	爵: () => "爵",
	牐: () => "牐",
	𤘈: () => 𤘈,
	犀: () => "犀",
	犕: () => "犕",
	𤜵: () => 𤜵,
	𤠔: () => 𤠔,
	獺: () => "獺",
	王: () => "王",
	㺬: () => "㺬",
	玥: () => "玥",
	㺸: () => "㺸",
	㺸: () => "㺸",
	瑇: () => "瑇",
	瑜: () => "瑜",
	瑱: () => "瑱",
	璅: () => "璅",
	瓊: () => "瓊",
	㼛: () => "㼛",
	甤: () => "甤",
	𤰶: () => 𤰶,
	甾: () => "甾",
	𤲒: () => 𤲒,
	異: () => "異",
	𢆟: () => 𢆟,
	瘐: () => "瘐",
	𤾡: () => 𤾡,
	𤾸: () => 𤾸,
	𥁄: () => 𥁄,
	㿼: () => "㿼",
	䀈: () => "䀈",
	直: () => "直",
	𥃳: () => 𥃳,
	𥃲: () => 𥃲,
	𥄙: () => 𥄙,
	𥄳: () => 𥄳,
	眞: () => "眞",
	真: () => "真",
	真: () => "真",
	睊: () => "睊",
	䀹: () => "䀹",
	瞋: () => "瞋",
	䁆: () => "䁆",
	䂖: () => "䂖",
	𥐝: () => 𥐝,
	硎: () => "硎",
	碌: () => "碌",
	磌: () => "磌",
	䃣: () => "䃣",
	𥘦: () => 𥘦,
	祖: () => "祖",
	𥚚: () => 𥚚,
	𥛅: () => 𥛅,
	福: () => "福",
	秫: () => "秫",
	䄯: () => "䄯",
	穀: () => "穀",
	穊: () => "穊",
	穏: () => "穏",
	𥥼: () => 𥥼,
	𥪧: () => 𥪧,
	𥪧: () => 𥪧,
	竮: () => "竮",
	䈂: () => "䈂",
	𥮫: () => 𥮫,
	篆: () => "篆",
	築: () => "築",
	䈧: () => "䈧",
	𥲀: () => 𥲀,
	糒: () => "糒",
	䊠: () => "䊠",
	糨: () => "糨",
	糣: () => "糣",
	紀: () => "紀",
	𥾆: () => 𥾆,
	絣: () => "絣",
	䌁: () => "䌁",
	緇: () => "緇",
	縂: () => "縂",
	繅: () => "繅",
	䌴: () => "䌴",
	𦈨: () => 𦈨,
	𦉇: () => 𦉇,
	䍙: () => "䍙",
	𦋙: () => 𦋙,
	罺: () => "罺",
	𦌾: () => 𦌾,
	羕: () => "羕",
	翺: () => "翺",
	者: () => "者",
	𦓚: () => 𦓚,
	𦔣: () => 𦔣,
	聠: () => "聠",
	𦖨: () => 𦖨,
	聰: () => "聰",
	𣍟: () => 𣍟,
	䏕: () => "䏕",
	育: () => "育",
	脃: () => "脃",
	䐋: () => "䐋",
	脾: () => "脾",
	媵: () => "媵",
	𦞧: () => 𦞧,
	𦞵: () => 𦞵,
	𣎓: () => 𣎓,
	𣎜: () => 𣎜,
	舁: () => "舁",
	舄: () => "舄",
	辞: () => "辞",
	䑫: () => "䑫",
	芑: () => "芑",
	芋: () => "芋",
	芝: () => "芝",
	劳: () => "劳",
	花: () => "花",
	芳: () => "芳",
	芽: () => "芽",
	苦: () => "苦",
	𦬼: () => 𦬼,
	若: () => "若",
	茝: () => "茝",
	荣: () => "荣",
	莭: () => "莭",
	茣: () => "茣",
	莽: () => "莽",
	菧: () => "菧",
	著: () => "著",
	荓: () => "荓",
	菊: () => "菊",
	菌: () => "菌",
	菜: () => "菜",
	𦰶: () => 𦰶,
	𦵫: () => 𦵫,
	𦳕: () => 𦳕,
	䔫: () => "䔫",
	蓱: () => "蓱",
	蓳: () => "蓳",
	蔖: () => "蔖",
	𧏊: () => 𧏊,
	蕤: () => "蕤",
	𦼬: () => 𦼬,
	䕝: () => "䕝",
	䕡: () => "䕡",
	𦾱: () => 𦾱,
	𧃒: () => 𧃒,
	䕫: () => "䕫",
	虐: () => "虐",
	虜: () => "虜",
	虧: () => "虧",
	虩: () => "虩",
	蚩: () => "蚩",
	蚈: () => "蚈",
	蜎: () => "蜎",
	蛢: () => "蛢",
	蝹: () => "蝹",
	蜨: () => "蜨",
	蝫: () => "蝫",
	螆: () => "螆",
	䗗: () => "䗗",
	蟡: () => "蟡",
	蠁: () => "蠁",
	䗹: () => "䗹",
	衠: () => "衠",
	衣: () => "衣",
	𧙧: () => 𧙧,
	裗: () => "裗",
	裞: () => "裞",
	䘵: () => "䘵",
	裺: () => "裺",
	㒻: () => "㒻",
	𧢮: () => 𧢮,
	𧥦: () => 𧥦,
	䚾: () => "䚾",
	䛇: () => "䛇",
	誠: () => "誠",
	諭: () => "諭",
	變: () => "變",
	豕: () => "豕",
	𧲨: () => 𧲨,
	貫: () => "貫",
	賁: () => "賁",
	贛: () => "贛",
	起: () => "起",
	𧼯: () => 𧼯,
	𠠄: () => 𠠄,
	跋: () => "跋",
	趼: () => "趼",
	跰: () => "跰",
	𠣞: () => 𠣞,
	軔: () => "軔",
	輸: () => "輸",
	𨗒: () => 𨗒,
	𨗭: () => 𨗭,
	邔: () => "邔",
	郱: () => "郱",
	鄑: () => "鄑",
	𨜮: () => 𨜮,
	鄛: () => "鄛",
	鈸: () => "鈸",
	鋗: () => "鋗",
	鋘: () => "鋘",
	鉼: () => "鉼",
	鏹: () => "鏹",
	鐕: () => "鐕",
	𨯺: () => 𨯺,
	開: () => "開",
	䦕: () => "䦕",
	閷: () => "閷",
	𨵷: () => 𨵷,
	䧦: () => "䧦",
	雃: () => "雃",
	嶲: () => "嶲",
	霣: () => "霣",
	𩅅: () => 𩅅,
	𩈚: () => 𩈚,
	䩮: () => "䩮",
	䩶: () => "䩶",
	韠: () => "韠",
	𩐊: () => 𩐊,
	䪲: () => "䪲",
	𩒖: () => 𩒖,
	頋: () => "頋",
	頋: () => "頋",
	頩: () => "頩",
	𩖶: () => 𩖶,
	飢: () => "飢",
	䬳: () => "䬳",
	餩: () => "餩",
	馧: () => "馧",
	駂: () => "駂",
	駾: () => "駾",
	䯎: () => "䯎",
	𩬰: () => 𩬰,
	鬒: () => "鬒",
	鱀: () => "鱀",
	鳽: () => "鳽",
	䳎: () => "䳎",
	䳭: () => "䳭",
	鵧: () => "鵧",
	𪃎: () => 𪃎,
	䳸: () => "䳸",
	𪄅: () => 𪄅,
	𪈎: () => 𪈎,
	𪊑: () => 𪊑,
	麻: () => "麻",
	䵖: () => "䵖",
	黹: () => "黹",
	黾: () => "黾",
	鼅: () => "鼅",
	鼏: () => "鼏",
	鼖: () => "鼖",
	鼻: () => "鼻",
	𪘀: () => 𪘀
}), ﱞ, ﱟ, ﳲ, ﱠ, ﳳ, ﱡ, ﳴ, ﱢ, ﱣ, ⵈ, ᒀ, ᐼ, ᒮ, ᐎ, ᑙ, ᐌ, ᐐ, ᐒ, ᐔ, ᐗ, ᐙ, ᐾ, ᑂ, ᑆ, ᑛ, ᑔ, ᑝ, ᑟ, ᑡ, ᑣ, ᑴ, ᑸ, ᑼ, ᒒ, ᒔ, ᒖ, ᒚ, ᒜ, ᒞ, ᒬ, ᒰ, ᒲ, ᒴ, ᒸ, ᓉ, ᣆ, ᣈ, ᣊ, ᣌ, ᓋ, ᓍ, ᓜ, ᓞ, ᓠ, ᓢ, ᓤ, ᓦ, ᓨ, ᓶ, ᓸ, ᓺ, ᓼ, ᓾ, ᔀ, ᔂ, ᔗ, ᔙ, ᔛ, ᔝ, ᔟ, ᔡ, ᔣ, ᔱ, ᔳ, ᔵ, ᔷ, ᔹ, ᔻ, ᣎ, ᣏ, ᣐ, ᣑ, ᣒ, ᣓ, ᕎ, ᕛ, ᕨ, ᢳ, ᢶ, ᢹ, ᣂ, ꙑ, ð, ᆖ, ힹ, ힺ, ힻ, ힼ, ᆕ, ᅴ, ㅢ, ᆗ, ᒁ, ɚ, ꭁ, ꭂ, ҙ, ң, ӊ, ӈ, ﷳ, ﷲ, Ǿ, ɶ, ﶓ, ﶔ, ൟ, တ, ꬿ, қ, ҟ, ɱ, ᵯ, ᵳ, ҭ, ᵿ, ⅷ, Ⅷ, Ӆ, ᐽ, ѽ, ӎ, Ғ, ᒯ, ᐏ, ᐬ, җ, Җ, Ҋ, ҋ, ӆ, Ѽ, ᣭ, Ҿ, և, ﬔ, ﬕ, ﬗ, ﬓ, ᑚ, ﬖ, ﭏ, ݑ, ࢶ, ࢡ, ﲜ, ﰅ, ﲝ, ﰆ, ﷂ, ﲞ, ﰇ, ﳒ, ﱋ, ﶞ, ﱪ, ﱫ, ﲟ, ﳡ, ﱬ, ﰈ, ﱭ, ﱮ, ﰉ, ﱯ, ﰊ, ﲡ, ﰋ, ﵐ, ﶠ, ﶟ, ﲢ, ﰌ, ﵒ, ﵑ, ﵓ, ﲣ, ﰍ, ﵔ, ﶢ, ﶡ, ﱰ, ﱱ, ﲤ, ﳣ, ﱲ, ﰎ, ﵕ, ﵖ, ﵗ, ﶤ, ﶣ, ﱳ, ﱴ, ﰏ, ﱵ, ﰐ, ﲧ, ﰕ, ﶦ, ﶾ, ﷻ, ﲨ, ﰖ, ﵙ, ﵘ, ﶧ, ﶥ, ﴝ, ﴁ, ﴞ, ﴂ, څ, ځ, ݲ, ﲩ, ﰗ, ﶿ, ﲪ, ﰘ, ﵛ, ﵚ, ﴛ, ﳿ, ﴜ, ﴀ, ﲫ, ﰙ, ﰚ, ﲬ, ﰛ, ﴟ, ﴃ, ﴠ, ﴄ, ڈ, ﮉ, ﮈ, ڎ, ﮇ, ﮆ, ۮ, ࢮ, ﱛ, ڋ, ڑ, ﮍ, ﮌ, ژ, ﮋ, ﮊ, ڒ, ࢹ, ۯ, ݬ, ﱜ, ﷶ, ࢲ, ݱ, ش, 𞸔, 𞸴, 𞹔, 𞹴, 𞺔, 𞺴, ﺷ, ﺸ, ﺶ, ﺵ, ݾ, ﴲ, ﳪ, ﲭ, ﴴ, ﰜ, ﴭ, ﴷ, ﴥ, ﴉ, ﵝ, ﵞ, ﵩ, ﲮ, ﴵ, ﰝ, ﴮ, ﴸ, ﴦ, ﴊ, ﵜ, ﵨ, ﵧ, ﶪ, ﲯ, ﴶ, ﰞ, ﴯ, ﴹ, ﴧ, ﴋ, ﶨ, ﷆ, ﴪ, ﴎ, ﴩ, ﴍ, ﲰ, ﳧ, ﰟ, ﴰ, ﳩ, ﴨ, ﴌ, ﵡ, ﵠ, ﵟ, ﵫ, ﵪ, ﵣ, ﵢ, ﵭ, ﵬ, ﴗ, ﳻ, ﴘ, ﳼ, ﴙ, ﳽ, ﴚ, ﳾ, ڞ, ࢯ, ﲱ, ﰠ, ﵥ, ﵤ, ﶩ, ﲲ, ﴫ, ﴏ, ﷵ, ﷹ, ﷰ, ﷺ, ﲳ, ﰡ, ﷅ, ﵦ, ﴡ, ﴅ, ﴢ, ﴆ, ﲴ, ﰢ, ﲵ, ﰣ, ﵮ, ﶫ, ﲶ, ﰤ, ﵰ, ﵯ, ﴬ, ﴐ, ﲷ, ﰥ, ﴣ, ﴇ, ﴤ, ﴈ, ڟ, ﲸ, ﰦ, ﴳ, ﴺ, ﰧ, ﵲ, ﵱ, ﵳ, ﵴ, ﴑ, ﳵ, ﴒ, ﳶ, ﲹ, ﴻ, ﰨ, ﲺ, ﰩ, ﷄ, ﵵ, ﷷ, ﲻ, ﰪ, ﵷ, ﵶ, ﵸ, ﶶ, ﴓ, ﳷ, ﴔ, ﳸ, ﲼ, ﰫ, ﲽ, ﰬ, ﵹ, ﵻ, ﵺ, ﴕ, ﳹ, ﴖ, ﳺ, ﲾ, ﰭ, ﲿ, ﰮ, ﳀ, ﰯ, ﵽ, ﵼ, ﳁ, ﰰ, ﷁ, ﱼ, ﰱ, ﱽ, ﰲ, ڤ, ﭬ, ﭭ, ﭫ, ﭪ, ڨ, ࢤ, ﳂ, ﰳ, ﷱ, ﳃ, ﰴ, ﶴ, ﵾ, ﵿ, ﶲ, ﱾ, ﰵ, ﱿ, ﰶ, ڭ, ﯕ, ﯖ, ﯔ, ﯓ, ݣ, ﳄ, ﰸ, ﳅ, ﰹ, ﳆ, ﰺ, ﳇ, ﳫ, ﲁ, ﰻ, ﳈ, ﳬ, ﲂ, ﰼ, ﷃ, ﶻ, ﶷ, ﲃ, ﰽ, ﲄ, ﰾ, ڴ, ڷ, ڵ, ﻺ, ﻹ, ﻸ, ﻷ, ﻶ, ﻵ, ﳉ, ﰿ, ﶃ, ﶄ, ﶺ, ﶼ, ﶬ, ﳊ, ﱀ, ﶵ, ﶀ, ﶂ, ﶁ, ﳋ, ﱁ, ﶆ, ﶅ, ﳌ, ﳭ, ﲅ, ﱂ, ﶈ, ﶇ, ﶭ, ﲆ, ﱃ, ﲇ, ﱄ, ࢧ, ﳎ, ﱅ, ﶌ, ﶒ, ﶍ, ﷀ, ﳏ, ﱆ, ﶉ, ﶊ, ﷴ, ﶋ, ﳐ, ﱇ, ﶎ, ﶏ, ﶹ, ﳑ, ﲉ, ﱈ, ﶱ, ﱉ, ﱊ, ݨ, ݩ, ﶸ, ﶽ, ﶘ, ﶗ, ﶙ, ﷇ, ﳓ, ﱌ, ﶕ, ﶖ, ﶳ, ﳔ, ﱍ, ﲊ, ﲋ, ﳕ, ﳮ, ﲌ, ﱎ, ﶛ, ﶚ, ﲍ, ﲎ, ﱏ, ﲏ, ﱐ, ۋ, ﯟ, ﯞ, ۇ, ﯘ, ﯗ, ۆ, ﯚ, ﯙ, ۉ, ﯣ, ﯢ, ۈ, ﯜ, ﯛ, ؤ, ﺆ, ﺅ, ٶ, ٷ, ﯝ, ﷸ, ٹ, ﭨ, ﭩ, ﭧ, ﭦ, ڻ, ﮢ, ﮣ, ﮡ, ﮠ, پ, ﭘ, ﭙ, ﭗ, ﭖ, ث, 𞸖, 𞸶, 𞹶, 𞺖, 𞺶, ﺛ, ﺜ, ﺚ, ﺙ, ڽ, ۑ, ؿ, ࢷ, ݖ, ێ, ࢺ, ؽ, ࢨ, ﲐ, ﱝ, ﳦ, ئ, ﺋ, ﺌ, ﺊ, ﺉ, ٸ, ﯫ, ﯪ, ﲛ, ﳠ, ﯭ, ﯬ, ﯸ, ﯷ, ﯶ, ﲗ, ﰀ, ﲘ, ﰁ, ﲙ, ﱤ, ﱥ, ﲚ, ﳟ, ﱦ, ﰂ, ﱧ, ﯯ, ﯮ, ﯱ, ﯰ, ﯳ, ﯲ, ﯵ, ﯴ, ﯻ, ﯺ, ﱨ, ﯹ, ﰃ, ﱩ, ﰄ, ﳚ, ﱕ, ﰑ, ﶯ, ﳛ, ﱖ, ﶮ, ﳜ, ﱗ, ﲑ, ﱶ, ﲒ, ﱷ, ﳝ, ﳰ, ﲓ, ﱘ, ﲦ, ﳥ, ﱸ, ﰒ, ﶝ, ﶜ, ﶰ, ﲔ, ﱹ, ﲕ, ﱙ, ﲖ, ﱚ, ﱺ, ﰓ, ﱻ, ﰔ, आ, ऒ, ओ, औ, ऄ, ऑ, ऍ, ऎ, ऐ, ई, আ, ৠ, ৡ, ਉ, ਊ, ਆ, ਐ, ਔ, ਇ, ਈ, ਏ, આ, ઑ, ઓ, ઔ, ઍ, એ, ઐ, ଆ, ஊ, ഊ, ഺ, ౠ, ౡ, ఔ, ಔ, ఓ, ಓ, ఢ, థ, భ, ఠ, ష, హ, మ, ೡ, ഈ, ഐ, ഓ, ഔ, ഌ, ങ, ൻ, ർ, 𑐓, 𑐙, 𑐤, 𑐪, 𑐭, 𑐯, 𑗘, 𑗙, 𑗚, 𑗛, ำ, แ, ໜ, ໝ, ຳ, ༀ, ႁ, က, ၰ, ၦ, ဟ, ၯ, ၾ, ဩ, ဪ, ᐍ, ᐫ, ᐑ, ᐓ, ᐭ, ᐕ, ᐘ, ᐮ, ᐚ, ᣝ, ᐿ, ᑃ, ᑇ, ᑜ, ᑞ, ᑩ, ᑠ, ᑢ, ᑪ, ᑤ, ᑵ, ᒅ, ᑹ, ᑽ, ᒓ, ᒕ, ᒗ, ᒛ, ᒝ, ᒟ, ᒭ, ᒱ, ᒳ, ᒵ, ᒹ, ᓊ, ᣇ, ᣉ, ᣋ, ᣍ, ᓌ, ᓎ, ᓝ, ᓟ, ᓡ, ᓣ, ᓥ, ᓧ, ᓩ, ᓷ, ᓹ, ᓻ, ᓽ, ᓿ, ᔁ, ᔃ, ᔌ, ᔎ, ᔍ, ᔏ, ᔘ, ᔚ, ᔜ, ᔞ, ᔠ, ᔢ, ᔤ, ᔲ, ᔴ, ᔶ, ᔸ, ᔺ, ᔼ, ᣠ, ᕏ, ᖃ, ᖄ, ᖁ, ᕿ, ᙯ, ᕾ, ᖀ, ᖂ, ᖅ, ᕜ, ᣣ, ᣤ, ᕩ, ᣥ, ᣨ, ᖑ, ᙰ, ᖎ, ᖏ, ᖐ, ᖒ, ᖓ, ᖔ, ᙳ, ᙱ, ᙲ, ᙴ, ᙵ, ᙶ, ᣪ, ᙷ, ᙸ, ᙹ, ᙺ, ᙻ, ᙼ, ᙽ, ᣰ, ᣲ, ᣜ, ᄁ, ㄲ, ᆩ, ᇺ, ᅚ, ᇃ, ᇻ, ᆪ, ㄳ, ᇄ, ᇼ, ᇽ, ᇾ, ᄓ, ᇅ, ᄔ, ㅥ, ᇿ, ᄕ, ㅦ, ᇆ, ퟋ, ᄖ, ᅛ, ᇇ, ㅧ, ᅜ, ᆬ, ㄵ, ퟌ, ᇉ, ᅝ, ᆭ, ㄶ, ᇈ, ㅨ, ᄗ, ᇊ, ᄄ, ㄸ, ퟍ, ퟎ, ᅞ, ᇋ, ꥠ, ꥡ, ퟏ, ꥢ, ퟐ, ퟑ, ꥣ, ퟒ, ퟓ, ퟔ, ꥤ, ᆰ, ㄺ, ꥥ, ퟕ, ᇌ, ㅩ, ퟖ, ᄘ, ᇍ, ꥦ, ᇎ, ㅪ, ꥧ, ᇏ, ᄙ, ᇐ, ퟗ, ꥨ, ᆱ, ㄻ, ᇑ, ᇒ, ퟘ, ꥩ, ᆲ, ㄼ, ퟙ, ꥪ, ᇓ, ㅫ, ꥫ, ᇕ, ퟚ, ᇔ, ꥬ, ᆳ, ㄽ, ᇖ, ᄛ, ퟝ, ꥭ, ꥮ, ᇘ, ᆴ, ㄾ, ᆵ, ㄿ, ᄚ, ㅀ, ᄻ, ᆶ, ퟲ, ᇗ, ㅬ, ퟛ, ᇙ, ㅭ, ퟜ, ꥯ, ᇚ, ퟞ, ퟟ, ꥰ, ᇛ, ퟠ, ᄜ, ㅮ, ᇜ, ퟡ, ꥱ, ᇝ, ㅯ, ᇞ, ᄝ, ㅱ, ᇢ, ퟢ, ᇠ, ᇡ, ᇟ, ㅰ, ᄞ, ㅲ, ᄟ, ᄠ, ㅳ, ퟣ, ᇣ, ퟤ, ퟥ, ᄈ, ㅃ, ퟦ, ᄬ, ㅹ, ᄡ, ㅄ, ᆹ, ᄢ, ㅴ, ᄣ, ㅵ, ퟧ, ᄤ, ᄥ, ᄦ, ꥲ, ᄫ, ㅸ, ᇦ, ᄧ, ㅶ, ퟨ, ᄨ, ퟩ, ꥳ, ᄩ, ㅷ, ᄪ, ᇤ, ꥴ, ᇥ, ᄭ, ㅺ, ᇧ, ᄮ, ㅻ, ᄯ, ㅼ, ᇨ, ᄰ, ᇩ, ᄱ, ퟪ, ᄲ, ㅽ, ᇪ, ᄳ, ퟫ, ᄊ, ㅆ, ᆻ, ퟬ, ퟭ, ꥵ, ᄴ, ᄵ, ᄶ, ㅾ, ퟯ, ᄷ, ퟰ, ᄸ, ᄹ, ퟱ, ᄺ, ퟮ, ᅁ, ᇬ, ᇭ, ᅂ, ꥶ, ᅃ, ᅄ, ᅅ, ᇱ, ㆂ, ᅇ, ㆀ, ᇮ, ᅈ, ᅉ, ᇯ, ᅊ, ᅋ, ꥷ, ᅆ, ᇲ, ㆃ, ퟷ, ퟸ, ᅍ, ᄍ, ㅉ, ퟹ, ꥸ, ᅒ, ᅓ, ꥹ, ᅖ, ᇳ, ퟺ, ᅗ, ㆄ, ᇴ, ퟻ, ꥺ, ᇵ, ᇶ, ᇷ, ᇸ, ꥻ, ᅘ, ㆅ, ᄽ, ᄿ, ퟳ, ퟴ, ퟵ, ퟶ, ᅏ, ᅑ, ꥼ, ᆣ, ᅶ, ᅷ, ᅢ, ㅐ, ᅸ, ᅹ, ᆤ, ᅤ, ㅒ, ᅼ, ᅺ, ᅻ, ᅦ, ㅔ, ᆥ, ᅽ, ᅾ, ᅨ, ㅖ, ᅪ, ㅘ, ᅫ, ㅙ, ᆦ, ᆧ, ᅿ, ᆀ, ힰ, ᆁ, ᆂ, ힱ, ᆃ, ᅬ, ㅚ, ힲ, ힳ, ᆄ, ㆇ, ᆆ, ᆅ, ㆈ, ힴ, ᆇ, ᆈ, ㆉ, ᆉ, ᆊ, ᅯ, ㅝ, ᆋ, ᅰ, ㅞ, ힵ, ᆌ, ᆍ, ᅱ, ㅟ, ힶ, ᆎ, ힷ, ᆏ, ᆐ, ᆑ, ㆊ, ᆒ, ㆋ, ힸ, ᆓ, ᆔ, ㆌ, ퟅ, ᆟ, ퟆ, ᆠ, ᆢ, ᆡ, ㆎ, 𑫦, 𑫨, 𑫩, 𑫪, 𑫧, 𑫴, 𑫶, 𑫷, 𑫸, 𑫵, 𑫬, 𑫭, 𑫮, Ꚛ, ꞛ, Ꞛ, 𐏑, 𐏓, 𒀸, 𓋹, ᆜ, ᆘ, ᆙ, ힽ, ힾ, ힿ, ퟀ, ᆚ, ퟁ, ퟂ, ᆛ, ퟃ, ᆝ, ퟄ, 𠄢, 𠔜, 𠔥, 𠕋, 𠘺, 𠠄, 𠣞, 𠨬, 𠭣, 𡓤, 𡚨, 𡛪, 𡧈, 𡬘, 𡴋, 𡷤, 𡷦, 𢆃, 𢆟, 𢌱, 𢌱, 𢛔, 𢡄, 𢡊, 𢬌, 𢯱, 𣀊, 𣊸, 𣍟, 𣎓, 𣎜, 𣏃, 𣏕, 𣑭, 𣚣, 𣢧, 𣪍, 𣫺, 𣲼, 𣴞, 𣻑, 𣽞, 𣾎, 𤉣, 𤋮, 𤎫, 𤘈, 𤜵, 𤠔, 𤰶, 𤲒, 𤾡, 𤾸, 𥁄, 𥃲, 𥃳, 𥄙, 𥄳, 𥉉, 𥐝, 𥘦, 𥚚, 𥛅, 𥥼, 𥪧, 𥪧, 𥮫, 𥲀, 𥳐, 𥾆, 𦇚, 𦈨, 𦉇, 𦋙, 𦌾, 𦓚, 𦔣, 𦖨, 𦞧, 𦞵, 𦬼, 𦰶, 𦳕, 𦵫, 𦼬, 𦾱, 𧃒, 𧏊, 𧙧, 𧢮, 𧥦, 𧲨, 𧻓, 𧼯, 𨗒, 𨗭, 𨜮, 𨯺, 𨵷, 𩅅, 𩇟, 𩈚, 𩐊, 𩒖, 𩖶, 𩬰, 𪃎, 𪄅, 𪈎, 𪊑, 𪎒, 𪘀, data_default, init_data = __esmMin((() => {
	ﱞ = "ﹲّ", ﱟ = "ﹴّ", ﳲ = "ﹷّ", ﱠ = "ﹶّ", ﳳ = "ﹹّ", ﱡ = "ﹸّ", ﳴ = "ﹻّ", ﱢ = "ﹺّ", ﱣ = "ﹼٰ", ⵈ = "···", ᒀ = "·ḃ", ᐼ = "·Ʌ", ᒮ = "·Γ", ᐎ = "·Δ", ᑙ = "·Ո", ᐌ = "·ᐁ", ᐐ = "·ᐄ", ᐒ = "·ᐅ", ᐔ = "·ᐆ", ᐗ = "·ᐊ", ᐙ = "·ᐋ", ᐾ = "·ᐲ", ᑂ = "·ᐴ", ᑆ = "·ᐹ", ᑛ = "·ᑏ", ᑔ = "·ᑐ", ᑝ = "·ᑐ", ᑟ = "·ᑑ", ᑡ = "·ᑕ", ᑣ = "·ᑖ", ᑴ = "·ᑫ", ᑸ = "·ᑮ", ᑼ = "·ᑰ", ᒒ = "·ᒉ", ᒔ = "·ᒋ", ᒖ = "·ᒌ", ᒚ = "·ᒎ", ᒜ = "·ᒐ", ᒞ = "·ᒑ", ᒬ = "·ᒣ", ᒰ = "·ᒦ", ᒲ = "·ᒧ", ᒴ = "·ᒨ", ᒸ = "·ᒫ", ᓉ = "·ᓀ", ᣆ = "·ᓂ", ᣈ = "·ᓃ", ᣊ = "·ᓄ", ᣌ = "·ᓅ", ᓋ = "·ᓇ", ᓍ = "·ᓈ", ᓜ = "·ᓓ", ᓞ = "·ᓕ", ᓠ = "·ᓖ", ᓢ = "·ᓗ", ᓤ = "·ᓘ", ᓦ = "·ᓚ", ᓨ = "·ᓛ", ᓶ = "·ᓭ", ᓸ = "·ᓯ", ᓺ = "·ᓰ", ᓼ = "·ᓱ", ᓾ = "·ᓲ", ᔀ = "·ᓴ", ᔂ = "·ᓵ", ᔗ = "·ᔐ", ᔙ = "·ᔑ", ᔛ = "·ᔒ", ᔝ = "·ᔓ", ᔟ = "·ᔔ", ᔡ = "·ᔕ", ᔣ = "·ᔖ", ᔱ = "·ᔨ", ᔳ = "·ᔩ", ᔵ = "·ᔪ", ᔷ = "·ᔫ", ᔹ = "·ᔭ", ᔻ = "·ᔮ", ᣎ = "·ᕃ", ᣏ = "·ᕆ", ᣐ = "·ᕇ", ᣑ = "·ᕈ", ᣒ = "·ᕉ", ᣓ = "·ᕋ", ᕎ = "·ᕌ", ᕛ = "·ᕚ", ᕨ = "·ᕧ", ᢳ = "·ᢱ", ᢶ = "·ᢴ", ᢹ = "·ᢸ", ᣂ = "·ᣀ", ꙑ = "ˉbi", ð = "∂̵", ᆖ = "ーー", ힹ = "ーᅡ", ힺ = "ーᅥ", ힻ = "ーᅥ丨", ힼ = "ーᅩ", ᆕ = "ーᅮ", ᅴ = "ー丨", ㅢ = "ー丨", ᆗ = "ー丨ᅮ", ᒁ = "ḃ·", ɚ = "ǝ˞", ꭁ = "ǝo̸", ꭂ = "ǝo̵", ҙ = "ɜ̦", ң = "ʜ̩", ӊ = "ʜ̦", ӈ = "ʜ̦", ﷳ = "lكبر", ﷲ = "lللّٰo", Ǿ = "Ó̸", ɶ = "oᴇ", ﶓ = "oمج", ﶔ = "oمم", ൟ = "oരo", တ = "oာ", ꬿ = "ɔ̸", қ = "ĸ̩", ҟ = "ĸ̵", ɱ = "rn̦", ᵯ = "rn̴", ᵳ = "ɾ̴", ҭ = "ᴛ̩", ᵿ = "ʊ̵", ⅷ = "viii", Ⅷ = "Vlll", Ӆ = "Ʌ̦", ᐽ = "Ʌ·", ѽ = "w҆҇", ӎ = "ʍ̦", Ғ = "Γ̵", ᒯ = "Γ·", ᐏ = "Δ·", ᐬ = "Δᐠ", җ = "ж̩", Җ = "Ж̩", Ҋ = "Ѝ̦", ҋ = "й̦", ӆ = "л̦", Ѽ = "Ѡ҆҇", ᣭ = "Ѡ·", Ҿ = "Ҽ̨", և = "եւ", ﬔ = "մե", ﬕ = "մի", ﬗ = "մխ", ﬓ = "մն", ᑚ = "Ո·", ﬖ = "վն", ﭏ = "אל", ݑ = "بۛ", ࢶ = "بۢ", ࢡ = "بٔ", ﲜ = "بج", ﰅ = "بج", ﲝ = "بح", ﰆ = "بح", ﷂ = "بحى", ﲞ = "بخ", ﰇ = "بخ", ﳒ = "بخ", ﱋ = "بخ", ﶞ = "بخى", ﱪ = "بر", ﱫ = "بز", ﲟ = "بم", ﳡ = "بم", ﱬ = "بم", ﰈ = "بم", ﱭ = "بن", ﱮ = "بى", ﰉ = "بى", ﱯ = "بى", ﰊ = "بى", ﲡ = "تج", ﰋ = "تج", ﵐ = "تجم", ﶠ = "تجى", ﶟ = "تجى", ﲢ = "تح", ﰌ = "تح", ﵒ = "تحج", ﵑ = "تحج", ﵓ = "تحم", ﲣ = "تخ", ﰍ = "تخ", ﵔ = "تخم", ﶢ = "تخى", ﶡ = "تخى", ﱰ = "تر", ﱱ = "تز", ﲤ = "تم", ﳣ = "تم", ﱲ = "تم", ﰎ = "تم", ﵕ = "تمج", ﵖ = "تمح", ﵗ = "تمخ", ﶤ = "تمى", ﶣ = "تمى", ﱳ = "تن", ﱴ = "تى", ﰏ = "تى", ﱵ = "تى", ﰐ = "تى", ﲧ = "جح", ﰕ = "جح", ﶦ = "جحى", ﶾ = "جحى", ﷻ = "جل جلlلo", ﲨ = "جم", ﰖ = "جم", ﵙ = "جمح", ﵘ = "جمح", ﶧ = "جمى", ﶥ = "جمى", ﴝ = "جى", ﴁ = "جى", ﴞ = "جى", ﴂ = "جى", څ = "حۛ", ځ = "حٔ", ݲ = "حٔ", ﲩ = "حج", ﰗ = "حج", ﶿ = "حجى", ﲪ = "حم", ﰘ = "حم", ﵛ = "حمى", ﵚ = "حمى", ﴛ = "حى", ﳿ = "حى", ﴜ = "حى", ﴀ = "حى", ﲫ = "خج", ﰙ = "خج", ﰚ = "خح", ﲬ = "خم", ﰛ = "خم", ﴟ = "خى", ﴃ = "خى", ﴠ = "خى", ﴄ = "خى", ڈ = "دؕ", ﮉ = "دؕ", ﮈ = "دؕ", ڎ = "دۛ", ﮇ = "دۛ", ﮆ = "دۛ", ۮ = "د̂", ࢮ = "د̤̣", ﱛ = "ذٰ", ڋ = "ڊؕ", ڑ = "رؕ", ﮍ = "رؕ", ﮌ = "رؕ", ژ = "رۛ", ﮋ = "رۛ", ﮊ = "رۛ", ڒ = "ر̆", ࢹ = "ر̆̇", ۯ = "ر̂", ݬ = "رٔ", ﱜ = "رٰ", ﷶ = "رسول", ࢲ = "ز̂", ݱ = "ڗؕ", ش = "سۛ", 𞸔 = "سۛ", 𞸴 = "سۛ", 𞹔 = "سۛ", 𞹴 = "سۛ", 𞺔 = "سۛ", 𞺴 = "سۛ", ﺷ = "سۛ", ﺸ = "سۛ", ﺶ = "سۛ", ﺵ = "سۛ", ݾ = "س̂", ﴲ = "سۛo", ﳪ = "سۛo", ﲭ = "سج", ﴴ = "سج", ﰜ = "سج", ﴭ = "سۛج", ﴷ = "سۛج", ﴥ = "سۛج", ﴉ = "سۛج", ﵝ = "سجح", ﵞ = "سجى", ﵩ = "سۛجى", ﲮ = "سح", ﴵ = "سح", ﰝ = "سح", ﴮ = "سۛح", ﴸ = "سۛح", ﴦ = "سۛح", ﴊ = "سۛح", ﵜ = "سحج", ﵨ = "سۛحم", ﵧ = "سۛحم", ﶪ = "سۛحى", ﲯ = "سخ", ﴶ = "سخ", ﰞ = "سخ", ﴯ = "سۛخ", ﴹ = "سۛخ", ﴧ = "سۛخ", ﴋ = "سۛخ", ﶨ = "سخى", ﷆ = "سخى", ﴪ = "سر", ﴎ = "سر", ﴩ = "سۛر", ﴍ = "سۛر", ﲰ = "سم", ﳧ = "سم", ﰟ = "سم", ﴰ = "سۛم", ﳩ = "سۛم", ﴨ = "سۛم", ﴌ = "سۛم", ﵡ = "سمج", ﵠ = "سمح", ﵟ = "سمح", ﵫ = "سۛمخ", ﵪ = "سۛمخ", ﵣ = "سمم", ﵢ = "سمم", ﵭ = "سۛمم", ﵬ = "سۛمم", ﴗ = "سى", ﳻ = "سى", ﴘ = "سى", ﳼ = "سى", ﴙ = "سۛى", ﳽ = "سۛى", ﴚ = "سۛى", ﳾ = "سۛى", ڞ = "صۛ", ࢯ = "ص̤̣", ﲱ = "صح", ﰠ = "صح", ﵥ = "صحح", ﵤ = "صحح", ﶩ = "صحى", ﲲ = "صخ", ﴫ = "صر", ﴏ = "صر", ﷵ = "صلعم", ﷹ = "صلى", ﷰ = "صلى", ﷺ = "صلى lللo علىo وسلم", ﲳ = "صم", ﰡ = "صم", ﷅ = "صمم", ﵦ = "صمم", ﴡ = "صى", ﴅ = "صى", ﴢ = "صى", ﴆ = "صى", ﲴ = "ضج", ﰢ = "ضج", ﲵ = "ضح", ﰣ = "ضح", ﵮ = "ضحى", ﶫ = "ضحى", ﲶ = "ضخ", ﰤ = "ضخ", ﵰ = "ضخم", ﵯ = "ضخم", ﴬ = "ضر", ﴐ = "ضر", ﲷ = "ضم", ﰥ = "ضم", ﴣ = "ضى", ﴇ = "ضى", ﴤ = "ضى", ﴈ = "ضى", ڟ = "طۛ", ﲸ = "طح", ﰦ = "طح", ﴳ = "طم", ﴺ = "طم", ﰧ = "طم", ﵲ = "طمح", ﵱ = "طمح", ﵳ = "طمم", ﵴ = "طمى", ﴑ = "طى", ﳵ = "طى", ﴒ = "طى", ﳶ = "طى", ﲹ = "ظم", ﴻ = "ظم", ﰨ = "ظم", ﲺ = "عج", ﰩ = "عج", ﷄ = "عجم", ﵵ = "عجم", ﷷ = "علىo", ﲻ = "عم", ﰪ = "عم", ﵷ = "عمم", ﵶ = "عمم", ﵸ = "عمى", ﶶ = "عمى", ﴓ = "عى", ﳷ = "عى", ﴔ = "عى", ﳸ = "عى", ﲼ = "غج", ﰫ = "غج", ﲽ = "غم", ﰬ = "غم", ﵹ = "غمم", ﵻ = "غمى", ﵺ = "غمى", ﴕ = "غى", ﳹ = "غى", ﴖ = "غى", ﳺ = "غى", ﲾ = "فج", ﰭ = "فج", ﲿ = "فح", ﰮ = "فح", ﳀ = "فخ", ﰯ = "فخ", ﵽ = "فخم", ﵼ = "فخم", ﳁ = "فم", ﰰ = "فم", ﷁ = "فمى", ﱼ = "فى", ﰱ = "فى", ﱽ = "فى", ﰲ = "فى", ڤ = "ڡۛ", ﭬ = "ڡۛ", ﭭ = "ڡۛ", ﭫ = "ڡۛ", ﭪ = "ڡۛ", ڨ = "ڡۛ", ࢤ = "ڢۛ", ﳂ = "قح", ﰳ = "قح", ﷱ = "قلى", ﳃ = "قم", ﰴ = "قم", ﶴ = "قمح", ﵾ = "قمح", ﵿ = "قمم", ﶲ = "قمى", ﱾ = "قى", ﰵ = "قى", ﱿ = "قى", ﰶ = "قى", ڭ = "كۛ", ﯕ = "كۛ", ﯖ = "كۛ", ﯔ = "كۛ", ﯓ = "كۛ", ݣ = "كۛ", ﳄ = "كج", ﰸ = "كج", ﳅ = "كح", ﰹ = "كح", ﳆ = "كخ", ﰺ = "كخ", ﳇ = "كل", ﳫ = "كل", ﲁ = "كل", ﰻ = "كل", ﳈ = "كم", ﳬ = "كم", ﲂ = "كم", ﰼ = "كم", ﷃ = "كمم", ﶻ = "كمم", ﶷ = "كمى", ﲃ = "كى", ﰽ = "كى", ﲄ = "كى", ﰾ = "كى", ڴ = "گۛ", ڷ = "لۛ", ڵ = "ل̆", ﻺ = "لlٕ", ﻹ = "لlٕ", ﻸ = "لlٴ", ﻷ = "لlٴ", ﻶ = "لآ", ﻵ = "لآ", ﳉ = "لج", ﰿ = "لج", ﶃ = "لجج", ﶄ = "لجج", ﶺ = "لجم", ﶼ = "لجم", ﶬ = "لجى", ﳊ = "لح", ﱀ = "لح", ﶵ = "لحم", ﶀ = "لحم", ﶂ = "لحى", ﶁ = "لحى", ﳋ = "لخ", ﱁ = "لخ", ﶆ = "لخم", ﶅ = "لخم", ﳌ = "لم", ﳭ = "لم", ﲅ = "لم", ﱂ = "لم", ﶈ = "لمح", ﶇ = "لمح", ﶭ = "لمى", ﲆ = "لى", ﱃ = "لى", ﲇ = "لى", ﱄ = "لى", ࢧ = "مۛ", ﳎ = "مج", ﱅ = "مج", ﶌ = "مجح", ﶒ = "مجخ", ﶍ = "مجم", ﷀ = "مجى", ﳏ = "مح", ﱆ = "مح", ﶉ = "محج", ﶊ = "محم", ﷴ = "محمد", ﶋ = "محى", ﳐ = "مخ", ﱇ = "مخ", ﶎ = "مخج", ﶏ = "مخم", ﶹ = "مخى", ﳑ = "مم", ﲉ = "مم", ﱈ = "مم", ﶱ = "ممى", ﱉ = "مى", ﱊ = "مى", ݨ = "نؕ", ݩ = "ن̆", ﶸ = "نجح", ﶽ = "نجح", ﶘ = "نجم", ﶗ = "نجم", ﶙ = "نجى", ﷇ = "نجى", ﳓ = "نح", ﱌ = "نح", ﶕ = "نحم", ﶖ = "نحى", ﶳ = "نحى", ﳔ = "نخ", ﱍ = "نخ", ﲊ = "نر", ﲋ = "نز", ﳕ = "نم", ﳮ = "نم", ﲌ = "نم", ﱎ = "نم", ﶛ = "نمى", ﶚ = "نمى", ﲍ = "نن", ﲎ = "نى", ﱏ = "نى", ﲏ = "نى", ﱐ = "نى", ۋ = "وۛ", ﯟ = "وۛ", ﯞ = "وۛ", ۇ = "و̓", ﯘ = "و̓", ﯗ = "و̓", ۆ = "و̆", ﯚ = "و̆", ﯙ = "و̆", ۉ = "و̂", ﯣ = "و̂", ﯢ = "و̂", ۈ = "وٰ", ﯜ = "وٰ", ﯛ = "وٰ", ؤ = "وٴ", ﺆ = "وٴ", ﺅ = "وٴ", ٶ = "وٴ", ٷ = "و̓ٴ", ﯝ = "و̓ٴ", ﷸ = "وسلم", ٹ = "ىؕ", ﭨ = "ىؕ", ﭩ = "ىؕ", ﭧ = "ىؕ", ﭦ = "ىؕ", ڻ = "ىؕ", ﮢ = "ىؕ", ﮣ = "ىؕ", ﮡ = "ىؕ", ﮠ = "ىؕ", پ = "ىۛ", ﭘ = "ىۛ", ﭙ = "ىۛ", ﭗ = "ىۛ", ﭖ = "ىۛ", ث = "ىۛ", 𞸖 = "ىۛ", 𞸶 = "ىۛ", 𞹶 = "ىۛ", 𞺖 = "ىۛ", 𞺶 = "ىۛ", ﺛ = "ىۛ", ﺜ = "ىۛ", ﺚ = "ىۛ", ﺙ = "ىۛ", ڽ = "ىۛ", ۑ = "ىۛ", ؿ = "ىۛ", ࢷ = "ىۛۢ", ݖ = "ى̆", ێ = "ى̆", ࢺ = "ى̆̇", ؽ = "ى̂", ࢨ = "ىٔ", ﲐ = "ىٰ", ﱝ = "ىٰ", ﳦ = "ىۛo", ئ = "ىٴ", ﺋ = "ىٴ", ﺌ = "ىٴ", ﺊ = "ىٴ", ﺉ = "ىٴ", ٸ = "ىٴ", ﯫ = "ىٴl", ﯪ = "ىٴl", ﲛ = "ىٴo", ﳠ = "ىٴo", ﯭ = "ىٴo", ﯬ = "ىٴo", ﯸ = "ىٴٻ", ﯷ = "ىٴٻ", ﯶ = "ىٴٻ", ﲗ = "ىٴج", ﰀ = "ىٴج", ﲘ = "ىٴح", ﰁ = "ىٴح", ﲙ = "ىٴخ", ﱤ = "ىٴر", ﱥ = "ىٴز", ﲚ = "ىٴم", ﳟ = "ىٴم", ﱦ = "ىٴم", ﰂ = "ىٴم", ﱧ = "ىٴن", ﯯ = "ىٴو", ﯮ = "ىٴو", ﯱ = "ىٴو̓", ﯰ = "ىٴو̓", ﯳ = "ىٴو̆", ﯲ = "ىٴو̆", ﯵ = "ىٴوٰ", ﯴ = "ىٴوٰ", ﯻ = "ىٴى", ﯺ = "ىٴى", ﱨ = "ىٴى", ﯹ = "ىٴى", ﰃ = "ىٴى", ﱩ = "ىٴى", ﰄ = "ىٴى", ﳚ = "ىج", ﱕ = "ىج", ﰑ = "ىۛج", ﶯ = "ىجى", ﳛ = "ىح", ﱖ = "ىح", ﶮ = "ىحى", ﳜ = "ىخ", ﱗ = "ىخ", ﲑ = "ىر", ﱶ = "ىۛر", ﲒ = "ىز", ﱷ = "ىۛز", ﳝ = "ىم", ﳰ = "ىم", ﲓ = "ىم", ﱘ = "ىم", ﲦ = "ىۛم", ﳥ = "ىۛم", ﱸ = "ىۛم", ﰒ = "ىۛم", ﶝ = "ىمم", ﶜ = "ىمم", ﶰ = "ىمى", ﲔ = "ىن", ﱹ = "ىۛن", ﲕ = "ىى", ﱙ = "ىى", ﲖ = "ىى", ﱚ = "ىى", ﱺ = "ىۛى", ﰓ = "ىۛى", ﱻ = "ىۛى", ﰔ = "ىۛى", आ = "अा", ऒ = "अाॆ", ओ = "अाे", औ = "अाै", ऄ = "अॆ", ऑ = "अॉ", ऍ = "एॅ", ऎ = "एॆ", ऐ = "एे", ई = "र्इ", আ = "অা", ৠ = "ঋৃ", ৡ = "ঋৃ", ਉ = "ੳੁ", ਊ = "ੳੂ", ਆ = "ਅਾ", ਐ = "ਅੈ", ਔ = "ਅੌ", ਇ = "ੲਿ", ਈ = "ੲੀ", ਏ = "ੲੇ", આ = "અા", ઑ = "અાૅ", ઓ = "અાે", ઔ = "અાૈ", ઍ = "અૅ", એ = "અે", ઐ = "અૈ", ଆ = "ଅା", ஊ = "உள", ഊ = "உൗ", ഺ = "டி", ౠ = "ఋా", ౡ = "ఌా", ఔ = "ఒౌ", ಔ = "ఒౌ", ఓ = "ఒౕ", ಓ = "ఒౕ", ఢ = "డ̣", థ = "ధּ", భ = "బ̣", ఠ = "రּ", ష = "వ̣", హ = "వా", మ = "వు", ೡ = "ಌಾ", ഈ = "ഇൗ", ഐ = "എെ", ഓ = "ഒാ", ഔ = "ഒൗ", ഌ = "നു", ങ = "നു", ൻ = "ന്", ർ = "ര്", 𑐓 = "𑐴𑑂𑐒", 𑐙 = "𑐴𑑂𑐘", 𑐤 = "𑐴𑑂𑐣", 𑐪 = "𑐴𑑂𑐩", 𑐭 = "𑐴𑑂𑐬", 𑐯 = "𑐴𑑂𑐮", 𑗘 = "𑖂", 𑗙 = "𑖂", 𑗚 = "𑖃", 𑗛 = "𑖄", ำ = "̊า", แ = "เเ", ໜ = "ຫນ", ໝ = "ຫມ", ຳ = "̊າ", ༀ = "ཨོཾ", ႁ = "ဂှ", က = "ဂာ", ၰ = "ဃှ", ၦ = "ပှ", ဟ = "ပာ", ၯ = "ပာှ", ၾ = "ၽှ", ဩ = "သြ", ဪ = "သြော်", ᐍ = "ᐁ·", ᐫ = "ᐁᐠ", ᐑ = "ᐄ·", ᐓ = "ᐅ·", ᐭ = "ᐅᐠ", ᐕ = "ᐆ·", ᐘ = "ᐊ·", ᐮ = "ᐊᐠ", ᐚ = "ᐋ·", ᣝ = "ᐞᣟ", ᐿ = "ᐲ·", ᑃ = "ᐴ·", ᑇ = "ᐹ·", ᑜ = "ᑏ·", ᑞ = "ᑐ·", ᑩ = "ᑐ'", ᑠ = "ᑑ·", ᑢ = "ᑕ·", ᑪ = "ᑕ'", ᑤ = "ᑖ·", ᑵ = "ᑫ·", ᒅ = "ᑫ'", ᑹ = "ᑮ·", ᑽ = "ᑰ·", ᒓ = "ᒉ·", ᒕ = "ᒋ·", ᒗ = "ᒌ·", ᒛ = "ᒎ·", ᒝ = "ᒐ·", ᒟ = "ᒑ·", ᒭ = "ᒣ·", ᒱ = "ᒦ·", ᒳ = "ᒧ·", ᒵ = "ᒨ·", ᒹ = "ᒫ·", ᓊ = "ᓀ·", ᣇ = "ᓂ·", ᣉ = "ᓃ·", ᣋ = "ᓄ·", ᣍ = "ᓅ·", ᓌ = "ᓇ·", ᓎ = "ᓈ·", ᓝ = "ᓓ·", ᓟ = "ᓕ·", ᓡ = "ᓖ·", ᓣ = "ᓗ·", ᓥ = "ᓘ·", ᓧ = "ᓚ·", ᓩ = "ᓛ·", ᓷ = "ᓭ·", ᓹ = "ᓯ·", ᓻ = "ᓰ·", ᓽ = "ᓱ·", ᓿ = "ᓲ·", ᔁ = "ᓴ·", ᔃ = "ᓵ·", ᔌ = "ᔋ<", ᔎ = "ᔋb", ᔍ = "ᔋᑕ", ᔏ = "ᔋᒐ", ᔘ = "ᔐ·", ᔚ = "ᔑ·", ᔜ = "ᔒ·", ᔞ = "ᔓ·", ᔠ = "ᔔ·", ᔢ = "ᔕ·", ᔤ = "ᔖ·", ᔲ = "ᔨ·", ᔴ = "ᔩ·", ᔶ = "ᔪ·", ᔸ = "ᔫ·", ᔺ = "ᔭ·", ᔼ = "ᔮ·", ᣠ = "ᕃ·", ᕏ = "ᕌ·", ᖃ = "ᕐb", ᖄ = "ᕐḃ", ᖁ = "ᕐd", ᕿ = "ᕐP", ᙯ = "ᕐᑫ", ᕾ = "ᕐᑬ", ᖀ = "ᕐᑮ", ᖂ = "ᕐᑰ", ᖅ = "ᕐᒃ", ᕜ = "ᕚ·", ᣣ = "ᕞ·", ᣤ = "ᕦ·", ᕩ = "ᕧ·", ᣥ = "ᕫ·", ᣨ = "ᖆ·", ᖑ = "ᖕJ", ᙰ = "ᖕᒉ", ᖎ = "ᖕᒊ", ᖏ = "ᖕᒋ", ᖐ = "ᖕᒌ", ᖒ = "ᖕᒎ", ᖓ = "ᖕᒐ", ᖔ = "ᖕᒑ", ᙳ = "ᖖJ", ᙱ = "ᖖᒋ", ᙲ = "ᖖᒌ", ᙴ = "ᖖᒎ", ᙵ = "ᖖᒐ", ᙶ = "ᖖᒑ", ᣪ = "ᖗ·", ᙷ = "ᖧ·", ᙸ = "ᖨ·", ᙹ = "ᖩ·", ᙺ = "ᖪ·", ᙻ = "ᖫ·", ᙼ = "ᖬ·", ᙽ = "ᖭ·", ᣰ = "ᗴ·", ᣲ = "ᘛ·", ᣜ = "ᣟᐞ", ᄁ = "ᄀᄀ", ㄲ = "ᄀᄀ", ᆩ = "ᄀᄀ", ᇺ = "ᄀᄂ", ᅚ = "ᄀᄃ", ᇃ = "ᄀᄅ", ᇻ = "ᄀᄇ", ᆪ = "ᄀᄉ", ㄳ = "ᄀᄉ", ᇄ = "ᄀᄉᄀ", ᇼ = "ᄀᄎ", ᇽ = "ᄀᄏ", ᇾ = "ᄀᄒ", ᄓ = "ᄂᄀ", ᇅ = "ᄂᄀ", ᄔ = "ᄂᄂ", ㅥ = "ᄂᄂ", ᇿ = "ᄂᄂ", ᄕ = "ᄂᄃ", ㅦ = "ᄂᄃ", ᇆ = "ᄂᄃ", ퟋ = "ᄂᄅ", ᄖ = "ᄂᄇ", ᅛ = "ᄂᄉ", ᇇ = "ᄂᄉ", ㅧ = "ᄂᄉ", ᅜ = "ᄂᄌ", ᆬ = "ᄂᄌ", ㄵ = "ᄂᄌ", ퟌ = "ᄂᄎ", ᇉ = "ᄂᄐ", ᅝ = "ᄂᄒ", ᆭ = "ᄂᄒ", ㄶ = "ᄂᄒ", ᇈ = "ᄂᅀ", ㅨ = "ᄂᅀ", ᄗ = "ᄃᄀ", ᇊ = "ᄃᄀ", ᄄ = "ᄃᄃ", ㄸ = "ᄃᄃ", ퟍ = "ᄃᄃ", ퟎ = "ᄃᄃᄇ", ᅞ = "ᄃᄅ", ᇋ = "ᄃᄅ", ꥠ = "ᄃᄆ", ꥡ = "ᄃᄇ", ퟏ = "ᄃᄇ", ꥢ = "ᄃᄉ", ퟐ = "ᄃᄉ", ퟑ = "ᄃᄉᄀ", ꥣ = "ᄃᄌ", ퟒ = "ᄃᄌ", ퟓ = "ᄃᄎ", ퟔ = "ᄃᄐ", ꥤ = "ᄅᄀ", ᆰ = "ᄅᄀ", ㄺ = "ᄅᄀ", ꥥ = "ᄅᄀᄀ", ퟕ = "ᄅᄀᄀ", ᇌ = "ᄅᄀᄉ", ㅩ = "ᄅᄀᄉ", ퟖ = "ᄅᄀᄒ", ᄘ = "ᄅᄂ", ᇍ = "ᄅᄂ", ꥦ = "ᄅᄃ", ᇎ = "ᄅᄃ", ㅪ = "ᄅᄃ", ꥧ = "ᄅᄃᄃ", ᇏ = "ᄅᄃᄒ", ᄙ = "ᄅᄅ", ᇐ = "ᄅᄅ", ퟗ = "ᄅᄅᄏ", ꥨ = "ᄅᄆ", ᆱ = "ᄅᄆ", ㄻ = "ᄅᄆ", ᇑ = "ᄅᄆᄀ", ᇒ = "ᄅᄆᄉ", ퟘ = "ᄅᄆᄒ", ꥩ = "ᄅᄇ", ᆲ = "ᄅᄇ", ㄼ = "ᄅᄇ", ퟙ = "ᄅᄇᄃ", ꥪ = "ᄅᄇᄇ", ᇓ = "ᄅᄇᄉ", ㅫ = "ᄅᄇᄉ", ꥫ = "ᄅᄇᄋ", ᇕ = "ᄅᄇᄋ", ퟚ = "ᄅᄇᄑ", ᇔ = "ᄅᄇᄒ", ꥬ = "ᄅᄉ", ᆳ = "ᄅᄉ", ㄽ = "ᄅᄉ", ᇖ = "ᄅᄉᄉ", ᄛ = "ᄅᄋ", ퟝ = "ᄅᄋ", ꥭ = "ᄅᄌ", ꥮ = "ᄅᄏ", ᇘ = "ᄅᄏ", ᆴ = "ᄅᄐ", ㄾ = "ᄅᄐ", ᆵ = "ᄅᄑ", ㄿ = "ᄅᄑ", ᄚ = "ᄅᄒ", ㅀ = "ᄅᄒ", ᄻ = "ᄅᄒ", ᆶ = "ᄅᄒ", ퟲ = "ᄅᄒ", ᇗ = "ᄅᅀ", ㅬ = "ᄅᅀ", ퟛ = "ᄅᅌ", ᇙ = "ᄅᅙ", ㅭ = "ᄅᅙ", ퟜ = "ᄅᅙᄒ", ꥯ = "ᄆᄀ", ᇚ = "ᄆᄀ", ퟞ = "ᄆᄂ", ퟟ = "ᄆᄂᄂ", ꥰ = "ᄆᄃ", ᇛ = "ᄆᄅ", ퟠ = "ᄆᄆ", ᄜ = "ᄆᄇ", ㅮ = "ᄆᄇ", ᇜ = "ᄆᄇ", ퟡ = "ᄆᄇᄉ", ꥱ = "ᄆᄉ", ᇝ = "ᄆᄉ", ㅯ = "ᄆᄉ", ᇞ = "ᄆᄉᄉ", ᄝ = "ᄆᄋ", ㅱ = "ᄆᄋ", ᇢ = "ᄆᄋ", ퟢ = "ᄆᄌ", ᇠ = "ᄆᄎ", ᇡ = "ᄆᄒ", ᇟ = "ᄆᅀ", ㅰ = "ᄆᅀ", ᄞ = "ᄇᄀ", ㅲ = "ᄇᄀ", ᄟ = "ᄇᄂ", ᄠ = "ᄇᄃ", ㅳ = "ᄇᄃ", ퟣ = "ᄇᄃ", ᇣ = "ᄇᄅ", ퟤ = "ᄇᄅᄑ", ퟥ = "ᄇᄆ", ᄈ = "ᄇᄇ", ㅃ = "ᄇᄇ", ퟦ = "ᄇᄇ", ᄬ = "ᄇᄇᄋ", ㅹ = "ᄇᄇᄋ", ᄡ = "ᄇᄉ", ㅄ = "ᄇᄉ", ᆹ = "ᄇᄉ", ᄢ = "ᄇᄉᄀ", ㅴ = "ᄇᄉᄀ", ᄣ = "ᄇᄉᄃ", ㅵ = "ᄇᄉᄃ", ퟧ = "ᄇᄉᄃ", ᄤ = "ᄇᄉᄇ", ᄥ = "ᄇᄉᄉ", ᄦ = "ᄇᄉᄌ", ꥲ = "ᄇᄉᄐ", ᄫ = "ᄇᄋ", ㅸ = "ᄇᄋ", ᇦ = "ᄇᄋ", ᄧ = "ᄇᄌ", ㅶ = "ᄇᄌ", ퟨ = "ᄇᄌ", ᄨ = "ᄇᄎ", ퟩ = "ᄇᄎ", ꥳ = "ᄇᄏ", ᄩ = "ᄇᄐ", ㅷ = "ᄇᄐ", ᄪ = "ᄇᄑ", ᇤ = "ᄇᄑ", ꥴ = "ᄇᄒ", ᇥ = "ᄇᄒ", ᄭ = "ᄉᄀ", ㅺ = "ᄉᄀ", ᇧ = "ᄉᄀ", ᄮ = "ᄉᄂ", ㅻ = "ᄉᄂ", ᄯ = "ᄉᄃ", ㅼ = "ᄉᄃ", ᇨ = "ᄉᄃ", ᄰ = "ᄉᄅ", ᇩ = "ᄉᄅ", ᄱ = "ᄉᄆ", ퟪ = "ᄉᄆ", ᄲ = "ᄉᄇ", ㅽ = "ᄉᄇ", ᇪ = "ᄉᄇ", ᄳ = "ᄉᄇᄀ", ퟫ = "ᄉᄇᄋ", ᄊ = "ᄉᄉ", ㅆ = "ᄉᄉ", ᆻ = "ᄉᄉ", ퟬ = "ᄉᄉᄀ", ퟭ = "ᄉᄉᄃ", ꥵ = "ᄉᄉᄇ", ᄴ = "ᄉᄉᄉ", ᄵ = "ᄉᄋ", ᄶ = "ᄉᄌ", ㅾ = "ᄉᄌ", ퟯ = "ᄉᄌ", ᄷ = "ᄉᄎ", ퟰ = "ᄉᄎ", ᄸ = "ᄉᄏ", ᄹ = "ᄉᄐ", ퟱ = "ᄉᄐ", ᄺ = "ᄉᄑ", ퟮ = "ᄉᅀ", ᅁ = "ᄋᄀ", ᇬ = "ᄋᄀ", ᇭ = "ᄋᄀᄀ", ᅂ = "ᄋᄃ", ꥶ = "ᄋᄅ", ᅃ = "ᄋᄆ", ᅄ = "ᄋᄇ", ᅅ = "ᄋᄉ", ᇱ = "ᄋᄉ", ㆂ = "ᄋᄉ", ᅇ = "ᄋᄋ", ㆀ = "ᄋᄋ", ᇮ = "ᄋᄋ", ᅈ = "ᄋᄌ", ᅉ = "ᄋᄎ", ᇯ = "ᄋᄏ", ᅊ = "ᄋᄐ", ᅋ = "ᄋᄑ", ꥷ = "ᄋᄒ", ᅆ = "ᄋᅀ", ᇲ = "ᄋᅀ", ㆃ = "ᄋᅀ", ퟷ = "ᄌᄇ", ퟸ = "ᄌᄇᄇ", ᅍ = "ᄌᄋ", ᄍ = "ᄌᄌ", ㅉ = "ᄌᄌ", ퟹ = "ᄌᄌ", ꥸ = "ᄌᄌᄒ", ᅒ = "ᄎᄏ", ᅓ = "ᄎᄒ", ꥹ = "ᄐᄐ", ᅖ = "ᄑᄇ", ᇳ = "ᄑᄇ", ퟺ = "ᄑᄉ", ᅗ = "ᄑᄋ", ㆄ = "ᄑᄋ", ᇴ = "ᄑᄋ", ퟻ = "ᄑᄐ", ꥺ = "ᄑᄒ", ᇵ = "ᄒᄂ", ᇶ = "ᄒᄅ", ᇷ = "ᄒᄆ", ᇸ = "ᄒᄇ", ꥻ = "ᄒᄉ", ᅘ = "ᄒᄒ", ㆅ = "ᄒᄒ", ᄽ = "ᄼᄼ", ᄿ = "ᄾᄾ", ퟳ = "ᅀᄇ", ퟴ = "ᅀᄇᄋ", ퟵ = "ᅌᄆ", ퟶ = "ᅌᄒ", ᅏ = "ᅎᅎ", ᅑ = "ᅐᅐ", ꥼ = "ᅙᅙ", ᆣ = "ᅡー", ᅶ = "ᅡᅩ", ᅷ = "ᅡᅮ", ᅢ = "ᅡ丨", ㅐ = "ᅡ丨", ᅸ = "ᅣᅩ", ᅹ = "ᅣᅭ", ᆤ = "ᅣᅮ", ᅤ = "ᅣ丨", ㅒ = "ᅣ丨", ᅼ = "ᅥー", ᅺ = "ᅥᅩ", ᅻ = "ᅥᅮ", ᅦ = "ᅥ丨", ㅔ = "ᅥ丨", ᆥ = "ᅧᅣ", ᅽ = "ᅧᅩ", ᅾ = "ᅧᅮ", ᅨ = "ᅧ丨", ㅖ = "ᅧ丨", ᅪ = "ᅩᅡ", ㅘ = "ᅩᅡ", ᅫ = "ᅩᅡ丨", ㅙ = "ᅩᅡ丨", ᆦ = "ᅩᅣ", ᆧ = "ᅩᅣ丨", ᅿ = "ᅩᅥ", ᆀ = "ᅩᅥ丨", ힰ = "ᅩᅧ", ᆁ = "ᅩᅧ丨", ᆂ = "ᅩᅩ", ힱ = "ᅩᅩ丨", ᆃ = "ᅩᅮ", ᅬ = "ᅩ丨", ㅚ = "ᅩ丨", ힲ = "ᅭᅡ", ힳ = "ᅭᅡ丨", ᆄ = "ᅭᅣ", ㆇ = "ᅭᅣ", ᆆ = "ᅭᅣ", ᆅ = "ᅭᅣ丨", ㆈ = "ᅭᅣ丨", ힴ = "ᅭᅥ", ᆇ = "ᅭᅩ", ᆈ = "ᅭ丨", ㆉ = "ᅭ丨", ᆉ = "ᅮᅡ", ᆊ = "ᅮᅡ丨", ᅯ = "ᅮᅥ", ㅝ = "ᅮᅥ", ᆋ = "ᅮᅥー", ᅰ = "ᅮᅥ丨", ㅞ = "ᅮᅥ丨", ힵ = "ᅮᅧ", ᆌ = "ᅮᅧ丨", ᆍ = "ᅮᅮ", ᅱ = "ᅮ丨", ㅟ = "ᅮ丨", ힶ = "ᅮ丨丨", ᆎ = "ᅲᅡ", ힷ = "ᅲᅡ丨", ᆏ = "ᅲᅥ", ᆐ = "ᅲᅥ丨", ᆑ = "ᅲᅧ", ㆊ = "ᅲᅧ", ᆒ = "ᅲᅧ丨", ㆋ = "ᅲᅧ丨", ힸ = "ᅲᅩ", ᆓ = "ᅲᅮ", ᆔ = "ᅲ丨", ㆌ = "ᅲ丨", ퟅ = "ᆞᅡ", ᆟ = "ᆞᅥ", ퟆ = "ᆞᅥ丨", ᆠ = "ᆞᅮ", ᆢ = "ᆞᆞ", ᆡ = "ᆞ丨", ㆎ = "ᆞ丨", 𑫦 = "𑫥𑫯", 𑫨 = "𑫥𑫥", 𑫩 = "𑫥𑫥𑫯", 𑫪 = "𑫥𑫥𑫰", 𑫧 = "𑫥𑫰", 𑫴 = "𑫳𑫯", 𑫶 = "𑫳𑫳", 𑫷 = "𑫳𑫳𑫯", 𑫸 = "𑫳𑫳𑫰", 𑫵 = "𑫳𑫰", 𑫬 = "𑫫𑫯", 𑫭 = "𑫫𑫫", 𑫮 = "𑫫𑫫𑫯", Ꚛ = "𐊨", ꞛ = "𐐺", Ꞛ = "𐐒", 𐏑 = "𐎂", 𐏓 = "𐎓", 𒀸 = "𐎚", 𓋹 = "𐦞", ᆜ = "丨ー", ᆘ = "丨ᅡ", ᆙ = "丨ᅣ", ힽ = "丨ᅣᅩ", ힾ = "丨ᅣ丨", ힿ = "丨ᅧ", ퟀ = "丨ᅧ丨", ᆚ = "丨ᅩ", ퟁ = "丨ᅩ丨", ퟂ = "丨ᅭ", ᆛ = "丨ᅮ", ퟃ = "丨ᅲ", ᆝ = "丨ᆞ", ퟄ = "丨丨", 𠄢 = "𠄢", 𠔜 = "𠔜", 𠔥 = "𠔥", 𠕋 = "𠕋", 𠘺 = "𠘺", 𠠄 = "𠠄", 𠣞 = "𠣞", 𠨬 = "𠨬", 𠭣 = "𠭣", 𡓤 = "𡓤", 𡚨 = "𡚨", 𡛪 = "𡛪", 𡧈 = "𡧈", 𡬘 = "𡬘", 𡴋 = "𡴋", 𡷤 = "𡷤", 𡷦 = "𡷦", 𢆃 = "𢆃", 𢆟 = "𢆟", 𢌱 = "𢌱", 𢌱 = "𢌱", 𢛔 = "𢛔", 𢡄 = "𢡄", 𢡊 = "𢡊", 𢬌 = "𢬌", 𢯱 = "𢯱", 𣀊 = "𣀊", 𣊸 = "𣊸", 𣍟 = "𣍟", 𣎓 = "𣎓", 𣎜 = "𣎜", 𣏃 = "𣏃", 𣏕 = "𣏕", 𣑭 = "𣑭", 𣚣 = "𣚣", 𣢧 = "𣢧", 𣪍 = "𣪍", 𣫺 = "𣫺", 𣲼 = "𣲼", 𣴞 = "𣴞", 𣻑 = "𣻑", 𣽞 = "𣽞", 𣾎 = "𣾎", 𤉣 = "𤉣", 𤋮 = "𤋮", 𤎫 = "𤎫", 𤘈 = "𤘈", 𤜵 = "𤜵", 𤠔 = "𤠔", 𤰶 = "𤰶", 𤲒 = "𤲒", 𤾡 = "𤾡", 𤾸 = "𤾸", 𥁄 = "𥁄", 𥃲 = "𥃲", 𥃳 = "𥃳", 𥄙 = "𥄙", 𥄳 = "𥄳", 𥉉 = "𥉉", 𥐝 = "𥐝", 𥘦 = "𥘦", 𥚚 = "𥚚", 𥛅 = "𥛅", 𥥼 = "𥥼", 𥪧 = "𥪧", 𥪧 = "𥪧", 𥮫 = "𥮫", 𥲀 = "𥲀", 𥳐 = "𥳐", 𥾆 = "𥾆", 𦇚 = "𦇚", 𦈨 = "𦈨", 𦉇 = "𦉇", 𦋙 = "𦋙", 𦌾 = "𦌾", 𦓚 = "𦓚", 𦔣 = "𦔣", 𦖨 = "𦖨", 𦞧 = "𦞧", 𦞵 = "𦞵", 𦬼 = "𦬼", 𦰶 = "𦰶", 𦳕 = "𦳕", 𦵫 = "𦵫", 𦼬 = "𦼬", 𦾱 = "𦾱", 𧃒 = "𧃒", 𧏊 = "𧏊", 𧙧 = "𧙧", 𧢮 = "𧢮", 𧥦 = "𧥦", 𧲨 = "𧲨", 𧻓 = "𧻓", 𧼯 = "𧼯", 𨗒 = "𨗒", 𨗭 = "𨗭", 𨜮 = "𨜮", 𨯺 = "𨯺", 𨵷 = "𨵷", 𩅅 = "𩅅", 𩇟 = "𩇟", 𩈚 = "𩈚", 𩐊 = "𩐊", 𩒖 = "𩒖", 𩖶 = "𩖶", 𩬰 = "𩬰", 𪃎 = "𪃎", 𪄅 = "𪄅", 𪈎 = "𪈎", 𪊑 = "𪊑", 𪎒 = "𪎒", 𪘀 = "𪘀", data_default = {
		0: "O",
		1: "l",
		"֭": "֖",
		"֮": "֘",
		"֨": "֙",
		"֤": "֚",
		"᪴": "ۛ",
		"⃛": "ۛ",
		"ؙ": "̓",
		"ࣳ": "̓",
		"̓": "̓",
		"̕": "̓",
		"ُ": "̓",
		"ٝ": "̔",
		"֜": "́",
		"֝": "́",
		"ؘ": "́",
		"݇": "́",
		"́": "́",
		"॔": "́",
		"َ": "́",
		"̀": "̀",
		"॓": "̀",
		"̌": "̆",
		"꙼": "̆",
		"٘": "̆",
		"ٚ": "̆",
		"ͮ": "̆",
		"ۨ": "̆̇",
		"̐": "̆̇",
		"ँ": "̆̇",
		"ঁ": "̆̇",
		"ઁ": "̆̇",
		"ଁ": "̆̇",
		"ఀ": "̆̇",
		"ಁ": "̆̇",
		"ഁ": "̆̇",
		"𑒿": "̆̇",
		"᳐": "̂",
		"̑": "̂",
		"ٛ": "̂",
		"߮": "̂",
		"꛰": "̂",
		"֯": "̊",
		"۟": "̊",
		"៓": "̊",
		"゚": "̊",
		"ْ": "̊",
		"ஂ": "̊",
		"ံ": "̊",
		"ំ": "̊",
		"𑌀": "̊",
		"ํ": "̊",
		"ໍ": "̊",
		"ͦ": "̊",
		"ⷪ": "̊",
		"࣫": "̈",
		"߳": "̈",
		"ً": "̋",
		"ࣰ": "̋",
		"͂": "̃",
		"ٓ": "̃",
		"ׄ": "̇",
		"۬": "̇",
		"݀": "̇",
		"࣪": "̇",
		"݁": "̇",
		"͘": "̇",
		"ֹ": "̇",
		"ֺ": "̇",
		"ׂ": "̇",
		"ׁ": "̇",
		"߭": "̇",
		"ं": "̇",
		"ਂ": "̇",
		"ં": "̇",
		"்": "̇",
		"̷": "̸",
		"᪷": "̨",
		"̢": "̨",
		"ͅ": "̨",
		"᳒": "̄",
		"̅": "̄",
		"ٙ": "̄",
		"߫": "̄",
		"꛱": "̄",
		"᳚": "̎",
		"ٗ": "̒",
		"͗": "͐",
		"ࣿ": "͐",
		"ࣸ": "͐",
		"ऀ": "͒",
		"᳭": "̖",
		"᳜": "̩",
		"ٖ": "̩",
		"᳕": "̫",
		"͇": "̳",
		"ࣹ": "͔",
		"ࣺ": "͕",
		゛: "ﾞ",
		゜: "ﾟ",
		"̶": "̵",
		"〬": "̉",
		"ׅ": "̣",
		"࣭": "̣",
		"᳝": "̣",
		"ִ": "̣",
		"ٜ": "̣",
		"़": "̣",
		"়": "̣",
		"਼": "̣",
		"઼": "̣",
		"଼": "̣",
		"𑇊": "̣",
		"𑓃": "̣",
		"𐨺": "̣",
		"࣮": "̤",
		"᳞": "̤",
		"༷": "̥",
		"〭": "̥",
		"̧": "̦",
		"̡": "̦",
		"̹": "̦",
		"᳙": "̭",
		"᳘": "̮",
		"॒": "̱",
		"̠": "̱",
		"ࣱ": "ٌ",
		"ࣨ": "ٌ",
		"ࣥ": "ٌ",
		ﱞ,
		"ࣲ": "ٍ",
		ﱟ,
		ﳲ,
		ﱠ,
		ﳳ,
		ﱡ,
		"ؚ": "ِ",
		"̗": "ِ",
		ﳴ,
		ﱢ,
		ﱣ,
		"ٟ": "ٕ",
		"̍": "ٰ",
		"݂": "ܼ",
		"ਃ": "ঃ",
		"ః": "ঃ",
		"ಃ": "ঃ",
		"ഃ": "ঃ",
		"ඃ": "ঃ",
		"း": "ঃ",
		"𑓁": "ঃ",
		"់": "่",
		"່": "่",
		"້": "้",
		"໊": "๊",
		"໋": "๋",
		"꙯": "⃩",
		"\u2028": " ",
		"\u2029": " ",
		" ": " ",
		" ": " ",
		" ": " ",
		" ": " ",
		" ": " ",
		" ": " ",
		" ": " ",
		" ": " ",
		" ": " ",
		" ": " ",
		" ": " ",
		" ": " ",
		"\xA0": " ",
		" ": " ",
		" ": " ",
		ߺ: "_",
		"﹍": "_",
		"﹎": "_",
		"﹏": "_",
		"‐": "-",
		"‑": "-",
		"‒": "-",
		"–": "-",
		"﹘": "-",
		"۔": "-",
		"⁃": "-",
		"˗": "-",
		"−": "-",
		"➖": "-",
		Ⲻ: "-",
		"⨩": "-̓",
		"⸚": "-̈",
		"﬩": "-̇",
		"∸": "-̇",
		"⨪": "-̣",
		"꓾": "-.",
		"～": "〜",
		"؍": ",",
		"٫": ",",
		"‚": ",",
		"¸": ",",
		ꓹ: ",",
		"⸲": "،",
		"٬": "،",
		";": ";",
		"⸵": "؛",
		"ः": ":",
		"ઃ": ":",
		"：": ":",
		"։": ":",
		"܃": ":",
		"܄": ":",
		"᛬": ":",
		"︰": ":",
		"᠃": ":",
		"᠉": ":",
		"⁚": ":",
		"׃": ":",
		"˸": ":",
		"꞉": ":",
		"∶": ":",
		ː: ":",
		ꓽ: ":",
		"⩴": "::=",
		"⧴": ":→",
		"！": "!",
		ǃ: "!",
		ⵑ: "!",
		"‼": "!!",
		"⁉": "!?",
		ʔ: "?",
		Ɂ: "?",
		ॽ: "?",
		Ꭾ: "?",
		ꛫ: "?",
		"⁈": "?!",
		"⁇": "??",
		"⸮": "؟",
		"𝅭": ".",
		"․": ".",
		"܁": ".",
		"܂": ".",
		"꘎": ".",
		"𐩐": ".",
		"٠": ".",
		"۰": ".",
		ꓸ: ".",
		ꓻ: ".,",
		"‥": "..",
		ꓺ: "..",
		"…": "...",
		"꛴": "꛳꛳",
		"・": "·",
		"･": "·",
		"᛫": "·",
		"·": "·",
		"⸱": "·",
		"𐄁": "·",
		"•": "·",
		"‧": "·",
		"∙": "·",
		"⋅": "·",
		ꞏ: "·",
		ᐧ: "·",
		"⋯": "···",
		ⵈ,
		ᑄ: "·<",
		"⋗": "·>",
		ᐷ: "·>",
		ᑀ: "·>",
		ᔯ: "·4",
		ᑾ: "·b",
		ᒀ,
		ᑺ: "·d",
		ᒘ: "·J",
		ᒶ: "·L",
		ᑶ: "·P",
		ᑗ: "·U",
		ᐺ: "·V",
		ᐼ,
		ᒮ,
		ᐎ,
		ᑙ,
		ᐌ,
		ᐐ,
		ᐒ,
		ᐔ,
		ᐗ,
		ᐙ,
		ᐾ,
		ᑂ,
		ᑆ,
		ᑛ,
		ᑔ,
		ᑝ,
		ᑟ,
		ᑡ,
		ᑣ,
		ᑴ,
		ᑸ,
		ᑼ,
		ᒒ,
		ᒔ,
		ᒖ,
		ᒚ,
		ᒜ,
		ᒞ,
		ᒬ,
		ᒰ,
		ᒲ,
		ᒴ,
		ᒸ,
		ᓉ,
		ᣆ,
		ᣈ,
		ᣊ,
		ᣌ,
		ᓋ,
		ᓍ,
		ᓜ,
		ᓞ,
		ᓠ,
		ᓢ,
		ᓤ,
		ᓦ,
		ᓨ,
		ᓶ,
		ᓸ,
		ᓺ,
		ᓼ,
		ᓾ,
		ᔀ,
		ᔂ,
		ᔗ,
		ᔙ,
		ᔛ,
		ᔝ,
		ᔟ,
		ᔡ,
		ᔣ,
		ᔱ,
		ᔳ,
		ᔵ,
		ᔷ,
		ᔹ,
		ᔻ,
		ᣎ,
		ᣏ,
		ᣐ,
		ᣑ,
		ᣒ,
		ᣓ,
		ᕎ,
		ᕛ,
		ᕨ,
		ᢳ,
		ᢶ,
		ᢹ,
		ᣂ,
		"꠰": "।",
		"॥": "।।",
		"᰼": "᰻᰻",
		"။": "၊၊",
		"᪩": "᪨᪨",
		"᪫": "᪪᪨",
		"᭟": "᭞᭞",
		"𐩗": "𐩖𐩖",
		"𑑌": "𑑋𑑋",
		"𑙂": "𑙁𑙁",
		"𑱂": "𑱁𑱁",
		"᱿": "᱾᱾",
		"՝": "'",
		"＇": "'",
		"‘": "'",
		"’": "'",
		"‛": "'",
		"′": "'",
		"‵": "'",
		"՚": "'",
		"׳": "'",
		"`": "'",
		"`": "'",
		"｀": "'",
		"´": "'",
		"΄": "'",
		"´": "'",
		"᾽": "'",
		"᾿": "'",
		"῾": "'",
		ʹ: "'",
		ʹ: "'",
		ˈ: "'",
		ˊ: "'",
		ˋ: "'",
		"˴": "'",
		ʻ: "'",
		ʽ: "'",
		ʼ: "'",
		ʾ: "'",
		ꞌ: "'",
		י: "'",
		ߴ: "'",
		ߵ: "'",
		ᑊ: "'",
		ᛌ: "'",
		"𖽑": "'",
		"𖽒": "'",
		"᳓": "''",
		"\"": "''",
		"＂": "''",
		"“": "''",
		"”": "''",
		"‟": "''",
		"″": "''",
		"‶": "''",
		"〃": "''",
		"״": "''",
		"˝": "''",
		ʺ: "''",
		"˶": "''",
		ˮ: "''",
		ײ: "''",
		"‴": "'''",
		"‷": "'''",
		"⁗": "''''",
		Ɓ: "'B",
		Ɗ: "'D",
		ŉ: "'n",
		Ƥ: "'P",
		Ƭ: "'T",
		Ƴ: "'Y",
		"［": "(",
		"❨": "(",
		"❲": "(",
		"〔": "(",
		"﴾": "(",
		"⸨": "((",
		"㈠": "(ー)",
		"⑵": "(2)",
		"⒇": "(2O)",
		"⑶": "(3)",
		"⑷": "(4)",
		"⑸": "(5)",
		"⑹": "(6)",
		"⑺": "(7)",
		"⑻": "(8)",
		"⑼": "(9)",
		"⒜": "(a)",
		"🄐": "(A)",
		"⒝": "(b)",
		"🄑": "(B)",
		"⒞": "(c)",
		"🄒": "(C)",
		"⒟": "(d)",
		"🄓": "(D)",
		"⒠": "(e)",
		"🄔": "(E)",
		"⒡": "(f)",
		"🄕": "(F)",
		"⒢": "(g)",
		"🄖": "(G)",
		"⒣": "(h)",
		"🄗": "(H)",
		"⒤": "(i)",
		"⒥": "(j)",
		"🄙": "(J)",
		"⒦": "(k)",
		"🄚": "(K)",
		"⑴": "(l)",
		"🄘": "(l)",
		"⒧": "(l)",
		"🄛": "(L)",
		"⑿": "(l2)",
		"⒀": "(l3)",
		"⒁": "(l4)",
		"⒂": "(l5)",
		"⒃": "(l6)",
		"⒄": "(l7)",
		"⒅": "(l8)",
		"⒆": "(l9)",
		"⑾": "(ll)",
		"⑽": "(lO)",
		"🄜": "(M)",
		"⒩": "(n)",
		"🄝": "(N)",
		"⒪": "(o)",
		"🄞": "(O)",
		"⒫": "(p)",
		"🄟": "(P)",
		"⒬": "(q)",
		"🄠": "(Q)",
		"⒭": "(r)",
		"🄡": "(R)",
		"⒨": "(rn)",
		"⒮": "(s)",
		"🄢": "(S)",
		"🄪": "(S)",
		"⒯": "(t)",
		"🄣": "(T)",
		"⒰": "(u)",
		"🄤": "(U)",
		"⒱": "(v)",
		"🄥": "(V)",
		"⒲": "(w)",
		"🄦": "(W)",
		"⒳": "(x)",
		"🄧": "(X)",
		"⒴": "(y)",
		"🄨": "(Y)",
		"⒵": "(z)",
		"🄩": "(Z)",
		"㈀": "(ᄀ)",
		"㈎": "(가)",
		"㈁": "(ᄂ)",
		"㈏": "(나)",
		"㈂": "(ᄃ)",
		"㈐": "(다)",
		"㈃": "(ᄅ)",
		"㈑": "(라)",
		"㈄": "(ᄆ)",
		"㈒": "(마)",
		"㈅": "(ᄇ)",
		"㈓": "(바)",
		"㈆": "(ᄉ)",
		"㈔": "(사)",
		"㈇": "(ᄋ)",
		"㈕": "(아)",
		"㈝": "(오전)",
		"㈞": "(오후)",
		"㈈": "(ᄌ)",
		"㈖": "(자)",
		"㈜": "(주)",
		"㈉": "(ᄎ)",
		"㈗": "(차)",
		"㈊": "(ᄏ)",
		"㈘": "(카)",
		"㈋": "(ᄐ)",
		"㈙": "(타)",
		"㈌": "(ᄑ)",
		"㈚": "(파)",
		"㈍": "(ᄒ)",
		"㈛": "(하)",
		"㈦": "(七)",
		"㈢": "(三)",
		"🉁": "(三)",
		"㈨": "(九)",
		"㈡": "(二)",
		"🉂": "(二)",
		"㈤": "(五)",
		"㈹": "(代)",
		"㈽": "(企)",
		"㉁": "(休)",
		"㈧": "(八)",
		"㈥": "(六)",
		"㈸": "(労)",
		"🉇": "(勝)",
		"㈩": "(十)",
		"㈿": "(協)",
		"㈴": "(名)",
		"㈺": "(呼)",
		"㈣": "(四)",
		"㈯": "(土)",
		"㈻": "(学)",
		"🉃": "(安)",
		"🉅": "(打)",
		"🉈": "(敗)",
		"㈰": "(日)",
		"㈪": "(月)",
		"㈲": "(有)",
		"㈭": "(木)",
		"🉀": "(本)",
		"㈱": "(株)",
		"㈬": "(水)",
		"㈫": "(火)",
		"🉄": "(点)",
		"㈵": "(特)",
		"🉆": "(盗)",
		"㈼": "(監)",
		"㈳": "(社)",
		"㈷": "(祝)",
		"㉀": "(祭)",
		"㉂": "(自)",
		"㉃": "(至)",
		"㈶": "(財)",
		"㈾": "(資)",
		"㈮": "(金)",
		"］": ")",
		"❩": ")",
		"❳": ")",
		"〕": ")",
		"﴿": ")",
		"⸩": "))",
		"❴": "{",
		"𝄔": "{",
		"❵": "}",
		"〚": "⟦",
		"〛": "⟧",
		"⟨": "❬",
		"〈": "❬",
		"〈": "❬",
		"㇛": "❬",
		く: "❬",
		𡿨: "❬",
		"⟩": "❭",
		"〉": "❭",
		"〉": "❭",
		"＾": "︿",
		"⸿": "¶",
		"⁎": "*",
		"٭": "*",
		"∗": "*",
		𐌟: "*",
		"᜵": "/",
		"⁁": "/",
		"∕": "/",
		"⁄": "/",
		"╱": "/",
		"⟋": "/",
		"⧸": "/",
		"𝈺": "/",
		"㇓": "/",
		〳: "/",
		Ⳇ: "/",
		ノ: "/",
		丿: "/",
		"⼃": "/",
		"⧶": "/̄",
		"⫽": "//",
		"⫻": "///",
		"＼": "\\",
		"﹨": "\\",
		"∖": "\\",
		"⟍": "\\",
		"⧵": "\\",
		"⧹": "\\",
		"𝈏": "\\",
		"𝈻": "\\",
		"㇔": "\\",
		丶: "\\",
		"⼂": "\\",
		"⳹": "\\\\",
		"⑊": "\\\\",
		"⟈": "\\ᑕ",
		ꝸ: "&",
		"૰": "॰",
		"𑂻": "॰",
		"𑇇": "॰",
		"⚬": "॰",
		"𑇛": "꣼",
		"៙": "๏",
		"៕": "๚",
		"៚": "๛",
		"༌": "་",
		"༎": "།།",
		"˄": "^",
		ˆ: "^",
		"꙾": "ˇ",
		"˘": "ˇ",
		"‾": "ˉ",
		"﹉": "ˉ",
		"﹊": "ˉ",
		"﹋": "ˉ",
		"﹌": "ˉ",
		"¯": "ˉ",
		"￣": "ˉ",
		"▔": "ˉ",
		ъ: "ˉb",
		ꙑ,
		"͵": "ˏ",
		"˻": "˪",
		"꜖": "˪",
		"꜔": "˫",
		"。": "˳",
		"⸰": "°",
		"˚": "°",
		"∘": "°",
		"○": "°",
		"◦": "°",
		"⍜": "°̲",
		"⍤": "°̈",
		"℃": "°C",
		"℉": "°F",
		"௵": "௳",
		"༛": "༚༚",
		"༟": "༚༝",
		"࿎": "༝༚",
		"༞": "༝༝",
		"Ⓒ": "©",
		"Ⓡ": "®",
		"Ⓟ": "℗",
		"𝈛": "⅄",
		"⯬": "↞",
		"⯭": "↟",
		"⯮": "↠",
		"⯯": "↡",
		"↵": "↲",
		"⥥": "⇃⇂",
		"⥯": "⇃ᛚ",
		"𝛛": "∂",
		"𝜕": "∂",
		"𝝏": "∂",
		"𝞉": "∂",
		"𝟃": "∂",
		"𞣌": "∂",
		"𞣍": "∂̵",
		ð,
		"⌀": "∅",
		"𝛁": "∇",
		"𝛻": "∇",
		"𝜵": "∇",
		"𝝯": "∇",
		"𝞩": "∇",
		𑢨: "∇",
		"⍢": "∇̈",
		"⍫": "∇̴",
		"█": "∎",
		"■": "∎",
		"⨿": "∐",
		"᛭": "+",
		"➕": "+",
		𐊛: "+",
		"⨣": "+̂",
		"⨢": "+̊",
		"⨤": "+̃",
		"∔": "+̇",
		"⨥": "+̣",
		"⨦": "+̰",
		"⨧": "+₂",
		"➗": "÷",
		"‹": "<",
		"❮": "<",
		"˂": "<",
		"𝈶": "<",
		ᐸ: "<",
		ᚲ: "<",
		"⋖": "<·",
		Ⲵ: "<·",
		ᑅ: "<·",
		"≪": "<<",
		"⋘": "<<<",
		"᐀": "=",
		"⹀": "=",
		"゠": "=",
		"꓿": "=",
		"≚": "=̆",
		"≙": "=̂",
		"≗": "=̊",
		"≐": "=̇",
		"≑": "=̣̇",
		"⩮": "=⃰",
		"⩵": "==",
		"⩶": "===",
		"≞": "=ͫ",
		"›": ">",
		"❯": ">",
		"˃": ">",
		"𝈷": ">",
		ᐳ: ">",
		𖼿: ">",
		ᑁ: ">·",
		"⪥": "><",
		"≫": ">>",
		"⨠": ">>",
		"⋙": ">>>",
		"⁓": "~",
		"˜": "~",
		"῀": "~",
		"∼": "~",
		"⍨": "~̈",
		"⸞": "~̇",
		"⩪": "~̇",
		"⸟": "~̣",
		"𞣈": "∠",
		"⋀": "∧",
		"∯": "∮∮",
		"∰": "∮∮∮",
		"⸫": "∴",
		"⸪": "∵",
		"⸬": "∷",
		"𑇞": "≈",
		"♎": "≏",
		"🝞": "≏",
		"≣": "≡",
		"⨃": "⊍",
		"⨄": "⊎",
		"𝈸": "⊏",
		"𝈹": "⊐",
		"⨅": "⊓",
		"⨆": "⊔",
		"⨂": "⊗",
		"⍟": "⊛",
		"🝱": "⊠",
		"🝕": "⊡",
		"◁": "⊲",
		"▷": "⊳",
		"⍣": "⋆̈",
		"︴": "⌇",
		"◠": "⌒",
		"⨽": "⌙",
		"⌥": "⌤",
		"⧇": "⌻",
		"◎": "⌾",
		"⦾": "⌾",
		"⧅": "⍂",
		"⦰": "⍉",
		"⏃": "⍋",
		"⏂": "⍎",
		"⏁": "⍕",
		"⏆": "⍭",
		"☸": "⎈",
		"︵": "⏜",
		"︶": "⏝",
		"︷": "⏞",
		"︸": "⏟",
		"︹": "⏠",
		"︺": "⏡",
		"▱": "⏥",
		"⏼": "⏻",
		"︱": "│",
		"｜": "│",
		"┃": "│",
		"┏": "┌",
		"┣": "├",
		"▐": "▌",
		"▗": "▖",
		"▝": "▘",
		"☐": "□",
		"￭": "▪",
		"▸": "▶",
		"►": "▶",
		"⳩": "☧",
		"🜊": "☩",
		"🌒": "☽",
		"🌙": "☽",
		"⏾": "☾",
		"🌘": "☾",
		"⧙": "⦚",
		"🜺": "⧟",
		"⨾": "⨟",
		"𐆠": "⳨",
		"♩": "𝅘𝅥",
		"♪": "𝅘𝅥𝅮",
		"⓪": "🄍",
		"↺": "🄎",
		"˙": "ॱ",
		ൎ: "ॱ",
		"－": "ー",
		"—": "ー",
		"―": "ー",
		"─": "ー",
		"━": "ー",
		"㇐": "ー",
		ꟷ: "ー",
		ᅳ: "ー",
		ㅡ: "ー",
		一: "ー",
		"⼀": "ー",
		ᆖ,
		ힹ,
		ힺ,
		ힻ,
		ힼ,
		ᆕ,
		ᅴ,
		ㅢ,
		ᆗ,
		"🄏": "$⃠",
		"₤": "£",
		"〒": "₸",
		"〶": "₸",
		"᭜": "᭐",
		"꧆": "꧐",
		"𑓑": "১",
		"೧": "౧",
		ၥ: "၁",
		"①": "➀",
		"⑩": "➉",
		"⏨": "₁₀",
		"𝟐": "2",
		"𝟚": "2",
		"𝟤": "2",
		"𝟮": "2",
		"𝟸": "2",
		"🯲": "2",
		Ꝛ: "2",
		Ƨ: "2",
		Ϩ: "2",
		Ꙅ: "2",
		ᒿ: "2",
		ꛯ: "2",
		ꧏ: "٢",
		"۲": "٢",
		"૨": "२",
		"𑓒": "২",
		"೨": "౨",
		"②": "➁",
		ƻ: "2̵",
		"🄃": "2,",
		"⒉": "2.",
		"㏵": "22日",
		"㍮": "22点",
		"㏶": "23日",
		"㍯": "23点",
		"㏷": "24日",
		"㍰": "24点",
		"㏸": "25日",
		"㏹": "26日",
		"㏺": "27日",
		"㏻": "28日",
		"㏼": "29日",
		"㏴": "2l日",
		"㍭": "2l点",
		"⒛": "2O.",
		"㏳": "2O日",
		"㍬": "2O点",
		"෩": "෨ා",
		"෯": "෨ී",
		"㏡": "2日",
		"㋁": "2月",
		"㍚": "2点",
		"𝈆": "3",
		"𝟑": "3",
		"𝟛": "3",
		"𝟥": "3",
		"𝟯": "3",
		"𝟹": "3",
		"🯳": "3",
		Ɜ: "3",
		Ȝ: "3",
		Ʒ: "3",
		Ꝫ: "3",
		Ⳍ: "3",
		З: "3",
		Ӡ: "3",
		𖼻: "3",
		𑣊: "3",
		"۳": "٣",
		"𞣉": "٣",
		"૩": "३",
		"③": "➂",
		Ҙ: "3̦",
		"🄄": "3,",
		"⒊": "3.",
		"㏾": "3l日",
		"㏽": "3O日",
		"㏢": "3日",
		"㋂": "3月",
		"㍛": "3点",
		"𝟒": "4",
		"𝟜": "4",
		"𝟦": "4",
		"𝟰": "4",
		"𝟺": "4",
		"🯴": "4",
		Ꮞ: "4",
		𑢯: "4",
		"۴": "٤",
		"૪": "४",
		"④": "➃",
		"🄅": "4,",
		"⒋": "4.",
		ᔰ: "4·",
		"㏣": "4日",
		"㋃": "4月",
		"㍜": "4点",
		"𝟓": "5",
		"𝟝": "5",
		"𝟧": "5",
		"𝟱": "5",
		"𝟻": "5",
		"🯵": "5",
		Ƽ: "5",
		𑢻: "5",
		"⑤": "➄",
		"🄆": "5,",
		"⒌": "5.",
		"㏤": "5日",
		"㋄": "5月",
		"㍝": "5点",
		"𝟔": "6",
		"𝟞": "6",
		"𝟨": "6",
		"𝟲": "6",
		"𝟼": "6",
		"🯶": "6",
		Ⳓ: "6",
		б: "6",
		Ꮾ: "6",
		𑣕: "6",
		"۶": "٦",
		"𑓖": "৬",
		"⑥": "➅",
		"🄇": "6,",
		"⒍": "6.",
		"㏥": "6日",
		"㋅": "6月",
		"㍞": "6点",
		"𝈒": "7",
		"𝟕": "7",
		"𝟟": "7",
		"𝟩": "7",
		"𝟳": "7",
		"𝟽": "7",
		"🯷": "7",
		𐓒: "7",
		𑣆: "7",
		"⑦": "➆",
		"🄈": "7,",
		"⒎": "7.",
		"㏦": "7日",
		"㋆": "7月",
		"㍟": "7点",
		"ଃ": "8",
		"৪": "8",
		"੪": "8",
		"𞣋": "8",
		"𝟖": "8",
		"𝟠": "8",
		"𝟪": "8",
		"𝟴": "8",
		"𝟾": "8",
		"🯸": "8",
		ȣ: "8",
		Ȣ: "8",
		𐌚: "8",
		"૮": "८",
		"⑧": "➇",
		"🄉": "8,",
		"⒏": "8.",
		"㏧": "8日",
		"㋇": "8月",
		"㍠": "8点",
		"੧": "9",
		"୨": "9",
		"৭": "9",
		"൭": "9",
		"𝟗": "9",
		"𝟡": "9",
		"𝟫": "9",
		"𝟵": "9",
		"𝟿": "9",
		"🯹": "9",
		Ꝯ: "9",
		Ⳋ: "9",
		𑣌: "9",
		𑢬: "9",
		𑣖: "9",
		"१": "٩",
		"𑣤": "٩",
		"۹": "٩",
		"೯": "౯",
		"⑨": "➈",
		"🄊": "9,",
		"⒐": "9.",
		"㏨": "9日",
		"㋈": "9月",
		"㍡": "9点",
		"⍺": "a",
		ａ: "a",
		𝐚: "a",
		𝑎: "a",
		𝒂: "a",
		𝒶: "a",
		𝓪: "a",
		𝔞: "a",
		𝕒: "a",
		𝖆: "a",
		𝖺: "a",
		𝗮: "a",
		𝘢: "a",
		𝙖: "a",
		𝚊: "a",
		ɑ: "a",
		α: "a",
		𝛂: "a",
		𝛼: "a",
		𝜶: "a",
		𝝰: "a",
		𝞪: "a",
		а: "a",
		"ⷶ": "ͣ",
		Ａ: "A",
		𝐀: "A",
		𝐴: "A",
		𝑨: "A",
		𝒜: "A",
		𝓐: "A",
		𝔄: "A",
		𝔸: "A",
		𝕬: "A",
		𝖠: "A",
		𝗔: "A",
		𝘈: "A",
		𝘼: "A",
		𝙰: "A",
		Α: "A",
		𝚨: "A",
		𝛢: "A",
		𝜜: "A",
		𝝖: "A",
		𝞐: "A",
		А: "A",
		Ꭺ: "A",
		ᗅ: "A",
		ꓮ: "A",
		𖽀: "A",
		𐊠: "A",
		"⍶": "a̲",
		ǎ: "ă",
		Ǎ: "Ă",
		ȧ: "å",
		Ȧ: "Å",
		ẚ: "ả",
		"℀": "a/c",
		"℁": "a/s",
		ꜳ: "aa",
		Ꜳ: "AA",
		æ: "ae",
		ӕ: "ae",
		Æ: "AE",
		Ӕ: "AE",
		ꜵ: "ao",
		Ꜵ: "AO",
		"🜇": "AR",
		ꜷ: "au",
		Ꜷ: "AU",
		ꜹ: "av",
		ꜻ: "av",
		Ꜹ: "AV",
		Ꜻ: "AV",
		ꜽ: "ay",
		Ꜽ: "AY",
		ꭺ: "ᴀ",
		"∀": "Ɐ",
		"𝈗": "Ɐ",
		ᗄ: "Ɐ",
		ꓯ: "Ɐ",
		𐐟: "Ɒ",
		𝐛: "b",
		𝑏: "b",
		𝒃: "b",
		𝒷: "b",
		𝓫: "b",
		𝔟: "b",
		𝕓: "b",
		𝖇: "b",
		𝖻: "b",
		𝗯: "b",
		𝘣: "b",
		𝙗: "b",
		𝚋: "b",
		Ƅ: "b",
		Ь: "b",
		Ꮟ: "b",
		ᑲ: "b",
		ᖯ: "b",
		Ｂ: "B",
		ℬ: "B",
		𝐁: "B",
		𝐵: "B",
		𝑩: "B",
		𝓑: "B",
		𝔅: "B",
		𝔹: "B",
		𝕭: "B",
		𝖡: "B",
		𝗕: "B",
		𝘉: "B",
		𝘽: "B",
		𝙱: "B",
		Ꞵ: "B",
		Β: "B",
		𝚩: "B",
		𝛣: "B",
		𝜝: "B",
		𝝗: "B",
		𝞑: "B",
		В: "B",
		Ᏼ: "B",
		ᗷ: "B",
		ꓐ: "B",
		𐊂: "B",
		𐊡: "B",
		𐌁: "B",
		ɓ: "b̔",
		ᑳ: "ḃ",
		ƃ: "b̄",
		Ƃ: "b̄",
		Б: "b̄",
		ƀ: "b̵",
		ҍ: "b̵",
		Ҍ: "b̵",
		ѣ: "b̵",
		Ѣ: "b̵",
		ᑿ: "b·",
		ᒁ,
		ᒈ: "b'",
		Ы: "bl",
		в: "ʙ",
		ᏼ: "ʙ",
		ｃ: "c",
		ⅽ: "c",
		𝐜: "c",
		𝑐: "c",
		𝒄: "c",
		𝒸: "c",
		𝓬: "c",
		𝔠: "c",
		𝕔: "c",
		𝖈: "c",
		𝖼: "c",
		𝗰: "c",
		𝘤: "c",
		𝙘: "c",
		𝚌: "c",
		ᴄ: "c",
		ϲ: "c",
		ⲥ: "c",
		с: "c",
		ꮯ: "c",
		𐐽: "c",
		"ⷭ": "ͨ",
		"🝌": "C",
		"𑣲": "C",
		"𑣩": "C",
		Ｃ: "C",
		Ⅽ: "C",
		ℂ: "C",
		ℭ: "C",
		𝐂: "C",
		𝐶: "C",
		𝑪: "C",
		𝒞: "C",
		𝓒: "C",
		𝕮: "C",
		𝖢: "C",
		𝗖: "C",
		𝘊: "C",
		𝘾: "C",
		𝙲: "C",
		Ϲ: "C",
		Ⲥ: "C",
		С: "C",
		Ꮯ: "C",
		ꓚ: "C",
		𐊢: "C",
		𐌂: "C",
		𐐕: "C",
		𐔜: "C",
		"¢": "c̸",
		ȼ: "c̸",
		"₡": "C⃫",
		"🅮": "C⃠",
		ç: "c̦",
		ҫ: "c̦",
		Ç: "C̦",
		Ҫ: "C̦",
		Ƈ: "C'",
		"℅": "c/o",
		"℆": "c/u",
		"🅭": "㏄	⃝",
		"⋴": "ꞓ",
		ɛ: "ꞓ",
		ε: "ꞓ",
		ϵ: "ꞓ",
		𝛆: "ꞓ",
		𝛜: "ꞓ",
		𝜀: "ꞓ",
		𝜖: "ꞓ",
		𝜺: "ꞓ",
		𝝐: "ꞓ",
		𝝴: "ꞓ",
		𝞊: "ꞓ",
		𝞮: "ꞓ",
		𝟄: "ꞓ",
		ⲉ: "ꞓ",
		є: "ꞓ",
		ԑ: "ꞓ",
		ꮛ: "ꞓ",
		𑣎: "ꞓ",
		𐐩: "ꞓ",
		"€": "Ꞓ",
		Ⲉ: "Ꞓ",
		Є: "Ꞓ",
		"⍷": "ꞓ̲",
		ͽ: "ꜿ",
		Ͽ: "Ꜿ",
		ⅾ: "d",
		ⅆ: "d",
		𝐝: "d",
		𝑑: "d",
		𝒅: "d",
		𝒹: "d",
		𝓭: "d",
		𝔡: "d",
		𝕕: "d",
		𝖉: "d",
		𝖽: "d",
		𝗱: "d",
		𝘥: "d",
		𝙙: "d",
		𝚍: "d",
		ԁ: "d",
		Ꮷ: "d",
		ᑯ: "d",
		ꓒ: "d",
		Ⅾ: "D",
		ⅅ: "D",
		𝐃: "D",
		𝐷: "D",
		𝑫: "D",
		𝒟: "D",
		𝓓: "D",
		𝔇: "D",
		𝔻: "D",
		𝕯: "D",
		𝖣: "D",
		𝗗: "D",
		𝘋: "D",
		𝘿: "D",
		𝙳: "D",
		Ꭰ: "D",
		ᗞ: "D",
		ᗪ: "D",
		ꓓ: "D",
		ɗ: "d̔",
		ɖ: "d̨",
		ƌ: "d̄",
		đ: "d̵",
		Đ: "D̵",
		Ð: "D̵",
		Ɖ: "D̵",
		"₫": "ḏ̵",
		ꝺ: "Ꝺ",
		ᑻ: "d·",
		ᒇ: "d'",
		ʤ: "dȝ",
		ǳ: "dz",
		ʣ: "dz",
		ǲ: "Dz",
		Ǳ: "DZ",
		ǆ: "dž",
		ǅ: "Dž",
		Ǆ: "DŽ",
		ʥ: "dʑ",
		ꭰ: "ᴅ",
		"⸹": "ẟ",
		δ: "ẟ",
		𝛅: "ẟ",
		𝛿: "ẟ",
		𝜹: "ẟ",
		𝝳: "ẟ",
		𝞭: "ẟ",
		ծ: "ẟ",
		ᕷ: "ẟ",
		℮: "e",
		ｅ: "e",
		ℯ: "e",
		ⅇ: "e",
		𝐞: "e",
		𝑒: "e",
		𝒆: "e",
		𝓮: "e",
		𝔢: "e",
		𝕖: "e",
		𝖊: "e",
		𝖾: "e",
		𝗲: "e",
		𝘦: "e",
		𝙚: "e",
		𝚎: "e",
		ꬲ: "e",
		е: "e",
		ҽ: "e",
		"ⷷ": "ͤ",
		"⋿": "E",
		Ｅ: "E",
		ℰ: "E",
		𝐄: "E",
		𝐸: "E",
		𝑬: "E",
		𝓔: "E",
		𝔈: "E",
		𝔼: "E",
		𝕰: "E",
		𝖤: "E",
		𝗘: "E",
		𝘌: "E",
		𝙀: "E",
		𝙴: "E",
		Ε: "E",
		𝚬: "E",
		𝛦: "E",
		𝜠: "E",
		𝝚: "E",
		𝞔: "E",
		Е: "E",
		ⴹ: "E",
		Ꭼ: "E",
		ꓰ: "E",
		𑢦: "E",
		𑢮: "E",
		𐊆: "E",
		ě: "ĕ",
		Ě: "Ĕ",
		ɇ: "e̸",
		Ɇ: "E̸",
		ҿ: "ę",
		ꭼ: "ᴇ",
		ə: "ǝ",
		ә: "ǝ",
		"∃": "Ǝ",
		ⴺ: "Ǝ",
		ꓱ: "Ǝ",
		ɚ,
		ᴔ: "ǝo",
		ꭁ,
		ꭂ,
		Ә: "Ə",
		"𝈡": "Ɛ",
		ℇ: "Ɛ",
		Ԑ: "Ɛ",
		Ꮛ: "Ɛ",
		𖼭: "Ɛ",
		𐐁: "Ɛ",
		ᶟ: "ᵋ",
		ᴈ: "ɜ",
		з: "ɜ",
		ҙ,
		𐑂: "ɞ",
		ꞝ: "ʚ",
		𐐪: "ʚ",
		𝐟: "f",
		𝑓: "f",
		𝒇: "f",
		𝒻: "f",
		𝓯: "f",
		𝔣: "f",
		𝕗: "f",
		𝖋: "f",
		𝖿: "f",
		𝗳: "f",
		𝘧: "f",
		𝙛: "f",
		𝚏: "f",
		ꬵ: "f",
		ꞙ: "f",
		ſ: "f",
		ẝ: "f",
		ք: "f",
		"𝈓": "F",
		ℱ: "F",
		𝐅: "F",
		𝐹: "F",
		𝑭: "F",
		𝓕: "F",
		𝔉: "F",
		𝔽: "F",
		𝕱: "F",
		𝖥: "F",
		𝗙: "F",
		𝘍: "F",
		𝙁: "F",
		𝙵: "F",
		Ꞙ: "F",
		Ϝ: "F",
		𝟊: "F",
		ᖴ: "F",
		ꓝ: "F",
		𑣂: "F",
		𑢢: "F",
		𐊇: "F",
		𐊥: "F",
		𐔥: "F",
		ƒ: "f̦",
		Ƒ: "F̦",
		ᵮ: "f̴",
		"℻": "FAX",
		ﬀ: "ff",
		ﬃ: "ffi",
		ﬄ: "ffl",
		ﬁ: "fi",
		ﬂ: "fl",
		ʩ: "fŋ",
		ᖵ: "Ⅎ",
		ꓞ: "Ⅎ",
		"𝈰": "ꟻ",
		ᖷ: "ꟻ",
		ｇ: "g",
		ℊ: "g",
		𝐠: "g",
		𝑔: "g",
		𝒈: "g",
		𝓰: "g",
		𝔤: "g",
		𝕘: "g",
		𝖌: "g",
		𝗀: "g",
		𝗴: "g",
		𝘨: "g",
		𝙜: "g",
		𝚐: "g",
		ɡ: "g",
		ᶃ: "g",
		ƍ: "g",
		ց: "g",
		𝐆: "G",
		𝐺: "G",
		𝑮: "G",
		𝒢: "G",
		𝓖: "G",
		𝔊: "G",
		𝔾: "G",
		𝕲: "G",
		𝖦: "G",
		𝗚: "G",
		𝘎: "G",
		𝙂: "G",
		𝙶: "G",
		Ԍ: "G",
		Ꮐ: "G",
		Ᏻ: "G",
		ꓖ: "G",
		ᶢ: "ᵍ",
		ɠ: "g̔",
		ǧ: "ğ",
		Ǧ: "Ğ",
		ǵ: "ģ",
		ǥ: "g̵",
		Ǥ: "G̵",
		Ɠ: "G'",
		ԍ: "ɢ",
		ꮐ: "ɢ",
		ᏻ: "ɢ",
		ｈ: "h",
		ℎ: "h",
		𝐡: "h",
		𝒉: "h",
		𝒽: "h",
		𝓱: "h",
		𝔥: "h",
		𝕙: "h",
		𝖍: "h",
		𝗁: "h",
		𝗵: "h",
		𝘩: "h",
		𝙝: "h",
		𝚑: "h",
		һ: "h",
		հ: "h",
		Ꮒ: "h",
		Ｈ: "H",
		ℋ: "H",
		ℌ: "H",
		ℍ: "H",
		𝐇: "H",
		𝐻: "H",
		𝑯: "H",
		𝓗: "H",
		𝕳: "H",
		𝖧: "H",
		𝗛: "H",
		𝘏: "H",
		𝙃: "H",
		𝙷: "H",
		Η: "H",
		𝚮: "H",
		𝛨: "H",
		𝜢: "H",
		𝝜: "H",
		𝞖: "H",
		Ⲏ: "H",
		Н: "H",
		Ꮋ: "H",
		ᕼ: "H",
		ꓧ: "H",
		𐋏: "H",
		ᵸ: "ᴴ",
		ɦ: "h̔",
		ꚕ: "h̔",
		Ᏺ: "h̔",
		Ⱨ: "H̩",
		Ң: "H̩",
		ħ: "h̵",
		ℏ: "h̵",
		ћ: "h̵",
		Ħ: "H̵",
		Ӊ: "H̦",
		Ӈ: "H̦",
		н: "ʜ",
		ꮋ: "ʜ",
		ң,
		ӊ,
		ӈ,
		Ԋ: "Ƕ",
		ꮀ: "ⱶ",
		Ͱ: "Ⱶ",
		Ꭸ: "Ⱶ",
		Ꮀ: "Ⱶ",
		ꚱ: "Ⱶ",
		ꞕ: "ꜧ",
		"˛": "i",
		"⍳": "i",
		ｉ: "i",
		ⅰ: "i",
		ℹ: "i",
		ⅈ: "i",
		𝐢: "i",
		𝑖: "i",
		𝒊: "i",
		𝒾: "i",
		𝓲: "i",
		𝔦: "i",
		𝕚: "i",
		𝖎: "i",
		𝗂: "i",
		𝗶: "i",
		𝘪: "i",
		𝙞: "i",
		𝚒: "i",
		ı: "i",
		𝚤: "i",
		ɪ: "i",
		ɩ: "i",
		ι: "i",
		ι: "i",
		ͺ: "i",
		𝛊: "i",
		𝜄: "i",
		𝜾: "i",
		𝝸: "i",
		𝞲: "i",
		і: "i",
		ꙇ: "i",
		ӏ: "i",
		ꭵ: "i",
		Ꭵ: "i",
		𑣃: "i",
		"ⓛ": "Ⓘ",
		"⍸": "i̲",
		ǐ: "ĭ",
		Ǐ: "Ĭ",
		ɨ: "i̵",
		ᵻ: "i̵",
		ᵼ: "i̵",
		ⅱ: "ii",
		ⅲ: "iii",
		ĳ: "ij",
		ⅳ: "iv",
		ⅸ: "ix",
		ｊ: "j",
		ⅉ: "j",
		𝐣: "j",
		𝑗: "j",
		𝒋: "j",
		𝒿: "j",
		𝓳: "j",
		𝔧: "j",
		𝕛: "j",
		𝖏: "j",
		𝗃: "j",
		𝗷: "j",
		𝘫: "j",
		𝙟: "j",
		𝚓: "j",
		ϳ: "j",
		ј: "j",
		Ｊ: "J",
		𝐉: "J",
		𝐽: "J",
		𝑱: "J",
		𝒥: "J",
		𝓙: "J",
		𝔍: "J",
		𝕁: "J",
		𝕵: "J",
		𝖩: "J",
		𝗝: "J",
		𝘑: "J",
		𝙅: "J",
		𝙹: "J",
		Ʝ: "J",
		Ϳ: "J",
		Ј: "J",
		Ꭻ: "J",
		ᒍ: "J",
		ꓙ: "J",
		ɉ: "j̵",
		Ɉ: "J̵",
		ᒙ: "J·",
		𝚥: "ȷ",
		յ: "ȷ",
		ꭻ: "ᴊ",
		𝐤: "k",
		𝑘: "k",
		𝒌: "k",
		𝓀: "k",
		𝓴: "k",
		𝔨: "k",
		𝕜: "k",
		𝖐: "k",
		𝗄: "k",
		𝗸: "k",
		𝘬: "k",
		𝙠: "k",
		𝚔: "k",
		K: "K",
		Ｋ: "K",
		𝐊: "K",
		𝐾: "K",
		𝑲: "K",
		𝒦: "K",
		𝓚: "K",
		𝔎: "K",
		𝕂: "K",
		𝕶: "K",
		𝖪: "K",
		𝗞: "K",
		𝘒: "K",
		𝙆: "K",
		𝙺: "K",
		Κ: "K",
		𝚱: "K",
		𝛫: "K",
		𝜥: "K",
		𝝟: "K",
		𝞙: "K",
		Ⲕ: "K",
		К: "K",
		Ꮶ: "K",
		ᛕ: "K",
		ꓗ: "K",
		𐔘: "K",
		ƙ: "k̔",
		Ⱪ: "K̩",
		Қ: "K̩",
		"₭": "K̵",
		Ꝁ: "K̵",
		Ҟ: "K̵",
		Ƙ: "K'",
		"׀": "l",
		"|": "l",
		"∣": "l",
		"⏽": "l",
		"￨": "l",
		"١": "l",
		"۱": "l",
		"𐌠": "l",
		"𞣇": "l",
		"𝟏": "l",
		"𝟙": "l",
		"𝟣": "l",
		"𝟭": "l",
		"𝟷": "l",
		"🯱": "l",
		I: "l",
		Ｉ: "l",
		Ⅰ: "l",
		ℐ: "l",
		ℑ: "l",
		𝐈: "l",
		𝐼: "l",
		𝑰: "l",
		𝓘: "l",
		𝕀: "l",
		𝕴: "l",
		𝖨: "l",
		𝗜: "l",
		𝘐: "l",
		𝙄: "l",
		𝙸: "l",
		Ɩ: "l",
		ｌ: "l",
		ⅼ: "l",
		ℓ: "l",
		𝐥: "l",
		𝑙: "l",
		𝒍: "l",
		𝓁: "l",
		𝓵: "l",
		𝔩: "l",
		𝕝: "l",
		𝖑: "l",
		𝗅: "l",
		𝗹: "l",
		𝘭: "l",
		𝙡: "l",
		𝚕: "l",
		ǀ: "l",
		Ι: "l",
		𝚰: "l",
		𝛪: "l",
		𝜤: "l",
		𝝞: "l",
		𝞘: "l",
		Ⲓ: "l",
		І: "l",
		Ӏ: "l",
		ו: "l",
		ן: "l",
		ا: "l",
		𞸀: "l",
		𞺀: "l",
		ﺎ: "l",
		ﺍ: "l",
		ߊ: "l",
		ⵏ: "l",
		ᛁ: "l",
		ꓲ: "l",
		𖼨: "l",
		𐊊: "l",
		𐌉: "l",
		"𝈪": "L",
		Ⅼ: "L",
		ℒ: "L",
		𝐋: "L",
		𝐿: "L",
		𝑳: "L",
		𝓛: "L",
		𝔏: "L",
		𝕃: "L",
		𝕷: "L",
		𝖫: "L",
		𝗟: "L",
		𝘓: "L",
		𝙇: "L",
		𝙻: "L",
		Ⳑ: "L",
		Ꮮ: "L",
		ᒪ: "L",
		ꓡ: "L",
		𖼖: "L",
		𑢣: "L",
		𑢲: "L",
		𐐛: "L",
		𐔦: "L",
		ﴼ: "l̋",
		ﴽ: "l̋",
		ł: "l̸",
		Ł: "L̸",
		ɭ: "l̨",
		Ɨ: "l̵",
		ƚ: "l̵",
		ɫ: "l̴",
		إ: "lٕ",
		ﺈ: "lٕ",
		ﺇ: "lٕ",
		ٳ: "lٕ",
		ŀ: "l·",
		Ŀ: "l·",
		ᒷ: "l·",
		"🄂": "l,",
		"⒈": "l.",
		ױ: "l'",
		"⒓": "l2.",
		"㏫": "l2日",
		"㋋": "l2月",
		"㍤": "l2点",
		"⒔": "l3.",
		"㏬": "l3日",
		"㍥": "l3点",
		"⒕": "l4.",
		"㏭": "l4日",
		"㍦": "l4点",
		"⒖": "l5.",
		"㏮": "l5日",
		"㍧": "l5点",
		"⒗": "l6.",
		"㏯": "l6日",
		"㍨": "l6点",
		"⒘": "l7.",
		"㏰": "l7日",
		"㍩": "l7点",
		"⒙": "l8.",
		"㏱": "l8日",
		"㍪": "l8点",
		"⒚": "l9.",
		"㏲": "l9日",
		"㍫": "l9点",
		ǉ: "lj",
		Ĳ: "lJ",
		ǈ: "Lj",
		Ǉ: "LJ",
		"‖": "ll",
		"∥": "ll",
		Ⅱ: "ll",
		ǁ: "ll",
		װ: "ll",
		"𐆙": "l̵l̵",
		"⒒": "ll.",
		Ⅲ: "lll",
		"𐆘": "l̵l̵S̵",
		"㏪": "ll日",
		"㋊": "ll月",
		"㍣": "ll点",
		Ю: "lO",
		"⒑": "lO.",
		"㏩": "lO日",
		"㋉": "lO月",
		"㍢": "lO点",
		ʪ: "ls",
		"₶": "lt",
		Ⅳ: "lV",
		Ⅸ: "lX",
		ɮ: "lȝ",
		ʫ: "lz",
		أ: "lٴ",
		ﺄ: "lٴ",
		ﺃ: "lٴ",
		ٲ: "lٴ",
		ٵ: "lٴ",
		ﷳ,
		ﷲ,
		"㏠": "l日",
		"㋀": "l月",
		"㍙": "l点",
		ⳑ: "ʟ",
		ꮮ: "ʟ",
		𐑃: "ʟ",
		Ｍ: "M",
		Ⅿ: "M",
		ℳ: "M",
		𝐌: "M",
		𝑀: "M",
		𝑴: "M",
		𝓜: "M",
		𝔐: "M",
		𝕄: "M",
		𝕸: "M",
		𝖬: "M",
		𝗠: "M",
		𝘔: "M",
		𝙈: "M",
		𝙼: "M",
		Μ: "M",
		𝚳: "M",
		𝛭: "M",
		𝜧: "M",
		𝝡: "M",
		𝞛: "M",
		Ϻ: "M",
		Ⲙ: "M",
		М: "M",
		Ꮇ: "M",
		ᗰ: "M",
		ᛖ: "M",
		ꓟ: "M",
		𐊰: "M",
		𐌑: "M",
		Ӎ: "M̦",
		"🝫": "MB",
		"ⷨ": "ᷟ",
		𝐧: "n",
		𝑛: "n",
		𝒏: "n",
		𝓃: "n",
		𝓷: "n",
		𝔫: "n",
		𝕟: "n",
		𝖓: "n",
		𝗇: "n",
		𝗻: "n",
		𝘯: "n",
		𝙣: "n",
		𝚗: "n",
		ո: "n",
		ռ: "n",
		Ｎ: "N",
		ℕ: "N",
		𝐍: "N",
		𝑁: "N",
		𝑵: "N",
		𝒩: "N",
		𝓝: "N",
		𝔑: "N",
		𝕹: "N",
		𝖭: "N",
		𝗡: "N",
		𝘕: "N",
		𝙉: "N",
		𝙽: "N",
		Ν: "N",
		𝚴: "N",
		𝛮: "N",
		𝜨: "N",
		𝝢: "N",
		𝞜: "N",
		Ⲛ: "N",
		ꓠ: "N",
		𐔓: "N",
		"𐆎": "N̊",
		ɳ: "n̨",
		ƞ: "n̩",
		η: "n̩",
		𝛈: "n̩",
		𝜂: "n̩",
		𝜼: "n̩",
		𝝶: "n̩",
		𝞰: "n̩",
		Ɲ: "N̦",
		ᵰ: "n̴",
		ǌ: "nj",
		ǋ: "Nj",
		Ǌ: "NJ",
		"№": "No",
		ͷ: "ᴎ",
		и: "ᴎ",
		𐑍: "ᴎ",
		ņ: "ɲ",
		"ం": "o",
		"ಂ": "o",
		"ം": "o",
		"ං": "o",
		"०": "o",
		"੦": "o",
		"૦": "o",
		"௦": "o",
		"౦": "o",
		"೦": "o",
		"൦": "o",
		"๐": "o",
		"໐": "o",
		"၀": "o",
		"٥": "o",
		"۵": "o",
		ｏ: "o",
		ℴ: "o",
		𝐨: "o",
		𝑜: "o",
		𝒐: "o",
		𝓸: "o",
		𝔬: "o",
		𝕠: "o",
		𝖔: "o",
		𝗈: "o",
		𝗼: "o",
		𝘰: "o",
		𝙤: "o",
		𝚘: "o",
		ᴏ: "o",
		ᴑ: "o",
		ꬽ: "o",
		ο: "o",
		𝛐: "o",
		𝜊: "o",
		𝝄: "o",
		𝝾: "o",
		𝞸: "o",
		σ: "o",
		𝛔: "o",
		𝜎: "o",
		𝝈: "o",
		𝞂: "o",
		𝞼: "o",
		ⲟ: "o",
		о: "o",
		ჿ: "o",
		օ: "o",
		ס: "o",
		ه: "o",
		𞸤: "o",
		𞹤: "o",
		𞺄: "o",
		ﻫ: "o",
		ﻬ: "o",
		ﻪ: "o",
		ﻩ: "o",
		ھ: "o",
		ﮬ: "o",
		ﮭ: "o",
		ﮫ: "o",
		ﮪ: "o",
		ہ: "o",
		ﮨ: "o",
		ﮩ: "o",
		ﮧ: "o",
		ﮦ: "o",
		ە: "o",
		ഠ: "o",
		ဝ: "o",
		𐓪: "o",
		𑣈: "o",
		𑣗: "o",
		𐐬: "o",
		"߀": "O",
		"০": "O",
		"୦": "O",
		〇: "O",
		"𑓐": "O",
		"𑣠": "O",
		"𝟎": "O",
		"𝟘": "O",
		"𝟢": "O",
		"𝟬": "O",
		"𝟶": "O",
		"🯰": "O",
		Ｏ: "O",
		𝐎: "O",
		𝑂: "O",
		𝑶: "O",
		𝒪: "O",
		𝓞: "O",
		𝔒: "O",
		𝕆: "O",
		𝕺: "O",
		𝖮: "O",
		𝗢: "O",
		𝘖: "O",
		𝙊: "O",
		𝙾: "O",
		Ο: "O",
		𝚶: "O",
		𝛰: "O",
		𝜪: "O",
		𝝤: "O",
		𝞞: "O",
		Ⲟ: "O",
		О: "O",
		Օ: "O",
		ⵔ: "O",
		ዐ: "O",
		ଠ: "O",
		𐓂: "O",
		ꓳ: "O",
		𑢵: "O",
		𐊒: "O",
		𐊫: "O",
		𐐄: "O",
		𐔖: "O",
		"⁰": "º",
		ᵒ: "º",
		ǒ: "ŏ",
		Ǒ: "Ŏ",
		ۿ: "ô",
		Ő: "Ö",
		ø: "o̸",
		ꬾ: "o̸",
		Ø: "O̸",
		ⵁ: "O̸",
		Ǿ,
		ɵ: "o̵",
		ꝋ: "o̵",
		ө: "o̵",
		ѳ: "o̵",
		ꮎ: "o̵",
		ꮻ: "o̵",
		"⊖": "O̵",
		"⊝": "O̵",
		"⍬": "O̵",
		"𝈚": "O̵",
		"🜔": "O̵",
		Ɵ: "O̵",
		Ꝋ: "O̵",
		θ: "O̵",
		ϑ: "O̵",
		𝛉: "O̵",
		𝛝: "O̵",
		𝜃: "O̵",
		𝜗: "O̵",
		𝜽: "O̵",
		𝝑: "O̵",
		𝝷: "O̵",
		𝞋: "O̵",
		𝞱: "O̵",
		𝟅: "O̵",
		Θ: "O̵",
		ϴ: "O̵",
		𝚯: "O̵",
		𝚹: "O̵",
		𝛩: "O̵",
		𝛳: "O̵",
		𝜣: "O̵",
		𝜭: "O̵",
		𝝝: "O̵",
		𝝧: "O̵",
		𝞗: "O̵",
		𝞡: "O̵",
		Ө: "O̵",
		Ѳ: "O̵",
		ⴱ: "O̵",
		Ꮎ: "O̵",
		Ꮻ: "O̵",
		ꭴ: "ơ",
		ﳙ: "oٰ",
		"🄁": "O,",
		"🄀": "O.",
		ơ: "o'",
		Ơ: "O'",
		Ꭴ: "O'",
		"%": "º/₀",
		"٪": "º/₀",
		"⁒": "º/₀",
		"‰": "º/₀₀",
		"؉": "º/₀₀",
		"‱": "º/₀₀₀",
		"؊": "º/₀₀₀",
		œ: "oe",
		Œ: "OE",
		ɶ,
		"∞": "oo",
		ꝏ: "oo",
		ꚙ: "oo",
		Ꝏ: "OO",
		Ꚙ: "OO",
		ﳗ: "oج",
		ﱑ: "oج",
		ﳘ: "oم",
		ﱒ: "oم",
		ﶓ,
		ﶔ,
		ﱓ: "oى",
		ﱔ: "oى",
		ൟ,
		တ,
		"㍘": "O点",
		ↄ: "ɔ",
		ᴐ: "ɔ",
		ͻ: "ɔ",
		𐑋: "ɔ",
		Ↄ: "Ɔ",
		Ͻ: "Ɔ",
		ꓛ: "Ɔ",
		𐐣: "Ɔ",
		ꬿ,
		ꭢ: "ɔe",
		𐐿: "ɷ",
		"⍴": "p",
		ｐ: "p",
		𝐩: "p",
		𝑝: "p",
		𝒑: "p",
		𝓅: "p",
		𝓹: "p",
		𝔭: "p",
		𝕡: "p",
		𝖕: "p",
		𝗉: "p",
		𝗽: "p",
		𝘱: "p",
		𝙥: "p",
		𝚙: "p",
		ρ: "p",
		ϱ: "p",
		𝛒: "p",
		𝛠: "p",
		𝜌: "p",
		𝜚: "p",
		𝝆: "p",
		𝝔: "p",
		𝞀: "p",
		𝞎: "p",
		𝞺: "p",
		𝟈: "p",
		ⲣ: "p",
		р: "p",
		Ｐ: "P",
		ℙ: "P",
		𝐏: "P",
		𝑃: "P",
		𝑷: "P",
		𝒫: "P",
		𝓟: "P",
		𝔓: "P",
		𝕻: "P",
		𝖯: "P",
		𝗣: "P",
		𝘗: "P",
		𝙋: "P",
		𝙿: "P",
		Ρ: "P",
		𝚸: "P",
		𝛲: "P",
		𝜬: "P",
		𝝦: "P",
		𝞠: "P",
		Ⲣ: "P",
		Р: "P",
		Ꮲ: "P",
		ᑭ: "P",
		ꓑ: "P",
		𐊕: "P",
		ƥ: "p̔",
		ᵽ: "p̵",
		ᑷ: "p·",
		ᒆ: "P'",
		ᴩ: "ᴘ",
		ꮲ: "ᴘ",
		φ: "ɸ",
		ϕ: "ɸ",
		𝛗: "ɸ",
		𝛟: "ɸ",
		𝜑: "ɸ",
		𝜙: "ɸ",
		𝝋: "ɸ",
		𝝓: "ɸ",
		𝞅: "ɸ",
		𝞍: "ɸ",
		𝞿: "ɸ",
		𝟇: "ɸ",
		ⲫ: "ɸ",
		ф: "ɸ",
		𝐪: "q",
		𝑞: "q",
		𝒒: "q",
		𝓆: "q",
		𝓺: "q",
		𝔮: "q",
		𝕢: "q",
		𝖖: "q",
		𝗊: "q",
		𝗾: "q",
		𝘲: "q",
		𝙦: "q",
		𝚚: "q",
		ԛ: "q",
		գ: "q",
		զ: "q",
		ℚ: "Q",
		𝐐: "Q",
		𝑄: "Q",
		𝑸: "Q",
		𝒬: "Q",
		𝓠: "Q",
		𝔔: "Q",
		𝕼: "Q",
		𝖰: "Q",
		𝗤: "Q",
		𝘘: "Q",
		𝙌: "Q",
		𝚀: "Q",
		ⵕ: "Q",
		ʠ: "q̔",
		"🜀": "QE",
		ᶐ: "ɋ",
		ᴋ: "ĸ",
		κ: "ĸ",
		ϰ: "ĸ",
		𝛋: "ĸ",
		𝛞: "ĸ",
		𝜅: "ĸ",
		𝜘: "ĸ",
		𝜿: "ĸ",
		𝝒: "ĸ",
		𝝹: "ĸ",
		𝞌: "ĸ",
		𝞳: "ĸ",
		𝟆: "ĸ",
		ⲕ: "ĸ",
		к: "ĸ",
		ꮶ: "ĸ",
		қ,
		ҟ,
		𝐫: "r",
		𝑟: "r",
		𝒓: "r",
		𝓇: "r",
		𝓻: "r",
		𝔯: "r",
		𝕣: "r",
		𝖗: "r",
		𝗋: "r",
		𝗿: "r",
		𝘳: "r",
		𝙧: "r",
		𝚛: "r",
		ꭇ: "r",
		ꭈ: "r",
		ᴦ: "r",
		ⲅ: "r",
		г: "r",
		ꮁ: "r",
		"𝈖": "R",
		ℛ: "R",
		ℜ: "R",
		ℝ: "R",
		𝐑: "R",
		𝑅: "R",
		𝑹: "R",
		𝓡: "R",
		𝕽: "R",
		𝖱: "R",
		𝗥: "R",
		𝘙: "R",
		𝙍: "R",
		𝚁: "R",
		Ʀ: "R",
		Ꭱ: "R",
		Ꮢ: "R",
		𐒴: "R",
		ᖇ: "R",
		ꓣ: "R",
		𖼵: "R",
		ɽ: "r̨",
		ɼ: "r̩",
		ɍ: "r̵",
		ғ: "r̵",
		ᵲ: "r̴",
		ґ: "r'",
		"𑣣": "rn",
		m: "rn",
		ⅿ: "rn",
		𝐦: "rn",
		𝑚: "rn",
		𝒎: "rn",
		𝓂: "rn",
		𝓶: "rn",
		𝔪: "rn",
		𝕞: "rn",
		𝖒: "rn",
		𝗆: "rn",
		𝗺: "rn",
		𝘮: "rn",
		𝙢: "rn",
		𝚖: "rn",
		𑜀: "rn",
		"₥": "rn̸",
		ɱ,
		ᵯ,
		"₨": "Rs",
		ꭱ: "ʀ",
		ꮢ: "ʀ",
		я: "ᴙ",
		ᵳ,
		"℩": "ɿ",
		ｓ: "s",
		𝐬: "s",
		𝑠: "s",
		𝒔: "s",
		𝓈: "s",
		𝓼: "s",
		𝔰: "s",
		𝕤: "s",
		𝖘: "s",
		𝗌: "s",
		𝘀: "s",
		𝘴: "s",
		𝙨: "s",
		𝚜: "s",
		ꜱ: "s",
		ƽ: "s",
		ѕ: "s",
		ꮪ: "s",
		𑣁: "s",
		𐑈: "s",
		Ｓ: "S",
		𝐒: "S",
		𝑆: "S",
		𝑺: "S",
		𝒮: "S",
		𝓢: "S",
		𝔖: "S",
		𝕊: "S",
		𝕾: "S",
		𝖲: "S",
		𝗦: "S",
		𝘚: "S",
		𝙎: "S",
		𝚂: "S",
		Ѕ: "S",
		Տ: "S",
		Ꮥ: "S",
		Ꮪ: "S",
		ꓢ: "S",
		𖼺: "S",
		𐊖: "S",
		𐐠: "S",
		ʂ: "s̨",
		ᵴ: "s̴",
		ꞵ: "ß",
		β: "ß",
		ϐ: "ß",
		𝛃: "ß",
		𝛽: "ß",
		𝜷: "ß",
		𝝱: "ß",
		𝞫: "ß",
		Ᏸ: "ß",
		"🝜": "sss",
		ﬆ: "st",
		"∫": "ʃ",
		ꭍ: "ʃ",
		"∑": "Ʃ",
		"⅀": "Ʃ",
		Σ: "Ʃ",
		𝚺: "Ʃ",
		𝛴: "Ʃ",
		𝜮: "Ʃ",
		𝝨: "Ʃ",
		𝞢: "Ʃ",
		ⵉ: "Ʃ",
		"∬": "ʃʃ",
		"∭": "ʃʃʃ",
		"⨌": "ʃʃʃʃ",
		𝐭: "t",
		𝑡: "t",
		𝒕: "t",
		𝓉: "t",
		𝓽: "t",
		𝔱: "t",
		𝕥: "t",
		𝖙: "t",
		𝗍: "t",
		𝘁: "t",
		𝘵: "t",
		𝙩: "t",
		𝚝: "t",
		"⊤": "T",
		"⟙": "T",
		"🝨": "T",
		Ｔ: "T",
		𝐓: "T",
		𝑇: "T",
		𝑻: "T",
		𝒯: "T",
		𝓣: "T",
		𝔗: "T",
		𝕋: "T",
		𝕿: "T",
		𝖳: "T",
		𝗧: "T",
		𝘛: "T",
		𝙏: "T",
		𝚃: "T",
		Τ: "T",
		𝚻: "T",
		𝛵: "T",
		𝜯: "T",
		𝝩: "T",
		𝞣: "T",
		Ⲧ: "T",
		Т: "T",
		Ꭲ: "T",
		ꓔ: "T",
		𖼊: "T",
		𑢼: "T",
		𐊗: "T",
		𐊱: "T",
		𐌕: "T",
		ƭ: "t̔",
		"⍡": "T̈",
		Ⱦ: "T̸",
		Ț: "Ţ",
		Ʈ: "T̨",
		Ҭ: "T̩",
		"₮": "T⃫",
		ŧ: "t̵",
		Ŧ: "T̵",
		ᵵ: "t̴",
		Ⴀ: "Ꞇ",
		Ꜩ: "T3",
		ʨ: "tɕ",
		"℡": "TEL",
		ꝷ: "tf",
		ʦ: "ts",
		ʧ: "tʃ",
		ꜩ: "tȝ",
		τ: "ᴛ",
		𝛕: "ᴛ",
		𝜏: "ᴛ",
		𝝉: "ᴛ",
		𝞃: "ᴛ",
		𝞽: "ᴛ",
		т: "ᴛ",
		ꭲ: "ᴛ",
		ҭ,
		ţ: "ƫ",
		ț: "ƫ",
		Ꮏ: "ƫ",
		𝐮: "u",
		𝑢: "u",
		𝒖: "u",
		𝓊: "u",
		𝓾: "u",
		𝔲: "u",
		𝕦: "u",
		𝖚: "u",
		𝗎: "u",
		𝘂: "u",
		𝘶: "u",
		𝙪: "u",
		𝚞: "u",
		ꞟ: "u",
		ᴜ: "u",
		ꭎ: "u",
		ꭒ: "u",
		ʋ: "u",
		υ: "u",
		𝛖: "u",
		𝜐: "u",
		𝝊: "u",
		𝞄: "u",
		𝞾: "u",
		ս: "u",
		𐓶: "u",
		𑣘: "u",
		"∪": "U",
		"⋃": "U",
		𝐔: "U",
		𝑈: "U",
		𝑼: "U",
		𝒰: "U",
		𝓤: "U",
		𝔘: "U",
		𝕌: "U",
		𝖀: "U",
		𝖴: "U",
		𝗨: "U",
		𝘜: "U",
		𝙐: "U",
		𝚄: "U",
		Ս: "U",
		ሀ: "U",
		𐓎: "U",
		ᑌ: "U",
		ꓴ: "U",
		𖽂: "U",
		𑢸: "U",
		ǔ: "ŭ",
		Ǔ: "Ŭ",
		ᵾ: "u̵",
		ꮜ: "u̵",
		Ʉ: "U̵",
		Ꮜ: "U̵",
		ᑘ: "U·",
		ᑧ: "U'",
		ᵫ: "ue",
		ꭣ: "uo",
		ṃ: "ꭑ",
		պ: "ɰ",
		ሣ: "ɰ",
		"℧": "Ʊ",
		ᘮ: "Ʊ",
		ᘴ: "Ʊ",
		ᵿ,
		"∨": "v",
		"⋁": "v",
		ｖ: "v",
		ⅴ: "v",
		𝐯: "v",
		𝑣: "v",
		𝒗: "v",
		𝓋: "v",
		𝓿: "v",
		𝔳: "v",
		𝕧: "v",
		𝖛: "v",
		𝗏: "v",
		𝘃: "v",
		𝘷: "v",
		𝙫: "v",
		𝚟: "v",
		ᴠ: "v",
		ν: "v",
		𝛎: "v",
		𝜈: "v",
		𝝂: "v",
		𝝼: "v",
		𝞶: "v",
		ѵ: "v",
		ט: "v",
		𑜆: "v",
		ꮩ: "v",
		𑣀: "v",
		"𝈍": "V",
		"٧": "V",
		"۷": "V",
		Ⅴ: "V",
		𝐕: "V",
		𝑉: "V",
		𝑽: "V",
		𝒱: "V",
		𝓥: "V",
		𝔙: "V",
		𝕍: "V",
		𝖁: "V",
		𝖵: "V",
		𝗩: "V",
		𝘝: "V",
		𝙑: "V",
		𝚅: "V",
		Ѵ: "V",
		ⴸ: "V",
		Ꮩ: "V",
		ᐯ: "V",
		ꛟ: "V",
		ꓦ: "V",
		𖼈: "V",
		𑢠: "V",
		𐔝: "V",
		"𐆗": "V̵",
		ᐻ: "V·",
		"🝬": "VB",
		ⅵ: "vi",
		ⅶ: "vii",
		ⅷ,
		Ⅵ: "Vl",
		Ⅶ: "Vll",
		Ⅷ,
		"🜈": "Vᷤ",
		ᴧ: "ʌ",
		𐓘: "ʌ",
		"٨": "Ʌ",
		"۸": "Ʌ",
		Λ: "Ʌ",
		𝚲: "Ʌ",
		𝛬: "Ʌ",
		𝜦: "Ʌ",
		𝝠: "Ʌ",
		𝞚: "Ʌ",
		Л: "Ʌ",
		ⴷ: "Ʌ",
		𐒰: "Ʌ",
		ᐱ: "Ʌ",
		ꛎ: "Ʌ",
		ꓥ: "Ʌ",
		𖼽: "Ʌ",
		𐊍: "Ʌ",
		Ӆ,
		ᐽ,
		ɯ: "w",
		𝐰: "w",
		𝑤: "w",
		𝒘: "w",
		𝓌: "w",
		𝔀: "w",
		𝔴: "w",
		𝕨: "w",
		𝖜: "w",
		𝗐: "w",
		𝘄: "w",
		𝘸: "w",
		𝙬: "w",
		𝚠: "w",
		ᴡ: "w",
		ѡ: "w",
		ԝ: "w",
		ա: "w",
		𑜊: "w",
		𑜎: "w",
		𑜏: "w",
		ꮃ: "w",
		"𑣯": "W",
		"𑣦": "W",
		𝐖: "W",
		𝑊: "W",
		𝑾: "W",
		𝒲: "W",
		𝓦: "W",
		𝔚: "W",
		𝕎: "W",
		𝖂: "W",
		𝖶: "W",
		𝗪: "W",
		𝘞: "W",
		𝙒: "W",
		𝚆: "W",
		Ԝ: "W",
		Ꮃ: "W",
		Ꮤ: "W",
		ꓪ: "W",
		ѽ,
		𑓅: "ẇ",
		"₩": "W̵",
		ꝡ: "w̦",
		ᴍ: "ʍ",
		м: "ʍ",
		ꮇ: "ʍ",
		ӎ,
		"᙮": "x",
		"×": "x",
		"⤫": "x",
		"⤬": "x",
		"⨯": "x",
		ｘ: "x",
		ⅹ: "x",
		𝐱: "x",
		𝑥: "x",
		𝒙: "x",
		𝓍: "x",
		𝔁: "x",
		𝔵: "x",
		𝕩: "x",
		𝖝: "x",
		𝗑: "x",
		𝘅: "x",
		𝘹: "x",
		𝙭: "x",
		𝚡: "x",
		х: "x",
		ᕁ: "x",
		ᕽ: "x",
		"ⷯ": "ͯ",
		"᙭": "X",
		"╳": "X",
		"𐌢": "X",
		"𑣬": "X",
		Ｘ: "X",
		Ⅹ: "X",
		𝐗: "X",
		𝑋: "X",
		𝑿: "X",
		𝒳: "X",
		𝓧: "X",
		𝔛: "X",
		𝕏: "X",
		𝖃: "X",
		𝖷: "X",
		𝗫: "X",
		𝘟: "X",
		𝙓: "X",
		𝚇: "X",
		Ꭓ: "X",
		Χ: "X",
		𝚾: "X",
		𝛸: "X",
		𝜲: "X",
		𝝬: "X",
		𝞦: "X",
		Ⲭ: "X",
		Х: "X",
		ⵝ: "X",
		ᚷ: "X",
		ꓫ: "X",
		𐊐: "X",
		𐊴: "X",
		𐌗: "X",
		𐔧: "X",
		"⨰": "ẋ",
		Ҳ: "X̩",
		"𐆖": "X̵",
		ⅺ: "xi",
		ⅻ: "xii",
		Ⅺ: "Xl",
		Ⅻ: "Xll",
		ɣ: "y",
		ᶌ: "y",
		ｙ: "y",
		𝐲: "y",
		𝑦: "y",
		𝒚: "y",
		𝓎: "y",
		𝔂: "y",
		𝔶: "y",
		𝕪: "y",
		𝖞: "y",
		𝗒: "y",
		𝘆: "y",
		𝘺: "y",
		𝙮: "y",
		𝚢: "y",
		ʏ: "y",
		ỿ: "y",
		ꭚ: "y",
		γ: "y",
		ℽ: "y",
		𝛄: "y",
		𝛾: "y",
		𝜸: "y",
		𝝲: "y",
		𝞬: "y",
		у: "y",
		ү: "y",
		ყ: "y",
		𑣜: "y",
		Ｙ: "Y",
		𝐘: "Y",
		𝑌: "Y",
		𝒀: "Y",
		𝒴: "Y",
		𝓨: "Y",
		𝔜: "Y",
		𝕐: "Y",
		𝖄: "Y",
		𝖸: "Y",
		𝗬: "Y",
		𝘠: "Y",
		𝙔: "Y",
		𝚈: "Y",
		Υ: "Y",
		ϒ: "Y",
		𝚼: "Y",
		𝛶: "Y",
		𝜰: "Y",
		𝝪: "Y",
		𝞤: "Y",
		Ⲩ: "Y",
		У: "Y",
		Ү: "Y",
		Ꭹ: "Y",
		Ꮍ: "Y",
		ꓬ: "Y",
		𖽃: "Y",
		𑢤: "Y",
		𐊲: "Y",
		ƴ: "y̔",
		ɏ: "y̵",
		ұ: "y̵",
		"¥": "Y̵",
		Ɏ: "Y̵",
		Ұ: "Y̵",
		ʒ: "ȝ",
		ꝫ: "ȝ",
		ⳍ: "ȝ",
		ӡ: "ȝ",
		ჳ: "ȝ",
		𝐳: "z",
		𝑧: "z",
		𝒛: "z",
		𝓏: "z",
		𝔃: "z",
		𝔷: "z",
		𝕫: "z",
		𝖟: "z",
		𝗓: "z",
		𝘇: "z",
		𝘻: "z",
		𝙯: "z",
		𝚣: "z",
		ᴢ: "z",
		ꮓ: "z",
		𑣄: "z",
		"𐋵": "Z",
		"𑣥": "Z",
		Ｚ: "Z",
		ℤ: "Z",
		ℨ: "Z",
		𝐙: "Z",
		𝑍: "Z",
		𝒁: "Z",
		𝒵: "Z",
		𝓩: "Z",
		𝖅: "Z",
		𝖹: "Z",
		𝗭: "Z",
		𝘡: "Z",
		𝙕: "Z",
		𝚉: "Z",
		Ζ: "Z",
		𝚭: "Z",
		𝛧: "Z",
		𝜡: "Z",
		𝝛: "Z",
		𝞕: "Z",
		Ꮓ: "Z",
		ꓜ: "Z",
		𑢩: "Z",
		ʐ: "z̨",
		ƶ: "z̵",
		Ƶ: "Z̵",
		ȥ: "z̦",
		Ȥ: "Z̦",
		ᵶ: "z̴",
		ƿ: "þ",
		ϸ: "þ",
		Ϸ: "Þ",
		𐓄: "Þ",
		"⁹": "ꝰ",
		ᴤ: "ƨ",
		ϩ: "ƨ",
		ꙅ: "ƨ",
		ь: "ƅ",
		ꮟ: "ƅ",
		ы: "ƅi",
		ꭾ: "ɂ",
		ˤ: "ˁ",
		ꛍ: "ʡ",
		"⊙": "ʘ",
		"☉": "ʘ",
		"⨀": "ʘ",
		Ꙩ: "ʘ",
		ⵙ: "ʘ",
		𐓃: "ʘ",
		ℾ: "Γ",
		𝚪: "Γ",
		𝛤: "Γ",
		𝜞: "Γ",
		𝝘: "Γ",
		𝞒: "Γ",
		Ⲅ: "Γ",
		Г: "Γ",
		Ꮁ: "Γ",
		ᒥ: "Γ",
		𖼇: "Γ",
		Ғ,
		ᒯ,
		Ґ: "Γ'",
		"∆": "Δ",
		"△": "Δ",
		"🜂": "Δ",
		𝚫: "Δ",
		𝛥: "Δ",
		𝜟: "Δ",
		𝝙: "Δ",
		𝞓: "Δ",
		Ⲇ: "Δ",
		ⵠ: "Δ",
		ᐃ: "Δ",
		𖼚: "Δ",
		𐊅: "Δ",
		𐊣: "Δ",
		"⍙": "Δ̲",
		ᐏ,
		ᐬ,
		𝟋: "ϝ",
		𝛇: "ζ",
		𝜁: "ζ",
		𝜻: "ζ",
		𝝵: "ζ",
		𝞯: "ζ",
		ⳤ: "ϗ",
		𝛌: "λ",
		𝜆: "λ",
		𝝀: "λ",
		𝝺: "λ",
		𝞴: "λ",
		Ⲗ: "λ",
		𐓛: "λ",
		µ: "μ",
		𝛍: "μ",
		𝜇: "μ",
		𝝁: "μ",
		𝝻: "μ",
		𝞵: "μ",
		𝛏: "ξ",
		𝜉: "ξ",
		𝝃: "ξ",
		𝝽: "ξ",
		𝞷: "ξ",
		𝚵: "Ξ",
		𝛯: "Ξ",
		𝜩: "Ξ",
		𝝣: "Ξ",
		𝞝: "Ξ",
		ϖ: "π",
		ℼ: "π",
		𝛑: "π",
		𝛡: "π",
		𝜋: "π",
		𝜛: "π",
		𝝅: "π",
		𝝕: "π",
		𝝿: "π",
		𝞏: "π",
		𝞹: "π",
		𝟉: "π",
		ᴨ: "π",
		п: "π",
		"∏": "Π",
		ℿ: "Π",
		𝚷: "Π",
		𝛱: "Π",
		𝜫: "Π",
		𝝥: "Π",
		𝞟: "Π",
		Ⲡ: "Π",
		П: "Π",
		ꛛ: "Π",
		𐊭: "Ϙ",
		𐌒: "Ϙ",
		ϛ: "ς",
		𝛓: "ς",
		𝜍: "ς",
		𝝇: "ς",
		𝞁: "ς",
		𝞻: "ς",
		𝚽: "Φ",
		𝛷: "Φ",
		𝜱: "Φ",
		𝝫: "Φ",
		𝞥: "Φ",
		Ⲫ: "Φ",
		Ф: "Φ",
		Փ: "Φ",
		ቀ: "Φ",
		ᛰ: "Φ",
		𐊳: "Φ",
		ꭓ: "χ",
		ꭕ: "χ",
		𝛘: "χ",
		𝜒: "χ",
		𝝌: "χ",
		𝞆: "χ",
		𝟀: "χ",
		ⲭ: "χ",
		𝛙: "ψ",
		𝜓: "ψ",
		𝝍: "ψ",
		𝞇: "ψ",
		𝟁: "ψ",
		ѱ: "ψ",
		𐓹: "ψ",
		𝚿: "Ψ",
		𝛹: "Ψ",
		𝜳: "Ψ",
		𝝭: "Ψ",
		𝞧: "Ψ",
		Ⲯ: "Ψ",
		Ѱ: "Ψ",
		𐓑: "Ψ",
		ᛘ: "Ψ",
		𐊵: "Ψ",
		"⍵": "ω",
		ꞷ: "ω",
		𝛚: "ω",
		𝜔: "ω",
		𝝎: "ω",
		𝞈: "ω",
		𝟂: "ω",
		ⲱ: "ω",
		ꙍ: "ω",
		Ω: "Ω",
		𝛀: "Ω",
		𝛺: "Ω",
		𝜴: "Ω",
		𝝮: "Ω",
		𝞨: "Ω",
		ᘯ: "Ω",
		ᘵ: "Ω",
		𐊶: "Ω",
		"⍹": "ω̲",
		ώ: "ῴ",
		"☰": "Ⲷ",
		Ⳝ: "Ϭ",
		җ,
		Җ,
		"𝈋": "И",
		Ͷ: "И",
		ꚡ: "И",
		𐐥: "И",
		Й: "Ѝ",
		Ҋ,
		ѝ: "й",
		ҋ,
		𐒼: "Ӄ",
		ᴫ: "л",
		ӆ,
		ꭠ: "љ",
		𐓫: "ꙩ",
		"ᷮ": "ⷬ",
		𐓍: "Ћ",
		"𝈂": "Ӿ",
		"𝈢": "Ѡ",
		Ꮗ: "Ѡ",
		ᗯ: "Ѡ",
		Ѽ,
		ᣭ,
		Ꞷ: "Ꙍ",
		ӌ: "ҷ",
		Ӌ: "Ҷ",
		Ҿ,
		ⲽ: "ш",
		Ⲽ: "Ш",
		Ꙑ: "Ъl",
		"℈": "Э",
		"🜁": "Ꙙ",
		𖼜: "Ꙙ",
		ꦒ: "ⰿ",
		և,
		ኔ: "ձ",
		ﬔ,
		ﬕ,
		ﬗ,
		ﬓ,
		"∩": "Ո",
		"⋂": "Ո",
		"𝉅": "Ո",
		በ: "Ո",
		ᑎ: "Ո",
		ꓵ: "Ո",
		ᑚ,
		ᑨ: "Ո'",
		ﬖ,
		"₽": "Ք",
		"˓": "ՙ",
		ʿ: "ՙ",
		ℵ: "א",
		ﬡ: "א",
		אָ: "אַ",
		אּ: "אַ",
		ﭏ,
		ℶ: "ב",
		ℷ: "ג",
		ℸ: "ד",
		ﬢ: "ד",
		ﬣ: "ה",
		יּ: "יִ",
		ﬤ: "כ",
		ﬥ: "ל",
		ﬦ: "ם",
		ﬠ: "ע",
		ﬧ: "ר",
		שׂ: "שׁ",
		שּ: "שׁ",
		שּׂ: "שּׁ",
		ﬨ: "ת",
		ﺀ: "ء",
		"۽": "ء͈",
		ﺂ: "آ",
		ﺁ: "آ",
		ﭑ: "ٱ",
		ﭐ: "ٱ",
		𞸁: "ب",
		𞸡: "ب",
		𞹡: "ب",
		𞺁: "ب",
		𞺡: "ب",
		ﺑ: "ب",
		ﺒ: "ب",
		ﺐ: "ب",
		ﺏ: "ب",
		ݑ,
		ࢶ,
		ࢡ,
		ﲠ: "بo",
		ﳢ: "بo",
		ﲜ,
		ﰅ,
		ﲝ,
		ﰆ,
		ﷂ,
		ﲞ,
		ﰇ,
		ﳒ,
		ﱋ,
		ﶞ,
		ﱪ,
		ﱫ,
		ﲟ,
		ﳡ,
		ﱬ,
		ﰈ,
		ﱭ,
		ﱮ,
		ﰉ,
		ﱯ,
		ﰊ,
		ﭔ: "ٻ",
		ﭕ: "ٻ",
		ﭓ: "ٻ",
		ﭒ: "ٻ",
		ې: "ٻ",
		ﯦ: "ٻ",
		ﯧ: "ٻ",
		ﯥ: "ٻ",
		ﯤ: "ٻ",
		ﭜ: "ڀ",
		ﭝ: "ڀ",
		ﭛ: "ڀ",
		ﭚ: "ڀ",
		ࢩ: "ݔ",
		ݧ: "ݔ",
		"⍥": "ة",
		ö: "ة",
		ﺔ: "ة",
		ﺓ: "ة",
		ۃ: "ة",
		𞸕: "ت",
		𞸵: "ت",
		𞹵: "ت",
		𞺕: "ت",
		𞺵: "ت",
		ﺗ: "ت",
		ﺘ: "ت",
		ﺖ: "ت",
		ﺕ: "ت",
		ﲥ: "تo",
		ﳤ: "تo",
		ﲡ,
		ﰋ,
		ﵐ,
		ﶠ,
		ﶟ,
		ﲢ,
		ﰌ,
		ﵒ,
		ﵑ,
		ﵓ,
		ﲣ,
		ﰍ,
		ﵔ,
		ﶢ,
		ﶡ,
		ﱰ,
		ﱱ,
		ﲤ,
		ﳣ,
		ﱲ,
		ﰎ,
		ﵕ,
		ﵖ,
		ﵗ,
		ﶤ,
		ﶣ,
		ﱳ,
		ﱴ,
		ﰏ,
		ﱵ,
		ﰐ,
		ﭠ: "ٺ",
		ﭡ: "ٺ",
		ﭟ: "ٺ",
		ﭞ: "ٺ",
		ﭤ: "ٿ",
		ﭥ: "ٿ",
		ﭣ: "ٿ",
		ﭢ: "ٿ",
		𞸂: "ج",
		𞸢: "ج",
		𞹂: "ج",
		𞹢: "ج",
		𞺂: "ج",
		𞺢: "ج",
		ﺟ: "ج",
		ﺠ: "ج",
		ﺞ: "ج",
		ﺝ: "ج",
		ﲧ,
		ﰕ,
		ﶦ,
		ﶾ,
		ﷻ,
		ﲨ,
		ﰖ,
		ﵙ,
		ﵘ,
		ﶧ,
		ﶥ,
		ﴝ,
		ﴁ,
		ﴞ,
		ﴂ,
		ﭸ: "ڃ",
		ﭹ: "ڃ",
		ﭷ: "ڃ",
		ﭶ: "ڃ",
		ﭴ: "ڄ",
		ﭵ: "ڄ",
		ﭳ: "ڄ",
		ﭲ: "ڄ",
		ﭼ: "چ",
		ﭽ: "چ",
		ﭻ: "چ",
		ﭺ: "چ",
		ﮀ: "ڇ",
		ﮁ: "ڇ",
		ﭿ: "ڇ",
		ﭾ: "ڇ",
		𞸇: "ح",
		𞸧: "ح",
		𞹇: "ح",
		𞹧: "ح",
		𞺇: "ح",
		𞺧: "ح",
		ﺣ: "ح",
		ﺤ: "ح",
		ﺢ: "ح",
		ﺡ: "ح",
		څ,
		ځ,
		ݲ,
		ﲩ,
		ﰗ,
		ﶿ,
		ﲪ,
		ﰘ,
		ﵛ,
		ﵚ,
		ﴛ,
		ﳿ,
		ﴜ,
		ﴀ,
		𞸗: "خ",
		𞸷: "خ",
		𞹗: "خ",
		𞹷: "خ",
		𞺗: "خ",
		𞺷: "خ",
		ﺧ: "خ",
		ﺨ: "خ",
		ﺦ: "خ",
		ﺥ: "خ",
		ﲫ,
		ﰙ,
		ﰚ,
		ﲬ,
		ﰛ,
		ﴟ,
		ﴃ,
		ﴠ,
		ﴄ,
		"𐋡": "د",
		𞸃: "د",
		𞺃: "د",
		𞺣: "د",
		ﺪ: "د",
		ﺩ: "د",
		ڈ,
		ﮉ,
		ﮈ,
		ڎ,
		ﮇ,
		ﮆ,
		ۮ,
		ࢮ,
		𞸘: "ذ",
		𞺘: "ذ",
		𞺸: "ذ",
		ﺬ: "ذ",
		ﺫ: "ذ",
		ﱛ,
		ڋ,
		ﮅ: "ڌ",
		ﮄ: "ڌ",
		ﮃ: "ڍ",
		ﮂ: "ڍ",
		𞸓: "ر",
		𞺓: "ر",
		𞺳: "ر",
		ﺮ: "ر",
		ﺭ: "ر",
		ڑ,
		ﮍ,
		ﮌ,
		ژ,
		ﮋ,
		ﮊ,
		ڒ,
		ࢹ,
		ۯ,
		ݬ,
		ﱜ,
		ﷶ,
		"﷼": "رىlل",
		𞸆: "ز",
		𞺆: "ز",
		𞺦: "ز",
		ﺰ: "ز",
		ﺯ: "ز",
		ࢲ,
		ݱ,
		𞸎: "س",
		𞸮: "س",
		𞹎: "س",
		𞹮: "س",
		𞺎: "س",
		𞺮: "س",
		ﺳ: "س",
		ﺴ: "س",
		ﺲ: "س",
		ﺱ: "س",
		ش,
		𞸔,
		𞸴,
		𞹔,
		𞹴,
		𞺔,
		𞺴,
		ﺷ,
		ﺸ,
		ﺶ,
		ﺵ,
		ݾ,
		ﴱ: "سo",
		ﳨ: "سo",
		ﴲ,
		ﳪ,
		ﲭ,
		ﴴ,
		ﰜ,
		ﴭ,
		ﴷ,
		ﴥ,
		ﴉ,
		ﵝ,
		ﵞ,
		ﵩ,
		ﲮ,
		ﴵ,
		ﰝ,
		ﴮ,
		ﴸ,
		ﴦ,
		ﴊ,
		ﵜ,
		ﵨ,
		ﵧ,
		ﶪ,
		ﲯ,
		ﴶ,
		ﰞ,
		ﴯ,
		ﴹ,
		ﴧ,
		ﴋ,
		ﶨ,
		ﷆ,
		ﴪ,
		ﴎ,
		ﴩ,
		ﴍ,
		ﲰ,
		ﳧ,
		ﰟ,
		ﴰ,
		ﳩ,
		ﴨ,
		ﴌ,
		ﵡ,
		ﵠ,
		ﵟ,
		ﵫ,
		ﵪ,
		ﵣ,
		ﵢ,
		ﵭ,
		ﵬ,
		ﴗ,
		ﳻ,
		ﴘ,
		ﳼ,
		ﴙ,
		ﳽ,
		ﴚ,
		ﳾ,
		"𐋲": "ص",
		𞸑: "ص",
		𞸱: "ص",
		𞹑: "ص",
		𞹱: "ص",
		𞺑: "ص",
		𞺱: "ص",
		ﺻ: "ص",
		ﺼ: "ص",
		ﺺ: "ص",
		ﺹ: "ص",
		ڞ,
		ࢯ,
		ﲱ,
		ﰠ,
		ﵥ,
		ﵤ,
		ﶩ,
		ﲲ,
		ﴫ,
		ﴏ,
		ﷵ,
		ﷹ,
		ﷰ,
		ﷺ,
		ﲳ,
		ﰡ,
		ﷅ,
		ﵦ,
		ﴡ,
		ﴅ,
		ﴢ,
		ﴆ,
		𞸙: "ض",
		𞸹: "ض",
		𞹙: "ض",
		𞹹: "ض",
		𞺙: "ض",
		𞺹: "ض",
		ﺿ: "ض",
		ﻀ: "ض",
		ﺾ: "ض",
		ﺽ: "ض",
		ﲴ,
		ﰢ,
		ﲵ,
		ﰣ,
		ﵮ,
		ﶫ,
		ﲶ,
		ﰤ,
		ﵰ,
		ﵯ,
		ﴬ,
		ﴐ,
		ﲷ,
		ﰥ,
		ﴣ,
		ﴇ,
		ﴤ,
		ﴈ,
		"𐋨": "ط",
		𞸈: "ط",
		𞹨: "ط",
		𞺈: "ط",
		𞺨: "ط",
		ﻃ: "ط",
		ﻄ: "ط",
		ﻂ: "ط",
		ﻁ: "ط",
		ڟ,
		ﲸ,
		ﰦ,
		ﴳ,
		ﴺ,
		ﰧ,
		ﵲ,
		ﵱ,
		ﵳ,
		ﵴ,
		ﴑ,
		ﳵ,
		ﴒ,
		ﳶ,
		𞸚: "ظ",
		𞹺: "ظ",
		𞺚: "ظ",
		𞺺: "ظ",
		ﻇ: "ظ",
		ﻈ: "ظ",
		ﻆ: "ظ",
		ﻅ: "ظ",
		ﲹ,
		ﴻ,
		ﰨ,
		"؏": "ع",
		𞸏: "ع",
		𞸯: "ع",
		𞹏: "ع",
		𞹯: "ع",
		𞺏: "ع",
		𞺯: "ع",
		ﻋ: "ع",
		ﻌ: "ع",
		ﻊ: "ع",
		ﻉ: "ع",
		ﲺ,
		ﰩ,
		ﷄ,
		ﵵ,
		ﷷ,
		ﲻ,
		ﰪ,
		ﵷ,
		ﵶ,
		ﵸ,
		ﶶ,
		ﴓ,
		ﳷ,
		ﴔ,
		ﳸ,
		𞸛: "غ",
		𞸻: "غ",
		𞹛: "غ",
		𞹻: "غ",
		𞺛: "غ",
		𞺻: "غ",
		ﻏ: "غ",
		ﻐ: "غ",
		ﻎ: "غ",
		ﻍ: "غ",
		ﲼ,
		ﰫ,
		ﲽ,
		ﰬ,
		ﵹ,
		ﵻ,
		ﵺ,
		ﴕ,
		ﳹ,
		ﴖ,
		ﳺ,
		𞸐: "ف",
		𞸰: "ف",
		𞹰: "ف",
		𞺐: "ف",
		𞺰: "ف",
		ﻓ: "ف",
		ﻔ: "ف",
		ﻒ: "ف",
		ﻑ: "ف",
		ڧ: "ف",
		ﲾ,
		ﰭ,
		ﲿ,
		ﰮ,
		ﳀ,
		ﰯ,
		ﵽ,
		ﵼ,
		ﳁ,
		ﰰ,
		ﷁ,
		ﱼ,
		ﰱ,
		ﱽ,
		ﰲ,
		𞸞: "ڡ",
		𞹾: "ڡ",
		ࢻ: "ڡ",
		ٯ: "ڡ",
		𞸟: "ڡ",
		𞹟: "ڡ",
		ࢼ: "ڡ",
		ڤ,
		ﭬ,
		ﭭ,
		ﭫ,
		ﭪ,
		ڨ,
		ࢤ,
		ﭰ: "ڦ",
		ﭱ: "ڦ",
		ﭯ: "ڦ",
		ﭮ: "ڦ",
		𞸒: "ق",
		𞸲: "ق",
		𞹒: "ق",
		𞹲: "ق",
		𞺒: "ق",
		𞺲: "ق",
		ﻗ: "ق",
		ﻘ: "ق",
		ﻖ: "ق",
		ﻕ: "ق",
		ﳂ,
		ﰳ,
		ﷱ,
		ﳃ,
		ﰴ,
		ﶴ,
		ﵾ,
		ﵿ,
		ﶲ,
		ﱾ,
		ﰵ,
		ﱿ,
		ﰶ,
		𞸊: "ك",
		𞸪: "ك",
		𞹪: "ك",
		ﻛ: "ك",
		ﻜ: "ك",
		ﻚ: "ك",
		ﻙ: "ك",
		ک: "ك",
		ﮐ: "ك",
		ﮑ: "ك",
		ﮏ: "ك",
		ﮎ: "ك",
		ڪ: "ك",
		ڭ,
		ﯕ,
		ﯖ,
		ﯔ,
		ﯓ,
		ݣ,
		ﲀ: "كl",
		ﰷ: "كl",
		ﳄ,
		ﰸ,
		ﳅ,
		ﰹ,
		ﳆ,
		ﰺ,
		ﳇ,
		ﳫ,
		ﲁ,
		ﰻ,
		ﳈ,
		ﳬ,
		ﲂ,
		ﰼ,
		ﷃ,
		ﶻ,
		ﶷ,
		ﲃ,
		ﰽ,
		ﲄ,
		ﰾ,
		ݢ: "ڬ",
		ﮔ: "گ",
		ﮕ: "گ",
		ﮓ: "گ",
		ﮒ: "گ",
		ࢰ: "گ",
		ڴ,
		ﮜ: "ڱ",
		ﮝ: "ڱ",
		ﮛ: "ڱ",
		ﮚ: "ڱ",
		ﮘ: "ڳ",
		ﮙ: "ڳ",
		ﮗ: "ڳ",
		ﮖ: "ڳ",
		𞸋: "ل",
		𞸫: "ل",
		𞹋: "ل",
		𞺋: "ل",
		𞺫: "ل",
		ﻟ: "ل",
		ﻠ: "ل",
		ﻞ: "ل",
		ﻝ: "ل",
		ڷ,
		ڵ,
		ﻼ: "لl",
		ﻻ: "لl",
		ﻺ,
		ﻹ,
		ﻸ,
		ﻷ,
		ﳍ: "لo",
		ﻶ,
		ﻵ,
		ﳉ,
		ﰿ,
		ﶃ,
		ﶄ,
		ﶺ,
		ﶼ,
		ﶬ,
		ﳊ,
		ﱀ,
		ﶵ,
		ﶀ,
		ﶂ,
		ﶁ,
		ﳋ,
		ﱁ,
		ﶆ,
		ﶅ,
		ﳌ,
		ﳭ,
		ﲅ,
		ﱂ,
		ﶈ,
		ﶇ,
		ﶭ,
		ﲆ,
		ﱃ,
		ﲇ,
		ﱄ,
		𞸌: "م",
		𞸬: "م",
		𞹬: "م",
		𞺌: "م",
		𞺬: "م",
		ﻣ: "م",
		ﻤ: "م",
		ﻢ: "م",
		ﻡ: "م",
		ࢧ,
		"۾": "م͈",
		ﲈ: "مl",
		ﳎ,
		ﱅ,
		ﶌ,
		ﶒ,
		ﶍ,
		ﷀ,
		ﳏ,
		ﱆ,
		ﶉ,
		ﶊ,
		ﷴ,
		ﶋ,
		ﳐ,
		ﱇ,
		ﶎ,
		ﶏ,
		ﶹ,
		ﳑ,
		ﲉ,
		ﱈ,
		ﶱ,
		ﱉ,
		ﱊ,
		𞸍: "ن",
		𞸭: "ن",
		𞹍: "ن",
		𞹭: "ن",
		𞺍: "ن",
		𞺭: "ن",
		ﻧ: "ن",
		ﻨ: "ن",
		ﻦ: "ن",
		ﻥ: "ن",
		ݨ,
		ݩ,
		ﳖ: "نo",
		ﳯ: "نo",
		ﶸ,
		ﶽ,
		ﶘ,
		ﶗ,
		ﶙ,
		ﷇ,
		ﳓ,
		ﱌ,
		ﶕ,
		ﶖ,
		ﶳ,
		ﳔ,
		ﱍ,
		ﲊ,
		ﲋ,
		ﳕ,
		ﳮ,
		ﲌ,
		ﱎ,
		ﶛ,
		ﶚ,
		ﲍ,
		ﲎ,
		ﱏ,
		ﲏ,
		ﱐ,
		ۂ: "ۀ",
		ﮥ: "ۀ",
		ﮤ: "ۀ",
		"𐋤": "و",
		𞸅: "و",
		𞺅: "و",
		𞺥: "و",
		ﻮ: "و",
		ﻭ: "و",
		ࢱ: "و",
		ۋ,
		ﯟ,
		ﯞ,
		ۇ,
		ﯘ,
		ﯗ,
		ۆ,
		ﯚ,
		ﯙ,
		ۉ,
		ﯣ,
		ﯢ,
		ۈ,
		ﯜ,
		ﯛ,
		ؤ,
		ﺆ,
		ﺅ,
		ٶ,
		ٷ,
		ﯝ,
		ﷸ,
		ﯡ: "ۅ",
		ﯠ: "ۅ",
		ٮ: "ى",
		𞸜: "ى",
		𞹼: "ى",
		ں: "ى",
		𞸝: "ى",
		𞹝: "ى",
		ﮟ: "ى",
		ﮞ: "ى",
		ࢽ: "ى",
		ﯨ: "ى",
		ﯩ: "ى",
		ﻰ: "ى",
		ﻯ: "ى",
		ي: "ى",
		𞸉: "ى",
		𞸩: "ى",
		𞹉: "ى",
		𞹩: "ى",
		𞺉: "ى",
		𞺩: "ى",
		ﻳ: "ى",
		ﻴ: "ى",
		ﻲ: "ى",
		ﻱ: "ى",
		ی: "ى",
		ﯾ: "ى",
		ﯿ: "ى",
		ﯽ: "ى",
		ﯼ: "ى",
		ے: "ى",
		ﮯ: "ى",
		ﮮ: "ى",
		ٹ,
		ﭨ,
		ﭩ,
		ﭧ,
		ﭦ,
		ڻ,
		ﮢ,
		ﮣ,
		ﮡ,
		ﮠ,
		پ,
		ﭘ,
		ﭙ,
		ﭗ,
		ﭖ,
		ث,
		𞸖,
		𞸶,
		𞹶,
		𞺖,
		𞺶,
		ﺛ,
		ﺜ,
		ﺚ,
		ﺙ,
		ڽ,
		ۑ,
		ؿ,
		ࢷ,
		ݖ,
		ێ,
		ࢺ,
		ؽ,
		ࢨ,
		ﲐ,
		ﱝ,
		ﳞ: "ىo",
		ﳱ: "ىo",
		ﳦ,
		ئ,
		ﺋ,
		ﺌ,
		ﺊ,
		ﺉ,
		ٸ,
		ﯫ,
		ﯪ,
		ﲛ,
		ﳠ,
		ﯭ,
		ﯬ,
		ﯸ,
		ﯷ,
		ﯶ,
		ﲗ,
		ﰀ,
		ﲘ,
		ﰁ,
		ﲙ,
		ﱤ,
		ﱥ,
		ﲚ,
		ﳟ,
		ﱦ,
		ﰂ,
		ﱧ,
		ﯯ,
		ﯮ,
		ﯱ,
		ﯰ,
		ﯳ,
		ﯲ,
		ﯵ,
		ﯴ,
		ﯻ,
		ﯺ,
		ﱨ,
		ﯹ,
		ﰃ,
		ﱩ,
		ﰄ,
		ﳚ,
		ﱕ,
		ﰑ,
		ﶯ,
		ﳛ,
		ﱖ,
		ﶮ,
		ﳜ,
		ﱗ,
		ﲑ,
		ﱶ,
		ﲒ,
		ﱷ,
		ﳝ,
		ﳰ,
		ﲓ,
		ﱘ,
		ﲦ,
		ﳥ,
		ﱸ,
		ﰒ,
		ﶝ,
		ﶜ,
		ﶰ,
		ﲔ,
		ﱹ,
		ﲕ,
		ﱙ,
		ﲖ,
		ﱚ,
		ﱺ,
		ﰓ,
		ﱻ,
		ﰔ,
		ﮱ: "ۓ",
		ﮰ: "ۓ",
		𐊸: "ⵀ",
		"⁞": "ⵂ",
		"⸽": "ⵂ",
		"⦙": "ⵂ",
		"︙": "ⵗ",
		"⁝": "ⵗ",
		"⋮": "ⵗ",
		Մ: "ሆ",
		Ռ: "ቡ",
		Ի: "ኮ",
		Պ: "ጣ",
		आ,
		ऒ,
		ओ,
		औ,
		ऄ,
		ऑ,
		ऍ,
		ऎ,
		ऐ,
		ई,
		ઽ: "ऽ",
		𑇜: "ꣻ",
		"𑇋": "ऺ",
		"ુ": "ु",
		"ૂ": "ू",
		"ੋ": "ॆ",
		"੍": "्",
		"્": "्",
		আ,
		ৠ,
		ৡ,
		𑒒: "ঘ",
		𑒔: "চ",
		𑒖: "জ",
		𑒘: "ঞ",
		𑒙: "ট",
		𑒛: "ড",
		𑒪: "ণ",
		𑒞: "ত",
		𑒟: "থ",
		𑒠: "দ",
		𑒡: "ধ",
		𑒢: "ন",
		𑒣: "প",
		𑒩: "ব",
		𑒧: "ম",
		𑒨: "য",
		𑒫: "র",
		𑒝: "ল",
		𑒭: "ষ",
		𑒮: "স",
		𑓄: "ঽ",
		"𑒰": "া",
		"𑒱": "ি",
		"𑒹": "ে",
		"𑒼": "ো",
		"𑒾": "ৌ",
		"𑓂": "্",
		"𑒽": "ৗ",
		ਉ,
		ਊ,
		ਆ,
		ਐ,
		ਔ,
		ਇ,
		ਈ,
		ਏ,
		આ,
		ઑ,
		ઓ,
		ઔ,
		ઍ,
		એ,
		ઐ,
		ଆ,
		"௮": "அ",
		ர: "ஈ",
		"ா": "ஈ",
		"௫": "ஈு",
		"௨": "உ",
		ഉ: "உ",
		ஊ,
		ഊ,
		"௭": "எ",
		"௷": "எவ",
		ஜ: "ஐ",
		ജ: "ஐ",
		"௧": "க",
		"௪": "ச",
		"௬": "சு",
		"௲": "சூ",
		ഺ,
		ണ: "ண",
		"௺": "நீ",
		"௴": "மீ",
		"௰": "ய",
		ഴ: "ழ",
		"ௗ": "ள",
		"ை": "ன",
		ശ: "ஶ",
		"௸": "ஷ",
		"ി": "ி",
		"ീ": "ி",
		"ொ": "ெஈ",
		"ௌ": "ெள",
		"ோ": "ேஈ",
		ಅ: "అ",
		ಆ: "ఆ",
		ಇ: "ఇ",
		ౠ,
		ౡ,
		ಒ: "ఒ",
		ఔ,
		ಔ,
		ఓ,
		ಓ,
		ಜ: "జ",
		ಞ: "ఞ",
		ఢ,
		ಣ: "ణ",
		థ,
		భ,
		ಯ: "య",
		ఠ,
		ಱ: "ఱ",
		ಲ: "ల",
		ష,
		హ,
		మ,
		"ూ": "ుా",
		"ౄ": "ృా",
		ೡ,
		ഈ,
		ഐ,
		ഓ,
		ഔ,
		ൡ: "ഞ",
		"൫": "ദ്ര",
		"൹": "നു",
		ഌ,
		ങ,
		"൯": "ന്",
		ൻ,
		"൬": "ന്ന",
		"൚": "ന്മ",
		റ: "ര",
		"൪": "ര്",
		ർ,
		"൮": "വ്ര",
		"൶": "ഹ്മ",
		"ൂ": "ു",
		"ൃ": "ു",
		"ൈ": "െെ",
		"෪": "ජ",
		"෫": "ද",
		𑐓,
		𑐙,
		𑐤,
		𑐪,
		𑐭,
		𑐯,
		𑗘,
		𑗙,
		𑗚,
		𑗛,
		"𑗜": "𑖲",
		"𑗝": "𑖳",
		ฃ: "ข",
		ด: "ค",
		ต: "ค",
		ม: "ฆ",
		ຈ: "จ",
		ซ: "ช",
		ฏ: "ฎ",
		ท: "ฑ",
		ບ: "บ",
		ປ: "ป",
		ຝ: "ฝ",
		ພ: "พ",
		ຟ: "ฟ",
		ฦ: "ภ",
		ຍ: "ย",
		"។": "ฯ",
		ๅ: "า",
		ำ,
		"ិ": "ิ",
		"ី": "ี",
		"ឹ": "ึ",
		"ឺ": "ื",
		"ຸ": "ุ",
		"ູ": "ู",
		แ,
		ໜ,
		ໝ,
		ຳ,
		"༂": "འུྂཿ",
		"༃": "འུྂ༔",
		ཪ: "ར",
		ༀ,
		"ཷ": "ྲཱྀ",
		"ཹ": "ླཱྀ",
		"𑲲": "𑲪",
		ႁ,
		က,
		ၰ,
		ၦ,
		ဟ,
		ၯ,
		ၾ,
		ဩ,
		ဪ,
		"႞": "ႃ̊",
		ឣ: "អ",
		"᧐": "ᦞ",
		"᧑": "ᦱ",
		"᪀": "ᩅ",
		"᪐": "ᩅ",
		"꩓": "ꨁ",
		"꩖": "ꨣ",
		"᭒": "ᬍ",
		"᭓": "ᬑ",
		"᭘": "ᬨ",
		ꦣ: "ꦝ",
		ᢖ: "ᡜ",
		ᡕ: "ᠵ",
		ῶ: "Ꮿ",
		ᐍ,
		ᐫ,
		ᐑ,
		ᐓ,
		ᐭ,
		ᐕ,
		ᐘ,
		ᐮ,
		ᐚ,
		ᣝ,
		ᓑ: "ᐡ",
		ᕀ: "ᐩ",
		ᐿ,
		ᑃ,
		"⍩": "ᐵ",
		ᑇ,
		ᑜ,
		"⸧": "ᑐ",
		"⊃": "ᑐ",
		ᑞ,
		ᑩ,
		"⟉": "ᑐ/",
		"⫗": "ᑐᑕ",
		ᑠ,
		"⸦": "ᑕ",
		"⊂": "ᑕ",
		ᑢ,
		ᑪ,
		ᑤ,
		ᑵ,
		ᒅ,
		ᑹ,
		ᑽ,
		ᘃ: "ᒉ",
		ᒓ,
		ᒕ,
		ᒗ,
		ᒛ,
		ᘂ: "ᒐ",
		ᒝ,
		ᒟ,
		ᒭ,
		ᒱ,
		ᒳ,
		ᒵ,
		ᒹ,
		ᓊ,
		ᣇ,
		ᣉ,
		ᣋ,
		ᣍ,
		ᓌ,
		ᓎ,
		ᘄ: "ᓓ",
		ᓝ,
		ᓟ,
		ᓡ,
		ᓣ,
		ᓥ,
		ᘇ: "ᓚ",
		ᓧ,
		ᓩ,
		ᓷ,
		ᓹ,
		ᓻ,
		ᓽ,
		ᓿ,
		ᔁ,
		ᔃ,
		ᔌ,
		ᔎ,
		ᔍ,
		ᔏ,
		ᔘ,
		ᔚ,
		ᔜ,
		ᔞ,
		ᔠ,
		ᔢ,
		ᔤ,
		ᔲ,
		ᔴ,
		ᔶ,
		ᔸ,
		ᔺ,
		ᔼ,
		ᘢ: "ᕃ",
		ᣠ,
		ᘣ: "ᕆ",
		ᘤ: "ᕊ",
		ᕏ,
		ᖃ,
		ᖄ,
		ᖁ,
		ᕿ,
		ᙯ,
		ᕾ,
		ᖀ,
		ᖂ,
		ᖅ,
		ᕜ,
		ᣣ,
		ᣤ,
		ᕩ,
		ᣥ,
		ᣨ,
		ᖑ,
		ᙰ,
		ᖎ,
		ᖏ,
		ᖐ,
		ᖒ,
		ᖓ,
		ᖔ,
		ᙳ,
		ᙱ,
		ᙲ,
		ᙴ,
		ᙵ,
		ᙶ,
		ᣪ,
		ᙷ,
		ᙸ,
		ᙹ,
		ᙺ,
		ᙻ,
		ᙼ,
		ᙽ,
		"⪫": "ᗒ",
		"⪪": "ᗕ",
		ꓷ: "ᗡ",
		ᣰ,
		ᣲ,
		ᶻ: "ᙆ",
		ꓭ: "ᙠ",
		ᶺ: "ᣔ",
		ᴾ: "ᣖ",
		ᣜ,
		ˡ: "ᣳ",
		ʳ: "ᣴ",
		ˢ: "ᣵ",
		ᣛ: "ᣵ",
		ꚰ: "ᚹ",
		ᛡ: "ᚼ",
		"⍿": "ᚽ",
		ᛂ: "ᚽ",
		"𝈿": "ᛋ",
		"↑": "ᛏ",
		"↿": "ᛐ",
		"⥮": "ᛐ⇂",
		"⥣": "ᛐᛚ",
		ⵣ: "ᛯ",
		"↾": "ᛚ",
		"⨡": "ᛚ",
		"⋄": "ᛜ",
		"◇": "ᛜ",
		"◊": "ᛜ",
		"♢": "ᛜ",
		"🝔": "ᛜ",
		𑢷: "ᛜ",
		𐊔: "ᛜ",
		"⍚": "ᛜ̲",
		"⋈": "ᛞ",
		"⨝": "ᛞ",
		𐓐: "ᛦ",
		"↕": "ᛨ",
		"𐳼": "𐲂",
		"𐳺": "𐲥",
		ㄱ: "ᄀ",
		ᆨ: "ᄀ",
		ᄁ,
		ㄲ,
		ᆩ,
		ᇺ,
		ᅚ,
		ᇃ,
		ᇻ,
		ᆪ,
		ㄳ,
		ᇄ,
		ᇼ,
		ᇽ,
		ᇾ,
		ㄴ: "ᄂ",
		ᆫ: "ᄂ",
		ᄓ,
		ᇅ,
		ᄔ,
		ㅥ,
		ᇿ,
		ᄕ,
		ㅦ,
		ᇆ,
		ퟋ,
		ᄖ,
		ᅛ,
		ᇇ,
		ㅧ,
		ᅜ,
		ᆬ,
		ㄵ,
		ퟌ,
		ᇉ,
		ᅝ,
		ᆭ,
		ㄶ,
		ᇈ,
		ㅨ,
		ㄷ: "ᄃ",
		ᆮ: "ᄃ",
		ᄗ,
		ᇊ,
		ᄄ,
		ㄸ,
		ퟍ,
		ퟎ,
		ᅞ,
		ᇋ,
		ꥠ,
		ꥡ,
		ퟏ,
		ꥢ,
		ퟐ,
		ퟑ,
		ꥣ,
		ퟒ,
		ퟓ,
		ퟔ,
		ㄹ: "ᄅ",
		ᆯ: "ᄅ",
		ꥤ,
		ᆰ,
		ㄺ,
		ꥥ,
		ퟕ,
		ᇌ,
		ㅩ,
		ퟖ,
		ᄘ,
		ᇍ,
		ꥦ,
		ᇎ,
		ㅪ,
		ꥧ,
		ᇏ,
		ᄙ,
		ᇐ,
		ퟗ,
		ꥨ,
		ᆱ,
		ㄻ,
		ᇑ,
		ᇒ,
		ퟘ,
		ꥩ,
		ᆲ,
		ㄼ,
		ퟙ,
		ꥪ,
		ᇓ,
		ㅫ,
		ꥫ,
		ᇕ,
		ퟚ,
		ᇔ,
		ꥬ,
		ᆳ,
		ㄽ,
		ᇖ,
		ᄛ,
		ퟝ,
		ꥭ,
		ꥮ,
		ᇘ,
		ᆴ,
		ㄾ,
		ᆵ,
		ㄿ,
		ᄚ,
		ㅀ,
		ᄻ,
		ᆶ,
		ퟲ,
		ᇗ,
		ㅬ,
		ퟛ,
		ᇙ,
		ㅭ,
		ퟜ,
		ㅁ: "ᄆ",
		ᆷ: "ᄆ",
		ꥯ,
		ᇚ,
		ퟞ,
		ퟟ,
		ꥰ,
		ᇛ,
		ퟠ,
		ᄜ,
		ㅮ,
		ᇜ,
		ퟡ,
		ꥱ,
		ᇝ,
		ㅯ,
		ᇞ,
		ᄝ,
		ㅱ,
		ᇢ,
		ퟢ,
		ᇠ,
		ᇡ,
		ᇟ,
		ㅰ,
		ㅂ: "ᄇ",
		ᆸ: "ᄇ",
		ᄞ,
		ㅲ,
		ᄟ,
		ᄠ,
		ㅳ,
		ퟣ,
		ᇣ,
		ퟤ,
		ퟥ,
		ᄈ,
		ㅃ,
		ퟦ,
		ᄬ,
		ㅹ,
		ᄡ,
		ㅄ,
		ᆹ,
		ᄢ,
		ㅴ,
		ᄣ,
		ㅵ,
		ퟧ,
		ᄤ,
		ᄥ,
		ᄦ,
		ꥲ,
		ᄫ,
		ㅸ,
		ᇦ,
		ᄧ,
		ㅶ,
		ퟨ,
		ᄨ,
		ퟩ,
		ꥳ,
		ᄩ,
		ㅷ,
		ᄪ,
		ᇤ,
		ꥴ,
		ᇥ,
		ㅅ: "ᄉ",
		ᆺ: "ᄉ",
		ᄭ,
		ㅺ,
		ᇧ,
		ᄮ,
		ㅻ,
		ᄯ,
		ㅼ,
		ᇨ,
		ᄰ,
		ᇩ,
		ᄱ,
		ퟪ,
		ᄲ,
		ㅽ,
		ᇪ,
		ᄳ,
		ퟫ,
		ᄊ,
		ㅆ,
		ᆻ,
		ퟬ,
		ퟭ,
		ꥵ,
		ᄴ,
		ᄵ,
		ᄶ,
		ㅾ,
		ퟯ,
		ᄷ,
		ퟰ,
		ᄸ,
		ᄹ,
		ퟱ,
		ᄺ,
		ퟮ,
		ㅇ: "ᄋ",
		ᆼ: "ᄋ",
		ᅁ,
		ᇬ,
		ᇭ,
		ᅂ,
		ꥶ,
		ᅃ,
		ᅄ,
		ᅅ,
		ᇱ,
		ㆂ,
		ᅇ,
		ㆀ,
		ᇮ,
		ᅈ,
		ᅉ,
		ᇯ,
		ᅊ,
		ᅋ,
		ꥷ,
		ᅆ,
		ᇲ,
		ㆃ,
		ㅈ: "ᄌ",
		ᆽ: "ᄌ",
		ퟷ,
		ퟸ,
		ᅍ,
		ᄍ,
		ㅉ,
		ퟹ,
		ꥸ,
		ㅊ: "ᄎ",
		ᆾ: "ᄎ",
		ᅒ,
		ᅓ,
		ㅋ: "ᄏ",
		ᆿ: "ᄏ",
		ㅌ: "ᄐ",
		ᇀ: "ᄐ",
		ꥹ,
		ㅍ: "ᄑ",
		ᇁ: "ᄑ",
		ᅖ,
		ᇳ,
		ퟺ,
		ᅗ,
		ㆄ,
		ᇴ,
		ퟻ,
		ꥺ,
		ㅎ: "ᄒ",
		ᇂ: "ᄒ",
		ᇵ,
		ᇶ,
		ᇷ,
		ᇸ,
		ꥻ,
		ᅘ,
		ㆅ,
		ᄽ,
		ᄿ,
		ㅿ: "ᅀ",
		ᇫ: "ᅀ",
		ퟳ,
		ퟴ,
		ㆁ: "ᅌ",
		ᇰ: "ᅌ",
		ퟵ,
		ퟶ,
		ᅏ,
		ᅑ,
		ㆆ: "ᅙ",
		ᇹ: "ᅙ",
		ꥼ,
		ㅤ: "ᅠ",
		ㅏ: "ᅡ",
		ᆣ,
		ᅶ,
		ᅷ,
		ᅢ,
		ㅐ,
		ㅑ: "ᅣ",
		ᅸ,
		ᅹ,
		ᆤ,
		ᅤ,
		ㅒ,
		ㅓ: "ᅥ",
		ᅼ,
		ᅺ,
		ᅻ,
		ᅦ,
		ㅔ,
		ㅕ: "ᅧ",
		ᆥ,
		ᅽ,
		ᅾ,
		ᅨ,
		ㅖ,
		ㅗ: "ᅩ",
		ᅪ,
		ㅘ,
		ᅫ,
		ㅙ,
		ᆦ,
		ᆧ,
		ᅿ,
		ᆀ,
		ힰ,
		ᆁ,
		ᆂ,
		ힱ,
		ᆃ,
		ᅬ,
		ㅚ,
		ㅛ: "ᅭ",
		ힲ,
		ힳ,
		ᆄ,
		ㆇ,
		ᆆ,
		ᆅ,
		ㆈ,
		ힴ,
		ᆇ,
		ᆈ,
		ㆉ,
		ㅜ: "ᅮ",
		ᆉ,
		ᆊ,
		ᅯ,
		ㅝ,
		ᆋ,
		ᅰ,
		ㅞ,
		ힵ,
		ᆌ,
		ᆍ,
		ᅱ,
		ㅟ,
		ힶ,
		ㅠ: "ᅲ",
		ᆎ,
		ힷ,
		ᆏ,
		ᆐ,
		ᆑ,
		ㆊ,
		ᆒ,
		ㆋ,
		ힸ,
		ᆓ,
		ᆔ,
		ㆌ,
		ㆍ: "ᆞ",
		ퟅ,
		ᆟ,
		ퟆ,
		ᆠ,
		ᆢ,
		ᆡ,
		ㆎ,
		ヘ: "へ",
		"⍁": "〼",
		"⧄": "〼",
		"꒞": "ꁊ",
		"꒬": "ꁐ",
		"꒜": "ꃀ",
		"꒨": "ꄲ",
		"꒿": "ꉙ",
		"꒾": "ꊱ",
		"꒔": "ꋍ",
		"꓀": "ꎫ",
		"꓂": "ꎵ",
		"꒺": "ꎿ",
		"꒰": "ꏂ",
		"꒧": "ꑘ",
		"⊥": "ꓕ",
		"⟂": "ꓕ",
		"𝈜": "ꓕ",
		Ʇ: "ꓕ",
		Ꞟ: "ꓤ",
		"⅁": "ꓨ",
		"⅂": "ꓶ",
		"𝈕": "ꓶ",
		"𝈫": "ꓶ",
		𖼦: "ꓶ",
		𐐑: "ꓶ",
		"⅃": "𖼀",
		𑫦,
		𑫨,
		𑫩,
		𑫪,
		𑫧,
		𑫴,
		𑫶,
		𑫷,
		𑫸,
		𑫵,
		𑫬,
		𑫭,
		𑫮,
		"⊕": "𐊨",
		"⨁": "𐊨",
		"🜨": "𐊨",
		Ꚛ,
		"▽": "𐊼",
		"𝈔": "𐊼",
		"🜄": "𐊼",
		"⧖": "𐋀",
		ꞛ,
		Ꞛ,
		"𐒠": "𐒆",
		𐏑,
		𐏓,
		𒀸,
		"☥": "𐦞",
		𓋹,
		〹: "卄",
		不: "不",
		丽: "丽",
		並: "並",
		"⎜": "丨",
		"⎟": "丨",
		"⎢": "丨",
		"⎥": "丨",
		"⎪": "丨",
		"⎮": "丨",
		"㇑": "丨",
		ᅵ: "丨",
		ㅣ: "丨",
		"⼁": "丨",
		ᆜ,
		ᆘ,
		ᆙ,
		ힽ,
		ힾ,
		ힿ,
		ퟀ,
		ᆚ,
		ퟁ,
		ퟂ,
		ᆛ,
		ퟃ,
		ᆝ,
		ퟄ,
		串: "串",
		丸: "丸",
		丹: "丹",
		乁: "乁",
		"㇠": "乙",
		"⼄": "乙",
		"㇟": "乚",
		"⺃": "乚",
		"㇖": "乛",
		"⺂": "乛",
		"⻲": "亀",
		亂: "亂",
		"㇚": "亅",
		"⼅": "亅",
		了: "了",
		ニ: "二",
		"⼆": "二",
		𠄢,
		"⼇": "亠",
		亮: "亮",
		"⼈": "人",
		イ: "亻",
		"⺅": "亻",
		什: "什",
		仌: "仌",
		令: "令",
		你: "你",
		倂: "併",
		倂: "併",
		侀: "侀",
		來: "來",
		例: "例",
		侮: "侮",
		侮: "侮",
		侻: "侻",
		便: "便",
		值: "値",
		倫: "倫",
		偺: "偺",
		備: "備",
		像: "像",
		僚: "僚",
		僧: "僧",
		僧: "僧",
		㒞: "㒞",
		"⼉": "儿",
		兀: "兀",
		"⺎": "兀",
		充: "充",
		免: "免",
		免: "免",
		兔: "兔",
		兤: "兤",
		"⼊": "入",
		內: "內",
		全: "全",
		兩: "兩",
		ハ: "八",
		"⼋": "八",
		六: "六",
		具: "具",
		𠔜,
		𠔥,
		冀: "冀",
		㒹: "㒹",
		"⼌": "冂",
		再: "再",
		𠕋,
		冒: "冒",
		冕: "冕",
		㒻: "㒻",
		最: "最",
		"⼍": "冖",
		冗: "冗",
		冤: "冤",
		"⼎": "冫",
		冬: "冬",
		况: "况",
		况: "况",
		冷: "冷",
		凉: "凉",
		凌: "凌",
		凜: "凜",
		凞: "凞",
		"⼏": "几",
		𠘺,
		凵: "凵",
		"⼐": "凵",
		"⼑": "刀",
		"⺉": "刂",
		刃: "刃",
		切: "切",
		切: "切",
		列: "列",
		利: "利",
		㓟: "㓟",
		刺: "刺",
		刻: "刻",
		剆: "剆",
		割: "割",
		剷: "剷",
		劉: "劉",
		𠠄,
		カ: "力",
		力: "力",
		"⼒": "力",
		劣: "劣",
		㔕: "㔕",
		劳: "劳",
		勇: "勇",
		勇: "勇",
		勉: "勉",
		勉: "勉",
		勒: "勒",
		勞: "勞",
		勤: "勤",
		勤: "勤",
		勵: "勵",
		"⼓": "勹",
		勺: "勺",
		勺: "勺",
		包: "包",
		匆: "匆",
		𠣞,
		"⼔": "匕",
		北: "北",
		北: "北",
		"⼕": "匚",
		"⼖": "匸",
		匿: "匿",
		"⼗": "十",
		〸: "十",
		〺: "卅",
		卉: "卉",
		"࿖": "卍",
		"࿕": "卐",
		卑: "卑",
		卑: "卑",
		博: "博",
		ト: "卜",
		"⼘": "卜",
		"⼙": "卩",
		"⺋": "㔾",
		即: "即",
		卵: "卵",
		卽: "卽",
		卿: "卿",
		卿: "卿",
		卿: "卿",
		"⼚": "厂",
		𠨬,
		"⼛": "厶",
		參: "參",
		"⼜": "又",
		及: "及",
		叟: "叟",
		𠭣,
		ロ: "口",
		"⼝": "口",
		囗: "口",
		"⼞": "口",
		句: "句",
		叫: "叫",
		叱: "叱",
		吆: "吆",
		吏: "吏",
		吝: "吝",
		吸: "吸",
		呂: "呂",
		呈: "呈",
		周: "周",
		咞: "咞",
		咢: "咢",
		咽: "咽",
		䎛: "㖈",
		哶: "哶",
		唐: "唐",
		啓: "啓",
		啟: "啓",
		啕: "啕",
		啣: "啣",
		善: "善",
		善: "善",
		喇: "喇",
		喙: "喙",
		喙: "喙",
		喝: "喝",
		喝: "喝",
		喫: "喫",
		喳: "喳",
		嗀: "嗀",
		嗂: "嗂",
		嗢: "嗢",
		嘆: "嘆",
		嘆: "嘆",
		噑: "噑",
		噴: "噴",
		器: "器",
		囹: "囹",
		圖: "圖",
		圗: "圗",
		"⼟": "土",
		士: "土",
		"⼠": "土",
		型: "型",
		城: "城",
		㦳: "㘽",
		埴: "埴",
		堍: "堍",
		報: "報",
		堲: "堲",
		塀: "塀",
		塚: "塚",
		塚: "塚",
		塞: "塞",
		填: "塡",
		壿: "墫",
		墬: "墬",
		墳: "墳",
		壘: "壘",
		壟: "壟",
		𡓤,
		壮: "壮",
		売: "売",
		壷: "壷",
		"⼡": "夂",
		夆: "夆",
		"⼢": "夊",
		タ: "夕",
		"⼣": "夕",
		多: "多",
		夢: "夢",
		"⼤": "大",
		奄: "奄",
		奈: "奈",
		契: "契",
		奔: "奔",
		奢: "奢",
		女: "女",
		"⼥": "女",
		𡚨,
		𡛪,
		姘: "姘",
		姬: "姬",
		娛: "娛",
		娧: "娧",
		婢: "婢",
		婦: "婦",
		嬀: "媯",
		㛮: "㛮",
		㛼: "㛼",
		媵: "媵",
		嬈: "嬈",
		嬨: "嬨",
		嬾: "嬾",
		嬾: "嬾",
		"⼦": "子",
		"⼧": "宀",
		宅: "宅",
		𡧈,
		寃: "寃",
		寘: "寘",
		寧: "寧",
		寧: "寧",
		寧: "寧",
		寮: "寮",
		寳: "寳",
		𡬘,
		"⼨": "寸",
		寿: "寿",
		将: "将",
		"⼩": "小",
		尢: "尢",
		"⺐": "尢",
		"⼪": "尢",
		"⺏": "尣",
		㞁: "㞁",
		"⼫": "尸",
		尿: "尿",
		屠: "屠",
		屢: "屢",
		層: "層",
		履: "履",
		屮: "屮",
		屮: "屮",
		"⼬": "屮",
		𡴋,
		"⼭": "山",
		峀: "峀",
		岍: "岍",
		𡷤,
		𡷦,
		崙: "崙",
		嵃: "嵃",
		嵐: "嵐",
		嵫: "嵫",
		嵮: "嵮",
		嵼: "嵼",
		嶲: "嶲",
		嶺: "嶺",
		"⼮": "巛",
		巢: "巢",
		エ: "工",
		"⼯": "工",
		"⼰": "己",
		"⺒": "巳",
		㠯: "㠯",
		巽: "巽",
		"⼱": "巾",
		帲: "帡",
		帨: "帨",
		帽: "帽",
		幩: "幩",
		㡢: "㡢",
		𢆃,
		"⼲": "干",
		年: "年",
		𢆟,
		"⺓": "幺",
		"⼳": "幺",
		"⼴": "广",
		度: "度",
		㡼: "㡼",
		庰: "庰",
		庳: "庳",
		庶: "庶",
		廊: "廊",
		廊: "廊",
		廉: "廉",
		廒: "廒",
		廓: "廓",
		廙: "廙",
		廬: "廬",
		"⼵": "廴",
		廾: "廾",
		"⼶": "廾",
		𢌱,
		𢌱,
		弄: "弄",
		"⼷": "弋",
		"⼸": "弓",
		弢: "弢",
		弢: "弢",
		"⼹": "彐",
		"⺔": "彑",
		当: "当",
		㣇: "㣇",
		"⼺": "彡",
		形: "形",
		彩: "彩",
		彫: "彫",
		"⼻": "彳",
		律: "律",
		㣣: "㣣",
		徚: "徚",
		復: "復",
		徭: "徭",
		"⼼": "心",
		"⺖": "忄",
		"⺗": "㣺",
		忍: "忍",
		志: "志",
		念: "念",
		忹: "忹",
		怒: "怒",
		怜: "怜",
		恵: "恵",
		㤜: "㤜",
		㤺: "㤺",
		悁: "悁",
		悔: "悔",
		悔: "悔",
		惇: "惇",
		惘: "惘",
		惡: "惡",
		𢛔,
		愈: "愈",
		慨: "慨",
		慄: "慄",
		慈: "慈",
		慌: "慌",
		慌: "慌",
		慎: "慎",
		慎: "慎",
		慠: "慠",
		慺: "慺",
		憎: "憎",
		憎: "憎",
		憎: "憎",
		憐: "憐",
		憤: "憤",
		憯: "憯",
		憲: "憲",
		𢡄,
		𢡊,
		懞: "懞",
		懲: "懲",
		懲: "懲",
		懲: "懲",
		懶: "懶",
		懶: "懶",
		戀: "戀",
		"⼽": "戈",
		成: "成",
		戛: "戛",
		戮: "戮",
		戴: "戴",
		"⼾": "戶",
		戸: "戶",
		"⼿": "手",
		"⺘": "扌",
		扝: "扝",
		抱: "抱",
		拉: "拉",
		拏: "拏",
		拓: "拓",
		拔: "拔",
		拼: "拼",
		拾: "拾",
		𢬌,
		挽: "挽",
		捐: "捐",
		捨: "捨",
		捻: "捻",
		掃: "掃",
		掠: "掠",
		掩: "掩",
		揄: "揄",
		揤: "揤",
		摒: "摒",
		𢯱,
		搜: "搜",
		搢: "搢",
		揅: "揅",
		摩: "摩",
		摷: "摷",
		摾: "摾",
		㨮: "㨮",
		搉: "㩁",
		撚: "撚",
		撝: "撝",
		擄: "擄",
		㩬: "㩬",
		"⽀": "支",
		"⽁": "攴",
		"⺙": "攵",
		敏: "敏",
		敏: "敏",
		敖: "敖",
		敬: "敬",
		數: "數",
		𣀊,
		"⽂": "文",
		"⻫": "斉",
		"⽃": "斗",
		料: "料",
		"⽄": "斤",
		"⽅": "方",
		旅: "旅",
		"⽆": "无",
		"⺛": "旡",
		既: "既",
		旣: "旣",
		"⽇": "日",
		易: "易",
		曶: "㫚",
		㫤: "㫤",
		晉: "晉",
		晩: "晚",
		晴: "晴",
		晴: "晴",
		暑: "暑",
		暑: "暑",
		暈: "暈",
		㬈: "㬈",
		暜: "暜",
		暴: "暴",
		曆: "曆",
		㬙: "㬙",
		𣊸,
		"⽈": "曰",
		更: "更",
		書: "書",
		"⽉": "月",
		𣍟,
		肦: "朌",
		胐: "朏",
		胊: "朐",
		脁: "朓",
		胶: "㬵",
		朗: "朗",
		朗: "朗",
		朗: "朗",
		脧: "朘",
		望: "望",
		望: "望",
		幐: "㬺",
		䐠: "㬻",
		𣎓,
		膧: "朣",
		𣎜,
		"⽊": "木",
		李: "李",
		杓: "杓",
		杖: "杖",
		杞: "杞",
		𣏃,
		柿: "杮",
		杻: "杻",
		枅: "枅",
		林: "林",
		㭉: "㭉",
		𣏕,
		柳: "柳",
		柺: "柺",
		栗: "栗",
		栟: "栟",
		桒: "桒",
		𣑭,
		梁: "梁",
		梅: "梅",
		梅: "梅",
		梎: "梎",
		梨: "梨",
		椔: "椔",
		楂: "楂",
		㮝: "㮝",
		㮝: "㮝",
		槩: "㮣",
		樧: "榝",
		榣: "榣",
		槪: "槪",
		樂: "樂",
		樂: "樂",
		樂: "樂",
		樓: "樓",
		𣚣,
		檨: "檨",
		櫓: "櫓",
		櫛: "櫛",
		欄: "欄",
		㰘: "㰘",
		"⽋": "欠",
		次: "次",
		𣢧,
		歔: "歔",
		㱎: "㱎",
		"⽌": "止",
		"⻭": "歯",
		歲: "歲",
		歷: "歷",
		歹: "歹",
		"⽍": "歹",
		"⺞": "歺",
		殟: "殟",
		殮: "殮",
		"⽎": "殳",
		殺: "殺",
		殺: "殺",
		殺: "殺",
		殻: "殻",
		𣪍,
		"⽏": "毋",
		"⺟": "母",
		𣫺,
		"⽐": "比",
		"⽑": "毛",
		"⽒": "氏",
		"⺠": "民",
		"⽓": "气",
		"⽔": "水",
		"⺡": "氵",
		"⺢": "氺",
		汎: "汎",
		汧: "汧",
		沈: "沈",
		沿: "沿",
		泌: "泌",
		泍: "泍",
		泥: "泥",
		𣲼,
		洛: "洛",
		洞: "洞",
		洴: "洴",
		派: "派",
		流: "流",
		流: "流",
		流: "流",
		洖: "洖",
		浩: "浩",
		浪: "浪",
		海: "海",
		海: "海",
		浸: "浸",
		涅: "涅",
		𣴞,
		淋: "淋",
		淚: "淚",
		淪: "淪",
		淹: "淹",
		渚: "渚",
		港: "港",
		湮: "湮",
		潙: "溈",
		滋: "滋",
		滋: "滋",
		溜: "溜",
		溺: "溺",
		滇: "滇",
		滑: "滑",
		滛: "滛",
		㴳: "㴳",
		漏: "漏",
		漢: "漢",
		漢: "漢",
		漣: "漣",
		𣻑,
		潮: "潮",
		𣽞,
		𣾎,
		濆: "濆",
		濫: "濫",
		濾: "濾",
		瀛: "瀛",
		瀞: "瀞",
		瀞: "瀞",
		瀹: "瀹",
		灊: "灊",
		㶖: "㶖",
		"⽕": "火",
		"⺣": "灬",
		灰: "灰",
		灷: "灷",
		災: "災",
		炙: "炙",
		炭: "炭",
		烈: "烈",
		烙: "烙",
		煮: "煮",
		煮: "煮",
		𤉣,
		煅: "煅",
		煉: "煉",
		𤋮,
		熜: "熜",
		燎: "燎",
		燐: "燐",
		𤎫,
		爐: "爐",
		爛: "爛",
		爨: "爨",
		"⽖": "爪",
		爫: "爫",
		"⺤": "爫",
		爵: "爵",
		爵: "爵",
		"⽗": "父",
		"⽘": "爻",
		"⺦": "丬",
		"⽙": "爿",
		"⽚": "片",
		牐: "牐",
		"⽛": "牙",
		𤘈,
		"⽜": "牛",
		牢: "牢",
		犀: "犀",
		犕: "犕",
		"⽝": "犬",
		"⺨": "犭",
		犯: "犯",
		狀: "狀",
		𤜵,
		狼: "狼",
		猪: "猪",
		猪: "猪",
		𤠔,
		獵: "獵",
		獺: "獺",
		"⽞": "玄",
		率: "率",
		率: "率",
		"⽟": "玉",
		王: "王",
		㺬: "㺬",
		玥: "玥",
		玲: "玲",
		㺸: "㺸",
		㺸: "㺸",
		珞: "珞",
		琉: "琉",
		理: "理",
		琢: "琢",
		瑇: "瑇",
		瑜: "瑜",
		瑩: "瑩",
		瑱: "瑱",
		瑱: "瑱",
		璅: "璅",
		璉: "璉",
		璘: "璘",
		瓊: "瓊",
		"⽠": "瓜",
		"⽡": "瓦",
		㼛: "㼛",
		甆: "甆",
		"⽢": "甘",
		"⽣": "生",
		甤: "甤",
		"⽤": "用",
		"⽥": "田",
		画: "画",
		甾: "甾",
		𤰶,
		留: "留",
		略: "略",
		異: "異",
		異: "異",
		𤲒,
		"⽦": "疋",
		"⽧": "疒",
		痢: "痢",
		瘐: "瘐",
		瘟: "瘟",
		瘝: "瘝",
		療: "療",
		癩: "癩",
		"⽨": "癶",
		"⽩": "白",
		𤾡,
		𤾸,
		"⽪": "皮",
		"⽫": "皿",
		𥁄,
		㿼: "㿼",
		益: "益",
		益: "益",
		盛: "盛",
		盧: "盧",
		䀈: "䀈",
		"⽬": "目",
		直: "直",
		直: "直",
		𥃲,
		𥃳,
		省: "省",
		䀘: "䀘",
		𥄙,
		眞: "眞",
		真: "真",
		真: "真",
		𥄳,
		着: "着",
		睊: "睊",
		睊: "睊",
		鿃: "䀹",
		䀹: "䀹",
		䀹: "䀹",
		晣: "䀿",
		䁆: "䁆",
		瞋: "瞋",
		𥉉,
		瞧: "瞧",
		"⽭": "矛",
		"⽮": "矢",
		"⽯": "石",
		䂖: "䂖",
		𥐝,
		硏: "研",
		硎: "硎",
		硫: "硫",
		碌: "碌",
		碌: "碌",
		碑: "碑",
		磊: "磊",
		磌: "磌",
		磌: "磌",
		磻: "磻",
		䃣: "䃣",
		礪: "礪",
		"⽰": "示",
		"⺭": "礻",
		礼: "礼",
		社: "社",
		祈: "祈",
		祉: "祉",
		𥘦,
		祐: "祐",
		祖: "祖",
		祖: "祖",
		祝: "祝",
		神: "神",
		祥: "祥",
		視: "視",
		視: "視",
		祿: "祿",
		𥚚,
		禍: "禍",
		禎: "禎",
		福: "福",
		福: "福",
		𥛅,
		禮: "禮",
		"⽱": "禸",
		"⽲": "禾",
		秊: "秊",
		䄯: "䄯",
		秫: "秫",
		稜: "稜",
		穊: "穊",
		穀: "穀",
		穀: "穀",
		穏: "穏",
		"⽳": "穴",
		突: "突",
		𥥼,
		窱: "窱",
		立: "立",
		"⽴": "立",
		"⻯": "竜",
		𥪧,
		𥪧,
		竮: "竮",
		"⽵": "竹",
		笠: "笠",
		節: "節",
		節: "節",
		䈂: "䈂",
		𥮫,
		篆: "篆",
		䈧: "䈧",
		築: "築",
		𥲀,
		𥳐,
		簾: "簾",
		籠: "籠",
		"⽶": "米",
		类: "类",
		粒: "粒",
		精: "精",
		糒: "糒",
		糖: "糖",
		糨: "糨",
		䊠: "䊠",
		糣: "糣",
		糧: "糧",
		"⽷": "糸",
		"⺯": "糹",
		𥾆,
		紀: "紀",
		紐: "紐",
		索: "索",
		累: "累",
		絶: "絕",
		絣: "絣",
		絛: "絛",
		綠: "綠",
		綾: "綾",
		緇: "緇",
		練: "練",
		練: "練",
		練: "練",
		縂: "縂",
		䌁: "䌁",
		縉: "縉",
		縷: "縷",
		繁: "繁",
		繅: "繅",
		𦇚,
		䌴: "䌴",
		"⽸": "缶",
		𦈨,
		缾: "缾",
		𦉇,
		"⽹": "网",
		"⺫": "罒",
		"⺲": "罒",
		"⺱": "罓",
		䍙: "䍙",
		署: "署",
		𦋙,
		罹: "罹",
		罺: "罺",
		羅: "羅",
		𦌾,
		"⽺": "羊",
		羕: "羕",
		羚: "羚",
		羽: "羽",
		"⽻": "羽",
		翺: "翺",
		老: "老",
		"⽼": "老",
		"⺹": "耂",
		者: "者",
		者: "者",
		者: "者",
		"⽽": "而",
		𦓚,
		"⽾": "耒",
		𦔣,
		"⽿": "耳",
		聆: "聆",
		聠: "聠",
		𦖨,
		聯: "聯",
		聰: "聰",
		聾: "聾",
		"⾀": "聿",
		"⺺": "肀",
		"⾁": "肉",
		肋: "肋",
		肭: "肭",
		育: "育",
		䏕: "䏕",
		䏙: "䏙",
		腁: "胼",
		脃: "脃",
		脾: "脾",
		䐋: "䐋",
		朡: "朡",
		𦞧,
		𦞵,
		朦: "䑃",
		臘: "臘",
		"⾂": "臣",
		臨: "臨",
		"⾃": "自",
		臭: "臭",
		"⾄": "至",
		"⾅": "臼",
		舁: "舁",
		舁: "舁",
		舄: "舄",
		"⾆": "舌",
		舘: "舘",
		"⾇": "舛",
		"⾈": "舟",
		䑫: "䑫",
		"⾉": "艮",
		良: "良",
		"⾊": "色",
		"⾋": "艸",
		艹: "艹",
		艹: "艹",
		"⺾": "艹",
		"⺿": "艹",
		"⻀": "艹",
		芋: "芋",
		芑: "芑",
		芝: "芝",
		花: "花",
		芳: "芳",
		芽: "芽",
		若: "若",
		若: "若",
		苦: "苦",
		𦬼,
		茶: "茶",
		荒: "荒",
		荣: "荣",
		茝: "茝",
		茣: "茣",
		莽: "莽",
		荓: "荓",
		菉: "菉",
		菊: "菊",
		菌: "菌",
		菜: "菜",
		菧: "菧",
		華: "華",
		菱: "菱",
		著: "著",
		著: "著",
		𦰶,
		莭: "莭",
		落: "落",
		葉: "葉",
		蔿: "蒍",
		𦳕,
		𦵫,
		蓮: "蓮",
		蓱: "蓱",
		蓳: "蓳",
		蓼: "蓼",
		蔖: "蔖",
		䔫: "䔫",
		蕤: "蕤",
		𦼬,
		藍: "藍",
		䕝: "䕝",
		𦾱,
		䕡: "䕡",
		藺: "藺",
		蘆: "蘆",
		䕫: "䕫",
		蘒: "蘒",
		蘭: "蘭",
		𧃒,
		虁: "蘷",
		蘿: "蘿",
		"⾌": "虍",
		"⻁": "虎",
		虐: "虐",
		虜: "虜",
		虜: "虜",
		虧: "虧",
		虩: "虩",
		"⾍": "虫",
		蚩: "蚩",
		蚈: "蚈",
		蛢: "蛢",
		蜎: "蜎",
		蜨: "蜨",
		蝫: "蝫",
		蟡: "蟡",
		蝹: "蝹",
		蝹: "蝹",
		螆: "螆",
		䗗: "䗗",
		𧏊,
		螺: "螺",
		蠁: "蠁",
		䗹: "䗹",
		蠟: "蠟",
		"⾎": "血",
		行: "行",
		"⾏": "行",
		衠: "衠",
		衣: "衣",
		"⾐": "衣",
		"⻂": "衤",
		裂: "裂",
		𧙧,
		裏: "裏",
		裗: "裗",
		裞: "裞",
		裡: "裡",
		裸: "裸",
		裺: "裺",
		䘵: "䘵",
		褐: "褐",
		襁: "襁",
		襤: "襤",
		"⾑": "襾",
		"⻄": "西",
		"⻃": "覀",
		覆: "覆",
		見: "見",
		"⾒": "見",
		𧢮,
		"⻅": "见",
		"⾓": "角",
		"⾔": "言",
		𧥦,
		詽: "訮",
		訞: "䚶",
		䚾: "䚾",
		䛇: "䛇",
		誠: "誠",
		說: "說",
		說: "說",
		調: "調",
		請: "請",
		諒: "諒",
		論: "論",
		諭: "諭",
		諭: "諭",
		諸: "諸",
		諸: "諸",
		諾: "諾",
		諾: "諾",
		謁: "謁",
		謁: "謁",
		謹: "謹",
		謹: "謹",
		識: "識",
		讀: "讀",
		讏: "讆",
		變: "變",
		變: "變",
		"⻈": "讠",
		"⾕": "谷",
		"⾖": "豆",
		豈: "豈",
		豕: "豕",
		"⾗": "豕",
		豣: "豜",
		"⾘": "豸",
		𧲨,
		"⾙": "貝",
		貫: "貫",
		賁: "賁",
		賂: "賂",
		賈: "賈",
		賓: "賓",
		贈: "贈",
		贈: "贈",
		贛: "贛",
		"⻉": "贝",
		"⾚": "赤",
		"⾛": "走",
		起: "起",
		趆: "赿",
		𧻓,
		𧼯,
		"⾜": "足",
		跋: "跋",
		趼: "趼",
		跺: "跥",
		路: "路",
		跰: "跰",
		躛: "躗",
		"⾝": "身",
		車: "車",
		"⾞": "車",
		軔: "軔",
		輧: "軿",
		輦: "輦",
		輪: "輪",
		輸: "輸",
		輸: "輸",
		輻: "輻",
		轢: "轢",
		"⻋": "车",
		"⾟": "辛",
		辞: "辞",
		辰: "辰",
		"⾠": "辰",
		"⾡": "辵",
		辶: "辶",
		"⻌": "辶",
		"⻍": "辶",
		巡: "巡",
		連: "連",
		逸: "逸",
		逸: "逸",
		遲: "遲",
		遼: "遼",
		𨗒,
		𨗭,
		邏: "邏",
		"⾢": "邑",
		邔: "邔",
		郎: "郎",
		郞: "郎",
		郞: "郎",
		郱: "郱",
		都: "都",
		𨜮,
		鄑: "鄑",
		鄛: "鄛",
		"⾣": "酉",
		酪: "酪",
		醙: "醙",
		醴: "醴",
		"⾤": "釆",
		里: "里",
		"⾥": "里",
		量: "量",
		金: "金",
		"⾦": "金",
		鈴: "鈴",
		鈸: "鈸",
		鉶: "鉶",
		鋗: "鋗",
		鋘: "鋘",
		鉼: "鉼",
		錄: "錄",
		鍊: "鍊",
		鎮: "鎭",
		鏹: "鏹",
		鐕: "鐕",
		𨯺,
		"⻐": "钅",
		"⻑": "長",
		"⾧": "長",
		"⻒": "镸",
		"⻓": "长",
		"⾨": "門",
		開: "開",
		䦕: "䦕",
		閭: "閭",
		閷: "閷",
		𨵷,
		"⻔": "门",
		"⾩": "阜",
		"⻏": "阝",
		"⻖": "阝",
		阮: "阮",
		陋: "陋",
		降: "降",
		陵: "陵",
		陸: "陸",
		陼: "陼",
		隆: "隆",
		隣: "隣",
		䧦: "䧦",
		"⾪": "隶",
		隷: "隷",
		隸: "隷",
		隸: "隷",
		"⾫": "隹",
		雃: "雃",
		離: "離",
		難: "難",
		難: "難",
		"⾬": "雨",
		零: "零",
		雷: "雷",
		霣: "霣",
		𩅅,
		露: "露",
		靈: "靈",
		"⾭": "靑",
		"⻘": "青",
		靖: "靖",
		靖: "靖",
		𩇟,
		"⾮": "非",
		"⾯": "面",
		𩈚,
		"⾰": "革",
		䩮: "䩮",
		䩶: "䩶",
		"⾱": "韋",
		韛: "韛",
		韠: "韠",
		"⻙": "韦",
		"⾲": "韭",
		𩐊,
		"⾳": "音",
		響: "響",
		響: "響",
		"⾴": "頁",
		䪲: "䪲",
		頋: "頋",
		頋: "頋",
		頋: "頋",
		領: "領",
		頩: "頩",
		𩒖,
		頻: "頻",
		頻: "頻",
		類: "類",
		"⻚": "页",
		"⾵": "風",
		𩖶,
		"⻛": "风",
		"⾶": "飛",
		"⻜": "飞",
		"⻝": "食",
		"⾷": "食",
		"⻟": "飠",
		飢: "飢",
		飯: "飯",
		飼: "飼",
		䬳: "䬳",
		館: "館",
		餩: "餩",
		"⻠": "饣",
		"⾸": "首",
		"⾹": "香",
		馧: "馧",
		"⾺": "馬",
		駂: "駂",
		駱: "駱",
		駾: "駾",
		驪: "驪",
		"⻢": "马",
		"⾻": "骨",
		䯎: "䯎",
		"⾼": "高",
		"⾽": "髟",
		𩬰,
		鬒: "鬒",
		鬒: "鬒",
		"⾾": "鬥",
		"⾿": "鬯",
		"⿀": "鬲",
		"⿁": "鬼",
		"⻤": "鬼",
		"⿂": "魚",
		魯: "魯",
		鱀: "鱀",
		鱗: "鱗",
		"⻥": "鱼",
		"⿃": "鳥",
		鳽: "鳽",
		䳎: "䳎",
		鵧: "鵧",
		䳭: "䳭",
		𪃎,
		鶴: "鶴",
		𪄅,
		䳸: "䳸",
		鷺: "鷺",
		𪈎,
		鸞: "鸞",
		鹃: "鹂",
		"⿄": "鹵",
		鹿: "鹿",
		"⿅": "鹿",
		𪊑,
		麗: "麗",
		麟: "麟",
		"⿆": "麥",
		"⻨": "麦",
		麻: "麻",
		"⿇": "麻",
		𪎒,
		"⿈": "黃",
		"⻩": "黄",
		"⿉": "黍",
		黎: "黎",
		䵖: "䵖",
		"⿊": "黑",
		黒: "黑",
		墨: "墨",
		黹: "黹",
		"⿋": "黹",
		"⿌": "黽",
		鼅: "鼅",
		黾: "黾",
		"⿍": "鼎",
		鼏: "鼏",
		"⿎": "鼓",
		鼖: "鼖",
		"⿏": "鼠",
		鼻: "鼻",
		"⿐": "鼻",
		齃: "齃",
		"⿑": "齊",
		"⻬": "齐",
		"⿒": "齒",
		𪘀,
		"⻮": "齿",
		龍: "龍",
		"⿓": "龍",
		龎: "龎",
		"⻰": "龙",
		龜: "龜",
		龜: "龜",
		龜: "龜",
		"⿔": "龜",
		"⻳": "龟",
		"⿕": "龠"
	};
})), require_unhomoglyph = /* @__PURE__ */ __commonJSMin(((e, b) => {
	var x = (init_data(), __toCommonJS(data_exports).default);
	function S(e) {
		return e.replace(/([.?*+^$[\]\\(){}|-])/g, "\\$1");
	}
	var C = RegExp(Object.keys(x).map(S).join("|"), "g");
	function w(e) {
		return x[e];
	}
	function T(e) {
		return e.replace(C, w);
	}
	b.exports = T;
})), objectToString = Object.prototype.toString, isError = (e) => objectToString.call(e) === "[object Error]", errorMessages = new Set([
	"network error",
	"NetworkError when attempting to fetch resource.",
	"The Internet connection appears to be offline.",
	"Network request failed",
	"fetch failed",
	"terminated",
	" A network error occurred.",
	"Network connection lost"
]);
function isNetworkError(e) {
	if (!(e && isError(e) && e.name === "TypeError" && typeof e.message == "string")) return !1;
	let { message: b, stack: x } = e;
	return b === "Load failed" ? x === void 0 || "__sentry_captured__" in e : b.startsWith("error sending request for url") || b === "Failed to fetch" || b.startsWith("Failed to fetch (") && b.endsWith(")") ? !0 : errorMessages.has(b);
}
function validateRetries(e) {
	if (typeof e == "number") {
		if (e < 0) throw TypeError("Expected `retries` to be a non-negative number.");
		if (Number.isNaN(e)) throw TypeError("Expected `retries` to be a valid number or Infinity, got NaN.");
	} else if (e !== void 0) throw TypeError("Expected `retries` to be a number or Infinity.");
}
function validateNumberOption(e, b, { min: x = 0, allowInfinity: S = !1 } = {}) {
	if (b !== void 0) {
		if (typeof b != "number" || Number.isNaN(b)) throw TypeError(`Expected \`${e}\` to be a number${S ? " or Infinity" : ""}.`);
		if (!S && !Number.isFinite(b)) throw TypeError(`Expected \`${e}\` to be a finite number.`);
		if (b < x) throw TypeError(`Expected \`${e}\` to be \u2265 ${x}.`);
	}
}
var AbortError = class extends Error {
	constructor(e) {
		super(), e instanceof Error ? (this.originalError = e, {message: e} = e) : (this.originalError = Error(e), this.originalError.stack = this.stack), this.name = "AbortError", this.message = e;
	}
};
function calculateDelay(e, b) {
	let x = Math.max(1, e + 1), S = b.randomize ? Math.random() + 1 : 1, C = Math.round(S * b.minTimeout * b.factor ** (x - 1));
	return C = Math.min(C, b.maxTimeout), C;
}
function calculateRemainingTime(e, b) {
	return Number.isFinite(b) ? b - (performance.now() - e) : b;
}
async function onAttemptFailure({ error: e, attemptNumber: b, retriesConsumed: x, startTime: S, options: C }) {
	let w = e instanceof Error ? e : /* @__PURE__ */ TypeError(`Non-error was thrown: "${e}". You should only throw errors.`);
	if (w instanceof AbortError) throw w.originalError;
	let T = Number.isFinite(C.retries) ? Math.max(0, C.retries - x) : C.retries, E = C.maxRetryTime ?? Infinity, D = Object.freeze({
		error: w,
		attemptNumber: b,
		retriesLeft: T,
		retriesConsumed: x
	});
	if (await C.onFailedAttempt(D), calculateRemainingTime(S, E) <= 0) throw w;
	let O = await C.shouldConsumeRetry(D), k = calculateRemainingTime(S, E);
	if (k <= 0 || T <= 0) throw w;
	if (w instanceof TypeError && !isNetworkError(w)) {
		if (O) throw w;
		return C.signal?.throwIfAborted(), !1;
	}
	if (!await C.shouldRetry(D)) throw w;
	if (!O) return C.signal?.throwIfAborted(), !1;
	let A = calculateDelay(x, C), j = Math.min(A, k);
	return C.signal?.throwIfAborted(), j > 0 && await new Promise((e, b) => {
		let x = () => {
			clearTimeout(S), C.signal?.removeEventListener("abort", x), b(C.signal.reason);
		}, S = setTimeout(() => {
			C.signal?.removeEventListener("abort", x), e();
		}, j);
		C.unref && S.unref?.(), C.signal?.addEventListener("abort", x, { once: !0 });
	}), C.signal?.throwIfAborted(), !0;
}
async function pRetry(e, b = {}) {
	if (b = { ...b }, validateRetries(b.retries), Object.hasOwn(b, "forever")) throw Error("The `forever` option is no longer supported. For many use-cases, you can set `retries: Infinity` instead.");
	b.retries ??= 10, b.factor ??= 2, b.minTimeout ??= 1e3, b.maxTimeout ??= Infinity, b.maxRetryTime ??= Infinity, b.randomize ??= !1, b.onFailedAttempt ??= () => {}, b.shouldRetry ??= () => !0, b.shouldConsumeRetry ??= () => !0, validateNumberOption("factor", b.factor, {
		min: 0,
		allowInfinity: !1
	}), validateNumberOption("minTimeout", b.minTimeout, {
		min: 0,
		allowInfinity: !1
	}), validateNumberOption("maxTimeout", b.maxTimeout, {
		min: 0,
		allowInfinity: !0
	}), validateNumberOption("maxRetryTime", b.maxRetryTime, {
		min: 0,
		allowInfinity: !0
	}), b.factor > 0 || (b.factor = 1), b.signal?.throwIfAborted();
	let x = 0, S = 0, C = performance.now();
	for (; !Number.isFinite(b.retries) || S <= b.retries;) {
		x++;
		try {
			b.signal?.throwIfAborted();
			let S = await e(x);
			return b.signal?.throwIfAborted(), S;
		} catch (e) {
			await onAttemptFailure({
				error: e,
				attemptNumber: x,
				retriesConsumed: S,
				startTime: C,
				options: b
			}) && S++;
		}
	}
	throw Error("Retry attempts exhausted without throwing an error.");
}
var NamespacedValue = class {
	constructor(e, b) {
		if (this.stable = e, this.unstable = b, !this.unstable && !this.stable) throw Error("One of stable or unstable values must be supplied");
	}
	get name() {
		return this.stable ? this.stable : this.unstable;
	}
	get altName() {
		return this.stable ? this.unstable : null;
	}
	get names() {
		var e = [this.name], b = this.altName;
		return b && e.push(b), e;
	}
	matches(e) {
		return this.name === e || this.altName === e;
	}
	findIn(e) {
		var b = void 0;
		return this.name && (b = e?.[this.name]), !b && this.altName && (b = e?.[this.altName]), b;
	}
	includedIn(e) {
		var b = !1;
		return this.name && (b = e.includes(this.name)), !b && this.altName && (b = e.includes(this.altName)), b;
	}
}, ServerControlledNamespacedValue = class extends NamespacedValue {
	constructor() {
		super(...arguments), _defineProperty(this, "preferUnstable", !1);
	}
	setPreferUnstable(e) {
		this.preferUnstable = e;
	}
	get name() {
		return this.stable && !this.preferUnstable ? this.stable : this.unstable;
	}
}, UnstableValue = class extends NamespacedValue {
	constructor(e, b) {
		if (super(e, b), !this.unstable) throw Error("Unstable value must be supplied");
	}
	get name() {
		return this.unstable;
	}
	get altName() {
		return this.stable;
	}
}, LocationAssetType = /* @__PURE__ */ function(e) {
	return e.Self = "m.self", e.Pin = "m.pin", e;
}({}), M_ASSET = new UnstableValue("m.asset", "org.matrix.msc3488.asset"), M_TIMESTAMP = new UnstableValue("m.ts", "org.matrix.msc3488.ts"), M_LOCATION = new UnstableValue("m.location", "org.matrix.msc3488.location"), ReceiptType = /* @__PURE__ */ function(e) {
	return e.Read = "m.read", e.FullyRead = "m.fully_read", e.ReadPrivate = "m.read.private", e;
}({}), MAIN_ROOM_TIMELINE = "main", import_unhomoglyph = /* @__PURE__ */ __toESM(require_unhomoglyph());
function ownKeys$25(e, b) {
	var x = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var S = Object.getOwnPropertySymbols(e);
		b && (S = S.filter(function(b) {
			return Object.getOwnPropertyDescriptor(e, b).enumerable;
		})), x.push.apply(x, S);
	}
	return x;
}
function _objectSpread$25(e) {
	for (var b = 1; b < arguments.length; b++) {
		var x = arguments[b] == null ? {} : arguments[b];
		b % 2 ? ownKeys$25(Object(x), !0).forEach(function(b) {
			_defineProperty(e, b, x[b]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(x)) : ownKeys$25(Object(x)).forEach(function(b) {
			Object.defineProperty(e, b, Object.getOwnPropertyDescriptor(x, b));
		});
	}
	return e;
}
var interns = /* @__PURE__ */ new Map();
function internaliseString(e) {
	return e instanceof String && (e = e.toString()), interns.has(e) || interns.set(e, e), interns.get(e);
}
function encodeParams(e, b) {
	var x = b ?? new URLSearchParams(), S = function(e) {
		w != null && (Array.isArray(w) ? w.forEach((b) => {
			x.append(e, String(b));
		}) : x.append(e, String(w)));
	};
	for (var [C, w] of Object.entries(e)) S(C);
	return x;
}
function replaceParam(e, b, x) {
	var S = _objectSpread$25(_objectSpread$25({}, x), {}, { [b]: x[e] });
	return delete S[e], S;
}
function encodeUri(e, b) {
	for (var x in b) if (b.hasOwnProperty(x)) {
		var S = b[x];
		S != null && (e = e.replace(x, encodeURIComponent(S)));
	}
	return e;
}
function removeElement(e, b, x) {
	var S;
	if (x) {
		for (S = e.length - 1; S >= 0; S--) if (b(e[S], S, e)) return e.splice(S, 1), !0;
	} else for (S = 0; S < e.length; S++) if (b(e[S], S, e)) return e.splice(S, 1), !0;
	return !1;
}
function checkObjectHasKeys(e, b) {
	for (var x of b) if (!e.hasOwnProperty(x)) throw Error("Missing required key: " + x);
}
function deepCopy(e) {
	return JSON.parse(JSON.stringify(e));
}
function deepCompare(e, b) {
	if (e === b) return !0;
	if (typeof e != typeof b) return !1;
	if (typeof e == "number" && isNaN(e) && isNaN(b)) return !0;
	if (e === null || b === null) return e === b;
	if (!(e instanceof Object) || e.constructor !== b.constructor || e.prototype !== b.prototype) return !1;
	if (e instanceof RegExp || e instanceof Date) return e.toString() === b.toString();
	if (Array.isArray(e)) {
		if (e.length !== b.length) return !1;
		for (var x = 0; x < e.length; x++) if (!deepCompare(e[x], b[x])) return !1;
	} else {
		for (var S in b) if (b.hasOwnProperty(S) !== e.hasOwnProperty(S)) return !1;
		for (var C in e) if (b.hasOwnProperty(C) !== e.hasOwnProperty(C) || !deepCompare(e[C], b[C])) return !1;
	}
	return !0;
}
function deepSortedObjectEntries(e) {
	if (typeof e != "object" || !e || Array.isArray(e)) return e;
	var b = [];
	for (var [x, S] of Object.entries(e)) b.push([x, deepSortedObjectEntries(S)]);
	return b.sort((e, b) => lexicographicCompare(e[0], b[0])), b;
}
function isNumber(e) {
	return typeof e == "number" && isFinite(e);
}
function removeHiddenChars(e) {
	return typeof e == "string" ? (0, import_unhomoglyph.default)(e.normalize("NFD").replace(removeHiddenCharsRegex, "")) : "";
}
function removeDirectionOverrideChars(e) {
	return typeof e == "string" ? e.replace(/[\u202d-\u202e]/g, "") : "";
}
function normalize(e) {
	return removeHiddenChars(e.toLowerCase()).replace(/[\\'!"#$%&()*+,\-./:;<=>?@[\]^_`{|}~\u2000-\u206f\u2e00-\u2e7f]/g, "").toLowerCase();
}
var removeHiddenCharsRegex = /[\u2000-\u200F\u202A-\u202F\u0300-\u036F\uFEFF\u061C\u2800\u2062-\u2063\s]/g;
function escapeRegExp(e) {
	return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function globToRegexp(e) {
	return escapeRegExp(e).replace(/\\\*/g, ".*").replace(/\?/g, ".");
}
function ensureNoTrailingSlash(e) {
	return e != null && e.endsWith("/") ? e.slice(0, -1) : e;
}
function sleep(e, b) {
	return new Promise((x) => {
		setTimeout(x, e, b);
	});
}
function logDuration(e, b, x) {
	return _logDuration.apply(this, arguments);
}
function _logDuration() {
	return _logDuration = _asyncToGenerator(function* (e, b, x) {
		var S = Date.now();
		try {
			return yield x();
		} finally {
			var C = Date.now();
			e.debug(`[Perf]: ${b} took ${C - S}ms`);
		}
	}), _logDuration.apply(this, arguments);
}
function logDurationSync(e, b, x) {
	var S = Date.now();
	try {
		return x();
	} finally {
		var C = Date.now();
		e.debug(`[Perf]: ${b} took ${C - S}ms`);
	}
}
function isNullOrUndefined(e) {
	return e == null;
}
function promiseMapSeries(e, b) {
	return _promiseMapSeries.apply(this, arguments);
}
function _promiseMapSeries() {
	return _promiseMapSeries = _asyncToGenerator(function* (e, b) {
		for (var x of e) yield b(yield x);
	}), _promiseMapSeries.apply(this, arguments);
}
function promiseTry(e) {
	return Promise.resolve(e());
}
function simpleRetryOperation(e, b) {
	return pRetry((b) => e(b), {
		retries: Infinity,
		shouldRetry: b ? (e) => {
			var { error: x } = e;
			return b(x);
		} : void 0,
		factor: 2,
		minTimeout: 3e3,
		maxTimeout: 15e3
	});
}
var DEFAULT_ALPHABET = (() => {
	for (var e = "", b = 32; b <= 126; b++) e += String.fromCharCode(b);
	return e;
})();
function alphabetPad(e, b) {
	var x = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : DEFAULT_ALPHABET;
	return e.padEnd(b, x[0]);
}
function baseToString(e) {
	var b = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : DEFAULT_ALPHABET, x = BigInt(b.length);
	if (e <= x) return b[Number(e) - 1] ?? "";
	var S = e / x, C = Number(e % x) - 1;
	return C < 0 && (S -= BigInt(Math.abs(C)), C = Number(x) - 1), baseToString(S, b) + b[C];
}
function stringToBase(e) {
	for (var b = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : DEFAULT_ALPHABET, x = BigInt(b.length), S = BigInt(0), C = e.length - 1, w = BigInt(0); C >= 0; C--, w++) {
		var T = e.charCodeAt(C) - b.charCodeAt(0);
		S += BigInt(1 + T) * x ** w;
	}
	return S;
}
function averageBetweenStrings(e, b) {
	var x = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : DEFAULT_ALPHABET, S = Math.max(e.length, b.length), C = stringToBase(alphabetPad(e, S, x), x), w = stringToBase(alphabetPad(b, S, x), x), T = (C + w) / BigInt(2);
	return T === C || T == w ? baseToString(T, x) + x[0] : baseToString(T, x);
}
function nextString(e) {
	var b = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : DEFAULT_ALPHABET;
	return baseToString(stringToBase(e, b) + BigInt(1), b);
}
function prevString(e) {
	var b = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : DEFAULT_ALPHABET;
	return baseToString(stringToBase(e, b) - BigInt(1), b);
}
function lexicographicCompare(e, b) {
	return e < b ? -1 : e > b ? 1 : 0;
}
function recursivelyAssign(e, b) {
	var x = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
	for (var [S, C] of Object.entries(b)) {
		if (e[S] instanceof Object && C) {
			recursivelyAssign(e[S], C);
			continue;
		}
		if (C != null || !x) {
			safeSet(e, S, C);
			continue;
		}
	}
	return e;
}
function getContentTimestampWithFallback(e) {
	return M_TIMESTAMP.findIn(e.getContent()) ?? -1;
}
function sortEventsByLatestContentTimestamp(e, b) {
	return getContentTimestampWithFallback(b) - getContentTimestampWithFallback(e);
}
function isSupportedReceiptType(e) {
	return [ReceiptType.Read, ReceiptType.ReadPrivate].includes(e);
}
function mapsEqual(e, b) {
	var x = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : (e, b) => e === b;
	if (e.size !== b.size) return !1;
	for (var [S, C] of e) {
		var w = b.get(S);
		if (w === void 0 || !x(C, w)) return !1;
	}
	return !0;
}
function processMapToObjectValue(e) {
	return e instanceof Map ? recursiveMapToObject(e) : Array.isArray(e) ? e.map((e) => processMapToObjectValue(e)) : e;
}
function recursiveMapToObject(e) {
	var b = /* @__PURE__ */ new Map();
	for (var [x, S] of e) b.set(x, processMapToObjectValue(S));
	return Object.fromEntries(b.entries());
}
function unsafeProp(e) {
	return e === "__proto__" || e === "prototype" || e === "constructor";
}
function safeSet(e, b, x) {
	if (unsafeProp(b)) throw Error("Trying to modify prototype or constructor");
	e[b] = x;
}
function noUnsafeEventProps(e) {
	return !(unsafeProp(e.room_id) || unsafeProp(e.sender) || unsafeProp(e.event_id));
}
var MapWithDefault = class extends Map {
	constructor(e) {
		super(), this.createDefault = e;
	}
	getOrCreate(e) {
		return this.has(e) || this.set(e, this.createDefault()), this.get(e);
	}
}, ACCOUNT_OBJECT_KEY_MIGRATION_STATE = "migrationState", MigrationState = /* @__PURE__ */ function(e) {
	return e[e.NOT_STARTED = 0] = "NOT_STARTED", e[e.INITIAL_DATA_MIGRATED = 1] = "INITIAL_DATA_MIGRATED", e[e.OLM_SESSIONS_MIGRATED = 2] = "OLM_SESSIONS_MIGRATED", e[e.MEGOLM_SESSIONS_MIGRATED = 3] = "MEGOLM_SESSIONS_MIGRATED", e[e.ROOM_SETTINGS_MIGRATED = 4] = "ROOM_SETTINGS_MIGRATED", e[e.INITIAL_OWN_KEY_QUERY_DONE = 5] = "INITIAL_OWN_KEY_QUERY_DONE", e;
}({});
function ownKeys$24(e, b) {
	var x = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var S = Object.getOwnPropertySymbols(e);
		b && (S = S.filter(function(b) {
			return Object.getOwnPropertyDescriptor(e, b).enumerable;
		})), x.push.apply(x, S);
	}
	return x;
}
function _objectSpread$24(e) {
	for (var b = 1; b < arguments.length; b++) {
		var x = arguments[b] == null ? {} : arguments[b];
		b % 2 ? ownKeys$24(Object(x), !0).forEach(function(b) {
			_defineProperty(e, b, x[b]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(x)) : ownKeys$24(Object(x)).forEach(function(b) {
			Object.defineProperty(e, b, Object.getOwnPropertyDescriptor(x, b));
		});
	}
	return e;
}
function encodeSessionKey(e, b) {
	return encodeURIComponent(e) + "/" + encodeURIComponent(b);
}
function decodeSessionKey(e) {
	var b = e.split("/"), x = decodeURIComponent(b[0]), S = decodeURIComponent(b[1]);
	return {
		senderKey: x,
		sessionId: S
	};
}
var MemoryCryptoStore = class {
	constructor() {
		_defineProperty(this, "migrationState", MigrationState.NOT_STARTED), _defineProperty(this, "account", null), _defineProperty(this, "crossSigningKeys", null), _defineProperty(this, "privateKeys", {}), _defineProperty(this, "sessions", {}), _defineProperty(this, "inboundGroupSessions", {}), _defineProperty(this, "inboundGroupSessionsWithheld", {}), _defineProperty(this, "rooms", {}), _defineProperty(this, "sessionsNeedingBackup", {});
	}
	containsData() {
		var e = this;
		return _asyncToGenerator(function* () {
			return e.account !== null;
		})();
	}
	startup() {
		var e = this;
		return _asyncToGenerator(function* () {
			return e;
		})();
	}
	deleteAllData() {
		return Promise.resolve();
	}
	getMigrationState() {
		var e = this;
		return _asyncToGenerator(function* () {
			return e.migrationState;
		})();
	}
	setMigrationState(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			b.migrationState = e;
		})();
	}
	getAccount(e, b) {
		b(this.account);
	}
	storeAccount(e, b) {
		this.account = b;
	}
	getCrossSigningKeys(e, b) {
		b(this.crossSigningKeys);
	}
	getSecretStorePrivateKey(e, b, x) {
		var S = this.privateKeys[x];
		b(S || null);
	}
	storeSecretStorePrivateKey(e, b, x) {
		this.privateKeys[b] = x;
	}
	countEndToEndSessions(e, b) {
		var x = 0;
		for (var S of Object.values(this.sessions)) x += Object.keys(S).length;
		b(x);
	}
	getEndToEndSession(e, b, x, S) {
		var C = this.sessions[e] || {};
		S(C[b] || null);
	}
	getEndToEndSessions(e, b, x) {
		x(this.sessions[e] || {});
	}
	storeEndToEndSession(e, b, x, S) {
		var C = this.sessions[e];
		C === void 0 && (C = {}, this.sessions[e] = C), safeSet(C, b, x);
	}
	getEndToEndSessionsBatch() {
		var e = this;
		return _asyncToGenerator(function* () {
			var b = [];
			for (var x of Object.values(e.sessions)) for (var S of Object.values(x)) if (b.push(S), b.length >= 50) return b;
			return b.length === 0 ? null : b;
		})();
	}
	deleteEndToEndSessionsBatch(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			for (var { deviceKey: x, sessionId: S } of e) {
				var C = b.sessions[x] || {};
				delete C[S], Object.keys(C).length === 0 && delete b.sessions[x];
			}
		})();
	}
	getEndToEndInboundGroupSession(e, b, x, S) {
		var C = encodeSessionKey(e, b);
		S(this.inboundGroupSessions[C] || null, this.inboundGroupSessionsWithheld[C] || null);
	}
	storeEndToEndInboundGroupSession(e, b, x, S) {
		var C = encodeSessionKey(e, b);
		this.inboundGroupSessions[C] = x;
	}
	countEndToEndInboundGroupSessions() {
		var e = this;
		return _asyncToGenerator(function* () {
			return Object.keys(e.inboundGroupSessions).length;
		})();
	}
	getEndToEndInboundGroupSessionsBatch() {
		var e = this;
		return _asyncToGenerator(function* () {
			var b = [];
			for (var [x, S] of Object.entries(e.inboundGroupSessions)) if (b.push(_objectSpread$24(_objectSpread$24({}, decodeSessionKey(x)), {}, {
				sessionData: S,
				needsBackup: x in e.sessionsNeedingBackup
			})), b.length >= 50) return b;
			return b.length === 0 ? null : b;
		})();
	}
	deleteEndToEndInboundGroupSessionsBatch(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			for (var { senderKey: x, sessionId: S } of e) {
				var C = encodeSessionKey(x, S);
				delete b.inboundGroupSessions[C];
			}
		})();
	}
	getEndToEndRooms(e, b) {
		b(this.rooms);
	}
	markSessionsNeedingBackup(e) {
		for (var b of e) {
			var x = encodeSessionKey(b.senderKey, b.sessionId);
			this.sessionsNeedingBackup[x] = !0;
		}
		return Promise.resolve();
	}
	doTxn(e, b, x) {
		return Promise.resolve(x(null));
	}
}, serverNameRegex = /^(?:(?:\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3})|(?:\[[\dA-Fa-f:.]{2,45}])|(?:[A-Za-z\d\-.]{1,255}))(?::\d{1,5})?$/;
function validateServerName(e) {
	return serverNameRegex.exec(e)?.[0] === e;
}
var mediaIdRegex = /^[\w-]+$/;
function validateMediaId(e) {
	return mediaIdRegex.exec(e)?.[0] === e;
}
function getHttpUriForMxc(e, b, x, S, C) {
	var w = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : !1, T = arguments.length > 6 ? arguments[6] : void 0, E = arguments.length > 7 ? arguments[7] : void 0;
	if (typeof b != "string" || !b) return "";
	if (!b.startsWith("mxc://")) return w ? b : "";
	var [D, O, ...k] = b.slice(6).split("/");
	if (k.length > 0 || !validateServerName(D) || !validateMediaId(O)) return "";
	E && (T = !0);
	var A, j = x || S || C ? "thumbnail" : "download";
	A = E ? `/_matrix/client/v1/media/${j}` : `/_matrix/media/v3/${j}`;
	var M = new URL(`${A}/${D}/${O}`, e);
	return x && M.searchParams.set("width", Math.round(x).toString()), S && M.searchParams.set("height", Math.round(S).toString()), C && M.searchParams.set("method", C), typeof T == "boolean" && M.searchParams.set("allow_redirect", JSON.stringify(T)), M.href;
}
var import_loglevel = /* @__PURE__ */ __toESM((/* @__PURE__ */ __commonJSMin(((e, b) => {
	(function(e, x) {
		typeof define == "function" && define.amd ? define(x) : typeof b == "object" && b.exports ? b.exports = x() : e.log = x();
	})(e, function() {
		var e = function() {}, b = "undefined", x = typeof window !== b && typeof window.navigator !== b && /Trident\/|MSIE /.test(window.navigator.userAgent), S = [
			"trace",
			"debug",
			"info",
			"warn",
			"error"
		], C = {}, w = null;
		function T(e, b) {
			var x = e[b];
			if (typeof x.bind == "function") return x.bind(e);
			try {
				return Function.prototype.bind.call(x, e);
			} catch {
				return function() {
					return Function.prototype.apply.apply(x, [e, arguments]);
				};
			}
		}
		function E() {
			console.log && (console.log.apply ? console.log.apply(console, arguments) : Function.prototype.apply.apply(console.log, [console, arguments])), console.trace && console.trace();
		}
		function D(S) {
			return S === "debug" && (S = "log"), typeof console === b ? !1 : S === "trace" && x ? E : console[S] === void 0 ? console.log === void 0 ? e : T(console, "log") : T(console, S);
		}
		function O() {
			for (var x = this.getLevel(), C = 0; C < S.length; C++) {
				var w = S[C];
				this[w] = C < x ? e : this.methodFactory(w, x, this.name);
			}
			if (this.log = this.debug, typeof console === b && x < this.levels.SILENT) return "No console available for logging";
		}
		function k(e) {
			return function() {
				typeof console !== b && (O.call(this), this[e].apply(this, arguments));
			};
		}
		function A(e, b, x) {
			return D(e) || k.apply(this, arguments);
		}
		function j(e, x) {
			var T = this, E, D, k, j = "loglevel";
			typeof e == "string" ? j += ":" + e : typeof e == "symbol" && (j = void 0);
			function M(e) {
				var x = (S[e] || "silent").toUpperCase();
				if (!(typeof window === b || !j)) {
					try {
						window.localStorage[j] = x;
						return;
					} catch {}
					try {
						window.document.cookie = encodeURIComponent(j) + "=" + x + ";";
					} catch {}
				}
			}
			function N() {
				var e;
				if (!(typeof window === b || !j)) {
					try {
						e = window.localStorage[j];
					} catch {}
					if (typeof e === b) try {
						var x = window.document.cookie, S = encodeURIComponent(j), C = x.indexOf(S + "=");
						C !== -1 && (e = /^([^;]+)/.exec(x.slice(C + S.length + 1))[1]);
					} catch {}
					return T.levels[e] === void 0 && (e = void 0), e;
				}
			}
			function P() {
				if (!(typeof window === b || !j)) {
					try {
						window.localStorage.removeItem(j);
					} catch {}
					try {
						window.document.cookie = encodeURIComponent(j) + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC";
					} catch {}
				}
			}
			function F(e) {
				var b = e;
				if (typeof b == "string" && T.levels[b.toUpperCase()] !== void 0 && (b = T.levels[b.toUpperCase()]), typeof b == "number" && b >= 0 && b <= T.levels.SILENT) return b;
				throw TypeError("log.setLevel() called with invalid level: " + e);
			}
			T.name = e, T.levels = {
				TRACE: 0,
				DEBUG: 1,
				INFO: 2,
				WARN: 3,
				ERROR: 4,
				SILENT: 5
			}, T.methodFactory = x || A, T.getLevel = function() {
				return k ?? D ?? E;
			}, T.setLevel = function(e, b) {
				return k = F(e), b !== !1 && M(k), O.call(T);
			}, T.setDefaultLevel = function(e) {
				D = F(e), N() || T.setLevel(e, !1);
			}, T.resetLevel = function() {
				k = null, P(), O.call(T);
			}, T.enableAll = function(e) {
				T.setLevel(T.levels.TRACE, e);
			}, T.disableAll = function(e) {
				T.setLevel(T.levels.SILENT, e);
			}, T.rebuild = function() {
				if (w !== T && (E = F(w.getLevel())), O.call(T), w === T) for (var e in C) C[e].rebuild();
			}, E = F(w ? w.getLevel() : "WARN");
			var I = N();
			I != null && (k = F(I)), O.call(T);
		}
		w = new j(), w.getLogger = function(e) {
			if (typeof e != "symbol" && typeof e != "string" || e === "") throw TypeError("You must supply a name when creating a logger.");
			var b = C[e];
			return b ||= C[e] = new j(e, w.methodFactory), b;
		};
		var M = typeof window === b ? void 0 : window.log;
		return w.noConflict = function() {
			return typeof window !== b && window.log === w && (window.log = M), w;
		}, w.getLoggers = function() {
			return C;
		}, w.default = w, w;
	});
})))()), DEFAULT_NAMESPACE = "matrix";
import_loglevel.default.methodFactory = function(e, b, x) {
	return function() {
		var b = [...arguments];
		return this.prefix && b.unshift(this.prefix), e === "error" || e === "warn" || e === "trace" || e === "info" || e === "debug" ? console[e](...b) : console.log(...b);
	};
};
function getPrefixedLogger(e) {
	var b = DEFAULT_NAMESPACE + (e === void 0 ? "" : `-${e}`), x = import_loglevel.default.getLogger(b);
	return x.getChild === void 0 && (x.prefix = e, x.getChild = (b) => {
		var S = getPrefixedLogger((e ?? "") + b);
		return S.methodFactory = x.methodFactory, S.rebuild(), S;
	}, x.setLevel(import_loglevel.default.levels.DEBUG, !1)), x;
}
var logger = getPrefixedLogger(), LogSpan = class {
	constructor(e, b) {
		this.parent = e, _defineProperty(this, "name", void 0), this.name = b + ":";
	}
	trace() {
		var e = [...arguments];
		this.parent.trace(this.name, ...e);
	}
	debug() {
		var e = [...arguments];
		this.parent.debug(this.name, ...e);
	}
	info() {
		var e = [...arguments];
		this.parent.info(this.name, ...e);
	}
	warn() {
		var e = [...arguments];
		this.parent.warn(this.name, ...e);
	}
	error() {
		var e = [...arguments];
		this.parent.error(this.name, ...e);
	}
}, DebugLogger = class e {
	constructor(e) {
		this.debugInstance = e;
	}
	trace() {
		var e = [...arguments];
		this.debugWithPrefix("[TRACE]", ...e);
	}
	debug() {
		var e = [...arguments];
		this.debugWithPrefix("[DEBUG]", ...e);
	}
	info() {
		var e = [...arguments];
		this.debugWithPrefix("[INFO]", ...e);
	}
	warn() {
		var e = [...arguments];
		this.debugWithPrefix("[WARN]", ...e);
	}
	error() {
		var e = [...arguments];
		this.debugWithPrefix("[ERROR]", ...e);
	}
	getChild(b) {
		return new e(this.debugInstance.extend(b));
	}
	debugWithPrefix(e) {
		var b, x = [...arguments].slice(1);
		if (x.length === 0) b = "";
		else if (x[0] instanceof Error) {
			var S = x.shift();
			b = S.stack || S.message;
		} else b = typeof x[0] == "string" ? x.shift() : "%O";
		this.debugInstance(e + " " + b, ...x);
	}
}, require_events$1 = /* @__PURE__ */ __commonJSMin(((e, b) => {
	var x = typeof Reflect == "object" ? Reflect : null, S = x && typeof x.apply == "function" ? x.apply : function(e, b, x) {
		return Function.prototype.apply.call(e, b, x);
	}, C = x && typeof x.ownKeys == "function" ? x.ownKeys : Object.getOwnPropertySymbols ? function(e) {
		return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
	} : function(e) {
		return Object.getOwnPropertyNames(e);
	};
	function w(e) {
		console && console.warn && console.warn(e);
	}
	var T = Number.isNaN || function(e) {
		return e !== e;
	};
	function E() {
		E.init.call(this);
	}
	b.exports = E, b.exports.once = R, E.EventEmitter = E, E.prototype._events = void 0, E.prototype._eventsCount = 0, E.prototype._maxListeners = void 0;
	var D = 10;
	function O(e) {
		if (typeof e != "function") throw TypeError("The \"listener\" argument must be of type Function. Received type " + typeof e);
	}
	Object.defineProperty(E, "defaultMaxListeners", {
		enumerable: !0,
		get: function() {
			return D;
		},
		set: function(e) {
			if (typeof e != "number" || e < 0 || T(e)) throw RangeError("The value of \"defaultMaxListeners\" is out of range. It must be a non-negative number. Received " + e + ".");
			D = e;
		}
	}), E.init = function() {
		(this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
	}, E.prototype.setMaxListeners = function(e) {
		if (typeof e != "number" || e < 0 || T(e)) throw RangeError("The value of \"n\" is out of range. It must be a non-negative number. Received " + e + ".");
		return this._maxListeners = e, this;
	};
	function k(e) {
		return e._maxListeners === void 0 ? E.defaultMaxListeners : e._maxListeners;
	}
	E.prototype.getMaxListeners = function() {
		return k(this);
	}, E.prototype.emit = function(e) {
		for (var b = [], x = 1; x < arguments.length; x++) b.push(arguments[x]);
		var C = e === "error", w = this._events;
		if (w !== void 0) C &&= w.error === void 0;
		else if (!C) return !1;
		if (C) {
			var T;
			if (b.length > 0 && (T = b[0]), T instanceof Error) throw T;
			var E = /* @__PURE__ */ Error("Unhandled error." + (T ? " (" + T.message + ")" : ""));
			throw E.context = T, E;
		}
		var D = w[e];
		if (D === void 0) return !1;
		if (typeof D == "function") S(D, this, b);
		else for (var O = D.length, k = F(D, O), x = 0; x < O; ++x) S(k[x], this, b);
		return !0;
	};
	function A(e, b, x, S) {
		var C, T, E;
		if (O(x), T = e._events, T === void 0 ? (T = e._events = Object.create(null), e._eventsCount = 0) : (T.newListener !== void 0 && (e.emit("newListener", b, x.listener ? x.listener : x), T = e._events), E = T[b]), E === void 0) E = T[b] = x, ++e._eventsCount;
		else if (typeof E == "function" ? E = T[b] = S ? [x, E] : [E, x] : S ? E.unshift(x) : E.push(x), C = k(e), C > 0 && E.length > C && !E.warned) {
			E.warned = !0;
			var D = /* @__PURE__ */ Error("Possible EventEmitter memory leak detected. " + E.length + " " + String(b) + " listeners added. Use emitter.setMaxListeners() to increase limit");
			D.name = "MaxListenersExceededWarning", D.emitter = e, D.type = b, D.count = E.length, w(D);
		}
		return e;
	}
	E.prototype.addListener = function(e, b) {
		return A(this, e, b, !1);
	}, E.prototype.on = E.prototype.addListener, E.prototype.prependListener = function(e, b) {
		return A(this, e, b, !0);
	};
	function j() {
		if (!this.fired) return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
	}
	function M(e, b, x) {
		var S = {
			fired: !1,
			wrapFn: void 0,
			target: e,
			type: b,
			listener: x
		}, C = j.bind(S);
		return C.listener = x, S.wrapFn = C, C;
	}
	E.prototype.once = function(e, b) {
		return O(b), this.on(e, M(this, e, b)), this;
	}, E.prototype.prependOnceListener = function(e, b) {
		return O(b), this.prependListener(e, M(this, e, b)), this;
	}, E.prototype.removeListener = function(e, b) {
		var x, S, C, w, T;
		if (O(b), S = this._events, S === void 0 || (x = S[e], x === void 0)) return this;
		if (x === b || x.listener === b) --this._eventsCount === 0 ? this._events = Object.create(null) : (delete S[e], S.removeListener && this.emit("removeListener", e, x.listener || b));
		else if (typeof x != "function") {
			for (C = -1, w = x.length - 1; w >= 0; w--) if (x[w] === b || x[w].listener === b) {
				T = x[w].listener, C = w;
				break;
			}
			if (C < 0) return this;
			C === 0 ? x.shift() : I(x, C), x.length === 1 && (S[e] = x[0]), S.removeListener !== void 0 && this.emit("removeListener", e, T || b);
		}
		return this;
	}, E.prototype.off = E.prototype.removeListener, E.prototype.removeAllListeners = function(e) {
		var b, x = this._events, S;
		if (x === void 0) return this;
		if (x.removeListener === void 0) return arguments.length === 0 ? (this._events = Object.create(null), this._eventsCount = 0) : x[e] !== void 0 && (--this._eventsCount === 0 ? this._events = Object.create(null) : delete x[e]), this;
		if (arguments.length === 0) {
			var C = Object.keys(x), w;
			for (S = 0; S < C.length; ++S) w = C[S], w !== "removeListener" && this.removeAllListeners(w);
			return this.removeAllListeners("removeListener"), this._events = Object.create(null), this._eventsCount = 0, this;
		}
		if (b = x[e], typeof b == "function") this.removeListener(e, b);
		else if (b !== void 0) for (S = b.length - 1; S >= 0; S--) this.removeListener(e, b[S]);
		return this;
	};
	function N(e, b, x) {
		var S = e._events;
		if (S === void 0) return [];
		var C = S[b];
		return C === void 0 ? [] : typeof C == "function" ? x ? [C.listener || C] : [C] : x ? L(C) : F(C, C.length);
	}
	E.prototype.listeners = function(e) {
		return N(this, e, !0);
	}, E.prototype.rawListeners = function(e) {
		return N(this, e, !1);
	}, E.listenerCount = function(e, b) {
		return typeof e.listenerCount == "function" ? e.listenerCount(b) : P.call(e, b);
	}, E.prototype.listenerCount = P;
	function P(e) {
		var b = this._events;
		if (b !== void 0) {
			var x = b[e];
			if (typeof x == "function") return 1;
			if (x !== void 0) return x.length;
		}
		return 0;
	}
	E.prototype.eventNames = function() {
		return this._eventsCount > 0 ? C(this._events) : [];
	};
	function F(e, b) {
		for (var x = Array(b), S = 0; S < b; ++S) x[S] = e[S];
		return x;
	}
	function I(e, b) {
		for (; b + 1 < e.length; b++) e[b] = e[b + 1];
		e.pop();
	}
	function L(e) {
		for (var b = Array(e.length), x = 0; x < b.length; ++x) b[x] = e[x].listener || e[x];
		return b;
	}
	function R(e, b) {
		return new Promise(function(x, S) {
			function C(x) {
				e.removeListener(b, w), S(x);
			}
			function w() {
				typeof e.removeListener == "function" && e.removeListener("error", C), x([].slice.call(arguments));
			}
			B(e, b, w, { once: !0 }), b !== "error" && z(e, C, { once: !0 });
		});
	}
	function z(e, b, x) {
		typeof e.on == "function" && B(e, "error", b, x);
	}
	function B(e, b, x, S) {
		if (typeof e.on == "function") S.once ? e.once(b, x) : e.on(b, x);
		else if (typeof e.addEventListener == "function") e.addEventListener(b, function C(w) {
			S.once && e.removeEventListener(b, C), x(w);
		});
		else throw TypeError("The \"emitter\" argument must be of type EventEmitter. Received type " + typeof e);
	}
})), import_events = /* @__PURE__ */ __toESM(require_events$1()), EventEmitterEvents = /* @__PURE__ */ function(e) {
	return e.NewListener = "newListener", e.RemoveListener = "removeListener", e.Error = "error", e;
}({}), TypedEventEmitter = class extends import_events.EventEmitter {
	addListener(e, b) {
		return super.addListener(e, b);
	}
	emit(e) {
		var b = [...arguments].slice(1);
		return super.emit(e, ...b);
	}
	emitPromised(e) {
		var b = arguments, x = this;
		return _asyncToGenerator(function* () {
			for (var S = b.length, C = Array(S > 1 ? S - 1 : 0), w = 1; w < S; w++) C[w - 1] = b[w];
			var T = x.listeners(e);
			return Promise.allSettled(T.map((e) => e(...C))).then(() => T.length > 0);
		})();
	}
	listenerCount(e) {
		return super.listenerCount(e);
	}
	listeners(e) {
		return super.listeners(e);
	}
	off(e, b) {
		return super.off(e, b);
	}
	on(e, b) {
		return super.on(e, b);
	}
	once(e, b) {
		return super.once(e, b);
	}
	prependListener(e, b) {
		return super.prependListener(e, b);
	}
	prependOnceListener(e, b) {
		return super.prependOnceListener(e, b);
	}
	removeAllListeners(e) {
		return e === void 0 ? super.removeAllListeners() : super.removeAllListeners(e);
	}
	removeListener(e, b) {
		return super.removeListener(e, b);
	}
	rawListeners(e) {
		return super.rawListeners(e);
	}
}, EventType = /* @__PURE__ */ function(e) {
	return e.RoomCanonicalAlias = "m.room.canonical_alias", e.RoomCreate = "m.room.create", e.RoomJoinRules = "m.room.join_rules", e.RoomMember = "m.room.member", e.RoomThirdPartyInvite = "m.room.third_party_invite", e.RoomPowerLevels = "m.room.power_levels", e.RoomName = "m.room.name", e.RoomTopic = "m.room.topic", e.RoomAvatar = "m.room.avatar", e.RoomPinnedEvents = "m.room.pinned_events", e.RoomEncryption = "m.room.encryption", e.RoomHistoryVisibility = "m.room.history_visibility", e.RoomGuestAccess = "m.room.guest_access", e.RoomServerAcl = "m.room.server_acl", e.RoomTombstone = "m.room.tombstone", e.RoomPredecessor = "org.matrix.msc3946.room_predecessor", e.PolicyRuleUser = "m.policy.rule.user", e.PolicyRuleRoom = "m.policy.rule.room", e.PolicyRuleServer = "m.policy.rule.server", e.SpaceChild = "m.space.child", e.SpaceParent = "m.space.parent", e.RoomRedaction = "m.room.redaction", e.RoomMessage = "m.room.message", e.RoomMessageEncrypted = "m.room.encrypted", e.Sticker = "m.sticker", e.CallInvite = "m.call.invite", e.CallCandidates = "m.call.candidates", e.CallAnswer = "m.call.answer", e.CallHangup = "m.call.hangup", e.CallReject = "m.call.reject", e.CallSelectAnswer = "m.call.select_answer", e.CallNegotiate = "m.call.negotiate", e.CallSDPStreamMetadataChanged = "m.call.sdp_stream_metadata_changed", e.CallSDPStreamMetadataChangedPrefix = "org.matrix.call.sdp_stream_metadata_changed", e.CallReplaces = "m.call.replaces", e.CallAssertedIdentity = "m.call.asserted_identity", e.CallAssertedIdentityPrefix = "org.matrix.call.asserted_identity", e.CallEncryptionKeysPrefix = "io.element.call.encryption_keys", e.KeyVerificationRequest = "m.key.verification.request", e.KeyVerificationStart = "m.key.verification.start", e.KeyVerificationCancel = "m.key.verification.cancel", e.KeyVerificationMac = "m.key.verification.mac", e.KeyVerificationDone = "m.key.verification.done", e.KeyVerificationKey = "m.key.verification.key", e.KeyVerificationAccept = "m.key.verification.accept", e.KeyVerificationReady = "m.key.verification.ready", e.RoomMessageFeedback = "m.room.message.feedback", e.Reaction = "m.reaction", e.PollStart = "org.matrix.msc3381.poll.start", e.Typing = "m.typing", e.Receipt = "m.receipt", e.Presence = "m.presence", e.FullyRead = "m.fully_read", e.Tag = "m.tag", e.SpaceOrder = "org.matrix.msc3230.space_order", e.PushRules = "m.push_rules", e.Direct = "m.direct", e.IgnoredUserList = "m.ignored_user_list", e.RoomKey = "m.room_key", e.RoomKeyRequest = "m.room_key_request", e.ForwardedRoomKey = "m.forwarded_room_key", e.Dummy = "m.dummy", e.SecretRequest = "m.secret.request", e.SecretSend = "m.secret.send", e.GroupCallPrefix = "org.matrix.msc3401.call", e.GroupCallMemberPrefix = "org.matrix.msc3401.call.member", e.RTCMembership = "org.matrix.msc4143.rtc.member", e.CallNotify = "org.matrix.msc4075.call.notify", e.RTCNotification = "org.matrix.msc4075.rtc.notification", e.RTCDecline = "org.matrix.msc4310.rtc.decline", e;
}({}), RelationType = /* @__PURE__ */ function(e) {
	return e.Annotation = "m.annotation", e.Replace = "m.replace", e.Reference = "m.reference", e.Thread = "m.thread", e;
}({}), MsgType = /* @__PURE__ */ function(e) {
	return e.Text = "m.text", e.Emote = "m.emote", e.Notice = "m.notice", e.Image = "m.image", e.File = "m.file", e.Audio = "m.audio", e.Location = "m.location", e.Video = "m.video", e.KeyVerificationRequest = "m.key.verification.request", e;
}({}), RoomCreateTypeField = "type", RoomType = /* @__PURE__ */ function(e) {
	return e.Space = "m.space", e.UnstableCall = "org.matrix.msc3417.call", e.ElementVideo = "io.element.video", e;
}({}), ToDeviceMessageId = "org.matrix.msgid", UNSTABLE_MSC3088_PURPOSE = new UnstableValue("m.room.purpose", "org.matrix.msc3088.purpose"), UNSTABLE_MSC3088_ENABLED = new UnstableValue("m.enabled", "org.matrix.msc3088.enabled"), UNSTABLE_MSC3089_TREE_SUBTYPE = new UnstableValue("m.data_tree", "org.matrix.msc3089.data_tree"), UNSTABLE_MSC3089_LEAF = new UnstableValue("m.leaf", "org.matrix.msc3089.leaf"), UNSTABLE_MSC3089_BRANCH = new UnstableValue("m.branch", "org.matrix.msc3089.branch"), UNSTABLE_MSC2716_MARKER = new UnstableValue("m.room.marker", "org.matrix.msc2716.marker"), MSC3912_RELATION_BASED_REDACTIONS_PROP = new UnstableValue("with_rel_types", "org.matrix.msc3912.with_relations"), UNSTABLE_ELEMENT_FUNCTIONAL_USERS = new UnstableValue("io.element.functional_members", "io.element.functional_members"), EVENT_VISIBILITY_CHANGE_TYPE = new UnstableValue("m.visibility", "org.matrix.msc3531.visibility"), PUSHER_ENABLED = new UnstableValue("enabled", "org.matrix.msc3881.enabled"), PUSHER_DEVICE_ID = new UnstableValue("device_id", "org.matrix.msc3881.device_id"), LOCAL_NOTIFICATION_SETTINGS_PREFIX = new UnstableValue("m.local_notification_settings", "org.matrix.msc3890.local_notification_settings"), UNSIGNED_THREAD_ID_FIELD = new UnstableValue("thread_id", "org.matrix.msc4023.thread_id"), UNSIGNED_MEMBERSHIP_FIELD = new NamespacedValue("membership", "io.element.msc4115.membership"), KnownMembership = /* @__PURE__ */ function(e) {
	return e.Ban = "ban", e.Invite = "invite", e.Join = "join", e.Knock = "knock", e.Leave = "leave", e;
}({}), RoomMemberEvent = /* @__PURE__ */ function(e) {
	return e.Membership = "RoomMember.membership", e.Name = "RoomMember.name", e.PowerLevel = "RoomMember.powerLevel", e.Typing = "RoomMember.typing", e;
}({}), RoomMember = class extends TypedEventEmitter {
	constructor(e, b) {
		super(), this.roomId = e, this.userId = b, _defineProperty(this, "_isOutOfBand", !1), _defineProperty(this, "modified", -1), _defineProperty(this, "requestedProfileInfo", !1), _defineProperty(this, "typing", !1), _defineProperty(this, "name", void 0), _defineProperty(this, "rawDisplayName", void 0), _defineProperty(this, "powerLevel", 0), _defineProperty(this, "user", void 0), _defineProperty(this, "membership", void 0), _defineProperty(this, "disambiguate", !1), _defineProperty(this, "events", {}), this.name = b, this.rawDisplayName = b, this.updateModifiedTime();
	}
	markOutOfBand() {
		this._isOutOfBand = !0;
	}
	isOutOfBand() {
		return this._isOutOfBand;
	}
	setMembershipEvent(e, b) {
		var x = e.getDirectionalContent().displayname ?? "";
		if (e.getType() === EventType.RoomMember) {
			this._isOutOfBand = !1, this.events.member = e;
			var S = this.membership;
			this.membership = e.getDirectionalContent().membership, this.membership === void 0 && logger.trace(`membership event with membership undefined (forwardLooking: ${e.forwardLooking})!`, e.getContent(), "prevcontent is ", e.getPrevContent()), this.disambiguate = shouldDisambiguate(this.userId, x, b);
			var C = this.name;
			this.name = calculateDisplayName(this.userId, x, this.disambiguate), this.rawDisplayName = removeDirectionOverrideChars(e.getDirectionalContent().displayname ?? ""), (!this.rawDisplayName || !removeHiddenChars(this.rawDisplayName)) && (this.rawDisplayName = this.userId), S !== this.membership && (this.updateModifiedTime(), this.emit(RoomMemberEvent.Membership, e, this, S)), C !== this.name && (this.updateModifiedTime(), this.emit(RoomMemberEvent.Name, e, this, C));
		}
	}
	setPowerLevel(e, b) {
		var x = this.powerLevel;
		this.powerLevel = e, x !== this.powerLevel && (this.updateModifiedTime(), this.emit(RoomMemberEvent.PowerLevel, b, this));
	}
	setTypingEvent(e) {
		if (e.getType() === "m.typing") {
			var b = this.typing;
			this.typing = !1;
			var x = e.getContent().user_ids;
			Array.isArray(x) && (x.indexOf(this.userId) !== -1 && (this.typing = !0), b !== this.typing && (this.updateModifiedTime(), this.emit(RoomMemberEvent.Typing, e, this)));
		}
	}
	updateModifiedTime() {
		this.modified = Date.now();
	}
	getLastModifiedTime() {
		return this.modified;
	}
	isKicked() {
		return this.membership === KnownMembership.Leave && this.events.member !== void 0 && this.events.member.getSender() !== this.events.member.getStateKey();
	}
	getDMInviter() {
		if (this.events.member) {
			var e = this.events.member, b = e.getContent(), x = e.getSender();
			if (b.membership === KnownMembership.Join && (b = e.getPrevContent(), x = e.getUnsigned().prev_sender), b.membership === KnownMembership.Invite && b.is_direct) return x;
		}
	}
	getAvatarUrl(e, b, x, S) {
		var C = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0, w = arguments.length > 5 ? arguments[5] : void 0, T = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : !1, E = this.getMxcAvatarUrl();
		return !E && !C ? null : getHttpUriForMxc(e, E, b, x, S, w, void 0, T) || null;
	}
	getMxcAvatarUrl() {
		if (this.events.member) return this.events.member.getDirectionalContent().avatar_url;
		if (this.user) return this.user.avatarUrl;
	}
}, MXID_PATTERN = /@.+:.+/, LTR_RTL_PATTERN = /[\u200E\u200F\u202A-\u202F]/;
function shouldDisambiguate(e, b, x) {
	if (!b || b === e || !x) return !1;
	var S = removeHiddenChars(b);
	return S ? !!(MXID_PATTERN.test(S) || LTR_RTL_PATTERN.test(b) || x.getUserIdsWithDisplayName(b).some((b) => b !== e)) : !1;
}
function calculateDisplayName(e, b, x) {
	return !b || b === e ? e : x ? removeDirectionOverrideChars(b) + " (" + e + ")" : removeHiddenChars(b) ? removeDirectionOverrideChars(b) : e;
}
var require_NamespacedMap = /* @__PURE__ */ __commonJSMin(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	function b(e, b) {
		var S = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
		if (!S) {
			if (Array.isArray(e) || (S = x(e)) || b && e && typeof e.length == "number") {
				S && (e = S);
				var C = 0, w = function() {};
				return {
					s: w,
					n: function() {
						return C >= e.length ? { done: !0 } : {
							done: !1,
							value: e[C++]
						};
					},
					e: function(e) {
						throw e;
					},
					f: w
				};
			}
			throw TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
		}
		var T = !0, E = !1, D;
		return {
			s: function() {
				S = S.call(e);
			},
			n: function() {
				var e = S.next();
				return T = e.done, e;
			},
			e: function(e) {
				E = !0, D = e;
			},
			f: function() {
				try {
					!T && S.return != null && S.return();
				} finally {
					if (E) throw D;
				}
			}
		};
	}
	function x(e, b) {
		if (e) {
			if (typeof e == "string") return S(e, b);
			var x = Object.prototype.toString.call(e).slice(8, -1);
			if (x === "Object" && e.constructor && (x = e.constructor.name), x === "Map" || x === "Set") return Array.from(e);
			if (x === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(x)) return S(e, b);
		}
	}
	function S(e, b) {
		(b == null || b > e.length) && (b = e.length);
		for (var x = 0, S = Array(b); x < b; x++) S[x] = e[x];
		return S;
	}
	function C(e, b) {
		if (!(e instanceof b)) throw TypeError("Cannot call a class as a function");
	}
	function w(e, b) {
		for (var x = 0; x < b.length; x++) {
			var S = b[x];
			S.enumerable = S.enumerable || !1, S.configurable = !0, "value" in S && (S.writable = !0), Object.defineProperty(e, S.key, S);
		}
	}
	function T(e, b, x) {
		return b && w(e.prototype, b), x && w(e, x), Object.defineProperty(e, "prototype", { writable: !1 }), e;
	}
	function E(e, b, x) {
		return b in e ? Object.defineProperty(e, b, {
			value: x,
			enumerable: !0,
			configurable: !0,
			writable: !0
		}) : e[b] = x, e;
	}
	e.NamespacedMap = /* @__PURE__ */ function() {
		function e(x) {
			if (C(this, e), E(this, "internalMap", /* @__PURE__ */ new Map()), x) {
				var S = b(x), w;
				try {
					for (S.s(); !(w = S.n()).done;) {
						var T = w.value;
						this.set(T[0], T[1]);
					}
				} catch (e) {
					S.e(e);
				} finally {
					S.f();
				}
			}
		}
		return T(e, [
			{
				key: "get",
				value: function(e) {
					return e.name && this.internalMap.has(e.name) ? this.internalMap.get(e.name) : e.altName && this.internalMap.has(e.altName) ? this.internalMap.get(e.altName) : null;
				}
			},
			{
				key: "set",
				value: function(e, b) {
					e.name && this.internalMap.set(e.name, b), e.altName && this.internalMap.set(e.altName, b);
				}
			},
			{
				key: "has",
				value: function(e) {
					return !!this.get(e);
				}
			},
			{
				key: "delete",
				value: function(e) {
					e.name && this.internalMap.delete(e.name), e.altName && this.internalMap.delete(e.altName);
				}
			},
			{
				key: "hasNamespaced",
				value: function(e) {
					return this.internalMap.has(e);
				}
			},
			{
				key: "getNamespaced",
				value: function(e) {
					return this.internalMap.get(e);
				}
			}
		]), e;
	}();
})), require_InvalidEventError = /* @__PURE__ */ __commonJSMin(((e) => {
	function b(e) {
		"@babel/helpers - typeof";
		return b = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
			return typeof e;
		} : function(e) {
			return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
		}, b(e);
	}
	Object.defineProperty(e, "__esModule", { value: !0 });
	function x(e, b) {
		for (var x = 0; x < b.length; x++) {
			var S = b[x];
			S.enumerable = S.enumerable || !1, S.configurable = !0, "value" in S && (S.writable = !0), Object.defineProperty(e, S.key, S);
		}
	}
	function S(e, b, S) {
		return b && x(e.prototype, b), S && x(e, S), Object.defineProperty(e, "prototype", { writable: !1 }), e;
	}
	function C(e, b) {
		if (!(e instanceof b)) throw TypeError("Cannot call a class as a function");
	}
	function w(e, b) {
		if (typeof b != "function" && b !== null) throw TypeError("Super expression must either be null or a function");
		e.prototype = Object.create(b && b.prototype, { constructor: {
			value: e,
			writable: !0,
			configurable: !0
		} }), Object.defineProperty(e, "prototype", { writable: !1 }), b && M(e, b);
	}
	function T(e) {
		var b = A();
		return function() {
			var x = N(e), S;
			if (b) {
				var C = N(this).constructor;
				S = Reflect.construct(x, arguments, C);
			} else S = x.apply(this, arguments);
			return E(this, S);
		};
	}
	function E(e, x) {
		if (x && (b(x) === "object" || typeof x == "function")) return x;
		if (x !== void 0) throw TypeError("Derived constructors may only return object or undefined");
		return D(e);
	}
	function D(e) {
		if (e === void 0) throw ReferenceError("this hasn't been initialised - super() hasn't been called");
		return e;
	}
	function O(e) {
		var b = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
		return O = function(e) {
			if (e === null || !j(e)) return e;
			if (typeof e != "function") throw TypeError("Super expression must either be null or a function");
			if (b !== void 0) {
				if (b.has(e)) return b.get(e);
				b.set(e, x);
			}
			function x() {
				return k(e, arguments, N(this).constructor);
			}
			return x.prototype = Object.create(e.prototype, { constructor: {
				value: x,
				enumerable: !1,
				writable: !0,
				configurable: !0
			} }), M(x, e);
		}, O(e);
	}
	function k(e, b, x) {
		return k = A() ? Reflect.construct : function(e, b, x) {
			var S = [null];
			S.push.apply(S, b);
			var C = new (Function.bind.apply(e, S))();
			return x && M(C, x.prototype), C;
		}, k.apply(null, arguments);
	}
	function A() {
		if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
		if (typeof Proxy == "function") return !0;
		try {
			return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
		} catch {
			return !1;
		}
	}
	function j(e) {
		return Function.toString.call(e).indexOf("[native code]") !== -1;
	}
	function M(e, b) {
		return M = Object.setPrototypeOf || function(e, b) {
			return e.__proto__ = b, e;
		}, M(e, b);
	}
	function N(e) {
		return N = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
			return e.__proto__ || Object.getPrototypeOf(e);
		}, N(e);
	}
	e.InvalidEventError = /* @__PURE__ */ function(e) {
		w(x, e);
		var b = T(x);
		function x(e) {
			return C(this, x), b.call(this, e);
		}
		return S(x);
	}(/* @__PURE__ */ O(Error));
})), require_ExtensibleEvent = /* @__PURE__ */ __commonJSMin(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	function b(e, b) {
		if (!(e instanceof b)) throw TypeError("Cannot call a class as a function");
	}
	function x(e, b) {
		for (var x = 0; x < b.length; x++) {
			var S = b[x];
			S.enumerable = S.enumerable || !1, S.configurable = !0, "value" in S && (S.writable = !0), Object.defineProperty(e, S.key, S);
		}
	}
	function S(e, b, S) {
		return b && x(e.prototype, b), S && x(e, S), Object.defineProperty(e, "prototype", { writable: !1 }), e;
	}
	e.ExtensibleEvent = /* @__PURE__ */ function() {
		function e(x) {
			b(this, e), this.wireFormat = x;
		}
		return S(e, [{
			key: "wireContent",
			get: function() {
				return this.wireFormat.content;
			}
		}]), e;
	}();
})), require_types = /* @__PURE__ */ __commonJSMin(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.isOptionalAString = b, e.isProvided = x;
	function b(e) {
		return x(e) && typeof e == "string";
	}
	function x(e) {
		return e != null;
	}
})), require_NamespacedValue = /* @__PURE__ */ __commonJSMin(((e) => {
	function b(e) {
		"@babel/helpers - typeof";
		return b = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
			return typeof e;
		} : function(e) {
			return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
		}, b(e);
	}
	Object.defineProperty(e, "__esModule", { value: !0 });
	function x(e, b) {
		if (typeof b != "function" && b !== null) throw TypeError("Super expression must either be null or a function");
		e.prototype = Object.create(b && b.prototype, { constructor: {
			value: e,
			writable: !0,
			configurable: !0
		} }), Object.defineProperty(e, "prototype", { writable: !1 }), b && S(e, b);
	}
	function S(e, b) {
		return S = Object.setPrototypeOf || function(e, b) {
			return e.__proto__ = b, e;
		}, S(e, b);
	}
	function C(e) {
		var b = E();
		return function() {
			var x = D(e), S;
			if (b) {
				var C = D(this).constructor;
				S = Reflect.construct(x, arguments, C);
			} else S = x.apply(this, arguments);
			return w(this, S);
		};
	}
	function w(e, x) {
		if (x && (b(x) === "object" || typeof x == "function")) return x;
		if (x !== void 0) throw TypeError("Derived constructors may only return object or undefined");
		return T(e);
	}
	function T(e) {
		if (e === void 0) throw ReferenceError("this hasn't been initialised - super() hasn't been called");
		return e;
	}
	function E() {
		if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
		if (typeof Proxy == "function") return !0;
		try {
			return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
		} catch {
			return !1;
		}
	}
	function D(e) {
		return D = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
			return e.__proto__ || Object.getPrototypeOf(e);
		}, D(e);
	}
	function O(e, b) {
		if (!(e instanceof b)) throw TypeError("Cannot call a class as a function");
	}
	function k(e, b) {
		for (var x = 0; x < b.length; x++) {
			var S = b[x];
			S.enumerable = S.enumerable || !1, S.configurable = !0, "value" in S && (S.writable = !0), Object.defineProperty(e, S.key, S);
		}
	}
	function A(e, b, x) {
		return b && k(e.prototype, b), x && k(e, x), Object.defineProperty(e, "prototype", { writable: !1 }), e;
	}
	var j = /* @__PURE__ */ function() {
		function e(b, x) {
			if (O(this, e), this.stable = b, this.unstable = x, !this.unstable && !this.stable) throw Error("One of stable or unstable values must be supplied");
		}
		return A(e, [
			{
				key: "name",
				get: function() {
					return this.stable ? this.stable : this.unstable;
				}
			},
			{
				key: "altName",
				get: function() {
					return this.stable ? this.unstable : null;
				}
			},
			{
				key: "matches",
				value: function(e) {
					return !!this.name && this.name === e || !!this.altName && this.altName === e;
				}
			},
			{
				key: "findIn",
				value: function(e) {
					var b;
					return this.name && (b = e?.[this.name]), !b && this.altName && (b = e?.[this.altName]), b;
				}
			},
			{
				key: "includedIn",
				value: function(e) {
					var b = !1;
					return this.name && (b = e.includes(this.name)), !b && this.altName && (b = e.includes(this.altName)), b;
				}
			}
		]), e;
	}();
	e.NamespacedValue = j, e.UnstableValue = /* @__PURE__ */ function(e) {
		x(S, e);
		var b = C(S);
		function S(e, x) {
			var C;
			if (O(this, S), C = b.call(this, e, x), !C.unstable) throw Error("Unstable value must be supplied");
			return C;
		}
		return A(S, [{
			key: "name",
			get: function() {
				return this.unstable;
			}
		}, {
			key: "altName",
			get: function() {
				return this.stable;
			}
		}]), S;
	}(j);
})), require_message_types = /* @__PURE__ */ __commonJSMin(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	var b = require_NamespacedValue();
	e.M_MESSAGE = new b.UnstableValue("m.message", "org.matrix.msc1767.message"), e.M_TEXT = new b.UnstableValue("m.text", "org.matrix.msc1767.text"), e.M_HTML = new b.UnstableValue("m.html", "org.matrix.msc1767.html"), e.M_EMOTE = new b.UnstableValue("m.emote", "org.matrix.msc1767.emote"), e.M_NOTICE = new b.UnstableValue("m.notice", "org.matrix.msc1767.notice");
})), require_events = /* @__PURE__ */ __commonJSMin(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.isEventTypeSame = b;
	function b(e, b) {
		if (typeof e == "string") return typeof b == "string" ? b === e : b.matches(e);
		if (typeof b == "string") return e.matches(b);
		var x = b, S = e;
		return x.matches(S.name) || x.matches(S.altName);
	}
})), require_MessageEvent = /* @__PURE__ */ __commonJSMin(((e) => {
	function b(e) {
		"@babel/helpers - typeof";
		return b = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
			return typeof e;
		} : function(e) {
			return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
		}, b(e);
	}
	Object.defineProperty(e, "__esModule", { value: !0 });
	var x = require_ExtensibleEvent(), S = require_types(), C = require_InvalidEventError(), w = require_message_types(), T = require_events();
	function E(e, b) {
		var x = Object.keys(e);
		if (Object.getOwnPropertySymbols) {
			var S = Object.getOwnPropertySymbols(e);
			b && (S = S.filter(function(b) {
				return Object.getOwnPropertyDescriptor(e, b).enumerable;
			})), x.push.apply(x, S);
		}
		return x;
	}
	function D(e) {
		for (var b = 1; b < arguments.length; b++) {
			var x = arguments[b] == null ? {} : arguments[b];
			b % 2 ? E(Object(x), !0).forEach(function(b) {
				R(e, b, x[b]);
			}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(x)) : E(Object(x)).forEach(function(b) {
				Object.defineProperty(e, b, Object.getOwnPropertyDescriptor(x, b));
			});
		}
		return e;
	}
	function O(e, b) {
		if (!(e instanceof b)) throw TypeError("Cannot call a class as a function");
	}
	function k(e, b) {
		for (var x = 0; x < b.length; x++) {
			var S = b[x];
			S.enumerable = S.enumerable || !1, S.configurable = !0, "value" in S && (S.writable = !0), Object.defineProperty(e, S.key, S);
		}
	}
	function A(e, b, x) {
		return b && k(e.prototype, b), x && k(e, x), Object.defineProperty(e, "prototype", { writable: !1 }), e;
	}
	function j(e, b) {
		if (typeof b != "function" && b !== null) throw TypeError("Super expression must either be null or a function");
		e.prototype = Object.create(b && b.prototype, { constructor: {
			value: e,
			writable: !0,
			configurable: !0
		} }), Object.defineProperty(e, "prototype", { writable: !1 }), b && M(e, b);
	}
	function M(e, b) {
		return M = Object.setPrototypeOf || function(e, b) {
			return e.__proto__ = b, e;
		}, M(e, b);
	}
	function N(e) {
		var b = I();
		return function() {
			var x = L(e), S;
			if (b) {
				var C = L(this).constructor;
				S = Reflect.construct(x, arguments, C);
			} else S = x.apply(this, arguments);
			return P(this, S);
		};
	}
	function P(e, x) {
		if (x && (b(x) === "object" || typeof x == "function")) return x;
		if (x !== void 0) throw TypeError("Derived constructors may only return object or undefined");
		return F(e);
	}
	function F(e) {
		if (e === void 0) throw ReferenceError("this hasn't been initialised - super() hasn't been called");
		return e;
	}
	function I() {
		if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
		if (typeof Proxy == "function") return !0;
		try {
			return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
		} catch {
			return !1;
		}
	}
	function L(e) {
		return L = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
			return e.__proto__ || Object.getPrototypeOf(e);
		}, L(e);
	}
	function R(e, b, x) {
		return b in e ? Object.defineProperty(e, b, {
			value: x,
			enumerable: !0,
			configurable: !0,
			writable: !0
		}) : e[b] = x, e;
	}
	e.MessageEvent = /* @__PURE__ */ function(e) {
		j(x, e);
		var b = N(x);
		function x(e) {
			var T;
			O(this, x), T = b.call(this, e), R(F(T), "text", void 0), R(F(T), "html", void 0), R(F(T), "renderings", void 0);
			var E = w.M_MESSAGE.findIn(T.wireContent), D = w.M_TEXT.findIn(T.wireContent), k = w.M_HTML.findIn(T.wireContent);
			if ((0, S.isProvided)(E)) {
				if (!Array.isArray(E)) throw new C.InvalidEventError("m.message contents must be an array");
				var A = E.find(function(e) {
					return !(0, S.isProvided)(e.mimetype) || e.mimetype === "text/plain";
				}), j = E.find(function(e) {
					return e.mimetype === "text/html";
				});
				if (!A) throw new C.InvalidEventError("m.message is missing a plain text representation");
				T.text = A.body, T.html = j?.body, T.renderings = E;
			} else if ((0, S.isOptionalAString)(D)) T.text = D, T.html = k, T.renderings = [{
				body: D,
				mimetype: "text/plain"
			}], T.html && T.renderings.push({
				body: T.html,
				mimetype: "text/html"
			});
			else throw new C.InvalidEventError("Missing textual representation for event");
			return T;
		}
		return A(x, [
			{
				key: "isEmote",
				get: function() {
					return w.M_EMOTE.matches(this.wireFormat.type) || (0, S.isProvided)(w.M_EMOTE.findIn(this.wireFormat.content));
				}
			},
			{
				key: "isNotice",
				get: function() {
					return w.M_NOTICE.matches(this.wireFormat.type) || (0, S.isProvided)(w.M_NOTICE.findIn(this.wireFormat.content));
				}
			},
			{
				key: "isEquivalentTo",
				value: function(e) {
					return (0, T.isEventTypeSame)(e, w.M_MESSAGE);
				}
			},
			{
				key: "serializeMMessageOnly",
				value: function() {
					var e = R({}, w.M_MESSAGE.name, this.renderings);
					if (this.renderings.length === 1) {
						var b = this.renderings[0].mimetype;
						(b === void 0 || b === "text/plain") && (e = R({}, w.M_TEXT.name, this.renderings[0].body));
					}
					return e;
				}
			},
			{
				key: "serialize",
				value: function() {
					return {
						type: "m.room.message",
						content: D(D({}, this.serializeMMessageOnly()), {}, {
							body: this.text,
							msgtype: "m.text",
							format: this.html ? "org.matrix.custom.html" : void 0,
							formatted_body: this.html ?? void 0
						})
					};
				}
			}
		], [{
			key: "from",
			value: function(e, b) {
				var S;
				return new x({
					type: w.M_MESSAGE.name,
					content: (S = {}, R(S, w.M_TEXT.name, e), R(S, w.M_HTML.name, b), S)
				});
			}
		}]), x;
	}(x.ExtensibleEvent);
})), require_NoticeEvent = /* @__PURE__ */ __commonJSMin(((e) => {
	function b(e) {
		"@babel/helpers - typeof";
		return b = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
			return typeof e;
		} : function(e) {
			return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
		}, b(e);
	}
	Object.defineProperty(e, "__esModule", { value: !0 });
	var x = require_MessageEvent(), S = require_message_types(), C = require_events();
	function w(e, b, x) {
		return b in e ? Object.defineProperty(e, b, {
			value: x,
			enumerable: !0,
			configurable: !0,
			writable: !0
		}) : e[b] = x, e;
	}
	function T(e, b) {
		if (!(e instanceof b)) throw TypeError("Cannot call a class as a function");
	}
	function E(e, b) {
		for (var x = 0; x < b.length; x++) {
			var S = b[x];
			S.enumerable = S.enumerable || !1, S.configurable = !0, "value" in S && (S.writable = !0), Object.defineProperty(e, S.key, S);
		}
	}
	function D(e, b, x) {
		return b && E(e.prototype, b), x && E(e, x), Object.defineProperty(e, "prototype", { writable: !1 }), e;
	}
	function O() {
		return O = typeof Reflect < "u" && Reflect.get ? Reflect.get : function(e, b, x) {
			var S = k(e, b);
			if (S) {
				var C = Object.getOwnPropertyDescriptor(S, b);
				return C.get ? C.get.call(arguments.length < 3 ? e : x) : C.value;
			}
		}, O.apply(this, arguments);
	}
	function k(e, b) {
		for (; !Object.prototype.hasOwnProperty.call(e, b) && (e = I(e), e !== null););
		return e;
	}
	function A(e, b) {
		if (typeof b != "function" && b !== null) throw TypeError("Super expression must either be null or a function");
		e.prototype = Object.create(b && b.prototype, { constructor: {
			value: e,
			writable: !0,
			configurable: !0
		} }), Object.defineProperty(e, "prototype", { writable: !1 }), b && j(e, b);
	}
	function j(e, b) {
		return j = Object.setPrototypeOf || function(e, b) {
			return e.__proto__ = b, e;
		}, j(e, b);
	}
	function M(e) {
		var b = F();
		return function() {
			var x = I(e), S;
			if (b) {
				var C = I(this).constructor;
				S = Reflect.construct(x, arguments, C);
			} else S = x.apply(this, arguments);
			return N(this, S);
		};
	}
	function N(e, x) {
		if (x && (b(x) === "object" || typeof x == "function")) return x;
		if (x !== void 0) throw TypeError("Derived constructors may only return object or undefined");
		return P(e);
	}
	function P(e) {
		if (e === void 0) throw ReferenceError("this hasn't been initialised - super() hasn't been called");
		return e;
	}
	function F() {
		if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
		if (typeof Proxy == "function") return !0;
		try {
			return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
		} catch {
			return !1;
		}
	}
	function I(e) {
		return I = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
			return e.__proto__ || Object.getPrototypeOf(e);
		}, I(e);
	}
	e.NoticeEvent = /* @__PURE__ */ function(e) {
		A(x, e);
		var b = M(x);
		function x(e) {
			return T(this, x), b.call(this, e);
		}
		return D(x, [
			{
				key: "isNotice",
				get: function() {
					return !0;
				}
			},
			{
				key: "isEquivalentTo",
				value: function(e) {
					return (0, C.isEventTypeSame)(e, S.M_NOTICE) || O(I(x.prototype), "isEquivalentTo", this).call(this, e);
				}
			},
			{
				key: "serialize",
				value: function() {
					var e = O(I(x.prototype), "serialize", this).call(this);
					return e.content.msgtype = "m.notice", e;
				}
			}
		], [{
			key: "from",
			value: function(e, b) {
				var C;
				return new x({
					type: S.M_NOTICE.name,
					content: (C = {}, w(C, S.M_TEXT.name, e), w(C, S.M_HTML.name, b), C)
				});
			}
		}]), x;
	}(x.MessageEvent);
})), require_EmoteEvent = /* @__PURE__ */ __commonJSMin(((e) => {
	function b(e) {
		"@babel/helpers - typeof";
		return b = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
			return typeof e;
		} : function(e) {
			return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
		}, b(e);
	}
	Object.defineProperty(e, "__esModule", { value: !0 });
	var x = require_MessageEvent(), S = require_message_types(), C = require_events();
	function w(e, b, x) {
		return b in e ? Object.defineProperty(e, b, {
			value: x,
			enumerable: !0,
			configurable: !0,
			writable: !0
		}) : e[b] = x, e;
	}
	function T(e, b) {
		if (!(e instanceof b)) throw TypeError("Cannot call a class as a function");
	}
	function E(e, b) {
		for (var x = 0; x < b.length; x++) {
			var S = b[x];
			S.enumerable = S.enumerable || !1, S.configurable = !0, "value" in S && (S.writable = !0), Object.defineProperty(e, S.key, S);
		}
	}
	function D(e, b, x) {
		return b && E(e.prototype, b), x && E(e, x), Object.defineProperty(e, "prototype", { writable: !1 }), e;
	}
	function O() {
		return O = typeof Reflect < "u" && Reflect.get ? Reflect.get : function(e, b, x) {
			var S = k(e, b);
			if (S) {
				var C = Object.getOwnPropertyDescriptor(S, b);
				return C.get ? C.get.call(arguments.length < 3 ? e : x) : C.value;
			}
		}, O.apply(this, arguments);
	}
	function k(e, b) {
		for (; !Object.prototype.hasOwnProperty.call(e, b) && (e = I(e), e !== null););
		return e;
	}
	function A(e, b) {
		if (typeof b != "function" && b !== null) throw TypeError("Super expression must either be null or a function");
		e.prototype = Object.create(b && b.prototype, { constructor: {
			value: e,
			writable: !0,
			configurable: !0
		} }), Object.defineProperty(e, "prototype", { writable: !1 }), b && j(e, b);
	}
	function j(e, b) {
		return j = Object.setPrototypeOf || function(e, b) {
			return e.__proto__ = b, e;
		}, j(e, b);
	}
	function M(e) {
		var b = F();
		return function() {
			var x = I(e), S;
			if (b) {
				var C = I(this).constructor;
				S = Reflect.construct(x, arguments, C);
			} else S = x.apply(this, arguments);
			return N(this, S);
		};
	}
	function N(e, x) {
		if (x && (b(x) === "object" || typeof x == "function")) return x;
		if (x !== void 0) throw TypeError("Derived constructors may only return object or undefined");
		return P(e);
	}
	function P(e) {
		if (e === void 0) throw ReferenceError("this hasn't been initialised - super() hasn't been called");
		return e;
	}
	function F() {
		if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
		if (typeof Proxy == "function") return !0;
		try {
			return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
		} catch {
			return !1;
		}
	}
	function I(e) {
		return I = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
			return e.__proto__ || Object.getPrototypeOf(e);
		}, I(e);
	}
	e.EmoteEvent = /* @__PURE__ */ function(e) {
		A(x, e);
		var b = M(x);
		function x(e) {
			return T(this, x), b.call(this, e);
		}
		return D(x, [
			{
				key: "isEmote",
				get: function() {
					return !0;
				}
			},
			{
				key: "isEquivalentTo",
				value: function(e) {
					return (0, C.isEventTypeSame)(e, S.M_EMOTE) || O(I(x.prototype), "isEquivalentTo", this).call(this, e);
				}
			},
			{
				key: "serialize",
				value: function() {
					var e = O(I(x.prototype), "serialize", this).call(this);
					return e.content.msgtype = "m.emote", e;
				}
			}
		], [{
			key: "from",
			value: function(e, b) {
				var C;
				return new x({
					type: S.M_EMOTE.name,
					content: (C = {}, w(C, S.M_TEXT.name, e), w(C, S.M_HTML.name, b), C)
				});
			}
		}]), x;
	}(x.MessageEvent);
})), require_MRoomMessage = /* @__PURE__ */ __commonJSMin(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.parseMRoomMessage = O;
	var b = require_MessageEvent(), x = require_NoticeEvent(), S = require_EmoteEvent(), C = require_NamespacedValue(), w = require_message_types();
	function T(e, b) {
		var x = Object.keys(e);
		if (Object.getOwnPropertySymbols) {
			var S = Object.getOwnPropertySymbols(e);
			b && (S = S.filter(function(b) {
				return Object.getOwnPropertyDescriptor(e, b).enumerable;
			})), x.push.apply(x, S);
		}
		return x;
	}
	function E(e) {
		for (var b = 1; b < arguments.length; b++) {
			var x = arguments[b] == null ? {} : arguments[b];
			b % 2 ? T(Object(x), !0).forEach(function(b) {
				D(e, b, x[b]);
			}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(x)) : T(Object(x)).forEach(function(b) {
				Object.defineProperty(e, b, Object.getOwnPropertyDescriptor(x, b));
			});
		}
		return e;
	}
	function D(e, b, x) {
		return b in e ? Object.defineProperty(e, b, {
			value: x,
			enumerable: !0,
			configurable: !0,
			writable: !0
		}) : e[b] = x, e;
	}
	e.LEGACY_M_ROOM_MESSAGE = new C.NamespacedValue("m.room.message");
	function O(e) {
		if (w.M_MESSAGE.findIn(e.content) || w.M_TEXT.findIn(e.content)) return new b.MessageEvent(e);
		var C = e.content?.msgtype, T = e.content?.body, O = e.content?.format === "org.matrix.custom.html" ? e.content.formatted_body : null;
		if (C === "m.text") {
			var k;
			return new b.MessageEvent(E(E({}, e), {}, { content: E(E({}, e.content), {}, (k = {}, D(k, w.M_TEXT.name, T), D(k, w.M_HTML.name, O), k)) }));
		} else if (C === "m.notice") {
			var A;
			return new x.NoticeEvent(E(E({}, e), {}, { content: E(E({}, e.content), {}, (A = {}, D(A, w.M_TEXT.name, T), D(A, w.M_HTML.name, O), A)) }));
		} else if (C === "m.emote") {
			var j;
			return new S.EmoteEvent(E(E({}, e), {}, { content: E(E({}, e.content), {}, (j = {}, D(j, w.M_TEXT.name, T), D(j, w.M_HTML.name, O), j)) }));
		} else return null;
	}
})), require_MMessage = /* @__PURE__ */ __commonJSMin(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.parseMMessage = w;
	var b = require_MessageEvent(), x = require_message_types(), S = require_EmoteEvent(), C = require_NoticeEvent();
	function w(e) {
		return x.M_EMOTE.matches(e.type) ? new S.EmoteEvent(e) : x.M_NOTICE.matches(e.type) ? new C.NoticeEvent(e) : new b.MessageEvent(e);
	}
})), require_poll_types = /* @__PURE__ */ __commonJSMin(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	var b = require_NamespacedValue();
	e.M_POLL_KIND_DISCLOSED = new b.UnstableValue("m.poll.disclosed", "org.matrix.msc3381.poll.disclosed"), e.M_POLL_KIND_UNDISCLOSED = new b.UnstableValue("m.poll.undisclosed", "org.matrix.msc3381.poll.undisclosed"), e.M_POLL_START = new b.UnstableValue("m.poll.start", "org.matrix.msc3381.poll.start"), e.M_POLL_RESPONSE = new b.UnstableValue("m.poll.response", "org.matrix.msc3381.poll.response"), e.M_POLL_END = new b.UnstableValue("m.poll.end", "org.matrix.msc3381.poll.end");
})), require_PollStartEvent = /* @__PURE__ */ __commonJSMin(((e) => {
	function b(e) {
		"@babel/helpers - typeof";
		return b = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
			return typeof e;
		} : function(e) {
			return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
		}, b(e);
	}
	Object.defineProperty(e, "__esModule", { value: !0 });
	var x = require_poll_types(), S = require_MessageEvent(), C = require_message_types(), w = require_InvalidEventError(), T = require_NamespacedValue(), E = require_events(), D = require_ExtensibleEvent();
	function O(e) {
		return M(e) || j(e) || A(e) || k();
	}
	function k() {
		throw TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	function A(e, b) {
		if (e) {
			if (typeof e == "string") return N(e, b);
			var x = Object.prototype.toString.call(e).slice(8, -1);
			if (x === "Object" && e.constructor && (x = e.constructor.name), x === "Map" || x === "Set") return Array.from(e);
			if (x === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(x)) return N(e, b);
		}
	}
	function j(e) {
		if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
	}
	function M(e) {
		if (Array.isArray(e)) return N(e);
	}
	function N(e, b) {
		(b == null || b > e.length) && (b = e.length);
		for (var x = 0, S = Array(b); x < b; x++) S[x] = e[x];
		return S;
	}
	function P(e, b) {
		var x = Object.keys(e);
		if (Object.getOwnPropertySymbols) {
			var S = Object.getOwnPropertySymbols(e);
			b && (S = S.filter(function(b) {
				return Object.getOwnPropertyDescriptor(e, b).enumerable;
			})), x.push.apply(x, S);
		}
		return x;
	}
	function F(e) {
		for (var b = 1; b < arguments.length; b++) {
			var x = arguments[b] == null ? {} : arguments[b];
			b % 2 ? P(Object(x), !0).forEach(function(b) {
				K(e, b, x[b]);
			}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(x)) : P(Object(x)).forEach(function(b) {
				Object.defineProperty(e, b, Object.getOwnPropertyDescriptor(x, b));
			});
		}
		return e;
	}
	function I(e, b) {
		if (!(e instanceof b)) throw TypeError("Cannot call a class as a function");
	}
	function L(e, b) {
		for (var x = 0; x < b.length; x++) {
			var S = b[x];
			S.enumerable = S.enumerable || !1, S.configurable = !0, "value" in S && (S.writable = !0), Object.defineProperty(e, S.key, S);
		}
	}
	function R(e, b, x) {
		return b && L(e.prototype, b), x && L(e, x), Object.defineProperty(e, "prototype", { writable: !1 }), e;
	}
	function z(e, b) {
		if (typeof b != "function" && b !== null) throw TypeError("Super expression must either be null or a function");
		e.prototype = Object.create(b && b.prototype, { constructor: {
			value: e,
			writable: !0,
			configurable: !0
		} }), Object.defineProperty(e, "prototype", { writable: !1 }), b && B(e, b);
	}
	function B(e, b) {
		return B = Object.setPrototypeOf || function(e, b) {
			return e.__proto__ = b, e;
		}, B(e, b);
	}
	function V(e) {
		var b = W();
		return function() {
			var x = G(e), S;
			if (b) {
				var C = G(this).constructor;
				S = Reflect.construct(x, arguments, C);
			} else S = x.apply(this, arguments);
			return H(this, S);
		};
	}
	function H(e, x) {
		if (x && (b(x) === "object" || typeof x == "function")) return x;
		if (x !== void 0) throw TypeError("Derived constructors may only return object or undefined");
		return U(e);
	}
	function U(e) {
		if (e === void 0) throw ReferenceError("this hasn't been initialised - super() hasn't been called");
		return e;
	}
	function W() {
		if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
		if (typeof Proxy == "function") return !0;
		try {
			return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
		} catch {
			return !1;
		}
	}
	function G(e) {
		return G = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
			return e.__proto__ || Object.getPrototypeOf(e);
		}, G(e);
	}
	function K(e, b, x) {
		return b in e ? Object.defineProperty(e, b, {
			value: x,
			enumerable: !0,
			configurable: !0,
			writable: !0
		}) : e[b] = x, e;
	}
	var q = /* @__PURE__ */ function(e) {
		z(x, e);
		var b = V(x);
		function x(e) {
			var S;
			I(this, x), S = b.call(this, e), K(U(S), "id", void 0);
			var C = e.content.id;
			if (!C || typeof C != "string") throw new w.InvalidEventError("Answer ID must be a non-empty string");
			return S.id = C, S;
		}
		return R(x, [{
			key: "serialize",
			value: function() {
				return {
					type: "org.matrix.sdk.poll.answer",
					content: F({ id: this.id }, this.serializeMMessageOnly())
				};
			}
		}], [{
			key: "from",
			value: function(e, b) {
				return new x({
					type: "org.matrix.sdk.poll.answer",
					content: K({ id: e }, C.M_TEXT.name, b)
				});
			}
		}]), x;
	}(S.MessageEvent);
	e.PollAnswerSubevent = q, e.PollStartEvent = /* @__PURE__ */ function(e) {
		z(D, e);
		var b = V(D);
		function D(e) {
			var C;
			I(this, D), C = b.call(this, e), K(U(C), "question", void 0), K(U(C), "kind", void 0), K(U(C), "rawKind", void 0), K(U(C), "maxSelections", void 0), K(U(C), "answers", void 0);
			var T = x.M_POLL_START.findIn(C.wireContent);
			if (!T.question) throw new w.InvalidEventError("A question is required");
			if (C.question = new S.MessageEvent({
				type: "org.matrix.sdk.poll.question",
				content: T.question
			}), C.rawKind = T.kind, x.M_POLL_KIND_DISCLOSED.matches(C.rawKind) ? C.kind = x.M_POLL_KIND_DISCLOSED : C.kind = x.M_POLL_KIND_UNDISCLOSED, C.maxSelections = Number.isFinite(T.max_selections) && T.max_selections > 0 ? T.max_selections : 1, !Array.isArray(T.answers)) throw new w.InvalidEventError("Poll answers must be an array");
			var E = T.answers.slice(0, 20).map(function(e) {
				return new q({
					type: "org.matrix.sdk.poll.answer",
					content: e
				});
			});
			if (E.length <= 0) throw new w.InvalidEventError("No answers available");
			return C.answers = E, C;
		}
		return R(D, [{
			key: "isEquivalentTo",
			value: function(e) {
				return (0, E.isEventTypeSame)(e, x.M_POLL_START);
			}
		}, {
			key: "serialize",
			value: function() {
				var e;
				return {
					type: x.M_POLL_START.name,
					content: (e = {}, K(e, x.M_POLL_START.name, {
						question: this.question.serialize().content,
						kind: this.rawKind,
						max_selections: this.maxSelections,
						answers: this.answers.map(function(e) {
							return e.serialize().content;
						})
					}), K(e, C.M_TEXT.name, `${this.question.text}
${this.answers.map(function(e, b) {
						return `${b + 1}. ${e.text}`;
					}).join("\n")}`), e)
				};
			}
		}], [{
			key: "from",
			value: function(e, b, S) {
				var w, E = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1;
				return new D({
					type: x.M_POLL_START.name,
					content: (w = {}, K(w, C.M_TEXT.name, e), K(w, x.M_POLL_START.name, {
						question: K({}, C.M_TEXT.name, e),
						kind: S instanceof T.NamespacedValue ? S.name : S,
						max_selections: E,
						answers: b.map(function(e) {
							return K({ id: Y() }, C.M_TEXT.name, e);
						})
					}), w)
				});
			}
		}]), D;
	}(D.ExtensibleEvent);
	var J = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
	function Y() {
		return O(Array(16)).map(function() {
			return J.charAt(Math.floor(Math.random() * J.length));
		}).join("");
	}
})), require_relationship_types = /* @__PURE__ */ __commonJSMin(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.REFERENCE_RELATION = new (require_NamespacedValue()).NamespacedValue("m.reference");
})), require_PollResponseEvent = /* @__PURE__ */ __commonJSMin(((e) => {
	function b(e) {
		"@babel/helpers - typeof";
		return b = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
			return typeof e;
		} : function(e) {
			return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
		}, b(e);
	}
	Object.defineProperty(e, "__esModule", { value: !0 });
	var x = require_ExtensibleEvent(), S = require_poll_types(), C = require_InvalidEventError(), w = require_relationship_types(), T = require_events();
	function E(e, b) {
		if (!(e instanceof b)) throw TypeError("Cannot call a class as a function");
	}
	function D(e, b) {
		for (var x = 0; x < b.length; x++) {
			var S = b[x];
			S.enumerable = S.enumerable || !1, S.configurable = !0, "value" in S && (S.writable = !0), Object.defineProperty(e, S.key, S);
		}
	}
	function O(e, b, x) {
		return b && D(e.prototype, b), x && D(e, x), Object.defineProperty(e, "prototype", { writable: !1 }), e;
	}
	function k(e, b) {
		if (typeof b != "function" && b !== null) throw TypeError("Super expression must either be null or a function");
		e.prototype = Object.create(b && b.prototype, { constructor: {
			value: e,
			writable: !0,
			configurable: !0
		} }), Object.defineProperty(e, "prototype", { writable: !1 }), b && A(e, b);
	}
	function A(e, b) {
		return A = Object.setPrototypeOf || function(e, b) {
			return e.__proto__ = b, e;
		}, A(e, b);
	}
	function j(e) {
		var b = P();
		return function() {
			var x = F(e), S;
			if (b) {
				var C = F(this).constructor;
				S = Reflect.construct(x, arguments, C);
			} else S = x.apply(this, arguments);
			return M(this, S);
		};
	}
	function M(e, x) {
		if (x && (b(x) === "object" || typeof x == "function")) return x;
		if (x !== void 0) throw TypeError("Derived constructors may only return object or undefined");
		return N(e);
	}
	function N(e) {
		if (e === void 0) throw ReferenceError("this hasn't been initialised - super() hasn't been called");
		return e;
	}
	function P() {
		if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
		if (typeof Proxy == "function") return !0;
		try {
			return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
		} catch {
			return !1;
		}
	}
	function F(e) {
		return F = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
			return e.__proto__ || Object.getPrototypeOf(e);
		}, F(e);
	}
	function I(e, b, x) {
		return b in e ? Object.defineProperty(e, b, {
			value: x,
			enumerable: !0,
			configurable: !0,
			writable: !0
		}) : e[b] = x, e;
	}
	e.PollResponseEvent = /* @__PURE__ */ function(e) {
		k(x, e);
		var b = j(x);
		function x(e) {
			var S;
			E(this, x), S = b.call(this, e), I(N(S), "internalAnswerIds", void 0), I(N(S), "internalSpoiled", void 0), I(N(S), "pollEventId", void 0);
			var T = S.wireContent["m.relates_to"];
			if (!w.REFERENCE_RELATION.matches(T?.rel_type) || typeof T?.event_id != "string") throw new C.InvalidEventError("Relationship must be a reference to an event");
			return S.pollEventId = T.event_id, S.validateAgainst(null), S;
		}
		return O(x, [
			{
				key: "answerIds",
				get: function() {
					return this.internalAnswerIds;
				}
			},
			{
				key: "spoiled",
				get: function() {
					return this.internalSpoiled;
				}
			},
			{
				key: "validateAgainst",
				value: function(e) {
					var b = S.M_POLL_RESPONSE.findIn(this.wireContent);
					if (!Array.isArray(b?.answers)) {
						this.internalSpoiled = !0, this.internalAnswerIds = [];
						return;
					}
					var x = b.answers;
					if (x.some(function(e) {
						return typeof e != "string";
					}) || x.length === 0) {
						this.internalSpoiled = !0, this.internalAnswerIds = [];
						return;
					}
					if (e) {
						if (x.some(function(b) {
							return !e.answers.some(function(e) {
								return e.id === b;
							});
						})) {
							this.internalSpoiled = !0, this.internalAnswerIds = [];
							return;
						}
						x = x.slice(0, e.maxSelections);
					}
					this.internalAnswerIds = x, this.internalSpoiled = !1;
				}
			},
			{
				key: "isEquivalentTo",
				value: function(e) {
					return (0, T.isEventTypeSame)(e, S.M_POLL_RESPONSE);
				}
			},
			{
				key: "serialize",
				value: function() {
					return {
						type: S.M_POLL_RESPONSE.name,
						content: I({ "m.relates_to": {
							rel_type: w.REFERENCE_RELATION.name,
							event_id: this.pollEventId
						} }, S.M_POLL_RESPONSE.name, { answers: this.spoiled ? void 0 : this.answerIds })
					};
				}
			}
		], [{
			key: "from",
			value: function(e, b) {
				return new x({
					type: S.M_POLL_RESPONSE.name,
					content: I({ "m.relates_to": {
						rel_type: w.REFERENCE_RELATION.name,
						event_id: b
					} }, S.M_POLL_RESPONSE.name, { answers: e })
				});
			}
		}]), x;
	}(x.ExtensibleEvent);
})), require_PollEndEvent = /* @__PURE__ */ __commonJSMin(((e) => {
	function b(e) {
		"@babel/helpers - typeof";
		return b = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
			return typeof e;
		} : function(e) {
			return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
		}, b(e);
	}
	Object.defineProperty(e, "__esModule", { value: !0 });
	var x = require_poll_types(), S = require_InvalidEventError(), C = require_relationship_types(), w = require_MessageEvent(), T = require_message_types(), E = require_events(), D = require_ExtensibleEvent();
	function O(e, b) {
		var x = Object.keys(e);
		if (Object.getOwnPropertySymbols) {
			var S = Object.getOwnPropertySymbols(e);
			b && (S = S.filter(function(b) {
				return Object.getOwnPropertyDescriptor(e, b).enumerable;
			})), x.push.apply(x, S);
		}
		return x;
	}
	function k(e) {
		for (var b = 1; b < arguments.length; b++) {
			var x = arguments[b] == null ? {} : arguments[b];
			b % 2 ? O(Object(x), !0).forEach(function(b) {
				B(e, b, x[b]);
			}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(x)) : O(Object(x)).forEach(function(b) {
				Object.defineProperty(e, b, Object.getOwnPropertyDescriptor(x, b));
			});
		}
		return e;
	}
	function A(e, b) {
		if (!(e instanceof b)) throw TypeError("Cannot call a class as a function");
	}
	function j(e, b) {
		for (var x = 0; x < b.length; x++) {
			var S = b[x];
			S.enumerable = S.enumerable || !1, S.configurable = !0, "value" in S && (S.writable = !0), Object.defineProperty(e, S.key, S);
		}
	}
	function M(e, b, x) {
		return b && j(e.prototype, b), x && j(e, x), Object.defineProperty(e, "prototype", { writable: !1 }), e;
	}
	function N(e, b) {
		if (typeof b != "function" && b !== null) throw TypeError("Super expression must either be null or a function");
		e.prototype = Object.create(b && b.prototype, { constructor: {
			value: e,
			writable: !0,
			configurable: !0
		} }), Object.defineProperty(e, "prototype", { writable: !1 }), b && P(e, b);
	}
	function P(e, b) {
		return P = Object.setPrototypeOf || function(e, b) {
			return e.__proto__ = b, e;
		}, P(e, b);
	}
	function F(e) {
		var b = R();
		return function() {
			var x = z(e), S;
			if (b) {
				var C = z(this).constructor;
				S = Reflect.construct(x, arguments, C);
			} else S = x.apply(this, arguments);
			return I(this, S);
		};
	}
	function I(e, x) {
		if (x && (b(x) === "object" || typeof x == "function")) return x;
		if (x !== void 0) throw TypeError("Derived constructors may only return object or undefined");
		return L(e);
	}
	function L(e) {
		if (e === void 0) throw ReferenceError("this hasn't been initialised - super() hasn't been called");
		return e;
	}
	function R() {
		if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
		if (typeof Proxy == "function") return !0;
		try {
			return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
		} catch {
			return !1;
		}
	}
	function z(e) {
		return z = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
			return e.__proto__ || Object.getPrototypeOf(e);
		}, z(e);
	}
	function B(e, b, x) {
		return b in e ? Object.defineProperty(e, b, {
			value: x,
			enumerable: !0,
			configurable: !0,
			writable: !0
		}) : e[b] = x, e;
	}
	e.PollEndEvent = /* @__PURE__ */ function(e) {
		N(D, e);
		var b = F(D);
		function D(e) {
			var x;
			A(this, D), x = b.call(this, e), B(L(x), "pollEventId", void 0), B(L(x), "closingMessage", void 0);
			var T = x.wireContent["m.relates_to"];
			if (!C.REFERENCE_RELATION.matches(T?.rel_type) || typeof T?.event_id != "string") throw new S.InvalidEventError("Relationship must be a reference to an event");
			return x.pollEventId = T.event_id, x.closingMessage = new w.MessageEvent(x.wireFormat), x;
		}
		return M(D, [{
			key: "isEquivalentTo",
			value: function(e) {
				return (0, E.isEventTypeSame)(e, x.M_POLL_END);
			}
		}, {
			key: "serialize",
			value: function() {
				return {
					type: x.M_POLL_END.name,
					content: k(B({ "m.relates_to": {
						rel_type: C.REFERENCE_RELATION.name,
						event_id: this.pollEventId
					} }, x.M_POLL_END.name, {}), this.closingMessage.serialize().content)
				};
			}
		}], [{
			key: "from",
			value: function(e, b) {
				var S;
				return new D({
					type: x.M_POLL_END.name,
					content: (S = { "m.relates_to": {
						rel_type: C.REFERENCE_RELATION.name,
						event_id: e
					} }, B(S, x.M_POLL_END.name, {}), B(S, T.M_TEXT.name, b), S)
				});
			}
		}]), D;
	}(D.ExtensibleEvent);
})), require_MPoll = /* @__PURE__ */ __commonJSMin(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.parseMPoll = w;
	var b = require_poll_types(), x = require_PollStartEvent(), S = require_PollResponseEvent(), C = require_PollEndEvent();
	function w(e) {
		return b.M_POLL_START.matches(e.type) ? new x.PollStartEvent(e) : b.M_POLL_RESPONSE.matches(e.type) ? new S.PollResponseEvent(e) : b.M_POLL_END.matches(e.type) ? new C.PollEndEvent(e) : null;
	}
})), require_ExtensibleEvents = /* @__PURE__ */ __commonJSMin(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	var b = require_NamespacedMap(), x = require_InvalidEventError(), S = require_MRoomMessage(), C = require_MMessage(), w = require_message_types(), T = require_poll_types(), E = require_MPoll();
	function D(e, b) {
		var x = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
		if (!x) {
			if (Array.isArray(e) || (x = O(e)) || b && e && typeof e.length == "number") {
				x && (e = x);
				var S = 0, C = function() {};
				return {
					s: C,
					n: function() {
						return S >= e.length ? { done: !0 } : {
							done: !1,
							value: e[S++]
						};
					},
					e: function(e) {
						throw e;
					},
					f: C
				};
			}
			throw TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
		}
		var w = !0, T = !1, E;
		return {
			s: function() {
				x = x.call(e);
			},
			n: function() {
				var e = x.next();
				return w = e.done, e;
			},
			e: function(e) {
				T = !0, E = e;
			},
			f: function() {
				try {
					!w && x.return != null && x.return();
				} finally {
					if (T) throw E;
				}
			}
		};
	}
	function O(e, b) {
		if (e) {
			if (typeof e == "string") return k(e, b);
			var x = Object.prototype.toString.call(e).slice(8, -1);
			if (x === "Object" && e.constructor && (x = e.constructor.name), x === "Map" || x === "Set") return Array.from(e);
			if (x === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(x)) return k(e, b);
		}
	}
	function k(e, b) {
		(b == null || b > e.length) && (b = e.length);
		for (var x = 0, S = Array(b); x < b; x++) S[x] = e[x];
		return S;
	}
	function A(e, b) {
		if (!(e instanceof b)) throw TypeError("Cannot call a class as a function");
	}
	function j(e, b) {
		for (var x = 0; x < b.length; x++) {
			var S = b[x];
			S.enumerable = S.enumerable || !1, S.configurable = !0, "value" in S && (S.writable = !0), Object.defineProperty(e, S.key, S);
		}
	}
	function M(e, b, x) {
		return b && j(e.prototype, b), x && j(e, x), Object.defineProperty(e, "prototype", { writable: !1 }), e;
	}
	function N(e, b, x) {
		return b in e ? Object.defineProperty(e, b, {
			value: x,
			enumerable: !0,
			configurable: !0,
			writable: !0
		}) : e[b] = x, e;
	}
	var P = /* @__PURE__ */ function() {
		function e() {
			A(this, e), N(this, "interpreters", new b.NamespacedMap([
				[S.LEGACY_M_ROOM_MESSAGE, S.parseMRoomMessage],
				[w.M_MESSAGE, C.parseMMessage],
				[w.M_EMOTE, C.parseMMessage],
				[w.M_NOTICE, C.parseMMessage],
				[T.M_POLL_START, E.parseMPoll],
				[T.M_POLL_RESPONSE, E.parseMPoll],
				[T.M_POLL_END, E.parseMPoll]
			])), N(this, "_unknownInterpretOrder", [w.M_MESSAGE]);
		}
		return M(e, [
			{
				key: "unknownInterpretOrder",
				get: function() {
					return this._unknownInterpretOrder ?? [];
				},
				set: function(e) {
					this._unknownInterpretOrder = e;
				}
			},
			{
				key: "registerInterpreter",
				value: function(e, b) {
					this.interpreters.set(e, b);
				}
			},
			{
				key: "parse",
				value: function(e) {
					try {
						if (this.interpreters.hasNamespaced(e.type)) return this.interpreters.getNamespaced(e.type)(e);
						var b = D(this.unknownInterpretOrder), S;
						try {
							for (b.s(); !(S = b.n()).done;) {
								var C = S.value;
								if (this.interpreters.has(C)) {
									var w = this.interpreters.get(C)(e);
									if (w) return w;
								}
							}
						} catch (e) {
							b.e(e);
						} finally {
							b.f();
						}
						return null;
					} catch (e) {
						if (e instanceof x.InvalidEventError) return null;
						throw e;
					}
				}
			}
		], [
			{
				key: "defaultInstance",
				get: function() {
					return e._defaultInstance;
				}
			},
			{
				key: "unknownInterpretOrder",
				get: function() {
					return e.defaultInstance.unknownInterpretOrder;
				},
				set: function(b) {
					e.defaultInstance.unknownInterpretOrder = b;
				}
			},
			{
				key: "registerInterpreter",
				value: function(b, x) {
					e.defaultInstance.registerInterpreter(b, x);
				}
			},
			{
				key: "parse",
				value: function(b) {
					return e.defaultInstance.parse(b);
				}
			}
		]), e;
	}();
	e.ExtensibleEvents = P, N(P, "_defaultInstance", new P());
})), require_IPartialEvent = /* @__PURE__ */ __commonJSMin(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
})), require_MessageMatchers = /* @__PURE__ */ __commonJSMin(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.isEventLike = S;
	var b = require_message_types(), x;
	(function(e) {
		e.Text = "m.text", e.Notice = "m.notice", e.Emote = "m.emote";
	})(x || (e.LegacyMsgType = x = {}));
	function S(e, S) {
		var C = e.content;
		return S === x.Text ? b.M_MESSAGE.matches(e.type) || e.type === "m.room.message" && C?.msgtype === "m.text" : S === x.Emote ? b.M_EMOTE.matches(e.type) || e.type === "m.room.message" && C?.msgtype === "m.emote" : S === x.Notice ? b.M_NOTICE.matches(e.type) || e.type === "m.room.message" && C?.msgtype === "m.notice" : !1;
	}
})), require_lib$1 = /* @__PURE__ */ __commonJSMin(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	var b = require_ExtensibleEvents();
	Object.keys(b).forEach(function(x) {
		x === "default" || x === "__esModule" || x in e && e[x] === b[x] || Object.defineProperty(e, x, {
			enumerable: !0,
			get: function() {
				return b[x];
			}
		});
	});
	var x = require_IPartialEvent();
	Object.keys(x).forEach(function(b) {
		b === "default" || b === "__esModule" || b in e && e[b] === x[b] || Object.defineProperty(e, b, {
			enumerable: !0,
			get: function() {
				return x[b];
			}
		});
	});
	var S = require_InvalidEventError();
	Object.keys(S).forEach(function(b) {
		b === "default" || b === "__esModule" || b in e && e[b] === S[b] || Object.defineProperty(e, b, {
			enumerable: !0,
			get: function() {
				return S[b];
			}
		});
	});
	var C = require_NamespacedValue();
	Object.keys(C).forEach(function(b) {
		b === "default" || b === "__esModule" || b in e && e[b] === C[b] || Object.defineProperty(e, b, {
			enumerable: !0,
			get: function() {
				return C[b];
			}
		});
	});
	var w = require_NamespacedMap();
	Object.keys(w).forEach(function(b) {
		b === "default" || b === "__esModule" || b in e && e[b] === w[b] || Object.defineProperty(e, b, {
			enumerable: !0,
			get: function() {
				return w[b];
			}
		});
	});
	var T = require_types();
	Object.keys(T).forEach(function(b) {
		b === "default" || b === "__esModule" || b in e && e[b] === T[b] || Object.defineProperty(e, b, {
			enumerable: !0,
			get: function() {
				return T[b];
			}
		});
	});
	var E = require_MessageMatchers();
	Object.keys(E).forEach(function(b) {
		b === "default" || b === "__esModule" || b in e && e[b] === E[b] || Object.defineProperty(e, b, {
			enumerable: !0,
			get: function() {
				return E[b];
			}
		});
	});
	var D = require_events();
	Object.keys(D).forEach(function(b) {
		b === "default" || b === "__esModule" || b in e && e[b] === D[b] || Object.defineProperty(e, b, {
			enumerable: !0,
			get: function() {
				return D[b];
			}
		});
	});
	var O = require_MRoomMessage();
	Object.keys(O).forEach(function(b) {
		b === "default" || b === "__esModule" || b in e && e[b] === O[b] || Object.defineProperty(e, b, {
			enumerable: !0,
			get: function() {
				return O[b];
			}
		});
	});
	var k = require_MMessage();
	Object.keys(k).forEach(function(b) {
		b === "default" || b === "__esModule" || b in e && e[b] === k[b] || Object.defineProperty(e, b, {
			enumerable: !0,
			get: function() {
				return k[b];
			}
		});
	});
	var A = require_MPoll();
	Object.keys(A).forEach(function(b) {
		b === "default" || b === "__esModule" || b in e && e[b] === A[b] || Object.defineProperty(e, b, {
			enumerable: !0,
			get: function() {
				return A[b];
			}
		});
	});
	var j = require_relationship_types();
	Object.keys(j).forEach(function(b) {
		b === "default" || b === "__esModule" || b in e && e[b] === j[b] || Object.defineProperty(e, b, {
			enumerable: !0,
			get: function() {
				return j[b];
			}
		});
	});
	var M = require_ExtensibleEvent();
	Object.keys(M).forEach(function(b) {
		b === "default" || b === "__esModule" || b in e && e[b] === M[b] || Object.defineProperty(e, b, {
			enumerable: !0,
			get: function() {
				return M[b];
			}
		});
	});
	var N = require_message_types();
	Object.keys(N).forEach(function(b) {
		b === "default" || b === "__esModule" || b in e && e[b] === N[b] || Object.defineProperty(e, b, {
			enumerable: !0,
			get: function() {
				return N[b];
			}
		});
	});
	var P = require_MessageEvent();
	Object.keys(P).forEach(function(b) {
		b === "default" || b === "__esModule" || b in e && e[b] === P[b] || Object.defineProperty(e, b, {
			enumerable: !0,
			get: function() {
				return P[b];
			}
		});
	});
	var F = require_EmoteEvent();
	Object.keys(F).forEach(function(b) {
		b === "default" || b === "__esModule" || b in e && e[b] === F[b] || Object.defineProperty(e, b, {
			enumerable: !0,
			get: function() {
				return F[b];
			}
		});
	});
	var I = require_NoticeEvent();
	Object.keys(I).forEach(function(b) {
		b === "default" || b === "__esModule" || b in e && e[b] === I[b] || Object.defineProperty(e, b, {
			enumerable: !0,
			get: function() {
				return I[b];
			}
		});
	});
	var L = require_poll_types();
	Object.keys(L).forEach(function(b) {
		b === "default" || b === "__esModule" || b in e && e[b] === L[b] || Object.defineProperty(e, b, {
			enumerable: !0,
			get: function() {
				return L[b];
			}
		});
	});
	var R = require_PollStartEvent();
	Object.keys(R).forEach(function(b) {
		b === "default" || b === "__esModule" || b in e && e[b] === R[b] || Object.defineProperty(e, b, {
			enumerable: !0,
			get: function() {
				return R[b];
			}
		});
	});
	var z = require_PollResponseEvent();
	Object.keys(z).forEach(function(b) {
		b === "default" || b === "__esModule" || b in e && e[b] === z[b] || Object.defineProperty(e, b, {
			enumerable: !0,
			get: function() {
				return z[b];
			}
		});
	});
	var B = require_PollEndEvent();
	Object.keys(B).forEach(function(b) {
		b === "default" || b === "__esModule" || b in e && e[b] === B[b] || Object.defineProperty(e, b, {
			enumerable: !0,
			get: function() {
				return B[b];
			}
		});
	});
}));
function _objectWithoutPropertiesLoose(e, b) {
	if (e == null) return {};
	var x = {};
	for (var S in e) if ({}.hasOwnProperty.call(e, S)) {
		if (b.indexOf(S) !== -1) continue;
		x[S] = e[S];
	}
	return x;
}
function _objectWithoutProperties(e, b) {
	if (e == null) return {};
	var x, S, C = _objectWithoutPropertiesLoose(e, b);
	if (Object.getOwnPropertySymbols) {
		var w = Object.getOwnPropertySymbols(e);
		for (S = 0; S < w.length; S++) x = w[S], b.indexOf(x) === -1 && {}.propertyIsEnumerable.call(e, x) && (C[x] = e[x]);
	}
	return C;
}
var UserEvent = /* @__PURE__ */ function(e) {
	return e.DisplayName = "User.displayName", e.AvatarUrl = "User.avatarUrl", e.Presence = "User.presence", e.CurrentlyActive = "User.currentlyActive", e.LastPresenceTs = "User.lastPresenceTs", e;
}({}), User = class e extends TypedEventEmitter {
	constructor(e) {
		super(), this.userId = e, _defineProperty(this, "modified", -1), _defineProperty(this, "displayName", void 0), _defineProperty(this, "rawDisplayName", void 0), _defineProperty(this, "avatarUrl", void 0), _defineProperty(this, "presenceStatusMsg", void 0), _defineProperty(this, "presence", "offline"), _defineProperty(this, "lastActiveAgo", 0), _defineProperty(this, "lastPresenceTs", 0), _defineProperty(this, "currentlyActive", !1), _defineProperty(this, "events", {}), this.displayName = e, this.rawDisplayName = e, this.updateModifiedTime();
	}
	static createUser(b, x) {
		var S = new e(b);
		return x.reEmitter.reEmit(S, [
			UserEvent.AvatarUrl,
			UserEvent.DisplayName,
			UserEvent.Presence,
			UserEvent.CurrentlyActive,
			UserEvent.LastPresenceTs
		]), S;
	}
	setPresenceEvent(e) {
		if (e.getType() === "m.presence") {
			var b = this.events.presence === null;
			this.events.presence = e;
			var x = [];
			(e.getContent().presence !== this.presence || b) && x.push(UserEvent.Presence), e.getContent().avatar_url && e.getContent().avatar_url !== this.avatarUrl && x.push(UserEvent.AvatarUrl), e.getContent().displayname && e.getContent().displayname !== this.displayName && x.push(UserEvent.DisplayName), e.getContent().currently_active !== void 0 && e.getContent().currently_active !== this.currentlyActive && x.push(UserEvent.CurrentlyActive), this.presence = e.getContent().presence, x.push(UserEvent.LastPresenceTs), e.getContent().status_msg && (this.presenceStatusMsg = e.getContent().status_msg), e.getContent().displayname && (this.displayName = e.getContent().displayname), e.getContent().avatar_url && (this.avatarUrl = e.getContent().avatar_url), this.lastActiveAgo = e.getContent().last_active_ago, this.lastPresenceTs = Date.now(), this.currentlyActive = e.getContent().currently_active, this.updateModifiedTime();
			for (var S of x) this.emit(S, e, this);
		}
	}
	setDisplayName(e) {
		var b = this.displayName;
		this.displayName = e, e !== b && this.updateModifiedTime();
	}
	setRawDisplayName(e) {
		this.rawDisplayName = e;
	}
	setAvatarUrl(e) {
		var b = this.avatarUrl;
		this.avatarUrl = e, e !== b && this.updateModifiedTime();
	}
	updateModifiedTime() {
		this.modified = Date.now();
	}
	getLastModifiedTime() {
		return this.modified;
	}
	getLastActiveTs() {
		return this.lastPresenceTs - this.lastActiveAgo;
	}
}, Direction = /* @__PURE__ */ function(e) {
	return e.Backward = "b", e.Forward = "f", e;
}({}), EventTimeline = class e {
	static setEventMetadata(e, b, x) {
		e.setMetadata(b, x);
	}
	constructor(e) {
		this.eventTimelineSet = e, _defineProperty(this, "roomId", void 0), _defineProperty(this, "name", void 0), _defineProperty(this, "events", []), _defineProperty(this, "baseIndex", 0), _defineProperty(this, "startState", void 0), _defineProperty(this, "endState", void 0), _defineProperty(this, "startToken", null), _defineProperty(this, "endToken", null), _defineProperty(this, "prevTimeline", null), _defineProperty(this, "nextTimeline", null), _defineProperty(this, "paginationRequests", {
			[Direction.Backward]: null,
			[Direction.Forward]: null
		}), this.roomId = e.room?.roomId ?? null, this.roomId && (this.startState = new RoomState(this.roomId), this.endState = new RoomState(this.roomId)), this.paginationRequests = {
			b: null,
			f: null
		}, this.name = this.roomId + ":" + (/* @__PURE__ */ new Date()).toISOString();
	}
	initialiseState(e) {
		var b, x, { timelineWasEmpty: S } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
		if (this.events.length > 0) throw Error("Cannot initialise state after events are added");
		(b = this.startState) == null || b.setStateEvents(e, { timelineWasEmpty: S }), (x = this.endState) == null || x.setStateEvents(e, { timelineWasEmpty: S });
	}
	forkLive(b) {
		var x = this.getState(b), S = new e(this.eventTimelineSet);
		return S.startState = x?.clone(), S.endState = x, this.endState = x?.clone(), S;
	}
	fork(b) {
		var x = this.getState(b), S = new e(this.eventTimelineSet);
		return S.startState = x?.clone(), S.endState = x?.clone(), S;
	}
	getRoomId() {
		return this.roomId;
	}
	getFilter() {
		return this.eventTimelineSet.getFilter();
	}
	getTimelineSet() {
		return this.eventTimelineSet;
	}
	getBaseIndex() {
		return this.baseIndex;
	}
	getEvents() {
		return this.events;
	}
	getState(b) {
		if (b == e.BACKWARDS) return this.startState;
		if (b == e.FORWARDS) return this.endState;
		throw Error("Invalid direction '" + b + "'");
	}
	getPaginationToken(e) {
		return this.roomId ? this.getState(e).paginationToken : e === Direction.Backward ? this.startToken : this.endToken;
	}
	setPaginationToken(e, b) {
		this.roomId ? this.getState(b).paginationToken = e : b === Direction.Backward ? this.startToken = e : this.endToken = e;
	}
	getNeighbouringTimeline(b) {
		if (b == e.BACKWARDS) return this.prevTimeline;
		if (b == e.FORWARDS) return this.nextTimeline;
		throw Error("Invalid direction '" + b + "'");
	}
	setNeighbouringTimeline(b, x) {
		if (this.getNeighbouringTimeline(x)) throw Error("timeline already has a neighbouring timeline - cannot reset neighbour (direction: " + x + ")");
		if (x == e.BACKWARDS) this.prevTimeline = b;
		else if (x == e.FORWARDS) this.nextTimeline = b;
		else throw Error("Invalid direction '" + x + "'");
		this.setPaginationToken(null, x);
	}
	addEvent(b, x) {
		var { toStartOfTimeline: S, roomState: C, timelineWasEmpty: w, addToState: T } = x;
		C ||= S ? this.startState : this.endState;
		var E = this.getTimelineSet();
		if (E.room && (e.setEventMetadata(b, C, S), T && b.isState() && E.room.getUnfilteredTimelineSet() === E)) {
			var D;
			(D = C) == null || D.setStateEvents([b], { timelineWasEmpty: w }), (!b.sender || b.getType() === EventType.RoomMember && !S) && e.setEventMetadata(b, C, S);
		}
		var O = S ? 0 : this.events.length;
		this.events.splice(O, 0, b), S && this.baseIndex++;
	}
	insertEvent(b, x, S, C) {
		var w = this.getTimelineSet();
		w.room && (e.setEventMetadata(b, S, !1), C && b.isState() && w.room.getUnfilteredTimelineSet() === w && (S.setStateEvents([b], {}), (!b.sender || b.getType() === EventType.RoomMember) && e.setEventMetadata(b, S, !1))), this.events.splice(x, 0, b);
	}
	removeEvent(e) {
		for (var b = this.events.length - 1; b >= 0; b--) {
			var x = this.events[b];
			if (x.getId() == e) return this.events.splice(b, 1), b < this.baseIndex && this.baseIndex--, x;
		}
		return null;
	}
	toString() {
		return this.name;
	}
};
_defineProperty(EventTimeline, "BACKWARDS", Direction.Backward), _defineProperty(EventTimeline, "FORWARDS", Direction.Forward);
var RelationsEvent = /* @__PURE__ */ function(e) {
	return e.Add = "Relations.add", e.Remove = "Relations.remove", e.Redaction = "Relations.redaction", e;
}({}), matchesEventType = function(e, b) {
	var x = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
	return [b, ...x].includes(e);
}, Relations = class extends TypedEventEmitter {
	constructor(e, b, x, S) {
		var C;
		super(), C = this, this.relationType = e, this.eventType = b, this.altEventTypes = S, _defineProperty(this, "relationEventIds", /* @__PURE__ */ new Set()), _defineProperty(this, "relations", /* @__PURE__ */ new Set()), _defineProperty(this, "annotationsByKey", {}), _defineProperty(this, "annotationsBySender", {}), _defineProperty(this, "sortedAnnotationsByKey", []), _defineProperty(this, "targetEvent", null), _defineProperty(this, "creationEmitted", !1), _defineProperty(this, "client", void 0), _defineProperty(this, "onEventStatus", (e, b) => {
			if (!e.isSending()) {
				e.removeListener(MatrixEventEvent.Status, this.onEventStatus);
				return;
			}
			b === EventStatus.CANCELLED && (e.removeListener(MatrixEventEvent.Status, this.onEventStatus), this.removeEvent(e));
		}), _defineProperty(this, "onBeforeRedaction", /* @__PURE__ */ function() {
			var e = _asyncToGenerator(function* (e) {
				if (C.relations.has(e)) {
					if (C.relations.delete(e), C.relationType === RelationType.Annotation) C.removeAnnotationFromAggregation(e);
					else if (C.relationType === RelationType.Replace && C.targetEvent && !C.targetEvent.isState()) {
						var b = yield C.getLastReplacement();
						C.targetEvent.makeReplaced(b);
					}
					e.removeListener(MatrixEventEvent.BeforeRedaction, C.onBeforeRedaction), C.emit(RelationsEvent.Redaction, e);
				}
			});
			return function(b) {
				return e.apply(this, arguments);
			};
		}()), this.client = x instanceof Room ? x.client : x;
	}
	addEvent(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			if (!b.relationEventIds.has(e.getId())) {
				var x = e.getRelation();
				if (!x) {
					logger.error("Event must have relation info");
					return;
				}
				var S = x.rel_type, C = e.getType();
				if (b.relationType !== S || !matchesEventType(C, b.eventType, b.altEventTypes)) {
					logger.error("Event relation info doesn't match this container");
					return;
				}
				if (e.isSending() && e.on(MatrixEventEvent.Status, b.onEventStatus), b.relations.add(e), b.relationEventIds.add(e.getId()), b.relationType === RelationType.Annotation) b.addAnnotationToAggregation(e);
				else if (b.relationType === RelationType.Replace && b.targetEvent && !b.targetEvent.isState()) {
					var w = yield b.getLastReplacement();
					b.targetEvent.makeReplaced(w);
				}
				e.on(MatrixEventEvent.BeforeRedaction, b.onBeforeRedaction), b.emit(RelationsEvent.Add, e), b.maybeEmitCreated();
			}
		})();
	}
	removeEvent(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			if (b.relations.has(e)) {
				if (b.relations.delete(e), b.relationType === RelationType.Annotation) b.removeAnnotationFromAggregation(e);
				else if (b.relationType === RelationType.Replace && b.targetEvent && !b.targetEvent.isState()) {
					var x = yield b.getLastReplacement();
					b.targetEvent.makeReplaced(x);
				}
				b.emit(RelationsEvent.Remove, e);
			}
		})();
	}
	getRelations() {
		return [...this.relations];
	}
	addAnnotationToAggregation(e) {
		var { key: b } = e.getRelation() ?? {};
		if (b) {
			var x = this.annotationsByKey[b];
			x || (x = this.annotationsByKey[b] = /* @__PURE__ */ new Set(), this.sortedAnnotationsByKey.push([b, x])), x.add(e), this.sortedAnnotationsByKey.sort((e, b) => {
				var x = e[1];
				return b[1].size - x.size;
			});
			var S = e.getSender(), C = this.annotationsBySender[S];
			C ||= this.annotationsBySender[S] = /* @__PURE__ */ new Set(), C.add(e);
		}
	}
	removeAnnotationFromAggregation(e) {
		var { key: b } = e.getRelation() ?? {};
		if (b) {
			var x = this.annotationsByKey[b];
			x && (x.delete(e), this.sortedAnnotationsByKey.sort((e, b) => {
				var x = e[1];
				return b[1].size - x.size;
			}));
			var S = e.getSender(), C = this.annotationsBySender[S];
			C && C.delete(e);
		}
	}
	getSortedAnnotationsByKey() {
		return this.relationType === RelationType.Annotation ? this.sortedAnnotationsByKey : null;
	}
	getAnnotationsBySender() {
		return this.relationType === RelationType.Annotation ? this.annotationsBySender : null;
	}
	getLastReplacement() {
		var e = this;
		return _asyncToGenerator(function* () {
			if (e.relationType !== RelationType.Replace || !e.targetEvent) return null;
			var b = e.targetEvent.getServerAggregatedRelation(RelationType.Replace)?.origin_server_ts, x = e.getRelations().reduce((x, S) => S.getSender() !== e.targetEvent.getSender() || b && b > S.getTs() || x && x.getTs() > S.getTs() ? x : S, null);
			return x != null && x.shouldAttemptDecryption() && e.client.getCrypto() ? yield x.attemptDecryption(e.client.getCrypto()) : x != null && x.isBeingDecrypted() && (yield x.getDecryptionPromise()), x;
		})();
	}
	setTargetEvent(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			if (!b.targetEvent) {
				if (b.targetEvent = e, b.relationType === RelationType.Replace && !b.targetEvent.isState()) {
					var x = yield b.getLastReplacement();
					x && b.targetEvent.makeReplaced(x);
				}
				b.maybeEmitCreated();
			}
		})();
	}
	maybeEmitCreated() {
		this.creationEmitted || !this.targetEvent || !this.relations.size || (this.creationEmitted = !0, this.targetEvent.emit(MatrixEventEvent.RelationsCreated, this.relationType, this.eventType));
	}
}, RelationsContainer = class {
	constructor(e, b) {
		this.client = e, this.room = b, _defineProperty(this, "relations", /* @__PURE__ */ new Map());
	}
	getChildEventsForEvent(e, b, x) {
		var S;
		return (S = this.relations.get(e)) == null || (S = S.get(b)) == null ? void 0 : S.get(x);
	}
	getAllChildEventsForEvent(e) {
		var b = this.relations.get(e) ?? /* @__PURE__ */ new Map(), x = [];
		for (var S of b.values()) for (var C of S.values()) x.push(...C.getRelations());
		return x;
	}
	aggregateParentEvent(e) {
		var b = this.relations.get(e.getId());
		if (b) for (var x of b.values()) for (var S of x.values()) S.setTargetEvent(e);
	}
	aggregateChildEvent(e, b) {
		if (!(e.isRedacted() || e.status === EventStatus.CANCELLED)) {
			var x = e.getRelation();
			if (x) {
				var S = () => {
					if (e.isDecryptionFailure()) {
						e.once(MatrixEventEvent.Decrypted, S);
						return;
					}
					this.aggregateChildEvent(e, b);
				};
				if (e.isBeingDecrypted() || e.shouldAttemptDecryption()) {
					e.once(MatrixEventEvent.Decrypted, S);
					return;
				}
				var { event_id: C, rel_type: w } = x, T = e.getType(), E = this.relations.get(C);
				E || (E = /* @__PURE__ */ new Map(), this.relations.set(C, E));
				var D = E.get(w);
				D || (D = /* @__PURE__ */ new Map(), E.set(w, D));
				var O = D.get(T);
				if (!O) {
					O = new Relations(w, T, this.client), D.set(T, O);
					var k = this.room ?? b?.room, A = b?.findEventById(C) ?? k?.findEventById(C) ?? k?.getPendingEvent(C);
					A && O.setTargetEvent(A);
				}
				O.addEvent(e);
			}
		}
	}
}, debuglog$2 = logger.log.bind(logger), DuplicateStrategy = /* @__PURE__ */ function(e) {
	return e.Ignore = "ignore", e.Replace = "replace", e;
}({}), EventTimelineSet = class extends TypedEventEmitter {
	constructor(e) {
		var b = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, x = arguments.length > 2 ? arguments[2] : void 0, S = arguments.length > 3 ? arguments[3] : void 0, C = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null;
		super(), this.room = e, this.thread = S, this.threadListType = C, _defineProperty(this, "relations", void 0), _defineProperty(this, "timelineSupport", void 0), _defineProperty(this, "displayPendingEvents", void 0), _defineProperty(this, "liveTimeline", void 0), _defineProperty(this, "timelines", void 0), _defineProperty(this, "_eventIdToTimeline", /* @__PURE__ */ new Map()), _defineProperty(this, "filter", void 0), this.timelineSupport = !!b.timelineSupport, this.liveTimeline = new EventTimeline(this), this.displayPendingEvents = b.pendingEvents !== !1, this.timelines = [this.liveTimeline], this._eventIdToTimeline = /* @__PURE__ */ new Map(), this.filter = b.filter, this.relations = this.room?.relations ?? new RelationsContainer(e?.client ?? x);
	}
	getTimelines() {
		return this.timelines;
	}
	getFilter() {
		return this.filter;
	}
	setFilter(e) {
		this.filter = e;
	}
	getPendingEvents() {
		return !this.room || !this.displayPendingEvents ? [] : this.room.getPendingEvents();
	}
	getLiveTimeline() {
		return this.liveTimeline;
	}
	setLiveTimeline(e) {
		this.liveTimeline = e;
	}
	eventIdToTimeline(e) {
		return this._eventIdToTimeline.get(e);
	}
	replaceEventId(e, b) {
		var x = this._eventIdToTimeline.get(e);
		x && (this._eventIdToTimeline.delete(e), this._eventIdToTimeline.set(b, x));
	}
	resetLiveTimeline(e, b) {
		var x = !this.timelineSupport || !b, S = this.liveTimeline, C = x ? S.forkLive(EventTimeline.FORWARDS) : S.fork(EventTimeline.FORWARDS);
		x ? (this.timelines = [C], this._eventIdToTimeline = /* @__PURE__ */ new Map()) : this.timelines.push(C), b && S.setPaginationToken(b, EventTimeline.FORWARDS), C.setPaginationToken(e ?? null, EventTimeline.BACKWARDS), this.liveTimeline = C, this.emit(RoomEvent.TimelineReset, this.room, this, x);
	}
	getTimelineForEvent(e) {
		if (e == null) return null;
		var b = this._eventIdToTimeline.get(e);
		return b === void 0 ? null : b;
	}
	findEventById(e) {
		var b = this.getTimelineForEvent(e);
		if (b) return b.getEvents().find(function(b) {
			return b.getId() == e;
		});
	}
	addTimeline() {
		if (!this.timelineSupport) throw Error("timeline support is disabled. Set the 'timelineSupport' parameter to true when creating MatrixClient to enable it.");
		var e = new EventTimeline(this);
		return this.timelines.push(e), e;
	}
	addEventsToTimeline(e, b, x, S, C) {
		if (!S) throw Error("'timeline' not specified for EventTimelineSet.addEventsToTimeline");
		if (!b && S == this.liveTimeline) throw Error("EventTimelineSet.addEventsToTimeline cannot be used for adding events to the live timeline - use Room.addLiveEvents instead");
		if (!(this.filter && (e = this.filter.filterRoomTimeline(e), !e.length))) {
			var w = b ? EventTimeline.BACKWARDS : EventTimeline.FORWARDS, T = b ? EventTimeline.FORWARDS : EventTimeline.BACKWARDS, E = !1, D = !1;
			for (var O of e) {
				var k = O.getId(), A = this._eventIdToTimeline.get(k);
				if (!A) {
					this.addEventToTimeline(O, S, {
						toStartOfTimeline: b,
						addToState: x
					}), D = !0, E = !0;
					continue;
				}
				if (D = !1, A == S) {
					debuglog$2("Event " + k + " already in timeline " + S);
					continue;
				}
				var j = S.getNeighbouringTimeline(w);
				if (j) {
					debuglog$2(A == j ? "Event " + k + " in neighbouring timeline - switching to " + A : "Event " + k + " already in a different timeline " + A), S = A;
					continue;
				}
				logger.info("Already have timeline for " + k + " - joining timeline " + S + " to " + A);
				var M = A === this.liveTimeline, N = S === this.liveTimeline, P = w === EventTimeline.BACKWARDS && M, F = w === EventTimeline.FORWARDS && N;
				if (P || F) {
					P && logger.warn("Refusing to set a preceding existingTimeLine on our timeline as the existingTimeLine is live (" + A + ")"), F && logger.warn("Refusing to set our preceding timeline on a existingTimeLine as our timeline is live (" + S + ")");
					continue;
				}
				S.setNeighbouringTimeline(A, w), A.setNeighbouringTimeline(S, T), S = A, E = !0;
			}
			if (D || !E) {
				if (w === EventTimeline.FORWARDS && S === this.liveTimeline) {
					logger.warn({
						lastEventWasNew: D,
						didUpdate: E
					}), logger.warn(`Refusing to set forwards pagination token of live timeline ${S} to ${C}`);
					return;
				}
				S.setPaginationToken(C ?? null, w);
			}
		}
	}
	addLiveEvent(e, b) {
		var { duplicateStrategy: x, fromCache: S, roomState: C, timelineWasEmpty: w, addToState: T } = b;
		if (!(this.filter && !this.filter.filterRoomTimeline([e]).length)) {
			var E = this._eventIdToTimeline.get(e.getId());
			if (E) {
				if (x === DuplicateStrategy.Replace) {
					debuglog$2("EventTimelineSet.addLiveEvent: replacing duplicate event " + e.getId());
					for (var D = E.getEvents(), O = 0; O < D.length; O++) if (D[O].getId() === e.getId()) {
						C ||= E.getState(EventTimeline.FORWARDS), EventTimeline.setEventMetadata(e, C, !1), D[O] = e;
						break;
					}
				} else debuglog$2("EventTimelineSet.addLiveEvent: ignoring duplicate event " + e.getId());
				return;
			}
			this.addEventToTimeline(e, this.liveTimeline, {
				toStartOfTimeline: !1,
				fromCache: S,
				roomState: C,
				timelineWasEmpty: w,
				addToState: T
			});
		}
	}
	addEventToTimeline(e, b, x) {
		var { toStartOfTimeline: S, fromCache: C = !1, roomState: w, timelineWasEmpty: T, addToState: E } = x;
		if (b.getTimelineSet() !== this) throw Error(`EventTimelineSet.addEventToTimeline: Timeline=${b.toString()} does not belong " +
                "in timelineSet(threadId=${this.thread?.id})`);
		var D = e.getId();
		if (this.relations.aggregateParentEvent(e), this.relations.aggregateChildEvent(e, this), this.room && !this.canContain(e)) {
			var O = `event=${D}`;
			e.threadRootId && (O += `(belongs to thread=${e.threadRootId})`), logger.warn(`EventTimelineSet.addEventToTimeline: Ignoring ${O} that does not belong in timeline=${b.toString()} timelineSet(threadId=${this.thread?.id})`);
			return;
		}
		b.addEvent(e, {
			toStartOfTimeline: S,
			roomState: w,
			timelineWasEmpty: T,
			addToState: E
		}), this._eventIdToTimeline.set(D, b);
		var k = {
			timeline: b,
			liveEvent: !S && b == this.liveTimeline && !C
		};
		this.emit(RoomEvent.Timeline, e, this.room, !!S, !1, k);
	}
	insertEventIntoTimeline(e, b, x, S) {
		if (b.getTimelineSet() !== this) throw Error(`EventTimelineSet.insertEventIntoTimeline: Timeline=${b.toString()} does not belong " +
                "in timelineSet(threadId=${this.thread?.id})`);
		var C = e.getId();
		if (this.relations.aggregateParentEvent(e), this.relations.aggregateChildEvent(e, this), this.room && !this.canContain(e)) {
			var w = `event=${C}`;
			e.threadRootId && (w += `(belongs to thread=${e.threadRootId})`), logger.warn(`EventTimelineSet.insertEventIntoTimeline: Ignoring ${w} that does not belong in timeline=${b.toString()} timelineSet(threadId=${this.thread?.id})`);
			return;
		}
		var T = e.relationEventId;
		if (!T) {
			this.addEventToTimeline(e, b, {
				toStartOfTimeline: !1,
				fromCache: !1,
				timelineWasEmpty: !1,
				roomState: x,
				addToState: S
			});
			return;
		}
		for (var E = this.findEventById(T), D = b.getEvents(), O = E === void 0 ? 0 : D.indexOf(E); O < D.length && !(D[O].getTs() > e.getTs()); O++);
		b.insertEvent(e, O, x, S), this._eventIdToTimeline.set(C, b);
		var k = {
			timeline: b,
			liveEvent: !1
		};
		this.emit(RoomEvent.Timeline, e, this.room, !1, !1, k);
	}
	handleRemoteEcho(e, b, x) {
		var S = this._eventIdToTimeline.get(b);
		S ? (this._eventIdToTimeline.delete(b), this._eventIdToTimeline.set(x, S)) : (!this.filter || this.filter.filterRoomTimeline([e]).length) && this.addEventToTimeline(e, this.liveTimeline, {
			toStartOfTimeline: !1,
			addToState: !1
		});
	}
	removeEvent(e) {
		var b = this._eventIdToTimeline.get(e);
		if (!b) return null;
		var x = b.removeEvent(e);
		if (x) {
			this._eventIdToTimeline.delete(e);
			var S = { timeline: b };
			this.emit(RoomEvent.Timeline, x, this.room, void 0, !0, S);
		}
		return x;
	}
	compareEventOrdering(e, b) {
		if (e == b) return 0;
		var x = this._eventIdToTimeline.get(e), S = this._eventIdToTimeline.get(b);
		if (x === void 0 || S === void 0) return null;
		if (x === S) {
			for (var C = void 0, w = void 0, T = x.getEvents(), E = 0; E < T.length && (C === void 0 || w === void 0); E++) {
				var D = T[E].getId();
				D == e && (C = E), D == b && (w = E);
			}
			var O = C - w;
			return O < 0 ? -1 : O > 0 ? 1 : 0;
		}
		for (var k = x; k;) {
			if (k === S) return -1;
			k = k.getNeighbouringTimeline(EventTimeline.FORWARDS);
		}
		for (k = x; k;) {
			if (k === S) return 1;
			k = k.getNeighbouringTimeline(EventTimeline.BACKWARDS);
		}
		return null;
	}
	canContain(e) {
		if (!this.room) throw Error("Cannot call `EventTimelineSet::canContain without a `room` set. Set the room when creating the EventTimelineSet to call this method.");
		var { threadId: b, shouldLiveInRoom: x, shouldLiveInThread: S } = this.room.eventShouldLiveIn(e);
		return this.thread ? this.thread.id === b : (!x && !S && logger.warn(`EventTimelineSet:canContain event encountered which cannot be added to any timeline roomId=${this.room?.roomId} eventId=${e.getId()} threadId=${e.threadRootId}`), x);
	}
}, EventStatus = /* @__PURE__ */ function(e) {
	return e.NOT_SENT = "not_sent", e.ENCRYPTING = "encrypting", e.SENDING = "sending", e.QUEUED = "queued", e.SENT = "sent", e.CANCELLED = "cancelled", e;
}({}), RoomSummary = class {
	constructor(e, b) {
		this.roomId = e;
	}
}, ReEmitter = class {
	constructor(e) {
		this.target = e, _defineProperty(this, "reEmitters", /* @__PURE__ */ new WeakMap());
	}
	reEmit(e, b) {
		var x = this, S = this.reEmitters.get(e);
		S || (S = /* @__PURE__ */ new Map(), this.reEmitters.set(e, S));
		var C = function(b) {
			if (S.has(b)) return 1;
			var C = function() {
				if (!(b === "error" && x.target.listenerCount("error") === 0)) {
					var S = [...arguments];
					x.target.emit(b, ...S, e);
				}
			};
			e.on(b, C), S.set(b, C);
		};
		for (var w of b) if (C(w)) continue;
	}
	stopReEmitting(e, b) {
		var x = this.reEmitters.get(e);
		if (x) {
			for (var S of b) e.off(S, x.get(S)), x.delete(S);
			x.size === 0 && this.reEmitters.delete(e);
		}
	}
}, TypedReEmitter = class extends ReEmitter {
	constructor(e) {
		super(e);
	}
	reEmit(e, b) {
		super.reEmit(e, b);
	}
	stopReEmitting(e, b) {
		super.stopReEmitting(e, b);
	}
}, UNREAD_THREAD_NOTIFICATIONS = new ServerControlledNamespacedValue("unread_thread_notifications", "org.matrix.msc3773.unread_thread_notifications");
function matchesWildcard(e, b) {
	if (b.endsWith("*")) {
		var x = b.slice(0, -1);
		return e.slice(0, x.length) === x;
	} else return e === b;
}
var FilterComponent = class {
	constructor(e, b) {
		this.filterJson = e, this.userId = b;
	}
	check(e) {
		var b, x = e.getUnsigned()?.["m.relations"] || {}, S = Object.keys(x), C = [];
		return this.userId && x != null && (b = x[THREAD_RELATION_TYPE.name]) != null && b.current_user_participated && C.push(this.userId), this.checkFields(e.getRoomId(), e.getSender(), e.getType(), e.getContent() ? e.getContent().url !== void 0 : !1, S, C);
	}
	toJSON() {
		return Object.fromEntries(Object.entries({
			types: this.filterJson.types,
			not_types: this.filterJson.not_types,
			rooms: this.filterJson.rooms,
			not_rooms: this.filterJson.not_rooms,
			senders: this.filterJson.senders,
			not_senders: this.filterJson.not_senders,
			contains_url: this.filterJson.contains_url,
			[FILTER_RELATED_BY_SENDERS.name]: this.filterJson[FILTER_RELATED_BY_SENDERS.name],
			[FILTER_RELATED_BY_REL_TYPES.name]: this.filterJson[FILTER_RELATED_BY_REL_TYPES.name]
		}).filter((e) => {
			var [b, x] = e;
			return x;
		}));
	}
	checkFields(e, b, x, S, C, w) {
		var T = {
			rooms: function(b) {
				return e === b;
			},
			senders: function(e) {
				return b === e;
			},
			types: function(e) {
				return matchesWildcard(x, e);
			}
		};
		for (var E in T) {
			var D = T[E], O = "not_" + E, k = this.filterJson[O];
			if (k != null && k.some(D)) return !1;
			var A = this.filterJson[E];
			if (A && !A.some(D)) return !1;
		}
		var j = this.filterJson.contains_url;
		if (j !== void 0 && j !== S) return !1;
		var M = this.filterJson[FILTER_RELATED_BY_REL_TYPES.name];
		if (M !== void 0 && !this.arrayMatchesFilter(M, C)) return !1;
		var N = this.filterJson[FILTER_RELATED_BY_SENDERS.name];
		return !(N !== void 0 && !this.arrayMatchesFilter(N, w));
	}
	arrayMatchesFilter(e, b) {
		return b.length > 0 && e.every((e) => b.includes(e));
	}
	filter(e) {
		return e.filter(this.check, this);
	}
	limit() {
		return this.filterJson.limit === void 0 ? 10 : this.filterJson.limit;
	}
};
function ownKeys$19(e, b) {
	var x = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var S = Object.getOwnPropertySymbols(e);
		b && (S = S.filter(function(b) {
			return Object.getOwnPropertyDescriptor(e, b).enumerable;
		})), x.push.apply(x, S);
	}
	return x;
}
function _objectSpread$19(e) {
	for (var b = 1; b < arguments.length; b++) {
		var x = arguments[b] == null ? {} : arguments[b];
		b % 2 ? ownKeys$19(Object(x), !0).forEach(function(b) {
			_defineProperty(e, b, x[b]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(x)) : ownKeys$19(Object(x)).forEach(function(b) {
			Object.defineProperty(e, b, Object.getOwnPropertyDescriptor(x, b));
		});
	}
	return e;
}
function setProp(e, b, x) {
	for (var S = b.split("."), C = e, w = 0; w < S.length - 1; w++) C[S[w]] || (C[S[w]] = {}), C = C[S[w]];
	C[S[S.length - 1]] = x;
}
var Filter = class e {
	static fromJson(b, x, S) {
		var C = new e(b, x);
		return C.setDefinition(S), C;
	}
	constructor(e, b) {
		this.userId = e, this.filterId = b, _defineProperty(this, "definition", {}), _defineProperty(this, "roomFilter", void 0), _defineProperty(this, "roomTimelineFilter", void 0);
	}
	getFilterId() {
		return this.filterId;
	}
	getDefinition() {
		return this.definition;
	}
	setDefinition(e) {
		this.definition = e;
		var b = e.room, x = {};
		b && (b.rooms && (x.rooms = b.rooms), b.rooms && (x.not_rooms = b.not_rooms)), this.roomFilter = new FilterComponent(x, this.userId), this.roomTimelineFilter = new FilterComponent(b?.timeline || {}, this.userId);
	}
	getRoomTimelineFilterComponent() {
		return this.roomTimelineFilter;
	}
	filterRoomTimeline(e) {
		return this.roomFilter && (e = this.roomFilter.filter(e)), this.roomTimelineFilter && (e = this.roomTimelineFilter.filter(e)), e;
	}
	setTimelineLimit(e) {
		setProp(this.definition, "room.timeline.limit", e);
	}
	setUnreadThreadNotifications(e) {
		var b;
		this.definition = _objectSpread$19(_objectSpread$19({}, this.definition), {}, { room: _objectSpread$19(_objectSpread$19({}, this.definition?.room), {}, { timeline: _objectSpread$19(_objectSpread$19({}, (b = this.definition) == null || (b = b.room) == null ? void 0 : b.timeline), {}, { [UNREAD_THREAD_NOTIFICATIONS.name]: e }) }) });
	}
	setLazyLoadMembers(e) {
		setProp(this.definition, "room.state.lazy_load_members", e);
	}
	setIncludeLeaveRooms(e) {
		setProp(this.definition, "room.include_leave", e);
	}
};
_defineProperty(Filter, "LAZY_LOADING_MESSAGES_FILTER", { lazy_load_members: !0 });
function isProvided(e) {
	return e != null;
}
var import_lib$7 = /* @__PURE__ */ __toESM(require_lib$1()), M_MESSAGE = new import_lib$7.UnstableValue("m.message", "org.matrix.msc1767.message"), M_TEXT = new import_lib$7.UnstableValue("m.text", "org.matrix.msc1767.text"), M_HTML = new import_lib$7.UnstableValue("m.html", "org.matrix.msc1767.html"), REFERENCE_RELATION = new import_lib$7.NamespacedValue("m.reference");
function isEventTypeSame(e, b) {
	if (typeof e == "string") return typeof b == "string" ? b === e : b.matches(e);
	if (typeof b == "string") return e.matches(b);
	var x = b, S = e;
	return x.matches(S.name) || isProvided(S.altName) && x.matches(S.altName);
}
var M_TOPIC = new NamespacedValue("m.topic"), content_helpers_exports = /* @__PURE__ */ __export({
	getTextForLocationEvent: () => getTextForLocationEvent,
	makeBeaconContent: () => makeBeaconContent,
	makeBeaconInfoContent: () => makeBeaconInfoContent,
	makeEmoteMessage: () => makeEmoteMessage,
	makeHtmlEmote: () => makeHtmlEmote,
	makeHtmlMessage: () => makeHtmlMessage,
	makeHtmlNotice: () => makeHtmlNotice,
	makeLocationContent: () => makeLocationContent,
	makeNotice: () => makeNotice,
	makeTextMessage: () => makeTextMessage,
	makeTopicContent: () => makeTopicContent,
	parseBeaconContent: () => parseBeaconContent,
	parseBeaconInfoContent: () => parseBeaconInfoContent,
	parseLocationEvent: () => parseLocationEvent,
	parseTopicContent: () => parseTopicContent
});
function ownKeys$18(e, b) {
	var x = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var S = Object.getOwnPropertySymbols(e);
		b && (S = S.filter(function(b) {
			return Object.getOwnPropertyDescriptor(e, b).enumerable;
		})), x.push.apply(x, S);
	}
	return x;
}
function _objectSpread$18(e) {
	for (var b = 1; b < arguments.length; b++) {
		var x = arguments[b] == null ? {} : arguments[b];
		b % 2 ? ownKeys$18(Object(x), !0).forEach(function(b) {
			_defineProperty(e, b, x[b]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(x)) : ownKeys$18(Object(x)).forEach(function(b) {
			Object.defineProperty(e, b, Object.getOwnPropertyDescriptor(x, b));
		});
	}
	return e;
}
function makeHtmlMessage(e, b) {
	return {
		msgtype: MsgType.Text,
		format: "org.matrix.custom.html",
		body: e,
		formatted_body: b
	};
}
function makeHtmlNotice(e, b) {
	return {
		msgtype: MsgType.Notice,
		format: "org.matrix.custom.html",
		body: e,
		formatted_body: b
	};
}
function makeHtmlEmote(e, b) {
	return {
		msgtype: MsgType.Emote,
		format: "org.matrix.custom.html",
		body: e,
		formatted_body: b
	};
}
function makeTextMessage(e) {
	return {
		msgtype: MsgType.Text,
		body: e
	};
}
function makeNotice(e) {
	return {
		msgtype: MsgType.Notice,
		body: e
	};
}
function makeEmoteMessage(e) {
	return {
		msgtype: MsgType.Emote,
		body: e
	};
}
var getTextForLocationEvent = (e, b, x, S) => {
	var C = `at ${new Date(x).toISOString()}`, w = b === LocationAssetType.Self ? "User" : void 0, T = S ? `"${S}"` : void 0;
	return [
		w,
		"Location",
		T,
		e,
		C
	].filter(Boolean).join(" ");
}, makeLocationContent = (e, b, x, S, C) => {
	var w = e ?? getTextForLocationEvent(b, C || LocationAssetType.Self, x, S), T = x ? { [M_TIMESTAMP.name]: x } : {};
	return _objectSpread$18({
		msgtype: MsgType.Location,
		body: w,
		geo_uri: b,
		[M_LOCATION.name]: {
			description: S,
			uri: b
		},
		[M_ASSET.name]: { type: C || LocationAssetType.Self },
		[M_TEXT.name]: w
	}, T);
}, parseLocationEvent = (e) => {
	var b = M_LOCATION.findIn(e), x = M_ASSET.findIn(e), S = M_TIMESTAMP.findIn(e), C = M_TEXT.findIn(e), w = b?.uri ?? e?.geo_uri, T = b?.description, E = x?.type ?? LocationAssetType.Self, D = C ?? e.body;
	return makeLocationContent(D, w, S ?? void 0, T, E);
}, makeTopicContent = (e, b) => {
	var x = [];
	return isProvided(b) && x.push({
		body: b,
		mimetype: "text/html"
	}), isProvided(e) && x.push({
		body: e,
		mimetype: "text/plain"
	}), {
		topic: e,
		[M_TOPIC.name]: { "m.text": x }
	};
}, parseTopicContent = (e) => {
	var b, x, S = M_TOPIC.findIn(e), C = Array.isArray(S) ? S : S?.["m.text"];
	if (!Array.isArray(C)) return { text: e.topic ?? void 0 };
	var w = (C == null || (b = C.find((e) => !isProvided(e.mimetype) || e.mimetype === "text/plain")) == null ? void 0 : b.body) ?? e.topic ?? void 0, T = C == null || (x = C.find((e) => e.mimetype === "text/html")) == null ? void 0 : x.body;
	return {
		text: w,
		html: T
	};
}, makeBeaconInfoContent = (e, b, x, S, C) => ({
	description: x,
	timeout: e,
	live: b,
	[M_TIMESTAMP.name]: C || Date.now(),
	[M_ASSET.name]: { type: S ?? LocationAssetType.Self }
}), parseBeaconInfoContent = (e) => {
	var { description: b, timeout: x, live: S } = e, C = M_TIMESTAMP.findIn(e) ?? void 0, w = M_ASSET.findIn(e);
	return {
		description: b,
		timeout: x,
		live: S,
		assetType: w?.type,
		timestamp: C
	};
}, makeBeaconContent = (e, b, x, S) => ({
	[M_LOCATION.name]: {
		description: S,
		uri: e
	},
	[M_TIMESTAMP.name]: b,
	"m.relates_to": {
		rel_type: REFERENCE_RELATION.name,
		event_id: x
	}
}), parseBeaconContent = (e) => {
	var b = M_LOCATION.findIn(e), x = M_TIMESTAMP.findIn(e) ?? void 0;
	return {
		description: b?.description,
		uri: b?.uri,
		timestamp: x
	};
}, BeaconEvent = /* @__PURE__ */ function(e) {
	return e.New = "Beacon.new", e.Update = "Beacon.update", e.LivenessChange = "Beacon.LivenessChange", e.Destroy = "Beacon.Destroy", e.LocationUpdate = "Beacon.LocationUpdate", e;
}({}), isTimestampInDuration = (e, b, x) => x >= e && e + b >= x, getBeaconInfoIdentifier = (e) => `${e.getRoomId()}_${e.getStateKey()}`, Beacon = class extends TypedEventEmitter {
	constructor(e) {
		super(), this.rootEvent = e, _defineProperty(this, "roomId", void 0), _defineProperty(this, "_beaconInfo", void 0), _defineProperty(this, "_isLive", void 0), _defineProperty(this, "livenessWatchTimeout", void 0), _defineProperty(this, "_latestLocationEvent", void 0), _defineProperty(this, "clearLatestLocation", () => {
			this._latestLocationEvent = void 0, this.emit(BeaconEvent.LocationUpdate, this.latestLocationState);
		}), this.roomId = this.rootEvent.getRoomId(), this.setBeaconInfo(this.rootEvent);
	}
	get isLive() {
		return !!this._isLive;
	}
	get identifier() {
		return getBeaconInfoIdentifier(this.rootEvent);
	}
	get beaconInfoId() {
		return this.rootEvent.getId();
	}
	get beaconInfoOwner() {
		return this.rootEvent.getStateKey();
	}
	get beaconInfoEventType() {
		return this.rootEvent.getType();
	}
	get beaconInfo() {
		return this._beaconInfo;
	}
	get latestLocationState() {
		return this._latestLocationEvent && parseBeaconContent(this._latestLocationEvent.getContent());
	}
	get latestLocationEvent() {
		return this._latestLocationEvent;
	}
	update(e) {
		if (getBeaconInfoIdentifier(e) !== this.identifier) throw Error("Invalid updating event");
		e.getTs() < this.rootEvent.getTs() || (this.rootEvent = e, this.setBeaconInfo(this.rootEvent), this.emit(BeaconEvent.Update, e, this), this.clearLatestLocation());
	}
	destroy() {
		this.livenessWatchTimeout && clearTimeout(this.livenessWatchTimeout), this._isLive = !1, this.emit(BeaconEvent.Destroy, this.identifier);
	}
	monitorLiveness() {
		if (this.livenessWatchTimeout && clearTimeout(this.livenessWatchTimeout), this.checkLiveness(), this.beaconInfo) if (this.isLive) {
			var e = this.beaconInfo.timestamp + this.beaconInfo.timeout - Date.now();
			e > 1 && (this.livenessWatchTimeout = setTimeout(() => {
				this.monitorLiveness();
			}, e));
		} else this.beaconInfo.timestamp > Date.now() && (this.livenessWatchTimeout = setTimeout(() => {
			this.monitorLiveness();
		}, this.beaconInfo.timestamp - Date.now()));
	}
	addLocations(e) {
		if (this.isLive) {
			var b = e.filter((e) => {
				var b = e.getContent(), x = parseBeaconContent(b);
				if (!x.uri || !x.timestamp) return !1;
				var { timestamp: S } = x;
				return this._beaconInfo.timestamp && isTimestampInDuration(this._beaconInfo.timestamp, this._beaconInfo.timeout, S) && (!this.latestLocationState || S > this.latestLocationState.timestamp);
			}).sort(sortEventsByLatestContentTimestamp)?.[0];
			b && (this._latestLocationEvent = b, this.emit(BeaconEvent.LocationUpdate, this.latestLocationState));
		}
	}
	setBeaconInfo(e) {
		this._beaconInfo = parseBeaconInfoContent(e.getContent()), this.checkLiveness();
	}
	checkLiveness() {
		var e = this.isLive;
		if (this.beaconInfo) {
			var b = this.beaconInfo.timestamp > Date.now() ? this.beaconInfo.timestamp - 36e4 : this.beaconInfo.timestamp;
			this._isLive = !!this._beaconInfo.live && !!b && isTimestampInDuration(b, this._beaconInfo.timeout, Date.now()), e !== this.isLive && this.emit(BeaconEvent.LivenessChange, this.isLive, this);
		}
	}
};
function ownKeys$17(e, b) {
	var x = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var S = Object.getOwnPropertySymbols(e);
		b && (S = S.filter(function(b) {
			return Object.getOwnPropertyDescriptor(e, b).enumerable;
		})), x.push.apply(x, S);
	}
	return x;
}
function _objectSpread$17(e) {
	for (var b = 1; b < arguments.length; b++) {
		var x = arguments[b] == null ? {} : arguments[b];
		b % 2 ? ownKeys$17(Object(x), !0).forEach(function(b) {
			_defineProperty(e, b, x[b]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(x)) : ownKeys$17(Object(x)).forEach(function(b) {
			Object.defineProperty(e, b, Object.getOwnPropertyDescriptor(x, b));
		});
	}
	return e;
}
function synthesizeReceipt(e, b, x) {
	var S = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
	return new MatrixEvent({
		content: { [b.getId()]: { [x]: { [e]: _objectSpread$17({ ts: b.getTs() }, !S && { thread_id: threadIdForReceipt(b) }) } } },
		type: EventType.Receipt,
		room_id: b.getRoomId()
	});
}
var ReceiptPairRealIndex = 0, ReceiptPairSyntheticIndex = 1, ReadReceipt = class extends TypedEventEmitter {
	constructor() {
		super(...arguments), _defineProperty(this, "receipts", new MapWithDefault(() => /* @__PURE__ */ new Map())), _defineProperty(this, "receiptCacheByEventId", /* @__PURE__ */ new Map());
	}
	getReadReceiptForUserId(e) {
		var b = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, x = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ReceiptType.Read, [S, C] = this.receipts.get(x)?.get(e) ?? [null, null];
		return b ? S : C ?? S;
	}
	compareReceipts(e, b) {
		return this.getUnfilteredTimelineSet().compareEventOrdering(e.eventId, b.eventId) ?? e.data.ts - b.data.ts;
	}
	getEventReadUpTo(e) {
		var b = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, x = this.getLatestReceipt(e, b);
		return x && this.receiptPointsAtConsistentEvent(x) ? x.eventId : null;
	}
	receiptPointsAtConsistentEvent(e) {
		var b, x = this.findEventById(e.eventId);
		if (!x) return !1;
		if (!((b = e.data) != null && b.thread_id)) return !0;
		if (e.data.thread_id === "main") {
			if (inMainTimelineForReceipt(x)) return !0;
		} else if (x.threadRootId === e.data.thread_id) return !0;
		return logger.warn(`Ignoring receipt because its thread_id (${e.data.thread_id}) disagrees with the thread root (${x.threadRootId}) of the referenced event (event ID = ${e.eventId})`), !1;
	}
	getLatestReceipt(e, b) {
		var x = this.getReadReceiptForUserId(e, b, ReceiptType.Read), S = this.getReadReceiptForUserId(e, b, ReceiptType.ReadPrivate), C;
		return x != null && x.eventId && S != null && S.eventId && (C = this.compareReceipts(x, S)), C ? (C < 0 ? S : x) ?? null : S ?? x ?? null;
	}
	addReceiptToStructure(e, b, x, S, C) {
		var w = this.receipts.getOrCreate(b), T = w.get(x);
		T || (T = [null, null], w.set(x, T));
		var E = T[ReceiptPairRealIndex];
		C && (E = T[ReceiptPairSyntheticIndex] ?? T[ReceiptPairRealIndex]);
		var D = {
			eventId: e,
			data: S
		};
		if (!(E && this.compareReceipts(E, D) >= 0)) {
			var O = C ? T[ReceiptPairRealIndex] : D, k = C ? D : T[ReceiptPairSyntheticIndex], A = null;
			O && k && (A = this.getUnfilteredTimelineSet().compareEventOrdering(O.eventId, k.eventId));
			var j = A === null || A < 0, M = T[ReceiptPairSyntheticIndex] ?? T[ReceiptPairRealIndex];
			C && j ? T[ReceiptPairSyntheticIndex] = D : C || (T[ReceiptPairRealIndex] = D, j || (T[ReceiptPairSyntheticIndex] = null));
			var N = T[ReceiptPairSyntheticIndex] ?? T[ReceiptPairRealIndex];
			if (M !== N) {
				if (M && this.receiptCacheByEventId.get(M.eventId)) {
					var P = M.eventId;
					this.receiptCacheByEventId.set(P, this.receiptCacheByEventId.get(P).filter((e) => e.type !== b || e.userId !== x)), this.receiptCacheByEventId.get(P).length < 1 && this.receiptCacheByEventId.delete(P);
				}
				this.receiptCacheByEventId.get(e) || this.receiptCacheByEventId.set(e, []), this.receiptCacheByEventId.get(e).push({
					userId: x,
					type: b,
					data: S
				});
			}
		}
	}
	getReceiptsForEvent(e) {
		return this.receiptCacheByEventId.get(e.getId()) || [];
	}
	fixupNotifications(e) {
		var b = this.getReadReceiptForUserId(e, !1), x = this.timeline[this.timeline.length - 1];
		x && b?.eventId === x.getId() && e === x.getSender() && (this.setUnread(NotificationCountType.Total, 0), this.setUnread(NotificationCountType.Highlight, 0));
	}
	addLocalEchoReceipt(e, b, x) {
		var S = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
		this.addReceipt(synthesizeReceipt(e, b, x, S), !0);
	}
	getUsersReadUpTo(e) {
		return this.getReceiptsForEvent(e).filter(function(e) {
			return isSupportedReceiptType(e.type);
		}).map(function(e) {
			return e.userId;
		});
	}
}, import_lib$6 = /* @__PURE__ */ __toESM(require_lib$1()), M_POLL_KIND_DISCLOSED = new import_lib$6.UnstableValue("m.poll.disclosed", "org.matrix.msc3381.poll.disclosed"), M_POLL_KIND_UNDISCLOSED = new import_lib$6.UnstableValue("m.poll.undisclosed", "org.matrix.msc3381.poll.undisclosed"), M_POLL_START$2 = new import_lib$6.UnstableValue("m.poll.start", "org.matrix.msc3381.poll.start"), M_POLL_RESPONSE = new import_lib$6.UnstableValue("m.poll.response", "org.matrix.msc3381.poll.response"), M_POLL_END = new import_lib$6.UnstableValue("m.poll.end", "org.matrix.msc3381.poll.end"), import_lib$5 = /* @__PURE__ */ __toESM(require_lib$1()), PollEvent = /* @__PURE__ */ function(e) {
	return e.New = "Poll.new", e.End = "Poll.end", e.Update = "Poll.update", e.Responses = "Poll.Responses", e.Destroy = "Poll.Destroy", e.UndecryptableRelations = "Poll.UndecryptableRelations", e;
}({}), filterResponseRelations = (e, b) => ({ responseEvents: e.filter((e) => {
	if (!e.isDecryptionFailure()) return M_POLL_RESPONSE.matches(e.getType()) && e.getTs() <= b;
}) }), Poll = class extends TypedEventEmitter {
	constructor(e, b, x) {
		if (super(), this.rootEvent = e, this.matrixClient = b, this.room = x, _defineProperty(this, "roomId", void 0), _defineProperty(this, "pollEvent", void 0), _defineProperty(this, "_isFetchingResponses", !1), _defineProperty(this, "relationsNextBatch", void 0), _defineProperty(this, "responses", null), _defineProperty(this, "endEvent", void 0), _defineProperty(this, "undecryptableRelationEventIds", /* @__PURE__ */ new Set()), _defineProperty(this, "countUndecryptableEvents", (e) => {
			var b = e.filter((e) => e.isDecryptionFailure()).map((e) => e.getId()), x = this.undecryptableRelationsCount;
			this.undecryptableRelationEventIds = new Set([...this.undecryptableRelationEventIds, ...b]), this.undecryptableRelationsCount !== x && this.emit(PollEvent.UndecryptableRelations, this.undecryptableRelationsCount);
		}), !this.rootEvent.getRoomId() || !this.rootEvent.getId()) throw Error("Invalid poll start event.");
		this.roomId = this.rootEvent.getRoomId(), this.pollEvent = this.rootEvent.unstableExtensibleEvent;
	}
	get pollId() {
		return this.rootEvent.getId();
	}
	get endEventId() {
		return this.endEvent?.getId();
	}
	get isEnded() {
		return !!this.endEvent;
	}
	get isFetchingResponses() {
		return this._isFetchingResponses;
	}
	get undecryptableRelationsCount() {
		return this.undecryptableRelationEventIds.size;
	}
	getResponses() {
		var e = this;
		return _asyncToGenerator(function* () {
			return e.responses || e.isFetchingResponses || (yield e.fetchResponses()), e.responses;
		})();
	}
	onNewRelation(e) {
		if (M_POLL_END.matches(e.getType()) && this.validateEndEvent(e) && (this.endEvent = e, this.refilterResponsesOnEnd(), this.emit(PollEvent.End)), this.responses) {
			var b = this.endEvent?.getTs() || 2 ** 53 - 1, { responseEvents: x } = filterResponseRelations([e], b);
			this.countUndecryptableEvents([e]), x.length && (x.forEach((e) => {
				this.responses.addEvent(e);
			}), this.emit(PollEvent.Responses, this.responses));
		}
	}
	fetchResponses() {
		var e = this;
		return _asyncToGenerator(function* () {
			e._isFetchingResponses = !0;
			var b = yield e.matrixClient.relations(e.roomId, e.rootEvent.getId(), "m.reference", void 0, { from: e.relationsNextBatch || void 0 });
			yield Promise.all(b.events.map((b) => e.matrixClient.decryptEventIfNeeded(b)));
			var x = e.responses || new Relations("m.reference", M_POLL_RESPONSE.name, e.matrixClient, [M_POLL_RESPONSE.altName]), S = b.events.find((e) => M_POLL_END.matches(e.getType()));
			e.validateEndEvent(S) && (e.endEvent = S, e.refilterResponsesOnEnd(), e.emit(PollEvent.End));
			var C = e.endEvent?.getTs() || 2 ** 53 - 1, { responseEvents: w } = filterResponseRelations(b.events, C);
			w.forEach((e) => {
				x.addEvent(e);
			}), e.relationsNextBatch = b.nextBatch ?? void 0, e.responses = x, e.countUndecryptableEvents(b.events), e.relationsNextBatch ? e.fetchResponses() : e._isFetchingResponses = !1, e.emit(PollEvent.Responses, e.responses);
		})();
	}
	refilterResponsesOnEnd() {
		if (this.responses) {
			var e = this.endEvent?.getTs() || 2 ** 53 - 1;
			this.responses.getRelations().forEach((b) => {
				if (b.getTs() > e) {
					var x;
					(x = this.responses) == null || x.removeEvent(b);
				}
			}), this.emit(PollEvent.Responses, this.responses);
		}
	}
	validateEndEvent(e) {
		if (!e || this.endEvent && this.endEvent.getTs() < e.getTs()) return !1;
		var b = this.room.currentState, x = e.getSender();
		return !!x && (x === this.rootEvent.getSender() || b.maySendRedactionForEvent(this.rootEvent, x));
	}
}, isPollEvent = (e) => {
	var b = e.getType();
	return import_lib$5.M_POLL_START.matches(b) || M_POLL_RESPONSE.matches(b) || M_POLL_END.matches(b);
}, RoomReceipts = class {
	constructor(e) {
		_defineProperty(this, "room", void 0), _defineProperty(this, "threadedReceipts", void 0), _defineProperty(this, "unthreadedReceipts", void 0), _defineProperty(this, "danglingReceipts", void 0), _defineProperty(this, "onTimelineEvent", (e) => {
			var b = e.getId();
			b && this.danglingReceipts.remove(b)?.forEach((e) => {
				e.receipt.thread_id ? this.threadedReceipts.set(e.receipt.thread_id, e.eventId, e.receiptType, e.userId, e.receipt.ts, e.synthetic) : this.unthreadedReceipts.set(b, e.receiptType, e.userId, e.receipt.ts, e.synthetic);
			});
		}), this.room = e, this.threadedReceipts = new ThreadedReceipts(e), this.unthreadedReceipts = new ReceiptsByUser(e), this.danglingReceipts = new DanglingReceipts(), e.on(RoomEvent.Timeline, this.onTimelineEvent);
	}
	add(e, b) {
		for (var [x, S] of Object.entries(e)) for (var [C, w] of Object.entries(S)) for (var [T, E] of Object.entries(w)) this.room.findEventById(x) ? E.thread_id ? this.threadedReceipts.set(E.thread_id, x, C, T, E.ts, b) : this.unthreadedReceipts.set(x, C, T, E.ts, b) : this.danglingReceipts.add(new DanglingReceipt(x, C, T, E, b));
	}
	hasUserReadEvent(e, b) {
		var x = this.unthreadedReceipts.get(e);
		if (x && isAfterOrSame(x.eventId, b, this.room)) return !0;
		var S = this.room.findEventById(b);
		if (!S) return logger.warn(`hasUserReadEvent event ID ${b} not found in room ${this.room.roomId}: this shouldn't happen!`), !1;
		var C = threadIdForReceipt(S), w = this.threadedReceipts.get(C, e);
		return !!(w && isAfterOrSame(w.eventId, b, this.room) || this.userSentLatestEventInThread(C, e));
	}
	userSentLatestEventInThread(e, b) {
		var x = e === "main" ? this.room.getLiveTimeline().getEvents() : this.room.getThread(e)?.timeline;
		return !!(x && x.length > 0 && x[x.length - 1].getSender() === b);
	}
}, ReceiptInfo = class {
	constructor(e, b, x) {
		this.eventId = e, this.receiptType = b, this.ts = x;
	}
}, DanglingReceipt = class {
	constructor(e, b, x, S, C) {
		this.eventId = e, this.receiptType = b, this.userId = x, this.receipt = S, this.synthetic = C;
	}
}, UserReceipts = class {
	constructor(e) {
		_defineProperty(this, "room", void 0), _defineProperty(this, "real", void 0), _defineProperty(this, "synthetic", void 0), this.room = e, this.real = void 0, this.synthetic = void 0;
	}
	set(e, b) {
		e ? this.synthetic = b : this.real = b, this.synthetic && this.real && isAfterOrSame(this.real.eventId, this.synthetic.eventId, this.room) && (this.synthetic = void 0);
	}
	get() {
		return this.synthetic ?? this.real;
	}
	getByType(e) {
		return e ? this.synthetic : this.real;
	}
}, ReceiptsByUser = class {
	constructor(e) {
		_defineProperty(this, "room", void 0), _defineProperty(this, "data", void 0), this.room = e, this.data = /* @__PURE__ */ new Map();
	}
	set(e, b, x, S, C) {
		var w = getOrCreate(this.data, x, () => new UserReceipts(this.room)), T = w.getByType(C);
		T && isAfter(T.eventId, e, this.room) || w.set(C, new ReceiptInfo(e, b, S));
	}
	get(e) {
		return this.data.get(e)?.get();
	}
}, ThreadedReceipts = class {
	constructor(e) {
		_defineProperty(this, "room", void 0), _defineProperty(this, "data", void 0), this.room = e, this.data = /* @__PURE__ */ new Map();
	}
	set(e, b, x, S, C, w) {
		getOrCreate(this.data, e, () => new ReceiptsByUser(this.room)).set(b, x, S, C, w);
	}
	get(e, b) {
		return this.data.get(e)?.get(b);
	}
}, DanglingReceipts = class {
	constructor() {
		_defineProperty(this, "data", /* @__PURE__ */ new Map());
	}
	add(e) {
		getOrCreate(this.data, e.eventId, () => []).push(e);
	}
	remove(e) {
		var b = this.data.get(e);
		return this.data.delete(e), b;
	}
};
function getOrCreate(e, b, x) {
	var S = e.get(b);
	if (S) return S;
	var C = x();
	return e.set(b, C), C;
}
function isAfterOrSame(e, b, x) {
	var S = x.compareEventOrdering(e, b);
	return S !== null && S >= 0;
}
function isAfter(e, b, x) {
	var S = x.compareEventOrdering(e, b);
	return S !== null && S > 0;
}
function compareEventOrdering(e, b, x) {
	var S = e.findEventById(b), C = e.findEventById(x);
	if (!S || !C) return null;
	var w = inMainTimelineForReceipt(S), T = inMainTimelineForReceipt(C);
	return w && T ? compareEventsInMainTimeline(e, b, x, S, C) : compareEventsInThreads(b, x, S, C);
}
function compareEventsInMainTimeline(e, b, x, S, C) {
	var w = e.getUnfilteredTimelineSet(), T = w.compareEventOrdering(b, x);
	return T === null ? w.getTimelineForEvent(b) === w.getLiveTimeline() ? 1 : w.getTimelineForEvent(x) === w.getLiveTimeline() ? -1 : guessOrderBasedOnTimestamp(S, C) : T;
}
function compareEventsInThreads(e, b, x, S) {
	var C = threadIdForReceipt(x), w = threadIdForReceipt(S), T = x.getThread();
	return T && C === w ? T.timelineSet.compareEventOrdering(e, b) : guessOrderBasedOnTimestamp(x, S);
}
function guessOrderBasedOnTimestamp(e, b) {
	var x = e.getTs(), S = b.getTs();
	return x < S ? -1 : x > S ? 1 : 0;
}
var Method = /* @__PURE__ */ function(e) {
	return e.Get = "GET", e.Put = "PUT", e.Post = "POST", e.Delete = "DELETE", e.Options = "OPTIONS", e.Head = "HEAD", e.Patch = "PATCH", e;
}({});
function ownKeys$16(e, b) {
	var x = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var S = Object.getOwnPropertySymbols(e);
		b && (S = S.filter(function(b) {
			return Object.getOwnPropertyDescriptor(e, b).enumerable;
		})), x.push.apply(x, S);
	}
	return x;
}
function _objectSpread$16(e) {
	for (var b = 1; b < arguments.length; b++) {
		var x = arguments[b] == null ? {} : arguments[b];
		b % 2 ? ownKeys$16(Object(x), !0).forEach(function(b) {
			_defineProperty(e, b, x[b]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(x)) : ownKeys$16(Object(x)).forEach(function(b) {
			Object.defineProperty(e, b, Object.getOwnPropertyDescriptor(x, b));
		});
	}
	return e;
}
var HTTPError = class extends Error {
	constructor(e, b, x) {
		super(e), this.httpStatus = b, this.httpHeaders = x;
	}
	isRateLimitError() {
		return this.httpStatus === 429;
	}
	getRetryAfterMs() {
		var e = this.httpHeaders?.get("Retry-After");
		if (e != null) {
			if (/^\d+$/.test(e)) {
				var b = Number.parseInt(e) * 1e3;
				if (!Number.isFinite(b)) throw Error("Retry-After header integer value is too large");
				return b;
			}
			var x = new Date(e);
			if (x.toUTCString() !== e) throw Error("Retry-After header value is not a valid HTTP-date or non-negative decimal integer");
			return x.getTime() - Date.now();
		}
		return null;
	}
}, MatrixError = class e extends HTTPError {
	constructor() {
		var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, b = arguments.length > 1 ? arguments[1] : void 0, x = arguments.length > 2 ? arguments[2] : void 0, S = arguments.length > 3 ? arguments[3] : void 0, C = arguments.length > 4 ? arguments[4] : void 0, w = e.error || "Unknown message";
		b && (w = `[${b}] ${w}`), x && (w = `${w} (${x})`), super(`MatrixError: ${w}`, b, C), this.url = x, this.event = S, _defineProperty(this, "errcode", void 0), _defineProperty(this, "data", void 0), this.errcode = e.errcode, this.name = e.errcode || "Unknown error code", this.data = e;
	}
	isRateLimitError() {
		return this.errcode === "M_LIMIT_EXCEEDED" || (this.errcode === "M_UNKNOWN" || this.errcode === void 0) && super.isRateLimitError();
	}
	getRetryAfterMs() {
		var e = super.getRetryAfterMs();
		if (e !== null) return e;
		if (this.errcode === "M_LIMIT_EXCEEDED" && "retry_after_ms" in this.data) {
			if (!Number.isInteger(this.data.retry_after_ms)) throw Error("retry_after_ms is not an integer");
			return this.data.retry_after_ms;
		}
		return null;
	}
	asWidgetApiErrorData() {
		var e = {};
		if (this.httpHeaders) for (var [b, x] of this.httpHeaders) e[b] = x;
		return {
			http_status: this.httpStatus ?? 400,
			http_headers: e,
			url: this.url ?? "",
			response: _objectSpread$16({
				errcode: this.errcode ?? "M_UNKNOWN",
				error: this.data.error ?? "Unknown message"
			}, this.data)
		};
	}
	static fromWidgetApiErrorData(b) {
		return new e(b.response, b.http_status, b.url, void 0, new Headers(b.http_headers));
	}
};
function safeGetRetryAfterMs(e, b) {
	if (!(e instanceof HTTPError) || !e.isRateLimitError()) return b;
	try {
		return e.getRetryAfterMs() ?? b;
	} catch {
		return b;
	}
}
var ConnectionError = class extends Error {
	constructor(e, b) {
		super(e + (b ? `: ${b.message}` : ""));
	}
	get name() {
		return "ConnectionError";
	}
}, TokenRefreshError = class extends Error {
	constructor(e) {
		super(e?.message ?? "");
	}
	get name() {
		return "TokenRefreshError";
	}
}, TokenRefreshLogoutError = class extends Error {
	constructor(e) {
		super(e?.message ?? "");
	}
	get name() {
		return "TokenRefreshLogoutError";
	}
}, HttpApiEvent = /* @__PURE__ */ function(e) {
	return e.SessionLoggedOut = "Session.logged_out", e.NoConsent = "no_consent", e;
}({}), import_content_type = /* @__PURE__ */ __toESM((/* @__PURE__ */ __commonJSMin(((e) => {
	var b = /; *([!#$%&'*+.^_`|~0-9A-Za-z-]+) *= *("(?:[\u000b\u0020\u0021\u0023-\u005b\u005d-\u007e\u0080-\u00ff]|\\[\u000b\u0020-\u00ff])*"|[!#$%&'*+.^_`|~0-9A-Za-z-]+) */g, x = /\\([\u000b\u0020-\u00ff])/g, S = /^[!#$%&'*+.^_`|~0-9A-Za-z-]+\/[!#$%&'*+.^_`|~0-9A-Za-z-]+$/;
	e.parse = C;
	function C(e) {
		if (!e) throw TypeError("argument string is required");
		var C = typeof e == "object" ? w(e) : e;
		if (typeof C != "string") throw TypeError("argument string is required to be a string");
		var E = C.indexOf(";"), D = E === -1 ? C.trim() : C.slice(0, E).trim();
		if (!S.test(D)) throw TypeError("invalid media type");
		var O = new T(D.toLowerCase());
		if (E !== -1) {
			var k, A, j;
			for (b.lastIndex = E; A = b.exec(C);) {
				if (A.index !== E) throw TypeError("invalid parameter format");
				E += A[0].length, k = A[1].toLowerCase(), j = A[2], j.charCodeAt(0) === 34 && (j = j.slice(1, -1), j.indexOf("\\") !== -1 && (j = j.replace(x, "$1"))), O.parameters[k] = j;
			}
			if (E !== C.length) throw TypeError("invalid parameter format");
		}
		return O;
	}
	function w(e) {
		var b;
		if (typeof e.getHeader == "function" ? b = e.getHeader("content-type") : typeof e.headers == "object" && (b = e.headers && e.headers["content-type"]), typeof b != "string") throw TypeError("content-type header is missing from object");
		return b;
	}
	function T(e) {
		this.parameters = Object.create(null), this.type = e;
	}
})))());
function timeoutSignal(e) {
	var b = new AbortController();
	return setTimeout(() => {
		b.abort();
	}, e), b.signal;
}
function anySignal(e) {
	var b = new AbortController();
	function x() {
		for (var b of e) b.removeEventListener("abort", S);
	}
	function S() {
		b.abort(), x();
	}
	for (var C of e) {
		if (C.aborted) {
			S();
			break;
		}
		C.addEventListener("abort", S);
	}
	return {
		signal: b.signal,
		cleanup: x
	};
}
function parseErrorResponse(e, b) {
	var x = isXhr(e) ? new Headers(e.getAllResponseHeaders().trim().split(/[\r\n]+/).map((e) => {
		var b = e.indexOf(":");
		return [e.substring(0, b), e.substring(b + 1)];
	})) : e.headers, S;
	try {
		S = getResponseContentType(x);
	} catch (e) {
		return e;
	}
	return S?.type === "application/json" && b ? new MatrixError(JSON.parse(b), e.status, isXhr(e) ? e.responseURL : e.url, void 0, x) : S?.type === "text/plain" ? new HTTPError(`Server returned ${e.status} error: ${b}`, e.status, x) : new HTTPError(`Server returned ${e.status} error`, e.status, x);
}
function isXhr(e) {
	return "getResponseHeader" in e;
}
function getResponseContentType(e) {
	var b = e.get("Content-Type");
	if (b === null) return null;
	try {
		return (0, import_content_type.parse)(b);
	} catch (e) {
		throw Error(`Error parsing Content-Type '${b}': ${e}`);
	}
}
function retryNetworkOperation(e, b) {
	return _retryNetworkOperation.apply(this, arguments);
}
function _retryNetworkOperation() {
	return _retryNetworkOperation = _asyncToGenerator(function* (e, b) {
		for (var x = 0, S = null; x < e;) try {
			if (x > 0) {
				var C = 1e3 * 2 ** x;
				logger.log(`network operation failed ${x} times, retrying in ${C}ms...`), yield sleep(C);
			}
			return yield b();
		} catch (e) {
			if (e instanceof ConnectionError) x += 1, S = e;
			else throw e;
		}
		throw S;
	}), _retryNetworkOperation.apply(this, arguments);
}
function calculateRetryBackoff(e, b, x) {
	return b > 4 || e instanceof ConnectionError && !x || e.httpStatus && Math.floor(e.httpStatus / 100) === 4 && e.httpStatus !== 429 || e.name === "AbortError" || e.name === "M_TOO_LARGE" ? -1 : safeGetRetryAfterMs(e, 1e3 * 2 ** b);
}
var TokenRefreshOutcome = /* @__PURE__ */ function(e) {
	return e.Success = "success", e.Failure = "failure", e.Logout = "logout", e;
}({}), REFRESH_IF_TOKEN_EXPIRES_WITHIN_MS = 500, REFRESH_ON_ERROR_IF_TOKEN_EXPIRES_WITHIN_MS = 60 * 1e3, TokenRefresher = class {
	constructor(e) {
		this.opts = e, _defineProperty(this, "tokenRefreshPromise", void 0), _defineProperty(this, "latestTokenRefreshExpiry", void 0);
	}
	prepareForRequest() {
		var e = this;
		return _asyncToGenerator(function* () {
			return yield e.refreshIfNeeded(), {
				accessToken: e.opts.accessToken,
				refreshToken: e.opts.refreshToken,
				expiry: e.latestTokenRefreshExpiry
			};
		})();
	}
	refreshIfNeeded() {
		var e = this;
		return _asyncToGenerator(function* () {
			if (e.tokenRefreshPromise) return e.tokenRefreshPromise;
			e.latestTokenRefreshExpiry && e.latestTokenRefreshExpiry.getTime() - Date.now() <= REFRESH_IF_TOKEN_EXPIRES_WITHIN_MS && (yield e._handleUnknownToken());
		})();
	}
	handleUnknownToken(e, b) {
		var x = this;
		return _asyncToGenerator(function* () {
			return x._handleUnknownToken(e, b);
		})();
	}
	_handleUnknownToken(e, b) {
		var x = this;
		return _asyncToGenerator(function* () {
			if (e != null && e.expiry && e.expiry.getTime() - Date.now() >= REFRESH_ON_ERROR_IF_TOKEN_EXPIRES_WITHIN_MS) return TokenRefreshOutcome.Logout;
			if (!e || e?.accessToken === x.opts.accessToken) {
				x.tokenRefreshPromise ??= x.doTokenRefresh(b);
				try {
					return yield x.tokenRefreshPromise;
				} finally {
					x.tokenRefreshPromise = void 0;
				}
			}
			return TokenRefreshOutcome.Success;
		})();
	}
	doTokenRefresh(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			if (!b.opts.refreshToken || !b.opts.tokenRefreshFunction) {
				var x;
				return (x = b.opts.logger) == null || x.error("Unable to refresh token - no refresh token or refresh function"), TokenRefreshOutcome.Logout;
			}
			e && e > 1 && (yield sleep(1e3 * Math.min(32, 2 ** e)));
			try {
				var S, C;
				(S = b.opts.logger) == null || S.debug("Attempting to refresh token");
				var { accessToken: w, refreshToken: T, expiry: E } = yield b.opts.tokenRefreshFunction(b.opts.refreshToken);
				return b.opts.accessToken = w, b.opts.refreshToken = T, b.latestTokenRefreshExpiry = E, (C = b.opts.logger) == null || C.debug("... token refresh complete, new token expiry:", E), TokenRefreshOutcome.Success;
			} catch (e) {
				var D;
				if (e instanceof TokenRefreshLogoutError || e instanceof MatrixError) {
					var O;
					return (O = b.opts.logger) == null || O.error("Failed to refresh token", e), TokenRefreshOutcome.Logout;
				}
				return (D = b.opts.logger) == null || D.warn("Failed to refresh token", e), TokenRefreshOutcome.Failure;
			}
		})();
	}
};
function ownKeys$15(e, b) {
	var x = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var S = Object.getOwnPropertySymbols(e);
		b && (S = S.filter(function(b) {
			return Object.getOwnPropertyDescriptor(e, b).enumerable;
		})), x.push.apply(x, S);
	}
	return x;
}
function _objectSpread$15(e) {
	for (var b = 1; b < arguments.length; b++) {
		var x = arguments[b] == null ? {} : arguments[b];
		b % 2 ? ownKeys$15(Object(x), !0).forEach(function(b) {
			_defineProperty(e, b, x[b]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(x)) : ownKeys$15(Object(x)).forEach(function(b) {
			Object.defineProperty(e, b, Object.getOwnPropertyDescriptor(x, b));
		});
	}
	return e;
}
var FetchHttpApi = class {
	constructor(e, b) {
		if (this.eventEmitter = e, this.opts = b, _defineProperty(this, "abortController", new AbortController()), _defineProperty(this, "tokenRefresher", void 0), checkObjectHasKeys(b, ["baseUrl", "prefix"]), !b.onlyData) throw Error("Constructing FetchHttpApi without `onlyData=true` is no longer supported.");
		b.useAuthorizationHeader = b.useAuthorizationHeader ?? !0, this.tokenRefresher = new TokenRefresher(b);
	}
	abort() {
		this.abortController.abort(), this.abortController = new AbortController();
	}
	fetch(e, b) {
		return this.opts.fetchFn ? this.opts.fetchFn(e, b) : globalThis.fetch(e, b);
	}
	setIdBaseUrl(e) {
		this.opts.idBaseUrl = e;
	}
	idServerRequest(e, b, x, S, C) {
		if (!this.opts.idBaseUrl) throw Error("No identity server base URL set");
		var w = void 0, T = void 0;
		e === Method.Get ? w = x : T = x;
		var E = this.getUrl(b, w, S, this.opts.idBaseUrl), D = {
			json: !0,
			headers: {}
		};
		return C && (D.headers.Authorization = `Bearer ${C}`), this.requestOtherUrl(e, E, T, D);
	}
	authedRequest(e, b) {
		var x = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, S = arguments.length > 3 ? arguments[3] : void 0, C = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
		return this.doAuthedRequest(1, e, b, x, S, C);
	}
	doAuthedRequest(e, b, x, S, C) {
		var w = arguments, T = this;
		return _asyncToGenerator(function* () {
			var E = w.length > 5 && w[5] !== void 0 ? w[5] : {}, D = deepCopy(E);
			D.abortSignal = E.abortSignal;
			var O = yield T.tokenRefresher.prepareForRequest();
			O.accessToken && (T.opts.useAuthorizationHeader ? (D.headers ||= {}, D.headers.Authorization || (D.headers.Authorization = `Bearer ${O.accessToken}`), S.access_token && delete S.access_token) : S.access_token ||= O.accessToken);
			try {
				return yield T.request(b, x, S, C, D);
			} catch (w) {
				if (!(w instanceof MatrixError)) throw w;
				if (w.errcode === "M_UNKNOWN_TOKEN") {
					var k = yield T.tokenRefresher.handleUnknownToken(O, e);
					if (k === TokenRefreshOutcome.Success) return T.doAuthedRequest(e + 1, b, x, S, C, E);
					if (k === TokenRefreshOutcome.Failure) throw new TokenRefreshError(w);
					D != null && D.inhibitLogoutEmit || T.eventEmitter.emit(HttpApiEvent.SessionLoggedOut, w);
				} else w.errcode == "M_CONSENT_NOT_GIVEN" && T.eventEmitter.emit(HttpApiEvent.NoConsent, w.message, w.data.consent_uri);
				throw w;
			}
		})();
	}
	request(e, b, x, S, C) {
		var w = this.getUrl(b, x, C?.prefix, C?.baseUrl);
		return this.requestOtherUrl(e, w, S, C);
	}
	requestOtherUrl(e, b, x) {
		var S = arguments, C = this;
		return _asyncToGenerator(function* () {
			var w, T, E = S.length > 3 && S[3] !== void 0 ? S[3] : {};
			if (E.json !== void 0 && E.rawResponseBody !== void 0) throw Error("Invalid call to `FetchHttpApi` sets both `opts.json` and `opts.rawResponseBody`");
			var D = C.sanitizeUrlForLogs(b);
			(w = C.opts.logger) == null || w.debug(`FetchHttpApi: --> ${e} ${D}`);
			var O = Object.assign({}, E.headers || {}), k = !E.rawResponseBody && E.json !== !1;
			k && (O.Accept ||= "application/json");
			var A = E.localTimeoutMs ?? C.opts.localTimeoutMs, j = E.keepAlive ?? !1, M = [C.abortController.signal];
			A !== void 0 && M.push(timeoutSignal(A)), E.abortSignal && M.push(E.abortSignal);
			var N;
			E.json !== !1 && (x == null || (T = x.constructor) == null ? void 0 : T.name) === Object.name ? (N = JSON.stringify(x), O["Content-Type"] ||= "application/json") : N = x;
			var { signal: P, cleanup: F } = anySignal(M), I = "Authorization" in O ? void 0 : "no-cache", L, R = Date.now();
			try {
				var z;
				L = yield C.fetch(b, {
					signal: P,
					method: e,
					body: N,
					headers: O,
					mode: "cors",
					redirect: "follow",
					referrer: "",
					referrerPolicy: "no-referrer",
					cache: I,
					credentials: "omit",
					keepalive: j,
					priority: E.priority
				}), (z = C.opts.logger) == null || z.debug(`FetchHttpApi: <-- ${e} ${D} [${Date.now() - R}ms ${L.status}]`);
			} catch (b) {
				var B;
				throw (B = C.opts.logger) == null || B.debug(`FetchHttpApi: <-- ${e} ${D} [${Date.now() - R}ms ${b}]`), b.name === "AbortError" ? b : new ConnectionError("fetch failed", b);
			} finally {
				F();
			}
			if (!L.ok) throw parseErrorResponse(L, yield L.text());
			return E.rawResponseBody ? yield L.blob() : k ? yield L.json() : yield L.text();
		})();
	}
	sanitizeUrlForLogs(e) {
		try {
			var b = typeof e == "string" ? new URL(e) : e, x = new URLSearchParams();
			for (var S of b.searchParams.keys()) x.append(S, "xxx");
			var C = x.toString(), w = C ? `?${C}` : "";
			return b.origin + b.pathname + w;
		} catch {
			return "??";
		}
	}
	getUrl(e, b, x, S) {
		var C = S ?? this.opts.baseUrl, w = C.endsWith("/") ? C.slice(0, -1) : C, T = new URL(w + (x ?? this.opts.prefix) + e);
		if (this.opts.extraParams || b) {
			var E = _objectSpread$15(_objectSpread$15({}, this.opts.extraParams), b);
			encodeParams(E, T.searchParams);
		}
		return T;
	}
}, ClientPrefix = /* @__PURE__ */ function(e) {
	return e.V1 = "/_matrix/client/v1", e.V3 = "/_matrix/client/v3", e.Unstable = "/_matrix/client/unstable", e;
}({}), IdentityPrefix = /* @__PURE__ */ function(e) {
	return e.V2 = "/_matrix/identity/v2", e;
}({}), MediaPrefix = /* @__PURE__ */ function(e) {
	return e.V1 = "/_matrix/media/v1", e.V3 = "/_matrix/media/v3", e;
}({}), TIMER_CHECK_PERIOD_MS = 1e3, count = 0, realCallbackKey, callbackList = [];
function setTimeout$1(e, b) {
	var x = [...arguments].slice(2);
	b ||= 0, b < 0 && (b = 0);
	var S = Date.now() + b, C = count++, w = {
		runAt: S,
		func: e,
		params: x,
		key: C
	}, T = binarySearch(callbackList, function(e) {
		return e.runAt - S;
	});
	return callbackList.splice(T, 0, w), scheduleRealCallback(), C;
}
function clearTimeout$1(e) {
	if (callbackList.length !== 0) {
		var b;
		for (b = 0; b < callbackList.length; b++) if (callbackList[b].key == e) {
			callbackList.splice(b, 1);
			break;
		}
		b === 0 && scheduleRealCallback();
	}
}
function scheduleRealCallback() {
	realCallbackKey && globalThis.clearTimeout(realCallbackKey);
	var e = callbackList[0];
	if (e) {
		var b = Date.now(), x = Math.min(e.runAt - b, TIMER_CHECK_PERIOD_MS);
		realCallbackKey = globalThis.setTimeout(runCallbacks, x);
	}
}
function runCallbacks() {
	for (var e = Date.now(), b = [];;) {
		var x = callbackList[0];
		if (!x || x.runAt > e) break;
		var S = callbackList.shift();
		S.key, b.push(S);
	}
	scheduleRealCallback();
	for (var C of b) try {
		C.func.apply(globalThis, C.params);
	} catch (e) {
		logger.error("Uncaught exception in callback function", e);
	}
}
function binarySearch(e, b) {
	for (var x = 0, S = e.length; x < S;) {
		var C = x + S >> 1;
		b(e[C]) > 0 ? S = C : x = C + 1;
	}
	return x;
}
var MatrixHttpApi = class extends FetchHttpApi {
	constructor() {
		super(...arguments), _defineProperty(this, "uploads", []);
	}
	uploadContent(e) {
		var b = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, x = b.includeFilename ?? !0, S = b.abortController ?? new AbortController(), C = (b.type ?? e.type) || "application/octet-stream", w = b.name ?? e.name, T = {
			loaded: 0,
			total: 0,
			abortController: S
		}, E = Promise.withResolvers();
		if (globalThis.XMLHttpRequest) {
			var D = new globalThis.XMLHttpRequest(), O = function() {
				D.abort(), E.reject(/* @__PURE__ */ Error("Timeout"));
			}, k = setTimeout$1(O, 3e4);
			D.onreadystatechange = function() {
				switch (D.readyState) {
					case globalThis.XMLHttpRequest.DONE:
						clearTimeout$1(k);
						try {
							if (D.status === 0) throw new DOMException(D.statusText, "AbortError");
							if (!D.responseText) throw Error("No response body.");
							D.status >= 400 ? E.reject(parseErrorResponse(D, D.responseText)) : E.resolve(JSON.parse(D.responseText));
						} catch (e) {
							if (e.name === "AbortError") {
								E.reject(e);
								return;
							}
							E.reject(new ConnectionError("request failed", e));
						}
						break;
				}
			}, D.upload.onprogress = (e) => {
				var x;
				clearTimeout$1(k), T.loaded = e.loaded, T.total = e.total, k = setTimeout$1(O, 3e4), (x = b.progressHandler) == null || x.call(b, {
					loaded: e.loaded,
					total: e.total
				});
			};
			var A = this.getUrl("/upload", void 0, MediaPrefix.V3);
			x && w && A.searchParams.set("filename", encodeURIComponent(w)), !this.opts.useAuthorizationHeader && this.opts.accessToken && A.searchParams.set("access_token", encodeURIComponent(this.opts.accessToken)), D.open(Method.Post, A.href), this.opts.useAuthorizationHeader && this.opts.accessToken && D.setRequestHeader("Authorization", "Bearer " + this.opts.accessToken), D.setRequestHeader("Content-Type", C), D.send(e), S.signal.addEventListener("abort", () => {
				D.abort();
			});
		} else {
			var j = {};
			x && w && (j.filename = w);
			var M = { "Content-Type": C };
			this.authedRequest(Method.Post, "/upload", j, e, {
				prefix: MediaPrefix.V3,
				headers: M,
				abortSignal: S.signal
			}).then(E.resolve, E.reject);
		}
		return T.promise = E.promise.finally(() => {
			removeElement(this.uploads, (e) => e === T);
		}), S.signal.addEventListener("abort", () => {
			removeElement(this.uploads, (e) => e === T), E.reject(new DOMException("Aborted", "AbortError"));
		}), this.uploads.push(T), T.promise;
	}
	cancelUpload(e) {
		var b = this.uploads.find((b) => b.promise === e);
		return b ? (b.abortController.abort(), !0) : !1;
	}
	getCurrentUploads() {
		return this.uploads;
	}
	getContentUri() {
		return {
			base: this.opts.baseUrl,
			path: MediaPrefix.V3 + "/upload",
			params: { access_token: this.opts.accessToken }
		};
	}
}, CAPABILITIES_CACHE_MS = 360 * 60 * 1e3, CAPABILITIES_RETRY_MS = 30 * 1e3, RoomVersionStability = /* @__PURE__ */ function(e) {
	return e.Stable = "stable", e.Unstable = "unstable", e;
}({}), ServerCapabilities = class {
	constructor(e, b) {
		var x = this;
		this.logger = e, this.http = b, _defineProperty(this, "capabilities", void 0), _defineProperty(this, "retryTimeout", void 0), _defineProperty(this, "refreshTimeout", void 0), _defineProperty(this, "fetchCapabilities", /* @__PURE__ */ _asyncToGenerator(function* () {
			return x.capabilities = (yield x.http.authedRequest(Method.Get, "/capabilities")).capabilities, x.capabilities;
		})), _defineProperty(this, "poll", /* @__PURE__ */ _asyncToGenerator(function* () {
			try {
				yield x.fetchCapabilities(), x.clearTimeouts(), x.refreshTimeout = setTimeout(x.poll, CAPABILITIES_CACHE_MS), x.logger.debug("Fetched new server capabilities");
			} catch (b) {
				x.clearTimeouts();
				var e = Math.floor(CAPABILITIES_RETRY_MS + Math.random() * 5e3);
				x.retryTimeout = setTimeout(x.poll, e), x.logger.warn(`Failed to refresh capabilities: retrying in ${e}ms`, b);
			}
		}));
	}
	start() {
		this.poll().then();
	}
	stop() {
		this.clearTimeouts();
	}
	getCachedCapabilities() {
		return this.capabilities;
	}
	clearTimeouts() {
		this.refreshTimeout &&= (clearInterval(this.refreshTimeout), void 0), this.retryTimeout &&= (clearTimeout(this.retryTimeout), void 0);
	}
}, logger$2 = logger.getChild("RoomStickyEvents"), RoomStickyEventsEvent = /* @__PURE__ */ function(e) {
	return e.Update = "RoomStickyEvents.Update", e;
}({});
function assertIsUserId(e) {
	if (typeof e != "string") throw Error("Not a string");
	if (!e.startsWith("@")) throw Error("Not a userId");
}
var RoomStickyEventsStore = class e extends TypedEventEmitter {
	constructor() {
		super(...arguments), _defineProperty(this, "stickyEventsMap", /* @__PURE__ */ new Map()), _defineProperty(this, "unkeyedStickyEvents", /* @__PURE__ */ new Set()), _defineProperty(this, "stickyEventTimer", void 0), _defineProperty(this, "nextStickyEventExpiryTs", 2 ** 53 - 1), _defineProperty(this, "cleanExpiredStickyEvents", () => {
			var e = Date.now(), b = [];
			this.nextStickyEventExpiryTs = 2 ** 53 - 1;
			for (var [x, S] of this.stickyEventsMap.entries()) {
				for (var [C, [w, ...T]] of S) e >= w.unstableStickyExpiresAt ? (logger$2.debug("Expiring sticky event", w.getId()), b.push(w), this.stickyEventsMap.get(x).delete(C)) : (this.stickyEventsMap.get(x).set(C, [w, ...T.filter((b) => b.unstableStickyExpiresAt <= e)]), this.nextStickyEventExpiryTs = Math.min(this.nextStickyEventExpiryTs, w.unstableStickyExpiresAt));
				this.stickyEventsMap.get(x)?.size === 0 && this.stickyEventsMap.delete(x);
			}
			for (var E of this.unkeyedStickyEvents) e >= E.unstableStickyExpiresAt ? (logger$2.debug("Expiring sticky event", E.getId()), this.unkeyedStickyEvents.delete(E), b.push(E)) : this.nextStickyEventExpiryTs = Math.min(this.nextStickyEventExpiryTs, E.unstableStickyExpiresAt);
			b.length && this.emit(RoomStickyEventsEvent.Update, [], [], b), this.scheduleStickyTimer();
		});
	}
	static sortStickyEvent(e, b) {
		if (b.getTs() !== e.getTs()) return b.getTs() - e.getTs();
		if ((b.getId() ?? "") > (e.getId() ?? "")) return 1;
		throw Error("Comparing two sticky events with the same event ID is not allowed.");
	}
	static stickyMapKey(e, b) {
		return `${e}${b}`;
	}
	*getStickyEvents() {
		yield* this.unkeyedStickyEvents;
		for (var e of this.stickyEventsMap.values()) for (var b of e.values()) yield b[0];
	}
	getKeyedStickyEvent(b, x, S) {
		var C;
		return assertIsUserId(b), (C = this.stickyEventsMap.get(x)) == null || (C = C.get(e.stickyMapKey(S, b))) == null ? void 0 : C[0];
	}
	getUnkeyedStickyEvent(e, b) {
		return [...this.unkeyedStickyEvents].filter((x) => x.getType() === b && x.getSender() === e);
	}
	addStickyEvent(b) {
		var x, S = b.getContent().msc4354_sticky_key;
		if (typeof S != "string" && S !== void 0) throw Error(`${b.getId()} is missing msc4354_sticky_key`);
		if (b.unstableStickyExpiresAt === void 0) throw Error(`${b.getId()} is missing msc4354_sticky.duration_ms`);
		var C = b.getSender(), w = b.getType();
		if (assertIsUserId(C), b.unstableStickyExpiresAt <= Date.now()) return logger$2.info("ignored sticky event with older expiration time than current time", S), { added: !1 };
		if (!C.startsWith("@")) throw Error("Expected sender to start with @");
		var T = b;
		if (S === void 0) return this.unkeyedStickyEvents.add(T), this.nextStickyEventExpiryTs = Math.min(b.unstableStickyExpiresAt, this.nextStickyEventExpiryTs), this.scheduleStickyTimer(), { added: !0 };
		var E = e.stickyMapKey(S, C), D = [T, ...this.stickyEventsMap.get(w)?.get(E) ?? []].sort(e.sortStickyEvent);
		return this.stickyEventsMap.has(w) || this.stickyEventsMap.set(w, /* @__PURE__ */ new Map()), (x = this.stickyEventsMap.get(w)) == null || x.set(E, D), this.nextStickyEventExpiryTs = Math.min(T.unstableStickyExpiresAt, this.nextStickyEventExpiryTs), this.scheduleStickyTimer(), {
			added: D[0] === T,
			prevEvent: D?.[1]
		};
	}
	addStickyEvents(e) {
		var b = [], x = [];
		for (var S of e) try {
			var C = this.addStickyEvent(S);
			C.added && (C.prevEvent ? x.push({
				current: S,
				previous: C.prevEvent
			}) : b.push(S));
		} catch (e) {
			logger$2.warn("ignored invalid sticky event", e);
		}
		(b.length || x.length) && this.emit(RoomStickyEventsEvent.Update, b, x, []), this.scheduleStickyTimer();
	}
	scheduleStickyTimer() {
		this.stickyEventTimer &&= (clearTimeout(this.stickyEventTimer), void 0), this.nextStickyEventExpiryTs !== 2 ** 53 - 1 && (this.stickyEventTimer = setTimeout(this.cleanExpiredStickyEvents, this.nextStickyEventExpiryTs - Date.now()));
	}
	handleRedaction(b) {
		var x = typeof b == "string" ? b : b.getId();
		for (var S of this.unkeyedStickyEvents) if (S.getId() === x) {
			this.unkeyedStickyEvents.delete(S), this.emit(RoomStickyEventsEvent.Update, [], [], [S]);
			return;
		}
		if (typeof b != "string" && !b.isRedacted()) {
			var C, w = b.getContent().msc4354_sticky_key;
			if (typeof w != "string" && w !== void 0) return;
			var T = b.getType(), E = b.getSender();
			assertIsUserId(E);
			var D = this.stickyEventsMap.get(T);
			if (!D) return;
			var O = e.stickyMapKey(w, E), [k, ...A] = D.get(O) ?? [];
			if (!k) return;
			logger$2.debug(`Redaction for ${x} under sticky key ${w}`);
			var j = A.filter((e) => !e.isRedacted()).sort(e.sortStickyEvent);
			(C = this.stickyEventsMap.get(T)) == null || C.set(O, j), j.length ? this.emit(RoomStickyEventsEvent.Update, [], [{
				previous: k,
				current: j[0]
			}], []) : (D.delete(O), D.size === 0 && this.stickyEventsMap.delete(T), this.emit(RoomStickyEventsEvent.Update, [], [], [k]));
			return;
		}
		for (var M of this.stickyEventsMap.values()) for (var [N] of M.values()) if (N.getId() === x) return this.handleRedaction(N);
	}
	clear() {
		this.stickyEventsMap.clear(), this.nextStickyEventExpiryTs = 2 ** 53 - 1, this.scheduleStickyTimer();
	}
}, import_lib$4 = /* @__PURE__ */ __toESM(require_lib$1());
function ownKeys$14(e, b) {
	var x = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var S = Object.getOwnPropertySymbols(e);
		b && (S = S.filter(function(b) {
			return Object.getOwnPropertyDescriptor(e, b).enumerable;
		})), x.push.apply(x, S);
	}
	return x;
}
function _objectSpread$14(e) {
	for (var b = 1; b < arguments.length; b++) {
		var x = arguments[b] == null ? {} : arguments[b];
		b % 2 ? ownKeys$14(Object(x), !0).forEach(function(b) {
			_defineProperty(e, b, x[b]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(x)) : ownKeys$14(Object(x)).forEach(function(b) {
			Object.defineProperty(e, b, Object.getOwnPropertyDescriptor(x, b));
		});
	}
	return e;
}
var KNOWN_SAFE_ROOM_VERSION = "10", SAFE_ROOM_VERSIONS = [
	"1",
	"2",
	"3",
	"4",
	"5",
	"6",
	"7",
	"8",
	"9",
	"10"
], MAX_NUMBER_OF_VISIBILITY_EVENTS_TO_SCAN_THROUGH = 30, NotificationCountType = /* @__PURE__ */ function(e) {
	return e.Highlight = "highlight", e.Total = "total", e;
}({}), RoomEvent = /* @__PURE__ */ function(e) {
	return e.MyMembership = "Room.myMembership", e.Tags = "Room.tags", e.AccountData = "Room.accountData", e.Receipt = "Room.receipt", e.Name = "Room.name", e.Redaction = "Room.redaction", e.RedactionCancelled = "Room.redactionCancelled", e.LocalEchoUpdated = "Room.localEchoUpdated", e.Timeline = "Room.timeline", e.TimelineReset = "Room.timelineReset", e.TimelineRefresh = "Room.TimelineRefresh", e.OldStateUpdated = "Room.OldStateUpdated", e.CurrentStateUpdated = "Room.CurrentStateUpdated", e.HistoryImportedWithinTimeline = "Room.historyImportedWithinTimeline", e.UnreadNotifications = "Room.UnreadNotifications", e.Summary = "Room.Summary", e;
}({}), Room = class extends ReadReceipt {
	constructor(e, b, x) {
		var S, C = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
		super(), S = this, this.roomId = e, this.client = b, this.myUserId = x, this.opts = C, _defineProperty(this, "reEmitter", void 0), _defineProperty(this, "txnToEvent", /* @__PURE__ */ new Map()), _defineProperty(this, "notificationCounts", {}), _defineProperty(this, "bumpStamp", void 0), _defineProperty(this, "threadNotifications", /* @__PURE__ */ new Map()), _defineProperty(this, "cachedThreadReadReceipts", /* @__PURE__ */ new Map()), _defineProperty(this, "oldestThreadedReceiptTs", Infinity), _defineProperty(this, "unthreadedReceipts", /* @__PURE__ */ new Map()), _defineProperty(this, "timelineSets", void 0), _defineProperty(this, "polls", /* @__PURE__ */ new Map()), _defineProperty(this, "threadsTimelineSets", []), _defineProperty(this, "filteredTimelineSets", {}), _defineProperty(this, "timelineNeedsRefresh", !1), _defineProperty(this, "pendingEventList", void 0), _defineProperty(this, "blacklistUnverifiedDevices", void 0), _defineProperty(this, "selfMembership", void 0), _defineProperty(this, "heroes", null), _defineProperty(this, "getTypeWarning", !1), _defineProperty(this, "membersPromise", void 0), _defineProperty(this, "name", void 0), _defineProperty(this, "normalizedName", void 0), _defineProperty(this, "tags", {}), _defineProperty(this, "accountData", /* @__PURE__ */ new Map()), _defineProperty(this, "summary", null), _defineProperty(this, "oldState", void 0), _defineProperty(this, "currentState", void 0), _defineProperty(this, "relations", void 0), _defineProperty(this, "threads", /* @__PURE__ */ new Map()), _defineProperty(this, "visibilityEvents", /* @__PURE__ */ new Map()), _defineProperty(this, "roomReceipts", new RoomReceipts(this)), _defineProperty(this, "stickyEvents", new RoomStickyEventsStore()), _defineProperty(this, "threadTimelineSetsPromise", null), _defineProperty(this, "threadsReady", !1), _defineProperty(this, "updateThreadRootEvents", (e, b, x) => {
			e.length && (this.updateThreadRootEvent(this.threadsTimelineSets?.[0], e, b, x), e.hasCurrentUserParticipated && this.updateThreadRootEvent(this.threadsTimelineSets?.[1], e, b, x));
		}), _defineProperty(this, "updateThreadRootEvent", (e, b, x, S) => {
			e && b.rootEvent && (S && e.removeEvent(b.id), Thread.hasServerSideSupport ? e.addLiveEvent(b.rootEvent, {
				duplicateStrategy: DuplicateStrategy.Replace,
				fromCache: !1,
				roomState: this.currentState,
				addToState: !1
			}) : e.addEventToTimeline(b.rootEvent, e.getLiveTimeline(), {
				toStartOfTimeline: x,
				addToState: !1
			}));
		}), _defineProperty(this, "tryApplyRedaction", (e) => {
			if (e.isRedaction()) {
				var b = e.event.redacts, x = b ? this.findEventById(b) : void 0;
				if (b) try {
					this.stickyEvents.handleRedaction(x || b);
				} catch (e) {
					logger.error("Failed to handle redaction for sticky event", e);
				}
				x && this.applyEventAsRedaction(e, x);
			} else if (e.getType() === EventType.RoomMember) {
				var S = e.getContent().membership;
				if (S !== KnownMembership.Ban && !(S === KnownMembership.Leave && e.getStateKey() !== e.getSender()) || e.getContent()["org.matrix.msc4293.redact_events"] !== !0 || !this.getLiveTimeline().getState(Direction.Forward).maySendRedactionForEvent(e, e.getSender())) return;
				for (var C of this.getTimelineSets().map((e) => e.getTimelines()).reduce((e, b) => (e.push(...b), e), []).map((b) => b.getEvents().filter((b) => b.getSender() === e.getStateKey())).reduce((e, b) => (e.push(...b), b), [])) this.applyEventAsRedaction(e, C);
			}
		}), this.setMaxListeners(100), this.reEmitter = new TypedReEmitter(this), C.pendingEventOrdering = C.pendingEventOrdering || PendingEventOrdering.Chronological, this.name = e, this.normalizedName = e, this.relations = new RelationsContainer(this.client, this), this.on(RoomEvent.Receipt, this.onReceipt), this.reEmitter.reEmit(this.stickyEvents, [RoomStickyEventsEvent.Update]), this.timelineSets = [new EventTimelineSet(this, C)], this.reEmitter.reEmit(this.getUnfilteredTimelineSet(), [RoomEvent.Timeline, RoomEvent.TimelineReset]), this.fixUpLegacyTimelineFields(), this.opts.pendingEventOrdering === PendingEventOrdering.Detached && (this.pendingEventList = [], this.client.store.getPendingEvents(this.roomId).then((e) => {
			var x = this.client.getEventMapper({ decrypt: !1 });
			e.forEach(/* @__PURE__ */ function() {
				var e = _asyncToGenerator(function* (e) {
					var C = x(e);
					yield b.decryptEventIfNeeded(C), C.setStatus(EventStatus.NOT_SENT), S.addPendingEvent(C, C.getTxnId());
				});
				return function(b) {
					return e.apply(this, arguments);
				};
			}());
		})), this.opts.lazyLoadMembers ? this.membersPromise = void 0 : this.membersPromise = Promise.resolve(!1);
	}
	createThreadsTimelineSets() {
		var e = this;
		return _asyncToGenerator(function* () {
			var b;
			if (e.threadTimelineSetsPromise) return e.threadTimelineSetsPromise;
			if ((b = e.client) != null && b.supportsThreads()) try {
				e.threadTimelineSetsPromise = Promise.all([e.createThreadTimelineSet(), e.createThreadTimelineSet(ThreadFilterType.My)]);
				var x = yield e.threadTimelineSetsPromise;
				return e.threadsTimelineSets[0] = x[0], e.threadsTimelineSets[1] = x[1], x;
			} catch {
				return e.threadTimelineSetsPromise = null, null;
			}
			return null;
		})();
	}
	decryptCriticalEvents() {
		var e = this;
		return _asyncToGenerator(function* () {
			if (e.client.getCrypto()) {
				var b = e.getEventReadUpTo(e.client.getUserId(), !0), x = e.getLiveTimeline().getEvents(), S = x.findIndex((e) => e.event.event_id === b), C = x.slice(S).reverse().map((b) => e.client.decryptEventIfNeeded(b));
				yield Promise.allSettled(C);
			}
		})();
	}
	decryptAllEvents() {
		var e = this;
		return _asyncToGenerator(function* () {
			if (e.client.getCrypto()) {
				var b = e.getUnfilteredTimelineSet().getLiveTimeline().getEvents().slice(0).reverse().map((b) => e.client.decryptEventIfNeeded(b));
				yield Promise.allSettled(b);
			}
		})();
	}
	getCreator() {
		return this.currentState.getStateEvents(EventType.RoomCreate, "")?.getSender() ?? null;
	}
	getVersion() {
		return this.currentState.getRoomVersion();
	}
	getRecommendedVersion() {
		var e = this;
		return _asyncToGenerator(function* () {
			var b = {};
			try {
				b = yield e.client.getCapabilities();
			} catch {}
			var x = b["m.room_versions"];
			if (!x) {
				x = {
					default: "10",
					available: {}
				};
				for (var S of SAFE_ROOM_VERSIONS) x.available[S] = RoomVersionStability.Stable;
			}
			var C = e.checkVersionAgainstCapability(x);
			if (C.urgent && C.needsUpgrade) {
				logger.warn("Refreshing room version capability because the server looks to be supporting a newer room version we don't know about.");
				try {
					b = yield e.client.fetchCapabilities();
				} catch (e) {
					logger.warn("Failed to refresh room version capabilities", e);
				}
				if (x = b["m.room_versions"], x) C = e.checkVersionAgainstCapability(x);
				else return logger.warn("No room version capability - assuming upgrade required."), C;
			}
			return C;
		})();
	}
	checkVersionAgainstCapability(e) {
		var b = this.getVersion();
		logger.log(`[${this.roomId}] Current version: ${b}`), logger.log(`[${this.roomId}] Version capability: `, e);
		var x = {
			version: b,
			needsUpgrade: !1,
			urgent: !1
		};
		return b === e.default || Object.keys(e.available).filter((b) => e.available[b] === "stable").includes(b) ? x : (x.version = e.default, x.needsUpgrade = !0, x.urgent = !!this.getVersion().match(/^[0-9]+[0-9.]*$/g), x.urgent ? logger.warn(`URGENT upgrade required on ${this.roomId}`) : logger.warn(`Non-urgent upgrade required on ${this.roomId}`), x);
	}
	userMayUpgradeRoom(e) {
		return this.currentState.maySendStateEvent(EventType.RoomTombstone, e);
	}
	getPendingEvents() {
		if (!this.pendingEventList) throw Error("Cannot call getPendingEvents with pendingEventOrdering == " + this.opts.pendingEventOrdering);
		return this.pendingEventList;
	}
	removePendingEvent(e) {
		if (!this.pendingEventList) throw Error("Cannot call removePendingEvent with pendingEventOrdering == " + this.opts.pendingEventOrdering);
		var b = removeElement(this.pendingEventList, function(b) {
			return b.getId() == e;
		}, !1);
		return this.savePendingEvents(), b;
	}
	hasPendingEvent(e) {
		return this.pendingEventList?.some((b) => b.getId() === e) ?? !1;
	}
	getPendingEvent(e) {
		return this.pendingEventList?.find((b) => b.getId() === e) ?? null;
	}
	getLiveTimeline() {
		return this.getUnfilteredTimelineSet().getLiveTimeline();
	}
	get timeline() {
		return this.getLiveTimeline().getEvents();
	}
	getLastActiveTimestamp() {
		var e = this.getLiveTimeline().getEvents();
		return e.length ? e[e.length - 1].getTs() : -(2 ** 53 - 1);
	}
	getLastLiveEvent() {
		var e = this.getLiveTimeline().getEvents(), b = e[e.length - 1], x = this.getLastThread();
		if (!x) return b;
		var S = x.events[x.events.length - 1];
		return (b?.getTs() ?? 0) > (S?.getTs() ?? 0) ? b : S;
	}
	getLastThread() {
		return this.getThreads().reduce((e, b) => {
			if (!e) return b;
			var x = b.events[b.events.length - 1], S = e.events[e.events.length - 1];
			return (x?.getTs() ?? 0) >= (S?.getTs() ?? 0) ? b : e;
		}, void 0);
	}
	getMyMembership() {
		return this.selfMembership ?? KnownMembership.Leave;
	}
	getDMInviter() {
		var e = this.getMember(this.myUserId);
		if (e) return e.getDMInviter();
		if (this.selfMembership === KnownMembership.Invite && this.getInvitedAndJoinedMemberCount() === 2) {
			var b;
			return (b = this.heroes) == null || (b = b[0]) == null ? void 0 : b.userId;
		}
	}
	guessDMUserId() {
		var e = this.getMember(this.myUserId);
		if (e) {
			var b = e.getDMInviter();
			if (b) return b;
		}
		if (Array.isArray(this.heroes) && this.heroes.length) return this.heroes[0].userId;
		var x = this.currentState.getMembers().find((e) => e.userId !== this.myUserId);
		return x ? x.userId : this.myUserId;
	}
	getFunctionalMembers() {
		var e = this.currentState.getStateEvents(UNSTABLE_ELEMENT_FUNCTIONAL_USERS.name, "");
		return Array.isArray(e?.getContent().service_members) ? e.getContent().service_members : [];
	}
	getAvatarFallbackMember() {
		var e = this.getFunctionalMembers(), b = 0;
		if (this.getMembers().forEach((x) => {
			x.membership !== "join" && x.membership !== "invite" || e.includes(x.userId) || b++;
		}), !(b > 2)) {
			var x = this.heroes?.filter((b) => !e.includes(b.userId)), S = Array.isArray(x) && x.length;
			if (S) {
				for (var C of x) if (C.fromMSC4186) {
					var w = new RoomMember(this.roomId, C.userId);
					return w.setMembershipEvent(new MatrixEvent({
						event_id: "$" + this.roomId + C.userId + (/* @__PURE__ */ new Date()).getTime(),
						type: EventType.RoomMember,
						state_key: C.userId,
						content: {
							displayname: C.displayName,
							avatar_url: C.avatarUrl
						}
					})), w;
				} else {
					var T = this.getMember(C.userId);
					if (T) return T;
				}
				var E = x.map((e) => this.getMember(e.userId)).find((e) => !!e);
				if (E) return E;
			}
			var D = this.getMembers()?.filter((b) => !e.includes(b.userId));
			if (D.length <= 2) {
				var O = D.find((e) => e.userId !== this.myUserId);
				if (O) return O;
			}
			if (S) {
				var k = x.map((e) => this.client.getUser(e.userId)).find((e) => !!e);
				if (k) {
					var A = new RoomMember(this.roomId, k.userId);
					return A.user = k, A;
				}
			}
		}
	}
	updateMyMembership(e) {
		var b = this.selfMembership;
		this.selfMembership = e, b !== e && (e === KnownMembership.Leave && this.cleanupAfterLeaving(), this.emit(RoomEvent.MyMembership, this, e, b));
	}
	loadMembersFromServer() {
		var e = this;
		return _asyncToGenerator(function* () {
			var b = e.client.store.getSyncToken();
			return (yield e.client.members(e.roomId, void 0, KnownMembership.Leave, b ?? void 0)).chunk;
		})();
	}
	loadMembers() {
		var e = this;
		return _asyncToGenerator(function* () {
			var b = !1, x = yield e.client.store.getOutOfBandMembers(e.roomId);
			return (x === null || e.hasEncryptionStateEvent()) && (b = !0, x = yield e.loadMembersFromServer(), logger.log(`LL: got ${x.length} members from server for room ${e.roomId}`)), {
				memberEvents: x.filter(noUnsafeEventProps).map(e.client.getEventMapper()),
				fromServer: b
			};
		})();
	}
	membersLoaded() {
		return this.opts.lazyLoadMembers ? this.currentState.outOfBandMembersReady() : !0;
	}
	loadMembersIfNeeded() {
		if (this.membersPromise) return this.membersPromise;
		this.currentState.markOutOfBandMembersStarted();
		var e = this.loadMembers().then((e) => (this.currentState.setOutOfBandMembers(e.memberEvents), e.fromServer)).catch((e) => {
			throw this.membersPromise = void 0, this.currentState.markOutOfBandMembersFailed(), e;
		});
		return e.then((e) => {
			if (e) {
				var b = this.currentState.getMembers().filter((e) => e.isOutOfBand()).map((e) => e.events.member?.event);
				return logger.log(`LL: telling store to write ${b.length} members for room ${this.roomId}`), this.client.store.setOutOfBandMembers(this.roomId, b).catch((e) => {
					logger.log("LL: storing OOB room members failed, oh well", e);
				});
			}
		}).catch((e) => {
			logger.error(e);
		}), this.membersPromise = e, this.membersPromise;
	}
	clearLoadedMembersIfNeeded() {
		var e = this;
		return _asyncToGenerator(function* () {
			e.opts.lazyLoadMembers && e.membersPromise && (yield e.loadMembersIfNeeded(), yield e.client.store.clearOutOfBandMembers(e.roomId), e.currentState.clearOutOfBandMembers(), e.membersPromise = void 0);
		})();
	}
	cleanupAfterLeaving() {
		this.clearLoadedMembersIfNeeded().catch((e) => {
			logger.error(`error after clearing loaded members from room ${this.roomId} after leaving`), logger.log(e);
		});
	}
	refreshLiveTimeline() {
		var e = this;
		return _asyncToGenerator(function* () {
			var b = e.getLiveTimeline(), x = b.getPaginationToken(EventTimeline.FORWARDS), S = b.getPaginationToken(EventTimeline.BACKWARDS), C = b.getEvents(), w = C[C.length - 1];
			logger.log(`[refreshLiveTimeline for ${e.roomId}] at mostRecentEventInTimeline=${w && w.getId()} liveTimelineBefore=${b.toString()} forwardPaginationToken=${x} backwardPaginationToken=${S}`);
			var T = e.getUnfilteredTimelineSet(), E = null;
			w ? (e.resetLiveTimeline(null, null), e.emit(RoomEvent.TimelineRefresh, e, T), E = yield e.client.getEventTimeline(T, w.getId())) : E = yield e.client.getLatestTimeline(T);
			var D = T.getLiveTimeline();
			!D || D.getPaginationToken(Direction.Forward) === null && D.getPaginationToken(Direction.Backward) === null && D.getEvents().length === 0 ? (logger.log(`[refreshLiveTimeline for ${e.roomId}] using our new live timeline`), E.setPaginationToken(x, EventTimeline.FORWARDS), T.setLiveTimeline(E), e.fixUpLegacyTimelineFields()) : logger.log(`[refreshLiveTimeline for ${e.roomId}] \`/sync\` or some other request beat us to creating a new live timeline after we reset it. We'll use that instead since any events in the scrollback from this timeline will include the history.`), e.setTimelineNeedsRefresh(!1), e.emit(RoomEvent.TimelineRefresh, e, T);
		})();
	}
	resetLiveTimeline(e, b) {
		for (var x of this.timelineSets) x.resetLiveTimeline(e ?? void 0, b ?? void 0);
		for (var S of this.threads.values()) S.resetLiveTimeline(e, b);
		this.fixUpLegacyTimelineFields();
	}
	fixUpLegacyTimelineFields() {
		var e = this.oldState, b = this.currentState;
		this.oldState = this.getLiveTimeline().getState(EventTimeline.BACKWARDS), this.currentState = this.getLiveTimeline().getState(EventTimeline.FORWARDS), e !== this.oldState && this.emit(RoomEvent.OldStateUpdated, this, e, this.oldState), b !== this.currentState && (this.emit(RoomEvent.CurrentStateUpdated, this, b, this.currentState), this.reEmitter.stopReEmitting(b, [
			RoomStateEvent.Events,
			RoomStateEvent.Members,
			RoomStateEvent.NewMember,
			RoomStateEvent.Update,
			RoomStateEvent.Marker,
			BeaconEvent.New,
			BeaconEvent.Update,
			BeaconEvent.Destroy,
			BeaconEvent.LivenessChange
		]), this.reEmitter.reEmit(this.currentState, [
			RoomStateEvent.Events,
			RoomStateEvent.Members,
			RoomStateEvent.NewMember,
			RoomStateEvent.Update,
			RoomStateEvent.Marker,
			BeaconEvent.New,
			BeaconEvent.Update,
			BeaconEvent.Destroy,
			BeaconEvent.LivenessChange
		]));
	}
	onReceipt(e) {
		this.hasEncryptionStateEvent() && this.clearNotificationsOnReceipt(e);
	}
	clearNotificationsOnReceipt(e) {
		var b = [], x = !1, S = e.getContent();
		for (var C of Object.values(S)) for (var [w, T] of Object.entries(C)) if (isSupportedReceiptType(w) && T) {
			for (var [E, D] of Object.entries(T)) if (!(!D || typeof D != "object")) {
				var O = D;
				E === this.client.getUserId() && (O.thread_id === void 0 ? x = !0 : typeof O.thread_id == "string" && b.push(O.thread_id));
			}
		}
		x && (b = this.getThreads().filter((e) => this.getThreadUnreadNotificationCount(e.id, NotificationCountType.Total) > 0 || this.getThreadUnreadNotificationCount(e.id, NotificationCountType.Highlight) > 0).map((e) => e.id), b.push("main"));
		for (var k of b) {
			var A = 20, j = k === "main" ? this.getLiveTimeline() : this.getThread(k)?.liveTimeline;
			if (!j) {
				logger.warn(`Couldn't find timeline for thread ID ${k} in room ${this.roomId}`);
				continue;
			}
			for (var M = j.getEvents(), N = 0, P = M.length - 1; P >= 0; P--) {
				var F;
				if (P === M.length - A) return;
				var I = M[P];
				if (this.hasUserReadEvent(this.client.getUserId(), I.getId())) break;
				var L = this.client.getPushActionsForEvent(I);
				N += L != null && (F = L.tweaks) != null && F.highlight ? 1 : 0;
			}
			k === "main" ? this.setUnreadNotificationCount(NotificationCountType.Highlight, N) : this.setThreadUnreadNotificationCount(k, NotificationCountType.Highlight, N);
		}
	}
	getTimelineSets() {
		return this.timelineSets;
	}
	getUnfilteredTimelineSet() {
		return this.timelineSets[0];
	}
	getTimelineForEvent(e) {
		var b = this.findEventById(e), x = this.findThreadForEvent(b);
		return x ? x.timelineSet.getTimelineForEvent(e) : this.getUnfilteredTimelineSet().getTimelineForEvent(e);
	}
	addTimeline() {
		return this.getUnfilteredTimelineSet().addTimeline();
	}
	setTimelineNeedsRefresh(e) {
		this.timelineNeedsRefresh = e;
	}
	getTimelineNeedsRefresh() {
		return this.timelineNeedsRefresh;
	}
	findEventById(e) {
		var b = this.getUnfilteredTimelineSet().findEventById(e);
		if (!b) {
			for (var x = this.getThreads(), S = 0; S < x.length; S++) if (b = x[S].findEventById(e), b) return b;
		}
		return b;
	}
	getUnreadNotificationCount() {
		var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : NotificationCountType.Total, b = this.getRoomUnreadNotificationCount(e);
		for (var x of this.threadNotifications.values()) b += x[e] ?? 0;
		return b;
	}
	getUnreadCountForEventContext() {
		var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : NotificationCountType.Total, b = arguments.length > 1 ? arguments[1] : void 0;
		return (b.threadRootId && !b.isThreadRoot ? this.getThreadUnreadNotificationCount(b.threadRootId, e) : this.getRoomUnreadNotificationCount(e)) ?? 0;
	}
	getRoomUnreadNotificationCount() {
		var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : NotificationCountType.Total;
		return this.notificationCounts[e] ?? 0;
	}
	getThreadUnreadNotificationCount(e) {
		var b = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : NotificationCountType.Total;
		return this.threadNotifications.get(e)?.[b] ?? 0;
	}
	hasThreadUnreadNotification() {
		for (var e of this.threadNotifications.values()) if ((e.highlight ?? 0) > 0 || (e.total ?? 0) > 0) return !0;
		return !1;
	}
	setThreadUnreadNotificationCount(e, b, x) {
		var S = _objectSpread$14({
			highlight: this.threadNotifications.get(e)?.highlight,
			total: this.threadNotifications.get(e)?.total
		}, { [b]: x });
		this.threadNotifications.set(e, S), this.emit(RoomEvent.UnreadNotifications, S, e);
	}
	get threadsAggregateNotificationType() {
		var e = null;
		for (var b of this.threadNotifications.values()) {
			if ((b.highlight ?? 0) > 0) return NotificationCountType.Highlight;
			(b.total ?? 0) > 0 && !e && (e = NotificationCountType.Total);
		}
		return e;
	}
	resetThreadUnreadNotificationCountFromSync() {
		var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], b = this.hasEncryptionStateEvent();
		for (var [x, S] of this.threadNotifications) e.includes(x) || (S.total = 0, b || (S.highlight = 0));
		this.emit(RoomEvent.UnreadNotifications);
	}
	setBumpStamp(e) {
		this.bumpStamp = e;
	}
	getBumpStamp() {
		return this.bumpStamp;
	}
	setUnreadNotificationCount(e, b) {
		this.notificationCounts[e] = b, this.emit(RoomEvent.UnreadNotifications, this.notificationCounts);
	}
	setUnread(e, b) {
		return this.setUnreadNotificationCount(e, b);
	}
	setSummary(e) {
		var b = e["m.heroes"]?.map((e) => ({
			userId: e,
			fromMSC4186: !1
		})), x = e["m.joined_member_count"], S = e["m.invited_member_count"];
		Number.isInteger(x) && this.currentState.setJoinedMemberCount(x), Number.isInteger(S) && this.currentState.setInvitedMemberCount(S), Array.isArray(b) && (this.heroes = b.filter((e) => e.userId != this.myUserId)), this.emit(RoomEvent.Summary, e);
	}
	setMSC4186SummaryData(e, b, x) {
		e && (this.heroes = e.filter((e) => e.user_id !== this.myUserId).map((e) => ({
			userId: e.user_id,
			displayName: e.displayname,
			avatarUrl: e.avatar_url,
			fromMSC4186: !0
		}))), b !== void 0 && Number.isInteger(b) && this.currentState.setJoinedMemberCount(b), x !== void 0 && Number.isInteger(x) && this.currentState.setInvitedMemberCount(x), this.emit(RoomEvent.Summary, {
			"m.heroes": this.heroes ? this.heroes.map((e) => e.userId) : [],
			"m.joined_member_count": b,
			"m.invited_member_count": x
		});
	}
	setBlacklistUnverifiedDevices(e) {
		this.blacklistUnverifiedDevices = e;
	}
	getBlacklistUnverifiedDevices() {
		return this.blacklistUnverifiedDevices === void 0 ? null : this.blacklistUnverifiedDevices;
	}
	getAvatarUrl(e, b, x, S) {
		var C = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0, w = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : !1, T = this.getMxcAvatarUrl();
		return !T && !C ? null : T ? getHttpUriForMxc(e, T, b, x, S, void 0, void 0, w) : null;
	}
	getMxcAvatarUrl() {
		var e = this.currentState.getStateEvents(EventType.RoomAvatar, "")?.getContent().url;
		return e && typeof e == "string" ? e : null;
	}
	getCanonicalAlias() {
		var e = this.currentState.getStateEvents(EventType.RoomCanonicalAlias, "")?.getContent().alias;
		return e && typeof e == "string" ? e : null;
	}
	getAltAliases() {
		var e = this.currentState.getStateEvents(EventType.RoomCanonicalAlias, "")?.getContent().alt_aliases;
		return Array.isArray(e) ? e.filter((e) => typeof e == "string") : [];
	}
	addEventsToTimeline(e, b, x, S, C) {
		S.getTimelineSet().addEventsToTimeline(e, b, x, S, C);
	}
	getThread(e) {
		return this.threads.get(e) ?? null;
	}
	getThreads() {
		return Array.from(this.threads.values());
	}
	getMember(e) {
		return this.currentState.getMember(e);
	}
	getMembers() {
		return this.currentState.getMembers();
	}
	getJoinedMembers() {
		return this.getMembersWithMembership(KnownMembership.Join);
	}
	getJoinedMemberCount() {
		return this.currentState.getJoinedMemberCount();
	}
	getInvitedMemberCount() {
		return this.currentState.getInvitedMemberCount();
	}
	getInvitedAndJoinedMemberCount() {
		return this.getInvitedMemberCount() + this.getJoinedMemberCount();
	}
	getMembersWithMembership(e) {
		return this.currentState.getMembers().filter(function(b) {
			return b.membership === e;
		});
	}
	getEncryptionTargetMembers() {
		var e = this;
		return _asyncToGenerator(function* () {
			yield e.loadMembersIfNeeded();
			var b = e.getMembersWithMembership(KnownMembership.Join);
			return e.shouldEncryptForInvitedMembers() && (b = b.concat(e.getMembersWithMembership(KnownMembership.Invite))), b;
		})();
	}
	shouldEncryptForInvitedMembers() {
		var e, b = this.currentState.getStateEvents(EventType.RoomHistoryVisibility, "");
		return (b == null || (e = b.getContent()) == null ? void 0 : e.history_visibility) !== "joined";
	}
	getDefaultRoomName(e) {
		return this.calculateRoomName(e, !0);
	}
	hasMembershipState(e, b) {
		var x = this.getMember(e);
		return x ? x.membership === b : !1;
	}
	getOrCreateFilteredTimelineSet(e) {
		var { prepopulateTimeline: b = !0, useSyncEvents: x = !0, pendingEvents: S = !0 } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
		if (this.filteredTimelineSets[e.filterId]) return this.filteredTimelineSets[e.filterId];
		var C = Object.assign({
			filter: e,
			pendingEvents: S
		}, this.opts), w = new EventTimelineSet(this, C);
		this.reEmitter.reEmit(w, [RoomEvent.Timeline, RoomEvent.TimelineReset]), x && (this.filteredTimelineSets[e.filterId] = w, this.timelineSets.push(w));
		var T = this.getLiveTimeline();
		if (b) {
			T.getEvents().forEach(function(e) {
				w.addLiveEvent(e, { addToState: !1 });
			});
			for (var E = T; E.getNeighbouringTimeline(EventTimeline.BACKWARDS);) E = E.getNeighbouringTimeline(EventTimeline.BACKWARDS);
			w.getLiveTimeline().setPaginationToken(E.getPaginationToken(EventTimeline.BACKWARDS), EventTimeline.BACKWARDS);
		} else if (x) {
			var D = T.getPaginationToken(Direction.Forward);
			w.getLiveTimeline().setPaginationToken(D, Direction.Backward);
		}
		return w;
	}
	getThreadListFilter() {
		var e = arguments, b = this;
		return _asyncToGenerator(function* () {
			var x = e.length > 0 && e[0] !== void 0 ? e[0] : ThreadFilterType.All, S = b.client.getUserId(), C = new Filter(S), w = { room: { timeline: { [FILTER_RELATED_BY_REL_TYPES.name]: [THREAD_RELATION_TYPE.name] } } };
			return x === ThreadFilterType.My && (w.room.timeline[FILTER_RELATED_BY_SENDERS.name] = [S]), C.setDefinition(w), C.filterId = yield b.client.getOrCreateFilter(`THREAD_PANEL_${b.roomId}_${x}`, C), C;
		})();
	}
	createThreadTimelineSet(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			var x;
			if (Thread.hasServerSideListSupport) x = new EventTimelineSet(b, _objectSpread$14(_objectSpread$14({}, b.opts), {}, { pendingEvents: !1 }), void 0, void 0, e ?? ThreadFilterType.All), b.reEmitter.reEmit(x, [RoomEvent.Timeline, RoomEvent.TimelineReset]);
			else if (Thread.hasServerSideSupport) {
				var S = yield b.getThreadListFilter(e);
				x = b.getOrCreateFilteredTimelineSet(S, {
					prepopulateTimeline: !1,
					useSyncEvents: !1,
					pendingEvents: !1
				});
			} else x = new EventTimelineSet(b, { pendingEvents: !1 }), Array.from(b.threads).forEach((S) => {
				var [, C] = S;
				if (C.length !== 0) {
					var w = C.timeline.some((e) => e.getSender() === b.client.getUserId());
					(e !== ThreadFilterType.My || w) && x.getLiveTimeline().addEvent(C.rootEvent, {
						toStartOfTimeline: !1,
						addToState: !1
					});
				}
			});
			return x;
		})();
	}
	processThreadRoots(e, b) {
		if (this.client.supportsThreads()) for (var x of e) EventTimeline.setEventMetadata(x, this.currentState, b), this.getThread(x.getId()) || this.createThread(x.getId(), x, [], b);
	}
	fetchRoomThreads() {
		var e = this;
		return _asyncToGenerator(function* () {
			if (!(e.threadsReady || !e.client.supportsThreads())) {
				if (Thread.hasServerSideListSupport) yield Promise.all([e.fetchRoomThreadList(ThreadFilterType.All), e.fetchRoomThreadList(ThreadFilterType.My)]);
				else {
					var b = yield e.getThreadListFilter(), { chunk: x } = yield e.client.createMessagesRequest(e.roomId, "", 2 ** 53 - 1, Direction.Backward, b);
					if (!x.length) return;
					var S = x.map(e.client.getEventMapper()).sort((e, b) => {
						var x = e.getServerAggregatedRelation(THREAD_RELATION_TYPE.name), S = b.getServerAggregatedRelation(THREAD_RELATION_TYPE.name);
						return x.latest_event.origin_server_ts - S.latest_event.origin_server_ts;
					}), C, w = e.getLiveTimeline().getState(EventTimeline.FORWARDS);
					for (var T of S) {
						var E, D = {
							duplicateStrategy: DuplicateStrategy.Ignore,
							fromCache: !1,
							addToState: !1,
							roomState: w
						};
						(E = e.threadsTimelineSets[0]) == null || E.addLiveEvent(T, D);
						var O = T.getServerAggregatedRelation(THREAD_RELATION_TYPE.name);
						if (O != null && O.current_user_participated) {
							var k;
							(k = e.threadsTimelineSets[1]) == null || k.addLiveEvent(T, D), C = T;
						}
					}
					e.processThreadRoots(S, !0), e.client.decryptEventIfNeeded(S[S.length - 1]), C && e.client.decryptEventIfNeeded(C);
				}
				e.on(ThreadEvent.NewReply, e.onThreadReply), e.on(ThreadEvent.Update, e.onThreadUpdate), e.on(ThreadEvent.Delete, e.onThreadDelete), e.threadsReady = !0;
			}
		})();
	}
	processPollEvents(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			for (var x of e) try {
				if (!x.isEncrypted() && !isPollEvent(x)) continue;
				yield b.client.decryptEventIfNeeded(x), b.processPollEvent(x);
			} catch (e) {
				logger.warn("Error processing poll event", x.getId(), e);
			}
		})();
	}
	processPollEvent(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			if (e.isDecryptionFailure()) {
				e.once(MatrixEventEvent.Decrypted, (e) => {
					b.processPollEvent(e);
				});
				return;
			}
			if (import_lib$4.M_POLL_START.matches(e.getType())) {
				try {
					var x = new Poll(e, b.client, b);
					b.polls.set(e.getId(), x), b.emit(PollEvent.New, x), e.once(MatrixEventEvent.BeforeRedaction, (e) => {
						b.polls.delete(e.getId());
					});
				} catch {}
				return;
			}
			var S = e.relationEventId;
			S && b.polls.has(S) && b.polls.get(S)?.onNewRelation(e);
		})();
	}
	fetchRoomThreadList(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			if (b.client.supportsThreads() && b.threadsTimelineSets.length !== 0) {
				var x = e === ThreadFilterType.My ? b.threadsTimelineSets[1] : b.threadsTimelineSets[0], { chunk: S, end: C } = yield b.client.createThreadListMessagesRequest(b.roomId, null, void 0, Direction.Backward, x.threadListType, x.getFilter());
				if (x.getLiveTimeline().setPaginationToken(C ?? null, Direction.Backward), S.length) {
					var w = S.map(b.client.getEventMapper());
					b.processThreadRoots(w, !0);
					var T = b.getLiveTimeline().getState(EventTimeline.FORWARDS);
					for (var E of w) x.addLiveEvent(E, {
						duplicateStrategy: DuplicateStrategy.Replace,
						fromCache: !1,
						roomState: T,
						addToState: !1
					});
				}
			}
		})();
	}
	onThreadUpdate(e) {
		this.updateThreadRootEvents(e, !1, !1);
	}
	onThreadReply(e) {
		this.updateThreadRootEvents(e, !1, !0);
	}
	onThreadDelete(e) {
		var b;
		this.threads.delete(e.id);
		var x = this.getTimelineForEvent(e.id), S = x == null || (b = x.getEvents()) == null ? void 0 : b.find((b) => b.getId() === e.id);
		S ? e.clearEventMetadata(S) : logger.debug("onThreadDelete: Could not find root event in room timeline");
		for (var C of this.threadsTimelineSets) C.removeEvent(e.id);
	}
	removeFilteredTimelineSet(e) {
		var b = this.filteredTimelineSets[e.filterId];
		delete this.filteredTimelineSets[e.filterId];
		var x = this.timelineSets.indexOf(b);
		x > -1 && this.timelineSets.splice(x, 1);
	}
	eventShouldLiveIn(e, b, x) {
		var S;
		if (!((S = this.client) != null && S.supportsThreads())) return {
			shouldLiveInRoom: !0,
			shouldLiveInThread: !1
		};
		if (e.isThreadRoot || x != null && x.has(e.getId())) return {
			shouldLiveInRoom: !0,
			shouldLiveInThread: !0,
			threadId: e.getId()
		};
		var C = e.isRelation(THREAD_RELATION_TYPE.name), w = e.getAssociatedId(), T = e.threadRootId;
		if (w && !C && (T === w || x != null && x.has(w))) return {
			shouldLiveInRoom: !0,
			shouldLiveInThread: !1
		};
		var E;
		return w && (E = this.findEventById(w) ?? b?.find((e) => e.getId() === w)), E && !C ? this.eventShouldLiveIn(E, b, x) : T == null ? !w || e.replyEventId ? {
			shouldLiveInRoom: !0,
			shouldLiveInThread: !1
		} : {
			shouldLiveInRoom: !1,
			shouldLiveInThread: !1
		} : {
			shouldLiveInRoom: !1,
			shouldLiveInThread: !0,
			threadId: T
		};
	}
	findThreadForEvent(e) {
		if (!e) return null;
		var { threadId: b } = this.eventShouldLiveIn(e);
		return b ? this.getThread(b) : null;
	}
	addThreadedEvents(e, b) {
		var x = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, S = this.getThread(e);
		if (S) S.addEvents(b, x);
		else {
			var C = this.findEventById(e) ?? b.find((b) => b.getId() === e);
			this.createThread(e, C, b, x);
		}
	}
	processThreadedEvents(e, b) {
		e.forEach(this.tryApplyRedaction);
		var x = {};
		for (var S of e) {
			var C, { threadId: w, shouldLiveInThread: T } = this.eventShouldLiveIn(S);
			T && !x[w] && (x[w] = []), (C = x[w]) == null || C.push(S);
		}
		Object.entries(x).map((e) => {
			var [x, S] = e;
			return this.addThreadedEvents(x, S, b);
		});
	}
	createThread(e, b) {
		var x = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], S = arguments.length > 3 ? arguments[3] : void 0;
		if (this.threads.has(e)) return this.threads.get(e);
		if (b) {
			var C = this.relations.getAllChildEventsForEvent(b.getId());
			C != null && C.length && (x = x.concat(C.filter((e) => !e.isRelation(RelationType.Replace))));
		}
		var w = new Thread(e, b, {
			room: this,
			client: this.client,
			pendingEventOrdering: this.opts.pendingEventOrdering,
			receipts: this.cachedThreadReadReceipts.get(e) ?? []
		});
		return this.reEmitter.reEmit(w, [
			ThreadEvent.Delete,
			ThreadEvent.Update,
			ThreadEvent.NewReply,
			RoomEvent.Timeline,
			RoomEvent.TimelineReset
		]), this.cachedThreadReadReceipts.delete(e), this.threads.set(w.id, w), w.addEvents(x, !1), this.threadsReady && w.initialEventsFetched && this.updateThreadRootEvents(w, S, !1), this.emit(ThreadEvent.New, w, S), w;
	}
	applyEventAsRedaction(e, b) {
		var x = b.threadRootId;
		b.makeRedacted(e, this), b.isState() && this.currentState.getStateEvents(b.getType(), b.getStateKey())?.getId() === b.getId() && this.currentState.setStateEvents([b]), this.emit(RoomEvent.Redaction, e, this, x), this.visibilityEvents.delete(b.getId()), b.isVisibilityEvent() && this.redactVisibilityChangeEvent(e);
	}
	processLiveEvent(e) {
		if (this.tryApplyRedaction(e), e.isVisibilityEvent() && this.applyNewVisibilityEvent(e), this.applyPendingVisibilityEvents(e), !e.getUnsigned().transaction_id && e.getSender() === this.myUserId) {
			for (var [b, x] of this.txnToEvent) if (x.getId() === e.getId()) {
				logger.debug("processLiveEvent: found sent event without txn ID: ", b, e.getId());
				var S = e.getUnsigned();
				S.transaction_id = b, e.setUnsigned(S);
				break;
			}
		}
	}
	addLiveEvent(e, b) {
		var { duplicateStrategy: x, timelineWasEmpty: S, fromCache: C, addToState: w } = b;
		for (var T of this.timelineSets) T.addLiveEvent(e, {
			duplicateStrategy: x,
			fromCache: C,
			timelineWasEmpty: S,
			addToState: w
		});
		e.sender && e.getType() !== EventType.RoomRedaction && this.addReceipt(synthesizeReceipt(e.sender.userId, e, ReceiptType.Read), !0);
	}
	addPendingEvent(e, b) {
		if (e.status !== EventStatus.SENDING && e.status !== EventStatus.NOT_SENT) throw Error("addPendingEvent called on an event with status " + e.status);
		if (this.txnToEvent.get(b)) throw Error("addPendingEvent called on an event with known txnId " + b);
		if (EventTimeline.setEventMetadata(e, this.getLiveTimeline().getState(EventTimeline.FORWARDS), !1), this.txnToEvent.set(b, e), this.pendingEventList) {
			if (this.pendingEventList.some((e) => e.status === EventStatus.NOT_SENT) && (logger.warn("Setting event as NOT_SENT due to messages in the same state"), e.setStatus(EventStatus.NOT_SENT)), this.pendingEventList.push(e), this.savePendingEvents(), e.isRelation() && this.aggregateNonLiveRelation(e), e.isRedaction()) {
				var x = e.event.redacts, S = this.pendingEventList.find((e) => e.getId() === x);
				!S && x && (S = this.findEventById(x)), S && (S.markLocallyRedacted(e), this.emit(RoomEvent.Redaction, e, this, S.threadRootId));
			}
		} else for (var C of this.timelineSets) C.getFilter() ? C.getFilter().filterRoomTimeline([e]).length && C.addEventToTimeline(e, C.getLiveTimeline(), {
			toStartOfTimeline: !1,
			addToState: !1
		}) : C.addEventToTimeline(e, C.getLiveTimeline(), {
			toStartOfTimeline: !1,
			addToState: !1
		});
		this.emit(RoomEvent.LocalEchoUpdated, e, this);
	}
	savePendingEvents() {
		if (this.pendingEventList) {
			var e = this.pendingEventList.map((e) => _objectSpread$14(_objectSpread$14({}, e.event), {}, { txn_id: e.getTxnId() })).filter((e) => {
				var b = e.type === EventType.RoomMessageEncrypted, x = this.hasEncryptionStateEvent();
				return b || !x;
			});
			this.client.store.setPendingEvents(this.roomId, e);
		}
	}
	aggregateNonLiveRelation(e) {
		this.relations.aggregateChildEvent(e);
	}
	getEventForTxnId(e) {
		return this.txnToEvent.get(e);
	}
	handleRemoteEcho(e, b) {
		var x = b.getId(), S = e.getId(), C = b.status;
		logger.debug(`Got remote echo for event ${x} -> ${S} old status ${C}`), this.txnToEvent.delete(e.getUnsigned().transaction_id), this.pendingEventList && this.removePendingEvent(x), b.handleRemoteEcho(e.event);
		var { shouldLiveInRoom: w, threadId: T } = this.eventShouldLiveIn(e), E = T ? this.getThread(T) : null;
		if (E?.setEventMetadata(b), E?.timelineSet.handleRemoteEcho(b, x, S), w) for (var D of this.timelineSets) D.handleRemoteEcho(b, x, S);
		this.emit(RoomEvent.LocalEchoUpdated, b, this, x, C);
	}
	updatePendingEvent(e, b, x) {
		if (logger.log(`setting pendingEvent status to ${b} in ${e.getRoomId()} event ID ${e.getId()} -> ${x}`), b == EventStatus.SENT && !x) throw Error("updatePendingEvent called with status=SENT, but no new event id");
		if (b == EventStatus.SENT && this.getTimelineForEvent(x)) {
			var S = this.findEventById(x);
			if (!S?.getUnsigned().transaction_id && S) {
				var C = S.getUnsigned();
				C.transaction_id = e.getTxnId(), S.setUnsigned(C), this.removeEvent(S.getId()), this.handleRemoteEcho(S, e);
			}
			return;
		}
		var w = e.status, T = e.getId();
		if (!w) throw Error("updatePendingEventStatus called on an event which is not a local echo.");
		var E = ALLOWED_TRANSITIONS[w];
		if (!(E != null && E.includes(b))) throw Error(`Invalid EventStatus transition ${w}->${b}`);
		if (e.setStatus(b), b == EventStatus.SENT) {
			e.replaceLocalEventId(x);
			var { shouldLiveInRoom: D, threadId: O } = this.eventShouldLiveIn(e), k = O ? this.getThread(O) : void 0;
			if (k?.setEventMetadata(e), k?.timelineSet.replaceEventId(T, x), D) for (var A of this.timelineSets) A.replaceEventId(T, x);
		} else if (b == EventStatus.CANCELLED) {
			if (this.pendingEventList) {
				var j = this.getPendingEvent(T);
				this.removePendingEvent(T), j != null && j.isRedaction() && this.revertRedactionLocalEcho(j);
			}
			this.removeEvent(T);
		}
		this.savePendingEvents(), this.emit(RoomEvent.LocalEchoUpdated, e, this, T, w);
	}
	revertRedactionLocalEcho(e) {
		var b = e.event.redacts;
		if (b) {
			var x = this.getUnfilteredTimelineSet().findEventById(b);
			x && (x.unmarkLocallyRedacted(), this.emit(RoomEvent.RedactionCancelled, e, this), x.isRelation() && this.aggregateNonLiveRelation(x));
		}
	}
	assertTimelineSetsAreLive() {
		for (var e = 0; e < this.timelineSets.length; e++) {
			var b = this.timelineSets[e].getLiveTimeline();
			if (b.getPaginationToken(EventTimeline.FORWARDS)) throw Error("live timeline " + e + " is no longer live - it has a pagination token (" + b.getPaginationToken(EventTimeline.FORWARDS) + ")");
			if (b.getNeighbouringTimeline(EventTimeline.FORWARDS)) throw Error(`live timeline ${e} is no longer live - it has a neighbouring timeline`);
		}
	}
	addLiveEvents(e, b) {
		var x = this;
		return _asyncToGenerator(function* () {
			var { duplicateStrategy: S, fromCache: C, timelineWasEmpty: w = !1, addToState: T } = b;
			if (S && ["replace", "ignore"].indexOf(S) === -1) throw Error("duplicateStrategy MUST be either 'replace' or 'ignore'");
			x.assertTimelineSetsAreLive();
			var E = x.findThreadRoots(e), D = {}, O = {
				duplicateStrategy: S,
				fromCache: C,
				timelineWasEmpty: w,
				addToState: T
			}, k = [...e];
			for (var A of e) {
				var j;
				if (x.processLiveEvent(A), A.getUnsigned().transaction_id) {
					var M = x.txnToEvent.get(A.getUnsigned().transaction_id);
					if (M) {
						x.handleRemoteEcho(A, M);
						continue;
					}
				}
				var { shouldLiveInRoom: N, shouldLiveInThread: P, threadId: F = "" } = x.eventShouldLiveIn(A, k, E);
				if (!P && !N && A.isRelation()) try {
					var I = new MatrixEvent(yield x.client.fetchRoomEvent(x.roomId, A.relationEventId));
					if (k.push(I), I.threadRootId) {
						E.add(I.threadRootId);
						var L = A.getUnsigned();
						L[UNSIGNED_THREAD_ID_FIELD.name] = I.threadRootId, A.setUnsigned(L);
					}
					({shouldLiveInRoom: N, shouldLiveInThread: P, threadId: F = ""} = x.eventShouldLiveIn(A, k, E));
				} catch (e) {
					logger.error("Failed to load parent event of unhandled relation", e);
				}
				P && !D[F] && (D[F] = []), (j = D[F]) == null || j.push(A), N ? x.addLiveEvent(A, O) : !P && A.isRelation() && x.relations.aggregateChildEvent(A);
			}
			Object.entries(D).forEach((e) => {
				var [b, S] = e;
				x.addThreadedEvents(b, S, !1);
			});
		})();
	}
	partitionThreadedEvents(e) {
		var b = 0, x = 1, S = 2;
		if (this.client.supportsThreads()) {
			var C = this.findThreadRoots(e);
			return e.reduce((w, T) => {
				var { shouldLiveInRoom: E, shouldLiveInThread: D, threadId: O } = this.eventShouldLiveIn(T, e, C);
				return E && w[b].push(T), D && (T.setThreadId(O ?? ""), w[x].push(T)), !D && !E && w[S].push(T), w;
			}, [
				[],
				[],
				[]
			]);
		} else return [
			e,
			[],
			[]
		];
	}
	findThreadRoots(e) {
		var b = /* @__PURE__ */ new Set();
		for (var x of e) {
			var S = x.threadRootId;
			S != null && b.add(S);
		}
		return b;
	}
	addReceipt(e) {
		var b = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, x = e.getContent();
		this.roomReceipts.add(x, b), Object.keys(x).forEach((e) => {
			Object.keys(x[e]).forEach((S) => {
				Object.keys(x[e][S]).forEach((C) => {
					var w = x[e][S][C], T = !w.thread_id || w.thread_id === "main", E = T ? this : this.threads.get(w.thread_id ?? "");
					if (E) {
						if (E.addReceiptToStructure(e, S, C, w, b), !b && this.client.isInitialSyncComplete() && C === this.client.getUserId()) {
							var D = E.timeline[E.timeline.length - 1];
							D && e === D.getId() && C === D.getSender() && (E.setUnread(NotificationCountType.Total, 0), E.setUnread(NotificationCountType.Highlight, 0));
						}
					} else this.cachedThreadReadReceipts.set(w.thread_id, [...this.cachedThreadReadReceipts.get(w.thread_id) ?? [], {
						eventId: e,
						receiptType: S,
						userId: C,
						receipt: w,
						synthetic: b
					}]);
					var O = this.client.getUserId();
					C === O && !T && w.ts < this.oldestThreadedReceiptTs && (this.oldestThreadedReceiptTs = w.ts), !w.thread_id && w.ts > (this.unthreadedReceipts.get(C)?.ts ?? 0) && this.unthreadedReceipts.set(C, w);
				});
			});
		}), this.emit(RoomEvent.Receipt, e, this);
	}
	addEphemeralEvents(e) {
		for (var b of e) b.getType() === EventType.Typing ? this.currentState.setTypingEvent(b) : b.getType() === EventType.Receipt && this.addReceipt(b);
	}
	removeEvents(e) {
		for (var b of e) this.removeEvent(b);
	}
	removeEvent(e) {
		var b = !1;
		for (var x of this.timelineSets) {
			var S = x.removeEvent(e);
			S && (S.isRedaction() && this.revertRedactionLocalEcho(S), b = !0);
		}
		return b;
	}
	recalculate() {
		var e = this.currentState.getStateEvents(EventType.RoomMember, this.myUserId);
		if (e) {
			var b = e.getContent().membership;
			this.updateMyMembership(b), b === KnownMembership.Invite && (e.getUnsigned().invite_room_state || []).forEach((e) => {
				this.currentState.getStateEvents(e.type, e.state_key) || this.currentState.setStateEvents([new MatrixEvent({
					type: e.type,
					state_key: e.state_key,
					content: e.content,
					event_id: "$fake" + Date.now(),
					room_id: this.roomId,
					sender: this.myUserId
				})]);
			});
		}
		var x = this.name;
		this.name = this.calculateRoomName(this.myUserId), this.normalizedName = normalize(this.name), this.summary = new RoomSummary(this.roomId, { title: this.name }), x !== this.name && this.emit(RoomEvent.Name, this);
	}
	addTags(e) {
		this.tags = e.getContent().tags || {}, this.emit(RoomEvent.Tags, e, this);
	}
	addAccountData(e) {
		for (var b of e) {
			b.getType() === "m.tag" && this.addTags(b);
			var x = b.getType(), S = this.accountData.get(x);
			this.accountData.set(x, b), this.emit(RoomEvent.AccountData, b, this, S);
		}
	}
	getAccountData(e) {
		return this.accountData.get(e);
	}
	_unstable_getStickyEvents() {
		return this.stickyEvents.getStickyEvents();
	}
	_unstable_getKeyedStickyEvent(e, b, x) {
		return this.stickyEvents.getKeyedStickyEvent(e, b, x);
	}
	_unstable_getUnkeyedStickyEvent(e, b) {
		return this.stickyEvents.getUnkeyedStickyEvent(e, b);
	}
	_unstable_addStickyEvents(e) {
		return this.stickyEvents.addStickyEvents(e);
	}
	maySendMessage() {
		return this.getMyMembership() === KnownMembership.Join && (this.hasEncryptionStateEvent() ? this.currentState.maySendEvent(EventType.RoomMessageEncrypted, this.myUserId) : this.currentState.maySendEvent(EventType.RoomMessage, this.myUserId));
	}
	canInvite(e) {
		var b = this.getMyMembership() === KnownMembership.Join, x = this.currentState.getStateEvents(EventType.RoomPowerLevels, ""), S = x && x.getContent(), C = this.getMember(e);
		return S && C && S.invite > C.powerLevel && (b = !1), b;
	}
	getJoinRule() {
		return this.currentState.getJoinRule();
	}
	getHistoryVisibility() {
		return this.currentState.getHistoryVisibility();
	}
	getGuestAccess() {
		return this.currentState.getGuestAccess();
	}
	getType() {
		var e = this.currentState.getStateEvents(EventType.RoomCreate, "");
		if (!e) {
			this.getTypeWarning ||= (logger.warn("[getType] Room " + this.roomId + " does not have an m.room.create event"), !0);
			return;
		}
		return e.getContent()[RoomCreateTypeField];
	}
	isSpaceRoom() {
		return this.getType() === RoomType.Space;
	}
	isCallRoom() {
		return this.getType() === RoomType.UnstableCall;
	}
	isElementVideoRoom() {
		return this.getType() === RoomType.ElementVideo;
	}
	findPredecessor() {
		var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, b = this.getLiveTimeline().getState(EventTimeline.FORWARDS);
		return b ? b.findPredecessor(e) : null;
	}
	roomNameGenerator(e) {
		if (this.client.roomNameGenerator) {
			var b = this.client.roomNameGenerator(this.roomId, e);
			if (b !== null) return b;
		}
		switch (e.type) {
			case RoomNameType.Actual: return e.name;
			case RoomNameType.Generated: switch (e.subtype) {
				case "Inviting": return `Inviting ${memberNamesToRoomName(e.names, e.count)}`;
				default: return memberNamesToRoomName(e.names, e.count);
			}
			case RoomNameType.EmptyRoom: return e.oldName ? `Empty room (was ${e.oldName})` : "Empty room";
		}
	}
	calculateRoomName(e) {
		if (!(arguments.length > 1 && arguments[1] !== void 0 && arguments[1])) {
			var b = this.currentState.getStateEvents(EventType.RoomName, "")?.getContent().name;
			if (b && typeof b == "string") return this.roomNameGenerator({
				type: RoomNameType.Actual,
				name: b
			});
		}
		var x = this.getCanonicalAlias();
		if (x) return this.roomNameGenerator({
			type: RoomNameType.Actual,
			name: x
		});
		var S = this.currentState.getJoinedMemberCount(), C = this.currentState.getInvitedMemberCount(), w = S + C - 1, T = this.getFunctionalMembers(), E = [];
		if (this.heroes) this.heroes.forEach((e) => {
			if (T.includes(e.userId)) {
				w--;
				return;
			}
			if (e.displayName) E.push(e.displayName);
			else {
				var b = this.getMember(e.userId);
				E.push(b ? b.name : e.userId);
			}
		});
		else {
			var D = this.currentState.getMembers().filter((b) => b.userId !== e && (b.membership === KnownMembership.Invite || b.membership === KnownMembership.Join));
			D = D.filter((e) => {
				var { userId: b } = e;
				return T.includes(b) ? (w--, !1) : !0;
			});
			var O = new Intl.Collator();
			D.sort((e, b) => O.compare(e.userId, b.userId)), D = D.slice(0, 5), E = D.map((e) => e.name);
		}
		if (w) return this.roomNameGenerator({
			type: RoomNameType.Generated,
			names: E,
			count: w
		});
		if (this.getMyMembership() == KnownMembership.Join) {
			var k = this.currentState.getStateEvents(EventType.RoomThirdPartyInvite);
			if (k != null && k.length) {
				var A = k.map((e) => e.getContent().display_name);
				return this.roomNameGenerator({
					type: RoomNameType.Generated,
					subtype: "Inviting",
					names: A,
					count: A.length + 1
				});
			}
		}
		var j = E;
		j.length || (j = this.currentState.getMembers().filter((b) => b.userId !== e && b.membership !== KnownMembership.Invite && b.membership !== KnownMembership.Join).map((e) => e.name));
		var M;
		return j.length && (M = this.roomNameGenerator({
			type: RoomNameType.Generated,
			names: j,
			count: j.length + 1
		})), this.roomNameGenerator({
			type: RoomNameType.EmptyRoom,
			oldName: M
		});
	}
	applyNewVisibilityEvent(e) {
		var b = e.asVisibilityChange();
		if (b) {
			var x = e.getSender();
			if (x && (EVENT_VISIBILITY_CHANGE_TYPE.name && this.currentState.maySendStateEvent(EVENT_VISIBILITY_CHANGE_TYPE.name, x) || EVENT_VISIBILITY_CHANGE_TYPE.altName && this.currentState.maySendStateEvent(EVENT_VISIBILITY_CHANGE_TYPE.altName, x))) {
				var S = this.visibilityEvents.get(b.eventId);
				if (S) {
					for (var C = S.length - 1, w = Math.max(0, S.length - MAX_NUMBER_OF_VISIBILITY_EVENTS_TO_SCAN_THROUGH); C >= w && !(S[C].getTs() < e.getTs()); --C);
					C === -1 ? S.unshift(e) : S.splice(C + 1, 0, e);
				} else this.visibilityEvents.set(b.eventId, [e]);
				var T = this.findEventById(b.eventId);
				T && T.applyVisibilityEvent(b);
			}
		}
	}
	redactVisibilityChangeEvent(e) {
		if (!e.isVisibilityEvent) throw Error("expected a visibility change event");
		var b = e.getRelation()?.event_id, x = this.visibilityEvents.get(b);
		if (x) {
			var S = x.findIndex((b) => b.getId() === e.getId());
			if (S !== -1 && (x.splice(S, 1), S === x.length)) {
				var C = this.findEventById(b);
				if (!C) return;
				if (S === 0) this.visibilityEvents.delete(b), C.applyVisibilityEvent();
				else {
					var w = x[x.length - 1].asVisibilityChange();
					if (!w) throw Error("at this stage, visibility changes should be well-formed");
					C.applyVisibilityEvent(w);
				}
			}
		}
	}
	applyPendingVisibilityEvents(e) {
		var b = this.visibilityEvents.get(e.getId());
		if (!(!b || b.length == 0)) {
			var x = b[b.length - 1], S = x.asVisibilityChange();
			S && (S.visible, !(x.getTs() < e.getTs()) && e.applyVisibilityEvent(S));
		}
	}
	getOldestThreadedReceiptTs() {
		return this.oldestThreadedReceiptTs;
	}
	hasUserReadEvent(e, b) {
		return this.roomReceipts.hasUserReadEvent(e, b);
	}
	getLastUnthreadedReceiptFor(e) {
		return this.unthreadedReceipts.get(e);
	}
	fixupNotifications(e) {
		super.fixupNotifications(e);
		for (var b of this.getThreads().filter((e) => this.getThreadUnreadNotificationCount(e.id, NotificationCountType.Total) > 0)) b.fixupNotifications(e);
	}
	compareEventOrdering(e, b) {
		return compareEventOrdering(this, e, b);
	}
	hasEncryptionStateEvent() {
		return !!this.getLiveTimeline().getState(EventTimeline.FORWARDS)?.getStateEvents(EventType.RoomEncryption, "");
	}
}, ALLOWED_TRANSITIONS = {
	[EventStatus.ENCRYPTING]: [
		EventStatus.SENDING,
		EventStatus.NOT_SENT,
		EventStatus.CANCELLED
	],
	[EventStatus.SENDING]: [
		EventStatus.ENCRYPTING,
		EventStatus.QUEUED,
		EventStatus.NOT_SENT,
		EventStatus.SENT
	],
	[EventStatus.QUEUED]: [
		EventStatus.SENDING,
		EventStatus.NOT_SENT,
		EventStatus.CANCELLED
	],
	[EventStatus.SENT]: [],
	[EventStatus.NOT_SENT]: [
		EventStatus.SENDING,
		EventStatus.QUEUED,
		EventStatus.CANCELLED
	],
	[EventStatus.CANCELLED]: []
}, RoomNameType = /* @__PURE__ */ function(e) {
	return e[e.EmptyRoom = 0] = "EmptyRoom", e[e.Generated = 1] = "Generated", e[e.Actual = 2] = "Actual", e;
}({});
function memberNamesToRoomName(e, b) {
	var x = b - 1;
	return e.length ? e.length === 1 && x <= 1 ? e[0] : e.length === 2 && x <= 2 ? `${e[0]} and ${e[1]}` : x > 1 ? `${e[0]} and ${x} others` : `${e[0]} and 1 other` : "Empty room";
}
var ServerSupport = /* @__PURE__ */ function(e) {
	return e[e.Stable = 0] = "Stable", e[e.Unstable = 1] = "Unstable", e[e.Unsupported = 2] = "Unsupported", e;
}({}), Feature = /* @__PURE__ */ function(e) {
	return e.Thread = "Thread", e.ThreadUnreadNotifications = "ThreadUnreadNotifications", e.LoginTokenRequest = "LoginTokenRequest", e.RelationBasedRedactions = "RelationBasedRedactions", e.AccountDataDeletion = "AccountDataDeletion", e.RelationsRecursion = "RelationsRecursion", e.IntentionalMentions = "IntentionalMentions", e;
}({}), featureSupportResolver = {
	[Feature.Thread]: {
		unstablePrefixes: ["org.matrix.msc3440"],
		matrixVersion: "v1.3"
	},
	[Feature.ThreadUnreadNotifications]: {
		unstablePrefixes: ["org.matrix.msc3771", "org.matrix.msc3773"],
		matrixVersion: "v1.4"
	},
	[Feature.LoginTokenRequest]: { unstablePrefixes: ["org.matrix.msc3882"] },
	[Feature.RelationBasedRedactions]: { unstablePrefixes: ["org.matrix.msc3912"] },
	[Feature.AccountDataDeletion]: { unstablePrefixes: ["org.matrix.msc3391"] },
	[Feature.RelationsRecursion]: {
		unstablePrefixes: ["org.matrix.msc3981"],
		matrixVersion: "v1.10"
	},
	[Feature.IntentionalMentions]: {
		unstablePrefixes: ["org.matrix.msc3952_intentional_mentions"],
		matrixVersion: "v1.7"
	}
};
function buildFeatureSupportMap(e) {
	return _buildFeatureSupportMap.apply(this, arguments);
}
function _buildFeatureSupportMap() {
	return _buildFeatureSupportMap = _asyncToGenerator(function* (e) {
		var b = /* @__PURE__ */ new Map();
		for (var [x, S] of Object.entries(featureSupportResolver)) {
			var C = e.versions?.includes(S.matrixVersion || "") ?? !1, w = S.unstablePrefixes?.every((b) => e.unstable_features?.[b] === !0) ?? !1;
			C ? b.set(x, ServerSupport.Stable) : w ? b.set(x, ServerSupport.Unstable) : b.set(x, ServerSupport.Unsupported);
		}
		return b;
	}), _buildFeatureSupportMap.apply(this, arguments);
}
function ownKeys$13(e, b) {
	var x = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var S = Object.getOwnPropertySymbols(e);
		b && (S = S.filter(function(b) {
			return Object.getOwnPropertyDescriptor(e, b).enumerable;
		})), x.push.apply(x, S);
	}
	return x;
}
function _objectSpread$13(e) {
	for (var b = 1; b < arguments.length; b++) {
		var x = arguments[b] == null ? {} : arguments[b];
		b % 2 ? ownKeys$13(Object(x), !0).forEach(function(b) {
			_defineProperty(e, b, x[b]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(x)) : ownKeys$13(Object(x)).forEach(function(b) {
			Object.defineProperty(e, b, Object.getOwnPropertyDescriptor(x, b));
		});
	}
	return e;
}
var BUFFER_PERIOD_MS$1 = 80 * 1e3, FAILED_SYNC_ERROR_THRESHOLD$1 = 3, SyncState = /* @__PURE__ */ function(e) {
	return e.Error = "ERROR", e.Prepared = "PREPARED", e.Stopped = "STOPPED", e.Syncing = "SYNCING", e.Catchup = "CATCHUP", e.Reconnecting = "RECONNECTING", e;
}({}), MSC2716_ROOM_VERSIONS = ["org.matrix.msc2716v3"];
function getFilterName(e, b) {
	return `FILTER_SYNC_${e}` + (b ? "_" + b : "");
}
var SetPresence = /* @__PURE__ */ function(e) {
	return e.Offline = "offline", e.Online = "online", e.Unavailable = "unavailable", e;
}({});
function defaultClientOpts(e) {
	return _objectSpread$13({
		initialSyncLimit: 8,
		resolveInvitesToProfiles: !1,
		pollTimeout: 30 * 1e3,
		pendingEventOrdering: PendingEventOrdering.Chronological,
		threadSupport: !1
	}, e);
}
function defaultSyncApiOpts(e) {
	return _objectSpread$13({ canResetEntireTimeline: (e) => !1 }, e);
}
var SyncApi = class {
	constructor(e, b, x) {
		var S = this;
		this.client = e, _defineProperty(this, "opts", void 0), _defineProperty(this, "syncOpts", void 0), _defineProperty(this, "_peekRoom", null), _defineProperty(this, "currentSyncRequest", void 0), _defineProperty(this, "abortController", void 0), _defineProperty(this, "syncState", null), _defineProperty(this, "syncStateData", void 0), _defineProperty(this, "catchingUp", !1), _defineProperty(this, "running", !1), _defineProperty(this, "keepAliveTimer", void 0), _defineProperty(this, "connectionReturnedResolvers", void 0), _defineProperty(this, "notifEvents", []), _defineProperty(this, "failedSyncCount", 0), _defineProperty(this, "storeIsInvalid", !1), _defineProperty(this, "presence", void 0), _defineProperty(this, "getPushRules", /* @__PURE__ */ _asyncToGenerator(function* () {
			try {
				S.syncOpts.logger.debug("Getting push rules...");
				var e = yield S.client.getPushRules();
				S.syncOpts.logger.debug("Got push rules"), S.client.pushRules = e;
			} catch (e) {
				return S.syncOpts.logger.error("Getting push rules failed", e), S.shouldAbortSync(e) ? void 0 : (S.syncOpts.logger.debug("Waiting for saved sync before retrying push rules..."), yield S.recoverFromSyncStartupError(S.savedSyncPromise, e), S.getPushRules());
			}
		})), _defineProperty(this, "buildDefaultFilter", () => {
			var e = new Filter(this.client.credentials.userId);
			return this.client.canSupport.get(Feature.ThreadUnreadNotifications) !== ServerSupport.Unsupported && e.setUnreadThreadNotifications(!0), e;
		}), _defineProperty(this, "prepareLazyLoadingForSync", /* @__PURE__ */ _asyncToGenerator(function* () {
			S.syncOpts.logger.debug("Prepare lazy loading for sync..."), S.client.isGuest() && (S.opts.lazyLoadMembers = !1), S.opts.lazyLoadMembers && (S.syncOpts.logger.debug("Enabling lazy load on sync filter..."), S.opts.filter || (S.opts.filter = S.buildDefaultFilter()), S.opts.filter.setLazyLoadMembers(!0));
		})), _defineProperty(this, "storeClientOptions", /* @__PURE__ */ _asyncToGenerator(function* () {
			try {
				S.syncOpts.logger.debug("Storing client options..."), yield S.client.storeClientOptions(), S.syncOpts.logger.debug("Stored client options");
			} catch (e) {
				throw S.syncOpts.logger.error("Storing client options failed", e), e;
			}
		})), _defineProperty(this, "getFilter", /* @__PURE__ */ _asyncToGenerator(function* () {
			S.syncOpts.logger.debug("Getting filter...");
			var e = S.opts.filter ? S.opts.filter : S.buildDefaultFilter(), b;
			try {
				b = yield S.client.getOrCreateFilter(getFilterName(S.client.credentials.userId), e);
			} catch (e) {
				return S.syncOpts.logger.error("Getting filter failed", e), S.shouldAbortSync(e) ? {} : (S.syncOpts.logger.debug("Waiting for saved sync before retrying filter..."), yield S.recoverFromSyncStartupError(S.savedSyncPromise, e), S.getFilter());
			}
			return {
				filter: e,
				filterId: b
			};
		})), _defineProperty(this, "savedSyncPromise", void 0), _defineProperty(this, "onOnline", () => {
			this.syncOpts.logger.debug("Browser thinks we are back online"), this.startKeepAlives(0);
		}), this.opts = defaultClientOpts(b), this.syncOpts = defaultSyncApiOpts(x), e.getNotifTimelineSet() && e.reEmitter.reEmit(e.getNotifTimelineSet(), [RoomEvent.Timeline, RoomEvent.TimelineReset]);
	}
	createRoom(e) {
		var b = _createAndReEmitRoom(this.client, e, this.opts);
		return b.on(RoomStateEvent.Marker, (e, x) => {
			this.onMarkerStateEvent(b, e, x);
		}), b;
	}
	onMarkerStateEvent(e, b) {
		var { timelineWasEmpty: x } = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
		if (x) {
			this.syncOpts.logger.debug(`MarkerState: Ignoring markerEventId=${b.getId()} in roomId=${e.roomId} because the timeline was empty before the marker arrived which means there is nothing to refresh.`);
			return;
		}
		MSC2716_ROOM_VERSIONS.includes(e.getVersion()) || b.getSender() === e.getCreator() ? (this.syncOpts.logger.debug(`MarkerState: Timeline needs to be refreshed because a new markerEventId=${b.getId()} was sent in roomId=${e.roomId}`), e.setTimelineNeedsRefresh(!0), e.emit(RoomEvent.HistoryImportedWithinTimeline, b, e)) : this.syncOpts.logger.debug(`MarkerState: Ignoring markerEventId=${b.getId()} in roomId=${e.roomId} because MSC2716 is not supported in the room version or for any room version, the marker wasn't sent by the room creator.`);
	}
	syncLeftRooms() {
		var e = this;
		return _asyncToGenerator(function* () {
			var b, x = e.client, S = new Filter(e.client.credentials.userId);
			S.setTimelineLimit(1), S.setIncludeLeaveRooms(!0);
			var C = e.opts.pollTimeout + BUFFER_PERIOD_MS$1, w = {
				timeout: 0,
				filter: yield x.getOrCreateFilter(getFilterName(x.credentials.userId, "LEFT_ROOMS"), S),
				"org.matrix.msc4222.use_state_after": !0
			}, T = yield x.http.authedRequest(Method.Get, "/sync", w, void 0, { localTimeoutMs: C }), E = [];
			return (b = T.rooms) != null && b.leave && (E = e.mapSyncResponseToRoomArray(T.rooms.leave)), (yield Promise.all(E.map(/* @__PURE__ */ function() {
				var b = _asyncToGenerator(function* (b) {
					var S = b.room;
					if (b.isBrandNewRoom) {
						b.timeline = b.timeline || {
							prev_batch: null,
							events: []
						}, S.getLiveTimeline().setPaginationToken(b.timeline.prev_batch, EventTimeline.BACKWARDS);
						var { timelineEvents: C } = yield e.mapAndInjectRoomEvents(b);
						return S.recalculate(), x.store.storeRoom(S), x.emit(ClientEvent.Room, S), e.processEventsForNotifs(S, C), S;
					}
				});
				return function(e) {
					return b.apply(this, arguments);
				};
			}()))).filter(Boolean);
		})();
	}
	peek(e) {
		var b = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 20;
		if (this._peekRoom?.roomId === e) return Promise.resolve(this._peekRoom);
		var x = this.client;
		return this._peekRoom = this.createRoom(e), this.client.roomInitialSync(e, b).then((b) => {
			if (this._peekRoom?.roomId !== e) throw Error("Peeking aborted");
			b.messages = b.messages || { chunk: [] }, b.messages.chunk = b.messages.chunk || [], b.state = b.state || [];
			var S = deepCopy(b.state).map(x.getEventMapper()), C = b.state.map(x.getEventMapper()), w = b.messages.chunk.map(x.getEventMapper());
			return Array.isArray(b.presence) && b.presence.map(x.getEventMapper()).forEach(function(e) {
				var b = x.store.getUser(e.getContent().user_id);
				b ? b.setPresenceEvent(e) : (b = User.createUser(e.getContent().user_id, x), b.setPresenceEvent(e), x.store.storeUser(b)), x.emit(ClientEvent.Event, e);
			}), b.messages.start && (this._peekRoom.oldState.paginationToken = b.messages.start), this._peekRoom.oldState.setStateEvents(S), this._peekRoom.currentState.setStateEvents(C), this.resolveInvites(this._peekRoom), this._peekRoom.recalculate(), this._peekRoom.addEventsToTimeline(w.reverse(), !0, !0, this._peekRoom.getLiveTimeline(), b.messages.start), x.store.storeRoom(this._peekRoom), x.emit(ClientEvent.Room, this._peekRoom), this.peekPoll(this._peekRoom), this._peekRoom;
		});
	}
	stopPeeking() {
		this._peekRoom = null;
	}
	peekPoll(e, b) {
		var x = this;
		if (this._peekRoom !== e) {
			this.syncOpts.logger.debug("Stopped peeking in room %s", e.roomId);
			return;
		}
		this.client.http.authedRequest(Method.Get, "/events", {
			room_id: e.roomId,
			timeout: "30000",
			from: b
		}, void 0, {
			localTimeoutMs: 50 * 1e3,
			abortSignal: this.abortController?.signal
		}).then(/* @__PURE__ */ function() {
			var b = _asyncToGenerator(function* (b) {
				if (x._peekRoom !== e) {
					x.syncOpts.logger.debug("Stopped peeking in room %s", e.roomId);
					return;
				}
				b.chunk.filter(function(e) {
					return e.type === "m.presence";
				}).map(x.client.getEventMapper()).forEach((e) => {
					var b = x.client.store.getUser(e.getContent().user_id);
					b ? b.setPresenceEvent(e) : (b = User.createUser(e.getContent().user_id, x.client), b.setPresenceEvent(e), x.client.store.storeUser(b)), x.client.emit(ClientEvent.Event, e);
				});
				var S = b.chunk.filter(function(b) {
					return b.room_id === e.roomId && b.event_id;
				}).map(x.client.getEventMapper());
				yield e.addLiveEvents(S, { addToState: !0 }), x.peekPoll(e, b.end);
			});
			return function(e) {
				return b.apply(this, arguments);
			};
		}(), (x) => {
			this.syncOpts.logger.error("[%s] Peek poll failed: %s", e.roomId, x), setTimeout(() => {
				this.peekPoll(e, b);
			}, 30 * 1e3);
		});
	}
	getSyncState() {
		return this.syncState;
	}
	getSyncStateData() {
		return this.syncStateData ?? null;
	}
	recoverFromSyncStartupError(e, b) {
		var x = this;
		return _asyncToGenerator(function* () {
			yield e;
			var S = x.startKeepAlives();
			x.updateSyncState(SyncState.Error, { error: b }), yield S;
		})();
	}
	shouldAbortSync(e) {
		return e.errcode === "M_UNKNOWN_TOKEN" ? (this.syncOpts.logger.warn("Token no longer valid - assuming logout"), this.stop(), this.updateSyncState(SyncState.Error, { error: e }), !0) : !1;
	}
	sync() {
		var e = this;
		return _asyncToGenerator(function* () {
			var b, x;
			if (e.running = !0, e.abortController = new AbortController(), (b = globalThis.window) == null || (x = b.addEventListener) == null || x.call(b, "online", e.onOnline, !1), e.client.isGuest()) return e.doSync({});
			e.syncOpts.logger.debug("Getting saved sync token...");
			var S = e.client.store.getSavedSyncToken().then((b) => (e.syncOpts.logger.debug("Got saved sync token"), b));
			e.savedSyncPromise = e.client.store.getSavedSync().then((b) => {
				if (e.syncOpts.logger.debug(`Got reply from saved sync, exists? ${!!b}`), b) return e.syncFromCache(b);
			}).catch((b) => {
				e.syncOpts.logger.error("Getting saved sync failed", b);
			}), yield e.getPushRules(), yield e.prepareLazyLoadingForSync(), yield e.storeClientOptions();
			var { filterId: C, filter: w } = yield e.getFilter();
			if (w) {
				if (e.client.resetNotifTimelineSet(), !e.currentSyncRequest) {
					var T = C, E = yield S;
					if (E) e.syncOpts.logger.debug("Sending first sync request...");
					else {
						e.syncOpts.logger.debug("Sending initial sync request...");
						var D = e.buildDefaultFilter();
						D.setDefinition(w.getDefinition()), D.setTimelineLimit(e.opts.initialSyncLimit), T = JSON.stringify(D.getDefinition());
					}
					e.currentSyncRequest = e.doSyncRequest({ filter: T }, E);
				}
				return e.syncOpts.logger.debug("Waiting for saved sync before starting sync processing..."), yield e.savedSyncPromise, e.doSync({ filter: C });
			}
		})();
	}
	stop() {
		var e, b, x;
		this.syncOpts.logger.debug("SyncApi.stop"), (e = globalThis.window) == null || (b = e.removeEventListener) == null || b.call(e, "online", this.onOnline, !1), this.running = !1, (x = this.abortController) == null || x.abort(), this.keepAliveTimer &&= (clearTimeout(this.keepAliveTimer), void 0);
	}
	retryImmediately() {
		return this.connectionReturnedResolvers ? (this.startKeepAlives(0), !0) : !1;
	}
	syncFromCache(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			b.syncOpts.logger.debug("sync(): not doing HTTP hit, instead returning stored /sync data");
			var x = e.nextBatch;
			b.client.store.setSyncToken(x);
			var S = {
				nextSyncToken: x,
				catchingUp: !1,
				fromCache: !0
			}, C = {
				next_batch: x,
				rooms: e.roomsData,
				account_data: { events: e.accountData }
			};
			try {
				yield b.processSyncResponse(S, C);
			} catch (e) {
				b.syncOpts.logger.error("Error processing cached sync", e);
			}
			b.storeIsInvalid || b.updateSyncState(SyncState.Prepared, S);
		})();
	}
	doSync(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			for (; b.running;) {
				var x = b.client.store.getSyncToken(), S = void 0;
				try {
					b.currentSyncRequest ||= b.doSyncRequest(e, x), S = yield b.currentSyncRequest;
				} catch (e) {
					if (yield b.onSyncError(e)) return;
					continue;
				} finally {
					b.currentSyncRequest = void 0;
				}
				b.client.store.setSyncToken(S.next_batch), b.failedSyncCount = 0;
				var C = {
					oldSyncToken: x ?? void 0,
					nextSyncToken: S.next_batch,
					catchingUp: b.catchingUp
				};
				try {
					yield b.processSyncResponse(C, S);
				} catch (e) {
					b.syncOpts.logger.error("Caught /sync error", e), b.client.emit(ClientEvent.SyncUnexpectedError, e);
				}
				yield b.client.store.setSyncData(S), C.catchingUp = b.catchingUp, e.hasSyncedBefore ||= (b.updateSyncState(SyncState.Prepared, C), !0), b.syncOpts.cryptoCallbacks && (yield b.syncOpts.cryptoCallbacks.onSyncCompleted(C)), b.updateSyncState(SyncState.Syncing, C), b.client.store.wantsSave() && (yield b.client.store.save());
			}
			b.running || (b.syncOpts.logger.debug("Sync no longer running: exiting."), b.connectionReturnedResolvers &&= (b.connectionReturnedResolvers.reject(), void 0), b.updateSyncState(SyncState.Stopped));
		})();
	}
	doSyncRequest(e, b) {
		var x = this.getSyncParams(e, b);
		return this.client.http.authedRequest(Method.Get, "/sync", x, void 0, {
			localTimeoutMs: x.timeout + BUFFER_PERIOD_MS$1,
			abortSignal: this.abortController?.signal
		});
	}
	getSyncParams(e, b) {
		var x = this.opts.pollTimeout;
		(this.getSyncState() !== SyncState.Syncing || this.catchingUp) && (this.catchingUp = !0, x = 0);
		var S = e.filter;
		this.client.isGuest() && !S && (S = this.getGuestFilter());
		var C = {
			filter: S,
			timeout: x,
			"org.matrix.msc4222.use_state_after": !0
		};
		return this.opts.disablePresence ? C.set_presence = SetPresence.Offline : this.presence !== void 0 && (C.set_presence = this.presence), b ? C.since = b : C._cacheBuster = Date.now(), [SyncState.Reconnecting, SyncState.Error].includes(this.getSyncState()) && (C.timeout = 0), C;
	}
	setPresence(e) {
		this.presence = e;
	}
	onSyncError(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			if (!b.running) return b.syncOpts.logger.debug("Sync no longer running: exiting"), b.connectionReturnedResolvers &&= (b.connectionReturnedResolvers.reject(), void 0), b.updateSyncState(SyncState.Stopped), !0;
			if (b.syncOpts.logger.error("/sync error %s", e), b.shouldAbortSync(e)) return !0;
			b.failedSyncCount++, b.syncOpts.logger.debug("Number of consecutive failed sync requests:", b.failedSyncCount), b.syncOpts.logger.debug("Starting keep-alive");
			var x = b.startKeepAlives();
			return b.currentSyncRequest = void 0, b.updateSyncState(b.failedSyncCount >= FAILED_SYNC_ERROR_THRESHOLD$1 ? SyncState.Error : SyncState.Reconnecting, { error: e }), (yield x) && b.getSyncState() === SyncState.Error && b.updateSyncState(SyncState.Catchup, { catchingUp: !0 }), !1;
		})();
	}
	processSyncResponse(e, b) {
		var x = this;
		return _asyncToGenerator(function* () {
			var S = x.client;
			if (Array.isArray(b.presence?.events) && b.presence.events.filter(noUnsafeEventProps).map(S.getEventMapper()).forEach(function(e) {
				var b = S.store.getUser(e.getSender());
				b ? b.setPresenceEvent(e) : (b = User.createUser(e.getSender(), S), b.setPresenceEvent(e), S.store.storeUser(b)), S.emit(ClientEvent.Event, e);
			}), Array.isArray(b.account_data?.events)) {
				var C = b.account_data.events.filter(noUnsafeEventProps).map(S.getEventMapper()), w = C.reduce((e, b) => (e[b.getType()] = S.store.getAccountData(b.getType()), e), {});
				S.store.storeAccountDataEvents(C), C.forEach(function(e) {
					if (e.getType() === EventType.PushRules) {
						var b = e.getContent();
						S.setPushRules(b);
					}
					var x = w[e.getType()];
					return S.emit(ClientEvent.AccountData, e, x), e;
				});
			}
			if (b.to_device && Array.isArray(b.to_device.events) && b.to_device.events.length > 0) {
				var T = b.to_device.events.filter(noUnsafeEventProps), E = x.syncOpts.cryptoCallbacks ? yield x.syncOpts.cryptoCallbacks.preprocessToDeviceMessages(T) : T.map((e) => ({
					message: e,
					encryptionInfo: null
				}));
				processToDeviceMessages(E, S);
			} else x.catchingUp = !1;
			var D = [], O = [], k = [], A = [];
			b.rooms && (b.rooms.invite && (D = x.mapSyncResponseToRoomArray(b.rooms.invite)), b.rooms.join && (O = x.mapSyncResponseToRoomArray(b.rooms.join)), b.rooms.leave && (k = x.mapSyncResponseToRoomArray(b.rooms.leave)), b.rooms.knock && (A = x.mapSyncResponseToRoomArray(b.rooms.knock))), x.notifEvents = [], yield promiseMapSeries(D, /* @__PURE__ */ function() {
				var e = _asyncToGenerator(function* (e) {
					var b = e.room, C = x.mapSyncEventsFormat(e.invite_state, b);
					yield x.injectRoomEvents(b, C, void 0), e.isBrandNewRoom ? (b.recalculate(), S.store.storeRoom(b), S.emit(ClientEvent.Room, b)) : b.recalculate(), C.forEach(function(e) {
						S.emit(ClientEvent.Event, e);
					});
				});
				return function(b) {
					return e.apply(this, arguments);
				};
			}()), yield promiseMapSeries(O, /* @__PURE__ */ function() {
				var b = _asyncToGenerator(function* (b) {
					var C = b.room, w = x.mapSyncEventsFormat(b.state, C), T = x.mapSyncEventsFormat(b["org.matrix.msc4222.state_after"], C), E = x.mapSyncEventsFormat(b.timeline, C, !1), D = x.mapSyncEventsFormat(b.ephemeral), O = x.mapSyncEventsFormat(b.account_data), k = x.mapSyncEventsFormat(b.msc4354_sticky), A = b["org.matrix.msc4222.state_after"] ? T : w.concat(E), j = x.isRoomEncrypted(C, A);
					b.unread_notifications && ((!j || b.unread_notifications.notification_count === 0) && C.setUnreadNotificationCount(NotificationCountType.Total, b.unread_notifications.notification_count ?? 0), (!j || C.getUnreadNotificationCount(NotificationCountType.Highlight) <= 0) && C.setUnreadNotificationCount(NotificationCountType.Highlight, b.unread_notifications.highlight_count ?? 0));
					var M = b[UNREAD_THREAD_NOTIFICATIONS.name] ?? b[UNREAD_THREAD_NOTIFICATIONS.altName];
					if (M) {
						C.resetThreadUnreadNotificationCountFromSync(Object.keys(M));
						for (var [N, P] of Object.entries(M)) {
							(!j || P.notification_count === 0) && C.setThreadUnreadNotificationCount(N, NotificationCountType.Total, P.notification_count ?? 0);
							var F = C.getThreadUnreadNotificationCount(N, NotificationCountType.Highlight) <= 0;
							(!j || j && F) && C.setThreadUnreadNotificationCount(N, NotificationCountType.Highlight, P.highlight_count ?? 0);
						}
					} else C.resetThreadUnreadNotificationCountFromSync();
					if (b.timeline = b.timeline || {}, b.isBrandNewRoom) b.timeline.prev_batch !== null && C.getLiveTimeline().setPaginationToken(b.timeline.prev_batch, EventTimeline.BACKWARDS);
					else if (b.timeline.limited) {
						for (var I = !0, L = E.length - 1; L >= 0; L--) {
							var R = E[L].getId();
							if (C.getTimelineForEvent(R)) {
								x.syncOpts.logger.debug(`Already have event ${R} in limited sync - not resetting`), I = !1, E.splice(0, L);
								break;
							}
						}
						I && (C.resetLiveTimeline(b.timeline.prev_batch, x.syncOpts.canResetEntireTimeline(C.roomId) ? null : e.oldSyncToken ?? null), S.resetNotifTimelineSet());
					}
					if (x.syncOpts.cryptoCallbacks) for (var z of A) z.isState() && z.getType() === EventType.RoomEncryption && z.getStateKey() === "" && (yield x.syncOpts.cryptoCallbacks.onCryptoEvent(C, z));
					for (var B of E.filter((e) => e.isState())) yield x.client.decryptEventIfNeeded(B);
					try {
						"org.matrix.msc4222.state_after" in b ? yield x.injectRoomEvents(C, void 0, T, E, e.fromCache) : yield x.injectRoomEvents(C, w, void 0, E, e.fromCache);
					} catch (e) {
						x.syncOpts.logger.error(`Failed to process events on room ${C.roomId}:`, e);
					}
					b.summary && C.setSummary(b.summary), C.addEphemeralEvents(D), C.addAccountData(O);
					var V = k.concat(E.filter((e) => e.unstableStickyInfo !== void 0));
					C._unstable_addStickyEvents(V), C.recalculate(), b.isBrandNewRoom && (S.store.storeRoom(C), S.emit(ClientEvent.Room, C)), x.processEventsForNotifs(C, E);
					var H = (e) => S.emit(ClientEvent.Event, e);
					w.forEach(H), E.forEach(H), D.forEach(H), O.forEach(H), k.filter((e) => !E.some((b) => b.getId() === e.getId())).forEach(H), C.decryptCriticalEvents();
				});
				return function(e) {
					return b.apply(this, arguments);
				};
			}()), yield promiseMapSeries(k, /* @__PURE__ */ function() {
				var e = _asyncToGenerator(function* (e) {
					var b = e.room, { timelineEvents: C, stateEvents: w, stateAfterEvents: T } = yield x.mapAndInjectRoomEvents(e), E = x.mapSyncEventsFormat(e.account_data);
					b.addAccountData(E), b.recalculate(), e.isBrandNewRoom && (S.store.storeRoom(b), S.emit(ClientEvent.Room, b)), x.processEventsForNotifs(b, C), w?.forEach(function(e) {
						S.emit(ClientEvent.Event, e);
					}), T?.forEach(function(e) {
						S.emit(ClientEvent.Event, e);
					}), C.forEach(function(e) {
						S.emit(ClientEvent.Event, e);
					}), E.forEach(function(e) {
						S.emit(ClientEvent.Event, e);
					});
				});
				return function(b) {
					return e.apply(this, arguments);
				};
			}()), yield promiseMapSeries(A, /* @__PURE__ */ function() {
				var e = _asyncToGenerator(function* (e) {
					var b = e.room, C = x.mapSyncEventsFormat(e.knock_state, b);
					yield x.injectRoomEvents(b, C, void 0), e.isBrandNewRoom ? (b.recalculate(), S.store.storeRoom(b), S.emit(ClientEvent.Room, b)) : b.recalculate(), C.forEach(function(e) {
						S.emit(ClientEvent.Event, e);
					});
				});
				return function(b) {
					return e.apply(this, arguments);
				};
			}()), e.oldSyncToken && x.notifEvents.length && (x.notifEvents.sort(function(e, b) {
				return e.getTs() - b.getTs();
			}), x.notifEvents.forEach(function(e) {
				var b;
				(b = S.getNotifTimelineSet()) == null || b.addLiveEvent(e, { addToState: !0 });
			})), b.device_lists && x.syncOpts.cryptoCallbacks && (yield x.syncOpts.cryptoCallbacks.processDeviceLists(b.device_lists)), yield x.syncOpts.cryptoCallbacks?.processKeyCounts(b.device_one_time_keys_count, b.device_unused_fallback_key_types ?? b["org.matrix.msc2732.device_unused_fallback_key_types"]);
		})();
	}
	startKeepAlives(e) {
		return e === void 0 && (e = 2e3 + Math.floor(Math.random() * 5e3)), this.keepAliveTimer !== null && clearTimeout(this.keepAliveTimer), e > 0 ? this.keepAliveTimer = setTimeout(this.pokeKeepAlive.bind(this), e) : this.pokeKeepAlive(), this.connectionReturnedResolvers ||= Promise.withResolvers(), this.connectionReturnedResolvers.promise;
	}
	pokeKeepAlive() {
		var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
		if (!this.running) {
			clearTimeout(this.keepAliveTimer), this.connectionReturnedResolvers &&= (this.connectionReturnedResolvers.reject("SyncApi.stop() was called"), void 0);
			return;
		}
		var b = () => {
			clearTimeout(this.keepAliveTimer), this.connectionReturnedResolvers &&= (this.connectionReturnedResolvers.resolve(e), void 0);
		};
		this.client.http.request(Method.Get, "/_matrix/client/versions", void 0, void 0, {
			prefix: "",
			localTimeoutMs: 15 * 1e3,
			abortSignal: this.abortController?.signal
		}).then(() => {
			b();
		}, (x) => {
			x.httpStatus == 400 || x.httpStatus == 404 ? this.keepAliveTimer = setTimeout(b, 2e3) : (e = !0, this.keepAliveTimer = setTimeout(this.pokeKeepAlive.bind(this, e), 5e3 + Math.floor(Math.random() * 5e3)), this.updateSyncState(SyncState.Error, { error: x }));
		});
	}
	mapSyncResponseToRoomArray(e) {
		var b = this.client;
		return Object.keys(e).filter((e) => !unsafeProp(e)).map((x) => {
			var S = b.store.getRoom(x), C = !1;
			return S || (S = this.createRoom(x), C = !0), _objectSpread$13(_objectSpread$13({}, e[x]), {}, {
				room: S,
				isBrandNewRoom: C
			});
		});
	}
	mapSyncEventsFormat(e, b) {
		var x = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
		if (!e || !Array.isArray(e.events)) return [];
		var S = this.client.getEventMapper({ decrypt: x });
		return e.events.filter(noUnsafeEventProps).map(function(e) {
			return b && (e.room_id = b.roomId), S(e);
		});
	}
	resolveInvites(e) {
		if (!(!e || !this.opts.resolveInvitesToProfiles)) {
			var b = this.client;
			e.getMembersWithMembership(KnownMembership.Invite).forEach(function(x) {
				if (!x.requestedProfileInfo) {
					x.requestedProfileInfo = !0;
					var S = b.getUser(x.userId);
					(S ? Promise.resolve({
						avatar_url: S.avatarUrl,
						displayname: S.displayName
					}) : b.getProfileInfo(x.userId)).then(function(b) {
						var S = x.events.member;
						S?.getContent().membership === KnownMembership.Invite && (S.getContent().avatar_url = b.avatar_url, S.getContent().displayname = b.displayname, x.setMembershipEvent(S, e.currentState));
					}, function(e) {});
				}
			});
		}
	}
	findEncryptionEvent(e) {
		return e?.find((e) => e.getType() === EventType.RoomEncryption && e.getStateKey() === "");
	}
	isRoomEncrypted(e, b) {
		return e.hasEncryptionStateEvent() || !!this.findEncryptionEvent(b);
	}
	mapAndInjectRoomEvents(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			var x = b.mapSyncEventsFormat(e.state, e.room), S = b.mapSyncEventsFormat(e["org.matrix.msc4222.state_after"], e.room), C = b.mapSyncEventsFormat(e.timeline, e.room);
			return "org.matrix.msc4222.state_after" in e ? yield b.injectRoomEvents(e.room, void 0, S, C) : yield b.injectRoomEvents(e.room, x, void 0, C), {
				timelineEvents: C,
				stateEvents: x,
				stateAfterEvents: S
			};
		})();
	}
	injectRoomEvents(e, b, x, S) {
		var C = arguments, w = this;
		return _asyncToGenerator(function* () {
			var T = C.length > 4 && C[4] !== void 0 ? C[4] : !1, E = x ?? b, D = e.getLiveTimeline(), O = D.getEvents().length == 0;
			if (O) {
				for (var k of E) w.client.getPushActionsForEvent(k);
				D.initialiseState(E, { timelineWasEmpty: O });
			}
			w.resolveInvites(e), e.recalculate(), O || (e.oldState.setStateEvents(E), e.currentState.setStateEvents(E)), yield e.addLiveEvents(S || [], {
				fromCache: T,
				timelineWasEmpty: O,
				addToState: x === void 0
			}), w.client.processBeaconEvents(e, S);
		})();
	}
	processEventsForNotifs(e, b) {
		if (this.client.getNotifTimelineSet()) for (var x of b) {
			var S, C = this.client.getPushActionsForEvent(x);
			C != null && C.notify && (S = C.tweaks) != null && S.highlight && this.notifEvents.push(x);
		}
	}
	getGuestFilter() {
		return "{}";
	}
	updateSyncState(e, b) {
		var x = this.syncState;
		this.syncState = e, this.syncStateData = b, this.client.emit(ClientEvent.Sync, this.syncState, x, b);
	}
};
function _createAndReEmitRoom(e, b, x) {
	var { timelineSupport: S } = e, C = new Room(b, e, e.getUserId(), {
		lazyLoadMembers: x.lazyLoadMembers,
		pendingEventOrdering: x.pendingEventOrdering,
		timelineSupport: S
	});
	return e.reEmitter.reEmit(C, [
		RoomEvent.Name,
		RoomEvent.Redaction,
		RoomEvent.RedactionCancelled,
		RoomEvent.Receipt,
		RoomEvent.Tags,
		RoomEvent.LocalEchoUpdated,
		RoomEvent.AccountData,
		RoomEvent.MyMembership,
		RoomEvent.Timeline,
		RoomEvent.TimelineReset,
		RoomStateEvent.Events,
		RoomStateEvent.Members,
		RoomStateEvent.NewMember,
		RoomStateEvent.Update,
		BeaconEvent.New,
		BeaconEvent.Update,
		BeaconEvent.Destroy,
		BeaconEvent.LivenessChange
	]), C.on(RoomStateEvent.NewMember, (b, x, S) => {
		S.user = e.getUser(S.userId) ?? void 0, e.reEmitter.reEmit(S, [
			RoomMemberEvent.Name,
			RoomMemberEvent.Typing,
			RoomMemberEvent.PowerLevel,
			RoomMemberEvent.Membership
		]);
	}), C;
}
function processToDeviceMessages(e, b) {
	var x = [];
	e.map((e) => {
		if (e.message.type === "m.key.verification.cancel") {
			var b = e.message.content.transaction_id;
			b && x.push(b);
		}
		return e;
	}).forEach(function(e) {
		var S = e.message, C = S.content, w = new MatrixEvent(Object.assign({}, S));
		if (S.type === "m.key.verification.start" || S.type === "m.key.verification.request") {
			var T = C.transaction_id;
			x.includes(T) && w.flagCancelled();
		}
		e.encryptionInfo && w.makeEncrypted(EventType.RoomMessageEncrypted, { ciphertext: "" }, e.encryptionInfo.senderCurve25519KeyBase64, ""), b.emit(ClientEvent.ToDeviceEvent, w), b.emit(ClientEvent.ReceivedToDeviceMessage, e);
	});
}
var StubStore = class {
	constructor() {
		_defineProperty(this, "accountData", /* @__PURE__ */ new Map()), _defineProperty(this, "fromToken", null);
	}
	isNewlyCreated() {
		return Promise.resolve(!0);
	}
	getSyncToken() {
		return this.fromToken;
	}
	setSyncToken(e) {
		this.fromToken = e;
	}
	storeRoom(e) {}
	getRoom(e) {
		return null;
	}
	getRooms() {
		return [];
	}
	removeRoom(e) {}
	getRoomSummaries() {
		return [];
	}
	storeUser(e) {}
	getUser(e) {
		return null;
	}
	getUsers() {
		return [];
	}
	scrollback(e, b) {
		return [];
	}
	setUserCreator(e) {}
	storeEvents(e, b, x, S) {}
	storeFilter(e) {}
	getFilter(e, b) {
		return null;
	}
	getFilterIdByName(e) {
		return null;
	}
	setFilterIdByName(e, b) {}
	storeAccountDataEvents(e) {}
	getAccountData(e) {}
	setSyncData(e) {
		return Promise.resolve();
	}
	wantsSave() {
		return !1;
	}
	save() {
		return Promise.resolve();
	}
	startup() {
		return Promise.resolve();
	}
	getSavedSync() {
		return Promise.resolve(null);
	}
	getSavedSyncToken() {
		return Promise.resolve(null);
	}
	deleteAllData() {
		return Promise.resolve();
	}
	getOutOfBandMembers() {
		return Promise.resolve(null);
	}
	setOutOfBandMembers(e, b) {
		return Promise.resolve();
	}
	clearOutOfBandMembers() {
		return Promise.resolve();
	}
	getClientOptions() {
		return Promise.resolve(void 0);
	}
	storeClientOptions(e) {
		return Promise.resolve();
	}
	getPendingEvents(e) {
		return _asyncToGenerator(function* () {
			return [];
		})();
	}
	setPendingEvents(e, b) {
		return Promise.resolve();
	}
	saveToDeviceBatches(e) {
		return _asyncToGenerator(function* () {
			return Promise.resolve();
		})();
	}
	getOldestToDeviceBatch() {
		return Promise.resolve(null);
	}
	removeToDeviceBatch(e) {
		return _asyncToGenerator(function* () {
			return Promise.resolve();
		})();
	}
	destroy() {
		return _asyncToGenerator(function* () {})();
	}
}, byteToHex = [];
for (let e = 0; e < 256; ++e) byteToHex.push((e + 256).toString(16).slice(1));
function unsafeStringify(e, b = 0) {
	return (byteToHex[e[b + 0]] + byteToHex[e[b + 1]] + byteToHex[e[b + 2]] + byteToHex[e[b + 3]] + "-" + byteToHex[e[b + 4]] + byteToHex[e[b + 5]] + "-" + byteToHex[e[b + 6]] + byteToHex[e[b + 7]] + "-" + byteToHex[e[b + 8]] + byteToHex[e[b + 9]] + "-" + byteToHex[e[b + 10]] + byteToHex[e[b + 11]] + byteToHex[e[b + 12]] + byteToHex[e[b + 13]] + byteToHex[e[b + 14]] + byteToHex[e[b + 15]]).toLowerCase();
}
var getRandomValues, rnds8 = new Uint8Array(16);
function rng() {
	if (!getRandomValues) {
		if (typeof crypto > "u" || !crypto.getRandomValues) throw Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
		getRandomValues = crypto.getRandomValues.bind(crypto);
	}
	return getRandomValues(rnds8);
}
var native_default = { randomUUID: typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto) };
function _v4(e, b, x) {
	e ||= {};
	let S = e.random ?? e.rng?.() ?? rng();
	if (S.length < 16) throw Error("Random bytes length must be >= 16");
	if (S[6] = S[6] & 15 | 64, S[8] = S[8] & 63 | 128, b) {
		if (x ||= 0, x < 0 || x + 16 > b.length) throw RangeError(`UUID byte range ${x}:${x + 15} is out of buffer bounds`);
		for (let e = 0; e < 16; ++e) b[x + e] = S[e];
		return b;
	}
	return unsafeStringify(S);
}
function v4(e, b, x) {
	return native_default.randomUUID && !b && !e ? native_default.randomUUID() : _v4(e, b, x);
}
var v4_default = v4, require_grammar = /* @__PURE__ */ __commonJSMin(((e, b) => {
	var x = b.exports = {
		v: [{
			name: "version",
			reg: /^(\d*)$/
		}],
		o: [{
			name: "origin",
			reg: /^(\S*) (\d*) (\d*) (\S*) IP(\d) (\S*)/,
			names: [
				"username",
				"sessionId",
				"sessionVersion",
				"netType",
				"ipVer",
				"address"
			],
			format: "%s %s %d %s IP%d %s"
		}],
		s: [{ name: "name" }],
		i: [{ name: "description" }],
		u: [{ name: "uri" }],
		e: [{ name: "email" }],
		p: [{ name: "phone" }],
		z: [{ name: "timezones" }],
		r: [{ name: "repeats" }],
		t: [{
			name: "timing",
			reg: /^(\d*) (\d*)/,
			names: ["start", "stop"],
			format: "%d %d"
		}],
		c: [{
			name: "connection",
			reg: /^IN IP(\d) (\S*)/,
			names: ["version", "ip"],
			format: "IN IP%d %s"
		}],
		b: [{
			push: "bandwidth",
			reg: /^(TIAS|AS|CT|RR|RS):(\d*)/,
			names: ["type", "limit"],
			format: "%s:%s"
		}],
		m: [{
			reg: /^(\w*) (\d*) ([\w/]*)(?: (.*))?/,
			names: [
				"type",
				"port",
				"protocol",
				"payloads"
			],
			format: "%s %d %s %s"
		}],
		a: [
			{
				push: "rtp",
				reg: /^rtpmap:(\d*) ([\w\-.]*)(?:\s*\/(\d*)(?:\s*\/(\S*))?)?/,
				names: [
					"payload",
					"codec",
					"rate",
					"encoding"
				],
				format: function(e) {
					return e.encoding ? "rtpmap:%d %s/%s/%s" : e.rate ? "rtpmap:%d %s/%s" : "rtpmap:%d %s";
				}
			},
			{
				push: "fmtp",
				reg: /^fmtp:(\d*) ([\S| ]*)/,
				names: ["payload", "config"],
				format: "fmtp:%d %s"
			},
			{
				name: "control",
				reg: /^control:(.*)/,
				format: "control:%s"
			},
			{
				name: "rtcp",
				reg: /^rtcp:(\d*)(?: (\S*) IP(\d) (\S*))?/,
				names: [
					"port",
					"netType",
					"ipVer",
					"address"
				],
				format: function(e) {
					return e.address == null ? "rtcp:%d" : "rtcp:%d %s IP%d %s";
				}
			},
			{
				push: "rtcpFbTrrInt",
				reg: /^rtcp-fb:(\*|\d*) trr-int (\d*)/,
				names: ["payload", "value"],
				format: "rtcp-fb:%s trr-int %d"
			},
			{
				push: "rtcpFb",
				reg: /^rtcp-fb:(\*|\d*) ([\w-_]*)(?: ([\w-_]*))?/,
				names: [
					"payload",
					"type",
					"subtype"
				],
				format: function(e) {
					return e.subtype == null ? "rtcp-fb:%s %s" : "rtcp-fb:%s %s %s";
				}
			},
			{
				push: "ext",
				reg: /^extmap:(\d+)(?:\/(\w+))?(?: (urn:ietf:params:rtp-hdrext:encrypt))? (\S*)(?: (\S*))?/,
				names: [
					"value",
					"direction",
					"encrypt-uri",
					"uri",
					"config"
				],
				format: function(e) {
					return "extmap:%d" + (e.direction ? "/%s" : "%v") + (e["encrypt-uri"] ? " %s" : "%v") + " %s" + (e.config ? " %s" : "");
				}
			},
			{
				name: "extmapAllowMixed",
				reg: /^(extmap-allow-mixed)/
			},
			{
				push: "crypto",
				reg: /^crypto:(\d*) ([\w_]*) (\S*)(?: (\S*))?/,
				names: [
					"id",
					"suite",
					"config",
					"sessionConfig"
				],
				format: function(e) {
					return e.sessionConfig == null ? "crypto:%d %s %s" : "crypto:%d %s %s %s";
				}
			},
			{
				name: "setup",
				reg: /^setup:(\w*)/,
				format: "setup:%s"
			},
			{
				name: "connectionType",
				reg: /^connection:(new|existing)/,
				format: "connection:%s"
			},
			{
				name: "mid",
				reg: /^mid:([^\s]*)/,
				format: "mid:%s"
			},
			{
				push: "msid",
				reg: /^msid:([\w-]+)(?: ([\w-]+))?/,
				names: ["id", "appdata"],
				format: "msid:%s %s"
			},
			{
				name: "ptime",
				reg: /^ptime:(\d*(?:\.\d*)*)/,
				format: "ptime:%d"
			},
			{
				name: "maxptime",
				reg: /^maxptime:(\d*(?:\.\d*)*)/,
				format: "maxptime:%d"
			},
			{
				name: "direction",
				reg: /^(sendrecv|recvonly|sendonly|inactive)/
			},
			{
				name: "icelite",
				reg: /^(ice-lite)/
			},
			{
				name: "iceUfrag",
				reg: /^ice-ufrag:(\S*)/,
				format: "ice-ufrag:%s"
			},
			{
				name: "icePwd",
				reg: /^ice-pwd:(\S*)/,
				format: "ice-pwd:%s"
			},
			{
				name: "fingerprint",
				reg: /^fingerprint:(\S*) (\S*)/,
				names: ["type", "hash"],
				format: "fingerprint:%s %s"
			},
			{
				push: "candidates",
				reg: /^candidate:(\S*) (\d*) (\S*) (\d*) (\S*) (\d*) typ (\S*)(?: raddr (\S*) rport (\d*))?(?: tcptype (\S*))?(?: generation (\d*))?(?: network-id (\d*))?(?: network-cost (\d*))?/,
				names: [
					"foundation",
					"component",
					"transport",
					"priority",
					"ip",
					"port",
					"type",
					"raddr",
					"rport",
					"tcptype",
					"generation",
					"network-id",
					"network-cost"
				],
				format: function(e) {
					var b = "candidate:%s %d %s %d %s %d typ %s";
					return b += e.raddr == null ? "%v%v" : " raddr %s rport %d", b += e.tcptype == null ? "%v" : " tcptype %s", e.generation != null && (b += " generation %d"), b += e["network-id"] == null ? "%v" : " network-id %d", b += e["network-cost"] == null ? "%v" : " network-cost %d", b;
				}
			},
			{
				name: "endOfCandidates",
				reg: /^(end-of-candidates)/
			},
			{
				name: "remoteCandidates",
				reg: /^remote-candidates:(.*)/,
				format: "remote-candidates:%s"
			},
			{
				name: "iceOptions",
				reg: /^ice-options:(\S*)/,
				format: "ice-options:%s"
			},
			{
				push: "ssrcs",
				reg: /^ssrc:(\d*) ([\w_-]*)(?::(.*))?/,
				names: [
					"id",
					"attribute",
					"value"
				],
				format: function(e) {
					var b = "ssrc:%d";
					return e.attribute != null && (b += " %s", e.value != null && (b += ":%s")), b;
				}
			},
			{
				push: "ssrcGroups",
				reg: /^ssrc-group:([\x21\x23\x24\x25\x26\x27\x2A\x2B\x2D\x2E\w]*) (.*)/,
				names: ["semantics", "ssrcs"],
				format: "ssrc-group:%s %s"
			},
			{
				name: "msidSemantic",
				reg: /^msid-semantic:\s?(\w*) (\S*)/,
				names: ["semantic", "token"],
				format: "msid-semantic: %s %s"
			},
			{
				push: "groups",
				reg: /^group:(\w*) (.*)/,
				names: ["type", "mids"],
				format: "group:%s %s"
			},
			{
				name: "rtcpMux",
				reg: /^(rtcp-mux)/
			},
			{
				name: "rtcpRsize",
				reg: /^(rtcp-rsize)/
			},
			{
				name: "sctpmap",
				reg: /^sctpmap:([\w_/]*) (\S*)(?: (\S*))?/,
				names: [
					"sctpmapNumber",
					"app",
					"maxMessageSize"
				],
				format: function(e) {
					return e.maxMessageSize == null ? "sctpmap:%s %s" : "sctpmap:%s %s %s";
				}
			},
			{
				name: "xGoogleFlag",
				reg: /^x-google-flag:([^\s]*)/,
				format: "x-google-flag:%s"
			},
			{
				push: "rids",
				reg: /^rid:([\d\w]+) (\w+)(?: ([\S| ]*))?/,
				names: [
					"id",
					"direction",
					"params"
				],
				format: function(e) {
					return e.params ? "rid:%s %s %s" : "rid:%s %s";
				}
			},
			{
				push: "imageattrs",
				reg: /* @__PURE__ */ RegExp("^imageattr:(\\d+|\\*)[\\s\\t]+(send|recv)[\\s\\t]+(\\*|\\[\\S+\\](?:[\\s\\t]+\\[\\S+\\])*)(?:[\\s\\t]+(recv|send)[\\s\\t]+(\\*|\\[\\S+\\](?:[\\s\\t]+\\[\\S+\\])*))?"),
				names: [
					"pt",
					"dir1",
					"attrs1",
					"dir2",
					"attrs2"
				],
				format: function(e) {
					return "imageattr:%s %s %s" + (e.dir2 ? " %s %s" : "");
				}
			},
			{
				name: "simulcast",
				reg: /* @__PURE__ */ RegExp("^simulcast:(send|recv) ([a-zA-Z0-9\\-_~;,]+)(?:\\s?(send|recv) ([a-zA-Z0-9\\-_~;,]+))?$"),
				names: [
					"dir1",
					"list1",
					"dir2",
					"list2"
				],
				format: function(e) {
					return "simulcast:%s %s" + (e.dir2 ? " %s %s" : "");
				}
			},
			{
				name: "simulcast_03",
				reg: /^simulcast:[\s\t]+([\S+\s\t]+)$/,
				names: ["value"],
				format: "simulcast: %s"
			},
			{
				name: "framerate",
				reg: /^framerate:(\d+(?:$|\.\d+))/,
				format: "framerate:%s"
			},
			{
				name: "sourceFilter",
				reg: /^source-filter: *(excl|incl) (\S*) (IP4|IP6|\*) (\S*) (.*)/,
				names: [
					"filterMode",
					"netType",
					"addressTypes",
					"destAddress",
					"srcList"
				],
				format: "source-filter: %s %s %s %s %s"
			},
			{
				name: "bundleOnly",
				reg: /^(bundle-only)/
			},
			{
				name: "label",
				reg: /^label:(.+)/,
				format: "label:%s"
			},
			{
				name: "sctpPort",
				reg: /^sctp-port:(\d+)$/,
				format: "sctp-port:%s"
			},
			{
				name: "maxMessageSize",
				reg: /^max-message-size:(\d+)$/,
				format: "max-message-size:%s"
			},
			{
				push: "tsRefClocks",
				reg: /^ts-refclk:([^\s=]*)(?:=(\S*))?/,
				names: ["clksrc", "clksrcExt"],
				format: function(e) {
					return "ts-refclk:%s" + (e.clksrcExt == null ? "" : "=%s");
				}
			},
			{
				name: "mediaClk",
				reg: /^mediaclk:(?:id=(\S*))? *([^\s=]*)(?:=(\S*))?(?: *rate=(\d+)\/(\d+))?/,
				names: [
					"id",
					"mediaClockName",
					"mediaClockValue",
					"rateNumerator",
					"rateDenominator"
				],
				format: function(e) {
					var b = "mediaclk:";
					return b += e.id == null ? "%v%s" : "id=%s %s", b += e.mediaClockValue == null ? "" : "=%s", b += e.rateNumerator == null ? "" : " rate=%s", b += e.rateDenominator == null ? "" : "/%s", b;
				}
			},
			{
				name: "keywords",
				reg: /^keywds:(.+)$/,
				format: "keywds:%s"
			},
			{
				name: "content",
				reg: /^content:(.+)/,
				format: "content:%s"
			},
			{
				name: "bfcpFloorCtrl",
				reg: /^floorctrl:(c-only|s-only|c-s)/,
				format: "floorctrl:%s"
			},
			{
				name: "bfcpConfId",
				reg: /^confid:(\d+)/,
				format: "confid:%s"
			},
			{
				name: "bfcpUserId",
				reg: /^userid:(\d+)/,
				format: "userid:%s"
			},
			{
				name: "bfcpFloorId",
				reg: /^floorid:(.+) (?:m-stream|mstrm):(.+)/,
				names: ["id", "mStream"],
				format: "floorid:%s mstrm:%s"
			},
			{
				push: "invalid",
				names: ["value"]
			}
		]
	};
	Object.keys(x).forEach(function(e) {
		x[e].forEach(function(e) {
			e.reg ||= /(.*)/, e.format ||= "%s";
		});
	});
})), require_parser = /* @__PURE__ */ __commonJSMin(((e) => {
	var b = function(e) {
		return String(Number(e)) === e ? Number(e) : e;
	}, x = function(e, x, S, C) {
		if (C && !S) x[C] = b(e[1]);
		else for (var w = 0; w < S.length; w += 1) e[w + 1] != null && (x[S[w]] = b(e[w + 1]));
	}, S = function(e, b, S) {
		var C = e.name && e.names;
		e.push && !b[e.push] ? b[e.push] = [] : C && !b[e.name] && (b[e.name] = {});
		var w = e.push ? {} : C ? b[e.name] : b;
		x(S.match(e.reg), w, e.names, e.name), e.push && b[e.push].push(w);
	}, C = require_grammar(), w = RegExp.prototype.test.bind(/^([a-z])=(.*)/);
	e.parse = function(e) {
		var b = {}, x = [], T = b;
		return e.split(/(\r\n|\r|\n)/).filter(w).forEach(function(e) {
			var b = e[0], w = e.slice(2);
			b === "m" && (x.push({
				rtp: [],
				fmtp: []
			}), T = x[x.length - 1]);
			for (var E = 0; E < (C[b] || []).length; E += 1) {
				var D = C[b][E];
				if (D.reg.test(w)) return S(D, T, w);
			}
		}), b.media = x, b;
	};
	var T = function(e, x) {
		var S = x.split(/=(.+)/, 2);
		return S.length === 2 ? e[S[0]] = b(S[1]) : S.length === 1 && x.length > 1 && (e[S[0]] = void 0), e;
	};
	e.parseParams = function(e) {
		return e.split(/;\s?/).reduce(T, {});
	}, e.parseFmtpConfig = e.parseParams, e.parsePayloads = function(e) {
		return e.toString().split(" ").map(Number);
	}, e.parseRemoteCandidates = function(e) {
		for (var x = [], S = e.split(" ").map(b), C = 0; C < S.length; C += 3) x.push({
			component: S[C],
			ip: S[C + 1],
			port: S[C + 2]
		});
		return x;
	}, e.parseImageAttributes = function(e) {
		return e.split(" ").map(function(e) {
			return e.substring(1, e.length - 1).split(",").reduce(T, {});
		});
	}, e.parseSimulcastStreamList = function(e) {
		return e.split(";").map(function(e) {
			return e.split(",").map(function(e) {
				var x, S = !1;
				return e[0] === "~" ? (x = b(e.substring(1, e.length)), S = !0) : x = b(e), {
					scid: x,
					paused: S
				};
			});
		});
	};
})), require_writer = /* @__PURE__ */ __commonJSMin(((e, b) => {
	var x = require_grammar(), S = /%[sdv%]/g, C = function(e) {
		var b = 1, x = arguments, C = x.length;
		return e.replace(S, function(e) {
			if (b >= C) return e;
			var S = x[b];
			switch (b += 1, e) {
				case "%%": return "%";
				case "%s": return String(S);
				case "%d": return Number(S);
				case "%v": return "";
			}
		});
	}, w = function(e, b, x) {
		var S = b.format instanceof Function ? b.format(b.push ? x : x[b.name]) : b.format, w = [e + "=" + S];
		if (b.names) for (var T = 0; T < b.names.length; T += 1) {
			var E = b.names[T];
			b.name ? w.push(x[b.name][E]) : w.push(x[b.names[T]]);
		}
		else w.push(x[b.name]);
		return C.apply(null, w);
	}, T = [
		"v",
		"o",
		"s",
		"i",
		"u",
		"e",
		"p",
		"c",
		"b",
		"t",
		"r",
		"z",
		"a"
	], E = [
		"i",
		"c",
		"b",
		"a"
	];
	b.exports = function(e, b) {
		b ||= {}, e.version ??= 0, e.name ??= " ", e.media.forEach(function(e) {
			e.payloads ??= "";
		});
		var S = b.outerOrder || T, C = b.innerOrder || E, D = [];
		return S.forEach(function(b) {
			x[b].forEach(function(x) {
				x.name in e && e[x.name] != null ? D.push(w(b, x, e)) : x.push in e && e[x.push] != null && e[x.push].forEach(function(e) {
					D.push(w(b, x, e));
				});
			});
		}), e.media.forEach(function(e) {
			D.push(w("m", x.m[0], e)), C.forEach(function(b) {
				x[b].forEach(function(x) {
					x.name in e && e[x.name] != null ? D.push(w(b, x, e)) : x.push in e && e[x.push] != null && e[x.push].forEach(function(e) {
						D.push(w(b, x, e));
					});
				});
			});
		}), D.join("\r\n") + "\r\n";
	};
})), require_lib = /* @__PURE__ */ __commonJSMin(((e) => {
	var b = require_parser(), x = require_writer();
	require_grammar(), e.write = x, e.parse = b.parse, e.parseParams = b.parseParams, e.parseFmtpConfig = b.parseFmtpConfig, e.parsePayloads = b.parsePayloads, e.parseRemoteCandidates = b.parseRemoteCandidates, e.parseImageAttributes = b.parseImageAttributes, e.parseSimulcastStreamList = b.parseSimulcastStreamList;
}));
function toBase64$1(e, b) {
	if (typeof e.toBase64 == "function") return e.toBase64(b);
	var x = btoa(e.reduce((e, b) => e + String.fromCharCode(b), ""));
	return b.omitPadding && (x = x.replace(/={1,2}$/, "")), b.alphabet === "base64url" && (x = x.replace(/\+/g, "-").replace(/\//g, "_")), x;
}
function encodeBase64(e) {
	return toBase64$1(e, {
		alphabet: "base64",
		omitPadding: !1
	});
}
function encodeUnpaddedBase64(e) {
	return toBase64$1(e, {
		alphabet: "base64",
		omitPadding: !0
	});
}
function encodeUnpaddedBase64Url(e) {
	return toBase64$1(e, {
		alphabet: "base64url",
		omitPadding: !0
	});
}
function fromBase64(e, b) {
	return typeof Uint8Array.fromBase64 == "function" ? Uint8Array.fromBase64(e, b) : Uint8Array.from(atob(e), (e) => e.charCodeAt(0));
}
function decodeBase64(e) {
	return fromBase64(e.replace(/-/g, "+").replace(/_/g, "/"), {
		alphabet: "base64",
		lastChunkHandling: "loose"
	});
}
var LOWERCASE = "abcdefghijklmnopqrstuvwxyz", UPPERCASE = "ABCDEFGHIJKLMNOPQRSTUVWXYZ", DIGITS = "0123456789";
function secureRandomBase64Url(e) {
	var b = new Uint8Array(e);
	return globalThis.crypto.getRandomValues(b), encodeUnpaddedBase64Url(b);
}
function secureRandomString(e) {
	return secureRandomStringFrom(e, UPPERCASE + LOWERCASE + DIGITS);
}
function secureRandomStringFrom(e, b) {
	if (b.length < 2 || b.length > 256) throw Error("Character set must be between 2 and 256 characters long");
	if (e < 1 || e > 32768) throw Error("Requested random string length must be between 1 and 32768");
	for (var x = 256 - 256 % b.length, S = new Uint8Array(Math.floor(e * 1.3)), C = S.length, w = []; w.length < e;) {
		C === S.length && (globalThis.crypto.getRandomValues(S), C = 0);
		var T = S[C++];
		T < x && w.push(b[T % b.length]);
	}
	return w.join("");
}
var SDPStreamMetadataKey = "org.matrix.msc3077.sdp_stream_metadata", SDPStreamMetadataPurpose = /* @__PURE__ */ function(e) {
	return e.Usermedia = "m.usermedia", e.Screenshare = "m.screenshare", e;
}({}), audioContext = null, refCount = 0, acquireContext = () => (audioContext === null && (audioContext = new AudioContext()), refCount++, audioContext), releaseContext = () => {
	if (refCount--, refCount === 0) {
		var e;
		(e = audioContext) == null || e.close(), audioContext = null;
	}
}, POLLING_INTERVAL = 200, SPEAKING_SAMPLE_COUNT = 8, CallFeedEvent = /* @__PURE__ */ function(e) {
	return e.NewStream = "new_stream", e.MuteStateChanged = "mute_state_changed", e.LocalVolumeChanged = "local_volume_changed", e.VolumeChanged = "volume_changed", e.ConnectedChanged = "connected_changed", e.Speaking = "speaking", e.Disposed = "disposed", e;
}({}), CallFeed = class e extends TypedEventEmitter {
	constructor(e) {
		super(), _defineProperty(this, "stream", void 0), _defineProperty(this, "sdpMetadataStreamId", void 0), _defineProperty(this, "userId", void 0), _defineProperty(this, "deviceId", void 0), _defineProperty(this, "purpose", void 0), _defineProperty(this, "speakingVolumeSamples", void 0), _defineProperty(this, "client", void 0), _defineProperty(this, "call", void 0), _defineProperty(this, "roomId", void 0), _defineProperty(this, "audioMuted", void 0), _defineProperty(this, "videoMuted", void 0), _defineProperty(this, "localVolume", 1), _defineProperty(this, "measuringVolumeActivity", !1), _defineProperty(this, "audioContext", void 0), _defineProperty(this, "analyser", void 0), _defineProperty(this, "frequencyBinCount", void 0), _defineProperty(this, "speakingThreshold", -60), _defineProperty(this, "speaking", !1), _defineProperty(this, "volumeLooperTimeout", void 0), _defineProperty(this, "_disposed", !1), _defineProperty(this, "_connected", !1), _defineProperty(this, "onAddTrack", () => {
			this.emit(CallFeedEvent.NewStream, this.stream);
		}), _defineProperty(this, "onCallState", (e) => {
			e === CallState.Connected ? this.connected = !0 : e === CallState.Connecting && (this.connected = !1);
		}), _defineProperty(this, "volumeLooper", () => {
			if (this.analyser && this.measuringVolumeActivity) {
				this.analyser.getFloatFrequencyData(this.frequencyBinCount);
				var e = -Infinity;
				for (var b of this.frequencyBinCount) b > e && (e = b);
				this.speakingVolumeSamples.shift(), this.speakingVolumeSamples.push(e), this.emit(CallFeedEvent.VolumeChanged, e);
				var x = !1;
				for (var S of this.speakingVolumeSamples) if (S > this.speakingThreshold) {
					x = !0;
					break;
				}
				this.speaking !== x && (this.speaking = x, this.emit(CallFeedEvent.Speaking, this.speaking)), this.volumeLooperTimeout = setTimeout(this.volumeLooper, POLLING_INTERVAL);
			}
		}), this.client = e.client, this.call = e.call, this.roomId = e.roomId, this.userId = e.userId, this.deviceId = e.deviceId, this.purpose = e.purpose, this.audioMuted = e.audioMuted, this.videoMuted = e.videoMuted, this.speakingVolumeSamples = Array(SPEAKING_SAMPLE_COUNT).fill(-Infinity), this.sdpMetadataStreamId = e.stream.id, this.updateStream(null, e.stream), this.stream = e.stream, this.hasAudioTrack && this.initVolumeMeasuring(), e.call && (e.call.addListener(CallEvent.State, this.onCallState), this.onCallState(e.call.state));
	}
	get connected() {
		return this.isLocal() || this._connected;
	}
	set connected(e) {
		this._connected = e, this.emit(CallFeedEvent.ConnectedChanged, this.connected);
	}
	get hasAudioTrack() {
		return this.stream.getAudioTracks().length > 0;
	}
	updateStream(e, b) {
		if (b !== e) {
			var x = this.measuringVolumeActivity;
			e && (e.removeEventListener("addtrack", this.onAddTrack), this.measureVolumeActivity(!1)), this.stream = b, b.addEventListener("addtrack", this.onAddTrack), this.hasAudioTrack ? (this.initVolumeMeasuring(), x && this.measureVolumeActivity(!0)) : this.measureVolumeActivity(!1), this.emit(CallFeedEvent.NewStream, this.stream);
		}
	}
	initVolumeMeasuring() {
		this.hasAudioTrack && (this.audioContext ||= acquireContext(), this.analyser = this.audioContext.createAnalyser(), this.analyser.fftSize = 512, this.analyser.smoothingTimeConstant = .1, this.audioContext.createMediaStreamSource(this.stream).connect(this.analyser), this.frequencyBinCount = new Float32Array(this.analyser.frequencyBinCount));
	}
	getMember() {
		return this.client.getRoom(this.roomId)?.getMember(this.userId) ?? null;
	}
	isLocal() {
		return this.userId === this.client.getUserId() && (this.deviceId === void 0 || this.deviceId === this.client.getDeviceId());
	}
	isAudioMuted() {
		return this.stream.getAudioTracks().length === 0 || this.audioMuted;
	}
	isVideoMuted() {
		return this.stream.getVideoTracks().length === 0 || this.videoMuted;
	}
	isSpeaking() {
		return this.speaking;
	}
	setNewStream(e) {
		this.updateStream(this.stream, e);
	}
	setAudioVideoMuted(e, b) {
		e !== null && (this.audioMuted !== e && this.speakingVolumeSamples.fill(-Infinity), this.audioMuted = e), b !== null && (this.videoMuted = b), this.emit(CallFeedEvent.MuteStateChanged, this.audioMuted, this.videoMuted);
	}
	measureVolumeActivity(e) {
		if (e) {
			if (!this.analyser || !this.frequencyBinCount || !this.hasAudioTrack) return;
			this.measuringVolumeActivity = !0, this.volumeLooper();
		} else this.measuringVolumeActivity = !1, this.speakingVolumeSamples.fill(-Infinity), this.emit(CallFeedEvent.VolumeChanged, -Infinity);
	}
	setSpeakingThreshold(e) {
		this.speakingThreshold = e;
	}
	clone() {
		var b = this.client.getMediaHandler(), x = this.stream.clone();
		return logger.log(`CallFeed clone() cloning stream (originalStreamId=${this.stream.id}, newStreamId${x.id})`), this.purpose === SDPStreamMetadataPurpose.Usermedia ? b.userMediaStreams.push(x) : b.screensharingStreams.push(x), new e({
			client: this.client,
			roomId: this.roomId,
			userId: this.userId,
			deviceId: this.deviceId,
			stream: x,
			purpose: this.purpose,
			audioMuted: this.audioMuted,
			videoMuted: this.videoMuted
		});
	}
	dispose() {
		var e, b;
		clearTimeout(this.volumeLooperTimeout), (e = this.stream) == null || e.removeEventListener("addtrack", this.onAddTrack), (b = this.call) == null || b.removeListener(CallEvent.State, this.onCallState), this.audioContext && (this.audioContext = void 0, this.analyser = void 0, releaseContext()), this._disposed = !0, this.emit(CallFeedEvent.Disposed);
	}
	get disposed() {
		return this._disposed;
	}
	set disposed(e) {
		this._disposed = e;
	}
	getLocalVolume() {
		return this.localVolume;
	}
	setLocalVolume(e) {
		this.localVolume = e, this.emit(CallFeedEvent.LocalVolumeChanged, e);
	}
}, RING_GRACE_PERIOD = 3e3, CallEventHandlerEvent = /* @__PURE__ */ function(e) {
	return e.Incoming = "Call.incoming", e;
}({}), CallEventHandler = class {
	constructor(e) {
		_defineProperty(this, "calls", void 0), _defineProperty(this, "callEventBuffer", void 0), _defineProperty(this, "nextSeqByCall", /* @__PURE__ */ new Map()), _defineProperty(this, "toDeviceEventBuffers", /* @__PURE__ */ new Map()), _defineProperty(this, "client", void 0), _defineProperty(this, "candidateEventsByCall", void 0), _defineProperty(this, "eventBufferPromiseChain", void 0), _defineProperty(this, "onSync", () => {
			var e = this.callEventBuffer;
			this.callEventBuffer = [], this.eventBufferPromiseChain ? this.eventBufferPromiseChain = this.eventBufferPromiseChain.then(() => this.evaluateEventBuffer(e)) : this.eventBufferPromiseChain = this.evaluateEventBuffer(e);
		}), _defineProperty(this, "onRoomTimeline", (e) => {
			this.callEventBuffer.push(e);
		}), _defineProperty(this, "onToDeviceEvent", (e) => {
			var b = e.getContent();
			if (!b.call_id) {
				this.callEventBuffer.push(e);
				return;
			}
			if (this.nextSeqByCall.has(b.call_id) || this.nextSeqByCall.set(b.call_id, 0), b.seq === void 0) {
				this.callEventBuffer.push(e);
				return;
			}
			var x = this.nextSeqByCall.get(b.call_id) || 0;
			if (b.seq !== x) {
				this.toDeviceEventBuffers.has(b.call_id) || this.toDeviceEventBuffers.set(b.call_id, []);
				var S = this.toDeviceEventBuffers.get(b.call_id), C = S.findIndex((e) => e.getContent().seq > b.seq);
				C === -1 ? S.push(e) : S.splice(C, 0, e);
			} else {
				var w = b.call_id;
				this.callEventBuffer.push(e), this.nextSeqByCall.set(w, b.seq + 1);
				for (var T = this.toDeviceEventBuffers.get(w), E = T && T.shift(); E && E.getContent().seq === this.nextSeqByCall.get(w);) this.callEventBuffer.push(E), this.nextSeqByCall.set(w, E.getContent().seq + 1), E = T.shift();
			}
		}), this.client = e, this.calls = /* @__PURE__ */ new Map(), this.callEventBuffer = [], this.candidateEventsByCall = /* @__PURE__ */ new Map();
	}
	start() {
		this.client.on(ClientEvent.Sync, this.onSync), this.client.on(RoomEvent.Timeline, this.onRoomTimeline), this.client.on(ClientEvent.ToDeviceEvent, this.onToDeviceEvent);
	}
	stop() {
		this.client.removeListener(ClientEvent.Sync, this.onSync), this.client.removeListener(RoomEvent.Timeline, this.onRoomTimeline), this.client.removeListener(ClientEvent.ToDeviceEvent, this.onToDeviceEvent);
	}
	evaluateEventBuffer(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			yield Promise.all(e.map((e) => b.client.decryptEventIfNeeded(e)));
			var x = e.filter((e) => {
				var b = e.getType();
				return b.startsWith("m.call.") || b.startsWith("org.matrix.call.");
			}), S = /* @__PURE__ */ new Set();
			for (var C of x) {
				var w = C.getType();
				(w === EventType.CallAnswer || w === EventType.CallHangup) && S.add(C.getContent().call_id);
			}
			for (var T of x) {
				var E = T.getType(), D = T.getContent().call_id;
				if (!(E === EventType.CallInvite && S.has(D))) try {
					yield b.handleCallEvent(T);
				} catch (e) {
					logger.error("CallEventHandler evaluateEventBuffer() caught exception handling call event", e);
				}
			}
		})();
	}
	handleCallEvent(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			var x;
			b.client.emit(ClientEvent.ReceivedVoipEvent, e);
			var S = e.getContent(), C = e.getRoomId() || ((x = b.client.groupCallEventHandler.getGroupCallById(S.conf_id)) == null || (x = x.room) == null ? void 0 : x.roomId), w = S.conf_id, T = e.getType(), E = e.getSender(), D = S.call_id ? b.calls.get(S.call_id) : void 0, O, k;
			if (w) {
				if (k = b.client.groupCallEventHandler.getGroupCallById(w), !k) {
					logger.warn(`CallEventHandler handleCallEvent() could not find a group call - ignoring event (groupCallId=${w}, type=${T})`);
					return;
				}
				if (O = S.device_id, !O) {
					logger.warn(`CallEventHandler handleCallEvent() could not find a device id - ignoring event (senderId=${E})`), k.emit(GroupCallEvent.Error, new GroupCallUnknownDeviceError(E));
					return;
				}
				if (S.dest_session_id !== b.client.getSessionId()) {
					logger.warn("CallEventHandler handleCallEvent() call event does not match current session id - ignoring");
					return;
				}
			}
			var A = E === b.client.credentials.userId && (O === void 0 || O === b.client.getDeviceId());
			if (C) {
				if (T === EventType.CallInvite) {
					if (A || e.getLocalAge() > S.lifetime - RING_GRACE_PERIOD || D && D.state === CallState.Ended || (D && logger.warn(`CallEventHandler handleCallEvent() already has a call but got an invite - clobbering (callId=${S.call_id})`), S.invitee && S.invitee !== b.client.getUserId())) return;
					var j = (b.client.getTurnServersExpiry() ?? 0) - Date.now();
					if (logger.info("CallEventHandler handleCallEvent() current turn creds expire in " + j + " ms"), D = createNewMatrixCall(b.client, C, {
						forceTURN: b.client.forceTURN,
						opponentDeviceId: O,
						groupCallId: w,
						opponentSessionId: S.sender_session_id
					}) ?? void 0, !D) {
						logger.log(`CallEventHandler handleCallEvent() this client does not support WebRTC (callId=${S.call_id})`);
						return;
					}
					D.callId = S.call_id;
					var M = k?.getGroupCallStats();
					M && D.initStats(M);
					try {
						yield D.initWithInvite(e);
					} catch (e) {
						if (e instanceof CallError) if (e.code === GroupCallErrorCode.UnknownDevice) {
							var N;
							(N = k) == null || N.emit(GroupCallEvent.Error, e);
						} else logger.error(e);
					}
					if (b.calls.set(D.callId, D), b.candidateEventsByCall.get(D.callId)) for (var P of b.candidateEventsByCall.get(D.callId)) D.onRemoteIceCandidatesReceived(P);
					var F;
					for (var I of b.calls.values()) {
						var L = [
							CallState.WaitLocalMedia,
							CallState.CreateOffer,
							CallState.InviteSent
						].includes(I.state);
						if (D.roomId === I.roomId && I.direction === CallDirection.Outbound && D.getOpponentMember()?.userId === I.invitee && L) {
							F = I;
							break;
						}
					}
					F ? F.callId > D.callId ? (logger.log(`CallEventHandler handleCallEvent() detected glare - answering incoming call and canceling outgoing call (incomingId=${D.callId}, outgoingId=${F.callId})`), F.replacedBy(D)) : (logger.log(`CallEventHandler handleCallEvent() detected glare - hanging up incoming call (incomingId=${D.callId}, outgoingId=${F.callId})`), D.hangup(CallErrorCode.Replaced, !0)) : b.client.emit(CallEventHandlerEvent.Incoming, D);
					return;
				} else if (T === EventType.CallCandidates) {
					if (A) return;
					D ? D.onRemoteIceCandidatesReceived(e) : (b.candidateEventsByCall.has(S.call_id) || b.candidateEventsByCall.set(S.call_id, []), b.candidateEventsByCall.get(S.call_id).push(e));
					return;
				} else if ([EventType.CallHangup, EventType.CallReject].includes(T)) {
					D ? D.state !== CallState.Ended && (T === EventType.CallHangup ? D.onHangupReceived(S) : D.onRejectReceived(S), D.state === CallState.Ended && b.calls.delete(S.call_id)) : (D = createNewMatrixCall(b.client, C, {
						opponentDeviceId: O,
						opponentSessionId: S.sender_session_id
					}) ?? void 0, D && (D.callId = S.call_id, D.initWithHangup(e), b.calls.set(S.call_id, D)));
					return;
				}
				if (!D || !D.hasPeerConnection) {
					logger.info(`CallEventHandler handleCallEvent() discarding possible call event as we don't have a call (type=${T})`);
					return;
				}
				if (e.getContent().party_id !== D.ourPartyId) switch (T) {
					case EventType.CallAnswer:
						A ? D.state === CallState.Ringing && D.onAnsweredElsewhere(S) : D.onAnswerReceived(e);
						break;
					case EventType.CallSelectAnswer:
						D.onSelectAnswerReceived(e);
						break;
					case EventType.CallNegotiate:
						D.onNegotiateReceived(e);
						break;
					case EventType.CallAssertedIdentity:
					case EventType.CallAssertedIdentityPrefix:
						D.onAssertedIdentityReceived(e);
						break;
					case EventType.CallSDPStreamMetadataChanged:
					case EventType.CallSDPStreamMetadataChangedPrefix:
						D.onSDPStreamMetadataChangedReceived(e);
						break;
				}
			}
		})();
	}
}, GroupCallEventHandlerEvent = /* @__PURE__ */ function(e) {
	return e.Incoming = "GroupCall.incoming", e.Outgoing = "GroupCall.outgoing", e.Ended = "GroupCall.ended", e.Participants = "GroupCall.participants", e;
}({}), GroupCallEventHandler = class {
	constructor(e) {
		this.client = e, _defineProperty(this, "groupCalls", /* @__PURE__ */ new Map()), _defineProperty(this, "roomDeferreds", /* @__PURE__ */ new Map()), _defineProperty(this, "onRoomsChanged", (e) => {
			this.createGroupCallForRoom(e);
		}), _defineProperty(this, "onRoomStateChanged", (e, b) => {
			if (e.getType() === EventType.GroupCallPrefix) {
				var x = e.getStateKey(), S = e.getContent(), C = this.groupCalls.get(b.roomId);
				!C && !S["m.terminated"] && !e.isRedacted() ? this.createGroupCallFromRoomStateEvent(e) : C && C.groupCallId === x ? S["m.terminated"] || e.isRedacted() ? C.terminate(!1) : S["m.type"] !== C.type && logger.warn(`GroupCallEventHandler onRoomStateChanged() currently does not support changing type (roomId=${b.roomId})`) : C && C.groupCallId !== x && logger.warn(`GroupCallEventHandler onRoomStateChanged() currently does not support multiple calls (roomId=${b.roomId})`);
			}
		});
	}
	start() {
		var e = this;
		return _asyncToGenerator(function* () {
			e.client.getSyncState() !== SyncState.Syncing && (logger.debug("GroupCallEventHandler start() waiting for client to start syncing"), yield new Promise((b) => {
				var x = () => {
					if (e.client.getSyncState() === SyncState.Syncing) return e.client.off(ClientEvent.Sync, x), b();
				};
				e.client.on(ClientEvent.Sync, x);
			}));
			for (var b of e.client.getRooms()) e.createGroupCallForRoom(b);
			e.client.on(ClientEvent.Room, e.onRoomsChanged), e.client.on(RoomStateEvent.Events, e.onRoomStateChanged);
		})();
	}
	stop() {
		this.client.removeListener(ClientEvent.Room, this.onRoomsChanged), this.client.removeListener(RoomStateEvent.Events, this.onRoomStateChanged);
	}
	getRoomDeferred(e) {
		var b = this.roomDeferreds.get(e);
		if (b === void 0) {
			var x;
			b = { prom: new Promise((e) => {
				x = e;
			}) }, b.resolve = x, this.roomDeferreds.set(e, b);
		}
		return b;
	}
	waitUntilRoomReadyForGroupCalls(e) {
		return this.getRoomDeferred(e).prom;
	}
	getGroupCallById(e) {
		return [...this.groupCalls.values()].find((b) => b.groupCallId === e);
	}
	createGroupCallForRoom(e) {
		var b = e.currentState.getStateEvents(EventType.GroupCallPrefix);
		for (var x of b.sort((e, b) => b.getTs() - e.getTs())) if (!(x.getContent()["m.terminated"] || x.isRedacted())) {
			logger.debug(`GroupCallEventHandler createGroupCallForRoom() choosing group call from possible calls (stateKey=${x.getStateKey()}, ts=${x.getTs()}, roomId=${e.roomId}, numOfPossibleCalls=${b.length})`), this.createGroupCallFromRoomStateEvent(x);
			break;
		}
		this.getRoomDeferred(e.roomId).resolve();
	}
	createGroupCallFromRoomStateEvent(e) {
		var b = e.getRoomId(), x = e.getContent(), S = this.client.getRoom(b);
		if (!S) {
			logger.warn(`GroupCallEventHandler createGroupCallFromRoomStateEvent() couldn't find room for call (roomId=${b})`);
			return;
		}
		var C = e.getStateKey(), w = x["m.type"];
		if (!Object.values(GroupCallType).includes(w)) {
			logger.warn(`GroupCallEventHandler createGroupCallFromRoomStateEvent() received invalid call type (type=${w}, roomId=${b})`);
			return;
		}
		var T = x["m.intent"];
		if (!Object.values(GroupCallIntent).includes(T)) {
			logger.warn(`Received invalid group call intent (type=${w}, roomId=${b})`);
			return;
		}
		var E = !!x["io.element.ptt"], D;
		if (x != null && x.dataChannelsEnabled && x != null && x.dataChannelOptions) {
			var { ordered: O, maxPacketLifeTime: k, maxRetransmits: A, protocol: j } = x.dataChannelOptions;
			D = {
				ordered: O,
				maxPacketLifeTime: k,
				maxRetransmits: A,
				protocol: j
			};
		}
		var M = new GroupCall(this.client, S, w, E, T, C, x?.dataChannelsEnabled || this.client.isVoipWithNoMediaAllowed, D, this.client.isVoipWithNoMediaAllowed, this.client.useLivekitForGroupCalls, x["io.element.livekit_service_url"]);
		return this.groupCalls.set(S.roomId, M), this.client.emit(GroupCallEventHandlerEvent.Incoming, M), M;
	}
}, ConnectionStats = class {
	constructor() {
		_defineProperty(this, "bandwidth", {}), _defineProperty(this, "bitrate", {}), _defineProperty(this, "packetLoss", {}), _defineProperty(this, "transport", []);
	}
}, ConnectionStatsBuilder = class {
	static buildBandwidthReport(e) {
		var b = e.availableIncomingBitrate, x = e.availableOutgoingBitrate;
		return {
			download: b ? Math.round(b / 1e3) : 0,
			upload: x ? Math.round(x / 1e3) : 0
		};
	}
}, TransportStatsBuilder = class {
	static buildReport(e, b, x, S) {
		var C = e?.get(b.localCandidateId), w = e?.get(b.remoteCandidateId);
		if (w && C) {
			var T = w.ip === void 0 ? w.address : w.ip, E = w.port, D = `${T}:${E}`, O = C.ip === void 0 ? C.address : C.ip, k = C.port, A = `${O}:${k}`, j = w.protocol;
			x.some((e) => e.ip === D && e.type === j && e.localIp === A) || x.push({
				ip: D,
				type: j,
				localIp: A,
				isFocus: S,
				localCandidateType: C.candidateType,
				remoteCandidateType: w.candidateType,
				networkType: C.networkType,
				rtt: b.currentRoundTripTime ? b.currentRoundTripTime * 1e3 : NaN
			});
		}
		return x;
	}
}, import_lib$3 = /* @__PURE__ */ __toESM(require_lib()), MediaSsrcHandler = class {
	constructor() {
		_defineProperty(this, "ssrcToMid", {
			local: /* @__PURE__ */ new Map(),
			remote: /* @__PURE__ */ new Map()
		});
	}
	findMidBySsrc(e, b) {
		var x;
		return this.ssrcToMid[b].forEach((b, S) => {
			if (b.find((b) => b == e)) {
				x = S;
				return;
			}
		}), x;
	}
	parse(e, b) {
		var x = (0, import_lib$3.parse)(e), S = /* @__PURE__ */ new Map();
		x.media.forEach((e) => {
			if (e.mid && e.type === "video" || e.type === "audio") {
				var b, x = [];
				(b = e.ssrcs) == null || b.forEach((e) => {
					e.attribute === "cname" && x.push(`${e.id}`);
				}), S.set(`${e.mid}`, x);
			}
		}), this.ssrcToMid[b] = S;
	}
	getSsrcToMidMap(e) {
		return this.ssrcToMid[e];
	}
}, MediaTrackHandler = class {
	constructor(e) {
		this.pc = e;
	}
	getLocalTracks(e) {
		return this.pc.getTransceivers().filter((e) => e.currentDirection === "sendonly" || e.currentDirection === "sendrecv").filter((e) => e.sender !== null).map((e) => e.sender).map((e) => e.track).filter((b) => b !== null && b.kind === e);
	}
	getTackById(e) {
		return this.pc.getTransceivers().map((b) => {
			if (b?.sender.track !== null && b.sender.track.id === e) return b.sender.track;
			if (b?.receiver.track !== null && b.receiver.track.id === e) return b.receiver.track;
		}).find((e) => e !== void 0);
	}
	getLocalTrackIdByMid(e) {
		var b, x = this.pc.getTransceivers().find((b) => b.mid === e);
		return x == null || (b = x.sender) == null || (b = b.track) == null ? void 0 : b.id;
	}
	getRemoteTrackIdByMid(e) {
		var b, x = this.pc.getTransceivers().find((b) => b.mid === e);
		return x == null || (b = x.receiver) == null || (b = b.track) == null ? void 0 : b.id;
	}
	getActiveSimulcastStreams() {
		return 3;
	}
	getTransceiverByTrackId(e) {
		return this.pc.getTransceivers().find((b) => b.receiver.track.id === e || b.sender.track !== null && b.sender.track.id === e);
	}
}, MediaTrackStats = class {
	constructor(e, b, x) {
		this.trackId = e, this.type = b, this.kind = x, _defineProperty(this, "loss", {
			packetsTotal: 0,
			packetsLost: 0,
			isDownloadStream: !1
		}), _defineProperty(this, "bitrate", {
			download: 0,
			upload: 0
		}), _defineProperty(this, "resolution", {
			width: -1,
			height: -1
		}), _defineProperty(this, "audioConcealment", {
			concealedAudio: 0,
			totalAudioDuration: 0
		}), _defineProperty(this, "framerate", 0), _defineProperty(this, "jitter", 0), _defineProperty(this, "codec", ""), _defineProperty(this, "isAlive", !0), _defineProperty(this, "isMuted", !1), _defineProperty(this, "isEnabled", !0);
	}
	getType() {
		return this.type;
	}
	setLoss(e) {
		this.loss = e;
	}
	getLoss() {
		return this.loss;
	}
	setResolution(e) {
		this.resolution = e;
	}
	getResolution() {
		return this.resolution;
	}
	setFramerate(e) {
		this.framerate = e;
	}
	getFramerate() {
		return this.framerate;
	}
	setBitrate(e) {
		this.bitrate = e;
	}
	getBitrate() {
		return this.bitrate;
	}
	setCodec(e) {
		return this.codec = e, !0;
	}
	getCodec() {
		return this.codec;
	}
	resetBitrate() {
		this.bitrate = {
			download: 0,
			upload: 0
		};
	}
	set alive(e) {
		this.isAlive = e;
	}
	get alive() {
		return this.isAlive;
	}
	set muted(e) {
		this.isMuted = e;
	}
	get muted() {
		return this.isMuted;
	}
	set enabled(e) {
		this.isEnabled = e;
	}
	get enabled() {
		return this.isEnabled;
	}
	setJitter(e) {
		this.jitter = e;
	}
	getJitter() {
		return this.jitter;
	}
	setAudioConcealment(e, b) {
		this.audioConcealment.concealedAudio = e, this.audioConcealment.totalAudioDuration = b;
	}
	getAudioConcealment() {
		return this.audioConcealment;
	}
}, MediaTrackStatsHandler = class {
	constructor(e, b) {
		this.mediaSsrcHandler = e, this.mediaTrackHandler = b, _defineProperty(this, "track2stats", /* @__PURE__ */ new Map());
	}
	findTrack2Stats(e, b) {
		var x;
		if (e.trackIdentifier) x = e.trackIdentifier;
		else if (e.mid) x = b === "remote" ? this.mediaTrackHandler.getRemoteTrackIdByMid(e.mid) : this.mediaTrackHandler.getLocalTrackIdByMid(e.mid);
		else if (e.ssrc) {
			if (!this.mediaSsrcHandler.findMidBySsrc(e.ssrc, b)) return;
			x = b === "remote" ? this.mediaTrackHandler.getRemoteTrackIdByMid(e.mid) : this.mediaTrackHandler.getLocalTrackIdByMid(e.mid);
		}
		if (x) {
			var S = this.track2stats.get(x);
			if (!S) {
				var C = this.mediaTrackHandler.getTackById(x);
				if (C !== void 0) {
					var w = C.kind === "audio" ? C.kind : "video";
					S = new MediaTrackStats(x, b, w), this.track2stats.set(x, S);
				} else return;
			}
			return S;
		}
	}
	findLocalVideoTrackStats(e) {
		if (this.mediaTrackHandler.getLocalTracks("video").length !== 0) return this.findTrack2Stats(e, "local");
	}
	getTrack2stats() {
		return this.track2stats;
	}
	findTransceiverByTrackId(e) {
		return this.mediaTrackHandler.getTransceiverByTrackId(e);
	}
}, ValueFormatter = class {
	static getNonNegativeValue(e) {
		var b = e;
		return typeof b != "number" && (b = Number(b)), isNaN(b) ? 0 : Math.max(0, b);
	}
}, TrackStatsBuilder = class e {
	static buildFramerateResolution(e, b) {
		var x = {
			height: b.frameHeight,
			width: b.frameWidth
		}, S = b.framesPerSecond;
		x.height && x.width && e.setResolution(x), e.setFramerate(Math.round(S || 0));
	}
	static calculateSimulcastFramerate(e, b, x, S) {
		var C = e.getFramerate();
		if (!C) {
			if (x) {
				var w = b.timestamp - x.timestamp;
				w > 0 && b.framesSent && (C = (b.framesSent - x.framesSent) / w * 1e3);
			}
			if (!C) return;
		}
		C = S ? Math.round(C / S) : 0, e.setFramerate(C);
	}
	static buildCodec(e, b, x) {
		var S = e?.get(x.codecId);
		if (S) {
			var C = S.mimeType.split("/")[1];
			C && b.setCodec(C);
		}
	}
	static buildBitrateReceived(b, x, S) {
		b.setBitrate({
			download: e.calculateBitrate(x.bytesReceived, S.bytesReceived, x.timestamp, S.timestamp),
			upload: 0
		});
	}
	static buildBitrateSend(e, b, x) {
		e.setBitrate({
			download: 0,
			upload: this.calculateBitrate(b.bytesSent, x.bytesSent, b.timestamp, x.timestamp)
		});
	}
	static buildPacketsLost(e, b, x) {
		var S = b.type === "outbound-rtp" ? "packetsSent" : "packetsReceived", C = b[S];
		(!C || C < 0) && (C = 0);
		var w = ValueFormatter.getNonNegativeValue(x[S]), T = Math.max(0, C - w), E = ValueFormatter.getNonNegativeValue(b.packetsLost), D = ValueFormatter.getNonNegativeValue(x.packetsLost), O = Math.max(0, E - D);
		e.setLoss({
			packetsTotal: T + O,
			packetsLost: O,
			isDownloadStream: b.type !== "outbound-rtp"
		});
	}
	static calculateBitrate(e, b, x, S) {
		var C = ValueFormatter.getNonNegativeValue(e), w = ValueFormatter.getNonNegativeValue(b), T = Math.max(0, C - w), E = x - S, D = 0;
		return E > 0 && (D = Math.round(T * 8 / E)), D;
	}
	static setTrackStatsState(e, b) {
		var x;
		if (b === void 0) {
			e.alive = !1;
			return;
		}
		var S = e.getType() === "remote" ? b.receiver.track : b == null || (x = b.sender) == null ? void 0 : x.track;
		if (S == null) {
			e.alive = !1;
			return;
		}
		if (S.readyState === "ended") {
			e.alive = !1;
			return;
		}
		e.muted = S.muted, e.enabled = S.enabled, e.alive = !0;
	}
	static buildTrackSummary(e) {
		var b = {
			count: 0,
			muted: 0,
			maxJitter: 0,
			maxPacketLoss: 0,
			concealedAudio: 0,
			totalAudio: 0
		}, x = {
			count: 0,
			muted: 0,
			maxJitter: 0,
			maxPacketLoss: 0,
			concealedAudio: 0,
			totalAudio: 0
		}, S = e.filter((e) => e.getType() === "remote"), C = S.filter((e) => e.kind === "audio");
		return S.forEach((e) => {
			var S = e.kind === "video" ? b : x;
			S.count++, e.alive && e.muted && S.muted++, S.maxJitter < e.getJitter() && (S.maxJitter = e.getJitter()), S.maxPacketLoss < e.getLoss().packetsLost && (S.maxPacketLoss = e.getLoss().packetsLost), C.length > 0 && (S.concealedAudio += e.getAudioConcealment()?.concealedAudio, S.totalAudio += e.getAudioConcealment()?.totalAudioDuration);
		}), {
			audioTrackSummary: x,
			videoTrackSummary: b
		};
	}
	static buildJitter(e, b) {
		if (b.type === "inbound-rtp") {
			var x = b?.jitter;
			if (x !== void 0) {
				var S = ValueFormatter.getNonNegativeValue(x);
				e.setJitter(Math.round(S * 1e3));
			} else e.setJitter(-1);
		}
	}
	static buildAudioConcealment(e, b) {
		if (b.type === "inbound-rtp") {
			var x = 1e3 * b?.totalSamplesDuration / b?.totalSamplesReceived * b?.concealedSamples, S = 1e3 * b?.totalSamplesDuration;
			e.setAudioConcealment(x, S);
		}
	}
}, ConnectionStatsReportBuilder = class e {
	static build(b) {
		var x = {}, S = {
			download: 0,
			upload: 0
		}, C = {
			download: 0,
			upload: 0
		}, w = 0, T = 0, E = {
			local: /* @__PURE__ */ new Map(),
			remote: /* @__PURE__ */ new Map()
		}, D = {
			local: /* @__PURE__ */ new Map(),
			remote: /* @__PURE__ */ new Map()
		}, O = {
			local: /* @__PURE__ */ new Map(),
			remote: /* @__PURE__ */ new Map()
		}, k = /* @__PURE__ */ new Map(), A = /* @__PURE__ */ new Map(), j = 0, M = 0, N = 0, P = 0, F = 0, I = 0;
		for (var [L, R] of b) {
			var z = R.getLoss(), B = z.isDownloadStream ? "download" : "upload";
			if (S[B] += z.packetsTotal, C[B] += z.packetsLost, w += R.getBitrate().download, T += R.getBitrate().upload, R.kind === "audio") {
				var V = R.getAudioConcealment();
				F += V.concealedAudio, I += V.totalAudioDuration, j += R.getBitrate().download, M += R.getBitrate().upload;
			} else N += R.getBitrate().download, P += R.getBitrate().upload;
			E[R.getType()].set(L, R.getResolution()), D[R.getType()].set(L, R.getFramerate()), O[R.getType()].set(L, R.getCodec()), R.getType() === "remote" && (k.set(L, R.getJitter()), R.kind === "audio" && A.set(L, R.getAudioConcealment())), R.resetBitrate();
		}
		return x.bitrate = {
			upload: T,
			download: w
		}, x.bitrate.audio = {
			upload: M,
			download: j
		}, x.bitrate.video = {
			upload: P,
			download: N
		}, x.packetLoss = {
			total: e.calculatePacketLoss(C.download + C.upload, S.download + S.upload),
			download: e.calculatePacketLoss(C.download, S.download),
			upload: e.calculatePacketLoss(C.upload, S.upload)
		}, x.audioConcealment = A, x.totalAudioConcealment = {
			concealedAudio: F,
			totalAudioDuration: I
		}, x.framerate = D, x.resolution = E, x.codec = O, x.jitter = k, x;
	}
	static calculatePacketLoss(e, b) {
		return !b || b <= 0 || !e || e <= 0 ? 0 : Math.round(e / b * 100);
	}
}, CallFeedStatsReporter = class e {
	static buildCallFeedReport(b, x, S) {
		var C = S.getTransceivers(), w = [];
		return C.forEach((b) => {
			var x, S = (x = b.sender) != null && x.track ? e.buildTrackStats(b.sender.track, "sender") : null, C = e.buildTrackStats(b.receiver.track, "receiver");
			w.push({
				mid: b.mid == null ? "null" : b.mid,
				direction: b.direction,
				currentDirection: b.currentDirection == null ? "null" : b.currentDirection,
				sender: S,
				receiver: C
			});
		}), {
			callId: b,
			opponentMemberId: x,
			transceiver: w,
			callFeeds: []
		};
	}
	static buildTrackStats(e) {
		var b = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "--", x = e.getSettings()?.deviceId, S = e.getConstraints()?.deviceId;
		return {
			id: e.id,
			kind: e.kind,
			settingDeviceId: x ?? "unknown",
			constrainDeviceId: S ?? "unknown",
			muted: e.muted,
			enabled: e.enabled,
			readyState: e.readyState,
			label: b
		};
	}
	static expandCallFeedReport(b, x) {
		var S = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "unknown";
		return x.forEach((x) => {
			var C = x.stream.getAudioTracks(), w = x.stream.getVideoTracks(), T = C.length > 0 ? e.buildTrackStats(x.stream.getAudioTracks()[0], x.purpose) : null, E = w.length > 0 ? e.buildTrackStats(x.stream.getVideoTracks()[0], x.purpose) : null, D = {
				stream: x.stream.id,
				type: x.isLocal() ? "local" : "remote",
				audio: T,
				video: E,
				purpose: x.purpose,
				prefix: S,
				isVideoMuted: x.isVideoMuted(),
				isAudioMuted: x.isAudioMuted()
			};
			b.callFeeds.push(D);
		}), b;
	}
};
function ownKeys$12(e, b) {
	var x = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var S = Object.getOwnPropertySymbols(e);
		b && (S = S.filter(function(b) {
			return Object.getOwnPropertyDescriptor(e, b).enumerable;
		})), x.push.apply(x, S);
	}
	return x;
}
function _objectSpread$12(e) {
	for (var b = 1; b < arguments.length; b++) {
		var x = arguments[b] == null ? {} : arguments[b];
		b % 2 ? ownKeys$12(Object(x), !0).forEach(function(b) {
			_defineProperty(e, b, x[b]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(x)) : ownKeys$12(Object(x)).forEach(function(b) {
			Object.defineProperty(e, b, Object.getOwnPropertyDescriptor(x, b));
		});
	}
	return e;
}
var CallStatsReportGatherer = class {
	constructor(e, b, x, S) {
		var C = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0;
		this.callId = e, this.opponentMemberId = b, this.pc = x, this.emitter = S, this.isFocus = C, _defineProperty(this, "isActive", !0), _defineProperty(this, "previousStatsReport", void 0), _defineProperty(this, "currentStatsReport", void 0), _defineProperty(this, "connectionStats", new ConnectionStats()), _defineProperty(this, "trackStats", void 0), x.addEventListener("signalingstatechange", this.onSignalStateChange.bind(this)), this.trackStats = new MediaTrackStatsHandler(new MediaSsrcHandler(), new MediaTrackHandler(x));
	}
	processStats(e, b) {
		var x = this;
		return _asyncToGenerator(function* () {
			var S = {
				isFirstCollection: x.previousStatsReport === void 0,
				receivedMedia: 0,
				receivedAudioMedia: 0,
				receivedVideoMedia: 0,
				audioTrackSummary: {
					count: 0,
					muted: 0,
					maxPacketLoss: 0,
					maxJitter: 0,
					concealedAudio: 0,
					totalAudio: 0
				},
				videoTrackSummary: {
					count: 0,
					muted: 0,
					maxPacketLoss: 0,
					maxJitter: 0,
					concealedAudio: 0,
					totalAudio: 0
				}
			};
			if (x.isActive) {
				var C = x.pc.getStats();
				if (typeof C?.then == "function") return C.then((C) => {
					x.currentStatsReport = typeof C?.result == "function" ? C.result() : C;
					try {
						x.processStatsReport(e, b);
					} catch (e) {
						return x.handleError(e), S;
					}
					x.previousStatsReport = x.currentStatsReport, S.receivedMedia = x.connectionStats.bitrate.download, S.receivedAudioMedia = x.connectionStats.bitrate.audio?.download || 0, S.receivedVideoMedia = x.connectionStats.bitrate.video?.download || 0;
					var w = TrackStatsBuilder.buildTrackSummary(Array.from(x.trackStats.getTrack2stats().values()));
					return _objectSpread$12(_objectSpread$12({}, S), {}, {
						audioTrackSummary: w.audioTrackSummary,
						videoTrackSummary: w.videoTrackSummary
					});
				}).catch((e) => (x.handleError(e), S));
				x.isActive = !1;
			}
			return Promise.resolve(S);
		})();
	}
	processStatsReport(e, b) {
		var x, S = /* @__PURE__ */ new Map();
		S.callId = this.callId, S.opponentMemberId = this.opponentMemberId, (x = this.currentStatsReport) == null || x.forEach((e) => {
			var b = this.previousStatsReport ? this.previousStatsReport.get(e.id) : null;
			if (e.type === "candidate-pair" && e.nominated && e.state === "succeeded") this.connectionStats.bandwidth = ConnectionStatsBuilder.buildBandwidthReport(e), this.connectionStats.transport = TransportStatsBuilder.buildReport(this.currentStatsReport, e, this.connectionStats.transport, this.isFocus);
			else if (e.type === "inbound-rtp" || e.type === "outbound-rtp") {
				var x = this.trackStats.findTrack2Stats(e, e.type === "inbound-rtp" ? "remote" : "local");
				if (!x) return;
				if (b && TrackStatsBuilder.buildPacketsLost(x, e, b), e.type === "inbound-rtp") {
					TrackStatsBuilder.buildFramerateResolution(x, e), b && TrackStatsBuilder.buildBitrateReceived(x, e, b);
					var C = this.trackStats.findTransceiverByTrackId(x.trackId);
					TrackStatsBuilder.setTrackStatsState(x, C), TrackStatsBuilder.buildJitter(x, e), TrackStatsBuilder.buildAudioConcealment(x, e);
				} else b && (S.set(x.trackId, ValueFormatter.getNonNegativeValue(e.bytesSent)), TrackStatsBuilder.buildBitrateSend(x, e, b));
				TrackStatsBuilder.buildCodec(this.currentStatsReport, x, e);
			} else if (e.type === "track" && e.kind === "video" && !e.remoteSource) {
				var w = this.trackStats.findLocalVideoTrackStats(e);
				if (!w) return;
				TrackStatsBuilder.buildFramerateResolution(w, e), TrackStatsBuilder.calculateSimulcastFramerate(w, e, b, this.trackStats.mediaTrackHandler.getActiveSimulcastStreams());
			}
		}), this.emitter.emitByteSendReport(S), this.emitter.emitCallFeedReport(CallFeedStatsReporter.buildCallFeedReport(this.callId, this.opponentMemberId, this.pc)), this.processAndEmitConnectionStatsReport();
	}
	setActive(e) {
		this.isActive = e;
	}
	getActive() {
		return this.isActive;
	}
	handleError(e) {
		this.isActive = !1, logger.warn(`CallStatsReportGatherer ${this.callId} processStatsReport fails and set to inactive ${e}`);
	}
	processAndEmitConnectionStatsReport() {
		var e = ConnectionStatsReportBuilder.build(this.trackStats.getTrack2stats());
		e.callId = this.callId, e.opponentMemberId = this.opponentMemberId, this.connectionStats.bandwidth = e.bandwidth, this.connectionStats.bitrate = e.bitrate, this.connectionStats.packetLoss = e.packetLoss, this.emitter.emitConnectionStatsReport(_objectSpread$12(_objectSpread$12({}, e), {}, { transport: this.connectionStats.transport })), this.connectionStats.transport = [];
	}
	stopProcessingStats() {}
	onSignalStateChange() {
		this.pc.signalingState === "stable" && (this.pc.currentRemoteDescription && this.trackStats.mediaSsrcHandler.parse(this.pc.currentRemoteDescription.sdp, "remote"), this.pc.currentLocalDescription && this.trackStats.mediaSsrcHandler.parse(this.pc.currentLocalDescription.sdp, "local"));
	}
	setOpponentMemberId(e) {
		this.opponentMemberId = e;
	}
}, StatsReport = /* @__PURE__ */ function(e) {
	return e.CONNECTION_STATS = "StatsReport.connection_stats", e.CALL_FEED_REPORT = "StatsReport.call_feed_report", e.BYTE_SENT_STATS = "StatsReport.byte_sent_stats", e.SUMMARY_STATS = "StatsReport.summary_stats", e;
}({}), StatsReportEmitter = class extends TypedEventEmitter {
	emitByteSendReport(e) {
		this.emit(StatsReport.BYTE_SENT_STATS, e);
	}
	emitConnectionStatsReport(e) {
		this.emit(StatsReport.CONNECTION_STATS, e);
	}
	emitCallFeedReport(e) {
		this.emit(StatsReport.CALL_FEED_REPORT, e);
	}
	emitSummaryStatsReport(e) {
		this.emit(StatsReport.SUMMARY_STATS, e);
	}
}, SummaryStatsReportGatherer = class {
	constructor(e) {
		this.emitter = e;
	}
	build(e) {
		var b = e.filter((e) => !e.isFirstCollection), x = b.length, S = e.length;
		if (x !== 0) {
			var C = {
				receivedAudio: 0,
				receivedVideo: 0,
				receivedMedia: 0,
				concealedAudio: 0,
				totalAudio: 0
			}, w = 0, T = 0;
			b.forEach((e) => {
				this.countTrackListReceivedMedia(C, e), this.countConcealedAudio(C, e), w = this.buildMaxJitter(w, e), T = this.buildMaxPacketLoss(T, e);
			});
			var E = 5, D = {
				percentageReceivedMedia: Number((C.receivedMedia / x).toFixed(E)),
				percentageReceivedVideoMedia: Number((C.receivedVideo / x).toFixed(E)),
				percentageReceivedAudioMedia: Number((C.receivedAudio / x).toFixed(E)),
				maxJitter: w,
				maxPacketLoss: T,
				percentageConcealedAudio: Number(C.totalAudio > 0 ? (C.concealedAudio / C.totalAudio).toFixed(E) : 0),
				peerConnections: S
			};
			this.emitter.emitSummaryStatsReport(D);
		}
	}
	static extendSummaryReport(e, b) {
		var x = [], S = [];
		for (var C of b) {
			S.push(C);
			for (var w of C[1]) x.push(w);
		}
		e.opponentDevicesInCall = Math.max(0, x.length - 1), e.opponentUsersInCall = Math.max(0, S.length - 1), e.diffDevicesToPeerConnections = Math.max(0, x.length - 1) - e.peerConnections, e.ratioPeerConnectionToDevices = Math.max(0, x.length - 1) == 0 ? 0 : e.peerConnections / (x.length - 1);
	}
	countTrackListReceivedMedia(e, b) {
		var x = !1, S = !1;
		(b.receivedAudioMedia > 0 || b.audioTrackSummary.count === 0) && (e.receivedAudio++, x = !0), (b.receivedVideoMedia > 0 || b.videoTrackSummary.count === 0 || b.videoTrackSummary.muted > 0 && b.videoTrackSummary.muted === b.videoTrackSummary.count) && (e.receivedVideo++, S = !0), S && x && e.receivedMedia++;
	}
	buildMaxJitter(e, b) {
		return e < b.videoTrackSummary.maxJitter && (e = b.videoTrackSummary.maxJitter), e < b.audioTrackSummary.maxJitter && (e = b.audioTrackSummary.maxJitter), e;
	}
	buildMaxPacketLoss(e, b) {
		return e < b.videoTrackSummary.maxPacketLoss && (e = b.videoTrackSummary.maxPacketLoss), e < b.audioTrackSummary.maxPacketLoss && (e = b.audioTrackSummary.maxPacketLoss), e;
	}
	countConcealedAudio(e, b) {
		e.concealedAudio += b.audioTrackSummary.concealedAudio, e.totalAudio += b.audioTrackSummary.totalAudio;
	}
}, GroupCallStats = class {
	constructor(e, b) {
		var x = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1e4;
		this.groupCallId = e, this.userId = b, this.interval = x, _defineProperty(this, "timer", void 0), _defineProperty(this, "gatherers", /* @__PURE__ */ new Map()), _defineProperty(this, "reports", new StatsReportEmitter()), _defineProperty(this, "summaryStatsReportGatherer", new SummaryStatsReportGatherer(this.reports));
	}
	start() {
		this.timer === void 0 && this.interval > 0 && (this.timer = setInterval(() => {
			this.processStats();
		}, this.interval));
	}
	stop() {
		this.timer !== void 0 && (clearInterval(this.timer), this.gatherers.forEach((e) => e.stopProcessingStats()));
	}
	hasStatsReportGatherer(e) {
		return this.gatherers.has(e);
	}
	addStatsReportGatherer(e, b, x) {
		return this.hasStatsReportGatherer(e) ? !1 : (this.gatherers.set(e, new CallStatsReportGatherer(e, b, x, this.reports)), !0);
	}
	removeStatsReportGatherer(e) {
		return this.gatherers.delete(e);
	}
	getStatsReportGatherer(e) {
		return this.hasStatsReportGatherer(e) ? this.gatherers.get(e) : void 0;
	}
	updateOpponentMember(e, b) {
		var x;
		(x = this.getStatsReportGatherer(e)) == null || x.setOpponentMemberId(b);
	}
	processStats() {
		var e = [];
		this.gatherers.forEach((b) => {
			e.push(b.processStats(this.groupCallId, this.userId));
		}), Promise.all(e).then((e) => this.summaryStatsReportGatherer.build(e)).catch((e) => {
			logger.error("Could not build summary stats report", e);
		});
	}
	setInterval(e) {
		this.interval = e;
	}
};
function ownKeys$11(e, b) {
	var x = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var S = Object.getOwnPropertySymbols(e);
		b && (S = S.filter(function(b) {
			return Object.getOwnPropertyDescriptor(e, b).enumerable;
		})), x.push.apply(x, S);
	}
	return x;
}
function _objectSpread$11(e) {
	for (var b = 1; b < arguments.length; b++) {
		var x = arguments[b] == null ? {} : arguments[b];
		b % 2 ? ownKeys$11(Object(x), !0).forEach(function(b) {
			_defineProperty(e, b, x[b]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(x)) : ownKeys$11(Object(x)).forEach(function(b) {
			Object.defineProperty(e, b, Object.getOwnPropertyDescriptor(x, b));
		});
	}
	return e;
}
var GroupCallIntent = /* @__PURE__ */ function(e) {
	return e.Ring = "m.ring", e.Prompt = "m.prompt", e.Room = "m.room", e;
}({}), GroupCallType = /* @__PURE__ */ function(e) {
	return e.Video = "m.video", e.Voice = "m.voice", e;
}({}), GroupCallTerminationReason = /* @__PURE__ */ function(e) {
	return e.CallEnded = "call_ended", e;
}({}), GroupCallEvent = /* @__PURE__ */ function(e) {
	return e.GroupCallStateChanged = "group_call_state_changed", e.ActiveSpeakerChanged = "active_speaker_changed", e.CallsChanged = "calls_changed", e.UserMediaFeedsChanged = "user_media_feeds_changed", e.ScreenshareFeedsChanged = "screenshare_feeds_changed", e.LocalScreenshareStateChanged = "local_screenshare_state_changed", e.LocalMuteStateChanged = "local_mute_state_changed", e.ParticipantsChanged = "participants_changed", e.Error = "group_call_error", e;
}({}), GroupCallStatsReportEvent = /* @__PURE__ */ function(e) {
	return e.ConnectionStats = "GroupCall.connection_stats", e.ByteSentStats = "GroupCall.byte_sent_stats", e.SummaryStats = "GroupCall.summary_stats", e.CallFeedStats = "GroupCall.call_feed_stats", e;
}({}), GroupCallErrorCode = /* @__PURE__ */ function(e) {
	return e.NoUserMedia = "no_user_media", e.UnknownDevice = "unknown_device", e.PlaceCallFailed = "place_call_failed", e;
}({}), GroupCallError = class extends Error {
	constructor(e, b, x) {
		x ? (super(b + ": " + x), _defineProperty(this, "code", void 0)) : (super(b), _defineProperty(this, "code", void 0)), this.code = e;
	}
}, GroupCallUnknownDeviceError = class extends GroupCallError {
	constructor(e) {
		super(GroupCallErrorCode.UnknownDevice, "No device found for " + e), this.userId = e;
	}
}, GroupCallState = /* @__PURE__ */ function(e) {
	return e.LocalCallFeedUninitialized = "local_call_feed_uninitialized", e.InitializingLocalCallFeed = "initializing_local_call_feed", e.LocalCallFeedInitialized = "local_call_feed_initialized", e.Entered = "entered", e.Ended = "ended", e;
}({}), DEVICE_TIMEOUT = 1e3 * 60 * 60;
function getCallUserId(e) {
	return e.getOpponentMember()?.userId || e.invitee || null;
}
var GroupCall = class extends TypedEventEmitter {
	constructor(e, b, x, S, C, w, T, E, D) {
		var O = arguments.length > 9 && arguments[9] !== void 0 ? arguments[9] : !1, k = arguments.length > 10 ? arguments[10] : void 0;
		super(), this.client = e, this.room = b, this.type = x, this.isPtt = S, this.intent = C, this.dataChannelsEnabled = T, this.dataChannelOptions = E, this.useLivekit = O, _defineProperty(this, "activeSpeakerInterval", 1e3), _defineProperty(this, "retryCallInterval", 5e3), _defineProperty(this, "participantTimeout", 1e3 * 15), _defineProperty(this, "pttMaxTransmitTime", 1e3 * 20), _defineProperty(this, "activeSpeaker", void 0), _defineProperty(this, "localCallFeed", void 0), _defineProperty(this, "localScreenshareFeed", void 0), _defineProperty(this, "localDesktopCapturerSourceId", void 0), _defineProperty(this, "userMediaFeeds", []), _defineProperty(this, "screenshareFeeds", []), _defineProperty(this, "groupCallId", void 0), _defineProperty(this, "allowCallWithoutVideoAndAudio", void 0), _defineProperty(this, "calls", /* @__PURE__ */ new Map()), _defineProperty(this, "callHandlers", /* @__PURE__ */ new Map()), _defineProperty(this, "activeSpeakerLoopInterval", void 0), _defineProperty(this, "retryCallLoopInterval", void 0), _defineProperty(this, "retryCallCounts", /* @__PURE__ */ new Map()), _defineProperty(this, "reEmitter", void 0), _defineProperty(this, "transmitTimer", null), _defineProperty(this, "participantsExpirationTimer", null), _defineProperty(this, "resendMemberStateTimer", null), _defineProperty(this, "initWithAudioMuted", !1), _defineProperty(this, "initWithVideoMuted", !1), _defineProperty(this, "initCallFeedPromise", void 0), _defineProperty(this, "_livekitServiceURL", void 0), _defineProperty(this, "stats", void 0), _defineProperty(this, "statsCollectIntervalTime", 0), _defineProperty(this, "onConnectionStats", (e) => {
			this.emit(GroupCallStatsReportEvent.ConnectionStats, { report: e });
		}), _defineProperty(this, "onByteSentStats", (e) => {
			this.emit(GroupCallStatsReportEvent.ByteSentStats, { report: e });
		}), _defineProperty(this, "onSummaryStats", (e) => {
			SummaryStatsReportGatherer.extendSummaryReport(e, this.participants), this.emit(GroupCallStatsReportEvent.SummaryStats, { report: e });
		}), _defineProperty(this, "onCallFeedReport", (e) => {
			this.localCallFeed && (e = CallFeedStatsReporter.expandCallFeedReport(e, [this.localCallFeed], "from-local-feed"));
			var b = [];
			this.forEachCall((x) => {
				x.callId === e.callId && x.getFeeds().forEach((e) => b.push(e));
			}), e = CallFeedStatsReporter.expandCallFeedReport(e, b, "from-call-feed"), this.emit(GroupCallStatsReportEvent.CallFeedStats, { report: e });
		}), _defineProperty(this, "_state", GroupCallState.LocalCallFeedUninitialized), _defineProperty(this, "_participants", /* @__PURE__ */ new Map()), _defineProperty(this, "_creationTs", null), _defineProperty(this, "_enteredViaAnotherSession", !1), _defineProperty(this, "onIncomingCall", (e) => {
			if (e.roomId === this.room.roomId) {
				if (e.state !== CallState.Ringing) {
					logger.warn(`GroupCall ${this.groupCallId} onIncomingCall() incoming call no longer in ringing state - ignoring`);
					return;
				}
				if (!e.groupCallId || e.groupCallId !== this.groupCallId) {
					logger.log(`GroupCall ${this.groupCallId} onIncomingCall() ignored because it doesn't match the current group call`), e.reject();
					return;
				}
				var b = e.getOpponentMember()?.userId;
				if (b === void 0) {
					logger.warn(`GroupCall ${this.groupCallId} onIncomingCall() incoming call with no member - ignoring`);
					return;
				}
				if (this.useLivekit) {
					logger.info("Received incoming call whilst in signaling-only mode! Ignoring.");
					return;
				}
				var x = this.calls.get(b) ?? /* @__PURE__ */ new Map(), S = x.get(e.getOpponentDeviceId());
				if (S?.callId !== e.callId) {
					logger.log(`GroupCall ${this.groupCallId} onIncomingCall() incoming call (userId=${b}, callId=${e.callId})`), S && S.hangup(CallErrorCode.Replaced, !1), x.set(e.getOpponentDeviceId(), e), this.calls.set(b, x), this.initCall(e);
					var C = this.getLocalFeeds().map((e) => e.clone());
					if (!this.callExpected(e)) for (var w of C) setTracksEnabled(w.stream.getAudioTracks(), !1), setTracksEnabled(w.stream.getVideoTracks(), !1);
					e.answerWithCallFeeds(C), this.emit(GroupCallEvent.CallsChanged, this.calls);
				}
			}
		}), _defineProperty(this, "onRetryCallLoop", () => {
			var e = !1;
			for (var [{ userId: b }, x] of this.participants) {
				var S = this.calls.get(b), C = this.retryCallCounts.get(b);
				for (var [w, T] of x) {
					var E = S?.get(w), D = C?.get(w) ?? 0;
					E?.getOpponentSessionId() !== T.sessionId && this.wantsOutgoingCall(b, w) && D < 3 && (C === void 0 && (C = /* @__PURE__ */ new Map(), this.retryCallCounts.set(b, C)), C.set(w, D + 1), e = !0);
				}
			}
			e && this.placeOutgoingCalls();
		}), _defineProperty(this, "onCallFeedsChanged", (e) => {
			var b = getCallUserId(e), x = e.getOpponentDeviceId();
			if (!b) throw Error("Cannot change call feeds without user id");
			var S = this.getUserMediaFeed(b, x), C = e.remoteUsermediaFeed, w = C !== S;
			if (this.calls.get(b)?.get(x)?.callId === e.callId) {
				w && (!S && C ? this.addUserMediaFeed(C) : S && C ? this.replaceUserMediaFeed(S, C) : S && !C && this.removeUserMediaFeed(S));
				var T = this.getScreenshareFeed(b, x), E = e.remoteScreensharingFeed;
				E !== T && (!T && E ? this.addScreenshareFeed(E) : T && E ? this.replaceScreenshareFeed(T, E) : T && !E && this.removeScreenshareFeed(T));
			}
		}), _defineProperty(this, "onCallStateChanged", (e, b, x) => {
			if (b !== CallState.Ended) {
				var S = this.localCallFeed.isAudioMuted();
				e.localUsermediaStream && e.isMicrophoneMuted() !== S && e.setMicrophoneMuted(S);
				var C = this.localCallFeed.isVideoMuted();
				e.localUsermediaStream && e.isLocalVideoMuted() !== C && e.setLocalVideoMuted(C);
				var w = e.getOpponentMember()?.userId;
				if (b === CallState.Connected && w) {
					var T = this.retryCallCounts.get(w);
					T?.delete(e.getOpponentDeviceId()), T?.size === 0 && this.retryCallCounts.delete(w);
				}
			}
		}), _defineProperty(this, "onCallHangup", (e) => {
			if (e.hangupReason !== CallErrorCode.Replaced) {
				var b = e.getOpponentMember()?.userId ?? this.room.getMember(e.invitee).userId, x = this.calls.get(b);
				x?.get(e.getOpponentDeviceId()) === e && (this.disposeCall(e, e.hangupReason), x.delete(e.getOpponentDeviceId()), x.size === 0 && this.calls.delete(b), this.emit(GroupCallEvent.CallsChanged, this.calls));
			}
		}), _defineProperty(this, "onCallReplaced", (e, b) => {
			var x = e.getOpponentMember().userId, S = this.calls.get(x);
			S === void 0 && (S = /* @__PURE__ */ new Map(), this.calls.set(x, S)), e.hangup(CallErrorCode.Replaced, !1), this.initCall(b), S.set(e.getOpponentDeviceId(), b), this.emit(GroupCallEvent.CallsChanged, this.calls);
		}), _defineProperty(this, "onActiveSpeakerLoop", () => {
			var e = void 0, b = void 0;
			for (var x of this.userMediaFeeds) if (!(x.isLocal() && this.userMediaFeeds.length > 1)) {
				var S = x.speakingVolumeSamples.reduce((e, b) => e + Math.max(b, -60)) / x.speakingVolumeSamples.length;
				(!e || S > e) && (e = S, b = x);
			}
			b && this.activeSpeaker !== b && e && e > -60 && (this.activeSpeaker = b, this.emit(GroupCallEvent.ActiveSpeakerChanged, this.activeSpeaker));
		}), _defineProperty(this, "onRoomState", () => this.updateParticipants()), _defineProperty(this, "onParticipantsChanged", () => {
			this.forEachCall((e) => {
				var b = this.callExpected(e);
				for (var x of e.getLocalFeeds()) setTracksEnabled(x.stream.getAudioTracks(), !x.isAudioMuted() && b), setTracksEnabled(x.stream.getVideoTracks(), !x.isVideoMuted() && b);
			}), this.state === GroupCallState.Entered && !this.useLivekit && this.placeOutgoingCalls();
		}), _defineProperty(this, "onStateChanged", (e, b) => {
			(e === GroupCallState.Entered || b === GroupCallState.Entered || e === GroupCallState.Ended) && (this.updateParticipants(), this.updateMemberState().catch((e) => logger.error(`GroupCall ${this.groupCallId} onStateChanged() failed to update member state devices"`, e)));
		}), _defineProperty(this, "onLocalFeedsChanged", () => {
			this.state === GroupCallState.Entered && this.updateMemberState().catch((e) => logger.error(`GroupCall ${this.groupCallId} onLocalFeedsChanged() failed to update member state feeds`, e));
		}), this.reEmitter = new ReEmitter(this), this.groupCallId = w ?? genCallID(), this._livekitServiceURL = k, this.creationTs = b.currentState.getStateEvents(EventType.GroupCallPrefix, this.groupCallId)?.getTs() ?? null, this.updateParticipants(), b.on(RoomStateEvent.Update, this.onRoomState), this.on(GroupCallEvent.ParticipantsChanged, this.onParticipantsChanged), this.on(GroupCallEvent.GroupCallStateChanged, this.onStateChanged), this.on(GroupCallEvent.LocalScreenshareStateChanged, this.onLocalFeedsChanged), this.allowCallWithoutVideoAndAudio = !!D;
	}
	create() {
		var e = this;
		return _asyncToGenerator(function* () {
			return e.creationTs = Date.now(), e.client.groupCallEventHandler.groupCalls.set(e.room.roomId, e), e.client.emit(GroupCallEventHandlerEvent.Outgoing, e), yield e.sendCallStateEvent(), e;
		})();
	}
	sendCallStateEvent() {
		var e = this;
		return _asyncToGenerator(function* () {
			var b = {
				"m.intent": e.intent,
				"m.type": e.type,
				"io.element.ptt": e.isPtt,
				dataChannelsEnabled: e.dataChannelsEnabled,
				dataChannelOptions: e.dataChannelsEnabled ? e.dataChannelOptions : void 0
			};
			e.livekitServiceURL && (b["io.element.livekit_service_url"] = e.livekitServiceURL), yield e.client.sendStateEvent(e.room.roomId, EventType.GroupCallPrefix, b, e.groupCallId);
		})();
	}
	get livekitServiceURL() {
		return this._livekitServiceURL;
	}
	updateLivekitServiceURL(e) {
		return this._livekitServiceURL = e, this.sendCallStateEvent();
	}
	get state() {
		return this._state;
	}
	set state(e) {
		var b = this._state;
		e !== b && (this._state = e, this.emit(GroupCallEvent.GroupCallStateChanged, e, b));
	}
	get participants() {
		return this._participants;
	}
	set participants(e) {
		var b = this._participants, x = (e, b) => e.sessionId === b.sessionId && e.screensharing === b.screensharing;
		mapsEqual(e, b, (e, b) => mapsEqual(e, b, x)) || (this._participants = e, this.emit(GroupCallEvent.ParticipantsChanged, e));
	}
	get creationTs() {
		return this._creationTs;
	}
	set creationTs(e) {
		this._creationTs = e;
	}
	get enteredViaAnotherSession() {
		return this._enteredViaAnotherSession;
	}
	set enteredViaAnotherSession(e) {
		this._enteredViaAnotherSession = e, this.updateParticipants();
	}
	forEachCall(e) {
		for (var b of this.calls.values()) for (var x of b.values()) e(x);
	}
	getLocalFeeds() {
		var e = [];
		return this.localCallFeed && e.push(this.localCallFeed), this.localScreenshareFeed && e.push(this.localScreenshareFeed), e;
	}
	hasLocalParticipant() {
		return this.participants.get(this.room.getMember(this.client.getUserId()))?.has(this.client.getDeviceId()) ?? !1;
	}
	callExpected(e) {
		var b = getCallUserId(e), x = b === null ? null : this.room.getMember(b), S = e.getOpponentDeviceId();
		return x !== null && S !== void 0 && this.participants.get(x)?.get(S) !== void 0;
	}
	initLocalCallFeed() {
		var e = this;
		return _asyncToGenerator(function* () {
			if (e.useLivekit) {
				logger.info("Livekit group call: not starting local call feed.");
				return;
			}
			if (e.state !== GroupCallState.LocalCallFeedUninitialized) throw Error(`Cannot initialize local call feed in the "${e.state}" state.`);
			if (e.state = GroupCallState.InitializingLocalCallFeed, e.initCallFeedPromise) return e.initCallFeedPromise;
			try {
				e.initCallFeedPromise = e.initLocalCallFeedInternal(), yield e.initCallFeedPromise;
			} finally {
				e.initCallFeedPromise = void 0;
			}
		})();
	}
	initLocalCallFeedInternal() {
		var e = this;
		return _asyncToGenerator(function* () {
			logger.log(`GroupCall ${e.groupCallId} initLocalCallFeedInternal() running`);
			var b;
			try {
				b = yield e.client.getMediaHandler().getUserMediaStream(!0, e.type === GroupCallType.Video);
			} catch (x) {
				if (e.allowCallWithoutVideoAndAudio) b = new MediaStream();
				else throw e.state = GroupCallState.LocalCallFeedUninitialized, x;
			}
			if (e._state !== GroupCallState.InitializingLocalCallFeed) throw e.client.getMediaHandler().stopUserMediaStream(b), Error("Group call disposed while gathering media stream");
			var x = new CallFeed({
				client: e.client,
				roomId: e.room.roomId,
				userId: e.client.getUserId(),
				deviceId: e.client.getDeviceId(),
				stream: b,
				purpose: SDPStreamMetadataPurpose.Usermedia,
				audioMuted: e.initWithAudioMuted || b.getAudioTracks().length === 0 || e.isPtt,
				videoMuted: e.initWithVideoMuted || b.getVideoTracks().length === 0
			});
			setTracksEnabled(b.getAudioTracks(), !x.isAudioMuted()), setTracksEnabled(b.getVideoTracks(), !x.isVideoMuted()), e.localCallFeed = x, e.addUserMediaFeed(x), e.state = GroupCallState.LocalCallFeedInitialized;
		})();
	}
	updateLocalUsermediaStream(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			if (b.localCallFeed) {
				var x = b.localCallFeed.stream;
				b.localCallFeed.setNewStream(e);
				var S = b.localCallFeed.isAudioMuted(), C = b.localCallFeed.isVideoMuted();
				logger.log(`GroupCall ${b.groupCallId} updateLocalUsermediaStream() (oldStreamId=${x.id}, newStreamId=${e.id}, micShouldBeMuted=${S}, vidShouldBeMuted=${C})`), setTracksEnabled(e.getAudioTracks(), !S), setTracksEnabled(e.getVideoTracks(), !C), b.client.getMediaHandler().stopUserMediaStream(x);
			}
		})();
	}
	enter() {
		var e = this;
		return _asyncToGenerator(function* () {
			if (e.state === GroupCallState.LocalCallFeedUninitialized) yield e.initLocalCallFeed();
			else if (e.state !== GroupCallState.LocalCallFeedInitialized) throw Error(`Cannot enter call in the "${e.state}" state`);
			logger.log(`GroupCall ${e.groupCallId} enter() running`), e.state = GroupCallState.Entered, e.client.on(CallEventHandlerEvent.Incoming, e.onIncomingCall);
			for (var b of e.client.callEventHandler.calls.values()) e.onIncomingCall(b);
			e.useLivekit || (e.retryCallLoopInterval = setInterval(e.onRetryCallLoop, e.retryCallInterval), e.activeSpeaker = void 0, e.onActiveSpeakerLoop(), e.activeSpeakerLoopInterval = setInterval(e.onActiveSpeakerLoop, e.activeSpeakerInterval));
		})();
	}
	dispose() {
		var e;
		this.localCallFeed &&= (this.removeUserMediaFeed(this.localCallFeed), void 0), this.localScreenshareFeed && (this.client.getMediaHandler().stopScreensharingStream(this.localScreenshareFeed.stream), this.removeScreenshareFeed(this.localScreenshareFeed), this.localScreenshareFeed = void 0, this.localDesktopCapturerSourceId = void 0), this.client.getMediaHandler().stopAllStreams(), this.transmitTimer !== null && (clearTimeout(this.transmitTimer), this.transmitTimer = null), this.retryCallLoopInterval !== void 0 && (clearInterval(this.retryCallLoopInterval), this.retryCallLoopInterval = void 0), this.participantsExpirationTimer !== null && (clearTimeout(this.participantsExpirationTimer), this.participantsExpirationTimer = null), this.state === GroupCallState.Entered && (this.forEachCall((e) => e.hangup(CallErrorCode.UserHangup, !1)), this.activeSpeaker = void 0, clearInterval(this.activeSpeakerLoopInterval), this.retryCallCounts.clear(), clearInterval(this.retryCallLoopInterval), this.client.removeListener(CallEventHandlerEvent.Incoming, this.onIncomingCall), (e = this.stats) == null || e.stop());
	}
	leave() {
		this.dispose(), this.state = GroupCallState.LocalCallFeedUninitialized;
	}
	terminate() {
		var e = arguments, b = this;
		return _asyncToGenerator(function* () {
			var x = e.length > 0 && e[0] !== void 0 ? e[0] : !0;
			if (b.dispose(), b.room.off(RoomStateEvent.Update, b.onRoomState), b.client.groupCallEventHandler.groupCalls.delete(b.room.roomId), b.client.emit(GroupCallEventHandlerEvent.Ended, b), b.state = GroupCallState.Ended, x) {
				var S = b.room.currentState.getStateEvents(EventType.GroupCallPrefix, b.groupCallId);
				yield b.client.sendStateEvent(b.room.roomId, EventType.GroupCallPrefix, _objectSpread$11(_objectSpread$11({}, S.getContent()), {}, { "m.terminated": GroupCallTerminationReason.CallEnded }), b.groupCallId);
			}
		})();
	}
	isLocalVideoMuted() {
		return this.localCallFeed ? this.localCallFeed.isVideoMuted() : !0;
	}
	isMicrophoneMuted() {
		return this.localCallFeed ? this.localCallFeed.isAudioMuted() : !0;
	}
	setMicrophoneMuted(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			if (!e && !(yield b.client.getMediaHandler().hasAudioDevice())) return !1;
			var x = !e && b.isPtt;
			b.isPtt && (!e && b.isMicrophoneMuted() ? b.transmitTimer = setTimeout(() => {
				b.setMicrophoneMuted(!0);
			}, b.pttMaxTransmitTime) : e && !b.isMicrophoneMuted() && (b.transmitTimer !== null && clearTimeout(b.transmitTimer), b.transmitTimer = null)), b.forEachCall((b) => b.localUsermediaFeed?.setAudioVideoMuted(e, null));
			var S = /* @__PURE__ */ function() {
				var e = _asyncToGenerator(function* () {
					var e = [];
					b.forEachCall((b) => e.push(b.sendMetadataUpdate())), yield Promise.all(e).catch((e) => logger.info(`GroupCall ${b.groupCallId} setMicrophoneMuted() failed to send some metadata updates`, e));
				});
				return function() {
					return e.apply(this, arguments);
				};
			}();
			if (x && (yield S()), b.localCallFeed) {
				if (logger.log(`GroupCall ${b.groupCallId} setMicrophoneMuted() (streamId=${b.localCallFeed.stream.id}, muted=${e})`), !(yield b.checkAudioPermissionIfNecessary(e))) return !1;
				b.localCallFeed.setAudioVideoMuted(e, null), setTracksEnabled(b.localCallFeed.stream.getAudioTracks(), !e);
			} else logger.log(`GroupCall ${b.groupCallId} setMicrophoneMuted() no stream muted (muted=${e})`), b.initWithAudioMuted = e;
			return b.forEachCall((x) => setTracksEnabled(x.localUsermediaFeed.stream.getAudioTracks(), !e && b.callExpected(x))), b.emit(GroupCallEvent.LocalMuteStateChanged, e, b.isLocalVideoMuted()), x || (yield S()), !0;
		})();
	}
	checkAudioPermissionIfNecessary(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			try {
				if (!e && b.localCallFeed && !b.localCallFeed.hasAudioTrack && (yield b.client.getMediaHandler().getUserMediaStream(!0, !b.localCallFeed.isVideoMuted()))?.getTracks().length === 0) return logger.log(`GroupCall ${b.groupCallId} setMicrophoneMuted() no device to receive local stream, muted=${e}`), !1;
			} catch {
				return logger.log(`GroupCall ${b.groupCallId} setMicrophoneMuted() no device or permission to receive local stream, muted=${e}`), !1;
			}
			return !0;
		})();
	}
	setLocalVideoMuted(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			if (!e && !(yield b.client.getMediaHandler().hasVideoDevice())) return !1;
			if (b.localCallFeed) {
				/* istanbul ignore next */
				logger.log(`GroupCall ${b.groupCallId} setLocalVideoMuted() (stream=${b.localCallFeed.stream.id}, muted=${e})`);
				try {
					var x = yield b.client.getMediaHandler().getUserMediaStream(!0, !e);
					yield b.updateLocalUsermediaStream(x), b.localCallFeed.setAudioVideoMuted(null, e), setTracksEnabled(b.localCallFeed.stream.getVideoTracks(), !e);
				} catch {
					return logger.log(`GroupCall ${b.groupCallId} setLocalVideoMuted() no device or permission to receive local stream, muted=${e}`), !1;
				}
			} else logger.log(`GroupCall ${b.groupCallId} setLocalVideoMuted() no stream muted (muted=${e})`), b.initWithVideoMuted = e;
			var S = [];
			return b.forEachCall((b) => S.push(b.setLocalVideoMuted(e))), yield Promise.all(S), b.forEachCall((x) => setTracksEnabled(x.localUsermediaFeed.stream.getVideoTracks(), !e && b.callExpected(x))), b.emit(GroupCallEvent.LocalMuteStateChanged, b.isMicrophoneMuted(), e), !0;
		})();
	}
	setScreensharingEnabled(e) {
		var b = arguments, x = this;
		return _asyncToGenerator(function* () {
			var S = b.length > 1 && b[1] !== void 0 ? b[1] : {};
			if (e === x.isScreensharing()) return e;
			if (e) try {
				logger.log(`GroupCall ${x.groupCallId} setScreensharingEnabled() is asking for screensharing permissions`);
				var C = yield x.client.getMediaHandler().getScreensharingStream(S), w = function* (e) {
					var b = () => {
						x.setScreensharingEnabled(!1), e.removeEventListener("ended", b);
					};
					e.addEventListener("ended", b);
				};
				for (var T of C.getTracks()) yield* w(T);
				return logger.log(`GroupCall ${x.groupCallId} setScreensharingEnabled() granted screensharing permissions. Setting screensharing enabled on all calls`), x.localDesktopCapturerSourceId = S.desktopCapturerSourceId, x.localScreenshareFeed = new CallFeed({
					client: x.client,
					roomId: x.room.roomId,
					userId: x.client.getUserId(),
					deviceId: x.client.getDeviceId(),
					stream: C,
					purpose: SDPStreamMetadataPurpose.Screenshare,
					audioMuted: !1,
					videoMuted: !1
				}), x.addScreenshareFeed(x.localScreenshareFeed), x.emit(GroupCallEvent.LocalScreenshareStateChanged, !0, x.localScreenshareFeed, x.localDesktopCapturerSourceId), x.forEachCall((e) => e.pushLocalFeed(x.localScreenshareFeed.clone())), !0;
			} catch (e) {
				if (S.throwOnFail) throw e;
				return logger.error(`GroupCall ${x.groupCallId} setScreensharingEnabled() enabling screensharing error`, e), x.emit(GroupCallEvent.Error, new GroupCallError(GroupCallErrorCode.NoUserMedia, "Failed to get screen-sharing stream: ", e)), !1;
			}
			else return x.forEachCall((e) => {
				e.localScreensharingFeed && e.removeLocalFeed(e.localScreensharingFeed);
			}), x.client.getMediaHandler().stopScreensharingStream(x.localScreenshareFeed.stream), x.removeScreenshareFeed(x.localScreenshareFeed), x.localScreenshareFeed = void 0, x.localDesktopCapturerSourceId = void 0, x.emit(GroupCallEvent.LocalScreenshareStateChanged, !1, void 0, void 0), !1;
		})();
	}
	isScreensharing() {
		return !!this.localScreenshareFeed;
	}
	wantsOutgoingCall(e, b) {
		var x = this.client.getUserId(), S = this.client.getDeviceId();
		return e >= x && (e !== x || b > S);
	}
	placeOutgoingCalls() {
		var e = this, b = !1, x = function(x) {
			var S = e.calls.get(x) ?? /* @__PURE__ */ new Map(), w = function(C) {
				var w = S.get(C);
				if (w?.getOpponentSessionId() !== E.sessionId && e.wantsOutgoingCall(x, C)) {
					b = !0, w !== void 0 && (logger.debug(`GroupCall ${e.groupCallId} placeOutgoingCalls() replacing call (userId=${x}, deviceId=${C}, callId=${w.callId})`), w.hangup(CallErrorCode.NewSession, !1));
					var T = createNewMatrixCall(e.client, e.room.roomId, {
						invitee: x,
						opponentDeviceId: C,
						opponentSessionId: E.sessionId,
						groupCallId: e.groupCallId
					});
					T === null ? (logger.error(`GroupCall ${e.groupCallId} placeOutgoingCalls() failed to create call (userId=${x}, device=${C})`), S.delete(C)) : (e.initCall(T), S.set(C, T), logger.debug(`GroupCall ${e.groupCallId} placeOutgoingCalls() placing call (userId=${x}, deviceId=${C}, sessionId=${E.sessionId})`), T.placeCallWithCallFeeds(e.getLocalFeeds().map((e) => e.clone()), E.screensharing).then(() => {
						e.dataChannelsEnabled && T.createDataChannel("datachannel", e.dataChannelOptions);
					}).catch((b) => {
						logger.warn(`GroupCall ${e.groupCallId} placeOutgoingCalls() failed to place call (userId=${x})`, b), b instanceof CallError && b.code === GroupCallErrorCode.UnknownDevice ? e.emit(GroupCallEvent.Error, b) : e.emit(GroupCallEvent.Error, new GroupCallError(GroupCallErrorCode.PlaceCallFailed, `Failed to place call to ${x}`)), T.hangup(CallErrorCode.SignallingFailed, !1), S.get(C) === T && S.delete(C);
					}));
				}
			};
			for (var [T, E] of C) w(T);
			S.size > 0 ? e.calls.set(x, S) : e.calls.delete(x);
		};
		for (var [{ userId: S }, C] of this.participants) x(S);
		b && this.emit(GroupCallEvent.CallsChanged, this.calls);
	}
	getMemberStateEvents(e) {
		return e === void 0 ? this.room.currentState.getStateEvents(EventType.GroupCallMemberPrefix) : this.room.currentState.getStateEvents(EventType.GroupCallMemberPrefix, e);
	}
	initCall(e) {
		var b = getCallUserId(e);
		if (!b) throw Error("Cannot init call without user id");
		var x = () => this.onCallFeedsChanged(e), S = (b, x) => this.onCallStateChanged(e, b, x), C = this.onCallHangup, w = (b) => this.onCallReplaced(e, b), T = this.callHandlers.get(b);
		T === void 0 && (T = /* @__PURE__ */ new Map(), this.callHandlers.set(b, T)), T.set(e.getOpponentDeviceId(), {
			onCallFeedsChanged: x,
			onCallStateChanged: S,
			onCallHangup: C,
			onCallReplaced: w
		}), e.on(CallEvent.FeedsChanged, x), e.on(CallEvent.State, S), e.on(CallEvent.Hangup, C), e.on(CallEvent.Replaced, w), e.isPtt = this.isPtt, this.reEmitter.reEmit(e, Object.values(CallEvent)), e.initStats(this.getGroupCallStats()), x();
	}
	disposeCall(e, b) {
		var x = getCallUserId(e), S = e.getOpponentDeviceId();
		if (!x) throw Error("Cannot dispose call without user id");
		var C = this.callHandlers.get(x), { onCallFeedsChanged: w, onCallStateChanged: T, onCallHangup: E, onCallReplaced: D } = C.get(S);
		if (e.removeListener(CallEvent.FeedsChanged, w), e.removeListener(CallEvent.State, T), e.removeListener(CallEvent.Hangup, E), e.removeListener(CallEvent.Replaced, D), C.delete(x), C.size === 0 && this.callHandlers.delete(x), e.hangupReason !== CallErrorCode.Replaced) {
			var O = this.getUserMediaFeed(x, S);
			O && this.removeUserMediaFeed(O);
			var k = this.getScreenshareFeed(x, S);
			k && this.removeScreenshareFeed(k);
		}
	}
	getUserMediaFeed(e, b) {
		return this.userMediaFeeds.find((x) => x.userId === e && x.deviceId === b);
	}
	addUserMediaFeed(e) {
		this.userMediaFeeds.push(e), e.measureVolumeActivity(!0), this.emit(GroupCallEvent.UserMediaFeedsChanged, this.userMediaFeeds);
	}
	replaceUserMediaFeed(e, b) {
		var x = this.userMediaFeeds.findIndex((b) => b.userId === e.userId && b.deviceId === e.deviceId);
		if (x === -1) throw Error("Couldn't find user media feed to replace");
		this.userMediaFeeds.splice(x, 1, b), e.dispose(), b.measureVolumeActivity(!0), this.emit(GroupCallEvent.UserMediaFeedsChanged, this.userMediaFeeds);
	}
	removeUserMediaFeed(e) {
		var b = this.userMediaFeeds.findIndex((b) => b.userId === e.userId && b.deviceId === e.deviceId);
		if (b === -1) throw Error("Couldn't find user media feed to remove");
		this.userMediaFeeds.splice(b, 1), e.dispose(), this.emit(GroupCallEvent.UserMediaFeedsChanged, this.userMediaFeeds), this.activeSpeaker === e && (this.activeSpeaker = this.userMediaFeeds[0], this.emit(GroupCallEvent.ActiveSpeakerChanged, this.activeSpeaker));
	}
	getScreenshareFeed(e, b) {
		return this.screenshareFeeds.find((x) => x.userId === e && x.deviceId === b);
	}
	addScreenshareFeed(e) {
		this.screenshareFeeds.push(e), this.emit(GroupCallEvent.ScreenshareFeedsChanged, this.screenshareFeeds);
	}
	replaceScreenshareFeed(e, b) {
		var x = this.screenshareFeeds.findIndex((b) => b.userId === e.userId && b.deviceId === e.deviceId);
		if (x === -1) throw Error("Couldn't find screenshare feed to replace");
		this.screenshareFeeds.splice(x, 1, b), e.dispose(), this.emit(GroupCallEvent.ScreenshareFeedsChanged, this.screenshareFeeds);
	}
	removeScreenshareFeed(e) {
		var b = this.screenshareFeeds.findIndex((b) => b.userId === e.userId && b.deviceId === e.deviceId);
		if (b === -1) throw Error("Couldn't find screenshare feed to remove");
		this.screenshareFeeds.splice(b, 1), e.dispose(), this.emit(GroupCallEvent.ScreenshareFeedsChanged, this.screenshareFeeds);
	}
	updateParticipants() {
		var e = this.room.getMember(this.client.getSafeUserId());
		if (!e) {
			logger.warn(`GroupCall ${this.groupCallId} updateParticipants() tried to update participants before local room member is available`);
			return;
		}
		if (this.participantsExpirationTimer !== null && (clearTimeout(this.participantsExpirationTimer), this.participantsExpirationTimer = null), this.state === GroupCallState.Ended) {
			this.participants = /* @__PURE__ */ new Map();
			return;
		}
		var b = /* @__PURE__ */ new Map(), x = Date.now(), S = this.state === GroupCallState.Entered || this.enteredViaAnotherSession, C = Infinity;
		for (var w of this.getMemberStateEvents()) {
			var T = this.room.getMember(w.getStateKey()), E = w.getContent(), D = (Array.isArray(E["m.calls"]) ? E["m.calls"] : []).find((e) => e["m.call_id"] === this.groupCallId), O = (Array.isArray(D?.["m.devices"]) ? D["m.devices"] : []).filter((e) => typeof e.device_id == "string" && typeof e.session_id == "string" && typeof e.expires_ts == "number" && e.expires_ts > x && Array.isArray(e.feeds));
			if (!S && T?.userId === this.client.getUserId() && (O = O.filter((e) => e.device_id !== this.client.getDeviceId())), O.length > 0 && T?.membership === KnownMembership.Join) {
				var k = /* @__PURE__ */ new Map();
				b.set(T, k);
				for (var A of O) k.set(A.device_id, {
					sessionId: A.session_id,
					screensharing: A.feeds.some((e) => e.purpose === SDPStreamMetadataPurpose.Screenshare)
				}), A.expires_ts < C && (C = A.expires_ts);
			}
		}
		if (S) {
			var j = b.get(e);
			j === void 0 && (j = /* @__PURE__ */ new Map(), b.set(e, j)), j.has(this.client.getDeviceId()) || j.set(this.client.getDeviceId(), {
				sessionId: this.client.getSessionId(),
				screensharing: this.getLocalFeeds().some((e) => e.purpose === SDPStreamMetadataPurpose.Screenshare)
			});
		}
		this.participants = b, C < Infinity && (this.participantsExpirationTimer = setTimeout(() => this.updateParticipants(), C - x));
	}
	updateDevices(e) {
		var b = arguments, x = this;
		return _asyncToGenerator(function* () {
			var S = b.length > 1 && b[1] !== void 0 ? b[1] : !1, C = Date.now(), w = x.client.getUserId(), T = x.getMemberStateEvents(w)?.getContent() ?? {}, E = Array.isArray(T["m.calls"]) ? T["m.calls"] : [], D = null, O = [];
			for (var k of E) k["m.call_id"] === x.groupCallId ? D = k : O.push(k);
			D === null && (D = {});
			var A = (Array.isArray(D["m.devices"]) ? D["m.devices"] : []).filter((e) => typeof e.device_id == "string" && typeof e.session_id == "string" && typeof e.expires_ts == "number" && e.expires_ts > C && Array.isArray(e.feeds)), j = e(A);
			if (j !== null) {
				var M = [...O];
				j.length > 0 && M.push(_objectSpread$11(_objectSpread$11({}, D), {}, {
					"m.call_id": x.groupCallId,
					"m.devices": j
				}));
				var N = { "m.calls": M };
				yield x.client.sendStateEvent(x.room.roomId, EventType.GroupCallMemberPrefix, N, w, { keepAlive: S });
			}
		})();
	}
	addDeviceToMemberState() {
		var e = this;
		return _asyncToGenerator(function* () {
			yield e.updateDevices((b) => [...b.filter((b) => b.device_id !== e.client.getDeviceId()), {
				device_id: e.client.getDeviceId(),
				session_id: e.client.getSessionId(),
				expires_ts: Date.now() + DEVICE_TIMEOUT,
				feeds: e.getLocalFeeds().map((e) => ({ purpose: e.purpose }))
			}]);
		})();
	}
	updateMemberState() {
		var e = this;
		return _asyncToGenerator(function* () {
			e.resendMemberStateTimer !== null && (clearInterval(e.resendMemberStateTimer), e.resendMemberStateTimer = null), e.state === GroupCallState.Entered ? (yield e.addDeviceToMemberState(), e.resendMemberStateTimer = setInterval(/* @__PURE__ */ _asyncToGenerator(function* () {
				logger.log(`GroupCall ${e.groupCallId} updateMemberState() resending call member state"`);
				try {
					yield e.addDeviceToMemberState();
				} catch (b) {
					logger.error(`GroupCall ${e.groupCallId} updateMemberState() failed to resend call member state`, b);
				}
			}), DEVICE_TIMEOUT * 3 / 4)) : yield e.updateDevices((b) => b.filter((b) => b.device_id !== e.client.getDeviceId()), !0);
		})();
	}
	cleanMemberState() {
		var e = this;
		return _asyncToGenerator(function* () {
			var { devices: b } = yield e.client.getDevices(), x = new Map(b.map((e) => [e.device_id, e]));
			yield e.updateDevices((b) => {
				var S = b.filter((b) => x.get(b.device_id)?.last_seen_ts !== void 0 && !(b.device_id === e.client.getDeviceId() && e.state !== GroupCallState.Entered && !e.enteredViaAnotherSession));
				return S.length === b.length ? null : S;
			});
		})();
	}
	getGroupCallStats() {
		if (this.stats === void 0) {
			var e = this.client.getUserId() || "unknown";
			this.stats = new GroupCallStats(this.groupCallId, e, this.statsCollectIntervalTime), this.stats.reports.on(StatsReport.CONNECTION_STATS, this.onConnectionStats), this.stats.reports.on(StatsReport.BYTE_SENT_STATS, this.onByteSentStats), this.stats.reports.on(StatsReport.SUMMARY_STATS, this.onSummaryStats), this.stats.reports.on(StatsReport.CALL_FEED_REPORT, this.onCallFeedReport);
		}
		return this.stats;
	}
	setGroupCallStatsInterval(e) {
		this.statsCollectIntervalTime = e, this.stats !== void 0 && (this.stats.stop(), this.stats.setInterval(e), e > 0 && this.stats.start());
	}
}, import_lib$2 = /* @__PURE__ */ __toESM(require_lib());
function ownKeys$10(e, b) {
	var x = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var S = Object.getOwnPropertySymbols(e);
		b && (S = S.filter(function(b) {
			return Object.getOwnPropertyDescriptor(e, b).enumerable;
		})), x.push.apply(x, S);
	}
	return x;
}
function _objectSpread$10(e) {
	for (var b = 1; b < arguments.length; b++) {
		var x = arguments[b] == null ? {} : arguments[b];
		b % 2 ? ownKeys$10(Object(x), !0).forEach(function(b) {
			_defineProperty(e, b, x[b]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(x)) : ownKeys$10(Object(x)).forEach(function(b) {
			Object.defineProperty(e, b, Object.getOwnPropertyDescriptor(x, b));
		});
	}
	return e;
}
var CallState = /* @__PURE__ */ function(e) {
	return e.Fledgling = "fledgling", e.InviteSent = "invite_sent", e.WaitLocalMedia = "wait_local_media", e.CreateOffer = "create_offer", e.CreateAnswer = "create_answer", e.Connecting = "connecting", e.Connected = "connected", e.Ringing = "ringing", e.Ended = "ended", e;
}({}), CallType = /* @__PURE__ */ function(e) {
	return e.Voice = "voice", e.Video = "video", e;
}({}), CallDirection = /* @__PURE__ */ function(e) {
	return e.Inbound = "inbound", e.Outbound = "outbound", e;
}({}), CallParty = /* @__PURE__ */ function(e) {
	return e.Local = "local", e.Remote = "remote", e;
}({}), CallEvent = /* @__PURE__ */ function(e) {
	return e.Hangup = "hangup", e.State = "state", e.Error = "error", e.Replaced = "replaced", e.LocalHoldUnhold = "local_hold_unhold", e.RemoteHoldUnhold = "remote_hold_unhold", e.HoldUnhold = "hold_unhold", e.FeedsChanged = "feeds_changed", e.AssertedIdentityChanged = "asserted_identity_changed", e.LengthChanged = "length_changed", e.DataChannel = "datachannel", e.SendVoipEvent = "send_voip_event", e.PeerConnectionCreated = "peer_connection_created", e;
}({}), CallErrorCode = /* @__PURE__ */ function(e) {
	return e.UserHangup = "user_hangup", e.LocalOfferFailed = "local_offer_failed", e.NoUserMedia = "no_user_media", e.UnknownDevices = "unknown_devices", e.SendInvite = "send_invite", e.CreateAnswer = "create_answer", e.CreateOffer = "create_offer", e.SendAnswer = "send_answer", e.SetRemoteDescription = "set_remote_description", e.SetLocalDescription = "set_local_description", e.AnsweredElsewhere = "answered_elsewhere", e.IceFailed = "ice_failed", e.InviteTimeout = "invite_timeout", e.Replaced = "replaced", e.SignallingFailed = "signalling_timeout", e.UserBusy = "user_busy", e.Transferred = "transferred", e.NewSession = "new_session", e;
}({}), VOIP_PROTO_VERSION = "1", FALLBACK_ICE_SERVER = "stun:turn.matrix.org", CALL_TIMEOUT_MS = 60 * 1e3, CALL_LENGTH_INTERVAL = 1e3, ICE_DISCONNECTED_TIMEOUT = 30 * 1e3, ICE_RECONNECTING_TIMEOUT = 2 * 1e3, CallError = class extends Error {
	constructor(e, b, x) {
		super(b + ": " + x), _defineProperty(this, "code", void 0), this.code = e;
	}
};
function genCallID() {
	return Date.now().toString() + secureRandomString(16);
}
function getCodecParamMods(e) {
	return [{
		mediaType: "audio",
		codec: "opus",
		enableDtx: !0,
		maxAverageBitrate: e ? 12e3 : void 0
	}];
}
function getTransceiverKey(e, b) {
	return e + ":" + b;
}
var MatrixCall = class extends TypedEventEmitter {
	constructor(e) {
		var b;
		if (super(), b = this, _defineProperty(this, "roomId", void 0), _defineProperty(this, "callId", void 0), _defineProperty(this, "invitee", void 0), _defineProperty(this, "hangupParty", void 0), _defineProperty(this, "hangupReason", void 0), _defineProperty(this, "direction", void 0), _defineProperty(this, "ourPartyId", void 0), _defineProperty(this, "peerConn", void 0), _defineProperty(this, "toDeviceSeq", 0), _defineProperty(this, "isPtt", !1), _defineProperty(this, "_state", CallState.Fledgling), _defineProperty(this, "client", void 0), _defineProperty(this, "forceTURN", void 0), _defineProperty(this, "turnServers", void 0), _defineProperty(this, "candidateSendQueue", []), _defineProperty(this, "candidateSendTries", 0), _defineProperty(this, "candidatesEnded", !1), _defineProperty(this, "feeds", []), _defineProperty(this, "transceivers", /* @__PURE__ */ new Map()), _defineProperty(this, "inviteOrAnswerSent", !1), _defineProperty(this, "waitForLocalAVStream", !1), _defineProperty(this, "successor", void 0), _defineProperty(this, "opponentMember", void 0), _defineProperty(this, "opponentVersion", void 0), _defineProperty(this, "opponentPartyId", void 0), _defineProperty(this, "opponentCaps", void 0), _defineProperty(this, "iceDisconnectedTimeout", void 0), _defineProperty(this, "iceReconnectionTimeOut", void 0), _defineProperty(this, "inviteTimeout", void 0), _defineProperty(this, "removeTrackListeners", /* @__PURE__ */ new Map()), _defineProperty(this, "remoteOnHold", !1), _defineProperty(this, "callStatsAtEnd", void 0), _defineProperty(this, "makingOffer", !1), _defineProperty(this, "ignoreOffer", !1), _defineProperty(this, "isSettingRemoteAnswerPending", !1), _defineProperty(this, "responsePromiseChain", void 0), _defineProperty(this, "remoteCandidateBuffer", /* @__PURE__ */ new Map()), _defineProperty(this, "remoteAssertedIdentity", void 0), _defineProperty(this, "remoteSDPStreamMetadata", void 0), _defineProperty(this, "callLengthInterval", void 0), _defineProperty(this, "callStartTime", void 0), _defineProperty(this, "opponentDeviceId", void 0), _defineProperty(this, "hasOpponentDeviceInfo", void 0), _defineProperty(this, "opponentSessionId", void 0), _defineProperty(this, "groupCallId", void 0), _defineProperty(this, "stopVideoTrackTimer", void 0), _defineProperty(this, "isOnlyDataChannelAllowed", void 0), _defineProperty(this, "stats", void 0), _defineProperty(this, "gotLocalIceCandidate", (e) => {
			if (e.candidate) {
				if (this.candidatesEnded && logger.warn(`Call ${this.callId} gotLocalIceCandidate() got candidate after candidates have ended!`), logger.debug(`Call ${this.callId} got local ICE ${e.candidate.sdpMid} ${e.candidate.candidate}`), this.callHasEnded()) return;
				e.candidate.candidate === "" ? this.queueCandidate(null) : this.queueCandidate(e.candidate);
			}
		}), _defineProperty(this, "onIceGatheringStateChange", (e) => {
			logger.debug(`Call ${this.callId} onIceGatheringStateChange() ice gathering state changed to ${this.peerConn.iceGatheringState}`), this.peerConn?.iceGatheringState === "complete" && (this.queueCandidate(null), logger.debug(`Call ${this.callId} onIceGatheringStateChange() ice gathering state complete, set candidates have ended`));
		}), _defineProperty(this, "getLocalOfferFailed", (e) => {
			logger.error(`Call ${this.callId} getLocalOfferFailed() running`, e), this.emit(CallEvent.Error, new CallError(CallErrorCode.LocalOfferFailed, "Failed to get local offer!", e), this), this.terminate(CallParty.Local, CallErrorCode.LocalOfferFailed, !1);
		}), _defineProperty(this, "getUserMediaFailed", (e) => {
			if (this.successor) {
				this.successor.getUserMediaFailed(e);
				return;
			}
			logger.warn(`Call ${this.callId} getUserMediaFailed() failed to get user media - ending call`, e), this.emit(CallEvent.Error, new CallError(CallErrorCode.NoUserMedia, "Couldn't start capturing media! Is your microphone set up and does this app have permission?", e), this), this.terminate(CallParty.Local, CallErrorCode.NoUserMedia, !1);
		}), _defineProperty(this, "placeCallFailed", (e) => {
			if (this.successor) {
				this.successor.placeCallFailed(e);
				return;
			}
			logger.warn(`Call ${this.callId} placeCallWithCallFeeds() failed - ending call`, e), this.emit(CallEvent.Error, new CallError(CallErrorCode.IceFailed, "Couldn't start call! Invalid ICE server configuration.", e), this), this.terminate(CallParty.Local, CallErrorCode.IceFailed, !1);
		}), _defineProperty(this, "onIceConnectionStateChanged", () => {
			if (!this.callHasEnded()) {
				if (logger.debug(`Call ${this.callId} onIceConnectionStateChanged() running (state=${this.peerConn?.iceConnectionState}, conn=${this.peerConn?.connectionState})`), ["connected", "completed"].includes(this.peerConn?.iceConnectionState ?? "")) clearTimeout(this.iceDisconnectedTimeout), this.iceDisconnectedTimeout = void 0, this.iceReconnectionTimeOut && clearTimeout(this.iceReconnectionTimeOut), this.state = CallState.Connected, !this.callLengthInterval && !this.callStartTime && (this.callStartTime = Date.now(), this.callLengthInterval = setInterval(() => {
					this.emit(CallEvent.LengthChanged, Math.round((Date.now() - this.callStartTime) / 1e3), this);
				}, CALL_LENGTH_INTERVAL));
				else if (this.peerConn?.iceConnectionState == "failed") {
					var e;
					this.candidatesEnded = !1, (e = this.peerConn) != null && e.restartIce ? (this.candidatesEnded = !1, logger.debug(`Call ${this.callId} onIceConnectionStateChanged() ice restart (state=${this.peerConn?.iceConnectionState})`), this.peerConn.restartIce()) : (logger.info(`Call ${this.callId} onIceConnectionStateChanged() hanging up call (ICE failed and no ICE restart method)`), this.hangup(CallErrorCode.IceFailed, !1));
				} else this.peerConn?.iceConnectionState == "disconnected" && (this.candidatesEnded = !1, this.iceReconnectionTimeOut = setTimeout(() => {
					var e;
					logger.info(`Call ${this.callId} onIceConnectionStateChanged() ICE restarting because of ICE disconnected, (state=${this.peerConn?.iceConnectionState}, conn=${this.peerConn?.connectionState})`), (e = this.peerConn) != null && e.restartIce && (this.candidatesEnded = !1, this.peerConn.restartIce()), this.iceReconnectionTimeOut = void 0;
				}, ICE_RECONNECTING_TIMEOUT), this.iceDisconnectedTimeout = setTimeout(() => {
					logger.info(`Call ${this.callId} onIceConnectionStateChanged() hanging up call (ICE disconnected for too long)`), this.hangup(CallErrorCode.IceFailed, !1);
				}, ICE_DISCONNECTED_TIMEOUT), this.state = CallState.Connecting);
				if (this.isPtt && ["failed", "disconnected"].includes(this.peerConn.iceConnectionState)) for (var b of this.getRemoteFeeds()) b.setAudioVideoMuted(!0, !0);
			}
		}), _defineProperty(this, "onSignallingStateChanged", () => {
			logger.debug(`Call ${this.callId} onSignallingStateChanged() running (state=${this.peerConn?.signalingState})`);
		}), _defineProperty(this, "onTrack", (e) => {
			if (e.streams.length === 0) {
				logger.warn(`Call ${this.callId} onTrack() called with streamless track streamless (kind=${e.track.kind})`);
				return;
			}
			var b = e.streams[0];
			if (this.pushRemoteFeed(b), !this.removeTrackListeners.has(b)) {
				var x = () => {
					b.getTracks().length === 0 && (logger.info(`Call ${this.callId} onTrack() removing track (streamId=${b.id})`), this.deleteFeedByStream(b), b.removeEventListener("removetrack", x), this.removeTrackListeners.delete(b));
				};
				b.addEventListener("removetrack", x), this.removeTrackListeners.set(b, x);
			}
		}), _defineProperty(this, "onDataChannel", (e) => {
			this.emit(CallEvent.DataChannel, e.channel, this);
		}), _defineProperty(this, "onNegotiationNeeded", /* @__PURE__ */ _asyncToGenerator(function* () {
			if (logger.info(`Call ${b.callId} onNegotiationNeeded() negotiation is needed!`), b.state !== CallState.CreateOffer && b.opponentVersion === 0) {
				logger.info(`Call ${b.callId} onNegotiationNeeded() opponent does not support renegotiation: ignoring negotiationneeded event`);
				return;
			}
			b.queueGotLocalOffer();
		})), _defineProperty(this, "onHangupReceived", (e) => {
			logger.debug(`Call ${this.callId} onHangupReceived() running`), this.partyIdMatches(e) || this.state === CallState.Ringing ? this.terminate(CallParty.Remote, e.reason || CallErrorCode.UserHangup, !0) : logger.info(`Call ${this.callId} onHangupReceived() ignoring message from party ID ${e.party_id}: our partner is ${this.opponentPartyId}`);
		}), _defineProperty(this, "onRejectReceived", (e) => {
			logger.debug(`Call ${this.callId} onRejectReceived() running`), [CallState.InviteSent, CallState.Ringing].includes(this.state) || this.state === CallState.Fledgling && this.direction === CallDirection.Inbound ? this.terminate(CallParty.Remote, e.reason || CallErrorCode.UserHangup, !0) : logger.debug(`Call ${this.callId} onRejectReceived() called in wrong state (state=${this.state})`);
		}), _defineProperty(this, "onAnsweredElsewhere", (e) => {
			logger.debug(`Call ${this.callId} onAnsweredElsewhere() running`), this.terminate(CallParty.Remote, CallErrorCode.AnsweredElsewhere, !0);
		}), this.roomId = e.roomId, this.invitee = e.invitee, this.client = e.client, !this.client.deviceId) throw Error("Client must have a device ID to start calls");
		this.forceTURN = e.forceTURN ?? !1, this.ourPartyId = this.client.deviceId, this.opponentDeviceId = e.opponentDeviceId, this.opponentSessionId = e.opponentSessionId, this.groupCallId = e.groupCallId, this.turnServers = e.turnServers || [], this.turnServers.length === 0 && this.client.isFallbackICEServerAllowed() && this.turnServers.push({ urls: [FALLBACK_ICE_SERVER] });
		for (var x of this.turnServers) checkObjectHasKeys(x, ["urls"]);
		this.callId = genCallID(), this.isOnlyDataChannelAllowed = this.client.isVoipWithNoMediaAllowed;
	}
	placeVoiceCall() {
		var e = this;
		return _asyncToGenerator(function* () {
			yield e.placeCall(!0, !1);
		})();
	}
	placeVideoCall() {
		var e = this;
		return _asyncToGenerator(function* () {
			yield e.placeCall(!0, !0);
		})();
	}
	createDataChannel(e, b) {
		var x = this.peerConn.createDataChannel(e, b);
		return this.emit(CallEvent.DataChannel, x, this), x;
	}
	getOpponentMember() {
		return this.opponentMember;
	}
	getOpponentDeviceId() {
		return this.opponentDeviceId;
	}
	getOpponentSessionId() {
		return this.opponentSessionId;
	}
	opponentCanBeTransferred() {
		return !!(this.opponentCaps && this.opponentCaps["m.call.transferee"]);
	}
	opponentSupportsDTMF() {
		return !!(this.opponentCaps && this.opponentCaps["m.call.dtmf"]);
	}
	getRemoteAssertedIdentity() {
		return this.remoteAssertedIdentity;
	}
	get state() {
		return this._state;
	}
	set state(e) {
		var b = this._state;
		this._state = e, this.emit(CallEvent.State, e, b, this);
	}
	get type() {
		return this.hasUserMediaVideoSender || this.hasRemoteUserMediaVideoTrack ? CallType.Video : CallType.Voice;
	}
	get hasLocalUserMediaVideoTrack() {
		var e;
		return !!((e = this.localUsermediaStream) != null && e.getVideoTracks().length);
	}
	get hasRemoteUserMediaVideoTrack() {
		return this.getRemoteFeeds().some((e) => e.purpose === SDPStreamMetadataPurpose.Usermedia && e.stream?.getVideoTracks().length);
	}
	get hasLocalUserMediaAudioTrack() {
		var e;
		return !!((e = this.localUsermediaStream) != null && e.getAudioTracks().length);
	}
	get hasRemoteUserMediaAudioTrack() {
		return this.getRemoteFeeds().some((e) => {
			var b;
			return e.purpose === SDPStreamMetadataPurpose.Usermedia && !!((b = e.stream) != null && b.getAudioTracks().length);
		});
	}
	get hasUserMediaAudioSender() {
		return !!this.transceivers.get(getTransceiverKey(SDPStreamMetadataPurpose.Usermedia, "audio"))?.sender;
	}
	get hasUserMediaVideoSender() {
		return !!this.transceivers.get(getTransceiverKey(SDPStreamMetadataPurpose.Usermedia, "video"))?.sender;
	}
	get localUsermediaFeed() {
		return this.getLocalFeeds().find((e) => e.purpose === SDPStreamMetadataPurpose.Usermedia);
	}
	get localScreensharingFeed() {
		return this.getLocalFeeds().find((e) => e.purpose === SDPStreamMetadataPurpose.Screenshare);
	}
	get localUsermediaStream() {
		return this.localUsermediaFeed?.stream;
	}
	get localScreensharingStream() {
		return this.localScreensharingFeed?.stream;
	}
	get remoteUsermediaFeed() {
		return this.getRemoteFeeds().find((e) => e.purpose === SDPStreamMetadataPurpose.Usermedia);
	}
	get remoteScreensharingFeed() {
		return this.getRemoteFeeds().find((e) => e.purpose === SDPStreamMetadataPurpose.Screenshare);
	}
	get remoteUsermediaStream() {
		return this.remoteUsermediaFeed?.stream;
	}
	get remoteScreensharingStream() {
		return this.remoteScreensharingFeed?.stream;
	}
	getFeedByStreamId(e) {
		return this.getFeeds().find((b) => b.stream.id === e);
	}
	getFeeds() {
		return this.feeds;
	}
	getLocalFeeds() {
		return this.feeds.filter((e) => e.isLocal());
	}
	getRemoteFeeds() {
		return this.feeds.filter((e) => !e.isLocal());
	}
	initOpponentCrypto() {
		var e = this;
		return _asyncToGenerator(function* () {
			if (e.opponentDeviceId && e.client.getUseE2eForGroupCall()) {
				if (!e.client.getCrypto()) {
					e.hasOpponentDeviceInfo = !0;
					return;
				}
				var b = e.invitee || e.getOpponentMember()?.userId;
				throw b ? (e.hasOpponentDeviceInfo = !1, new GroupCallUnknownDeviceError(b)) : Error("Couldn't find opponent user ID to init crypto");
			}
		})();
	}
	getLocalSDPStreamMetadata() {
		var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, b = {};
		for (var x of this.getLocalFeeds()) e && (x.sdpMetadataStreamId = x.stream.id), b[x.sdpMetadataStreamId] = {
			purpose: x.purpose,
			audio_muted: x.isAudioMuted(),
			video_muted: x.isVideoMuted()
		};
		return b;
	}
	noIncomingFeeds() {
		return !this.feeds.some((e) => !e.isLocal());
	}
	pushRemoteFeed(e) {
		if (!this.opponentSupportsSDPStreamMetadata()) {
			this.pushRemoteFeedWithoutMetadata(e);
			return;
		}
		var b = this.getOpponentMember().userId, x = this.remoteSDPStreamMetadata[e.id].purpose, S = this.remoteSDPStreamMetadata[e.id].audio_muted, C = this.remoteSDPStreamMetadata[e.id].video_muted;
		if (!x) {
			logger.warn(`Call ${this.callId} pushRemoteFeed() ignoring stream because we didn't get any metadata about it (streamId=${e.id})`);
			return;
		}
		if (this.getFeedByStreamId(e.id)) {
			logger.warn(`Call ${this.callId} pushRemoteFeed() ignoring stream because we already have a feed for it (streamId=${e.id})`);
			return;
		}
		this.feeds.push(new CallFeed({
			client: this.client,
			call: this,
			roomId: this.roomId,
			userId: b,
			deviceId: this.getOpponentDeviceId(),
			stream: e,
			purpose: x,
			audioMuted: S,
			videoMuted: C
		})), this.emit(CallEvent.FeedsChanged, this.feeds, this), logger.info(`Call ${this.callId} pushRemoteFeed() pushed stream (streamId=${e.id}, active=${e.active}, purpose=${x})`);
	}
	pushRemoteFeedWithoutMetadata(e) {
		var b = this.getOpponentMember().userId, x = SDPStreamMetadataPurpose.Usermedia, S = this.feeds.find((e) => !e.isLocal())?.stream;
		if (S && e.id !== S.id) {
			logger.warn(`Call ${this.callId} pushRemoteFeedWithoutMetadata() ignoring new stream because we already have stream (streamId=${e.id})`);
			return;
		}
		if (this.getFeedByStreamId(e.id)) {
			logger.warn(`Call ${this.callId} pushRemoteFeedWithoutMetadata() ignoring stream because we already have a feed for it (streamId=${e.id})`);
			return;
		}
		this.feeds.push(new CallFeed({
			client: this.client,
			call: this,
			roomId: this.roomId,
			audioMuted: !1,
			videoMuted: !1,
			userId: b,
			deviceId: this.getOpponentDeviceId(),
			stream: e,
			purpose: x
		})), this.emit(CallEvent.FeedsChanged, this.feeds, this), logger.info(`Call ${this.callId} pushRemoteFeedWithoutMetadata() pushed stream (streamId=${e.id}, active=${e.active})`);
	}
	pushNewLocalFeed(e, b) {
		var x = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, S = this.client.getUserId();
		if (setTracksEnabled(e.getAudioTracks(), !0), setTracksEnabled(e.getVideoTracks(), !0), this.getFeedByStreamId(e.id)) {
			logger.warn(`Call ${this.callId} pushNewLocalFeed() ignoring stream because we already have a feed for it (streamId=${e.id})`);
			return;
		}
		this.pushLocalFeed(new CallFeed({
			client: this.client,
			roomId: this.roomId,
			audioMuted: !1,
			videoMuted: !1,
			userId: S,
			deviceId: this.getOpponentDeviceId(),
			stream: e,
			purpose: b
		}), x);
	}
	pushLocalFeed(e) {
		var b = this, x = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
		if (this.feeds.some((b) => e.stream.id === b.stream.id)) {
			logger.info(`Call ${this.callId} pushLocalFeed() ignoring duplicate local stream (streamId=${e.stream.id})`);
			return;
		}
		if (this.feeds.push(e), x) {
			var S = function() {
				logger.info(`Call ${b.callId} pushLocalFeed() adding track to peer connection (id=${C.id}, kind=${C.kind}, streamId=${e.stream.id}, streamPurpose=${e.purpose}, enabled=${C.enabled})`);
				var x = getTransceiverKey(e.purpose, C.kind);
				if (b.transceivers.has(x)) {
					var S = b.transceivers.get(x);
					S.sender.replaceTrack(C), S.direction = S.direction === "inactive" ? "sendonly" : "sendrecv";
				} else {
					var w = b.peerConn.addTrack(C, e.stream), T = b.peerConn.getTransceivers().find((e) => e.sender === w);
					T ? b.transceivers.set(x, T) : logger.warn(`Call ${b.callId} pushLocalFeed() didn't find a matching transceiver after adding track!`);
				}
			};
			for (var C of e.stream.getTracks()) S();
		}
		logger.info(`Call ${this.callId} pushLocalFeed() pushed stream (id=${e.stream.id}, active=${e.stream.active}, purpose=${e.purpose})`), this.emit(CallEvent.FeedsChanged, this.feeds, this);
	}
	removeLocalFeed(e) {
		var b = getTransceiverKey(e.purpose, "audio"), x = getTransceiverKey(e.purpose, "video");
		for (var S of [b, x]) if (this.transceivers.has(S)) {
			var C = this.transceivers.get(S);
			C.sender && this.peerConn.removeTrack(C.sender);
		}
		e.purpose === SDPStreamMetadataPurpose.Screenshare && this.client.getMediaHandler().stopScreensharingStream(e.stream), this.deleteFeed(e);
	}
	deleteAllFeeds() {
		for (var e of this.feeds) (!e.isLocal() || !this.groupCallId) && e.dispose();
		this.feeds = [], this.emit(CallEvent.FeedsChanged, this.feeds, this);
	}
	deleteFeedByStream(e) {
		var b = this.getFeedByStreamId(e.id);
		if (!b) {
			logger.warn(`Call ${this.callId} deleteFeedByStream() didn't find the feed to delete (streamId=${e.id})`);
			return;
		}
		this.deleteFeed(b);
	}
	deleteFeed(e) {
		e.dispose(), this.feeds.splice(this.feeds.indexOf(e), 1), this.emit(CallEvent.FeedsChanged, this.feeds, this);
	}
	getCurrentCallStats() {
		var e = this;
		return _asyncToGenerator(function* () {
			return e.callHasEnded() ? e.callStatsAtEnd : e.collectCallStats();
		})();
	}
	collectCallStats() {
		var e = this;
		return _asyncToGenerator(function* () {
			if (e.peerConn) {
				var b = yield e.peerConn.getStats(), x = [];
				return b.forEach((e) => {
					x.push(e);
				}), x;
			}
		})();
	}
	initWithInvite(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			var x = e.getContent();
			b.direction = CallDirection.Inbound, (yield b.client.checkTurnServers()) || logger.warn(`Call ${b.callId} initWithInvite() failed to get TURN credentials! Proceeding with call anyway...`);
			var S = x[SDPStreamMetadataKey];
			S ? b.updateRemoteSDPStreamMetadata(S) : logger.debug(`Call ${b.callId} initWithInvite() did not get any SDPStreamMetadata! Can not send/receive multiple streams`), b.peerConn = b.createPeerConnection(), b.emit(CallEvent.PeerConnectionCreated, b.peerConn, b), b.chooseOpponent(e), yield b.initOpponentCrypto();
			try {
				yield b.peerConn.setRemoteDescription(x.offer), logger.debug(`Call ${b.callId} initWithInvite() set remote description: ${x.offer.type}`), yield b.addBufferedIceCandidates();
			} catch (e) {
				logger.debug(`Call ${b.callId} initWithInvite() failed to set remote description`, e), b.terminate(CallParty.Local, CallErrorCode.SetRemoteDescription, !1);
				return;
			}
			var C = b.feeds.find((e) => !e.isLocal())?.stream;
			if (!b.isOnlyDataChannelAllowed && (!C || C.getTracks().length === 0)) {
				logger.error(`Call ${b.callId} initWithInvite() no remote stream or no tracks after setting remote description!`), b.terminate(CallParty.Local, CallErrorCode.SetRemoteDescription, !1);
				return;
			}
			if (b.state = CallState.Ringing, e.getLocalAge()) {
				var w = setTimeout(() => {
					if (b.state == CallState.Ringing) {
						var e;
						logger.debug(`Call ${b.callId} initWithInvite() invite has expired. Hanging up.`), b.hangupParty = CallParty.Remote, b.state = CallState.Ended, b.stopAllMedia(), b.peerConn.signalingState != "closed" && b.peerConn.close(), (e = b.stats) == null || e.removeStatsReportGatherer(b.callId), b.emit(CallEvent.Hangup, b);
					}
				}, x.lifetime - e.getLocalAge()), T = (e) => {
					e !== CallState.Ringing && (clearTimeout(w), b.off(CallEvent.State, T));
				};
				b.on(CallEvent.State, T);
			}
		})();
	}
	initWithHangup(e) {
		this.state = CallState.Ended;
	}
	shouldAnswerWithMediaType(e, b, x) {
		return e && !b ? (logger.warn(`Call ${this.callId} shouldAnswerWithMediaType() unable to answer with ${x} because the other side isn't sending it either.`), !1) : !isNullOrUndefined(e) && e !== b && !this.opponentSupportsSDPStreamMetadata() ? (logger.warn(`Call ${this.callId} shouldAnswerWithMediaType() unable to answer with ${x}=${e} because the other side doesn't support it. Answering with ${x}=${b}.`), b) : e ?? b;
	}
	answer(e, b) {
		var x = this;
		return _asyncToGenerator(function* () {
			if (!x.inviteOrAnswerSent) {
				if (e === !1 && b === !1) throw Error("You CANNOT answer a call without media");
				if (!x.localUsermediaStream && !x.waitForLocalAVStream) {
					var S = x.state, C = x.shouldAnswerWithMediaType(e, x.hasRemoteUserMediaAudioTrack, "audio"), w = x.shouldAnswerWithMediaType(b, x.hasRemoteUserMediaVideoTrack, "video");
					x.state = CallState.WaitLocalMedia, x.waitForLocalAVStream = !0;
					try {
						var T = yield x.client.getMediaHandler().getUserMediaStream(C, w);
						x.waitForLocalAVStream = !1;
						var E = [new CallFeed({
							client: x.client,
							roomId: x.roomId,
							userId: x.client.getUserId(),
							deviceId: x.client.getDeviceId() ?? void 0,
							stream: T,
							purpose: SDPStreamMetadataPurpose.Usermedia,
							audioMuted: !1,
							videoMuted: !1
						})];
						x.localScreensharingFeed && E.push(x.localScreensharingFeed), x.answerWithCallFeeds(E);
					} catch (e) {
						if (w) logger.warn(`Call ${x.callId} answer() failed to getUserMedia(), trying to getUserMedia() without video`), x.state = S, x.waitForLocalAVStream = !1, yield x.answer(C, !1);
						else {
							x.getUserMediaFailed(e);
							return;
						}
					}
				} else x.waitForLocalAVStream && (x.state = CallState.WaitLocalMedia);
			}
		})();
	}
	answerWithCallFeeds(e) {
		this.inviteOrAnswerSent || this.queueGotCallFeedsForAnswer(e);
	}
	replacedBy(e) {
		logger.debug(`Call ${this.callId} replacedBy() running (newCallId=${e.callId})`), this.state === CallState.WaitLocalMedia ? (logger.debug(`Call ${this.callId} replacedBy() telling new call to wait for local media (newCallId=${e.callId})`), e.waitForLocalAVStream = !0) : [CallState.CreateOffer, CallState.InviteSent].includes(this.state) && (e.direction === CallDirection.Outbound ? e.queueGotCallFeedsForAnswer([]) : (logger.debug(`Call ${this.callId} replacedBy() handing local stream to new call(newCallId=${e.callId})`), e.queueGotCallFeedsForAnswer(this.getLocalFeeds().map((e) => e.clone())))), this.successor = e, this.emit(CallEvent.Replaced, e, this), this.hangup(CallErrorCode.Replaced, !0);
	}
	hangup(e, b) {
		if (!this.callHasEnded() && (logger.debug(`Call ${this.callId} hangup() ending call (reason=${e})`), this.terminate(CallParty.Local, e, !b), ![CallState.Fledgling, CallState.WaitLocalMedia].includes(this.state))) {
			var x = {};
			(this.opponentVersion && this.opponentVersion !== 0 || e !== CallErrorCode.UserHangup) && (x.reason = e), this.sendVoipEvent(EventType.CallHangup, x);
		}
	}
	reject() {
		if (this.state !== CallState.Ringing) throw Error("Call must be in 'ringing' state to reject!");
		if (this.opponentVersion === 0) {
			logger.info(`Call ${this.callId} reject() opponent version is less than 1: sending hangup instead of reject (opponentVersion=${this.opponentVersion})`), this.hangup(CallErrorCode.UserHangup, !0);
			return;
		}
		logger.debug("Rejecting call: " + this.callId), this.terminate(CallParty.Local, CallErrorCode.UserHangup, !0), this.sendVoipEvent(EventType.CallReject, {});
	}
	upgradeCall(e, b) {
		var x = this;
		return _asyncToGenerator(function* () {
			if (!(!e && !b) && x.opponentSupportsSDPStreamMetadata()) try {
				logger.debug(`Call ${x.callId} upgradeCall() upgrading call (audio=${e}, video=${b})`);
				var S = e || x.hasLocalUserMediaAudioTrack, C = b || x.hasLocalUserMediaVideoTrack, w = yield x.client.getMediaHandler().getUserMediaStream(S, C, !1);
				yield x.updateLocalUsermediaStream(w, e, b);
			} catch (e) {
				logger.error(`Call ${x.callId} upgradeCall() failed to upgrade the call`, e), x.emit(CallEvent.Error, new CallError(CallErrorCode.NoUserMedia, "Failed to get camera access: ", e), x);
			}
		})();
	}
	opponentSupportsSDPStreamMetadata() {
		return !!this.remoteSDPStreamMetadata;
	}
	isScreensharing() {
		return !!this.localScreensharingStream;
	}
	setScreensharingEnabled(e, b) {
		var x = this;
		return _asyncToGenerator(function* () {
			if (e && x.isScreensharing()) return logger.warn(`Call ${x.callId} setScreensharingEnabled() there is already a screensharing stream - there is nothing to do!`), !0;
			if (!e && !x.isScreensharing()) return logger.warn(`Call ${x.callId} setScreensharingEnabled() there already isn't a screensharing stream - there is nothing to do!`), !1;
			if (!x.opponentSupportsSDPStreamMetadata()) return x.setScreensharingEnabledWithoutMetadataSupport(e, b);
			if (logger.debug(`Call ${x.callId} setScreensharingEnabled() running (enabled=${e})`), e) try {
				var S = yield x.client.getMediaHandler().getScreensharingStream(b);
				return S ? (x.pushNewLocalFeed(S, SDPStreamMetadataPurpose.Screenshare), !0) : !1;
			} catch (e) {
				return logger.error(`Call ${x.callId} setScreensharingEnabled() failed to get screen-sharing stream:`, e), !1;
			}
			else {
				var C = x.transceivers.get(getTransceiverKey(SDPStreamMetadataPurpose.Screenshare, "audio")), w = x.transceivers.get(getTransceiverKey(SDPStreamMetadataPurpose.Screenshare, "video"));
				for (var T of [C, w]) T && T.sender && x.peerConn.removeTrack(T.sender);
				return x.client.getMediaHandler().stopScreensharingStream(x.localScreensharingStream), x.deleteFeedByStream(x.localScreensharingStream), !1;
			}
		})();
	}
	setScreensharingEnabledWithoutMetadataSupport(e, b) {
		var x = this;
		return _asyncToGenerator(function* () {
			if (logger.debug(`Call ${x.callId} setScreensharingEnabledWithoutMetadataSupport() running (enabled=${e})`), e) try {
				var S = yield x.client.getMediaHandler().getScreensharingStream(b);
				if (!S) return !1;
				var C = S.getTracks().find((e) => e.kind === "video");
				return (x.transceivers.get(getTransceiverKey(SDPStreamMetadataPurpose.Usermedia, "video"))?.sender)?.replaceTrack(C ?? null), x.pushNewLocalFeed(S, SDPStreamMetadataPurpose.Screenshare, !1), !0;
			} catch (e) {
				return logger.error(`Call ${x.callId} setScreensharingEnabledWithoutMetadataSupport() failed to get screen-sharing stream:`, e), !1;
			}
			else {
				var w = x.localUsermediaStream?.getTracks().find((e) => e.kind === "video");
				return (x.transceivers.get(getTransceiverKey(SDPStreamMetadataPurpose.Usermedia, "video"))?.sender)?.replaceTrack(w ?? null), x.client.getMediaHandler().stopScreensharingStream(x.localScreensharingStream), x.deleteFeedByStream(x.localScreensharingStream), !1;
			}
		})();
	}
	updateLocalUsermediaStream(e) {
		var b = arguments, x = this;
		return _asyncToGenerator(function* () {
			var S = b.length > 1 && b[1] !== void 0 ? b[1] : !1, C = b.length > 2 && b[2] !== void 0 ? b[2] : !1, w = x.localUsermediaFeed, T = S || !w.isAudioMuted() && !x.remoteOnHold, E = C || !w.isVideoMuted() && !x.remoteOnHold;
			logger.log(`Call ${x.callId} updateLocalUsermediaStream() running (streamId=${e.id}, audio=${T}, video=${E})`), setTracksEnabled(e.getAudioTracks(), T), setTracksEnabled(e.getVideoTracks(), E);
			for (var D of x.localUsermediaStream.getTracks()) x.localUsermediaStream.removeTrack(D), D.stop();
			for (var O of e.getTracks()) x.localUsermediaStream.addTrack(O);
			var k = function* () {
				var b = getTransceiverKey(SDPStreamMetadataPurpose.Usermedia, A.kind), S = x.transceivers.get(b), C = S?.sender, T = !1;
				if (C) try {
					logger.info(`Call ${x.callId} updateLocalUsermediaStream() replacing track (id=${A.id}, kind=${A.kind}, streamId=${e.id}, streamPurpose=${w.purpose})`), yield C.replaceTrack(A), S.direction = S.direction === "inactive" ? "sendonly" : "sendrecv", T = !0;
				} catch (e) {
					logger.warn(`Call ${x.callId} updateLocalUsermediaStream() replaceTrack failed: adding new transceiver instead`, e);
				}
				if (!T) {
					logger.info(`Call ${x.callId} updateLocalUsermediaStream() adding track to peer connection (id=${A.id}, kind=${A.kind}, streamId=${e.id}, streamPurpose=${w.purpose})`);
					var E = x.peerConn.addTrack(A, x.localUsermediaStream), D = x.peerConn.getTransceivers().find((e) => e.sender === E);
					D ? x.transceivers.set(b, D) : logger.warn(`Call ${x.callId} updateLocalUsermediaStream() couldn't find matching transceiver for newly added track!`);
				}
			};
			for (var A of e.getTracks()) yield* k();
		})();
	}
	setLocalVideoMuted(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			var x;
			if (logger.log(`Call ${b.callId} setLocalVideoMuted() running ${e}`), !e && b.stopVideoTrackTimer !== void 0 && (clearTimeout(b.stopVideoTrackTimer), b.stopVideoTrackTimer = void 0), !(yield b.client.getMediaHandler().hasVideoDevice())) return b.isLocalVideoMuted();
			if (!b.hasUserMediaVideoSender && !e) {
				var S;
				return (S = b.localUsermediaFeed) == null || S.setAudioVideoMuted(null, e), yield b.upgradeCall(!1, !0), b.isLocalVideoMuted();
			}
			if (!e && b.localUsermediaStream.getVideoTracks().length === 0) {
				var C = yield b.client.getMediaHandler().getUserMediaStream(!0, !0);
				yield b.updateLocalUsermediaStream(C);
			}
			return (x = b.localUsermediaFeed) == null || x.setAudioVideoMuted(null, e), b.updateMuteStatus(), yield b.sendMetadataUpdate(), e && (b.stopVideoTrackTimer = setTimeout(() => {
				for (var e of b.localUsermediaStream.getVideoTracks()) e.stop(), b.localUsermediaStream.removeTrack(e);
			}, 120)), b.isLocalVideoMuted();
		})();
	}
	isLocalVideoMuted() {
		return this.localUsermediaFeed?.isVideoMuted() ?? !1;
	}
	setMicrophoneMuted(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			var x;
			return logger.log(`Call ${b.callId} setMicrophoneMuted() running ${e}`), (yield b.client.getMediaHandler().hasAudioDevice()) ? !e && (!b.hasUserMediaAudioSender || !b.hasLocalUserMediaAudioTrack) ? (yield b.upgradeCall(!0, !1), b.isMicrophoneMuted()) : ((x = b.localUsermediaFeed) == null || x.setAudioVideoMuted(e, null), b.updateMuteStatus(), yield b.sendMetadataUpdate(), b.isMicrophoneMuted()) : b.isMicrophoneMuted();
		})();
	}
	isMicrophoneMuted() {
		return this.localUsermediaFeed?.isAudioMuted() ?? !1;
	}
	isRemoteOnHold() {
		return this.remoteOnHold;
	}
	setRemoteOnHold(e) {
		if (this.isRemoteOnHold() !== e) {
			this.remoteOnHold = e;
			for (var b of this.peerConn.getTransceivers()) b.direction = e ? "sendonly" : "sendrecv";
			this.updateMuteStatus(), this.sendMetadataUpdate(), this.emit(CallEvent.RemoteHoldUnhold, this.remoteOnHold, this);
		}
	}
	isLocalOnHold() {
		if (this.state !== CallState.Connected) return !1;
		var e = !0;
		for (var b of this.peerConn.getTransceivers()) ["inactive", "recvonly"].includes(b.currentDirection) || (e = !1);
		return e;
	}
	sendDtmfDigit(e) {
		for (var b of this.peerConn.getSenders()) if (b.track?.kind === "audio" && b.dtmf) {
			b.dtmf.insertDTMF(e);
			return;
		}
		throw Error("Unable to find a track to send DTMF on");
	}
	updateMuteStatus() {
		var e = this.isMicrophoneMuted() || this.remoteOnHold, b = this.isLocalVideoMuted() || this.remoteOnHold;
		logger.log(`Call ${this.callId} updateMuteStatus stream ${this.localUsermediaStream.id} micShouldBeMuted ${e} vidShouldBeMuted ${b}`), setTracksEnabled(this.localUsermediaStream.getAudioTracks(), !e), setTracksEnabled(this.localUsermediaStream.getVideoTracks(), !b);
	}
	sendMetadataUpdate() {
		var e = this;
		return _asyncToGenerator(function* () {
			yield e.sendVoipEvent(EventType.CallSDPStreamMetadataChangedPrefix, { [SDPStreamMetadataKey]: e.getLocalSDPStreamMetadata() });
		})();
	}
	gotCallFeedsForInvite(e) {
		var b = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
		if (this.successor) {
			this.successor.queueGotCallFeedsForAnswer(e);
			return;
		}
		if (this.callHasEnded()) {
			this.stopAllMedia();
			return;
		}
		for (var x of e) this.pushLocalFeed(x);
		b && this.peerConn.addTransceiver("video", { direction: "recvonly" }), this.state = CallState.CreateOffer, logger.debug(`Call ${this.callId} gotUserMediaForInvite() run`);
	}
	sendAnswer() {
		var e = this;
		return _asyncToGenerator(function* () {
			var b = {
				answer: {
					sdp: e.peerConn.localDescription.sdp,
					type: e.peerConn.localDescription.type
				},
				[SDPStreamMetadataKey]: e.getLocalSDPStreamMetadata(!0)
			};
			b.capabilities = {
				"m.call.transferee": e.client.supportsCallTransfer,
				"m.call.dtmf": !1
			};
			var x = e.discardDuplicateCandidates();
			logger.info(`Call ${e.callId} sendAnswer() discarding ${x} candidates that will be sent in answer`);
			try {
				yield e.sendVoipEvent(EventType.CallAnswer, b), e.inviteOrAnswerSent = !0;
			} catch (b) {
				e.state = CallState.Ringing, b instanceof MatrixError && b.event && e.client.cancelPendingEvent(b.event);
				var S = CallErrorCode.SendAnswer, C = "Failed to send answer";
				throw b.name == "UnknownDeviceError" && (S = CallErrorCode.UnknownDevices, C = "Unknown devices present in the room"), e.emit(CallEvent.Error, new CallError(S, C, b), e), b;
			}
			e.sendCandidateQueue();
		})();
	}
	queueGotCallFeedsForAnswer(e) {
		this.responsePromiseChain ? this.responsePromiseChain = this.responsePromiseChain.then(() => this.gotCallFeedsForAnswer(e)) : this.responsePromiseChain = this.gotCallFeedsForAnswer(e);
	}
	mungeSdp(e, b) {
		var x = (0, import_lib$2.parse)(e.sdp);
		x.media.forEach((e) => {
			var x = /* @__PURE__ */ new Map(), S = /* @__PURE__ */ new Map();
			for (var C of e.rtp) x.set(C.payload, C.codec), S.set(C.codec, C.payload);
			for (var w of b) if (w.mediaType === e.type) {
				if (!S.has(w.codec)) {
					logger.info(`Call ${this.callId} mungeSdp() ignoring SDP modifications for ${w.codec} as it's not present.`);
					continue;
				}
				var T = [];
				w.enableDtx !== void 0 && T.push(`usedtx=${w.enableDtx ? "1" : "0"}`), w.maxAverageBitrate !== void 0 && T.push(`maxaveragebitrate=${w.maxAverageBitrate}`);
				var E = !1;
				for (var D of e.fmtp) x.get(D.payload) === w.codec && (E = !0, D.config += ";" + T.join(";"));
				E || e.fmtp.push({
					payload: S.get(w.codec),
					config: T.join(";")
				});
			}
		}), e.sdp = (0, import_lib$2.write)(x);
	}
	createOffer() {
		var e = this;
		return _asyncToGenerator(function* () {
			var b = yield e.peerConn.createOffer();
			return e.mungeSdp(b, getCodecParamMods(e.isPtt)), b;
		})();
	}
	createAnswer() {
		var e = this;
		return _asyncToGenerator(function* () {
			var b = yield e.peerConn.createAnswer();
			return e.mungeSdp(b, getCodecParamMods(e.isPtt)), b;
		})();
	}
	gotCallFeedsForAnswer(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			if (!b.callHasEnded()) {
				b.waitForLocalAVStream = !1;
				for (var x of e) b.pushLocalFeed(x);
				b.state = CallState.CreateAnswer;
				var S;
				try {
					b.getRidOfRTXCodecs(), S = yield b.createAnswer();
				} catch (e) {
					logger.debug(`Call ${b.callId} gotCallFeedsForAnswer() failed to create answer: `, e), b.terminate(CallParty.Local, CallErrorCode.CreateAnswer, !0);
					return;
				}
				try {
					if (yield b.peerConn.setLocalDescription(S), b.callHasEnded() || (b.state = CallState.Connecting, yield new Promise((e) => {
						setTimeout(e, 200);
					}), b.callHasEnded())) return;
					b.sendAnswer();
				} catch (e) {
					logger.debug(`Call ${b.callId} gotCallFeedsForAnswer() error setting local description!`, e), b.terminate(CallParty.Local, CallErrorCode.SetLocalDescription, !0);
					return;
				}
			}
		})();
	}
	onRemoteIceCandidatesReceived(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			if (!b.callHasEnded()) {
				var x = e.getContent(), S = x.candidates;
				if (!S) {
					logger.info(`Call ${b.callId} onRemoteIceCandidatesReceived() ignoring candidates event with no candidates!`);
					return;
				}
				var C = x.version === 0 ? null : x.party_id || null;
				if (b.opponentPartyId === void 0) {
					if (C) {
						logger.info(`Call ${b.callId} onRemoteIceCandidatesReceived() buffering ${S.length} candidates until we pick an opponent`);
						var w = b.remoteCandidateBuffer.get(C) || [];
						w.push(...S), b.remoteCandidateBuffer.set(C, w);
					}
					return;
				}
				if (!b.partyIdMatches(x)) {
					logger.info(`Call ${b.callId} onRemoteIceCandidatesReceived() ignoring candidates from party ID ${x.party_id}: we have chosen party ID ${b.opponentPartyId}`);
					return;
				}
				yield b.addIceCandidates(S);
			}
		})();
	}
	onAnswerReceived(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			var x = e.getContent();
			if (logger.debug(`Call ${b.callId} onAnswerReceived() running (hangupParty=${x.party_id})`), b.callHasEnded()) {
				logger.debug(`Call ${b.callId} onAnswerReceived() ignoring answer because call has ended`);
				return;
			}
			if (b.opponentPartyId !== void 0) {
				logger.info(`Call ${b.callId} onAnswerReceived() ignoring answer from party ID ${x.party_id}: we already have an answer/reject from ${b.opponentPartyId}`);
				return;
			}
			b.chooseOpponent(e), yield b.addBufferedIceCandidates(), b.state = CallState.Connecting;
			var S = x[SDPStreamMetadataKey];
			S ? b.updateRemoteSDPStreamMetadata(S) : logger.warn(`Call ${b.callId} onAnswerReceived() did not get any SDPStreamMetadata! Can not send/receive multiple streams`);
			try {
				b.isSettingRemoteAnswerPending = !0, yield b.peerConn.setRemoteDescription(x.answer), b.isSettingRemoteAnswerPending = !1, logger.debug(`Call ${b.callId} onAnswerReceived() set remote description: ${x.answer.type}`);
			} catch (e) {
				b.isSettingRemoteAnswerPending = !1, logger.debug(`Call ${b.callId} onAnswerReceived() failed to set remote description`, e), b.terminate(CallParty.Local, CallErrorCode.SetRemoteDescription, !1);
				return;
			}
			if (b.opponentPartyId !== null) try {
				yield b.sendVoipEvent(EventType.CallSelectAnswer, { selected_party_id: b.opponentPartyId });
			} catch (e) {
				logger.warn(`Call ${b.callId} onAnswerReceived() failed to send select_answer event`, e);
			}
		})();
	}
	onSelectAnswerReceived(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			if (b.direction !== CallDirection.Inbound) {
				logger.warn(`Call ${b.callId} onSelectAnswerReceived() got select_answer for an outbound call: ignoring`);
				return;
			}
			var x = e.getContent().selected_party_id;
			if (x == null) {
				logger.warn(`Call ${b.callId} onSelectAnswerReceived() got nonsensical select_answer with null/undefined selected_party_id: ignoring`);
				return;
			}
			x !== b.ourPartyId && (logger.info(`Call ${b.callId} onSelectAnswerReceived() got select_answer for party ID ${x}: we are party ID ${b.ourPartyId}.`), yield b.terminate(CallParty.Remote, CallErrorCode.AnsweredElsewhere, !0));
		})();
	}
	onNegotiateReceived(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			var x = e.getContent(), S = x.description;
			if (!S || !S.sdp || !S.type) {
				logger.info(`Call ${b.callId} onNegotiateReceived() ignoring invalid m.call.negotiate event`);
				return;
			}
			var C = b.direction === CallDirection.Inbound, w = !b.makingOffer && (b.peerConn.signalingState === "stable" || b.isSettingRemoteAnswerPending), T = S.type === "offer" && !w;
			if (b.ignoreOffer = !C && T, b.ignoreOffer) {
				logger.info(`Call ${b.callId} onNegotiateReceived() ignoring colliding negotiate event because we're impolite`);
				return;
			}
			var E = b.isLocalOnHold(), D = x[SDPStreamMetadataKey];
			D ? b.updateRemoteSDPStreamMetadata(D) : logger.warn(`Call ${b.callId} onNegotiateReceived() received negotiation event without SDPStreamMetadata!`);
			try {
				if (b.isSettingRemoteAnswerPending = S.type == "answer", yield b.peerConn.setRemoteDescription(S), b.isSettingRemoteAnswerPending = !1, logger.debug(`Call ${b.callId} onNegotiateReceived() set remote description: ${S.type}`), S.type === "offer") {
					var O;
					try {
						b.getRidOfRTXCodecs(), O = yield b.createAnswer();
					} catch (e) {
						logger.debug(`Call ${b.callId} onNegotiateReceived() failed to create answer: `, e), b.terminate(CallParty.Local, CallErrorCode.CreateAnswer, !0);
						return;
					}
					yield b.peerConn.setLocalDescription(O), logger.debug(`Call ${b.callId} onNegotiateReceived() create an answer`), b.sendVoipEvent(EventType.CallNegotiate, {
						lifetime: CALL_TIMEOUT_MS,
						description: b.peerConn.localDescription?.toJSON(),
						[SDPStreamMetadataKey]: b.getLocalSDPStreamMetadata(!0)
					});
				}
			} catch (e) {
				b.isSettingRemoteAnswerPending = !1, logger.warn(`Call ${b.callId} onNegotiateReceived() failed to complete negotiation`, e);
			}
			var k = b.isLocalOnHold();
			E !== k && (b.emit(CallEvent.LocalHoldUnhold, k, b), b.emit(CallEvent.HoldUnhold, k));
		})();
	}
	updateRemoteSDPStreamMetadata(e) {
		this.remoteSDPStreamMetadata = recursivelyAssign(this.remoteSDPStreamMetadata || {}, e, !0);
		for (var b of this.getRemoteFeeds()) {
			var x = b.stream.id, S = this.remoteSDPStreamMetadata[x];
			b.setAudioVideoMuted(S?.audio_muted, S?.video_muted), b.purpose = this.remoteSDPStreamMetadata[x]?.purpose;
		}
	}
	onSDPStreamMetadataChangedReceived(e) {
		var b = e.getContent()[SDPStreamMetadataKey];
		this.updateRemoteSDPStreamMetadata(b);
	}
	onAssertedIdentityReceived(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			var x = e.getContent();
			x.asserted_identity && (b.remoteAssertedIdentity = {
				id: x.asserted_identity.id,
				displayName: x.asserted_identity.display_name
			}, b.emit(CallEvent.AssertedIdentityChanged, b));
		})();
	}
	callHasEnded() {
		return this.state === CallState.Ended;
	}
	queueGotLocalOffer() {
		this.responsePromiseChain ? this.responsePromiseChain = this.responsePromiseChain.then(() => this.wrappedGotLocalOffer()) : this.responsePromiseChain = this.wrappedGotLocalOffer();
	}
	wrappedGotLocalOffer() {
		var e = this;
		return _asyncToGenerator(function* () {
			e.makingOffer = !0;
			try {
				yield e.gotLocalOffer();
			} catch (b) {
				e.getLocalOfferFailed(b);
				return;
			} finally {
				e.makingOffer = !1;
			}
		})();
	}
	gotLocalOffer() {
		var e = this;
		return _asyncToGenerator(function* () {
			if (logger.debug(`Call ${e.callId} gotLocalOffer() running`), e.callHasEnded()) {
				logger.debug(`Call ${e.callId} gotLocalOffer() ignoring newly created offer because the call has ended"`);
				return;
			}
			var b;
			try {
				e.getRidOfRTXCodecs(), b = yield e.createOffer();
			} catch (b) {
				logger.debug(`Call ${e.callId} gotLocalOffer() failed to create offer: `, b), e.terminate(CallParty.Local, CallErrorCode.CreateOffer, !0);
				return;
			}
			try {
				yield e.peerConn.setLocalDescription(b);
			} catch (b) {
				logger.debug(`Call ${e.callId} gotLocalOffer() error setting local description!`, b), e.terminate(CallParty.Local, CallErrorCode.SetLocalDescription, !0);
				return;
			}
			if (e.peerConn.iceGatheringState === "gathering" && (yield new Promise((e) => {
				setTimeout(e, 200);
			})), !e.callHasEnded()) {
				var x = e.state === CallState.CreateOffer ? EventType.CallInvite : EventType.CallNegotiate, S = { lifetime: CALL_TIMEOUT_MS };
				x === EventType.CallInvite && e.invitee && (S.invitee = e.invitee), e.state === CallState.CreateOffer ? S.offer = e.peerConn.localDescription?.toJSON() : S.description = e.peerConn.localDescription?.toJSON(), S.capabilities = {
					"m.call.transferee": e.client.supportsCallTransfer,
					"m.call.dtmf": !1
				}, S[SDPStreamMetadataKey] = e.getLocalSDPStreamMetadata(!0);
				var C = e.discardDuplicateCandidates();
				logger.info(`Call ${e.callId} gotLocalOffer() discarding ${C} candidates that will be sent in offer`);
				try {
					yield e.sendVoipEvent(x, S);
				} catch (b) {
					logger.error(`Call ${e.callId} gotLocalOffer() failed to send invite`, b), b instanceof MatrixError && b.event && e.client.cancelPendingEvent(b.event);
					var w = CallErrorCode.SignallingFailed, T = "Signalling failed";
					e.state === CallState.CreateOffer && (w = CallErrorCode.SendInvite, T = "Failed to send invite"), b.name == "UnknownDeviceError" && (w = CallErrorCode.UnknownDevices, T = "Unknown devices present in the room"), e.emit(CallEvent.Error, new CallError(w, T, b), e), e.terminate(CallParty.Local, w, !1);
					return;
				}
				e.sendCandidateQueue(), e.state === CallState.CreateOffer && (e.inviteOrAnswerSent = !0, e.state = CallState.InviteSent, e.inviteTimeout = setTimeout(() => {
					e.inviteTimeout = void 0, e.state === CallState.InviteSent && e.hangup(CallErrorCode.InviteTimeout, !1);
				}, CALL_TIMEOUT_MS));
			}
		})();
	}
	getRidOfRTXCodecs() {
		if (!(!RTCRtpReceiver.getCapabilities || !RTCRtpSender.getCapabilities)) {
			var e = this.transceivers.get(getTransceiverKey(SDPStreamMetadataPurpose.Screenshare, "video"));
			if (!(!e || !e.setCodecPreferences)) {
				var b = RTCRtpReceiver.getCapabilities("video").codecs, x = RTCRtpSender.getCapabilities("video").codecs, S = [];
				for (var C of [...b, ...x]) if (C.mimeType !== "video/rtx") {
					S.push(C);
					try {
						e.setCodecPreferences(S);
					} catch (e) {
						logger.info("Working around buggy WebRTC impl: claimed to support codec but threw when setting codec preferences", C, e), S.pop();
					}
				}
			}
		}
	}
	sendVoipEvent(e, b) {
		var x = this;
		return _asyncToGenerator(function* () {
			var S = _objectSpread$10(_objectSpread$10({}, b), {}, {
				version: VOIP_PROTO_VERSION,
				call_id: x.callId,
				party_id: x.ourPartyId,
				conf_id: x.groupCallId
			});
			if (x.opponentDeviceId) {
				var C = x.toDeviceSeq++, w = _objectSpread$10(_objectSpread$10({}, S), {}, {
					device_id: x.client.deviceId,
					sender_session_id: x.client.getSessionId(),
					dest_session_id: x.opponentSessionId,
					seq: C,
					[ToDeviceMessageId]: v4_default()
				});
				x.emit(CallEvent.SendVoipEvent, {
					type: "toDevice",
					eventType: e,
					userId: x.invitee || x.getOpponentMember()?.userId,
					opponentDeviceId: x.opponentDeviceId,
					content: w
				}, x);
				var T = x.invitee || x.getOpponentMember().userId;
				if (x.client.getUseE2eForGroupCall()) {
					if (!x.hasOpponentDeviceInfo) {
						logger.warn(`Call ${x.callId} sendVoipEvent() failed: we do not have opponentDeviceInfo`);
						return;
					}
					throw Error("Unimplemented");
				} else yield x.client.sendToDevice(e, new Map([[T, new Map([[x.opponentDeviceId, w]])]]));
			} else x.emit(CallEvent.SendVoipEvent, {
				type: "sendEvent",
				eventType: e,
				roomId: x.roomId,
				content: S,
				userId: x.invitee || x.getOpponentMember()?.userId
			}, x), yield x.client.sendEvent(x.roomId, e, S);
		})();
	}
	queueCandidate(e) {
		if (e ? this.candidateSendQueue.push(e) : this.candidatesEnded = !0, !(this.state === CallState.Ringing || !this.inviteOrAnswerSent)) {
			var b = this.direction === CallDirection.Inbound ? 500 : 2e3;
			this.candidateSendTries === 0 && setTimeout(() => {
				this.sendCandidateQueue();
			}, b);
		}
	}
	discardDuplicateCandidates() {
		for (var e = 0, b = [], x = 0; x < this.candidateSendQueue.length; x++) {
			var S = this.candidateSendQueue[x];
			S.candidate === "" ? b.push(S) : e++;
		}
		return this.candidateSendQueue = b, e;
	}
	transfer(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			var x = yield b.client.getProfileInfo(e), S = genCallID(), C = {
				replacement_id: genCallID(),
				target_user: {
					id: e,
					display_name: x.displayname,
					avatar_url: x.avatar_url
				},
				create_call: S
			};
			yield b.sendVoipEvent(EventType.CallReplaces, C), yield b.terminate(CallParty.Local, CallErrorCode.Transferred, !0);
		})();
	}
	transferToCall(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			var x = e.getOpponentMember()?.userId, S = x ? yield b.client.getProfileInfo(x) : void 0, C = b.getOpponentMember()?.userId, w = C ? yield b.client.getProfileInfo(C) : void 0, T = genCallID(), E = {
				replacement_id: genCallID(),
				target_user: {
					id: C,
					display_name: w?.displayname,
					avatar_url: w?.avatar_url
				},
				await_call: T
			};
			yield e.sendVoipEvent(EventType.CallReplaces, E);
			var D = {
				replacement_id: genCallID(),
				target_user: {
					id: x,
					display_name: S?.displayname,
					avatar_url: S?.avatar_url
				},
				create_call: T
			};
			yield b.sendVoipEvent(EventType.CallReplaces, D), yield b.terminate(CallParty.Local, CallErrorCode.Transferred, !0), yield e.terminate(CallParty.Local, CallErrorCode.Transferred, !0);
		})();
	}
	terminate(e, b, x) {
		var S = this;
		return _asyncToGenerator(function* () {
			var C;
			if (!S.callHasEnded()) {
				S.hangupParty = e, S.hangupReason = b, S.state = CallState.Ended, S.inviteTimeout &&= (clearTimeout(S.inviteTimeout), void 0), S.iceDisconnectedTimeout !== void 0 && (clearTimeout(S.iceDisconnectedTimeout), S.iceDisconnectedTimeout = void 0), S.callLengthInterval &&= (clearInterval(S.callLengthInterval), void 0), S.stopVideoTrackTimer !== void 0 && (clearTimeout(S.stopVideoTrackTimer), S.stopVideoTrackTimer = void 0);
				for (var [w, T] of S.removeTrackListeners) w.removeEventListener("removetrack", T);
				S.removeTrackListeners.clear(), S.callStatsAtEnd = yield S.collectCallStats(), S.stopAllMedia(), S.deleteAllFeeds(), S.peerConn && S.peerConn.signalingState !== "closed" && S.peerConn.close(), (C = S.stats) == null || C.removeStatsReportGatherer(S.callId), x && S.emit(CallEvent.Hangup, S), S.client.callEventHandler.calls.delete(S.callId);
			}
		})();
	}
	stopAllMedia() {
		logger.debug(`Call ${this.callId} stopAllMedia() running`);
		for (var e of this.feeds) if (e.isLocal() && e.purpose === SDPStreamMetadataPurpose.Usermedia) this.client.getMediaHandler().stopUserMediaStream(e.stream);
		else if (e.isLocal() && e.purpose === SDPStreamMetadataPurpose.Screenshare) this.client.getMediaHandler().stopScreensharingStream(e.stream);
		else if (!e.isLocal()) {
			logger.debug(`Call ${this.callId} stopAllMedia() stopping stream (streamId=${e.stream.id})`);
			for (var b of e.stream.getTracks()) b.stop();
		}
	}
	checkForErrorListener() {
		if (this.listeners(EventEmitterEvents.Error).length === 0) throw Error("You MUST attach an error listener using call.on('error', function() {})");
	}
	sendCandidateQueue() {
		var e = this;
		return _asyncToGenerator(function* () {
			if (!(e.candidateSendQueue.length === 0 || e.callHasEnded())) {
				var b = e.candidateSendQueue;
				e.candidateSendQueue = [], ++e.candidateSendTries;
				var x = { candidates: b.map((e) => e.toJSON()) };
				e.candidatesEnded && x.candidates.push({ candidate: "" }), logger.debug(`Call ${e.callId} sendCandidateQueue() attempting to send ${b.length} candidates`);
				try {
					yield e.sendVoipEvent(EventType.CallCandidates, x), e.candidateSendTries = 0, e.sendCandidateQueue();
				} catch (x) {
					if (x instanceof MatrixError && x.event && e.client.cancelPendingEvent(x.event), e.candidateSendQueue.push(...b), e.candidateSendTries > 5) {
						logger.debug(`Call ${e.callId} sendCandidateQueue() failed to send candidates on attempt ${e.candidateSendTries}. Giving up on this call.`, x);
						var S = CallErrorCode.SignallingFailed;
						e.emit(CallEvent.Error, new CallError(S, "Signalling failed", x), e), e.hangup(S, !1);
						return;
					}
					var C = 500 * 2 ** e.candidateSendTries;
					++e.candidateSendTries, logger.debug(`Call ${e.callId} sendCandidateQueue() failed to send candidates. Retrying in ${C}ms`, x), setTimeout(() => {
						e.sendCandidateQueue();
					}, C);
				}
			}
		})();
	}
	placeCall(e, b) {
		var x = this;
		return _asyncToGenerator(function* () {
			if (!e) throw Error("You CANNOT start a call without audio");
			x.state = CallState.WaitLocalMedia;
			var S;
			try {
				var C = yield x.client.getMediaHandler().getUserMediaStream(e, b);
				setTracksEnabled(C.getAudioTracks(), !0), setTracksEnabled(C.getVideoTracks(), !0), S = new CallFeed({
					client: x.client,
					roomId: x.roomId,
					userId: x.client.getUserId(),
					deviceId: x.client.getDeviceId() ?? void 0,
					stream: C,
					purpose: SDPStreamMetadataPurpose.Usermedia,
					audioMuted: !1,
					videoMuted: !1
				});
			} catch (e) {
				x.getUserMediaFailed(e);
				return;
			}
			try {
				yield x.placeCallWithCallFeeds([S]);
			} catch (e) {
				x.placeCallFailed(e);
				return;
			}
		})();
	}
	placeCallWithCallFeeds(e) {
		var b = arguments, x = this;
		return _asyncToGenerator(function* () {
			var S = b.length > 1 && b[1] !== void 0 ? b[1] : !1;
			x.checkForErrorListener(), x.direction = CallDirection.Outbound, yield x.initOpponentCrypto(), x.client.callEventHandler.calls.set(x.callId, x), (yield x.client.checkTurnServers()) || logger.warn(`Call ${x.callId} placeCallWithCallFeeds() failed to get TURN credentials! Proceeding with call anyway...`), x.peerConn = x.createPeerConnection(), x.emit(CallEvent.PeerConnectionCreated, x.peerConn, x), x.gotCallFeedsForInvite(e, S);
		})();
	}
	createPeerConnection() {
		var e, b = new window.RTCPeerConnection({
			iceTransportPolicy: this.forceTURN ? "relay" : void 0,
			iceServers: this.turnServers.length ? this.turnServers : void 0,
			iceCandidatePoolSize: this.client.iceCandidatePoolSize,
			bundlePolicy: "max-bundle"
		});
		b.addEventListener("iceconnectionstatechange", this.onIceConnectionStateChanged), b.addEventListener("signalingstatechange", this.onSignallingStateChanged), b.addEventListener("icecandidate", this.gotLocalIceCandidate), b.addEventListener("icegatheringstatechange", this.onIceGatheringStateChange), b.addEventListener("track", this.onTrack), b.addEventListener("negotiationneeded", this.onNegotiationNeeded), b.addEventListener("datachannel", this.onDataChannel);
		var x = this.getOpponentMember(), S = x ? x.userId : "unknown";
		return (e = this.stats) == null || e.addStatsReportGatherer(this.callId, S, b), b;
	}
	partyIdMatches(e) {
		return (e.version === 0 ? null : e.party_id || null) === this.opponentPartyId;
	}
	chooseOpponent(e) {
		var b = e.getContent();
		if (logger.debug(`Call ${this.callId} chooseOpponent() running (partyId=${b.party_id})`), this.opponentVersion = b.version, this.opponentVersion === 0 ? this.opponentPartyId = null : this.opponentPartyId = b.party_id || null, this.opponentCaps = b.capabilities || {}, this.opponentMember = this.client.getRoom(this.roomId).getMember(e.getSender()) ?? void 0, this.opponentMember) {
			var x;
			(x = this.stats) == null || x.updateOpponentMember(this.callId, this.opponentMember.userId);
		}
	}
	addBufferedIceCandidates() {
		var e = this;
		return _asyncToGenerator(function* () {
			var b = e.remoteCandidateBuffer.get(e.opponentPartyId);
			b && (logger.info(`Call ${e.callId} addBufferedIceCandidates() adding ${b.length} buffered candidates for opponent ${e.opponentPartyId}`), yield e.addIceCandidates(b)), e.remoteCandidateBuffer.clear();
		})();
	}
	addIceCandidates(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			for (var x of e) {
				(x.sdpMid === null || x.sdpMid === void 0) && (x.sdpMLineIndex === null || x.sdpMLineIndex === void 0) ? logger.debug(`Call ${b.callId} addIceCandidates() got remote ICE end-of-candidates`) : logger.debug(`Call ${b.callId} addIceCandidates() got remote ICE candidate (sdpMid=${x.sdpMid}, candidate=${x.candidate})`);
				try {
					yield b.peerConn.addIceCandidate(x);
				} catch (e) {
					b.ignoreOffer ? logger.debug(`Call ${b.callId} addIceCandidates() failed to add remote ICE candidate because ignoring offer`, e) : logger.info(`Call ${b.callId} addIceCandidates() failed to add remote ICE candidate`, e);
				}
			}
		})();
	}
	get hasPeerConnection() {
		return !!this.peerConn;
	}
	initStats(e) {
		arguments.length > 1 && arguments[1] !== void 0 && arguments[1], this.stats = e, this.stats.start();
	}
};
function setTracksEnabled(e, b) {
	for (var x of e) x.enabled = b;
}
function supportsMatrixCall() {
	if (typeof window > "u" || typeof document > "u") return !1;
	try {
		if (!(window.RTCPeerConnection ?? window.RTCSessionDescription ?? window.RTCIceCandidate ?? navigator.mediaDevices)) return process.env.NODE_ENV !== "test" && logger.error("WebRTC is not supported in this browser / environment"), !1;
	} catch (e) {
		return logger.error("Exception thrown when trying to access WebRTC", e), !1;
	}
	return !0;
}
function createNewMatrixCall(e, b, x) {
	if (!supportsMatrixCall()) return null;
	var S = x ? x.forceTURN : !1, C = {
		client: e,
		roomId: b,
		invitee: x?.invitee,
		turnServers: e.getTurnServers(),
		forceTURN: e.forceTURN || S,
		opponentDeviceId: x?.opponentDeviceId,
		opponentSessionId: x?.opponentSessionId,
		groupCallId: x?.groupCallId
	}, w = new MatrixCall(C);
	return e.reEmitter.reEmit(w, Object.values(CallEvent)), w;
}
var PushRuleActionName = /* @__PURE__ */ function(e) {
	return e.DontNotify = "dont_notify", e.Notify = "notify", e.Coalesce = "coalesce", e;
}({}), TweakName = /* @__PURE__ */ function(e) {
	return e.Highlight = "highlight", e.Sound = "sound", e;
}({}), ConditionOperator = /* @__PURE__ */ function(e) {
	return e.ExactEquals = "==", e.LessThan = "<", e.GreaterThan = ">", e.GreaterThanOrEqual = ">=", e.LessThanOrEqual = "<=", e;
}({}), DMMemberCountCondition = "2";
function isDmMemberCountCondition(e) {
	return e === "==2" || e === "2";
}
var ConditionKind = /* @__PURE__ */ function(e) {
	return e.EventMatch = "event_match", e.EventPropertyIs = "event_property_is", e.EventPropertyContains = "event_property_contains", e.ContainsDisplayName = "contains_display_name", e.RoomMemberCount = "room_member_count", e.SenderNotificationPermission = "sender_notification_permission", e.CallStarted = "call_started", e.CallStartedPrefix = "org.matrix.msc3914.call_started", e;
}({}), PushRuleKind = /* @__PURE__ */ function(e) {
	return e.Override = "override", e.ContentSpecific = "content", e.RoomSpecific = "room", e.SenderSpecific = "sender", e.Underride = "underride", e;
}({}), RuleId = /* @__PURE__ */ function(e) {
	return e.Master = ".m.rule.master", e.IsUserMention = ".m.rule.is_user_mention", e.IsRoomMention = ".m.rule.is_room_mention", e.ContainsDisplayName = ".m.rule.contains_display_name", e.ContainsUserName = ".m.rule.contains_user_name", e.AtRoomNotification = ".m.rule.roomnotif", e.DM = ".m.rule.room_one_to_one", e.EncryptedDM = ".m.rule.encrypted_room_one_to_one", e.Message = ".m.rule.message", e.EncryptedMessage = ".m.rule.encrypted", e.InviteToSelf = ".m.rule.invite_for_me", e.MemberEvent = ".m.rule.member_event", e.IncomingCall = ".m.rule.call", e.SuppressNotices = ".m.rule.suppress_notices", e.Tombstone = ".m.rule.tombstone", e.PollStart = ".m.rule.poll_start", e.PollStartUnstable = ".org.matrix.msc3930.rule.poll_start", e.PollEnd = ".m.rule.poll_end", e.PollEndUnstable = ".org.matrix.msc3930.rule.poll_end", e.PollStartOneToOne = ".m.rule.poll_start_one_to_one", e.PollStartOneToOneUnstable = ".org.matrix.msc3930.rule.poll_start_one_to_one", e.PollEndOneToOne = ".m.rule.poll_end_one_to_one", e.PollEndOneToOneUnstable = ".org.matrix.msc3930.rule.poll_end_one_to_one", e;
}({});
function ownKeys$9(e, b) {
	var x = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var S = Object.getOwnPropertySymbols(e);
		b && (S = S.filter(function(b) {
			return Object.getOwnPropertyDescriptor(e, b).enumerable;
		})), x.push.apply(x, S);
	}
	return x;
}
function _objectSpread$9(e) {
	for (var b = 1; b < arguments.length; b++) {
		var x = arguments[b] == null ? {} : arguments[b];
		b % 2 ? ownKeys$9(Object(x), !0).forEach(function(b) {
			_defineProperty(e, b, x[b]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(x)) : ownKeys$9(Object(x)).forEach(function(b) {
			Object.defineProperty(e, b, Object.getOwnPropertyDescriptor(x, b));
		});
	}
	return e;
}
var RULEKINDS_IN_ORDER = [
	PushRuleKind.Override,
	PushRuleKind.ContentSpecific,
	PushRuleKind.RoomSpecific,
	PushRuleKind.SenderSpecific,
	PushRuleKind.Underride
], DEFAULT_OVERRIDE_RULES = {
	".m.rule.is_room_mention": {
		rule_id: ".m.rule.is_room_mention",
		default: !0,
		enabled: !0,
		conditions: [{
			kind: ConditionKind.EventPropertyIs,
			key: "content.m\\.mentions.room",
			value: !0
		}, {
			kind: ConditionKind.SenderNotificationPermission,
			key: "room"
		}],
		actions: [PushRuleActionName.Notify, { set_tweak: TweakName.Highlight }]
	},
	".m.rule.reaction": {
		rule_id: ".m.rule.reaction",
		default: !0,
		enabled: !0,
		conditions: [{
			kind: ConditionKind.EventMatch,
			key: "type",
			pattern: "m.reaction"
		}],
		actions: [PushRuleActionName.DontNotify]
	},
	".org.matrix.msc3786.rule.room.server_acl": {
		rule_id: ".org.matrix.msc3786.rule.room.server_acl",
		default: !0,
		enabled: !0,
		conditions: [{
			kind: ConditionKind.EventMatch,
			key: "type",
			pattern: EventType.RoomServerAcl
		}, {
			kind: ConditionKind.EventMatch,
			key: "state_key",
			pattern: ""
		}],
		actions: []
	}
}, UserDefinedRules = Symbol("UserDefinedRules"), EXPECTED_DEFAULT_OVERRIDE_RULE_IDS = [
	RuleId.Master,
	UserDefinedRules,
	RuleId.SuppressNotices,
	RuleId.InviteToSelf,
	RuleId.MemberEvent,
	RuleId.IsUserMention,
	RuleId.ContainsDisplayName,
	RuleId.IsRoomMention,
	RuleId.AtRoomNotification,
	RuleId.Tombstone,
	".m.rule.reaction",
	".m.rule.room.server_acl",
	".org.matrix.msc3786.rule.room.server_acl",
	".m.rule.suppress_edits"
], DEFAULT_UNDERRIDE_RULES = { ".org.matrix.msc3914.rule.room.call": {
	rule_id: ".org.matrix.msc3914.rule.room.call",
	default: !0,
	enabled: !0,
	conditions: [{
		kind: ConditionKind.EventMatch,
		key: "type",
		pattern: "org.matrix.msc3401.call"
	}, { kind: ConditionKind.CallStarted }],
	actions: [PushRuleActionName.Notify, {
		set_tweak: TweakName.Sound,
		value: "default"
	}]
} }, EXPECTED_DEFAULT_UNDERRIDE_RULE_IDS = [
	UserDefinedRules,
	RuleId.IncomingCall,
	".org.matrix.msc3914.rule.room.call",
	RuleId.EncryptedDM,
	RuleId.DM,
	RuleId.Message,
	RuleId.EncryptedMessage
];
function mergeRulesWithDefaults(e, b, x, S, C) {
	var w = x.filter((e) => e.default), T = x.filter((e) => !e.default);
	function E(x) {
		x === UserDefinedRules ? O.push(...T) : x in S ? (e.warn(`Adding default global ${b} push rule ${x}`), O.push(S[x])) : e.warn(`Missing default global ${b} push rule ${x}`);
	}
	var D = 0, O = [];
	for (var k of w) {
		var A = C.indexOf(k.rule_id);
		if (A === -1) {
			O.push(k);
			continue;
		}
		for (; A > D;) {
			var j = C[D];
			E(j), D += 1;
		}
		O.push(k), D += 1;
	}
	for (var M of C.slice(D)) E(M);
	return O;
}
var PushProcessor = class e {
	constructor(e) {
		this.client = e, _defineProperty(this, "parsedKeys", /* @__PURE__ */ new Map());
	}
	static actionListToActionsObject(e) {
		var b = {
			notify: !1,
			tweaks: {}
		};
		for (var x of e) x === PushRuleActionName.Notify ? b.notify = !0 : typeof x == "object" && (x.value === void 0 && (x.value = !0), b.tweaks[x.set_tweak] = x.value);
		return b;
	}
	static rewriteDefaultRules(e, b) {
		arguments.length > 2 && arguments[2] !== void 0 && arguments[2];
		var x = JSON.parse(JSON.stringify(b));
		return x ||= {}, x.global ||= {}, x.global.override || (x.global.override = []), x.global.underride || (x.global.underride = []), x.global.override = mergeRulesWithDefaults(e, PushRuleKind.Override, x.global.override, DEFAULT_OVERRIDE_RULES, EXPECTED_DEFAULT_OVERRIDE_RULE_IDS), x.global.underride = mergeRulesWithDefaults(e, PushRuleKind.Underride, x.global.underride, DEFAULT_UNDERRIDE_RULES, EXPECTED_DEFAULT_UNDERRIDE_RULE_IDS), x;
	}
	static getPushRuleGlobRegex(b) {
		var x = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, S = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "i", [C, w] = x ? ["(?<=^|\\W)", "(?=\\W|$)"] : ["^", "$"], T = `${x}-${S}-${b}`;
		return e.cachedGlobToRegex[T] || (e.cachedGlobToRegex[T] = RegExp(C + "(" + globToRegexp(b) + ")" + w, S)), e.cachedGlobToRegex[T];
	}
	updateCachedPushRuleKeys(b) {
		b ||= {}, b.global ||= {}, b.global.override || (b.global.override = []), b.global.room || (b.global.room = []), b.global.sender || (b.global.sender = []), b.global.underride || (b.global.underride = []);
		var x = new Set(this.parsedKeys.keys());
		for (var S of [
			b.global.override,
			b.global.room,
			b.global.sender,
			b.global.underride
		]) for (var C of S) if (C.conditions) for (var w of C.conditions) w.kind === ConditionKind.EventMatch && (x.delete(w.key), this.parsedKeys.set(w.key, e.partsForDottedKey(w.key)));
		x.forEach((e) => this.parsedKeys.delete(e));
	}
	matchingRuleFromKindSet(e, b) {
		for (var x of RULEKINDS_IN_ORDER) {
			var S = b[x];
			if (S) {
				for (var C of S) if (C.enabled) {
					var w = this.templateRuleToRaw(x, C);
					if (w && this.ruleMatchesEvent(w, e)) return _objectSpread$9(_objectSpread$9({}, C), {}, { kind: x });
				}
			}
		}
		return null;
	}
	templateRuleToRaw(e, b) {
		var x = {
			rule_id: b.rule_id,
			actions: b.actions,
			conditions: []
		};
		switch (e) {
			case PushRuleKind.Underride:
			case PushRuleKind.Override:
				x.conditions = b.conditions;
				break;
			case PushRuleKind.RoomSpecific:
				if (!b.rule_id) return null;
				x.conditions.push({
					kind: ConditionKind.EventMatch,
					key: "room_id",
					value: b.rule_id
				});
				break;
			case PushRuleKind.SenderSpecific:
				if (!b.rule_id) return null;
				x.conditions.push({
					kind: ConditionKind.EventMatch,
					key: "user_id",
					value: b.rule_id
				});
				break;
			case PushRuleKind.ContentSpecific:
				if (!b.pattern) return null;
				x.conditions.push({
					kind: ConditionKind.EventMatch,
					key: "content.body",
					pattern: b.pattern
				});
				break;
		}
		return x;
	}
	eventFulfillsCondition(e, b) {
		switch (e.kind) {
			case ConditionKind.EventMatch: return this.eventFulfillsEventMatchCondition(e, b);
			case ConditionKind.EventPropertyIs: return this.eventFulfillsEventPropertyIsCondition(e, b);
			case ConditionKind.EventPropertyContains: return this.eventFulfillsEventPropertyContains(e, b);
			case ConditionKind.ContainsDisplayName: return this.eventFulfillsDisplayNameCondition(e, b);
			case ConditionKind.RoomMemberCount: return this.eventFulfillsRoomMemberCountCondition(e, b);
			case ConditionKind.SenderNotificationPermission: return this.eventFulfillsSenderNotifPermCondition(e, b);
			case ConditionKind.CallStarted:
			case ConditionKind.CallStartedPrefix: return this.eventFulfillsCallStartedCondition(e, b);
		}
		return !1;
	}
	eventFulfillsSenderNotifPermCondition(e, b) {
		var x = e.key;
		if (!x) return !1;
		var S = this.client.getRoom(b.getRoomId());
		return S != null && S.currentState ? S.currentState.mayTriggerNotifOfType(x, b.getSender()) : !1;
	}
	eventFulfillsRoomMemberCountCondition(e, b) {
		if (!e.is) return !1;
		var x = this.client.getRoom(b.getRoomId());
		if (!x || !x.currentState || !x.currentState.members) return !1;
		var S = x.currentState.getJoinedMemberCount(), C = e.is.match(/^([=<>]*)(\d*)$/);
		if (!C) return !1;
		var w = C[1], T = parseInt(C[2]);
		if (isNaN(T)) return !1;
		switch (w) {
			case "":
			case "==": return S == T;
			case "<": return S < T;
			case ">": return S > T;
			case "<=": return S <= T;
			case ">=": return S >= T;
			default: return !1;
		}
	}
	eventFulfillsDisplayNameCondition(e, b) {
		var x, S = b.getContent();
		if (b.isEncrypted() && b.getClearContent() && (S = b.getClearContent()), !S || !S.body || typeof S.body != "string") return !1;
		var C = this.client.getRoom(b.getRoomId()), w = C == null || (x = C.currentState) == null ? void 0 : x.getMember(this.client.credentials.userId);
		if (!w) return !1;
		var T = w.name, E = RegExp("(^|\\W)" + escapeRegExp(T) + "(\\W|$)", "i");
		return S.body.search(E) > -1;
	}
	eventFulfillsEventMatchCondition(b, x) {
		if (!b.key) return !1;
		var S = this.valueForDottedKey(b.key, x);
		if (typeof S != "string") return !1;
		if (b.value) return b.value === S;
		if (typeof b.pattern != "string") return !1;
		var C = e.getPushRuleGlobRegex(b.pattern, b.key === "content.body");
		return !!S.match(C);
	}
	eventFulfillsEventPropertyIsCondition(e, b) {
		return !e.key || e.value === void 0 ? !1 : e.value === this.valueForDottedKey(e.key, b);
	}
	eventFulfillsEventPropertyContains(e, b) {
		if (!e.key || e.value === void 0) return !1;
		var x = this.valueForDottedKey(e.key, b);
		return Array.isArray(x) ? x.includes(e.value) : !1;
	}
	eventFulfillsCallStartedCondition(e, b) {
		return ["m.ring", "m.prompt"].includes(b.getContent()["m.intent"]) && !("m.terminated" in b.getContent()) && (b.getPrevContent()["m.terminated"] !== b.getContent()["m.terminated"] || deepCompare(b.getPrevContent(), {}));
	}
	static partsForDottedKey(e) {
		var b = [], x = "", S = !1;
		for (var C of e) {
			if (S) {
				C === "\\" || C === "." ? x += C : x += "\\" + C, S = !1;
				continue;
			}
			C == "." ? (b.push(x), x = "") : C == "\\" ? S = !0 : x += C;
		}
		return S && (x += "\\"), b.push(x), b;
	}
	valueForDottedKey(b, x) {
		var S = this.parsedKeys.get(b);
		S === void 0 && (S = e.partsForDottedKey(b), this.parsedKeys.set(b, S));
		var C, w = S[0], T = 0;
		for (w === "content" ? (C = x.getContent(), ++T) : w === "type" ? (C = x.getType(), ++T) : C = x.event; T < S.length; ++T) {
			if (isNullOrUndefined(C)) return;
			var E = S[T];
			C = C[E];
		}
		return C;
	}
	matchingRuleForEventWithRulesets(e, b) {
		return !b || e.getSender() === this.client.getSafeUserId() ? null : this.matchingRuleFromKindSet(e, b.global);
	}
	pushActionsForEventAndRulesets(b, x) {
		var S = this.matchingRuleForEventWithRulesets(b, x);
		if (!S) return {};
		var C = e.actionListToActionsObject(S.actions);
		return C.tweaks.highlight === void 0 && (C.tweaks.highlight = S.kind == PushRuleKind.ContentSpecific), {
			actions: C,
			rule: S
		};
	}
	ruleMatchesEvent(e, b) {
		var x;
		return this.client.supportsIntentionalMentions() && b.getContent()["m.mentions"] !== void 0 && (e.rule_id === RuleId.ContainsUserName || e.rule_id === RuleId.ContainsDisplayName || e.rule_id === RuleId.AtRoomNotification) ? !1 : !((x = e.conditions) != null && x.some((e) => !this.eventFulfillsCondition(e, b)));
	}
	actionsForEvent(e) {
		var { actions: b } = this.pushActionsForEventAndRulesets(e, this.client.pushRules);
		return b || {};
	}
	actionsAndRuleForEvent(e) {
		return this.pushActionsForEventAndRulesets(e, this.client.pushRules);
	}
	getPushRuleById(e) {
		return this.getPushRuleAndKindById(e)?.rule ?? null;
	}
	getPushRuleAndKindById(e) {
		for (var b of ["global"]) if (this.client.pushRules?.[b] !== void 0) {
			for (var x of RULEKINDS_IN_ORDER) if (this.client.pushRules[b][x] !== void 0) {
				for (var S of this.client.pushRules[b][x]) if (S.rule_id === e) return {
					rule: S,
					kind: x
				};
			}
		}
		return null;
	}
};
_defineProperty(PushProcessor, "cachedGlobToRegex", {});
var SUPPORTED_MATRIX_VERSIONS = [
	"v1.1",
	"v1.2",
	"v1.3",
	"v1.4",
	"v1.5",
	"v1.6",
	"v1.7",
	"v1.8",
	"v1.9"
], MINIMUM_MATRIX_VERSION = SUPPORTED_MATRIX_VERSIONS[0], MAXIMUM_MATRIX_VERSION = SUPPORTED_MATRIX_VERSIONS[SUPPORTED_MATRIX_VERSIONS.length - 1], AutoDiscoveryAction = /* @__PURE__ */ function(e) {
	return e.SUCCESS = "SUCCESS", e.IGNORE = "IGNORE", e.PROMPT = "PROMPT", e.FAIL_PROMPT = "FAIL_PROMPT", e.FAIL_ERROR = "FAIL_ERROR", e;
}({}), AutoDiscoveryError = /* @__PURE__ */ function(e) {
	return e.Invalid = "Invalid homeserver discovery response", e.GenericFailure = "Failed to get autodiscovery configuration from server", e.InvalidHsBaseUrl = "Invalid base_url for m.homeserver", e.InvalidHomeserver = "Homeserver URL does not appear to be a valid Matrix homeserver", e.InvalidIsBaseUrl = "Invalid base_url for m.identity_server", e.InvalidIdentityServer = "Identity server URL does not appear to be a valid identity server", e.InvalidIs = "Invalid identity server discovery response", e.MissingWellknown = "No .well-known JSON file found", e.InvalidJson = "Invalid JSON", e.UnsupportedHomeserverSpecVersion = "The homeserver does not meet the version requirements", e;
}({}), AutoDiscovery = class e {
	static fromDiscoveryConfig(b) {
		var x = this;
		return _asyncToGenerator(function* () {
			var S = {
				"m.homeserver": {
					state: e.FAIL_ERROR,
					error: e.ERROR_INVALID,
					base_url: null
				},
				"m.identity_server": {
					state: e.PROMPT,
					error: null,
					base_url: null
				}
			};
			if (!(b != null && b["m.homeserver"])) return logger.error("No m.homeserver key in config"), S["m.homeserver"].state = e.FAIL_PROMPT, S["m.homeserver"].error = e.ERROR_INVALID, Promise.resolve(S);
			if (!b["m.homeserver"].base_url) return logger.error("No m.homeserver base_url in config"), S["m.homeserver"].state = e.FAIL_PROMPT, S["m.homeserver"].error = e.ERROR_INVALID_HS_BASE_URL, Promise.resolve(S);
			var C = x.sanitizeWellKnownUrl(b["m.homeserver"].base_url);
			if (!C) return logger.error("Invalid base_url for m.homeserver"), S["m.homeserver"].error = e.ERROR_INVALID_HS_BASE_URL, Promise.resolve(S);
			var w = yield x.fetchWellKnownObject(`${C}/_matrix/client/versions`);
			if (!w || !Array.isArray(w.raw?.versions)) return logger.error("Invalid /versions response"), S["m.homeserver"].error = e.ERROR_INVALID_HOMESERVER, S["m.homeserver"].base_url = C, Promise.resolve(S);
			var T = new Set(w.raw.versions), E = !1;
			for (var D of SUPPORTED_MATRIX_VERSIONS) if (T.has(D)) {
				E = !0;
				break;
			}
			if (!E) return logger.error("Homeserver does not meet version requirements"), S["m.homeserver"].error = e.ERROR_UNSUPPORTED_HOMESERVER_SPEC_VERSION, S["m.homeserver"].base_url = C, Promise.resolve(S);
			S["m.homeserver"] = {
				state: e.SUCCESS,
				error: null,
				base_url: C
			};
			var O = "";
			if (b["m.identity_server"]) {
				var k = {
					"m.homeserver": S["m.homeserver"],
					"m.identity_server": {
						state: e.FAIL_PROMPT,
						error: e.ERROR_INVALID_IS,
						base_url: null
					}
				};
				if (O = x.sanitizeWellKnownUrl(b["m.identity_server"].base_url), !O) return logger.error("Invalid base_url for m.identity_server"), k["m.identity_server"].error = e.ERROR_INVALID_IS_BASE_URL, Promise.resolve(k);
				var A = yield x.fetchWellKnownObject(`${O}/_matrix/identity/v2`);
				if (!(A != null && A.raw) || A.action !== AutoDiscoveryAction.SUCCESS) return logger.error("Invalid /v2 response"), k["m.identity_server"].error = e.ERROR_INVALID_IDENTITY_SERVER, k["m.identity_server"].base_url = O, Promise.resolve(k);
			}
			return O && O.toString().length > 0 && (S["m.identity_server"] = {
				state: e.SUCCESS,
				error: null,
				base_url: O
			}), Object.keys(b).forEach((e) => {
				if (e === "m.homeserver" || e === "m.identity_server") {
					var x = [
						"error",
						"state",
						"base_url"
					];
					for (var C of Object.keys(b[e])) x.includes(C) || (S[e][C] = b[e][C]);
				} else S[e] = b[e];
			}), Promise.resolve(S);
		})();
	}
	static findClientConfig(b) {
		var x = this;
		return _asyncToGenerator(function* () {
			if (!b || typeof b != "string" || b.length === 0) throw Error("'domain' must be a string of non-zero length");
			var S = {
				"m.homeserver": {
					state: e.FAIL_ERROR,
					error: e.ERROR_INVALID,
					base_url: null
				},
				"m.identity_server": {
					state: e.PROMPT,
					error: null,
					base_url: null
				}
			}, C = b.includes("://") ? b : `https://${b}`, w = yield x.fetchWellKnownObject(`${C}/.well-known/matrix/client`);
			return !w || w.action !== AutoDiscoveryAction.SUCCESS ? (logger.error("No response or error when parsing .well-known"), w.reason && logger.error(w.reason), w.action === AutoDiscoveryAction.IGNORE ? S["m.homeserver"] = {
				state: e.PROMPT,
				error: null,
				base_url: null
			} : (S["m.homeserver"].state = e.FAIL_PROMPT, S["m.homeserver"].error = e.ERROR_INVALID), Promise.resolve(S)) : e.fromDiscoveryConfig(w.raw);
		})();
	}
	static getRawClientConfig(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			if (!e || typeof e != "string" || e.length === 0) throw Error("'domain' must be a string of non-zero length");
			var x = yield b.fetchWellKnownObject(`https://${e}/.well-known/matrix/client`);
			return x ? x.raw ?? {} : {};
		})();
	}
	static sanitizeWellKnownUrl(e) {
		if (!e) return !1;
		try {
			var b, x;
			try {
				x = new URL(e);
			} catch (e) {
				logger.error("Could not parse url", e);
			}
			if (!((b = x) != null && b.hostname) || x.protocol !== "http:" && x.protocol !== "https:") return !1;
			var S = x.port ? `:${x.port}` : "", C = x.pathname ? x.pathname : "", w = `${x.protocol}//${x.hostname}${S}${C}`;
			return w.endsWith("/") && (w = w.substring(0, w.length - 1)), w;
		} catch (e) {
			return logger.error(e), !1;
		}
	}
	static fetch(e, b) {
		return this.fetchFn ? this.fetchFn(e, b) : globalThis.fetch(e, b);
	}
	static setFetchFn(b) {
		e.fetchFn = b;
	}
	static fetchWellKnownObject(b) {
		return _asyncToGenerator(function* () {
			var x;
			try {
				if (x = yield e.fetch(b, {
					method: Method.Get,
					signal: timeoutSignal(5e3)
				}), x.status === 404) return {
					raw: {},
					action: AutoDiscoveryAction.IGNORE,
					reason: e.ERROR_MISSING_WELLKNOWN
				};
				if (x.status !== 200) return {
					raw: {},
					action: AutoDiscoveryAction.FAIL_PROMPT,
					reason: "General failure"
				};
			} catch (e) {
				var S = e, C = "";
				return typeof S == "object" && (C = S?.message), {
					error: S,
					raw: {},
					action: AutoDiscoveryAction.FAIL_PROMPT,
					reason: C || "General failure"
				};
			}
			try {
				return {
					raw: yield x.json(),
					action: AutoDiscoveryAction.SUCCESS
				};
			} catch (b) {
				var w = b;
				return {
					error: w,
					raw: {},
					action: AutoDiscoveryAction.FAIL_PROMPT,
					reason: w?.name === "SyntaxError" ? e.ERROR_INVALID_JSON : e.ERROR_INVALID
				};
			}
		})();
	}
};
_defineProperty(AutoDiscovery, "ERROR_INVALID", AutoDiscoveryError.Invalid), _defineProperty(AutoDiscovery, "ERROR_GENERIC_FAILURE", AutoDiscoveryError.GenericFailure), _defineProperty(AutoDiscovery, "ERROR_INVALID_HS_BASE_URL", AutoDiscoveryError.InvalidHsBaseUrl), _defineProperty(AutoDiscovery, "ERROR_INVALID_HOMESERVER", AutoDiscoveryError.InvalidHomeserver), _defineProperty(AutoDiscovery, "ERROR_INVALID_IS_BASE_URL", AutoDiscoveryError.InvalidIsBaseUrl), _defineProperty(AutoDiscovery, "ERROR_INVALID_IDENTITY_SERVER", AutoDiscoveryError.InvalidIdentityServer), _defineProperty(AutoDiscovery, "ERROR_INVALID_IS", AutoDiscoveryError.InvalidIs), _defineProperty(AutoDiscovery, "ERROR_MISSING_WELLKNOWN", AutoDiscoveryError.MissingWellknown), _defineProperty(AutoDiscovery, "ERROR_INVALID_JSON", AutoDiscoveryError.InvalidJson), _defineProperty(AutoDiscovery, "ERROR_UNSUPPORTED_HOMESERVER_SPEC_VERSION", AutoDiscoveryError.UnsupportedHomeserverSpecVersion), _defineProperty(AutoDiscovery, "ALL_ERRORS", Object.keys(AutoDiscoveryError)), _defineProperty(AutoDiscovery, "FAIL_ERROR", AutoDiscoveryAction.FAIL_ERROR), _defineProperty(AutoDiscovery, "FAIL_PROMPT", AutoDiscoveryAction.FAIL_PROMPT), _defineProperty(AutoDiscovery, "PROMPT", AutoDiscoveryAction.PROMPT), _defineProperty(AutoDiscovery, "SUCCESS", AutoDiscoveryAction.SUCCESS), _defineProperty(AutoDiscovery, "fetchFn", void 0);
var SERVICE_TYPES = /* @__PURE__ */ function(e) {
	return e.IS = "SERVICE_TYPE_IS", e.IM = "SERVICE_TYPE_IM", e;
}({}), EventContext = class {
	constructor(e) {
		this.ourEvent = e, _defineProperty(this, "timeline", void 0), _defineProperty(this, "ourEventIndex", 0), _defineProperty(this, "paginateTokens", {
			[Direction.Backward]: null,
			[Direction.Forward]: null
		}), this.timeline = [e];
	}
	getEvent() {
		return this.timeline[this.ourEventIndex];
	}
	getTimeline() {
		return this.timeline;
	}
	getOurEventIndex() {
		return this.ourEventIndex;
	}
	getPaginateToken() {
		var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
		return this.paginateTokens[e ? Direction.Backward : Direction.Forward];
	}
	setPaginateToken(e) {
		var b = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
		this.paginateTokens[b ? Direction.Backward : Direction.Forward] = e ?? null;
	}
	addEvents(e) {
		arguments.length > 1 && arguments[1] !== void 0 && arguments[1] ? (this.timeline = e.concat(this.timeline), this.ourEventIndex += e.length) : this.timeline = this.timeline.concat(e);
	}
}, SearchResult = class e {
	static fromJson(b, x) {
		var S = b.context || {}, C = (S.events_before || []).map(x), w = (S.events_after || []).map(x), T = new EventContext(x(b.result)), E = T.ourEvent.threadRootId;
		return C = C.filter((e) => e.threadRootId === E), w = w.filter((e) => e.threadRootId === E), T.setPaginateToken(S.start, !0), T.addEvents(C, !0), T.addEvents(w, !1), T.setPaginateToken(S.end, !1), new e(b.rank, T);
	}
	constructor(e, b) {
		this.rank = e, this.context = b;
	}
};
function isSendDelayedEventRequestOpts(e) {
	return "parent_delay_id" in e && typeof e.parent_delay_id != "string" ? !1 : "delay" in e && typeof e.delay != "number" ? !0 : "delay" in e || "parent_delay_id" in e;
}
var UpdateDelayedEventAction = /* @__PURE__ */ function(e) {
	return e.Cancel = "cancel", e.Restart = "restart", e.Send = "send", e;
}({}), Visibility = /* @__PURE__ */ function(e) {
	return e.Public = "public", e.Private = "private", e;
}({}), Preset = /* @__PURE__ */ function(e) {
	return e.PrivateChat = "private_chat", e.TrustedPrivateChat = "trusted_private_chat", e.PublicChat = "public_chat", e;
}({}), JoinRule = /* @__PURE__ */ function(e) {
	return e.Public = "public", e.Invite = "invite", e.Private = "private", e.Knock = "knock", e.Restricted = "restricted", e;
}({}), RestrictedAllowType = /* @__PURE__ */ function(e) {
	return e.RoomMembership = "m.room_membership", e;
}({}), GuestAccess = /* @__PURE__ */ function(e) {
	return e.CanJoin = "can_join", e.Forbidden = "forbidden", e;
}({}), HistoryVisibility = /* @__PURE__ */ function(e) {
	return e.Invited = "invited", e.Joined = "joined", e.Shared = "shared", e.WorldReadable = "world_readable", e;
}({});
function ownKeys$8(e, b) {
	var x = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var S = Object.getOwnPropertySymbols(e);
		b && (S = S.filter(function(b) {
			return Object.getOwnPropertyDescriptor(e, b).enumerable;
		})), x.push.apply(x, S);
	}
	return x;
}
function _objectSpread$8(e) {
	for (var b = 1; b < arguments.length; b++) {
		var x = arguments[b] == null ? {} : arguments[b];
		b % 2 ? ownKeys$8(Object(x), !0).forEach(function(b) {
			_defineProperty(e, b, x[b]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(x)) : ownKeys$8(Object(x)).forEach(function(b) {
			Object.defineProperty(e, b, Object.getOwnPropertyDescriptor(x, b));
		});
	}
	return e;
}
function eventMapperFor(e, b) {
	var x = !!b.preventReEmit, S = b.decrypt !== !1;
	function C(b) {
		var w = e.getRoom(b.room_id), T;
		w && b.state_key === void 0 && (T = w.findEventById(b.event_id)), !T || T.status ? T = new MatrixEvent(b) : (T.setUnsigned(_objectSpread$8(_objectSpread$8({}, T.getUnsigned()), b.unsigned)), x = !0);
		var E = T.getServerAggregatedRelation(RelationType.Replace);
		if (E != null && E.content) {
			var D = C(E);
			T.makeReplaced(D);
		}
		var O = w?.findThreadForEvent(T);
		return O && T.setThread(O), T.isEncrypted() && (x || e.reEmitter.reEmit(T, [MatrixEventEvent.Decrypted]), S && e.decryptEventIfNeeded(T)), x || (e.reEmitter.reEmit(T, [MatrixEventEvent.Replaced, MatrixEventEvent.VisibilityChange]), w?.reEmitter.reEmit(T, [MatrixEventEvent.BeforeRedaction])), T;
	}
	return C;
}
function ownKeys$7(e, b) {
	var x = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var S = Object.getOwnPropertySymbols(e);
		b && (S = S.filter(function(b) {
			return Object.getOwnPropertyDescriptor(e, b).enumerable;
		})), x.push.apply(x, S);
	}
	return x;
}
function _objectSpread$7(e) {
	for (var b = 1; b < arguments.length; b++) {
		var x = arguments[b] == null ? {} : arguments[b];
		b % 2 ? ownKeys$7(Object(x), !0).forEach(function(b) {
			_defineProperty(e, b, x[b]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(x)) : ownKeys$7(Object(x)).forEach(function(b) {
			Object.defineProperty(e, b, Object.getOwnPropertyDescriptor(x, b));
		});
	}
	return e;
}
var MSC3089Branch = class {
	constructor(e, b, x) {
		this.client = e, this.indexEvent = b, this.directory = x;
	}
	get id() {
		var e = this.indexEvent.getStateKey();
		if (!e) throw Error("State key not found for branch");
		return e;
	}
	get isActive() {
		return this.indexEvent.getContent().active === !0;
	}
	get version() {
		return this.indexEvent.getContent().version ?? 1;
	}
	get roomId() {
		return this.indexEvent.getRoomId();
	}
	delete() {
		var e = this;
		return _asyncToGenerator(function* () {
			yield e.client.sendStateEvent(e.roomId, UNSTABLE_MSC3089_BRANCH.name, {}, e.id), yield e.client.redactEvent(e.roomId, e.id);
			var b = (yield e.getVersionHistory())[1];
			b && (yield b.delete());
		})();
	}
	getName() {
		return this.indexEvent.getContent().name || "Unnamed File";
	}
	setName(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			yield b.client.sendStateEvent(b.roomId, UNSTABLE_MSC3089_BRANCH.name, _objectSpread$7(_objectSpread$7({}, b.indexEvent.getContent()), {}, { name: e }), b.id);
		})();
	}
	isLocked() {
		return this.indexEvent.getContent().locked || !1;
	}
	setLocked(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			yield b.client.sendStateEvent(b.roomId, UNSTABLE_MSC3089_BRANCH.name, _objectSpread$7(_objectSpread$7({}, b.indexEvent.getContent()), {}, { locked: e }), b.id);
		})();
	}
	getFileInfo() {
		var e = this;
		return _asyncToGenerator(function* () {
			var b = (yield e.getFileEvent()).getOriginalContent().file, x = e.client.mxcUrlToHttp(b.url);
			if (!x) throw Error(`No HTTP URL available for ${b.url}`);
			return {
				info: b,
				httpUrl: x
			};
		})();
	}
	getFileEvent() {
		var e = this;
		return _asyncToGenerator(function* () {
			var b = e.client.getRoom(e.roomId);
			if (!b) throw Error("Unknown room");
			for (var x = b.getUnfilteredTimelineSet().findEventById(e.id); !x && b.getLiveTimeline().getState(EventTimeline.BACKWARDS).paginationToken;) yield e.client.scrollback(b, 100), x = b.getUnfilteredTimelineSet().findEventById(e.id);
			if (!x) throw Error("Failed to find event");
			return yield e.client.decryptEventIfNeeded(x), x;
		})();
	}
	createNewVersion(e, b, x, S) {
		var C = this;
		return _asyncToGenerator(function* () {
			var w = yield C.directory.createFile(e, b, x, _objectSpread$7(_objectSpread$7({}, S ?? {}), {}, {
				"m.new_content": !0,
				"m.relates_to": {
					rel_type: RelationType.Replace,
					event_id: C.id
				}
			}));
			return yield C.client.sendStateEvent(C.roomId, UNSTABLE_MSC3089_BRANCH.name, {
				active: !0,
				name: e,
				version: C.version + 1
			}, w.event_id), yield C.client.sendStateEvent(C.roomId, UNSTABLE_MSC3089_BRANCH.name, _objectSpread$7(_objectSpread$7({}, C.indexEvent.getContent()), {}, { active: !1 }), C.id), w;
		})();
	}
	getVersionHistory() {
		var e = this;
		return _asyncToGenerator(function* () {
			var b = [];
			b.push(e);
			var x = e.client.getRoom(e.roomId);
			if (!x) throw Error("Invalid or unknown room");
			var S = [...x.getLiveTimeline().getEvents()].reverse(), C, w = yield e.getFileEvent();
			do
				if (C = S.find((e) => e.replacingEventId() === w.getId()), C) {
					var T = e.directory.getFile(C.getId());
					if (T) b.push(T), w = C;
					else break;
				}
			while (C);
			return b;
		})();
	}
};
function ownKeys$6(e, b) {
	var x = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var S = Object.getOwnPropertySymbols(e);
		b && (S = S.filter(function(b) {
			return Object.getOwnPropertyDescriptor(e, b).enumerable;
		})), x.push.apply(x, S);
	}
	return x;
}
function _objectSpread$6(e) {
	for (var b = 1; b < arguments.length; b++) {
		var x = arguments[b] == null ? {} : arguments[b];
		b % 2 ? ownKeys$6(Object(x), !0).forEach(function(b) {
			_defineProperty(e, b, x[b]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(x)) : ownKeys$6(Object(x)).forEach(function(b) {
			Object.defineProperty(e, b, Object.getOwnPropertyDescriptor(x, b));
		});
	}
	return e;
}
var DEFAULT_TREE_POWER_LEVELS_TEMPLATE = {
	invite: 100,
	kick: 100,
	ban: 100,
	redact: 50,
	state_default: 50,
	events_default: 50,
	users_default: 0,
	events: {
		[EventType.RoomPowerLevels]: 100,
		[EventType.RoomHistoryVisibility]: 100,
		[EventType.RoomTombstone]: 100,
		[EventType.RoomEncryption]: 100,
		[EventType.RoomName]: 50,
		[EventType.RoomMessage]: 50,
		[EventType.RoomMessageEncrypted]: 50,
		[EventType.Sticker]: 50
	},
	users: {}
}, TreePermissions = /* @__PURE__ */ function(e) {
	return e.Viewer = "viewer", e.Editor = "editor", e.Owner = "owner", e;
}({}), MSC3089TreeSpace = class {
	constructor(e, b) {
		if (this.client = e, this.roomId = b, _defineProperty(this, "room", void 0), this.room = this.client.getRoom(this.roomId), !this.room) throw Error("Unknown room");
	}
	get id() {
		return this.roomId;
	}
	get isTopLevel() {
		var e = this.room.currentState.getStateEvents(EventType.SpaceParent);
		return e != null && e.length ? e.every((e) => {
			var b;
			return !((b = e.getContent()) != null && b.via);
		}) : !0;
	}
	setName(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			yield b.client.sendStateEvent(b.roomId, EventType.RoomName, { name: e }, "");
		})();
	}
	invite(e) {
		var b = arguments, x = this;
		return _asyncToGenerator(function* () {
			var S = b.length > 1 && b[1] !== void 0 ? b[1] : !0, C = [x.retryInvite(e)];
			S && C.push(...x.getDirectories().map((b) => b.invite(e, S))), yield Promise.all(C);
		})();
	}
	retryInvite(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			yield simpleRetryOperation(() => b.client.invite(b.roomId, e), (e) => !(e instanceof MatrixError && e.errcode === "M_FORBIDDEN"));
		})();
	}
	setPermissions(e, b) {
		var x = this;
		return _asyncToGenerator(function* () {
			var S = x.room.currentState.getStateEvents(EventType.RoomPowerLevels, "");
			if (Array.isArray(S)) throw Error("Unexpected return type for power levels");
			var C = S?.getContent() || {}, w = C.users_default || 0, T = C.events_default || 50, E = C.events?.[EventType.RoomPowerLevels] || 100, D = C.users || {};
			switch (b) {
				case TreePermissions.Viewer:
					D[e] = w;
					break;
				case TreePermissions.Editor:
					D[e] = T;
					break;
				case TreePermissions.Owner:
					D[e] = E;
					break;
				default: throw Error("Invalid role: " + b);
			}
			C.users = D, yield x.client.sendStateEvent(x.roomId, EventType.RoomPowerLevels, C, "");
		})();
	}
	getPermissions(e) {
		var b = this.room.currentState.getStateEvents(EventType.RoomPowerLevels, "");
		if (Array.isArray(b)) throw Error("Unexpected return type for power levels");
		var x = b?.getContent() || {}, S = x.users_default || 0, C = x.events_default || 50, w = x.events?.[EventType.RoomPowerLevels] || 100, T = x.users?.[e] || S;
		return T >= w ? TreePermissions.Owner : T >= C ? TreePermissions.Editor : TreePermissions.Viewer;
	}
	createDirectory(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			var x = yield b.client.unstableCreateFileTree(e);
			return yield b.client.sendStateEvent(b.roomId, EventType.SpaceChild, { via: [b.client.getDomain()] }, x.roomId), yield b.client.sendStateEvent(x.roomId, EventType.SpaceParent, { via: [b.client.getDomain()] }, b.roomId), x;
		})();
	}
	getDirectories() {
		var e = [];
		for (var b of this.room.currentState.getStateEvents(EventType.SpaceChild)) try {
			var x = b.getStateKey();
			if (x) {
				var S = this.client.unstableGetFileTreeSpace(x);
				S && e.push(S);
			}
		} catch (e) {
			logger.warn("Unable to create tree space instance for listing. Are we joined?", e);
		}
		return e;
	}
	getDirectory(e) {
		return this.getDirectories().find((b) => b.roomId === e);
	}
	delete() {
		var e = this;
		return _asyncToGenerator(function* () {
			for (var b of e.getDirectories()) yield b.delete();
			var x = [
				KnownMembership.Invite,
				KnownMembership.Knock,
				KnownMembership.Join
			];
			for (var S of e.room.currentState.getStateEvents(EventType.RoomMember)) if (S.getStateKey() !== e.client.getUserId() && x.includes(S.getContent().membership)) {
				var C = S.getStateKey();
				if (!C) throw Error("State key not found for branch");
				yield e.client.kick(e.roomId, C, "Room deleted");
			}
			yield e.client.leave(e.roomId);
		})();
	}
	getOrderedChildren(e) {
		var b = e.map((e) => ({
			roomId: e.getStateKey(),
			order: e.getContent().order
		})).filter((e) => e.roomId);
		return b.sort((e, b) => {
			if (e.order && !b.order) return -1;
			if (!e.order && b.order) return 1;
			if (!e.order && !b.order) {
				var x = this.client.getRoom(e.roomId), S = this.client.getRoom(b.roomId);
				if (!x || !S) return lexicographicCompare(e.roomId, b.roomId);
				var C = x.currentState.getStateEvents(EventType.RoomCreate, "")?.getTs() ?? 0, w = S.currentState.getStateEvents(EventType.RoomCreate, "")?.getTs() ?? 0;
				return C === w ? lexicographicCompare(e.roomId, b.roomId) : C - w;
			} else return lexicographicCompare(e.order, b.order);
		}), b;
	}
	getParentRoom() {
		var e = this.room.currentState.getStateEvents(EventType.SpaceParent)[0];
		if (!e) throw Error("Expected to have a parent in a non-top level space");
		var b = e.getStateKey();
		if (!b) throw Error("No state key found for parent");
		var x = this.client.getRoom(b);
		if (!x) throw Error("Unable to locate room for parent");
		return x;
	}
	getOrder() {
		if (this.isTopLevel) return -1;
		var e = this.getParentRoom().currentState.getStateEvents(EventType.SpaceChild);
		return this.getOrderedChildren(e).findIndex((e) => e.roomId === this.roomId);
	}
	setOrder(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			if (b.isTopLevel) throw Error("Cannot set order of top level spaces currently");
			var x = b.getParentRoom(), S = x.currentState.getStateEvents(EventType.SpaceChild), C = b.getOrderedChildren(S);
			e = Math.max(Math.min(e, C.length - 1), 0);
			var w = b.getOrder() < e;
			w && e === C.length - 1 ? e-- : !w && e === 0 && e++;
			var T = C[w ? e : e - 1], E = C[w ? e + 1 : e], D = DEFAULT_ALPHABET[0], O = !1;
			if (!T) E != null && E.order && (D = prevString(E.order));
			else if (e === C.length - 1) E != null && E.order && (D = nextString(E.order));
			else {
				var k = T?.order, A = E?.order;
				k && A ? D = k === A ? nextString(k) : averageBetweenStrings(k, A) : k ? D = nextString(k) : A ? D = prevString(A) : O = !0;
			}
			if (O) {
				for (var j, M = 0; M <= e; M++) {
					var N = C[M];
					if (M === 0 && (j = N.order), N.order) j = N.order;
					else {
						j = j ? nextString(j) : DEFAULT_ALPHABET[0];
						var P = x.currentState.getStateEvents(EventType.SpaceChild, N.roomId)?.getContent() ?? { via: [b.client.getDomain()] };
						yield b.client.sendStateEvent(x.roomId, EventType.SpaceChild, _objectSpread$6(_objectSpread$6({}, P), {}, { order: j }), N.roomId);
					}
				}
				j && (D = nextString(j));
			}
			var F = x.currentState.getStateEvents(EventType.SpaceChild, b.roomId)?.getContent() ?? { via: [b.client.getDomain()] };
			yield b.client.sendStateEvent(x.roomId, EventType.SpaceChild, _objectSpread$6(_objectSpread$6({}, F), {}, { order: D }), b.roomId);
		})();
	}
	createFile(e, b, x, S) {
		var C = this;
		return _asyncToGenerator(function* () {
			var { content_uri: w } = yield C.client.uploadContent(b, { includeFilename: !1 });
			x.url = w;
			var T = {
				msgtype: MsgType.File,
				body: e,
				url: w,
				file: x
			};
			S ??= {}, S["m.new_content"] &&= T;
			var E = yield C.client.sendMessage(C.roomId, _objectSpread$6(_objectSpread$6(_objectSpread$6({}, S), T), {}, { [UNSTABLE_MSC3089_LEAF.name]: {} }));
			return yield C.client.sendStateEvent(C.roomId, UNSTABLE_MSC3089_BRANCH.name, {
				active: !0,
				name: e
			}, E.event_id), E;
		})();
	}
	getFile(e) {
		var b = this.room.currentState.getStateEvents(UNSTABLE_MSC3089_BRANCH.name, e);
		return b ? new MSC3089Branch(this.client, b, this) : null;
	}
	listFiles() {
		return this.listAllFiles().filter((e) => e.isActive);
	}
	listAllFiles() {
		return (this.room.currentState.getStateEvents(UNSTABLE_MSC3089_BRANCH.name) ?? []).map((e) => new MSC3089Branch(this.client, e, this));
	}
}, SearchOrderBy = /* @__PURE__ */ function(e) {
	return e.Recent = "recent", e.Rank = "rank", e;
}({}), MediaHandlerEvent = /* @__PURE__ */ function(e) {
	return e.LocalStreamsChanged = "local_streams_changed", e;
}({}), MediaHandler = class extends TypedEventEmitter {
	constructor(e) {
		super(), this.client = e, _defineProperty(this, "audioInput", void 0), _defineProperty(this, "audioSettings", void 0), _defineProperty(this, "videoInput", void 0), _defineProperty(this, "localUserMediaStream", void 0), _defineProperty(this, "userMediaStreams", []), _defineProperty(this, "screensharingStreams", []), _defineProperty(this, "getMediaStreamPromise", void 0);
	}
	restoreMediaSettings(e, b) {
		this.audioInput = e, this.videoInput = b;
	}
	setAudioInput(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			logger.info(`MediaHandler setAudioInput() running (deviceId=${e})`), b.audioInput !== e && (b.audioInput = e, yield b.updateLocalUsermediaStreams());
		})();
	}
	setAudioSettings(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			logger.info(`MediaHandler setAudioSettings() running (opts=${JSON.stringify(e)})`), b.audioSettings = Object.assign({}, e), yield b.updateLocalUsermediaStreams();
		})();
	}
	setVideoInput(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			logger.info(`MediaHandler setVideoInput() running (deviceId=${e})`), b.videoInput !== e && (b.videoInput = e, yield b.updateLocalUsermediaStreams());
		})();
	}
	setMediaInputs(e, b) {
		var x = this;
		return _asyncToGenerator(function* () {
			logger.log(`MediaHandler setMediaInputs() running (audioInput: ${e} videoInput: ${b})`), x.audioInput = e, x.videoInput = b, yield x.updateLocalUsermediaStreams();
		})();
	}
	updateLocalUsermediaStreams() {
		var e = this;
		return _asyncToGenerator(function* () {
			if (e.userMediaStreams.length !== 0) {
				var b = /* @__PURE__ */ new Map();
				for (var x of e.client.callEventHandler.calls.values()) b.set(x.callId, {
					audio: x.hasLocalUserMediaAudioTrack,
					video: x.hasLocalUserMediaVideoTrack
				});
				for (var S of e.userMediaStreams) {
					logger.log(`MediaHandler updateLocalUsermediaStreams() stopping all tracks (streamId=${S.id})`);
					for (var C of S.getTracks()) C.stop();
				}
				e.userMediaStreams = [], e.localUserMediaStream = void 0;
				for (var w of e.client.callEventHandler.calls.values()) if (!(w.callHasEnded() || !b.has(w.callId))) {
					var { audio: T, video: E } = b.get(w.callId);
					logger.log(`MediaHandler updateLocalUsermediaStreams() calling getUserMediaStream() (callId=${w.callId})`);
					var D = yield e.getUserMediaStream(T, E);
					w.callHasEnded() || (yield w.updateLocalUsermediaStream(D));
				}
				for (var O of e.client.groupCallEventHandler.groupCalls.values()) if (O.localCallFeed) {
					logger.log(`MediaHandler updateLocalUsermediaStreams() calling getUserMediaStream() (groupCallId=${O.groupCallId})`);
					var k = yield e.getUserMediaStream(!0, O.type === GroupCallType.Video);
					O.state !== GroupCallState.Ended && (yield O.updateLocalUsermediaStream(k));
				}
				e.emit(MediaHandlerEvent.LocalStreamsChanged);
			}
		})();
	}
	hasAudioDevice() {
		return _asyncToGenerator(function* () {
			try {
				return (yield navigator.mediaDevices.enumerateDevices()).filter((e) => e.kind === "audioinput").length > 0;
			} catch (e) {
				return logger.log("MediaHandler hasAudioDevice() calling navigator.mediaDevices.enumerateDevices with error", e), !1;
			}
		})();
	}
	hasVideoDevice() {
		return _asyncToGenerator(function* () {
			try {
				return (yield navigator.mediaDevices.enumerateDevices()).filter((e) => e.kind === "videoinput").length > 0;
			} catch (e) {
				return logger.log("MediaHandler hasVideoDevice() calling navigator.mediaDevices.enumerateDevices with error", e), !1;
			}
		})();
	}
	getUserMediaStream(e, b) {
		var x = arguments, S = this;
		return _asyncToGenerator(function* () {
			var C = x.length > 2 && x[2] !== void 0 ? x[2] : !0;
			return S.getMediaStreamPromise ? S.getMediaStreamPromise = S.getMediaStreamPromise.then(() => S.getUserMediaStreamInternal(e, b, C)) : S.getMediaStreamPromise = S.getUserMediaStreamInternal(e, b, C), S.getMediaStreamPromise;
		})();
	}
	getUserMediaStreamInternal(e, b, x) {
		var S = this;
		return _asyncToGenerator(function* () {
			var C = e && (yield S.hasAudioDevice()), w = b && (yield S.hasVideoDevice()), T, E = !0;
			if (S.localUserMediaStream) {
				var D, O;
				C !== S.localUserMediaStream.getAudioTracks().length > 0 && (E = !1), w !== S.localUserMediaStream.getVideoTracks().length > 0 && (E = !1), C && ((D = S.localUserMediaStream.getAudioTracks()[0]) == null || (D = D.getSettings()) == null ? void 0 : D.deviceId) !== S.audioInput && (E = !1), w && ((O = S.localUserMediaStream.getVideoTracks()[0]) == null || (O = O.getSettings()) == null ? void 0 : O.deviceId) !== S.videoInput && (E = !1);
			} else E = !1;
			if (E) {
				if (T = S.localUserMediaStream.clone(), logger.log(`MediaHandler getUserMediaStreamInternal() cloning (oldStreamId=${S.localUserMediaStream?.id} newStreamId=${T.id} shouldRequestAudio=${C} shouldRequestVideo=${w})`), !C) for (var k of T.getAudioTracks()) T.removeTrack(k);
				if (!w) for (var A of T.getVideoTracks()) T.removeTrack(A);
			} else {
				var j;
				try {
					j = S.getUserMediaContraints(C, w, !0), T = yield navigator.mediaDevices.getUserMedia(j);
				} catch (e) {
					logger.warn(`MediaHandler getUserMediaStreamInternal() error (e=${e}), retrying without exact deviceId`), j = S.getUserMediaContraints(C, w, !1), T = yield navigator.mediaDevices.getUserMedia(j);
				}
				logger.log(`MediaHandler getUserMediaStreamInternal() calling getUserMediaStream (streamId=${T.id}, shouldRequestAudio=${C}, shouldRequestVideo=${w}, constraints=${JSON.stringify(j)})`);
				for (var M of T.getTracks()) {
					var N = M.getSettings();
					M.kind === "audio" ? S.audioInput = N.deviceId : M.kind === "video" && (S.videoInput = N.deviceId);
				}
				x && (S.localUserMediaStream = T);
			}
			return x && S.userMediaStreams.push(T), S.emit(MediaHandlerEvent.LocalStreamsChanged), T;
		})();
	}
	stopUserMediaStream(e) {
		logger.log(`MediaHandler stopUserMediaStream() stopping (streamId=${e.id})`);
		for (var b of e.getTracks()) b.stop();
		var x = this.userMediaStreams.indexOf(e);
		if (x !== -1 && (logger.debug(`MediaHandler stopUserMediaStream() splicing usermedia stream out stream array (streamId=${e.id})`, e.id), this.userMediaStreams.splice(x, 1)), this.emit(MediaHandlerEvent.LocalStreamsChanged), this.localUserMediaStream === e) this.localUserMediaStream = void 0;
		else for (var S of e.getTracks()) {
			var C;
			if ((C = this.localUserMediaStream) != null && C.getTrackById(S.id)) {
				this.stopUserMediaStream(this.localUserMediaStream);
				break;
			}
		}
	}
	getScreensharingStream() {
		var e = arguments, b = this;
		return _asyncToGenerator(function* () {
			var x = e.length > 0 && e[0] !== void 0 ? e[0] : {}, S = e.length > 1 && e[1] !== void 0 ? e[1] : !0, C;
			if (b.screensharingStreams.length === 0) {
				var w = b.getScreenshareContraints(x);
				x.desktopCapturerSourceId ? (logger.debug(`MediaHandler getScreensharingStream() calling getUserMedia() (opts=${JSON.stringify(x)})`), C = yield navigator.mediaDevices.getUserMedia(w)) : (logger.debug(`MediaHandler getScreensharingStream() calling getDisplayMedia() (opts=${JSON.stringify(x)})`), C = yield navigator.mediaDevices.getDisplayMedia(w));
			} else {
				var T = b.screensharingStreams[b.screensharingStreams.length - 1];
				logger.log(`MediaHandler getScreensharingStream() cloning (streamId=${T.id})`), C = T.clone();
			}
			return S && b.screensharingStreams.push(C), b.emit(MediaHandlerEvent.LocalStreamsChanged), C;
		})();
	}
	stopScreensharingStream(e) {
		logger.debug(`MediaHandler stopScreensharingStream() stopping stream (streamId=${e.id})`);
		for (var b of e.getTracks()) b.stop();
		var x = this.screensharingStreams.indexOf(e);
		x !== -1 && (logger.debug(`MediaHandler stopScreensharingStream() splicing stream out (streamId=${e.id})`), this.screensharingStreams.splice(x, 1)), this.emit(MediaHandlerEvent.LocalStreamsChanged);
	}
	stopAllStreams() {
		for (var e of this.userMediaStreams) {
			logger.log(`MediaHandler stopAllStreams() stopping (streamId=${e.id})`);
			for (var b of e.getTracks()) b.stop();
		}
		for (var x of this.screensharingStreams) for (var S of x.getTracks()) S.stop();
		this.userMediaStreams = [], this.screensharingStreams = [], this.localUserMediaStream = void 0, this.emit(MediaHandlerEvent.LocalStreamsChanged);
	}
	getUserMediaContraints(e, b, x) {
		var S = !!navigator.webkitGetUserMedia, C = x ? "exact" : "ideal", w = {};
		this.audioInput && (w.deviceId = { [C]: this.audioInput }), this.audioSettings && (w.autoGainControl = { ideal: this.audioSettings.autoGainControl }, w.echoCancellation = { ideal: this.audioSettings.echoCancellation }, w.noiseSuppression = { ideal: this.audioSettings.noiseSuppression });
		var T = {
			width: S ? { exact: 640 } : { ideal: 640 },
			height: S ? { exact: 360 } : { ideal: 360 }
		};
		return this.videoInput && (T.deviceId = { [C]: this.videoInput }), {
			audio: e ? w : !1,
			video: b ? T : !1
		};
	}
	getScreenshareContraints(e) {
		var { desktopCapturerSourceId: b, audio: x } = e;
		return b ? {
			audio: x ?? !1,
			video: { mandatory: {
				chromeMediaSource: "desktop",
				chromeMediaSourceId: b
			} }
		} : {
			audio: x ?? !1,
			video: !0
		};
	}
}, SlidingSyncState = /* @__PURE__ */ function(e) {
	return e.RequestFinished = "FINISHED", e.Complete = "COMPLETE", e;
}({}), ExtensionState = /* @__PURE__ */ function(e) {
	return e.PreProcess = "ExtState.PreProcess", e.PostProcess = "ExtState.PostProcess", e;
}({}), SlidingSyncEvent = /* @__PURE__ */ function(e) {
	return e.RoomData = "SlidingSync.RoomData", e.Lifecycle = "SlidingSync.Lifecycle", e;
}({}), FAILED_SYNC_ERROR_THRESHOLD = 3, ExtensionE2EE = class {
	constructor(e) {
		this.crypto = e;
	}
	name() {
		return "e2ee";
	}
	when() {
		return ExtensionState.PreProcess;
	}
	onRequest(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			return e && (logger.log("ExtensionE2EE: invalidating all device lists due to missing 'pos'"), yield b.crypto.markAllTrackedUsersAsDirty()), { enabled: !0 };
		})();
	}
	onResponse(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			e.device_lists && (yield b.crypto.processDeviceLists(e.device_lists)), yield b.crypto.processKeyCounts(e.device_one_time_keys_count, e.device_unused_fallback_key_types || e["org.matrix.msc2732.device_unused_fallback_key_types"]), b.crypto.onSyncCompleted({});
		})();
	}
}, ExtensionToDevice = class {
	constructor(e, b) {
		this.client = e, this.cryptoCallbacks = b, _defineProperty(this, "nextBatch", null);
	}
	name() {
		return "to_device";
	}
	when() {
		return ExtensionState.PreProcess;
	}
	onRequest(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			return {
				since: b.nextBatch === null ? void 0 : b.nextBatch,
				limit: 100,
				enabled: !0
			};
		})();
	}
	onResponse(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			var x = e.events || [], S = b.cryptoCallbacks ? yield b.cryptoCallbacks.preprocessToDeviceMessages(x) : x.map((e) => ({
				message: e,
				encryptionInfo: null
			}));
			processToDeviceMessages(S, b.client), b.nextBatch = e.next_batch;
		})();
	}
}, ExtensionAccountData = class {
	constructor(e) {
		this.client = e;
	}
	name() {
		return "account_data";
	}
	when() {
		return ExtensionState.PostProcess;
	}
	onRequest(e) {
		return _asyncToGenerator(function* () {
			return { enabled: !0 };
		})();
	}
	onResponse(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			for (var x in e.global && e.global.length > 0 && b.processGlobalAccountData(e.global), e.rooms) {
				var S = mapEvents(b.client, x, e.rooms[x]), C = b.client.getRoom(x);
				if (!C) {
					logger.warn("got account data for room but room doesn't exist on client:", x);
					continue;
				}
				C.addAccountData(S), S.forEach((e) => {
					b.client.emit(ClientEvent.Event, e);
				});
			}
		})();
	}
	processGlobalAccountData(e) {
		var b = mapEvents(this.client, void 0, e), x = b.reduce((e, b) => (e[b.getType()] = this.client.store.getAccountData(b.getType()), e), {});
		this.client.store.storeAccountDataEvents(b), b.forEach((e) => {
			if (e.getType() === EventType.PushRules) {
				var b = e.getContent();
				this.client.setPushRules(b);
			}
			var S = x[e.getType()];
			return this.client.emit(ClientEvent.AccountData, e, S), e;
		});
	}
}, ExtensionTyping = class {
	constructor(e) {
		this.client = e;
	}
	name() {
		return "typing";
	}
	when() {
		return ExtensionState.PostProcess;
	}
	onRequest(e) {
		return _asyncToGenerator(function* () {
			return { enabled: !0 };
		})();
	}
	onResponse(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			if (e != null && e.rooms) for (var x in e.rooms) processEphemeralEvents(b.client, x, [e.rooms[x]]);
		})();
	}
}, ExtensionReceipts = class {
	constructor(e) {
		this.client = e;
	}
	name() {
		return "receipts";
	}
	when() {
		return ExtensionState.PostProcess;
	}
	onRequest(e) {
		return _asyncToGenerator(function* () {
			return { enabled: !0 };
		})();
	}
	onResponse(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			if (e != null && e.rooms) for (var x in e.rooms) processEphemeralEvents(b.client, x, [e.rooms[x]]);
		})();
	}
}, SlidingSyncSdk = class {
	constructor(e, b, x, S) {
		this.slidingSync = e, this.client = b, _defineProperty(this, "opts", void 0), _defineProperty(this, "syncOpts", void 0), _defineProperty(this, "syncState", null), _defineProperty(this, "syncStateData", void 0), _defineProperty(this, "lastPos", null), _defineProperty(this, "failCount", 0), _defineProperty(this, "notifEvents", []), this.opts = defaultClientOpts(x), this.syncOpts = defaultSyncApiOpts(S), b.getNotifTimelineSet() && b.reEmitter.reEmit(b.getNotifTimelineSet(), [RoomEvent.Timeline, RoomEvent.TimelineReset]), this.slidingSync.on(SlidingSyncEvent.Lifecycle, this.onLifecycle.bind(this)), this.slidingSync.on(SlidingSyncEvent.RoomData, this.onRoomData.bind(this));
		var C = [
			new ExtensionToDevice(this.client, this.syncOpts.cryptoCallbacks),
			new ExtensionAccountData(this.client),
			new ExtensionTyping(this.client),
			new ExtensionReceipts(this.client)
		];
		this.syncOpts.cryptoCallbacks && C.push(new ExtensionE2EE(this.syncOpts.cryptoCallbacks)), C.forEach((e) => {
			this.slidingSync.registerExtension(e);
		});
	}
	onRoomData(e, b) {
		var x = this;
		return _asyncToGenerator(function* () {
			var S = x.client.store.getRoom(e);
			if (!S) {
				if (!b.initial) {
					x.syncOpts.logger.debug("initial flag not set but no stored room exists for room ", e, b);
					return;
				}
				S = _createAndReEmitRoom(x.client, e, x.opts);
			}
			yield x.processRoomData(x.client, S, b);
		})();
	}
	onLifecycle(e, b, x) {
		switch (x && this.syncOpts.logger.debug("onLifecycle", e, x), e) {
			case SlidingSyncState.Complete:
				if (this.purgeNotifications(), !b) break;
				this.lastPos || this.updateSyncState(SyncState.Prepared, {
					oldSyncToken: void 0,
					nextSyncToken: b.pos,
					catchingUp: !1,
					fromCache: !1
				}), this.updateSyncState(SyncState.Syncing, {
					oldSyncToken: this.lastPos,
					nextSyncToken: b.pos,
					catchingUp: !1,
					fromCache: !1
				}), this.lastPos = b.pos;
				break;
			case SlidingSyncState.RequestFinished:
				if (x) {
					if (this.failCount += 1, this.updateSyncState(this.failCount > FAILED_SYNC_ERROR_THRESHOLD ? SyncState.Error : SyncState.Reconnecting, { error: new MatrixError(x) }), this.shouldAbortSync(new MatrixError(x))) return;
				} else this.failCount = 0, this.syncOpts.logger.debug(`SlidingSyncState.RequestFinished with ${Object.keys(b?.rooms || []).length} rooms`);
				break;
		}
	}
	syncLeftRooms() {
		return _asyncToGenerator(function* () {
			return [];
		})();
	}
	peek(e) {
		return _asyncToGenerator(function* () {
			return null;
		})();
	}
	stopPeeking() {}
	setPresence(e) {}
	getSyncState() {
		return this.syncState;
	}
	getSyncStateData() {
		return this.syncStateData ?? null;
	}
	createRoom(e) {
		var { timelineSupport: b } = this.client, x = new Room(e, this.client, this.client.getUserId(), {
			lazyLoadMembers: this.opts.lazyLoadMembers,
			pendingEventOrdering: this.opts.pendingEventOrdering,
			timelineSupport: b
		});
		return this.client.reEmitter.reEmit(x, [
			RoomEvent.Name,
			RoomEvent.Redaction,
			RoomEvent.RedactionCancelled,
			RoomEvent.Receipt,
			RoomEvent.Tags,
			RoomEvent.LocalEchoUpdated,
			RoomEvent.AccountData,
			RoomEvent.MyMembership,
			RoomEvent.Timeline,
			RoomEvent.TimelineReset
		]), this.registerStateListeners(x), x;
	}
	registerStateListeners(e) {
		this.client.reEmitter.reEmit(e.currentState, [
			RoomStateEvent.Events,
			RoomStateEvent.Members,
			RoomStateEvent.NewMember,
			RoomStateEvent.Update
		]), e.currentState.on(RoomStateEvent.NewMember, (e, b, x) => {
			x.user = this.client.getUser(x.userId) ?? void 0, this.client.reEmitter.reEmit(x, [
				RoomMemberEvent.Name,
				RoomMemberEvent.Typing,
				RoomMemberEvent.PowerLevel,
				RoomMemberEvent.Membership
			]);
		});
	}
	shouldAbortSync(e) {
		return e.errcode === "M_UNKNOWN_TOKEN" ? (this.syncOpts.logger.warn("Token no longer valid - assuming logout"), this.stop(), this.updateSyncState(SyncState.Error, { error: e }), !0) : !1;
	}
	processRoomData(e, b, x) {
		var S = this;
		return _asyncToGenerator(function* () {
			x = ensureNameEvent(e, b.roomId, x);
			var C = mapEvents(S.client, b.roomId, x.required_state), w = mapEvents(S.client, b.roomId, x.timeline, !1), T = [];
			if (x.limited || x.initial) {
				var E = /* @__PURE__ */ new Set();
				b.getLiveTimeline().getEvents().forEach((e) => {
					E.add(e.getId());
				});
				for (var D = [], O = [], k = !1, A = w.length - 1; A >= 0; A--) {
					var j = w[A];
					if (E.has(j.getId())) {
						k = !0;
						continue;
					}
					k ? D.push(j) : O.unshift(j);
				}
				w = O, D.length > 0 && b.addEventsToTimeline(D, !0, !1, b.getLiveTimeline(), x.prev_batch);
			}
			var N = b.hasEncryptionStateEvent();
			if (x.notification_count != null && b.setUnreadNotificationCount(NotificationCountType.Total, x.notification_count), x.highlight_count != null && (!N || N && b.getUnreadNotificationCount(NotificationCountType.Highlight) <= 0) && b.setUnreadNotificationCount(NotificationCountType.Highlight, x.highlight_count), x.bump_stamp && b.setBumpStamp(x.bump_stamp), Number.isInteger(x.invited_count) && b.currentState.setInvitedMemberCount(x.invited_count), Number.isInteger(x.joined_count) && b.currentState.setJoinedMemberCount(x.joined_count), x.invite_state) {
				var P = mapEvents(S.client, b.roomId, x.invite_state);
				yield S.injectRoomEvents(b, P), x.initial && (b.recalculate(), S.client.store.storeRoom(b), S.client.emit(ClientEvent.Room, b)), P.forEach((e) => {
					S.client.emit(ClientEvent.Event, e);
				});
				return;
			}
			x.limited && b.getLiveTimeline().setPaginationToken(x.prev_batch ?? null, EventTimeline.BACKWARDS), yield S.injectRoomEvents(b, C, w, x.num_live), b.addEphemeralEvents(T), b.updateMyMembership(KnownMembership.Join), b.setMSC4186SummaryData(x.heroes, x.joined_count, x.invited_count), b.recalculate(), x.initial && (e.store.storeRoom(b), e.emit(ClientEvent.Room, b)), S.addNotifications(w);
			var F = /* @__PURE__ */ function() {
				var x = _asyncToGenerator(function* (x) {
					e.emit(ClientEvent.Event, x), x.isState() && x.getType() == EventType.RoomEncryption && S.syncOpts.cryptoCallbacks && (yield S.syncOpts.cryptoCallbacks.onCryptoEvent(b, x));
				});
				return function(e) {
					return x.apply(this, arguments);
				};
			}();
			yield promiseMapSeries(C, F), yield promiseMapSeries(w, F), T.forEach(function(b) {
				e.emit(ClientEvent.Event, b);
			}), b.decryptCriticalEvents();
		})();
	}
	injectRoomEvents(e, b) {
		var x = arguments, S = this;
		return _asyncToGenerator(function* () {
			var C = x.length > 2 && x[2] !== void 0 ? x[2] : [], w = x.length > 3 && x[3] !== void 0 ? x[3] : 0, T = e.getLiveTimeline(), E = T.getEvents().length == 0;
			if (E) {
				for (var D of b) S.client.getPushActionsForEvent(D);
				T.initialiseState(b);
			}
			E || (e.oldState.setStateEvents(b), e.currentState.setStateEvents(b));
			var O = [];
			w > 0 && (O = C.slice(-1 * w), C = C.slice(0, -1 * O.length)), yield e.addLiveEvents(C, {
				fromCache: !0,
				addToState: !1
			}), O.length > 0 && (yield e.addLiveEvents(O, {
				fromCache: !1,
				addToState: !1
			})), e.recalculate(), S.resolveInvites(e);
		})();
	}
	resolveInvites(e) {
		if (!(!e || !this.opts.resolveInvitesToProfiles)) {
			var b = this.client;
			e.getMembersWithMembership(KnownMembership.Invite).forEach(function(x) {
				if (!x.requestedProfileInfo) {
					x.requestedProfileInfo = !0;
					var S = b.getUser(x.userId);
					(S ? Promise.resolve({
						avatar_url: S.avatarUrl,
						displayname: S.displayName
					}) : b.getProfileInfo(x.userId)).then(function(b) {
						var S = x.events.member;
						S.getContent().membership === KnownMembership.Invite && (S.getContent().avatar_url = b.avatar_url, S.getContent().displayname = b.displayname, x.setMembershipEvent(S, e.currentState));
					}, function(e) {});
				}
			});
		}
	}
	retryImmediately() {
		return !0;
	}
	sync() {
		var e = this;
		return _asyncToGenerator(function* () {
			for (e.syncOpts.logger.debug("Sliding sync init loop"); !e.client.isGuest();) try {
				e.syncOpts.logger.debug("Getting push rules...");
				var b = yield e.client.getPushRules();
				e.syncOpts.logger.debug("Got push rules"), e.client.pushRules = b;
				break;
			} catch (b) {
				if (e.syncOpts.logger.error("Getting push rules failed", b), e.shouldAbortSync(b)) return;
			}
			yield e.slidingSync.start();
		})();
	}
	stop() {
		this.syncOpts.logger.debug("SyncApi.stop"), this.slidingSync.stop();
	}
	updateSyncState(e, b) {
		var x = this.syncState;
		this.syncState = e, this.syncStateData = b, this.client.emit(ClientEvent.Sync, this.syncState, x, b);
	}
	addNotifications(e) {
		if (this.client.getNotifTimelineSet()) for (var b of e) {
			var x = this.client.getPushActionsForEvent(b);
			x && x.notify && x.tweaks && x.tweaks.highlight && this.notifEvents.push(b);
		}
	}
	purgeNotifications() {
		this.notifEvents.sort(function(e, b) {
			return e.getTs() - b.getTs();
		}), this.notifEvents.forEach((e) => {
			var b;
			(b = this.client.getNotifTimelineSet()) == null || b.addLiveEvent(e, { addToState: !1 });
		}), this.notifEvents = [];
	}
};
function ensureNameEvent(e, b, x) {
	if (!x.name) return x;
	for (var S of x.required_state) if (S.type === EventType.RoomName && S.state_key === "") return S.content = { name: x.name }, x;
	return x.required_state.push({
		event_id: "$fake-sliding-sync-name-event-" + b,
		state_key: "",
		type: EventType.RoomName,
		content: { name: x.name },
		sender: e.getUserId(),
		origin_server_ts: (/* @__PURE__ */ new Date()).getTime()
	}), x;
}
function mapEvents(e, b, x) {
	var S = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !0, C = e.getEventMapper({ decrypt: S });
	return x.map(function(e) {
		return e.room_id = b, C(e);
	});
}
function processEphemeralEvents(e, b, x) {
	var S = mapEvents(e, b, x), C = e.getRoom(b);
	if (!C) {
		logger.warn("got ephemeral events for room but room doesn't exist on client:", b);
		return;
	}
	C.addEphemeralEvents(S), S.forEach((b) => {
		e.emit(ClientEvent.Event, b);
	});
}
var M_BEACON_INFO = new UnstableValue("m.beacon_info", "org.matrix.msc3672.beacon_info"), M_BEACON = new UnstableValue("m.beacon", "org.matrix.msc3672.beacon"), DEBUG = !1, MatrixScheduler = class e {
	static RETRY_BACKOFF_RATELIMIT(e, b, x) {
		return calculateRetryBackoff(x, b, !1);
	}
	static QUEUE_MESSAGES(e) {
		return e.getType() === EventType.RoomMessage || e.hasAssociation() ? "message" : null;
	}
	constructor() {
		var b = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : e.RETRY_BACKOFF_RATELIMIT, x = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : e.QUEUE_MESSAGES;
		this.retryAlgorithm = b, this.queueAlgorithm = x, _defineProperty(this, "queues", {}), _defineProperty(this, "activeQueues", []), _defineProperty(this, "procFn", null), _defineProperty(this, "processQueue", (e) => {
			var b = this.peekNextEvent(e);
			if (!b) {
				this.disableQueue(e);
				return;
			}
			debuglog("Queue '%s' has %s pending events", e, this.queues[e].length), Promise.resolve().then(() => this.procFn(b.event)).then((x) => {
				this.removeNextEvent(e), debuglog("Queue '%s' sent event %s", e, b.event.getId()), b.resolvers.resolve(x), this.processQueue(e);
			}, (x) => {
				b.attempts += 1;
				var S = this.retryAlgorithm(b.event, b.attempts, x);
				debuglog("retry(%s) err=%s event_id=%s waitTime=%s", b.attempts, x, b.event.getId(), S), S === -1 ? (logger.info("Queue '%s' giving up on event %s", e, b.event.getId()), this.clearQueue(e, x)) : setTimeout(this.processQueue, S, e);
			});
		});
	}
	getQueueForEvent(e) {
		var b = this.queueAlgorithm(e);
		return !b || !this.queues[b] ? null : this.queues[b].map(function(e) {
			return e.event;
		});
	}
	removeEventFromQueue(e) {
		var b = this.queueAlgorithm(e);
		if (!b || !this.queues[b]) return !1;
		var x = !1;
		return removeElement(this.queues[b], (b) => b.event.getId() === e.getId() ? (x = !0, !0) : !1), x;
	}
	setProcessFunction(e) {
		this.procFn = e, this.startProcessingQueues();
	}
	queueEvent(e) {
		var b = this.queueAlgorithm(e);
		if (!b) return null;
		this.queues[b] || (this.queues[b] = []);
		var x = Promise.withResolvers();
		return this.queues[b].push({
			event: e,
			resolvers: x,
			attempts: 0
		}), debuglog("Queue algorithm dumped event %s into queue '%s'", e.getId(), b), this.startProcessingQueues(), x.promise;
	}
	startProcessingQueues() {
		this.procFn && Object.keys(this.queues).filter((e) => this.activeQueues.indexOf(e) === -1 && this.queues[e].length > 0).forEach((e) => {
			this.activeQueues.push(e), debuglog("Spinning up queue: '%s'", e), this.processQueue(e);
		});
	}
	disableQueue(e) {
		var b = this.activeQueues.indexOf(e);
		b >= 0 && this.activeQueues.splice(b, 1), logger.info("Stopping queue '%s' as it is now empty", e);
	}
	clearQueue(e, b) {
		logger.info("clearing queue '%s'", e);
		for (var x; x = this.removeNextEvent(e);) x.resolvers.reject(b);
		this.disableQueue(e);
	}
	peekNextEvent(e) {
		var b = this.queues[e];
		if (Array.isArray(b)) return b[0];
	}
	removeNextEvent(e) {
		var b = this.queues[e];
		if (Array.isArray(b)) return b.shift();
	}
};
/* istanbul ignore next */
function debuglog() {
	DEBUG && logger.log(...arguments);
}
var MAX_BATCH_SIZE = 20, ToDeviceMessageQueue = class {
	constructor(e, b) {
		var x = this;
		this.client = e, this.logger = b, _defineProperty(this, "sending", !1), _defineProperty(this, "running", !0), _defineProperty(this, "retryTimeout", null), _defineProperty(this, "retryAttempts", 0), _defineProperty(this, "sendQueue", /* @__PURE__ */ _asyncToGenerator(function* () {
			if (x.retryTimeout !== null && clearTimeout(x.retryTimeout), x.retryTimeout = null, !(x.sending || !x.running)) {
				x.logger.debug("Attempting to send queued to-device messages"), x.sending = !0;
				var e;
				try {
					for (; x.running && (e = yield x.client.store.getOldestToDeviceBatch(), e !== null);) yield x.sendBatch(e), yield x.client.store.removeToDeviceBatch(e.id), x.retryAttempts = 0;
					if (!x.running) return;
					x.logger.debug("All queued to-device messages sent");
				} catch (S) {
					++x.retryAttempts;
					var b = MatrixScheduler.RETRY_BACKOFF_RATELIMIT(null, x.retryAttempts, S);
					if (b === -1) {
						Math.floor(S.httpStatus / 100) === 4 ? (x.logger.error("Fatal error when sending to-device message - dropping to-device batch!", S), yield x.client.store.removeToDeviceBatch(e.id)) : x.logger.info("Automatic retry limit reached for to-device messages.");
						return;
					}
					x.logger.info(`Failed to send batch of to-device messages. Will retry in ${b}ms`, S), x.retryTimeout = setTimeout(x.sendQueue, b);
				} finally {
					x.sending = !1;
				}
			}
		})), _defineProperty(this, "onResumedSync", (e, b) => {
			e === SyncState.Syncing && b !== SyncState.Syncing && (this.logger.info("Resuming queue after resumed sync"), this.sendQueue());
		});
	}
	start() {
		this.running = !0, this.sendQueue(), this.client.on(ClientEvent.Sync, this.onResumedSync);
	}
	stop() {
		this.running = !1, this.retryTimeout !== null && clearTimeout(this.retryTimeout), this.retryTimeout = null, this.client.removeListener(ClientEvent.Sync, this.onResumedSync);
	}
	queueBatch(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			for (var x = [], S = 0; S < e.batch.length; S += MAX_BATCH_SIZE) {
				var C = {
					eventType: e.eventType,
					batch: e.batch.slice(S, S + MAX_BATCH_SIZE),
					txnId: b.client.makeTxnId()
				};
				x.push(C);
				var w = C.batch.map((e) => `${e.userId}/${e.deviceId} (msgid ${e.payload[ToDeviceMessageId]})`);
				b.logger.info(`Enqueuing batch of to-device messages. type=${e.eventType} txnid=${C.txnId}`, w);
			}
			yield b.client.store.saveToDeviceBatches(x), b.sendQueue();
		})();
	}
	sendBatch(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			var x = new MapWithDefault(() => /* @__PURE__ */ new Map());
			for (var S of e.batch) x.getOrCreate(S.userId).set(S.deviceId, S.payload);
			b.logger.info(`Sending batch of ${e.batch.length} to-device messages with ID ${e.id} and txnId ${e.txnId}`), yield b.client.sendToDevice(e.eventType, x, e.txnId);
		})();
	}
}, import_lib$1 = /* @__PURE__ */ __toESM(require_lib$1()), POLICIES_ACCOUNT_EVENT_TYPE = new import_lib$1.UnstableValue("m.policies", "org.matrix.msc3847.policies"), IGNORE_INVITES_ACCOUNT_EVENT_KEY = new import_lib$1.UnstableValue("m.ignore.invites", "org.matrix.msc3847.ignore.invites"), PolicyRecommendation = /* @__PURE__ */ function(e) {
	return e.Ban = "m.ban", e;
}({}), PolicyScope = /* @__PURE__ */ function(e) {
	return e.User = "m.policy.user", e.Room = "m.policy.room", e.Server = "m.policy.server", e;
}({}), scopeToEventTypeMap = {
	[PolicyScope.User]: EventType.PolicyRuleUser,
	[PolicyScope.Room]: EventType.PolicyRuleRoom,
	[PolicyScope.Server]: EventType.PolicyRuleServer
}, IgnoredInvites = class {
	constructor(e) {
		this.client = e;
	}
	addRule(e, b, x) {
		var S = this;
		return _asyncToGenerator(function* () {
			var C = yield S.getOrCreateTargetRoom();
			return (yield S.client.sendStateEvent(C.roomId, scopeToEventTypeMap[e], {
				entity: b,
				reason: x,
				recommendation: PolicyRecommendation.Ban
			})).event_id;
		})();
	}
	removeRule(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			yield b.client.redactEvent(e.getRoomId(), e.getId());
		})();
	}
	addSource(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			yield b.client.joinRoom(e);
			var x = (yield b.getOrCreateSourceRooms()).map((e) => e.roomId);
			return x.includes(e) ? !1 : (x.push(e), yield b.withIgnoreInvitesPolicies((e) => {
				e.sources = x;
			}), !0);
		})();
	}
	getRuleForInvite(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			var { sender: x, roomId: S } = e, C = yield b.getOrCreateSourceRooms(), w = x.split(":")[1], T = S.split(":")[1];
			for (var E of C) {
				var D = E.getUnfilteredTimelineSet().getLiveTimeline().getState(EventTimeline.FORWARDS);
				for (var { scope: O, entities: k } of [
					{
						scope: PolicyScope.Room,
						entities: [S]
					},
					{
						scope: PolicyScope.User,
						entities: [x]
					},
					{
						scope: PolicyScope.Server,
						entities: [w, T]
					}
				]) for (var A of D.getStateEvents(scopeToEventTypeMap[O])) {
					var j = A.getContent();
					if (j?.recommendation == PolicyRecommendation.Ban) {
						var M = j?.entity;
						if (M) {
							var N = void 0;
							try {
								N = new RegExp(globToRegexp(M));
							} catch {
								continue;
							}
							for (var P of k) if (P && N.test(P)) return A;
						}
					}
				}
			}
			return null;
		})();
	}
	getOrCreateTargetRoom() {
		var e = this;
		return _asyncToGenerator(function* () {
			var b = e.getIgnoreInvitesPolicies().target;
			if (typeof b != "string" && (b = null), b) {
				var x = e.client.getRoom(b);
				if (x) return x;
				b = null;
			}
			return b = (yield e.client.createRoom({
				name: "Individual Policy Room",
				preset: Preset.PrivateChat
			})).room_id, yield e.withIgnoreInvitesPolicies((e) => {
				e.target = b;
			}), e.client.getRoom(b);
		})();
	}
	getOrCreateSourceRooms() {
		var e = this;
		return _asyncToGenerator(function* () {
			var b = e.getIgnoreInvitesPolicies().sources, x = !1;
			Array.isArray(b) || (x = !0, b = []);
			var S = b.filter((e) => typeof e == "string").map((b) => e.client.getRoom(b)).filter((e) => !!e);
			if (S.length != b.length && (x = !0), S.length == 0) {
				var C = yield e.getOrCreateTargetRoom();
				x = !0, S = [C];
			}
			return x && (yield e.withIgnoreInvitesPolicies((e) => {
				e.sources = b;
			})), S;
		})();
	}
	getIgnoreInvitesPolicies() {
		return this.getPoliciesAndIgnoreInvitesPolicies().ignoreInvitesPolicies;
	}
	withIgnoreInvitesPolicies(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			var { policies: x, ignoreInvitesPolicies: S } = b.getPoliciesAndIgnoreInvitesPolicies();
			e(S), x[IGNORE_INVITES_ACCOUNT_EVENT_KEY.name] = S, yield b.client.setAccountData(POLICIES_ACCOUNT_EVENT_TYPE.name, x);
		})();
	}
	getPoliciesAndIgnoreInvitesPolicies() {
		var e = {};
		for (var b of [POLICIES_ACCOUNT_EVENT_TYPE.name, POLICIES_ACCOUNT_EVENT_TYPE.altName]) if (b) {
			var x = this.client.getAccountData(b)?.getContent();
			if (x) {
				e = x;
				break;
			}
		}
		var S = {}, C = !1;
		for (var w of [IGNORE_INVITES_ACCOUNT_EVENT_KEY.name, IGNORE_INVITES_ACCOUNT_EVENT_KEY.altName]) if (w) {
			var T = e[w];
			if (T && typeof T == "object") {
				S = T, C = !0;
				break;
			}
		}
		return C || (e[IGNORE_INVITES_ACCOUNT_EVENT_KEY.name] = S), {
			policies: e,
			ignoreInvitesPolicies: S
		};
	}
}, RUST_SDK_STORE_PREFIX = "matrix-js-sdk", VerificationRequestEvent = /* @__PURE__ */ function(e) {
	return e.Change = "change", e;
}({}), VerificationPhase = /* @__PURE__ */ function(e) {
	return e[e.Unsent = 1] = "Unsent", e[e.Requested = 2] = "Requested", e[e.Ready = 3] = "Ready", e[e.Started = 4] = "Started", e[e.Cancelled = 5] = "Cancelled", e[e.Done = 6] = "Done", e;
}({}), VerifierEvent = /* @__PURE__ */ function(e) {
	return e.Cancel = "cancel", e.ShowSas = "show_sas", e.ShowReciprocateQr = "show_reciprocate_qr", e;
}({});
function base(e) {
	if (e.length >= 255) throw TypeError("Alphabet too long");
	let b = new Uint8Array(256);
	for (let e = 0; e < b.length; e++) b[e] = 255;
	for (let x = 0; x < e.length; x++) {
		let S = e.charAt(x), C = S.charCodeAt(0);
		if (b[C] !== 255) throw TypeError(S + " is ambiguous");
		b[C] = x;
	}
	let x = e.length, S = e.charAt(0), C = Math.log(x) / Math.log(256), w = Math.log(256) / Math.log(x);
	function T(b) {
		if (b instanceof Uint8Array || (ArrayBuffer.isView(b) ? b = new Uint8Array(b.buffer, b.byteOffset, b.byteLength) : Array.isArray(b) && (b = Uint8Array.from(b))), !(b instanceof Uint8Array)) throw TypeError("Expected Uint8Array");
		if (b.length === 0) return "";
		let C = 0, T = 0, E = 0, D = b.length;
		for (; E !== D && b[E] === 0;) E++, C++;
		let O = (D - E) * w + 1 >>> 0, k = new Uint8Array(O);
		for (; E !== D;) {
			let e = b[E], S = 0;
			for (let b = O - 1; (e !== 0 || S < T) && b !== -1; b--, S++) e += 256 * k[b] >>> 0, k[b] = e % x >>> 0, e = e / x >>> 0;
			if (e !== 0) throw Error("Non-zero carry");
			T = S, E++;
		}
		let A = O - T;
		for (; A !== O && k[A] === 0;) A++;
		let j = S.repeat(C);
		for (; A < O; ++A) j += e.charAt(k[A]);
		return j;
	}
	function E(e) {
		if (typeof e != "string") throw TypeError("Expected String");
		if (e.length === 0) return new Uint8Array();
		let w = 0, T = 0, E = 0;
		for (; e[w] === S;) T++, w++;
		let D = (e.length - w) * C + 1 >>> 0, O = new Uint8Array(D);
		for (; w < e.length;) {
			let S = e.charCodeAt(w);
			if (S > 255) return;
			let C = b[S];
			if (C === 255) return;
			let T = 0;
			for (let e = D - 1; (C !== 0 || T < E) && e !== -1; e--, T++) C += x * O[e] >>> 0, O[e] = C % 256 >>> 0, C = C / 256 >>> 0;
			if (C !== 0) throw Error("Non-zero carry");
			E = T, w++;
		}
		let k = D - E;
		for (; k !== D && O[k] === 0;) k++;
		let A = new Uint8Array(T + (D - k)), j = T;
		for (; k !== D;) A[j++] = O[k++];
		return A;
	}
	function D(e) {
		let b = E(e);
		if (b) return b;
		throw Error("Non-base" + x + " character");
	}
	return {
		encode: T,
		decodeUnsafe: E,
		decode: D
	};
}
var esm_default = base("123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"), OLM_RECOVERY_KEY_PREFIX = [139, 1];
function encodeRecoveryKey(e) {
	var b = new Uint8Array(OLM_RECOVERY_KEY_PREFIX.length + e.length + 1);
	b.set(OLM_RECOVERY_KEY_PREFIX, 0), b.set(e, OLM_RECOVERY_KEY_PREFIX.length);
	for (var x = 0, S = 0; S < b.length - 1; ++S) x ^= b[S];
	return b[b.length - 1] = x, esm_default.encode(b).match(/.{1,4}/g)?.join(" ");
}
var DEFAULT_BIT_SIZE = 256;
function deriveRecoveryKeyFromPassphrase(e, b, x) {
	return _deriveRecoveryKeyFromPassphrase.apply(this, arguments);
}
function _deriveRecoveryKeyFromPassphrase() {
	return _deriveRecoveryKeyFromPassphrase = _asyncToGenerator(function* (e, b, x) {
		var S = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : DEFAULT_BIT_SIZE;
		if (!globalThis.crypto.subtle || !TextEncoder) throw Error("Password-based backup is not available on this platform");
		var C = yield globalThis.crypto.subtle.importKey("raw", new TextEncoder().encode(e), { name: "PBKDF2" }, !1, ["deriveBits"]), w = yield globalThis.crypto.subtle.deriveBits({
			name: "PBKDF2",
			salt: new TextEncoder().encode(b),
			iterations: x,
			hash: "SHA-512"
		}, C, S);
		return new Uint8Array(w);
	}), _deriveRecoveryKeyFromPassphrase.apply(this, arguments);
}
var CryptoEvent = /* @__PURE__ */ function(e) {
	return e.UserTrustStatusChanged = "userTrustStatusChanged", e.KeyBackupStatus = "crypto.keyBackupStatus", e.KeyBackupFailed = "crypto.keyBackupFailed", e.KeyBackupSessionsRemaining = "crypto.keyBackupSessionsRemaining", e.KeyBackupDecryptionKeyCached = "crypto.keyBackupDecryptionKeyCached", e.VerificationRequestReceived = "crypto.verificationRequestReceived", e.WillUpdateDevices = "crypto.willUpdateDevices", e.DevicesUpdated = "crypto.devicesUpdated", e.KeysChanged = "crossSigning.keysChanged", e.LegacyCryptoStoreMigrationProgress = "crypto.legacyCryptoStoreMigrationProgress", e.DehydratedDeviceCreated = "dehydration.DehydratedDeviceCreated", e.DehydratedDeviceUploaded = "dehydration.DehydratedDeviceUploaded", e.RehydrationStarted = "dehydration.RehydrationStarted", e.RehydrationProgress = "dehydration.RehydrationProgress", e.RehydrationCompleted = "dehydration.RehydrationCompleted", e.RehydrationError = "dehydration.RehydrationError", e.DehydrationKeyCached = "dehydration.DehydrationKeyCached", e.DehydratedDeviceRotationError = "dehydration.DehydratedDeviceRotationError", e;
}({}), DecryptionFailureCode = /* @__PURE__ */ function(e) {
	return e.MEGOLM_UNKNOWN_INBOUND_SESSION_ID = "MEGOLM_UNKNOWN_INBOUND_SESSION_ID", e.MEGOLM_KEY_WITHHELD = "MEGOLM_KEY_WITHHELD", e.MEGOLM_KEY_WITHHELD_FOR_UNVERIFIED_DEVICE = "MEGOLM_KEY_WITHHELD_FOR_UNVERIFIED_DEVICE", e.OLM_UNKNOWN_MESSAGE_INDEX = "OLM_UNKNOWN_MESSAGE_INDEX", e.HISTORICAL_MESSAGE_NO_KEY_BACKUP = "HISTORICAL_MESSAGE_NO_KEY_BACKUP", e.HISTORICAL_MESSAGE_BACKUP_UNCONFIGURED = "HISTORICAL_MESSAGE_BACKUP_UNCONFIGURED", e.HISTORICAL_MESSAGE_WORKING_BACKUP = "HISTORICAL_MESSAGE_WORKING_BACKUP", e.HISTORICAL_MESSAGE_USER_NOT_JOINED = "HISTORICAL_MESSAGE_USER_NOT_JOINED", e.SENDER_IDENTITY_PREVIOUSLY_VERIFIED = "SENDER_IDENTITY_PREVIOUSLY_VERIFIED", e.UNSIGNED_SENDER_DEVICE = "UNSIGNED_SENDER_DEVICE", e.UNKNOWN_SENDER_DEVICE = "UNKNOWN_SENDER_DEVICE", e.UNKNOWN_ERROR = "UNKNOWN_ERROR", e;
}({}), DeviceIsolationModeKind = /* @__PURE__ */ function(e) {
	return e[e.AllDevicesIsolationMode = 0] = "AllDevicesIsolationMode", e[e.OnlySignedDevicesIsolationMode = 1] = "OnlySignedDevicesIsolationMode", e;
}({}), AllDevicesIsolationMode = class {
	constructor(e) {
		this.errorOnVerifiedUserProblems = e, _defineProperty(this, "kind", DeviceIsolationModeKind.AllDevicesIsolationMode);
	}
}, UserVerificationStatus = class {
	constructor(e, b, x) {
		var S = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
		this.crossSigningVerified = e, this.crossSigningVerifiedBefore = b, this.tofu = x, _defineProperty(this, "needsUserApproval", void 0), this.needsUserApproval = S;
	}
	isVerified() {
		return this.isCrossSigningVerified();
	}
	isCrossSigningVerified() {
		return this.crossSigningVerified;
	}
	wasCrossSigningVerified() {
		return this.crossSigningVerifiedBefore;
	}
	isTofu() {
		return this.tofu;
	}
}, DeviceVerificationStatus = class {
	constructor(e) {
		_defineProperty(this, "signedByOwner", void 0), _defineProperty(this, "crossSigningVerified", void 0), _defineProperty(this, "tofu", void 0), _defineProperty(this, "localVerified", void 0), _defineProperty(this, "trustCrossSignedDevices", void 0), this.signedByOwner = e.signedByOwner ?? !1, this.crossSigningVerified = e.crossSigningVerified ?? !1, this.tofu = e.tofu ?? !1, this.localVerified = e.localVerified ?? !1, this.trustCrossSignedDevices = e.trustCrossSignedDevices ?? !1;
	}
	isVerified() {
		return this.localVerified || this.trustCrossSignedDevices && this.crossSigningVerified;
	}
}, ImportRoomKeyStage = /* @__PURE__ */ function(e) {
	return e.Fetch = "fetch", e.LoadKeys = "load_keys", e;
}({}), CrossSigningKey = /* @__PURE__ */ function(e) {
	return e.Master = "master", e.SelfSigning = "self_signing", e.UserSigning = "user_signing", e;
}({}), EventShieldColour = /* @__PURE__ */ function(e) {
	return e[e.NONE = 0] = "NONE", e[e.GREY = 1] = "GREY", e[e.RED = 2] = "RED", e;
}({}), EventShieldReason = /* @__PURE__ */ function(e) {
	return e[e.UNKNOWN = 0] = "UNKNOWN", e[e.UNVERIFIED_IDENTITY = 1] = "UNVERIFIED_IDENTITY", e[e.UNSIGNED_DEVICE = 2] = "UNSIGNED_DEVICE", e[e.UNKNOWN_DEVICE = 3] = "UNKNOWN_DEVICE", e[e.AUTHENTICITY_NOT_GUARANTEED = 4] = "AUTHENTICITY_NOT_GUARANTEED", e[e.MISMATCHED_SENDER_KEY = 5] = "MISMATCHED_SENDER_KEY", e[e.SENT_IN_CLEAR = 6] = "SENT_IN_CLEAR", e[e.VERIFICATION_VIOLATION = 7] = "VERIFICATION_VIOLATION", e[e.MISMATCHED_SENDER = 8] = "MISMATCHED_SENDER", e;
}({}), zeroSalt = new Uint8Array(8);
function deriveKeys(e, b) {
	return _deriveKeys.apply(this, arguments);
}
function _deriveKeys() {
	return _deriveKeys = _asyncToGenerator(function* (e, b) {
		var x = yield globalThis.crypto.subtle.importKey("raw", e, { name: "HKDF" }, !1, ["deriveBits"]), S = yield globalThis.crypto.subtle.deriveBits({
			name: "HKDF",
			salt: zeroSalt,
			info: new TextEncoder().encode(b),
			hash: "SHA-256"
		}, x, 512), C = S.slice(0, 32), w = S.slice(32), T = globalThis.crypto.subtle.importKey("raw", C, { name: "AES-CTR" }, !1, ["encrypt", "decrypt"]), E = globalThis.crypto.subtle.importKey("raw", w, {
			name: "HMAC",
			hash: { name: "SHA-256" }
		}, !1, ["sign", "verify"]);
		return Promise.all([T, E]);
	}), _deriveKeys.apply(this, arguments);
}
function encryptAESSecretStorageItem(e, b, x, S) {
	return _encryptAESSecretStorageItem.apply(this, arguments);
}
function _encryptAESSecretStorageItem() {
	return _encryptAESSecretStorageItem = _asyncToGenerator(function* (e, b, x, S) {
		var C;
		S ? C = decodeBase64(S) : (C = new Uint8Array(16), globalThis.crypto.getRandomValues(C), C[8] &= 127);
		var [w, T] = yield deriveKeys(b, x), E = new TextEncoder().encode(e), D = yield globalThis.crypto.subtle.encrypt({
			name: "AES-CTR",
			counter: C,
			length: 64
		}, w, E), O = yield globalThis.crypto.subtle.sign({ name: "HMAC" }, T, D);
		return {
			iv: encodeBase64(C),
			ciphertext: encodeBase64(new Uint8Array(D)),
			mac: encodeBase64(new Uint8Array(O))
		};
	}), _encryptAESSecretStorageItem.apply(this, arguments);
}
function decryptAESSecretStorageItem(e, b, x) {
	return _decryptAESSecretStorageItem.apply(this, arguments);
}
function _decryptAESSecretStorageItem() {
	return _decryptAESSecretStorageItem = _asyncToGenerator(function* (e, b, x) {
		var [S, C] = yield deriveKeys(b, x), w = decodeBase64(e.ciphertext);
		if (!(yield globalThis.crypto.subtle.verify({ name: "HMAC" }, C, decodeBase64(e.mac), w))) throw Error(`Error decrypting secret ${x}: bad MAC`);
		var T = yield globalThis.crypto.subtle.decrypt({
			name: "AES-CTR",
			counter: decodeBase64(e.iv),
			length: 64
		}, S, w);
		return new TextDecoder().decode(new Uint8Array(T));
	}), _decryptAESSecretStorageItem.apply(this, arguments);
}
var secret_storage_exports = /* @__PURE__ */ __export({
	SECRET_STORAGE_ALGORITHM_V1_AES: () => SECRET_STORAGE_ALGORITHM_V1_AES,
	ServerSideSecretStorageImpl: () => ServerSideSecretStorageImpl,
	calculateKeyCheck: () => calculateKeyCheck,
	trimTrailingEquals: () => trimTrailingEquals
}), SECRET_STORAGE_ALGORITHM_V1_AES = "m.secret_storage.v1.aes-hmac-sha2", ServerSideSecretStorageImpl = class {
	constructor(e, b) {
		this.accountDataAdapter = e, this.callbacks = b;
	}
	getDefaultKeyId() {
		var e = this;
		return _asyncToGenerator(function* () {
			var b = yield e.accountDataAdapter.getAccountDataFromServer("m.secret_storage.default_key");
			return b ? b.key ?? null : null;
		})();
	}
	setDefaultKeyId(e) {
		return new Promise((b, x) => {
			var S = (x) => {
				if (x.getType() === "m.secret_storage.default_key") {
					var C = x.getContent();
					(e === null ? Object.keys(C).length === 0 : C.key === e) && (this.accountDataAdapter.removeListener(ClientEvent.AccountData, S), b());
				}
			};
			this.accountDataAdapter.on(ClientEvent.AccountData, S);
			var C = e === null ? {} : { key: e };
			this.accountDataAdapter.setAccountData("m.secret_storage.default_key", C).catch((e) => {
				this.accountDataAdapter.removeListener(ClientEvent.AccountData, S), x(e);
			});
		});
	}
	addKey(e, b, x) {
		var S = this;
		return _asyncToGenerator(function* () {
			if (e !== "m.secret_storage.v1.aes-hmac-sha2") throw Error(`Unknown key algorithm ${e}`);
			var C = { algorithm: e };
			b.name && (C.name = b.name), b.passphrase && (C.passphrase = b.passphrase);
			var { iv: w, mac: T } = yield calculateKeyCheck(b.key);
			if (C.iv = w, C.mac = T, !x) do
				x = secureRandomString(32);
			while (yield S.accountDataAdapter.getAccountDataFromServer(`m.secret_storage.key.${x}`));
			return yield S.accountDataAdapter.setAccountData(`m.secret_storage.key.${x}`, C), {
				keyId: x,
				keyInfo: C
			};
		})();
	}
	getKey(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			if (e ||= yield b.getDefaultKeyId(), !e) return null;
			var x = yield b.accountDataAdapter.getAccountDataFromServer(`m.secret_storage.key.${e}`);
			return x ? [e, x] : null;
		})();
	}
	hasKey(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			return !!(yield b.getKey(e));
		})();
	}
	checkKey(e, b) {
		return _asyncToGenerator(function* () {
			if (b.algorithm === "m.secret_storage.v1.aes-hmac-sha2") if (b.mac) {
				var { mac: x } = yield calculateKeyCheck(e, b.iv);
				return trimTrailingEquals(b.mac) === trimTrailingEquals(x);
			} else return !0;
			else throw Error("Unknown algorithm");
		})();
	}
	store(e, b, x) {
		var S = this;
		return _asyncToGenerator(function* () {
			if (b === null) {
				yield S.accountDataAdapter.setAccountData(e, {});
				return;
			}
			var C = {};
			if (!x) {
				var w = yield S.getDefaultKeyId();
				if (!w) throw Error("No keys specified and no default key present");
				x = [w];
			}
			if (x.length === 0) throw Error("Zero keys given to encrypt with!");
			for (var T of x) {
				var E = yield S.accountDataAdapter.getAccountDataFromServer(`m.secret_storage.key.${T}`);
				if (!E) throw Error("Unknown key: " + T);
				if (E.algorithm === "m.secret_storage.v1.aes-hmac-sha2") {
					var D = { [T]: E }, [, O] = yield S.getSecretStorageKey(D, e);
					C[T] = yield O.encrypt(b);
				} else logger.warn("unknown algorithm for secret storage key " + T + ": " + E.algorithm);
			}
			yield S.accountDataAdapter.setAccountData(e, { encrypted: C });
		})();
	}
	get(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			var x = yield b.accountDataAdapter.getAccountDataFromServer(e);
			if (x) {
				if (!x.encrypted) throw Error("Content is not encrypted!");
				var S = {};
				for (var C of Object.keys(x.encrypted)) {
					var w = yield b.accountDataAdapter.getAccountDataFromServer(`m.secret_storage.key.${C}`), T = x.encrypted[C];
					w?.algorithm === "m.secret_storage.v1.aes-hmac-sha2" && T.iv && T.ciphertext && T.mac && (S[C] = w);
				}
				if (Object.keys(S).length === 0) throw Error(`Could not decrypt ${e} because none of the keys it is encrypted with are for a supported algorithm`);
				var [E, D] = yield b.getSecretStorageKey(S, e), O = x.encrypted[E];
				return D.decrypt(O);
			}
		})();
	}
	isStored(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			var x = yield b.accountDataAdapter.getAccountDataFromServer(e);
			if (!(x != null && x.encrypted)) return null;
			var S = {};
			for (var C of Object.keys(x.encrypted)) {
				var w = yield b.accountDataAdapter.getAccountDataFromServer(`m.secret_storage.key.${C}`);
				if (w) {
					var T = x.encrypted[C];
					w.algorithm === "m.secret_storage.v1.aes-hmac-sha2" && T.iv && T.ciphertext && T.mac && (S[C] = w);
				}
			}
			return Object.keys(S).length ? S : null;
		})();
	}
	getSecretStorageKey(e, b) {
		var x = this;
		return _asyncToGenerator(function* () {
			if (!x.callbacks.getSecretStorageKey) throw Error("No getSecretStorageKey callback supplied");
			var S = yield x.callbacks.getSecretStorageKey({ keys: e }, b);
			if (!S) throw Error("getSecretStorageKey callback returned falsey");
			if (S.length < 2) throw Error("getSecretStorageKey callback returned invalid data");
			var [C, w] = S;
			if (!e[C]) throw Error("App returned unknown key from getSecretStorageKey!");
			if (e[C].algorithm === "m.secret_storage.v1.aes-hmac-sha2") return [C, {
				encrypt: function(e) {
					return encryptAESSecretStorageItem(e, w, b);
				},
				decrypt: function(e) {
					return decryptAESSecretStorageItem(e, w, b);
				}
			}];
			throw Error("Unknown key type: " + e[C].algorithm);
		})();
	}
};
function trimTrailingEquals(e) {
	for (var b = e.length; b >= 1 && e.charCodeAt(b - 1) == 61;) b--;
	return b < e.length ? e.substring(0, b) : e;
}
var ZERO_STR = "\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0";
function calculateKeyCheck(e, b) {
	return encryptAESSecretStorageItem(ZERO_STR, e, "", b);
}
var DEFAULT_EXPIRE_DURATION = 1e3 * 60 * 60 * 4, checkRtcMembershipData = (e, b, x) => {
	var S = " - ";
	if (typeof e.slot_id == "string" ? e.slot_id.split("#").length !== 2 && b.push(S + "slot_id must include exactly one \"#\"") : b.push(S + "slot_id must be string"), typeof e.member != "object" || e.member === null ? b.push(S + "member must be an object") : (typeof e.member.user_id == "string" ? MXID_PATTERN.test(e.member.user_id) ? e.member.user_id !== x && b.push(S + "member.user_id must match the sender") : b.push(S + "member.user_id must be a valid mxid") : b.push(S + "member.user_id must be string"), typeof e.member.device_id != "string" && b.push(S + "member.device_id must be string"), typeof e.member.id != "string" && b.push(S + "member.id must be string")), typeof e.application != "object" || e.application === null ? b.push(S + "application must be an object") : typeof e.application.type == "string" ? e.application.type.includes("#") && b.push(S + "application.type must not include \"#\"") : b.push(S + "application.type must be a string"), e.rtc_transports === void 0 || !Array.isArray(e.rtc_transports)) b.push(S + "rtc_transports must be an array");
	else for (var C of e.rtc_transports) if (typeof C != "object" || !C || typeof C.type != "string") {
		b.push(S + "rtc_transports entries must be objects with a string type");
		break;
	}
	if (e.versions === void 0 || !Array.isArray(e.versions) ? b.push(S + "versions must be an array") : e.versions.every((e) => typeof e == "string") || b.push(S + "versions must be an array of strings"), (e.sticky_key ?? e.msc4354_sticky_key) === void 0 && b.push(S + "sticky_key or msc4354_sticky_key must be a defined"), e.sticky_key !== void 0 && typeof e.sticky_key != "string" && b.push(S + "sticky_key must be a string"), e.msc4354_sticky_key !== void 0 && typeof e.msc4354_sticky_key != "string" && b.push(S + "msc4354_sticky_key must be a string"), e.sticky_key !== void 0 && e.msc4354_sticky_key !== void 0 && e.sticky_key !== e.msc4354_sticky_key && b.push(S + "sticky_key and msc4354_sticky_key must be equal if both are defined"), e["m.relates_to"] !== void 0) {
		var w = e["m.relates_to"];
		typeof w != "object" || !w ? b.push(S + "m.relates_to must be an object if provided") : (typeof w.event_id != "string" && b.push(S + "m.relates_to.event_id must be a string"), w.rel_type !== "m.reference" && b.push(S + "m.relates_to.rel_type must be m.reference"));
	}
	return b.length === 0;
}, checkSessionsMembershipData = (e, b) => {
	var x = " - ";
	return typeof e.device_id != "string" && b.push(x + "device_id must be string"), typeof e.call_id != "string" && b.push(x + "call_id must be string"), typeof e.application != "string" && b.push(x + "application must be a string"), typeof e.focus_active?.type != "string" && b.push(x + "focus_active.type must be a string"), e.focus_active === void 0 && b.push(x + "focus_active has an invalid type"), e.foci_preferred !== void 0 && !(Array.isArray(e.foci_preferred) && e.foci_preferred.every((e) => typeof e == "object" && !!e && typeof e.type == "string")) && b.push(x + "foci_preferred must be an array of transport objects"), e.created_ts !== void 0 && typeof e.created_ts != "number" && b.push(x + "created_ts must be number"), e.scope !== void 0 && typeof e.scope != "string" && b.push(x + "scope must be string"), e["m.call.intent"] !== void 0 && typeof e["m.call.intent"] != "string" && b.push(x + "m.call.intent must be a string"), b.length === 0;
}, CallMembership = class e {
	static equal(e, b) {
		return deepCompare(e?.membershipData, b?.membershipData);
	}
	constructor(e, b) {
		this.matrixEvent = e, _defineProperty(this, "membershipData", void 0), _defineProperty(this, "matrixEventData", void 0);
		var x = e.getId(), S = e.getSender();
		if (x === void 0) throw Error("parentEvent is missing eventId field");
		if (S === void 0) throw Error("parentEvent is missing sender field");
		var C = [], w = [];
		if (checkSessionsMembershipData(b, C)) this.membershipData = {
			kind: "session",
			data: b
		};
		else if (checkRtcMembershipData(b, w, S)) this.membershipData = {
			kind: "rtc",
			data: b
		};
		else {
			var T = C.length < w.length ? `Does not match MSC4143 m.call.member:
${C.join("\n")}

` : `Does not match MSC4143 m.rtc.member:
${w.join("\n")}

`, E = "\nevent:\n" + JSON.stringify(b).replaceAll("\"", "'");
			throw Error("unknown CallMembership data.\n" + T + E);
		}
		this.matrixEventData = {
			eventId: x,
			sender: S
		};
	}
	get sender() {
		return this.userId;
	}
	get userId() {
		var { kind: e, data: b } = this.membershipData;
		switch (e) {
			case "rtc": return b.member.user_id;
			case "session":
			default: return this.matrixEventData.sender;
		}
	}
	get eventId() {
		return this.matrixEventData.eventId;
	}
	get slotId() {
		var { kind: e, data: b } = this.membershipData;
		switch (e) {
			case "rtc": return b.slot_id;
			case "session":
			default: return slotDescriptionToId({
				application: this.application,
				id: b.call_id
			});
		}
	}
	get deviceId() {
		var { kind: e, data: b } = this.membershipData;
		switch (e) {
			case "rtc": return b.member.device_id;
			case "session":
			default: return b.device_id;
		}
	}
	get callIntent() {
		var { kind: e, data: b } = this.membershipData;
		switch (e) {
			case "rtc":
				var x = b.application["m.call.intent"];
				if (typeof x == "string") return x;
				logger.warn("RTC membership has invalid m.call.intent");
				return;
			case "session":
			default: return b["m.call.intent"];
		}
	}
	get slotDescription() {
		return slotIdToDescription(this.slotId);
	}
	get application() {
		var { kind: e, data: b } = this.membershipData;
		switch (e) {
			case "rtc": return b.application.type;
			case "session":
			default: return b.application;
		}
	}
	get applicationData() {
		var { kind: e, data: b } = this.membershipData;
		switch (e) {
			case "rtc": return b.application;
			case "session":
			default: return {
				type: b.application,
				"m.call.intent": b["m.call.intent"]
			};
		}
	}
	get scope() {
		var { kind: e, data: b } = this.membershipData;
		switch (e) {
			case "rtc": return;
			case "session":
			default: return b.scope;
		}
	}
	get membershipID() {
		var { kind: e, data: b } = this.membershipData;
		switch (e) {
			case "rtc": return b.member.id;
			case "session":
			default: return (this.createdTs() ?? "").toString();
		}
	}
	createdTs() {
		var { kind: e, data: b } = this.membershipData;
		switch (e) {
			case "rtc": return this.matrixEvent.getTs();
			case "session":
			default: return b.created_ts ?? this.matrixEvent.getTs();
		}
	}
	getAbsoluteExpiry() {
		var { kind: e, data: b } = this.membershipData;
		switch (e) {
			case "rtc": return;
			case "session":
			default: return this.createdTs() + (b.expires ?? DEFAULT_EXPIRE_DURATION);
		}
	}
	getMsUntilExpiry() {
		var { kind: e } = this.membershipData;
		switch (e) {
			case "rtc": return;
			case "session":
			default: return this.getAbsoluteExpiry() - Date.now();
		}
	}
	isExpired() {
		var { kind: e } = this.membershipData;
		switch (e) {
			case "rtc": return !1;
			case "session":
			default: return this.getMsUntilExpiry() <= 0;
		}
	}
	getTransport(b) {
		var { kind: x, data: S } = this.membershipData;
		switch (x) {
			case "rtc": return S.rtc_transports[0];
			case "session": switch (S.focus_active.focus_selection) {
				case "multi_sfu": return S.foci_preferred[0];
				case "oldest_membership":
					if (e.equal(this, b)) return S.foci_preferred[0];
					if (b !== void 0) return b.getTransport(b);
					break;
			}
		}
	}
	getFocusActive() {
		var { kind: e, data: b } = this.membershipData;
		if (e === "session") return b.focus_active;
	}
	get transports() {
		var { kind: e, data: b } = this.membershipData;
		switch (e) {
			case "rtc": return b.rtc_transports;
			case "session":
			default: return b.foci_preferred;
		}
	}
}, Status = /* @__PURE__ */ function(e) {
	return e.Disconnected = "Disconnected", e.Connecting = "Connecting", e.ConnectingFailed = "ConnectingFailed", e.Connected = "Connected", e.Reconnecting = "Reconnecting", e.Disconnecting = "Disconnecting", e.Stuck = "Stuck", e.Unknown = "Unknown", e;
}({}), isMyMembership = (e, b, x) => e.sender === b && e.deviceId === x, ActionScheduler = class {
	constructor(e, b) {
		this.membershipLoopHandler = e, _defineProperty(this, "logger", void 0), _defineProperty(this, "running", !1), _defineProperty(this, "wakeup", (e) => {
			this.logger.error("Cannot call wakeup before calling `startWithJoin()`");
		}), _defineProperty(this, "_actions", []), this.logger = (b ?? logger).getChild("[NewMembershipActionScheduler]");
	}
	get actions() {
		return this._actions;
	}
	startWithJoin() {
		var e = this;
		return _asyncToGenerator(function* () {
			if (e.running) {
				e.logger.error("Cannot call startWithJoin() on NewMembershipActionScheduler while already running");
				return;
			}
			e.running = !0, e._actions = [{
				ts: Date.now(),
				type: MembershipActionType.SendDelayedEvent
			}];
			try {
				for (var b = function* () {
					e._actions.sort((e, b) => e.ts - b.ts);
					var b = e._actions[0], x = void 0, S = new Promise((b) => {
						e.wakeup = (e) => {
							x = e, b();
						};
					});
					b.ts > Date.now() && (yield Promise.race([S, sleep(b.ts - Date.now())]));
					var C = {};
					if (!x) {
						e.logger.debug(`Current MembershipManager processing: ${b.type}
Queue:`, e._actions, `
Date.now: "${Date.now()}`);
						try {
							C = yield e.membershipLoopHandler(b.type);
						} catch (e) {
							throw Error(`The MembershipManager shut down because of the end condition: ${e}`);
						}
					}
					e._actions.splice(0, 1);
					var w = x ?? C;
					"replace" in w ? e._actions = w.replace : "insert" in w && e._actions.push(...w.insert);
				}; e._actions.length > 0;) yield* b();
			} finally {
				e.running = !1;
			}
			e.logger.debug("Leave MembershipManager ActionScheduler loop (no more actions)");
		})();
	}
	initiateJoin() {
		var e;
		(e = this.wakeup) == null || e.call(this, { replace: [{
			ts: Date.now(),
			type: MembershipActionType.SendDelayedEvent
		}] });
	}
	initiateLeave() {
		var e;
		(e = this.wakeup) == null || e.call(this, { replace: [{
			ts: Date.now(),
			type: MembershipActionType.SendScheduledDelayedLeaveEvent
		}] });
	}
}, InvalidCryptoStoreState = /* @__PURE__ */ function(e) {
	return e.TooNew = "TOO_NEW", e;
}({}), InvalidCryptoStoreError = class extends Error {
	constructor(e) {
		var b = `Crypto store is invalid because ${e}, please stop the client, delete all data and start the client again`;
		super(b), this.reason = e, this.name = "InvalidCryptoStoreError";
	}
};
_defineProperty(InvalidCryptoStoreError, "TOO_NEW", InvalidCryptoStoreState.TooNew);
var KeySignatureUploadError = class extends Error {
	constructor(e, b) {
		super(e), this.value = b;
	}
}, ClientStoppedError = class extends Error {
	constructor() {
		super("MatrixClient has been stopped");
	}
}, UnsupportedDelayedEventsEndpointError = class extends Error {
	constructor(e, b) {
		super(e), this.clientEndpoint = b, this.name = "UnsupportedDelayedEventsEndpointError";
	}
}, UnsupportedStickyEventsEndpointError = class extends Error {
	constructor(e, b) {
		super(e), this.clientEndpoint = b, this.name = "UnsupportedStickyEventsEndpointError";
	}
}, MembershipManagerEvent = /* @__PURE__ */ function(e) {
	return e.StatusChanged = "StatusChanged", e.ProbablyLeft = "ProbablyLeft", e;
}({});
function ownKeys$5(e, b) {
	var x = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var S = Object.getOwnPropertySymbols(e);
		b && (S = S.filter(function(b) {
			return Object.getOwnPropertyDescriptor(e, b).enumerable;
		})), x.push.apply(x, S);
	}
	return x;
}
function _objectSpread$5(e) {
	for (var b = 1; b < arguments.length; b++) {
		var x = arguments[b] == null ? {} : arguments[b];
		b % 2 ? ownKeys$5(Object(x), !0).forEach(function(b) {
			_defineProperty(e, b, x[b]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(x)) : ownKeys$5(Object(x)).forEach(function(b) {
			Object.defineProperty(e, b, Object.getOwnPropertyDescriptor(x, b));
		});
	}
	return e;
}
var MEMBERSHIP_STICKY_DURATION_MS = 3600 * 1e3, MembershipActionType = /* @__PURE__ */ function(e) {
	return e.SendDelayedEvent = "SendDelayedEvent", e.SendJoinEvent = "SendJoinEvent", e.RestartDelayedEvent = "RestartDelayedEvent", e.UpdateExpiry = "UpdateExpiry", e.SendScheduledDelayedLeaveEvent = "SendScheduledDelayedLeaveEvent", e.SendLeaveEvent = "SendLeaveEvent", e;
}({});
function createInsertActionUpdate(e, b) {
	return { insert: [{
		ts: Date.now() + (b ?? 0),
		type: e
	}] };
}
function createReplaceActionUpdate(e, b) {
	return { replace: [{
		ts: Date.now() + (b ?? 0),
		type: e
	}] };
}
var MembershipManager = class e extends TypedEventEmitter {
	isActivated() {
		return this.activated;
	}
	isJoined() {
		return this.isActivated();
	}
	join(b, x, S) {
		if (this.scheduler.running) {
			this.logger.error("MembershipManager is already running. Ignoring join request.");
			return;
		}
		this.fociPreferred = b, this.rtcTransport = x, this.leavePromiseResolvers = void 0, this.activated = !0, this.oldStatus = this.status, this.state = e.defaultState, this.scheduler.startWithJoin().catch((e) => {
			this.logger.error("MembershipManager stopped because: ", e), S?.(e);
		}).finally(() => {
			if (this.activated = !1, this.oldStatus && this.oldStatus !== this.status && this.emit(MembershipManagerEvent.StatusChanged, this.oldStatus, this.status), !this.scheduler.running) {
				var e;
				(e = this.leavePromiseResolvers) == null || e.resolve(!0), this.leavePromiseResolvers = void 0;
			}
		});
	}
	leave(e) {
		return this.scheduler.running ? (this.leavePromiseResolvers || (this.leavePromiseResolvers = Promise.withResolvers(), this.activated = !1, this.scheduler.initiateLeave(), e && setTimeout(() => this.leavePromiseResolvers?.resolve(!1), e)), this.leavePromiseResolvers.promise) : (this.logger.warn("Called MembershipManager.leave() even though the MembershipManager is not running"), Promise.resolve(!0));
	}
	onRTCSessionMemberUpdate(e) {
		if (!this.isActivated()) return Promise.resolve();
		var b = this.client.getUserId(), x = this.client.getDeviceId();
		if (!b || !x) return this.logger.error("MembershipManager.onRTCSessionMemberUpdate called without user or device id"), Promise.resolve();
		if (this._ownMembership = e.find((e) => isMyMembership(e, b, x)), !this._ownMembership) {
			var S = [MembershipActionType.SendDelayedEvent, MembershipActionType.SendJoinEvent];
			this.logger.warn("Missing own membership: force re-join"), this.state.hasMemberStateEvent = !1, this.scheduler.actions.some((e) => S.includes(e.type)) ? this.logger.error("tried adding another `SendDelayedEvent` actions even though we already have one in the Queue\nActionQueueOnMemberUpdate:", this.scheduler.actions) : this.scheduler.initiateJoin();
		}
		return Promise.resolve();
	}
	updateCallIntent(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			if (!b.activated || !b.ownMembership) throw Error("You cannot update your intent before joining the call");
			b.ownMembership.callIntent !== e && (b.callIntent = e, yield b.sendJoinEvent());
		})();
	}
	constructor(b, x, S, C, w) {
		super(), this.joinConfig = b, this.room = x, this.client = S, this.slotDescription = C, _defineProperty(this, "activated", !1), _defineProperty(this, "logger", void 0), _defineProperty(this, "callIntent", void 0), _defineProperty(this, "leavePromiseResolvers", void 0), _defineProperty(this, "_ownMembership", void 0), _defineProperty(this, "oldStatus", void 0), _defineProperty(this, "scheduler", void 0), _defineProperty(this, "state", void 0), _defineProperty(this, "deviceId", void 0), _defineProperty(this, "memberId", void 0), _defineProperty(this, "rtcTransport", void 0), _defineProperty(this, "fociPreferred", void 0), _defineProperty(this, "delayedLeaveEventDelayMsOverride", void 0), _defineProperty(this, "clientSendDelayedDisconnectMembership", () => this.client._unstable_sendDelayedStateEvent(this.room.roomId, { delay: this.delayedLeaveEventDelayMs }, EventType.GroupCallMemberPrefix, {}, this.memberId)), _defineProperty(this, "clientSendMembership", (e) => this.client.sendStateEvent(this.room.roomId, EventType.GroupCallMemberPrefix, e, this.memberId)), this.logger = (w ?? logger).getChild("[MembershipManager]");
		var [T, E] = [this.client.getUserId(), this.client.getDeviceId()];
		if (T === null) throw Error("Missing userId in client");
		if (E === null) throw Error("Missing deviceId in client");
		this.deviceId = E, this.memberId = this.makeMembershipStateKey(T, E), this.state = e.defaultState, this.callIntent = b?.callIntent, this.scheduler = new ActionScheduler((e) => (this.oldStatus && (this.logger.debug(`MembershipManager applied action changes. Status: ${this.oldStatus} -> ${this.status}`), this.oldStatus !== this.status && this.emit(MembershipManagerEvent.StatusChanged, this.oldStatus, this.status)), this.oldStatus = this.status, this.logger.debug(`MembershipManager before processing action. status=${this.oldStatus}`), this.membershipLoopHandler(e)), this.logger);
	}
	get ownMembership() {
		return this._ownMembership;
	}
	static get defaultState() {
		return {
			hasMemberStateEvent: !1,
			delayId: void 0,
			startTime: 0,
			rateLimitRetries: /* @__PURE__ */ new Map(),
			networkErrorRetries: /* @__PURE__ */ new Map(),
			expireUpdateIterations: 1,
			probablyLeft: !1
		};
	}
	get networkErrorRetryMs() {
		return this.joinConfig?.networkErrorRetryMs ?? 3e3;
	}
	get membershipEventExpiryMs() {
		return this.joinConfig?.membershipEventExpiryMs ?? DEFAULT_EXPIRE_DURATION;
	}
	get membershipEventExpiryHeadroomMs() {
		return this.joinConfig?.membershipEventExpiryHeadroomMs ?? 5e3;
	}
	computeNextExpiryActionTs(e) {
		return this.state.startTime + Math.min(this.membershipEventExpiryMs, MEMBERSHIP_STICKY_DURATION_MS) * e - this.membershipEventExpiryHeadroomMs;
	}
	get delayedLeaveEventDelayMs() {
		return this.delayedLeaveEventDelayMsOverride ?? this.joinConfig?.delayedLeaveEventDelayMs ?? 8e3;
	}
	get delayedLeaveEventRestartMs() {
		return this.joinConfig?.delayedLeaveEventRestartMs ?? 5e3;
	}
	get maximumRateLimitRetryCount() {
		return this.joinConfig?.maximumRateLimitRetryCount ?? 10;
	}
	get maximumNetworkErrorRetryCount() {
		return this.joinConfig?.maximumNetworkErrorRetryCount ?? 10;
	}
	get delayedLeaveEventRestartLocalTimeoutMs() {
		return this.joinConfig?.delayedLeaveEventRestartLocalTimeoutMs ?? 2e3;
	}
	membershipLoopHandler(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			switch (e) {
				case MembershipActionType.SendDelayedEvent: return b.state.delayId ? b.cancelKnownDelayIdBeforeSendDelayedEvent(b.state.delayId) : b.sendOrResendDelayedLeaveEvent();
				case MembershipActionType.RestartDelayedEvent: return b.state.delayId ? b.restartDelayedEvent(b.state.delayId) : createInsertActionUpdate(MembershipActionType.SendDelayedEvent);
				case MembershipActionType.SendScheduledDelayedLeaveEvent: return b.state.hasMemberStateEvent ? b.state.delayId ? b.sendScheduledDelayedLeaveEventOrFallbackToSendLeaveEvent(b.state.delayId) : createInsertActionUpdate(MembershipActionType.SendLeaveEvent) : { replace: [] };
				case MembershipActionType.SendJoinEvent: return b.sendJoinEvent();
				case MembershipActionType.UpdateExpiry: return b.updateExpiryOnJoinedEvent();
				case MembershipActionType.SendLeaveEvent: return b.state.hasMemberStateEvent ? b.sendFallbackLeaveEvent() : { replace: [] };
			}
		})();
	}
	sendOrResendDelayedLeaveEvent() {
		var e = this;
		return _asyncToGenerator(function* () {
			return yield e.clientSendDelayedDisconnectMembership().then((b) => (e.state.expectedServerDelayLeaveTs = Date.now() + e.delayedLeaveEventDelayMs, e.setAndEmitProbablyLeft(!1), e.resetRateLimitCounter(MembershipActionType.SendDelayedEvent), e.state.delayId = b.delay_id, e.state.hasMemberStateEvent ? createInsertActionUpdate(MembershipActionType.RestartDelayedEvent, e.delayedLeaveEventRestartMs) : createInsertActionUpdate(MembershipActionType.SendJoinEvent))).catch((b) => {
				var x = MembershipActionType.SendDelayedEvent;
				if (e.manageMaxDelayExceededSituation(b)) return createInsertActionUpdate(x);
				var S = e.actionUpdateFromErrors(b, x, "_unstable_sendDelayedStateEvent");
				if (S) return S;
				if (e.state.hasMemberStateEvent) {
					if (e.isUnsupportedDelayedEndpoint(b)) return {};
					throw Error("Could not send delayed event, even though delayed events are supported. " + b);
				} else return e.isUnsupportedDelayedEndpoint(b) ? e.logger.info("Not using delayed event because the endpoint is not supported") : e.logger.info("Not using delayed event because: " + b), createInsertActionUpdate(MembershipActionType.SendJoinEvent);
			});
		})();
	}
	cancelKnownDelayIdBeforeSendDelayedEvent(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			return yield b.client._unstable_cancelScheduledDelayedEvent(e).then(() => (b.state.delayId = void 0, b.resetRateLimitCounter(MembershipActionType.SendDelayedEvent), createReplaceActionUpdate(MembershipActionType.SendDelayedEvent))).catch((e) => {
				var x = MembershipActionType.SendDelayedEvent, S = b.actionUpdateFromErrors(e, x, "cancelScheduledDelayedEvent");
				if (S) return S;
				if (b.isNotFoundError(e)) return b.state.delayId = void 0, createReplaceActionUpdate(x);
				if (b.isUnsupportedDelayedEndpoint(e)) return createReplaceActionUpdate(MembershipActionType.SendJoinEvent);
				throw Error("We failed to cancel a delayed event where we already had a delay id with an error we cannot automatically handle");
			});
		})();
	}
	setAndEmitProbablyLeft(e) {
		this.state.probablyLeft !== e && (this.state.probablyLeft = e, this.emit(MembershipManagerEvent.ProbablyLeft, this.state.probablyLeft));
	}
	restartDelayedEvent(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			var x = b.state.expectedServerDelayLeaveTs ? b.state.expectedServerDelayLeaveTs - Date.now() : void 0, S = new Promise((e, S) => {
				setTimeout(() => {
					S(new AbortError("Restart delayed event timed out before the HS responded"));
				}, x !== void 0 && !b.state.probablyLeft ? Math.min(b.delayedLeaveEventRestartLocalTimeoutMs, x) : b.delayedLeaveEventRestartLocalTimeoutMs);
			});
			return yield Promise.race([b.client._unstable_restartScheduledDelayedEvent(e), S]).then(() => (b.state.expectedServerDelayLeaveTs = Date.now() + b.delayedLeaveEventDelayMs, b.resetRateLimitCounter(MembershipActionType.RestartDelayedEvent), b.setAndEmitProbablyLeft(!1), createInsertActionUpdate(MembershipActionType.RestartDelayedEvent, b.delayedLeaveEventRestartMs))).catch((e) => {
				b.state.expectedServerDelayLeaveTs && b.state.expectedServerDelayLeaveTs <= Date.now() && b.setAndEmitProbablyLeft(!0);
				var x = MembershipActionType.RestartDelayedEvent;
				if (b.isNotFoundError(e)) return b.state.delayId = void 0, createInsertActionUpdate(MembershipActionType.SendDelayedEvent);
				if (b.isUnsupportedDelayedEndpoint(e)) return {};
				var S = b.actionUpdateFromErrors(e, x, "restartScheduledDelayedEvent");
				if (S) return S;
				throw Error("Could not restart delayed event, even though delayed events are supported. " + e);
			});
		})();
	}
	sendScheduledDelayedLeaveEventOrFallbackToSendLeaveEvent(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			return yield b.client._unstable_sendScheduledDelayedEvent(e).then(() => (b.state.hasMemberStateEvent = !1, b.resetRateLimitCounter(MembershipActionType.SendScheduledDelayedLeaveEvent), { replace: [] })).catch((e) => {
				var x = MembershipActionType.SendLeaveEvent;
				return b.isUnsupportedDelayedEndpoint(e) ? {} : b.isNotFoundError(e) ? (b.state.delayId = void 0, createInsertActionUpdate(x)) : b.actionUpdateFromErrors(e, x, "sendScheduledDelayedEvent") || (b.logger.warn("Encountered unexpected error during SendScheduledDelayedLeaveEvent. Falling back to SendLeaveEvent", e), createInsertActionUpdate(x));
			});
		})();
	}
	sendJoinEvent() {
		var e = this;
		return _asyncToGenerator(function* () {
			return yield e.clientSendMembership(e.makeMyMembership(e.membershipEventExpiryMs)).then(() => (e.setAndEmitProbablyLeft(!1), e.state.startTime = Date.now(), e.state.expireUpdateIterations = 1, e.state.hasMemberStateEvent = !0, e.resetRateLimitCounter(MembershipActionType.SendJoinEvent), { replace: [
				...e.scheduler.actions.filter((e) => e.type !== MembershipActionType.UpdateExpiry && e.type !== MembershipActionType.SendJoinEvent),
				{
					ts: Date.now(),
					type: MembershipActionType.RestartDelayedEvent
				},
				{
					ts: e.computeNextExpiryActionTs(e.state.expireUpdateIterations),
					type: MembershipActionType.UpdateExpiry
				}
			] })).catch((b) => {
				var x = e.actionUpdateFromErrors(b, MembershipActionType.SendJoinEvent, "sendStateEvent");
				if (x) return x;
				throw b;
			});
		})();
	}
	updateExpiryOnJoinedEvent() {
		var e = this;
		return _asyncToGenerator(function* () {
			var b = e.state.expireUpdateIterations + 1;
			return yield e.clientSendMembership(e.makeMyMembership(e.membershipEventExpiryMs * b)).then(() => (e.resetRateLimitCounter(MembershipActionType.UpdateExpiry), e.state.expireUpdateIterations = b, { insert: [{
				ts: e.computeNextExpiryActionTs(b),
				type: MembershipActionType.UpdateExpiry
			}] })).catch((b) => {
				var x = e.actionUpdateFromErrors(b, MembershipActionType.UpdateExpiry, "sendStateEvent");
				if (x) return x;
				throw b;
			});
		})();
	}
	sendFallbackLeaveEvent() {
		var e = this;
		return _asyncToGenerator(function* () {
			return yield e.clientSendMembership({}).then(() => (e.resetRateLimitCounter(MembershipActionType.SendLeaveEvent), e.state.hasMemberStateEvent = !1, { replace: [] })).catch((b) => {
				var x = e.actionUpdateFromErrors(b, MembershipActionType.SendLeaveEvent, "sendStateEvent");
				if (x) return x;
				throw b;
			});
		})();
	}
	makeMembershipStateKey(e, b) {
		var x = `${e}_${b}_${this.slotDescription.application}${this.slotDescription.id}`;
		return /^org\.matrix\.msc(3757|3779)\b/.exec(this.room.getVersion()) ? x : `_${x}`;
	}
	makeMyMembership(e) {
		var b = this.ownMembership, x = this.rtcTransport === void 0 ? {
			focus_active: {
				type: "livekit",
				focus_selection: "oldest_membership"
			},
			foci_preferred: this.fociPreferred ?? []
		} : {
			focus_active: {
				type: "livekit",
				focus_selection: "multi_sfu"
			},
			foci_preferred: [this.rtcTransport, ...this.fociPreferred ?? []]
		};
		return _objectSpread$5(_objectSpread$5({
			application: this.slotDescription.application,
			call_id: this.slotDescription.id,
			scope: "m.room",
			device_id: this.deviceId,
			expires: e,
			"m.call.intent": this.callIntent
		}, x), b === void 0 ? void 0 : { created_ts: b.createdTs() });
	}
	isNotFoundError(e) {
		return e instanceof MatrixError && e.errcode === "M_NOT_FOUND";
	}
	manageMaxDelayExceededSituation(e) {
		if (e instanceof MatrixError && e.errcode === "M_UNKNOWN" && e.data["org.matrix.msc4140.errcode"] === "M_MAX_DELAY_EXCEEDED") {
			var b = e.data["org.matrix.msc4140.max_delay"];
			return typeof b == "number" && this.delayedLeaveEventDelayMs > b && (this.delayedLeaveEventDelayMsOverride = b), this.logger.warn("Retry sending delayed disconnection event due to server timeout limitations:", e), !0;
		}
		return !1;
	}
	actionUpdateFromErrors(e, b, x) {
		var S = this.actionUpdateFromRateLimitError(e, x, b);
		if (S) return S;
		var C = this.actionUpdateFromNetworkErrorRetry(e, b);
		if (C) return C;
	}
	actionUpdateFromRateLimitError(e, b, x) {
		if ((e instanceof HTTPError || e instanceof MatrixError) && e.isRateLimitError()) {
			var S = this.state.rateLimitRetries.get(x) ?? 0;
			if (S < this.maximumRateLimitRetryCount) {
				var C, w = 5e3;
				try {
					C = e.getRetryAfterMs() ?? w, this.logger.info(`Rate limited by server, retrying in ${C}ms`);
				} catch (e) {
					this.logger.warn(`Error while retrieving a rate-limit retry delay, retrying after default delay of ${w}`, e), C = w;
				}
				return this.state.rateLimitRetries.set(x, S + 1), createInsertActionUpdate(x, C);
			}
			throw Error("Exceeded maximum retries for " + x + " attempts (client." + b + ")", { cause: e });
		}
	}
	actionUpdateFromNetworkErrorRetry(e, b) {
		var x = this.state.networkErrorRetries.get(b) ?? 0, S = this.networkErrorRetryMs / 1e3 + "s", C = "(" + x + "/" + this.maximumNetworkErrorRetryCount + ")", w = this.networkErrorRetryMs;
		if (e instanceof Error && e.name === "AbortError") w = 0, this.logger.warn("Network local timeout error while sending event, immediate retry (" + C + ")", e);
		else if (e instanceof Error && e.message.includes("updating delayed event")) this.logger.warn("delayed event update timeout error, retrying in " + S + " " + C, e);
		else if (e instanceof ConnectionError) this.logger.warn("Network connection error while sending event, retrying in " + S + " " + C, e);
		else if ((e instanceof HTTPError || e instanceof MatrixError) && typeof e.httpStatus == "number" && e.httpStatus >= 500 && e.httpStatus < 600) this.logger.warn("Server error while sending event, retrying in " + S + " " + C, e);
		else return;
		if (x < this.maximumNetworkErrorRetryCount) return this.state.networkErrorRetries.set(b, x + 1), createInsertActionUpdate(b, w);
		throw Error("Reached maximum (" + this.maximumNetworkErrorRetryCount + ") retries cause by: " + e);
	}
	isUnsupportedDelayedEndpoint(e) {
		return e instanceof UnsupportedDelayedEventsEndpointError;
	}
	resetRateLimitCounter(e) {
		this.state.rateLimitRetries.set(e, 0), this.state.networkErrorRetries.set(e, 0);
	}
	get status() {
		var e = this.scheduler.actions;
		if (e.length === 1) {
			var { type: b } = e[0];
			switch (b) {
				case MembershipActionType.SendDelayedEvent:
				case MembershipActionType.SendJoinEvent: return Status.Connecting;
				case MembershipActionType.UpdateExpiry: return Status.Connected;
				case MembershipActionType.SendScheduledDelayedLeaveEvent:
				case MembershipActionType.SendLeaveEvent: return Status.Disconnecting;
				default:
			}
		} else if (e.length === 2) {
			var x = e.map((e) => e.type);
			if ((x.includes(MembershipActionType.RestartDelayedEvent) || x.includes(MembershipActionType.SendDelayedEvent) && this.state.hasMemberStateEvent) && x.includes(MembershipActionType.UpdateExpiry)) return Status.Connected;
		} else if (e.length === 3) {
			var S = e.map((e) => e.type);
			if (S.filter((e) => e === MembershipActionType.RestartDelayedEvent).length === 2 && S.includes(MembershipActionType.UpdateExpiry)) return Status.Connected;
		}
		return this.scheduler.running ? (this.logger.error("MembershipManager has an unknown state. Actions: ", e), Status.Unknown) : Status.Disconnected;
	}
	get probablyLeft() {
		return this.state.probablyLeft;
	}
}, StickyEventMembershipManager = class e extends MembershipManager {
	constructor(e, b, x, S, C) {
		super(e, b, x, S, C), this.clientWithSticky = x, _defineProperty(this, "clientSendDelayedDisconnectMembership", () => this.clientWithSticky._unstable_sendStickyDelayedEvent(this.room.roomId, MEMBERSHIP_STICKY_DURATION_MS, { delay: this.delayedLeaveEventDelayMs }, null, EventType.RTCMembership, { msc4354_sticky_key: this.memberId })), _defineProperty(this, "clientSendMembership", (e) => this.clientWithSticky._unstable_sendStickyEvent(this.room.roomId, MEMBERSHIP_STICKY_DURATION_MS, null, EventType.RTCMembership, _objectSpread$5(_objectSpread$5({}, e), {}, { msc4354_sticky_key: this.memberId })));
	}
	actionUpdateFromErrors(b, x, S) {
		return super.actionUpdateFromErrors(b, x, e.nameMap.get(S) ?? "unknown");
	}
	makeMyMembership(e) {
		var b = this.ownMembership, x = b != null && b.eventId ? { "m.relation": {
			rel_type: RelationType.Reference,
			event_id: b?.eventId
		} } : {};
		return _objectSpread$5({
			application: _objectSpread$5({ type: this.slotDescription.application }, this.callIntent ? { "m.call.intent": this.callIntent } : {}),
			slot_id: slotDescriptionToId(this.slotDescription),
			rtc_transports: this.rtcTransport ? [this.rtcTransport] : [],
			member: {
				device_id: this.deviceId,
				user_id: this.client.getUserId(),
				id: this.memberId
			},
			versions: []
		}, x);
	}
};
_defineProperty(StickyEventMembershipManager, "nameMap", new Map([["sendStateEvent", "_unstable_sendStickyEvent"], ["sendDelayedStateEvent", "_unstable_sendStickyDelayedEvent"]]));
var KeyTransportEvents = /* @__PURE__ */ function(e) {
	return e.ReceivedKeys = "received_keys", e.NotSupportedError = "not_supported_error", e;
}({}), OutdatedKeyFilter = class {
	constructor() {
		_defineProperty(this, "tsBuffer", /* @__PURE__ */ new Map());
	}
	isOutdated(e, b) {
		this.tsBuffer.has(e) || this.tsBuffer.set(e, /* @__PURE__ */ new Map());
		var x = this.tsBuffer.get(e)?.get(b.keyIndex);
		return x && x > b.creationTS ? !0 : (this.tsBuffer.get(e).set(b.keyIndex, b.creationTS), !1);
	}
};
function getParticipantId(e, b) {
	return `${e}:${b}`;
}
var EncryptionManager = class {
	get updateEncryptionKeyThrottle() {
		return this.joinConfig?.updateEncryptionKeyThrottle ?? 3e3;
	}
	get makeKeyDelay() {
		return this.joinConfig?.makeKeyDelay ?? 3e3;
	}
	get useKeyDelay() {
		return this.joinConfig?.useKeyDelay ?? 5e3;
	}
	constructor(e, b, x, S, C, w, T) {
		var E = this;
		this.userId = e, this.deviceId = b, this.getMemberships = x, this.transport = S, this.statistics = C, this.onEncryptionKeysChanged = w, _defineProperty(this, "manageMediaKeys", !1), _defineProperty(this, "keysEventUpdateTimeout", void 0), _defineProperty(this, "makeNewKeyTimeout", void 0), _defineProperty(this, "setNewKeyTimeouts", /* @__PURE__ */ new Set()), _defineProperty(this, "encryptionKeys", /* @__PURE__ */ new Map()), _defineProperty(this, "lastEncryptionKeyUpdateRequest", void 0), _defineProperty(this, "lastMembershipFingerprints", void 0), _defineProperty(this, "latestGeneratedKeyIndex", -1), _defineProperty(this, "joinConfig", void 0), _defineProperty(this, "logger", void 0), _defineProperty(this, "joined", !1), _defineProperty(this, "sendEncryptionKeysEvent", /* @__PURE__ */ function() {
			var e = _asyncToGenerator(function* (e) {
				if (E.keysEventUpdateTimeout !== void 0 && (clearTimeout(E.keysEventUpdateTimeout), E.keysEventUpdateTimeout = void 0), E.lastEncryptionKeyUpdateRequest = Date.now(), E.joined) {
					var b = E.getKeysForParticipant(E.userId, E.deviceId);
					if (!b) {
						E.logger.warn("Tried to send encryption keys event but no keys found!");
						return;
					}
					if (typeof e != "number" && E.latestGeneratedKeyIndex === -1) {
						E.logger.warn("Tried to send encryption keys event but no current key index found!");
						return;
					}
					var x = e ?? E.latestGeneratedKeyIndex;
					E.logger.info(`Try sending encryption keys event. keyIndexToSend=${x} (method parameter: ${e})`);
					var S = b[x];
					try {
						E.statistics.counters.roomEventEncryptionKeysSent += 1;
						var C = E.getMemberships().filter((e) => e.sender != null).map((e) => ({
							userId: e.sender,
							deviceId: e.deviceId,
							membershipTs: e.createdTs()
						}));
						yield E.transport.sendKey(encodeUnpaddedBase64(S), x, C), E.logger.debug(`sendEncryptionKeysEvent participantId=${E.userId}:${E.deviceId} numKeys=${b.length} currentKeyIndex=${E.latestGeneratedKeyIndex} keyIndexToSend=${x}`);
					} catch (e) {
						if (E.keysEventUpdateTimeout === void 0) {
							var w = safeGetRetryAfterMs(e, 5e3);
							E.logger.warn(`Failed to send m.call.encryption_key, retrying in ${w}`, e), E.keysEventUpdateTimeout = setTimeout(() => void E.sendEncryptionKeysEvent(), w);
						} else E.logger.info("Not scheduling key resend as another re-send is already pending");
					}
				}
			});
			return function(b) {
				return e.apply(this, arguments);
			};
		}()), _defineProperty(this, "onNewKeyReceived", (e, b, x, S, C) => {
			this.logger.debug(`Received key over key transport ${e}:${b} at index ${S}`), this.setEncryptionKey(e, b, S, x, C);
		}), _defineProperty(this, "onRotateKeyTimeout", () => {
			if (this.manageMediaKeys) {
				this.makeNewKeyTimeout = void 0, this.logger.info("Making new sender key for key rotation");
				var e = this.makeNewSenderKey(!0);
				this.sendEncryptionKeysEvent(e);
			}
		}), this.logger = (T ?? logger).getChild("[EncryptionManager]");
	}
	getEncryptionKeys() {
		var e = /* @__PURE__ */ new Map();
		for (var [b, x] of this.encryptionKeys) {
			var S = x.map((e, b) => ({
				key: e.key,
				keyIndex: b
			}));
			e.set(b, S);
		}
		return e;
	}
	join(e) {
		var b;
		this.joinConfig = e, this.joined = !0, this.manageMediaKeys = this.joinConfig?.manageMediaKeys ?? this.manageMediaKeys, this.transport.on(KeyTransportEvents.ReceivedKeys, this.onNewKeyReceived), this.transport.start(), (b = this.joinConfig) != null && b.manageMediaKeys && (this.makeNewSenderKey(), this.requestSendCurrentKey());
	}
	leave() {
		this.encryptionKeys.set(getParticipantId(this.userId, this.deviceId), []), this.transport.off(KeyTransportEvents.ReceivedKeys, this.onNewKeyReceived), this.transport.stop(), this.makeNewKeyTimeout !== void 0 && (clearTimeout(this.makeNewKeyTimeout), this.makeNewKeyTimeout = void 0);
		for (var e of this.setNewKeyTimeouts) clearTimeout(e);
		this.setNewKeyTimeouts.clear(), this.manageMediaKeys = !1, this.joined = !1;
	}
	onMembershipsUpdate(e) {
		if (this.manageMediaKeys && this.joined) {
			var b = new Set(e.filter((e) => !isMyMembership(e, this.userId, this.deviceId)).map(getParticipantIdFromMembership)), x = new Set(this.getMemberships().filter((e) => !isMyMembership(e, this.userId, this.deviceId)).map(getParticipantIdFromMembership)), S = Array.from(b).some((e) => !x.has(e)), C = Array.from(x).some((e) => !b.has(e)), w = this.lastMembershipFingerprints;
			if (this.storeLastMembershipFingerprints(), S) this.makeNewKeyTimeout ||= (this.logger.debug("Member(s) have left: queueing sender key rotation"), setTimeout(this.onRotateKeyTimeout, this.makeKeyDelay));
			else if (C) this.logger.debug("New member(s) have joined: re-sending keys"), this.requestSendCurrentKey();
			else if (w) {
				var T = this.lastMembershipFingerprints;
				(Array.from(w).some((e) => !T.has(e)) || Array.from(T).some((e) => !w.has(e))) && (this.logger.debug("Member(s) have updated/reconnected: re-sending keys to everyone"), this.requestSendCurrentKey());
			}
		}
	}
	makeNewSenderKey() {
		var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, b = secureRandomBase64Url(16), x = this.getNewEncryptionKeyIndex();
		return this.logger.info("Generated new key at index " + x), this.setEncryptionKey(this.userId, this.deviceId, x, b, Date.now(), e), x;
	}
	requestSendCurrentKey() {
		if (this.manageMediaKeys) {
			if (this.lastEncryptionKeyUpdateRequest && this.lastEncryptionKeyUpdateRequest + this.updateEncryptionKeyThrottle > Date.now()) {
				this.logger.info("Last encryption key event sent too recently: postponing"), this.keysEventUpdateTimeout === void 0 && (this.keysEventUpdateTimeout = setTimeout(() => void this.sendEncryptionKeysEvent(), this.updateEncryptionKeyThrottle));
				return;
			}
			this.sendEncryptionKeysEvent();
		}
	}
	getKeysForParticipant(e, b) {
		return this.encryptionKeys.get(getParticipantId(e, b))?.map((e) => e.key);
	}
	storeLastMembershipFingerprints() {
		this.lastMembershipFingerprints = new Set(this.getMemberships().filter((e) => !isMyMembership(e, this.userId, this.deviceId)).map((e) => `${getParticipantIdFromMembership(e)}:${e.createdTs()}`));
	}
	getNewEncryptionKeyIndex() {
		return this.latestGeneratedKeyIndex === -1 ? 0 : (this.latestGeneratedKeyIndex + 1) % 256;
	}
	setEncryptionKey(e, b, x, S, C) {
		var w = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : !1;
		this.logger.debug(`Setting encryption key for ${e}:${b} at index ${x}`);
		var T = decodeBase64(S), E = getParticipantId(e, b);
		this.encryptionKeys.has(E) || this.encryptionKeys.set(E, []);
		var D = this.encryptionKeys.get(E), O = D[x];
		if (O) {
			if (O.timestamp > C) {
				this.logger.info(`Ignoring new key at index ${x} for ${E} as it is older than existing known key`);
				return;
			}
			if (keysEqual(O.key, T)) {
				O.timestamp = C;
				return;
			}
		}
		if (e === this.userId && b === this.deviceId && (this.latestGeneratedKeyIndex = x), D[x] = {
			key: T,
			timestamp: C
		}, w) {
			var k = setTimeout(() => {
				this.setNewKeyTimeouts.delete(k), this.logger.info(`Delayed-emitting key changed event for ${E} index ${x}`), this.onEncryptionKeysChanged(T, x, E);
			}, this.useKeyDelay);
			this.setNewKeyTimeouts.add(k);
		} else this.onEncryptionKeysChanged(T, x, E);
	}
};
function keysEqual(e, b) {
	return e === b ? !0 : !!e && !!b && e.length === b.length && e.every((e, x) => e === b[x]);
}
var getParticipantIdFromMembership = (e) => getParticipantId(e.sender, e.deviceId), RTCEncryptionManager = class {
	constructor(e, b, x, S, C, w, T) {
		this.userId = e, this.deviceId = b, this.getMemberships = x, this.transport = S, this.statistics = C, this.onEncryptionKeysChanged = w, _defineProperty(this, "manageMediaKeys", !1), _defineProperty(this, "participantKeyRings", /* @__PURE__ */ new Map()), _defineProperty(this, "outboundSession", null), _defineProperty(this, "currentKeyDistributionPromise", null), _defineProperty(this, "useKeyDelay", 5e3), _defineProperty(this, "keyRotationGracePeriodMs", 1e4), _defineProperty(this, "needToEnsureKeyAgain", !1), _defineProperty(this, "keyBuffer", new OutdatedKeyFilter()), _defineProperty(this, "logger", void 0), _defineProperty(this, "onNewKeyReceived", (e, b, x, S, C) => {
			var w;
			if (!this.manageMediaKeys) {
				var T;
				(T = this.logger) == null || T.warn(`Received key over transport ${e}:${b} at index ${S} but media keys are disabled`);
				return;
			}
			(w = this.logger) == null || w.debug(`Received key over transport ${e}:${b} at index ${S}`);
			var E = getParticipantId(e, b), D = {
				key: decodeBase64(x),
				participantId: E,
				keyIndex: S,
				creationTS: C
			};
			if (!this.keyBuffer.isOutdated(E, D)) this.addKeyToParticipant(D.key, D.keyIndex, D.participantId), this.statistics.counters.roomEventEncryptionKeysReceived += 1;
			else {
				var O;
				(O = this.logger) == null || O.info(`Received an out of order key for ${e}:${b}, dropping it`);
			}
		}), this.logger = T?.getChild("[EncryptionManager]");
	}
	getEncryptionKeys() {
		return new Map(this.participantKeyRings);
	}
	addKeyToParticipant(e, b, x) {
		this.participantKeyRings.has(x) || this.participantKeyRings.set(x, []), this.participantKeyRings.get(x).push({
			key: e,
			keyIndex: b
		}), this.onEncryptionKeysChanged(e, b, x);
	}
	join(e) {
		var b;
		this.manageMediaKeys = e?.manageMediaKeys ?? !0, (b = this.logger) == null || b.info("Joining room"), this.useKeyDelay = e?.useKeyDelay ?? 1e3, this.keyRotationGracePeriodMs = e?.keyRotationGracePeriodMs ?? 1e4, this.transport.on(KeyTransportEvents.ReceivedKeys, this.onNewKeyReceived), this.transport.start();
	}
	leave() {
		this.transport.off(KeyTransportEvents.ReceivedKeys, this.onNewKeyReceived), this.transport.stop(), this.participantKeyRings.clear();
	}
	ensureKeyDistribution() {
		if (this.manageMediaKeys) if (this.currentKeyDistributionPromise == null) {
			var e;
			(e = this.logger) == null || e.debug("No active rollout, start a new one"), this.currentKeyDistributionPromise = this.rolloutOutboundKey().then(() => {
				var e;
				if ((e = this.logger) == null || e.debug("Rollout completed"), this.currentKeyDistributionPromise = null, this.needToEnsureKeyAgain) {
					var b;
					(b = this.logger) == null || b.debug("New Rollout needed"), this.needToEnsureKeyAgain = !1, this.ensureKeyDistribution();
				}
			});
		} else {
			var b;
			(b = this.logger) == null || b.debug("Rollout in progress, a new rollout will be started after the current one"), this.needToEnsureKeyAgain = !0;
		}
	}
	onMembershipsUpdate() {
		var e;
		arguments.length > 0 && arguments[0] !== void 0 && arguments[0], (e = this.logger) == null || e.trace("onMembershipsUpdate"), this.ensureKeyDistribution();
	}
	rolloutOutboundKey() {
		var e = this;
		return _asyncToGenerator(function* () {
			e.outboundSession ?? (e.outboundSession = {
				key: e.generateRandomKey(),
				creationTS: Date.now(),
				sharedWith: [],
				keyId: 0
			}, e.addKeyToParticipant(e.outboundSession.key, e.outboundSession.keyId, getParticipantId(e.userId, e.deviceId)));
			var b = e.getMemberships().filter((e) => e.sender != null).map((e) => ({
				userId: e.sender,
				deviceId: e.deviceId,
				membershipTs: e.createdTs()
			})), x = e.outboundSession?.sharedWith ?? [];
			x = x.filter((e) => !b.some((b) => e.userId == b.userId && e.deviceId == b.deviceId && e.membershipTs != b.membershipTs));
			var S = x.filter((e) => !b.some((b) => e.userId == b.userId && e.deviceId == b.deviceId && e.membershipTs == b.membershipTs)), C = b.filter((e) => !x.some((b) => e.userId == b.userId && e.deviceId == b.deviceId && e.membershipTs == b.membershipTs)), w = [], T, E = !1;
			if (S.length > 0) {
				var D = e.createNewOutboundSession();
				E = !0, w = b, T = D;
			} else if (C.length > 0) {
				var O = Date.now() - e.outboundSession.creationTS;
				if (O < e.keyRotationGracePeriodMs) {
					var k;
					(k = e.logger) == null || k.debug(`New joiners detected, but the key is recent enough (age:${O}), keeping it`), w = C, T = e.outboundSession;
				} else {
					var A;
					(A = e.logger) == null || A.debug("New joiners detected, rotating the key");
					var j = e.createNewOutboundSession();
					E = !0, w = b, T = j;
				}
			} else return;
			try {
				var M, N;
				if ((M = e.logger) == null || M.trace("Sending key..."), yield e.transport.sendKey(encodeBase64(T.key), T.keyId, w), e.statistics.counters.roomEventEncryptionKeysSent += 1, T.sharedWith.push(...w), (N = e.logger) == null || N.trace(`key index:${T.keyId} sent to ${T.sharedWith.map((e) => `${e.userId}:${e.deviceId}`).join(",")}`), E) {
					var P, F;
					(P = e.logger) == null || P.trace(`Delay Rollout for key:${T.keyId}...`), yield sleep(e.useKeyDelay), (F = e.logger) == null || F.trace(`...Delayed rollout of index:${T.keyId} `), e.addKeyToParticipant(T.key, T.keyId, getParticipantId(e.userId, e.deviceId));
				}
			} catch (b) {
				var I;
				(I = e.logger) == null || I.error("Failed to rollout key", b);
			}
		})();
	}
	createNewOutboundSession() {
		var e, b = {
			key: this.generateRandomKey(),
			creationTS: Date.now(),
			sharedWith: [],
			keyId: this.nextKeyIndex()
		};
		return (e = this.logger) == null || e.info(`creating new outbound key index:${b.keyId}`), this.outboundSession = b, b;
	}
	nextKeyIndex() {
		return this.outboundSession ? (this.outboundSession.keyId + 1) % 256 : 0;
	}
	generateRandomKey() {
		var e = new Uint8Array(16);
		return globalThis.crypto.getRandomValues(e), e;
	}
}, NotSupportedError = class extends Error {
	constructor(e) {
		super(e);
	}
	get name() {
		return "NotSupportedError";
	}
}, ToDeviceKeyTransport = class extends TypedEventEmitter {
	setParentLogger(e) {
		this.logger = e.getChild("[ToDeviceKeyTransport]");
	}
	constructor(e, b, x, S, C, w) {
		super(), this.userId = e, this.deviceId = b, this.roomId = x, this.client = S, this.statistics = C, _defineProperty(this, "logger", logger), _defineProperty(this, "onToDeviceEvent", (e) => {
			if (e.getType() === EventType.CallEncryptionKeysPrefix) {
				var b = this.getValidEventContent(e);
				b && e.getSender() && this.receiveCallKeyEvent(e.getSender(), b);
			}
		}), this.setParentLogger(w ?? logger);
	}
	start() {
		this.client.on(ClientEvent.ToDeviceEvent, this.onToDeviceEvent);
	}
	stop() {
		this.client.off(ClientEvent.ToDeviceEvent, this.onToDeviceEvent);
	}
	sendKey(e, b, x) {
		var S = this;
		return _asyncToGenerator(function* () {
			var C = {
				keys: {
					index: b,
					key: e
				},
				room_id: S.roomId,
				member: { claimed_device_id: S.deviceId },
				session: {
					call_id: "",
					application: "m.call",
					scope: "m.room"
				},
				sent_ts: Date.now()
			}, w = x.map((e) => ({
				userId: e.userId,
				deviceId: e.deviceId
			})).filter((e) => !(e.userId == S.userId && e.deviceId == S.deviceId));
			w.length > 0 ? (yield S.client.encryptAndSendToDevice(EventType.CallEncryptionKeysPrefix, w, C).catch((e) => {
				var b = e.message;
				if (b.includes("unknown variant") && b.includes("send_to_device") || b.includes("not supported")) throw new NotSupportedError("The widget driver does not support to-device encryption");
			}), S.statistics.counters.roomEventEncryptionKeysSent += 1) : S.logger.warn("No targets found for sending key");
		})();
	}
	receiveCallKeyEvent(e, b) {
		this.statistics.counters.roomEventEncryptionKeysReceived += 1;
		var x = Date.now(), S = x - (typeof b.sent_ts == "number" ? b.sent_ts : x);
		this.statistics.totals.roomEventEncryptionKeysReceivedTotalAge += S, this.emit(KeyTransportEvents.ReceivedKeys, e, b.member.claimed_device_id, b.keys.key, b.keys.index, x);
	}
	getValidEventContent(e) {
		var b = e.getContent(), x = b.room_id;
		if (!x) {
			this.logger.warn("Malformed Event: invalid call encryption keys event, no roomId");
			return;
		}
		if (x !== this.roomId) {
			this.logger.warn("Malformed Event: Mismatch roomId");
			return;
		}
		if (!b.keys || !b.keys.key || typeof b.keys.index != "number") {
			this.logger.warn("Malformed Event: Missing keys field");
			return;
		}
		if (!b.member || !b.member.claimed_device_id) {
			this.logger.warn("Malformed Event: Missing claimed_device_id");
			return;
		}
		return b;
	}
}, RoomKeyTransport = class extends TypedEventEmitter {
	setParentLogger(e) {
		this.logger = e.getChild("[RoomKeyTransport]");
	}
	constructor(e, b, x, S) {
		super(), this.room = e, this.client = b, this.statistics = x, _defineProperty(this, "logger", logger), this.setParentLogger(S ?? logger);
	}
	start() {
		this.room.on(RoomEvent.Timeline, (e) => void this.consumeCallEncryptionEvent(e));
	}
	stop() {
		this.room.off(RoomEvent.Timeline, (e) => void this.consumeCallEncryptionEvent(e));
	}
	consumeCallEncryptionEvent(e) {
		var b = arguments, x = this;
		return _asyncToGenerator(function* () {
			var S = b.length > 1 && b[1] !== void 0 ? b[1] : !1;
			if (yield x.client.decryptEventIfNeeded(e), e.isDecryptionFailure()) {
				S ? x.logger.warn(`Decryption failed for event ${e.getId()}: ${e.decryptionFailureReason}`) : (x.logger.warn(`Decryption failed for event ${e.getId()}: ${e.decryptionFailureReason} will retry once only`), setTimeout(() => void x.consumeCallEncryptionEvent(e, !0), 1e3));
				return;
			} else S && x.logger.info(`Decryption succeeded for event ${e.getId()} after retry`);
			if (e.getType() !== EventType.CallEncryptionKeysPrefix) return Promise.resolve();
			if (!x.room) return x.logger.error(`Got room state event for unknown room ${e.getRoomId()}!`), Promise.resolve();
			x.onEncryptionEvent(e);
		})();
	}
	sendKey(e, b, x) {
		var S = this;
		return _asyncToGenerator(function* () {
			var x = {
				keys: [{
					index: b,
					key: e
				}],
				device_id: S.client.getDeviceId(),
				call_id: "",
				sent_ts: Date.now()
			};
			try {
				yield S.client.sendEvent(S.room.roomId, EventType.CallEncryptionKeysPrefix, x);
			} catch (e) {
				S.logger.error("Failed to send call encryption keys", e);
				var C = e;
				throw C.event && S.client.cancelPendingEvent(C.event), e;
			}
		})();
	}
	onEncryptionEvent(e) {
		var b = e.getSender(), x = e.getContent(), S = x.device_id, C = x.call_id;
		if (!b) {
			this.logger.warn(`Received m.call.encryption_keys with no userId: callId=${C}`);
			return;
		}
		if (C !== "") {
			this.logger.warn(`Received m.call.encryption_keys with unsupported callId: userId=${b}, deviceId=${S}, callId=${C}`);
			return;
		}
		if (!Array.isArray(x.keys)) {
			this.logger.warn(`Received m.call.encryption_keys where keys wasn't an array: callId=${C}`);
			return;
		}
		if (b === this.client.getUserId() && S === this.client.getDeviceId()) {
			this.logger.info("Ignoring our own keys event");
			return;
		}
		this.statistics.counters.roomEventEncryptionKeysReceived += 1;
		var w = Date.now() - (typeof x.sent_ts == "number" ? x.sent_ts : e.getTs());
		this.statistics.totals.roomEventEncryptionKeysReceivedTotalAge += w;
		for (var T of x.keys) {
			if (!T) {
				this.logger.info("Ignoring false-y key in keys event");
				continue;
			}
			var E = T.key, D = T.index;
			!E || D == null || C == null || typeof S != "string" || typeof C != "string" || typeof E != "string" || typeof D != "number" ? this.logger.warn(`Malformed call encryption_key: userId=${b}, deviceId=${S}, encryptionKeyIndex=${D} callId=${C}`) : (this.logger.debug(`onCallEncryption userId=${b}:${S} encryptionKeyIndex=${D} age=${w}ms`), this.emit(KeyTransportEvents.ReceivedKeys, b, S, E, D, e.getTs()));
		}
	}
};
function ownKeys$4(e, b) {
	var x = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var S = Object.getOwnPropertySymbols(e);
		b && (S = S.filter(function(b) {
			return Object.getOwnPropertyDescriptor(e, b).enumerable;
		})), x.push.apply(x, S);
	}
	return x;
}
function _objectSpread$4(e) {
	for (var b = 1; b < arguments.length; b++) {
		var x = arguments[b] == null ? {} : arguments[b];
		b % 2 ? ownKeys$4(Object(x), !0).forEach(function(b) {
			_defineProperty(e, b, x[b]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(x)) : ownKeys$4(Object(x)).forEach(function(b) {
			Object.defineProperty(e, b, Object.getOwnPropertyDescriptor(x, b));
		});
	}
	return e;
}
var MatrixRTCSessionEvent = /* @__PURE__ */ function(e) {
	return e.MembershipsChanged = "memberships_changed", e.JoinStateChanged = "join_state_changed", e.EncryptionKeyChanged = "encryption_key_changed", e.MembershipManagerError = "membership_manager_error", e.DidSendCallNotification = "did_send_call_notification", e;
}({});
function slotIdToDescription(e) {
	var [b, x] = e.split("#");
	return {
		application: b,
		id: x
	};
}
function slotDescriptionToId(e) {
	return `${e.application}#${e.id}`;
}
var MatrixRTCSession = class e extends TypedEventEmitter {
	get membershipStatus() {
		return this.membershipManager?.status;
	}
	get probablyLeft() {
		return this.membershipManager?.probablyLeft;
	}
	get callId() {
		return this.slotDescription?.id;
	}
	get slotId() {
		return slotDescriptionToId(this.slotDescription);
	}
	static callMembershipsForRoom(b) {
		return e.sessionMembershipsForSlot(b, {
			id: "",
			application: "m.call"
		});
	}
	static sessionMembershipsForRoom(e, b) {
		return this.sessionMembershipsForSlot(e, b);
	}
	static sessionMembershipsForSlot(e, b) {
		var { listenForStickyEvents: x, listenForMemberStateEvents: S } = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
			listenForStickyEvents: !0,
			listenForMemberStateEvents: !0
		}, C = logger.getChild(`[MatrixRTCSession ${e.roomId}]`), w = [];
		if (x && (w = [...e._unstable_getStickyEvents()].filter((e) => e.getType() === EventType.RTCMembership)), S) {
			var T = e.getLiveTimeline().getState(EventTimeline.FORWARDS);
			if (!T) throw C.warn("Couldn't get state for room " + e.roomId), Error("Could't get state for room " + e.roomId);
			var E = T.getStateEvents(EventType.GroupCallMemberPrefix);
			w = w.concat(E.filter((e) => !w.some((b) => b.getContent().msc4354_sticky_key === e.getStateKey())));
		}
		var D = [];
		for (var O of w) {
			var k = O.getContent(), A = Object.keys(k).filter((e) => e !== "msc4354_sticky_key").length;
			if (A !== 0) {
				var j = [];
				if (A > 1 && "application" in k ? j.push(k) : A === 1 && "memberships" in k && C.warn("Legacy event found. Those are ignored, they do not contribute to the MatrixRTC session"), j.length !== 0) {
					for (var M of j) if ("application" in M) try {
						var N = new CallMembership(O, M);
						if (!deepCompare(N.slotDescription, b)) {
							C.info(`Ignoring membership of user ${N.sender} for a different slot:  ${JSON.stringify(N.slotDescription)}`);
							continue;
						}
						if (N.isExpired()) {
							C.info(`Ignoring expired device membership ${N.sender}/${N.deviceId}`);
							continue;
						}
						if (!e.hasMembershipState(N.sender ?? "", KnownMembership.Join)) {
							C.info(`Ignoring membership of user ${N.sender} who is not in the room.`);
							continue;
						}
						D.push(N);
					} catch (e) {
						C.warn("Couldn't construct call membership: ", e);
					}
				}
			}
		}
		return D.sort((e, b) => e.createdTs() - b.createdTs()), D.length > 1 && C.debug(`Call memberships in room ${e.roomId}, in order: `, D.map((e) => [e.createdTs(), e.sender])), D;
	}
	static roomSessionForRoom(b, x, S) {
		var C = e.sessionMembershipsForSlot(x, {
			id: "",
			application: "m.call"
		}, S);
		return new e(b, x, C, {
			id: "",
			application: "m.call"
		});
	}
	static sessionForRoom(e, b, x) {
		return this.sessionForSlot(e, b, x);
	}
	static sessionForSlot(b, x, S, C) {
		var w = e.sessionMembershipsForSlot(x, S, C);
		return new e(b, x, w, S);
	}
	get room() {
		return this.roomSubset;
	}
	constructor(b, x, S, C) {
		super(), this.client = b, this.roomSubset = x, this.memberships = S, this.slotDescription = C, _defineProperty(this, "membershipManager", void 0), _defineProperty(this, "encryptionManager", void 0), _defineProperty(this, "joinConfig", void 0), _defineProperty(this, "logger", void 0), _defineProperty(this, "pendingNotificationToSend", void 0), _defineProperty(this, "expiryTimeout", void 0), _defineProperty(this, "statistics", {
			counters: {
				roomEventEncryptionKeysSent: 0,
				roomEventEncryptionKeysReceived: 0
			},
			totals: { roomEventEncryptionKeysReceivedTotalAge: 0 }
		}), _defineProperty(this, "reEmitter", new TypedReEmitter(this)), _defineProperty(this, "onRoomMemberUpdate", () => {
			this.recalculateSessionMembers();
		}), _defineProperty(this, "onStickyEventUpdate", (e, b, x) => {
			[
				...e,
				...x,
				...b.flatMap((e) => [e.current, e.previous])
			].some((e) => e.getType() === EventType.RTCMembership) && this.recalculateSessionMembers();
		}), _defineProperty(this, "onRTCSessionMemberUpdate", () => {
			this.recalculateSessionMembers();
		}), _defineProperty(this, "recalculateSessionMembers", () => {
			var b, x = this.memberships;
			if (this.memberships = e.sessionMembershipsForSlot(this.room, this.slotDescription), x.length != this.memberships.length || x.some((e, b) => !CallMembership.equal(e, this.memberships[b]))) {
				var S;
				this.logger.info(`Memberships for call in room ${this.roomSubset.roomId} have changed: emitting (${this.memberships.length} members)`), logDurationSync(this.logger, "emit MatrixRTCSessionEvent.MembershipsChanged", () => {
					this.emit(MatrixRTCSessionEvent.MembershipsChanged, x, this.memberships);
				}), (S = this.membershipManager) == null || S.onRTCSessionMemberUpdate(this.memberships);
				var C = this.membershipManager?.ownMembership;
				if (this.pendingNotificationToSend && C && x.length === 0) {
					var w;
					C.eventId && (w = this.joinConfig) != null && w.notificationType ? this.sendCallNotify(C.eventId, this.joinConfig.notificationType, C.callIntent) : this.logger.warn("Own membership eventId is undefined, cannot send call notification");
				}
				this.memberships.length > 0 && (this.pendingNotificationToSend = void 0);
			} else this.logger.debug(`No membership changes detected for room ${this.roomSubset.roomId}`);
			(b = this.encryptionManager) == null || b.onMembershipsUpdate(x), this.setExpiryTimer();
		}), this.logger = logger.getChild(`[MatrixRTCSession ${x.roomId}]`), this.roomSubset.getLiveTimeline().getState(EventTimeline.FORWARDS)?.on(RoomStateEvent.Members, this.onRoomMemberUpdate), this.roomSubset.on(RoomStickyEventsEvent.Update, this.onStickyEventUpdate), this.setExpiryTimer();
	}
	isJoined() {
		return this.membershipManager?.isJoined() ?? !1;
	}
	stop() {
		var e = this;
		return _asyncToGenerator(function* () {
			yield e.membershipManager?.leave(1e3), e.expiryTimeout &&= (clearTimeout(e.expiryTimeout), void 0), e.roomSubset.getLiveTimeline().getState(EventTimeline.FORWARDS)?.off(RoomStateEvent.Members, e.onRoomMemberUpdate), e.roomSubset.off(RoomStickyEventsEvent.Update, e.onStickyEventUpdate);
		})();
	}
	joinRoomSession(e, b, x) {
		if (this.isJoined()) {
			this.logger.info(`Already joined to session in room ${this.roomSubset.roomId}: ignoring join call`);
			return;
		} else {
			this.membershipManager = x != null && x.unstableSendStickyEvents ? new StickyEventMembershipManager(x, this.roomSubset, this.client, this.slotDescription, this.logger) : new MembershipManager(x, this.roomSubset, this.client, this.slotDescription, this.logger), this.reEmitter.reEmit(this.membershipManager, [MembershipManagerEvent.ProbablyLeft, MembershipManagerEvent.StatusChanged]);
			var S;
			if (x != null && x.useExperimentalToDeviceTransport) {
				this.logger.info("Using experimental to-device transport for encryption keys"), this.logger.info("Using to-device with room fallback transport for encryption keys");
				var [C, w] = [this.client.getUserId(), this.client.getDeviceId()], [T, E, D] = [
					this.roomSubset,
					this.client,
					this.statistics
				], O = new ToDeviceKeyTransport(C, w, T.roomId, E, D);
				this.encryptionManager = new RTCEncryptionManager(this.client.getUserId(), this.client.getDeviceId(), () => this.memberships, O, this.statistics, (e, b, x) => {
					this.emit(MatrixRTCSessionEvent.EncryptionKeyChanged, e, b, x);
				}, this.logger);
			} else S = new RoomKeyTransport(this.roomSubset, this.client, this.statistics), this.encryptionManager = new EncryptionManager(this.client.getUserId(), this.client.getDeviceId(), () => this.memberships, S, this.statistics, (e, b, x) => {
				this.emit(MatrixRTCSessionEvent.EncryptionKeyChanged, e, b, x);
			});
		}
		this.joinConfig = x, this.pendingNotificationToSend = this.joinConfig?.notificationType, this.membershipManager.join(e, b, (e) => {
			this.logger.error("MembershipManager encountered an unrecoverable error: ", e), this.emit(MatrixRTCSessionEvent.MembershipManagerError, e), this.emit(MatrixRTCSessionEvent.JoinStateChanged, this.isJoined());
		}), this.encryptionManager.join(x), this.emit(MatrixRTCSessionEvent.JoinStateChanged, !0);
	}
	leaveRoomSession() {
		var e = arguments, b = this;
		return _asyncToGenerator(function* () {
			var x = e.length > 0 && e[0] !== void 0 ? e[0] : void 0;
			if (!b.isJoined()) return b.logger.info(`Not joined to session in room ${b.roomSubset.roomId}: ignoring leave call`), !1;
			b.logger.info(`Leaving call session in room ${b.roomSubset.roomId}`), b.encryptionManager.leave();
			var S = b.membershipManager.leave(x);
			return b.emit(MatrixRTCSessionEvent.JoinStateChanged, !1), yield S;
		})();
	}
	getFocusInUse() {
		var e = this.getOldestMembership();
		return e?.getTransport(e);
	}
	getActiveFocus() {
		return this.getOldestMembership()?.getFocusActive();
	}
	getOldestMembership() {
		return this.memberships[0];
	}
	getConsensusCallIntent() {
		var e = this.memberships.find((e) => !!e.callIntent)?.callIntent;
		if (e && this.memberships.every((b) => !b.callIntent || b.callIntent === e)) return e;
	}
	updateCallIntent(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			if (!b.membershipManager?.ownMembership) throw Error("Not connected yet");
			yield b.membershipManager?.updateCallIntent(e);
		})();
	}
	reemitEncryptionKeys() {
		var e;
		(e = this.encryptionManager) == null || e.getEncryptionKeys().forEach((e, b) => {
			e.forEach((e) => {
				this.emit(MatrixRTCSessionEvent.EncryptionKeyChanged, e.key, e.keyIndex, b);
			});
		});
	}
	setExpiryTimer() {
		this.expiryTimeout &&= (clearTimeout(this.expiryTimeout), void 0);
		var e;
		for (var b of this.memberships) {
			var x = b.getMsUntilExpiry();
			x !== void 0 && (e === void 0 || x < e) && (e = x);
		}
		e != null && (this.expiryTimeout = setTimeout(this.onRTCSessionMemberUpdate, e));
	}
	sendCallNotify(e, b, x) {
		var S = this, C = /* @__PURE__ */ function() {
			var e = _asyncToGenerator(function* () {
				var e = {
					application: "m.call",
					"m.mentions": {
						user_ids: [],
						room: !0
					},
					notify_type: b === "notification" ? "notify" : b,
					call_id: S.callId
				};
				return {
					response: yield S.client.sendEvent(S.roomSubset.roomId, EventType.CallNotify, e),
					content: e
				};
			});
			return function() {
				return e.apply(this, arguments);
			};
		}(), w = /* @__PURE__ */ function() {
			var C = _asyncToGenerator(function* () {
				var C = {
					"m.mentions": {
						user_ids: [],
						room: !0
					},
					notification_type: b,
					"m.relates_to": {
						event_id: e,
						rel_type: RelationType.Reference
					},
					sender_ts: Date.now(),
					lifetime: 3e4
				};
				return x && (C["m.call.intent"] = x), {
					response: yield S.client.sendEvent(S.roomSubset.roomId, EventType.RTCNotification, C),
					content: C
				};
			});
			return function() {
				return C.apply(this, arguments);
			};
		}();
		Promise.all([C(), w()]).then((e) => {
			var [b, x] = e, S = _objectSpread$4(_objectSpread$4({}, b.response), b.content), C = _objectSpread$4(_objectSpread$4({}, x.response), x.content);
			this.emit(MatrixRTCSessionEvent.DidSendCallNotification, C, S);
		}).catch((e) => {
			var [b, x] = e;
			return this.logger.error("Failed to send call notification", b, x);
		});
	}
}, MatrixRTCSessionManagerEvents = /* @__PURE__ */ function(e) {
	return e.SessionStarted = "session_started", e.SessionEnded = "session_ended", e;
}({}), MatrixRTCSessionManager = class extends TypedEventEmitter {
	constructor(e, b) {
		var x = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
			application: "m.call",
			id: ""
		};
		super(), this.client = b, this.slotDescription = x, _defineProperty(this, "roomSessions", /* @__PURE__ */ new Map()), _defineProperty(this, "logger", void 0), _defineProperty(this, "onRoom", (e) => {
			this.refreshRoom(e);
		}), _defineProperty(this, "onEvent", (e) => {
			if (e.unstableStickyExpiresAt && e.getType() === EventType.RTCMembership) {
				var b = this.client.getRoom(e.getRoomId());
				b && this.refreshRoom(b);
			}
		}), _defineProperty(this, "onRoomState", (e) => {
			if (e.getType() === EventType.GroupCallMemberPrefix) {
				var b = this.client.getRoom(e.getRoomId());
				if (!b) {
					this.logger.error(`Got room state event for unknown room ${e.getRoomId()}!`);
					return;
				}
				this.refreshRoom(b);
			}
		}), this.logger = e.getChild("[MatrixRTCSessionManager]");
	}
	start() {
		for (var e of (b = this.client.getRooms()) ?? []) {
			var b, x = MatrixRTCSession.sessionForRoom(this.client, e, this.slotDescription);
			x.memberships.length > 0 && this.roomSessions.set(e.roomId, x);
		}
		this.client.on(ClientEvent.Room, this.onRoom), this.client.on(ClientEvent.Event, this.onEvent), this.client.on(RoomStateEvent.Events, this.onRoomState);
	}
	stop() {
		for (var e of this.roomSessions.values()) e.stop();
		this.roomSessions.clear(), this.client.off(ClientEvent.Room, this.onRoom), this.client.off(ClientEvent.Event, this.onEvent), this.client.off(RoomStateEvent.Events, this.onRoomState);
	}
	getActiveRoomSession(e) {
		return this.roomSessions.get(e.roomId);
	}
	getRoomSession(e) {
		return this.roomSessions.has(e.roomId) || this.roomSessions.set(e.roomId, MatrixRTCSession.sessionForRoom(this.client, e, this.slotDescription)), this.roomSessions.get(e.roomId);
	}
	refreshRoom(e) {
		var b = !this.roomSessions.has(e.roomId), x = this.getRoomSession(e), S = x.memberships.length > 0 && !b;
		x.onRTCSessionMemberUpdate();
		var C = x.memberships.length > 0;
		S && !C ? (this.logger.trace(`Session ended for ${e.roomId} (${x.memberships.length} members)`), this.emit(MatrixRTCSessionManagerEvents.SessionEnded, e.roomId, this.roomSessions.get(e.roomId))) : !S && C && (this.logger.trace(`Session started for ${e.roomId} (${x.memberships.length} members)`), this.emit(MatrixRTCSessionManagerEvents.SessionStarted, e.roomId, this.roomSessions.get(e.roomId)));
	}
};
function getRelationsThreadFilter(e) {
	return (b) => {
		var x, S;
		return ((x = b.content) == null || (x = x["m.relates_to"]) == null ? void 0 : x.event_id) !== e || ((S = b.content) == null || (S = S["m.relates_to"]) == null ? void 0 : S.rel_type) === THREAD_RELATION_TYPE.name;
	};
}
function sha256(e) {
	return _sha.apply(this, arguments);
}
function _sha() {
	return _sha = _asyncToGenerator(function* (e) {
		if (!globalThis.crypto.subtle) throw Error("Crypto.subtle is not available: insecure context?");
		var b = new TextEncoder().encode(e), x = yield globalThis.crypto.subtle.digest("SHA-256", b);
		return new Uint8Array(x);
	}), _sha.apply(this, arguments);
}
var InvalidTokenError = class extends Error {};
InvalidTokenError.prototype.name = "InvalidTokenError";
function b64DecodeUnicode(e) {
	return decodeURIComponent(atob(e).replace(/(.)/g, (e, b) => {
		let x = b.charCodeAt(0).toString(16).toUpperCase();
		return x.length < 2 && (x = "0" + x), "%" + x;
	}));
}
function base64UrlDecode(e) {
	let b = e.replace(/-/g, "+").replace(/_/g, "/");
	switch (b.length % 4) {
		case 0: break;
		case 2:
			b += "==";
			break;
		case 3:
			b += "=";
			break;
		default: throw Error("base64 string is not of the correct length");
	}
	try {
		return b64DecodeUnicode(b);
	} catch {
		return atob(b);
	}
}
function jwtDecode(e, b) {
	if (typeof e != "string") throw new InvalidTokenError("Invalid token specified: must be a string");
	b ||= {};
	let x = b.header === !0 ? 0 : 1, S = e.split(".")[x];
	if (typeof S != "string") throw new InvalidTokenError(`Invalid token specified: missing part #${x + 1}`);
	let C;
	try {
		C = base64UrlDecode(S);
	} catch (e) {
		throw new InvalidTokenError(`Invalid token specified: invalid base64 for part #${x + 1} (${e.message})`);
	}
	try {
		return JSON.parse(C);
	} catch (e) {
		throw new InvalidTokenError(`Invalid token specified: invalid json for part #${x + 1} (${e.message})`);
	}
}
var nopLogger = {
	debug: () => void 0,
	info: () => void 0,
	warn: () => void 0,
	error: () => void 0
}, level, logger$1, Log = /* @__PURE__ */ ((e) => (e[e.NONE = 0] = "NONE", e[e.ERROR = 1] = "ERROR", e[e.WARN = 2] = "WARN", e[e.INFO = 3] = "INFO", e[e.DEBUG = 4] = "DEBUG", e))(Log || {});
((e) => {
	function b() {
		level = 3, logger$1 = nopLogger;
	}
	e.reset = b;
	function x(e) {
		if (!(0 <= e && e <= 4)) throw Error("Invalid log level");
		level = e;
	}
	e.setLevel = x;
	function S(e) {
		logger$1 = e;
	}
	e.setLogger = S;
})(Log ||= {});
var Logger = class e {
	constructor(e) {
		this._name = e;
	}
	debug(...b) {
		level >= 4 && logger$1.debug(e._format(this._name, this._method), ...b);
	}
	info(...b) {
		level >= 3 && logger$1.info(e._format(this._name, this._method), ...b);
	}
	warn(...b) {
		level >= 2 && logger$1.warn(e._format(this._name, this._method), ...b);
	}
	error(...b) {
		level >= 1 && logger$1.error(e._format(this._name, this._method), ...b);
	}
	throw(e) {
		throw this.error(e), e;
	}
	create(e) {
		let b = Object.create(this);
		return b._method = e, b.debug("begin"), b;
	}
	static createStatic(b, x) {
		let S = new e(`${b}.${x}`);
		return S.debug("begin"), S;
	}
	static _format(e, b) {
		let x = `[${e}]`;
		return b ? `${x} ${b}:` : x;
	}
	static debug(b, ...x) {
		level >= 4 && logger$1.debug(e._format(b), ...x);
	}
	static info(b, ...x) {
		level >= 3 && logger$1.info(e._format(b), ...x);
	}
	static warn(b, ...x) {
		level >= 2 && logger$1.warn(e._format(b), ...x);
	}
	static error(b, ...x) {
		level >= 1 && logger$1.error(e._format(b), ...x);
	}
};
Log.reset();
var JwtUtils = class {
	static decode(e) {
		try {
			return jwtDecode(e);
		} catch (e) {
			throw Logger.error("JwtUtils.decode", e), e;
		}
	}
	static async generateSignedJwt(e, b, x) {
		let S = CryptoUtils.encodeBase64Url(new TextEncoder().encode(JSON.stringify(e))), C = CryptoUtils.encodeBase64Url(new TextEncoder().encode(JSON.stringify(b))), w = `${S}.${C}`, T = await window.crypto.subtle.sign({
			name: "ECDSA",
			hash: { name: "SHA-256" }
		}, x, new TextEncoder().encode(w)), E = CryptoUtils.encodeBase64Url(new Uint8Array(T));
		return `${w}.${E}`;
	}
	static async generateSignedJwtWithHmac(e, b, x) {
		let S = CryptoUtils.encodeBase64Url(new TextEncoder().encode(JSON.stringify(e))), C = CryptoUtils.encodeBase64Url(new TextEncoder().encode(JSON.stringify(b))), w = `${S}.${C}`, T = await window.crypto.subtle.sign("HMAC", x, new TextEncoder().encode(w)), E = CryptoUtils.encodeBase64Url(new Uint8Array(T));
		return `${w}.${E}`;
	}
}, UUID_V4_TEMPLATE = "10000000-1000-4000-8000-100000000000", toBase64 = (e) => btoa([...new Uint8Array(e)].map((e) => String.fromCharCode(e)).join("")), _CryptoUtils = class e {
	static _randomWord() {
		let e = new Uint32Array(1);
		return crypto.getRandomValues(e), e[0];
	}
	static generateUUIDv4() {
		return UUID_V4_TEMPLATE.replace(/[018]/g, (b) => (b ^ e._randomWord() & 15 >> b / 4).toString(16)).replace(/-/g, "");
	}
	static generateCodeVerifier() {
		return e.generateUUIDv4() + e.generateUUIDv4() + e.generateUUIDv4();
	}
	static async generateCodeChallenge(e) {
		if (!crypto.subtle) throw Error("Crypto.subtle is available only in secure contexts (HTTPS).");
		try {
			let b = new TextEncoder().encode(e), x = await crypto.subtle.digest("SHA-256", b);
			return toBase64(x).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
		} catch (e) {
			throw Logger.error("CryptoUtils.generateCodeChallenge", e), e;
		}
	}
	static generateBasicAuth(e, b) {
		let x = new TextEncoder().encode([e, b].join(":"));
		return toBase64(x);
	}
	static async hash(e, b) {
		let x = new TextEncoder().encode(b), S = await crypto.subtle.digest(e, x);
		return new Uint8Array(S);
	}
	static async customCalculateJwkThumbprint(b) {
		let x;
		switch (b.kty) {
			case "RSA":
				x = {
					e: b.e,
					kty: b.kty,
					n: b.n
				};
				break;
			case "EC":
				x = {
					crv: b.crv,
					kty: b.kty,
					x: b.x,
					y: b.y
				};
				break;
			case "OKP":
				x = {
					crv: b.crv,
					kty: b.kty,
					x: b.x
				};
				break;
			case "oct":
				x = {
					crv: b.k,
					kty: b.kty
				};
				break;
			default: throw Error("Unknown jwk type");
		}
		let S = await e.hash("SHA-256", JSON.stringify(x));
		return e.encodeBase64Url(S);
	}
	static async generateDPoPProof({ url: b, accessToken: x, httpMethod: S, keyPair: C, nonce: w }) {
		let T, E, D = {
			jti: window.crypto.randomUUID(),
			htm: S ?? "GET",
			htu: b,
			iat: Math.floor(Date.now() / 1e3)
		};
		x && (T = await e.hash("SHA-256", x), E = e.encodeBase64Url(T), D.ath = E), w && (D.nonce = w);
		try {
			let e = await crypto.subtle.exportKey("jwk", C.publicKey), b = {
				alg: "ES256",
				typ: "dpop+jwt",
				jwk: {
					crv: e.crv,
					kty: e.kty,
					x: e.x,
					y: e.y
				}
			};
			return await JwtUtils.generateSignedJwt(b, D, C.privateKey);
		} catch (e) {
			throw e instanceof TypeError ? Error(`Error exporting dpop public key: ${e.message}`) : e;
		}
	}
	static async generateDPoPJkt(b) {
		try {
			let x = await crypto.subtle.exportKey("jwk", b.publicKey);
			return await e.customCalculateJwkThumbprint(x);
		} catch (e) {
			throw e instanceof TypeError ? Error(`Could not retrieve dpop keys from storage: ${e.message}`) : e;
		}
	}
	static async generateDPoPKeys() {
		return await window.crypto.subtle.generateKey({
			name: "ECDSA",
			namedCurve: "P-256"
		}, !1, ["sign", "verify"]);
	}
	static async generateClientAssertionJwt(b, x, S, C = "HS256") {
		let w = Math.floor(Date.now() / 1e3), T = {
			alg: C,
			typ: "JWT"
		}, E = {
			iss: b,
			sub: b,
			aud: S,
			jti: e.generateUUIDv4(),
			exp: w + 300,
			iat: w
		}, D = {
			HS256: "SHA-256",
			HS384: "SHA-384",
			HS512: "SHA-512"
		}[C];
		if (!D) throw Error(`Unsupported algorithm: ${C}. Supported algorithms are: HS256, HS384, HS512`);
		let O = new TextEncoder(), k = await crypto.subtle.importKey("raw", O.encode(x), {
			name: "HMAC",
			hash: D
		}, !1, ["sign"]);
		return await JwtUtils.generateSignedJwtWithHmac(T, E, k);
	}
};
_CryptoUtils.encodeBase64Url = (e) => toBase64(e).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
var CryptoUtils = _CryptoUtils, Event = class {
	constructor(e) {
		this._name = e, this._callbacks = [], this._logger = new Logger(`Event('${this._name}')`);
	}
	addHandler(e) {
		return this._callbacks.push(e), () => this.removeHandler(e);
	}
	removeHandler(e) {
		let b = this._callbacks.lastIndexOf(e);
		b >= 0 && this._callbacks.splice(b, 1);
	}
	async raise(...e) {
		this._logger.debug("raise:", ...e);
		for (let b of this._callbacks) await b(...e);
	}
}, Timer = class e extends Event {
	constructor() {
		super(...arguments), this._logger = new Logger(`Timer('${this._name}')`), this._timerHandle = null, this._expiration = 0, this._callback = () => {
			let b = this._expiration - e.getEpochTime();
			this._logger.debug("timer completes in", b), this._expiration <= e.getEpochTime() && (this.cancel(), super.raise());
		};
	}
	static getEpochTime() {
		return Math.floor(Date.now() / 1e3);
	}
	init(b) {
		let x = this._logger.create("init");
		b = Math.max(Math.floor(b), 1);
		let S = e.getEpochTime() + b;
		if (this.expiration === S && this._timerHandle) {
			x.debug("skipping since already initialized for expiration at", this.expiration);
			return;
		}
		this.cancel(), x.debug("using duration", b), this._expiration = S;
		let C = Math.min(b, 5);
		this._timerHandle = setInterval(this._callback, C * 1e3);
	}
	get expiration() {
		return this._expiration;
	}
	cancel() {
		this._logger.create("cancel"), this._timerHandle &&= (clearInterval(this._timerHandle), null);
	}
}, UrlUtils = class {
	static readParams(e, b = "query") {
		if (!e) throw TypeError("Invalid URL");
		let x = new URL(e, "http://127.0.0.1")[b === "fragment" ? "hash" : "search"];
		return new URLSearchParams(x.slice(1));
	}
}, URL_STATE_DELIMITER = ";", ErrorResponse = class extends Error {
	constructor(e, b) {
		if (super(e.error_description || e.error || ""), this.form = b, this.name = "ErrorResponse", !e.error) throw Logger.error("ErrorResponse", "No error passed"), Error("No error passed");
		this.error = e.error, this.error_description = e.error_description ?? null, this.error_uri = e.error_uri ?? null, this.state = e.userState, this.session_state = e.session_state ?? null, this.url_state = e.url_state;
	}
}, ErrorTimeout = class extends Error {
	constructor(e) {
		super(e), this.name = "ErrorTimeout";
	}
}, InMemoryWebStorage = class {
	constructor() {
		this._logger = new Logger("InMemoryWebStorage"), this._data = {};
	}
	clear() {
		this._logger.create("clear"), this._data = {};
	}
	getItem(e) {
		return this._logger.create(`getItem('${e}')`), this._data[e];
	}
	setItem(e, b) {
		this._logger.create(`setItem('${e}')`), this._data[e] = b;
	}
	removeItem(e) {
		this._logger.create(`removeItem('${e}')`), delete this._data[e];
	}
	get length() {
		return Object.getOwnPropertyNames(this._data).length;
	}
	key(e) {
		return Object.getOwnPropertyNames(this._data)[e];
	}
}, ErrorDPoPNonce = class extends Error {
	constructor(e, b) {
		super(b), this.name = "ErrorDPoPNonce", this.nonce = e;
	}
}, JsonService = class {
	constructor(e = [], b = null, x = {}) {
		this._jwtHandler = b, this._extraHeaders = x, this._logger = new Logger("JsonService"), this._contentTypes = [], this._contentTypes.push(...e, "application/json"), b && this._contentTypes.push("application/jwt");
	}
	async fetchWithTimeout(e, b = {}) {
		let { timeoutInSeconds: x,...S } = b;
		if (!x) return await fetch(e, S);
		let C = new AbortController(), w = setTimeout(() => C.abort(), x * 1e3);
		try {
			return await fetch(e, {
				...b,
				signal: C.signal
			});
		} catch (e) {
			throw e instanceof DOMException && e.name === "AbortError" ? new ErrorTimeout("Network timed out") : e;
		} finally {
			clearTimeout(w);
		}
	}
	async getJson(e, { token: b, credentials: x, timeoutInSeconds: S } = {}) {
		let C = this._logger.create("getJson"), w = { Accept: this._contentTypes.join(", ") };
		b && (C.debug("token passed, setting Authorization header"), w.Authorization = "Bearer " + b), this._appendExtraHeaders(w);
		let T;
		try {
			C.debug("url:", e), T = await this.fetchWithTimeout(e, {
				method: "GET",
				headers: w,
				timeoutInSeconds: S,
				credentials: x
			});
		} catch (e) {
			throw C.error("Network Error"), e;
		}
		C.debug("HTTP response received, status", T.status);
		let E = T.headers.get("Content-Type");
		if (E && !this._contentTypes.find((e) => E.startsWith(e)) && C.throw(/* @__PURE__ */ Error(`Invalid response Content-Type: ${E ?? "undefined"}, from URL: ${e}`)), T.ok && this._jwtHandler && E?.startsWith("application/jwt")) return await this._jwtHandler(await T.text());
		let D;
		try {
			D = await T.json();
		} catch (e) {
			throw C.error("Error parsing JSON response", e), T.ok ? e : Error(`${T.statusText} (${T.status})`);
		}
		if (!T.ok) throw C.error("Error from server:", D), D.error ? new ErrorResponse(D) : Error(`${T.statusText} (${T.status}): ${JSON.stringify(D)}`);
		return D;
	}
	async postForm(e, { body: b, basicAuth: x, timeoutInSeconds: S, initCredentials: C, extraHeaders: w }) {
		let T = this._logger.create("postForm"), E = {
			Accept: this._contentTypes.join(", "),
			"Content-Type": "application/x-www-form-urlencoded",
			...w
		};
		x !== void 0 && (E.Authorization = "Basic " + x), this._appendExtraHeaders(E);
		let D;
		try {
			T.debug("url:", e), D = await this.fetchWithTimeout(e, {
				method: "POST",
				headers: E,
				body: b,
				timeoutInSeconds: S,
				credentials: C
			});
		} catch (e) {
			throw T.error("Network error"), e;
		}
		T.debug("HTTP response received, status", D.status);
		let O = D.headers.get("Content-Type");
		if (O && !this._contentTypes.find((e) => O.startsWith(e))) throw Error(`Invalid response Content-Type: ${O ?? "undefined"}, from URL: ${e}`);
		let k = await D.text(), A = {};
		if (k) try {
			A = JSON.parse(k);
		} catch (e) {
			throw T.error("Error parsing JSON response", e), D.ok ? e : Error(`${D.statusText} (${D.status})`);
		}
		if (!D.ok) {
			if (T.error("Error from server:", A), D.headers.has("dpop-nonce")) {
				let e = D.headers.get("dpop-nonce");
				throw new ErrorDPoPNonce(e, `${JSON.stringify(A)}`);
			}
			throw A.error ? new ErrorResponse(A, b) : Error(`${D.statusText} (${D.status}): ${JSON.stringify(A)}`);
		}
		return A;
	}
	_appendExtraHeaders(e) {
		let b = this._logger.create("appendExtraHeaders"), x = Object.keys(this._extraHeaders), S = ["accept", "content-type"], C = ["authorization"];
		x.length !== 0 && x.forEach((x) => {
			if (S.includes(x.toLocaleLowerCase())) {
				b.warn("Protected header could not be set", x, S);
				return;
			}
			if (C.includes(x.toLocaleLowerCase()) && Object.keys(e).includes(x)) {
				b.warn("Header could not be overridden", x, C);
				return;
			}
			let w = typeof this._extraHeaders[x] == "function" ? this._extraHeaders[x]() : this._extraHeaders[x];
			w && w !== "" && (e[x] = w);
		});
	}
}, MetadataService = class {
	constructor(e) {
		this._settings = e, this._logger = new Logger("MetadataService"), this._signingKeys = null, this._metadata = null, this._metadataUrl = this._settings.metadataUrl, this._jsonService = new JsonService(["application/jwk-set+json"], null, this._settings.extraHeaders), this._settings.signingKeys && (this._logger.debug("using signingKeys from settings"), this._signingKeys = this._settings.signingKeys), this._settings.metadata && (this._logger.debug("using metadata from settings"), this._metadata = this._settings.metadata), this._settings.fetchRequestCredentials && (this._logger.debug("using fetchRequestCredentials from settings"), this._fetchRequestCredentials = this._settings.fetchRequestCredentials);
	}
	resetSigningKeys() {
		this._signingKeys = null;
	}
	async getMetadata() {
		let e = this._logger.create("getMetadata");
		if (this._metadata) return e.debug("using cached values"), this._metadata;
		if (!this._metadataUrl) throw e.throw(/* @__PURE__ */ Error("No authority or metadataUrl configured on settings")), null;
		e.debug("getting metadata from", this._metadataUrl);
		let b = await this._jsonService.getJson(this._metadataUrl, {
			credentials: this._fetchRequestCredentials,
			timeoutInSeconds: this._settings.requestTimeoutInSeconds
		});
		return e.debug("merging remote JSON with seed metadata"), this._metadata = Object.assign({}, b, this._settings.metadataSeed), this._metadata;
	}
	getIssuer() {
		return this._getMetadataProperty("issuer");
	}
	getAuthorizationEndpoint() {
		return this._getMetadataProperty("authorization_endpoint");
	}
	getUserInfoEndpoint() {
		return this._getMetadataProperty("userinfo_endpoint");
	}
	getTokenEndpoint(e = !0) {
		return this._getMetadataProperty("token_endpoint", e);
	}
	getCheckSessionIframe() {
		return this._getMetadataProperty("check_session_iframe", !0);
	}
	getEndSessionEndpoint() {
		return this._getMetadataProperty("end_session_endpoint", !0);
	}
	getRevocationEndpoint(e = !0) {
		return this._getMetadataProperty("revocation_endpoint", e);
	}
	getKeysEndpoint(e = !0) {
		return this._getMetadataProperty("jwks_uri", e);
	}
	async _getMetadataProperty(e, b = !1) {
		let x = this._logger.create(`_getMetadataProperty('${e}')`), S = await this.getMetadata();
		if (x.debug("resolved"), S[e] === void 0) {
			if (b === !0) {
				x.warn("Metadata does not contain optional property");
				return;
			}
			x.throw(/* @__PURE__ */ Error("Metadata does not contain property " + e));
		}
		return S[e];
	}
	async getSigningKeys() {
		let e = this._logger.create("getSigningKeys");
		if (this._signingKeys) return e.debug("returning signingKeys from cache"), this._signingKeys;
		let b = await this.getKeysEndpoint(!1);
		e.debug("got jwks_uri", b);
		let x = await this._jsonService.getJson(b, { timeoutInSeconds: this._settings.requestTimeoutInSeconds });
		if (e.debug("got key set", x), !Array.isArray(x.keys)) throw e.throw(/* @__PURE__ */ Error("Missing keys on keyset")), null;
		return this._signingKeys = x.keys, this._signingKeys;
	}
}, WebStorageStateStore = class {
	constructor({ prefix: e = "oidc.", store: b = localStorage } = {}) {
		this._logger = new Logger("WebStorageStateStore"), this._store = b, this._prefix = e;
	}
	async set(e, b) {
		this._logger.create(`set('${e}')`), e = this._prefix + e, await this._store.setItem(e, b);
	}
	async get(e) {
		return this._logger.create(`get('${e}')`), e = this._prefix + e, await this._store.getItem(e);
	}
	async remove(e) {
		this._logger.create(`remove('${e}')`), e = this._prefix + e;
		let b = await this._store.getItem(e);
		return await this._store.removeItem(e), b;
	}
	async getAllKeys() {
		this._logger.create("getAllKeys");
		let e = await this._store.length, b = [];
		for (let x = 0; x < e; x++) {
			let e = await this._store.key(x);
			e && e.indexOf(this._prefix) === 0 && b.push(e.substr(this._prefix.length));
		}
		return b;
	}
}, DefaultResponseType = "code", DefaultScope = "openid", DefaultClientAuthentication = "client_secret_post", DefaultStaleStateAgeInSeconds = 900, OidcClientSettingsStore = class {
	constructor({ authority: e, metadataUrl: b, metadata: x, signingKeys: S, metadataSeed: C, client_id: w, client_secret: T, response_type: E = DefaultResponseType, scope: D = DefaultScope, redirect_uri: O, post_logout_redirect_uri: k, client_authentication: A = DefaultClientAuthentication, token_endpoint_auth_signing_alg: j = "HS256", prompt: M, display: N, max_age: P, ui_locales: F, acr_values: I, resource: L, response_mode: R, filterProtocolClaims: z = !0, loadUserInfo: B = !1, requestTimeoutInSeconds: V, staleStateAgeInSeconds: H = DefaultStaleStateAgeInSeconds, mergeClaimsStrategy: U = { array: "replace" }, disablePKCE: W = !1, stateStore: G, revokeTokenAdditionalContentTypes: K, fetchRequestCredentials: q, refreshTokenAllowedScope: J, extraQueryParams: Y = {}, extraTokenParams: X = {}, extraHeaders: Z = {}, dpop: Q, omitScopeWhenRequesting: $ = !1 }) {
		if (this.authority = e, b ? this.metadataUrl = b : (this.metadataUrl = e, e && (this.metadataUrl.endsWith("/") || (this.metadataUrl += "/"), this.metadataUrl += ".well-known/openid-configuration")), this.metadata = x, this.metadataSeed = C, this.signingKeys = S, this.client_id = w, this.client_secret = T, this.response_type = E, this.scope = D, this.redirect_uri = O, this.post_logout_redirect_uri = k, this.client_authentication = A, this.token_endpoint_auth_signing_alg = j, this.prompt = M, this.display = N, this.max_age = P, this.ui_locales = F, this.acr_values = I, this.resource = L, this.response_mode = R, this.filterProtocolClaims = z ?? !0, this.loadUserInfo = !!B, this.staleStateAgeInSeconds = H, this.mergeClaimsStrategy = U, this.omitScopeWhenRequesting = $, this.disablePKCE = !!W, this.revokeTokenAdditionalContentTypes = K, this.fetchRequestCredentials = q || "same-origin", this.requestTimeoutInSeconds = V, G) this.stateStore = G;
		else {
			let e = typeof window < "u" ? window.localStorage : new InMemoryWebStorage();
			this.stateStore = new WebStorageStateStore({ store: e });
		}
		if (this.refreshTokenAllowedScope = J, this.extraQueryParams = Y, this.extraTokenParams = X, this.extraHeaders = Z, this.dpop = Q, this.dpop && !this.dpop?.store) throw Error("A DPoPStore is required when dpop is enabled");
	}
}, UserInfoService = class {
	constructor(e, b) {
		this._settings = e, this._metadataService = b, this._logger = new Logger("UserInfoService"), this._getClaimsFromJwt = async (e) => {
			let b = this._logger.create("_getClaimsFromJwt");
			try {
				let x = JwtUtils.decode(e);
				return b.debug("JWT decoding successful"), x;
			} catch (e) {
				throw b.error("Error parsing JWT response"), e;
			}
		}, this._jsonService = new JsonService(void 0, this._getClaimsFromJwt, this._settings.extraHeaders);
	}
	async getClaims(e) {
		let b = this._logger.create("getClaims");
		e || this._logger.throw(/* @__PURE__ */ Error("No token passed"));
		let x = await this._metadataService.getUserInfoEndpoint();
		b.debug("got userinfo url", x);
		let S = await this._jsonService.getJson(x, {
			token: e,
			credentials: this._settings.fetchRequestCredentials,
			timeoutInSeconds: this._settings.requestTimeoutInSeconds
		});
		return b.debug("got claims", S), S;
	}
}, TokenClient = class {
	constructor(e, b) {
		this._settings = e, this._metadataService = b, this._logger = new Logger("TokenClient"), this._jsonService = new JsonService(this._settings.revokeTokenAdditionalContentTypes, null, this._settings.extraHeaders);
	}
	async exchangeCode({ grant_type: e = "authorization_code", redirect_uri: b = this._settings.redirect_uri, client_id: x = this._settings.client_id, client_secret: S = this._settings.client_secret, extraHeaders: C,...w }) {
		let T = this._logger.create("exchangeCode");
		x || T.throw(/* @__PURE__ */ Error("A client_id is required")), b || T.throw(/* @__PURE__ */ Error("A redirect_uri is required")), w.code || T.throw(/* @__PURE__ */ Error("A code is required"));
		let E = new URLSearchParams({
			grant_type: e,
			redirect_uri: b
		});
		for (let [e, b] of Object.entries(w)) b != null && E.set(e, b);
		if ((this._settings.client_authentication === "client_secret_basic" || this._settings.client_authentication === "client_secret_jwt") && S == null) throw T.throw(/* @__PURE__ */ Error("A client_secret is required")), null;
		let D, O = await this._metadataService.getTokenEndpoint(!1);
		switch (this._settings.client_authentication) {
			case "client_secret_basic":
				D = CryptoUtils.generateBasicAuth(x, S);
				break;
			case "client_secret_post":
				E.append("client_id", x), S && E.append("client_secret", S);
				break;
			case "client_secret_jwt": {
				let e = await CryptoUtils.generateClientAssertionJwt(x, S, O, this._settings.token_endpoint_auth_signing_alg);
				E.append("client_id", x), E.append("client_assertion_type", "urn:ietf:params:oauth:client-assertion-type:jwt-bearer"), E.append("client_assertion", e);
				break;
			}
		}
		T.debug("got token endpoint");
		let k = await this._jsonService.postForm(O, {
			body: E,
			basicAuth: D,
			timeoutInSeconds: this._settings.requestTimeoutInSeconds,
			initCredentials: this._settings.fetchRequestCredentials,
			extraHeaders: C
		});
		return T.debug("got response"), k;
	}
	async exchangeCredentials({ grant_type: e = "password", client_id: b = this._settings.client_id, client_secret: x = this._settings.client_secret, scope: S = this._settings.scope,...C }) {
		let w = this._logger.create("exchangeCredentials");
		b || w.throw(/* @__PURE__ */ Error("A client_id is required"));
		let T = new URLSearchParams({ grant_type: e });
		this._settings.omitScopeWhenRequesting || T.set("scope", S);
		for (let [e, b] of Object.entries(C)) b != null && T.set(e, b);
		if ((this._settings.client_authentication === "client_secret_basic" || this._settings.client_authentication === "client_secret_jwt") && x == null) throw w.throw(/* @__PURE__ */ Error("A client_secret is required")), null;
		let E, D = await this._metadataService.getTokenEndpoint(!1);
		switch (this._settings.client_authentication) {
			case "client_secret_basic":
				E = CryptoUtils.generateBasicAuth(b, x);
				break;
			case "client_secret_post":
				T.append("client_id", b), x && T.append("client_secret", x);
				break;
			case "client_secret_jwt": {
				let e = await CryptoUtils.generateClientAssertionJwt(b, x, D, this._settings.token_endpoint_auth_signing_alg);
				T.append("client_id", b), T.append("client_assertion_type", "urn:ietf:params:oauth:client-assertion-type:jwt-bearer"), T.append("client_assertion", e);
				break;
			}
		}
		w.debug("got token endpoint");
		let O = await this._jsonService.postForm(D, {
			body: T,
			basicAuth: E,
			timeoutInSeconds: this._settings.requestTimeoutInSeconds,
			initCredentials: this._settings.fetchRequestCredentials
		});
		return w.debug("got response"), O;
	}
	async exchangeRefreshToken({ grant_type: e = "refresh_token", client_id: b = this._settings.client_id, client_secret: x = this._settings.client_secret, timeoutInSeconds: S, extraHeaders: C,...w }) {
		let T = this._logger.create("exchangeRefreshToken");
		b || T.throw(/* @__PURE__ */ Error("A client_id is required")), w.refresh_token || T.throw(/* @__PURE__ */ Error("A refresh_token is required"));
		let E = new URLSearchParams({ grant_type: e });
		for (let [e, b] of Object.entries(w)) Array.isArray(b) ? b.forEach((b) => E.append(e, b)) : b != null && E.set(e, b);
		if ((this._settings.client_authentication === "client_secret_basic" || this._settings.client_authentication === "client_secret_jwt") && x == null) throw T.throw(/* @__PURE__ */ Error("A client_secret is required")), null;
		let D, O = await this._metadataService.getTokenEndpoint(!1);
		switch (this._settings.client_authentication) {
			case "client_secret_basic":
				D = CryptoUtils.generateBasicAuth(b, x);
				break;
			case "client_secret_post":
				E.append("client_id", b), x && E.append("client_secret", x);
				break;
			case "client_secret_jwt": {
				let e = await CryptoUtils.generateClientAssertionJwt(b, x, O, this._settings.token_endpoint_auth_signing_alg);
				E.append("client_id", b), E.append("client_assertion_type", "urn:ietf:params:oauth:client-assertion-type:jwt-bearer"), E.append("client_assertion", e);
				break;
			}
		}
		T.debug("got token endpoint");
		let k = await this._jsonService.postForm(O, {
			body: E,
			basicAuth: D,
			timeoutInSeconds: S,
			initCredentials: this._settings.fetchRequestCredentials,
			extraHeaders: C
		});
		return T.debug("got response"), k;
	}
	async revoke(e) {
		let b = this._logger.create("revoke");
		e.token || b.throw(/* @__PURE__ */ Error("A token is required"));
		let x = await this._metadataService.getRevocationEndpoint(!1);
		b.debug(`got revocation endpoint, revoking ${e.token_type_hint ?? "default token type"}`);
		let S = new URLSearchParams();
		for (let [b, x] of Object.entries(e)) x != null && S.set(b, x);
		S.set("client_id", this._settings.client_id), this._settings.client_secret && S.set("client_secret", this._settings.client_secret), await this._jsonService.postForm(x, {
			body: S,
			timeoutInSeconds: this._settings.requestTimeoutInSeconds
		}), b.debug("got response");
	}
}, ResponseValidator = class {
	constructor(e, b, x) {
		this._settings = e, this._metadataService = b, this._claimsService = x, this._logger = new Logger("ResponseValidator"), this._userInfoService = new UserInfoService(this._settings, this._metadataService), this._tokenClient = new TokenClient(this._settings, this._metadataService);
	}
	async validateSigninResponse(e, b, x) {
		let S = this._logger.create("validateSigninResponse");
		this._processSigninState(e, b), S.debug("state processed"), await this._processCode(e, b, x), S.debug("code processed"), e.isOpenId && this._validateIdTokenAttributes(e, "", b.nonce), S.debug("tokens validated"), await this._processClaims(e, b?.skipUserInfo, e.isOpenId), S.debug("claims processed");
	}
	async validateCredentialsResponse(e, b) {
		let x = this._logger.create("validateCredentialsResponse"), S = e.isOpenId && !!e.id_token;
		S && this._validateIdTokenAttributes(e), x.debug("tokens validated"), await this._processClaims(e, b, S), x.debug("claims processed");
	}
	async validateRefreshResponse(e, b) {
		let x = this._logger.create("validateRefreshResponse");
		e.userState = b.data, e.session_state ??= b.session_state, e.scope ??= b.scope, e.isOpenId && e.id_token && (this._validateIdTokenAttributes(e, b.id_token), x.debug("ID Token validated")), e.id_token || (e.id_token = b.id_token, e.profile = b.profile);
		let S = e.isOpenId && !!e.id_token;
		await this._processClaims(e, !1, S), x.debug("claims processed");
	}
	validateSignoutResponse(e, b) {
		let x = this._logger.create("validateSignoutResponse");
		if (b.id !== e.state && x.throw(/* @__PURE__ */ Error("State does not match")), x.debug("state validated"), e.userState = b.data, e.error) throw x.warn("Response was error", e.error), new ErrorResponse(e);
	}
	_processSigninState(e, b) {
		let x = this._logger.create("_processSigninState");
		if (b.id !== e.state && x.throw(/* @__PURE__ */ Error("State does not match")), b.client_id || x.throw(/* @__PURE__ */ Error("No client_id on state")), b.authority || x.throw(/* @__PURE__ */ Error("No authority on state")), this._settings.authority !== b.authority && x.throw(/* @__PURE__ */ Error("authority mismatch on settings vs. signin state")), this._settings.client_id && this._settings.client_id !== b.client_id && x.throw(/* @__PURE__ */ Error("client_id mismatch on settings vs. signin state")), x.debug("state validated"), e.userState = b.data, e.url_state = b.url_state, e.scope ??= b.scope, e.error) throw x.warn("Response was error", e.error), new ErrorResponse(e);
		b.code_verifier && !e.code && x.throw(/* @__PURE__ */ Error("Expected code in response"));
	}
	async _processClaims(e, b = !1, x = !0) {
		let S = this._logger.create("_processClaims");
		if (e.profile = this._claimsService.filterProtocolClaims(e.profile), b || !this._settings.loadUserInfo || !e.access_token) {
			S.debug("not loading user info");
			return;
		}
		S.debug("loading user info");
		let C = await this._userInfoService.getClaims(e.access_token);
		S.debug("user info claims received from user info endpoint"), x && C.sub !== e.profile.sub && S.throw(/* @__PURE__ */ Error("subject from UserInfo response does not match subject in ID Token")), e.profile = this._claimsService.mergeClaims(e.profile, this._claimsService.filterProtocolClaims(C)), S.debug("user info claims received, updated profile:", e.profile);
	}
	async _processCode(e, b, x) {
		let S = this._logger.create("_processCode");
		if (e.code) {
			S.debug("Validating code");
			let C = await this._tokenClient.exchangeCode({
				client_id: b.client_id,
				client_secret: b.client_secret,
				code: e.code,
				redirect_uri: b.redirect_uri,
				code_verifier: b.code_verifier,
				extraHeaders: x,
				...b.extraTokenParams
			});
			Object.assign(e, C);
		} else S.debug("No code to process");
	}
	_validateIdTokenAttributes(e, b, x) {
		let S = this._logger.create("_validateIdTokenAttributes");
		S.debug("decoding ID Token JWT");
		let C = JwtUtils.decode(e.id_token ?? "");
		if (C.sub || S.throw(/* @__PURE__ */ Error("ID Token is missing a subject claim")), x && C.nonce !== x && S.throw(/* @__PURE__ */ Error("nonce in id_token does not match nonce in client storage")), b) {
			let e = JwtUtils.decode(b);
			C.sub !== e.sub && S.throw(/* @__PURE__ */ Error("sub in id_token does not match current sub")), C.auth_time && C.auth_time !== e.auth_time && S.throw(/* @__PURE__ */ Error("auth_time in id_token does not match original auth_time")), C.azp && C.azp !== e.azp && S.throw(/* @__PURE__ */ Error("azp in id_token does not match original azp")), !C.azp && e.azp && S.throw(/* @__PURE__ */ Error("azp not in id_token, but present in original id_token"));
		}
		e.profile = C;
	}
}, State = class e {
	constructor(e) {
		this.id = e.id || CryptoUtils.generateUUIDv4(), this.data = e.data, e.created && e.created > 0 ? this.created = e.created : this.created = Timer.getEpochTime(), this.request_type = e.request_type, this.url_state = e.url_state;
	}
	toStorageString() {
		return new Logger("State").create("toStorageString"), JSON.stringify({
			id: this.id,
			data: this.data,
			created: this.created,
			request_type: this.request_type,
			url_state: this.url_state
		});
	}
	static fromStorageString(b) {
		return Logger.createStatic("State", "fromStorageString"), Promise.resolve(new e(JSON.parse(b)));
	}
	static async clearStaleState(b, x) {
		let S = Logger.createStatic("State", "clearStaleState"), C = Timer.getEpochTime() - x, w = await b.getAllKeys();
		S.debug("got keys", w);
		for (let x = 0; x < w.length; x++) {
			let T = w[x], E = await b.get(T), D = !1;
			if (E) try {
				let b = await e.fromStorageString(E);
				S.debug("got item from key:", T, b.created), b.created <= C && (D = !0);
			} catch (e) {
				S.error("Error parsing state for key:", T, e), D = !0;
			}
			else S.debug("no item in storage for key:", T), D = !0;
			D && (S.debug("removed item for key:", T), b.remove(T));
		}
	}
}, SigninState = class e extends State {
	constructor(e) {
		super(e), this.code_verifier = e.code_verifier, this.code_challenge = e.code_challenge, this.authority = e.authority, this.client_id = e.client_id, this.redirect_uri = e.redirect_uri, this.scope = e.scope, this.client_secret = e.client_secret, this.extraTokenParams = e.extraTokenParams, this.response_mode = e.response_mode, this.skipUserInfo = e.skipUserInfo, this.nonce = e.nonce;
	}
	static async create(b) {
		let x = b.code_verifier === !0 ? CryptoUtils.generateCodeVerifier() : b.code_verifier || void 0, S = x ? await CryptoUtils.generateCodeChallenge(x) : void 0;
		return new e({
			...b,
			code_verifier: x,
			code_challenge: S
		});
	}
	toStorageString() {
		return new Logger("SigninState").create("toStorageString"), JSON.stringify({
			id: this.id,
			data: this.data,
			created: this.created,
			request_type: this.request_type,
			url_state: this.url_state,
			code_verifier: this.code_verifier,
			authority: this.authority,
			client_id: this.client_id,
			redirect_uri: this.redirect_uri,
			scope: this.scope,
			client_secret: this.client_secret,
			extraTokenParams: this.extraTokenParams,
			response_mode: this.response_mode,
			skipUserInfo: this.skipUserInfo,
			nonce: this.nonce
		});
	}
	static fromStorageString(b) {
		Logger.createStatic("SigninState", "fromStorageString");
		let x = JSON.parse(b);
		return e.create(x);
	}
}, _SigninRequest = class e {
	constructor(e) {
		this.url = e.url, this.state = e.state;
	}
	static async create({ url: b, authority: x, client_id: S, redirect_uri: C, response_type: w, scope: T, state_data: E, response_mode: D, request_type: O, client_secret: k, nonce: A, url_state: j, resource: M, skipUserInfo: N, extraQueryParams: P, extraTokenParams: F, disablePKCE: I, dpopJkt: L, omitScopeWhenRequesting: R,...z }) {
		if (!b) throw this._logger.error("create: No url passed"), Error("url");
		if (!S) throw this._logger.error("create: No client_id passed"), Error("client_id");
		if (!C) throw this._logger.error("create: No redirect_uri passed"), Error("redirect_uri");
		if (!w) throw this._logger.error("create: No response_type passed"), Error("response_type");
		if (!T) throw this._logger.error("create: No scope passed"), Error("scope");
		if (!x) throw this._logger.error("create: No authority passed"), Error("authority");
		let B = await SigninState.create({
			data: E,
			request_type: O,
			url_state: j,
			code_verifier: !I,
			client_id: S,
			authority: x,
			redirect_uri: C,
			response_mode: D,
			client_secret: k,
			scope: T,
			extraTokenParams: F,
			skipUserInfo: N,
			nonce: A
		}), V = new URL(b);
		V.searchParams.append("client_id", S), V.searchParams.append("redirect_uri", C), V.searchParams.append("response_type", w), R || V.searchParams.append("scope", T), A && V.searchParams.append("nonce", A), L && V.searchParams.append("dpop_jkt", L);
		let H = B.id;
		j && (H = `${H}${URL_STATE_DELIMITER}${j}`), V.searchParams.append("state", H), B.code_challenge && (V.searchParams.append("code_challenge", B.code_challenge), V.searchParams.append("code_challenge_method", "S256")), M && (Array.isArray(M) ? M : [M]).forEach((e) => V.searchParams.append("resource", e));
		for (let [e, b] of Object.entries({
			response_mode: D,
			...z,
			...P
		})) b != null && V.searchParams.append(e, b.toString());
		return new e({
			url: V.href,
			state: B
		});
	}
};
_SigninRequest._logger = new Logger("SigninRequest");
var SigninRequest = _SigninRequest, OidcScope = "openid", SigninResponse = class {
	constructor(e) {
		if (this.access_token = "", this.token_type = "", this.profile = {}, this.state = e.get("state"), this.session_state = e.get("session_state"), this.state) {
			let e = decodeURIComponent(this.state).split(URL_STATE_DELIMITER);
			this.state = e[0], e.length > 1 && (this.url_state = e.slice(1).join(URL_STATE_DELIMITER));
		}
		this.error = e.get("error"), this.error_description = e.get("error_description"), this.error_uri = e.get("error_uri"), this.code = e.get("code");
	}
	get expires_in() {
		if (this.expires_at !== void 0) return this.expires_at - Timer.getEpochTime();
	}
	set expires_in(e) {
		typeof e == "string" && (e = Number(e)), e !== void 0 && e >= 0 && (this.expires_at = Math.floor(e) + Timer.getEpochTime());
	}
	get isOpenId() {
		return this.scope?.split(" ").includes(OidcScope) || !!this.id_token;
	}
}, SignoutRequest = class {
	constructor({ url: e, state_data: b, id_token_hint: x, post_logout_redirect_uri: S, extraQueryParams: C, request_type: w, client_id: T, url_state: E }) {
		if (this._logger = new Logger("SignoutRequest"), !e) throw this._logger.error("ctor: No url passed"), Error("url");
		let D = new URL(e);
		if (x && D.searchParams.append("id_token_hint", x), T && D.searchParams.append("client_id", T), S && (D.searchParams.append("post_logout_redirect_uri", S), b || E)) {
			this.state = new State({
				data: b,
				request_type: w,
				url_state: E
			});
			let e = this.state.id;
			E && (e = `${e}${URL_STATE_DELIMITER}${E}`), D.searchParams.append("state", e);
		}
		for (let [e, b] of Object.entries({ ...C })) b != null && D.searchParams.append(e, b.toString());
		this.url = D.href;
	}
}, SignoutResponse = class {
	constructor(e) {
		if (this.state = e.get("state"), this.state) {
			let e = decodeURIComponent(this.state).split(URL_STATE_DELIMITER);
			this.state = e[0], e.length > 1 && (this.url_state = e.slice(1).join(URL_STATE_DELIMITER));
		}
		this.error = e.get("error"), this.error_description = e.get("error_description"), this.error_uri = e.get("error_uri");
	}
}, DefaultProtocolClaims = [
	"nbf",
	"jti",
	"auth_time",
	"nonce",
	"acr",
	"amr",
	"azp",
	"at_hash"
], InternalRequiredProtocolClaims = [
	"sub",
	"iss",
	"aud",
	"exp",
	"iat"
], ClaimsService = class {
	constructor(e) {
		this._settings = e, this._logger = new Logger("ClaimsService");
	}
	filterProtocolClaims(e) {
		let b = { ...e };
		if (this._settings.filterProtocolClaims) {
			let e;
			e = Array.isArray(this._settings.filterProtocolClaims) ? this._settings.filterProtocolClaims : DefaultProtocolClaims;
			for (let x of e) InternalRequiredProtocolClaims.includes(x) || delete b[x];
		}
		return b;
	}
	mergeClaims(e, b) {
		let x = { ...e };
		for (let [e, S] of Object.entries(b)) if (x[e] !== S) if (Array.isArray(x[e]) || Array.isArray(S)) if (this._settings.mergeClaimsStrategy.array == "replace") x[e] = S;
		else {
			let b = Array.isArray(x[e]) ? x[e] : [x[e]];
			for (let e of Array.isArray(S) ? S : [S]) b.includes(e) || b.push(e);
			x[e] = b;
		}
		else typeof x[e] == "object" && typeof S == "object" ? x[e] = this.mergeClaims(x[e], S) : x[e] = S;
		return x;
	}
}, DPoPState = class {
	constructor(e, b) {
		this.keys = e, this.nonce = b;
	}
}, OidcClient = class {
	constructor(e, b) {
		this._logger = new Logger("OidcClient"), this.settings = e instanceof OidcClientSettingsStore ? e : new OidcClientSettingsStore(e), this.metadataService = b ?? new MetadataService(this.settings), this._claimsService = new ClaimsService(this.settings), this._validator = new ResponseValidator(this.settings, this.metadataService, this._claimsService), this._tokenClient = new TokenClient(this.settings, this.metadataService);
	}
	async createSigninRequest({ state: e, request: b, request_uri: x, request_type: S, id_token_hint: C, login_hint: w, skipUserInfo: T, nonce: E, url_state: D, response_type: O = this.settings.response_type, scope: k = this.settings.scope, redirect_uri: A = this.settings.redirect_uri, prompt: j = this.settings.prompt, display: M = this.settings.display, max_age: N = this.settings.max_age, ui_locales: P = this.settings.ui_locales, acr_values: F = this.settings.acr_values, resource: I = this.settings.resource, response_mode: L = this.settings.response_mode, extraQueryParams: R = this.settings.extraQueryParams, extraTokenParams: z = this.settings.extraTokenParams, dpopJkt: B, omitScopeWhenRequesting: V = this.settings.omitScopeWhenRequesting }) {
		let H = this._logger.create("createSigninRequest");
		if (O !== "code") throw Error("Only the Authorization Code flow (with PKCE) is supported");
		let U = await this.metadataService.getAuthorizationEndpoint();
		H.debug("Received authorization endpoint", U);
		let W = await SigninRequest.create({
			url: U,
			authority: this.settings.authority,
			client_id: this.settings.client_id,
			redirect_uri: A,
			response_type: O,
			scope: k,
			state_data: e,
			url_state: D,
			prompt: j,
			display: M,
			max_age: N,
			ui_locales: P,
			id_token_hint: C,
			login_hint: w,
			acr_values: F,
			dpopJkt: B,
			resource: I,
			request: b,
			request_uri: x,
			extraQueryParams: R,
			extraTokenParams: z,
			request_type: S,
			response_mode: L,
			client_secret: this.settings.client_secret,
			skipUserInfo: T,
			nonce: E,
			disablePKCE: this.settings.disablePKCE,
			omitScopeWhenRequesting: V
		});
		await this.clearStaleState();
		let G = W.state;
		return await this.settings.stateStore.set(G.id, G.toStorageString()), W;
	}
	async readSigninResponseState(e, b = !1) {
		let x = this._logger.create("readSigninResponseState"), S = new SigninResponse(UrlUtils.readParams(e, this.settings.response_mode));
		if (!S.state) throw x.throw(/* @__PURE__ */ Error("No state in response")), null;
		let C = await this.settings.stateStore[b ? "remove" : "get"](S.state);
		if (!C) throw x.throw(/* @__PURE__ */ Error("No matching state found in storage")), null;
		return {
			state: await SigninState.fromStorageString(C),
			response: S
		};
	}
	async processSigninResponse(e, b, x = !0) {
		let S = this._logger.create("processSigninResponse"), { state: C, response: w } = await this.readSigninResponseState(e, x);
		if (S.debug("received state from storage; validating response"), this.settings.dpop && this.settings.dpop.store) {
			let e = await this.getDpopProof(this.settings.dpop.store);
			b = {
				...b,
				DPoP: e
			};
		}
		try {
			await this._validator.validateSigninResponse(w, C, b);
		} catch (e) {
			if (e instanceof ErrorDPoPNonce && this.settings.dpop) b.DPoP = await this.getDpopProof(this.settings.dpop.store, e.nonce), await this._validator.validateSigninResponse(w, C, b);
			else throw e;
		}
		return w;
	}
	async getDpopProof(e, b) {
		let x, S;
		return (await e.getAllKeys()).includes(this.settings.client_id) ? (S = await e.get(this.settings.client_id), S.nonce !== b && b && (S.nonce = b, await e.set(this.settings.client_id, S))) : (x = await CryptoUtils.generateDPoPKeys(), S = new DPoPState(x, b), await e.set(this.settings.client_id, S)), await CryptoUtils.generateDPoPProof({
			url: await this.metadataService.getTokenEndpoint(!1),
			httpMethod: "POST",
			keyPair: S.keys,
			nonce: S.nonce
		});
	}
	async processResourceOwnerPasswordCredentials({ username: e, password: b, skipUserInfo: x = !1, extraTokenParams: S = {} }) {
		let C = await this._tokenClient.exchangeCredentials({
			username: e,
			password: b,
			...S
		}), w = new SigninResponse(new URLSearchParams());
		return Object.assign(w, C), await this._validator.validateCredentialsResponse(w, x), w;
	}
	async useRefreshToken({ state: e, redirect_uri: b, resource: x, timeoutInSeconds: S, extraHeaders: C, extraTokenParams: w }) {
		let T = this._logger.create("useRefreshToken"), E;
		if (this.settings.refreshTokenAllowedScope === void 0) E = e.scope;
		else {
			let b = this.settings.refreshTokenAllowedScope.split(" ");
			E = (e.scope?.split(" ") || []).filter((e) => b.includes(e)).join(" ");
		}
		if (this.settings.dpop && this.settings.dpop.store) {
			let e = await this.getDpopProof(this.settings.dpop.store);
			C = {
				...C,
				DPoP: e
			};
		}
		let D;
		try {
			D = await this._tokenClient.exchangeRefreshToken({
				refresh_token: e.refresh_token,
				scope: E,
				redirect_uri: b,
				resource: x,
				timeoutInSeconds: S,
				extraHeaders: C,
				...w
			});
		} catch (T) {
			if (T instanceof ErrorDPoPNonce && this.settings.dpop) C.DPoP = await this.getDpopProof(this.settings.dpop.store, T.nonce), D = await this._tokenClient.exchangeRefreshToken({
				refresh_token: e.refresh_token,
				scope: E,
				redirect_uri: b,
				resource: x,
				timeoutInSeconds: S,
				extraHeaders: C,
				...w
			});
			else throw T;
		}
		let O = new SigninResponse(new URLSearchParams());
		return Object.assign(O, D), T.debug("validating response", O), await this._validator.validateRefreshResponse(O, {
			...e,
			scope: E
		}), O;
	}
	async createSignoutRequest({ state: e, id_token_hint: b, client_id: x, request_type: S, url_state: C, post_logout_redirect_uri: w = this.settings.post_logout_redirect_uri, extraQueryParams: T = this.settings.extraQueryParams } = {}) {
		let E = this._logger.create("createSignoutRequest"), D = await this.metadataService.getEndSessionEndpoint();
		if (!D) throw E.throw(/* @__PURE__ */ Error("No end session endpoint")), null;
		E.debug("Received end session endpoint", D), !x && w && !b && (x = this.settings.client_id);
		let O = new SignoutRequest({
			url: D,
			id_token_hint: b,
			client_id: x,
			post_logout_redirect_uri: w,
			state_data: e,
			extraQueryParams: T,
			request_type: S,
			url_state: C
		});
		await this.clearStaleState();
		let k = O.state;
		return k && (E.debug("Signout request has state to persist"), await this.settings.stateStore.set(k.id, k.toStorageString())), O;
	}
	async readSignoutResponseState(e, b = !1) {
		let x = this._logger.create("readSignoutResponseState"), S = new SignoutResponse(UrlUtils.readParams(e, this.settings.response_mode));
		if (!S.state) {
			if (x.debug("No state in response"), S.error) throw x.warn("Response was error:", S.error), new ErrorResponse(S);
			return {
				state: void 0,
				response: S
			};
		}
		let C = await this.settings.stateStore[b ? "remove" : "get"](S.state);
		if (!C) throw x.throw(/* @__PURE__ */ Error("No matching state found in storage")), null;
		return {
			state: await State.fromStorageString(C),
			response: S
		};
	}
	async processSignoutResponse(e) {
		let b = this._logger.create("processSignoutResponse"), { state: x, response: S } = await this.readSignoutResponseState(e, !0);
		return x ? (b.debug("Received state from storage; validating response"), this._validator.validateSignoutResponse(S, x)) : b.debug("No state from storage; skipping response validation"), S;
	}
	clearStaleState() {
		return this._logger.create("clearStaleState"), State.clearStaleState(this.settings.stateStore, this.settings.staleStateAgeInSeconds);
	}
	async revokeToken(e, b) {
		return this._logger.create("revokeToken"), await this._tokenClient.revoke({
			token: e,
			token_type_hint: b
		});
	}
}, OidcError = /* @__PURE__ */ function(e) {
	return e.NotSupported = "OIDC authentication not supported", e.Misconfigured = "OIDC is misconfigured", e.General = "Something went wrong with OIDC discovery", e.OpSupport = "Configured OIDC OP does not support required functions", e.DynamicRegistrationNotSupported = "Dynamic registration not supported", e.DynamicRegistrationFailed = "Dynamic registration failed", e.DynamicRegistrationInvalid = "Dynamic registration invalid response", e.CodeExchangeFailed = "Failed to exchange code for token", e.InvalidBearerTokenResponse = "Invalid bearer token response", e.InvalidIdToken = "Invalid ID token", e.MissingOrInvalidStoredState = "State required to finish logging in is not found in storage.", e;
}({}), isRecord = (e) => !!e && typeof e == "object" && !Array.isArray(e), requiredStringProperty = (e, b) => !e[b] || !optionalStringProperty(e, b) ? (logger.error(`Missing or invalid property: ${b}`), !1) : !0, optionalStringProperty = (e, b) => e[b] && typeof e[b] != "string" ? (logger.error(`Invalid property: ${b}`), !1) : !0, optionalStringArrayProperty = (e, b) => e[b] && (!Array.isArray(e[b]) || !e[b].every((e) => typeof e == "string")) ? (logger.error(`Invalid property: ${b}`), !1) : !0, requiredArrayValue = (e, b, x) => {
	var S = e[b];
	return !S || !Array.isArray(S) || !S.includes(x) ? (logger.error(`Invalid property: ${b}. ${x} is required.`), !1) : !0;
}, validateAuthMetadata = (e) => {
	if (!isRecord(e)) throw logger.error("Issuer configuration not found or malformed"), Error(OidcError.OpSupport);
	if (![
		requiredStringProperty(e, "issuer"),
		requiredStringProperty(e, "authorization_endpoint"),
		requiredStringProperty(e, "token_endpoint"),
		requiredStringProperty(e, "revocation_endpoint"),
		optionalStringProperty(e, "registration_endpoint"),
		optionalStringProperty(e, "account_management_uri"),
		optionalStringProperty(e, "device_authorization_endpoint"),
		optionalStringArrayProperty(e, "account_management_actions_supported"),
		requiredArrayValue(e, "response_types_supported", "code"),
		requiredArrayValue(e, "grant_types_supported", "authorization_code"),
		requiredArrayValue(e, "code_challenge_methods_supported", "S256"),
		optionalStringArrayProperty(e, "prompt_values_supported")
	].some((e) => !e)) return e;
	throw logger.error("Issuer configuration not valid"), Error(OidcError.OpSupport);
}, decodeIdToken = (e) => {
	try {
		return jwtDecode(e);
	} catch (e) {
		throw logger.error("Could not decode id_token", e), e;
	}
}, validateIdToken = (e, b, x, S) => {
	try {
		if (!e) throw Error("No ID token");
		var C = decodeIdToken(e);
		if (C.iss !== b) throw Error("Invalid issuer");
		if (!(typeof C.aud == "string" ? [C.aud] : C.aud).includes(x)) throw Error("Invalid audience");
		if (S !== void 0 && C.nonce !== S) throw Error("Invalid nonce");
		if (!C.exp || Date.now() > C.exp * 1e3) throw Error("Invalid expiry");
	} catch (e) {
		throw logger.error("Invalid ID token", e), Error(OidcError.InvalidIdToken);
	}
};
function validateStoredUserState(e) {
	if (!isRecord(e)) throw logger.error("Stored user state not found"), Error(OidcError.MissingOrInvalidStoredState);
	if ([
		requiredStringProperty(e, "homeserverUrl"),
		requiredStringProperty(e, "nonce"),
		optionalStringProperty(e, "identityServerUrl")
	].some((e) => !e)) throw Error(OidcError.MissingOrInvalidStoredState);
}
var isValidBearerTokenResponse = (e) => isRecord(e) && requiredStringProperty(e, "token_type") && e.token_type.toLowerCase() === "bearer" && requiredStringProperty(e, "access_token") && requiredStringProperty(e, "refresh_token") && (!("expires_in" in e) || typeof e.expires_in == "number");
function validateBearerTokenResponse(e) {
	if (!isValidBearerTokenResponse(e)) throw Error(OidcError.InvalidBearerTokenResponse);
}
function ownKeys$3(e, b) {
	var x = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var S = Object.getOwnPropertySymbols(e);
		b && (S = S.filter(function(b) {
			return Object.getOwnPropertyDescriptor(e, b).enumerable;
		})), x.push.apply(x, S);
	}
	return x;
}
function _objectSpread$3(e) {
	for (var b = 1; b < arguments.length; b++) {
		var x = arguments[b] == null ? {} : arguments[b];
		b % 2 ? ownKeys$3(Object(x), !0).forEach(function(b) {
			_defineProperty(e, b, x[b]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(x)) : ownKeys$3(Object(x)).forEach(function(b) {
			Object.defineProperty(e, b, Object.getOwnPropertyDescriptor(x, b));
		});
	}
	return e;
}
var generateScope = (e) => `openid urn:matrix:org.matrix.msc2967.client:api:* urn:matrix:org.matrix.msc2967.client:device:${e ?? secureRandomString(10)}`, generateCodeChallenge = /* @__PURE__ */ function() {
	var e = _asyncToGenerator(function* (e) {
		if (!globalThis.crypto.subtle) return logger.warn("A secure context is required to generate code challenge. Using plain text code challenge"), e;
		var b = yield sha256(e);
		return encodeUnpaddedBase64Url(b);
	});
	return function(b) {
		return e.apply(this, arguments);
	};
}(), generateAuthorizationParams = (e) => {
	var { redirectUri: b } = e;
	return {
		scope: generateScope(),
		redirectUri: b,
		state: secureRandomString(8),
		nonce: secureRandomString(8),
		codeVerifier: secureRandomString(64)
	};
}, generateAuthorizationUrl = /* @__PURE__ */ function() {
	var e = _asyncToGenerator(function* (e, b, x) {
		var { scope: S, redirectUri: C, state: w, nonce: T, codeVerifier: E } = x, D = new URL(e);
		return D.searchParams.append("response_mode", "query"), D.searchParams.append("response_type", "code"), D.searchParams.append("redirect_uri", C), D.searchParams.append("client_id", b), D.searchParams.append("state", w), D.searchParams.append("scope", S), D.searchParams.append("nonce", T), D.searchParams.append("code_challenge_method", "S256"), D.searchParams.append("code_challenge", yield generateCodeChallenge(E)), D.toString();
	});
	return function(b, x, S) {
		return e.apply(this, arguments);
	};
}(), generateOidcAuthorizationUrl = /* @__PURE__ */ function() {
	var e = _asyncToGenerator(function* (e) {
		var { metadata: b, redirectUri: x, clientId: S, homeserverUrl: C, identityServerUrl: w, nonce: T, prompt: E, urlState: D, loginHint: O } = e, k = generateScope(), A = new OidcClient(_objectSpread$3(_objectSpread$3({}, b), {}, {
			client_id: S,
			redirect_uri: x,
			authority: b.issuer,
			response_mode: "query",
			response_type: "code",
			scope: k,
			stateStore: new WebStorageStateStore({
				prefix: "mx_oidc_",
				store: window.sessionStorage
			})
		})), j = {
			homeserverUrl: C,
			nonce: T,
			identityServerUrl: w
		};
		return (yield A.createSigninRequest({
			state: j,
			nonce: T,
			prompt: E,
			url_state: D,
			login_hint: O
		})).url;
	});
	return function(b) {
		return e.apply(this, arguments);
	};
}(), normalizeBearerTokenResponseTokenType = (e) => ({
	id_token: e.id_token,
	scope: e.scope,
	expires_at: e.expires_at,
	refresh_token: e.refresh_token,
	access_token: e.access_token,
	token_type: "Bearer"
}), completeAuthorizationCodeGrant = /* @__PURE__ */ function() {
	var e = _asyncToGenerator(function* (e, b) {
		var x = new URL(window.location.origin);
		x.searchParams.append("code", e), x.searchParams.append("state", b), Log.setLogger(logger);
		try {
			var S = new SigninResponse(x.searchParams), C = new WebStorageStateStore({
				prefix: "mx_oidc_",
				store: window.sessionStorage
			}), w = yield C.get(S.state);
			if (!w) throw Error(OidcError.MissingOrInvalidStoredState);
			var T = yield SigninState.fromStorageString(w), E = new OidcClient(_objectSpread$3(_objectSpread$3({}, T), {}, { stateStore: C })), D = yield E.processSigninResponse(x.href), O = D.userState;
			validateStoredUserState(O), validateBearerTokenResponse(D), validateIdToken(D.id_token, E.settings.authority, E.settings.client_id, O.nonce);
			var k = normalizeBearerTokenResponseTokenType(D);
			return {
				oidcClientSettings: {
					clientId: E.settings.client_id,
					issuer: E.settings.authority
				},
				tokenResponse: k,
				homeserverUrl: O.homeserverUrl,
				identityServerUrl: O.identityServerUrl,
				idTokenClaims: D.profile
			};
		} catch (e) {
			logger.error("Oidc login failed", e);
			var A = e.message;
			throw Object.values(OidcError).includes(A) ? e : Error(OidcError.CodeExchangeFailed);
		}
	});
	return function(b, x) {
		return e.apply(this, arguments);
	};
}();
function ownKeys$2(e, b) {
	var x = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var S = Object.getOwnPropertySymbols(e);
		b && (S = S.filter(function(b) {
			return Object.getOwnPropertyDescriptor(e, b).enumerable;
		})), x.push.apply(x, S);
	}
	return x;
}
function _objectSpread$2(e) {
	for (var b = 1; b < arguments.length; b++) {
		var x = arguments[b] == null ? {} : arguments[b];
		b % 2 ? ownKeys$2(Object(x), !0).forEach(function(b) {
			_defineProperty(e, b, x[b]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(x)) : ownKeys$2(Object(x)).forEach(function(b) {
			Object.defineProperty(e, b, Object.getOwnPropertyDescriptor(x, b));
		});
	}
	return e;
}
var discoverAndValidateOIDCIssuerWellKnown = /* @__PURE__ */ function() {
	var e = _asyncToGenerator(function* (e) {
		var b = new URL(".well-known/openid-configuration", e), x = yield (yield fetch(b, {
			method: Method.Get,
			signal: timeoutSignal(5e3)
		})).json();
		return validateAuthMetadataAndKeys(x);
	});
	return function(b) {
		return e.apply(this, arguments);
	};
}(), validateAuthMetadataAndKeys = /* @__PURE__ */ function() {
	var e = _asyncToGenerator(function* (e) {
		var b = validateAuthMetadata(e), x = new OidcClientSettingsStore({
			authority: b.issuer,
			metadata: b,
			redirect_uri: "",
			client_id: ""
		}), S = new MetadataService(x);
		return _objectSpread$2(_objectSpread$2({}, b), {}, { signingKeys: yield S.getSigningKeys() });
	});
	return function(b) {
		return e.apply(this, arguments);
	};
}(), DEVICE_CODE_SCOPE = "urn:ietf:params:oauth:grant-type:device_code", urlHasCommonBase = (e, b) => {
	if (!b) return !1;
	var x = new URL(b);
	return !(x.protocol !== e.protocol || x.hostname !== e.hostname && !x.hostname.endsWith(`.${e.hostname}`));
}, registerOidcClient = /* @__PURE__ */ function() {
	var e = _asyncToGenerator(function* (e, b) {
		if (!e.registration_endpoint) throw Error(OidcError.DynamicRegistrationNotSupported);
		var x = ["authorization_code", "refresh_token"];
		if (x.some((b) => !e.grant_types_supported.includes(b))) throw Error(OidcError.DynamicRegistrationNotSupported);
		var S = new URL(b.clientUri), C = {
			client_name: b.clientName,
			client_uri: b.clientUri,
			response_types: ["code"],
			grant_types: x,
			redirect_uris: b.redirectUris,
			id_token_signed_response_alg: "RS256",
			token_endpoint_auth_method: "none",
			application_type: b.applicationType,
			contacts: b.contacts,
			logo_uri: urlHasCommonBase(S, b.logoUri) ? b.logoUri : void 0,
			policy_uri: urlHasCommonBase(S, b.policyUri) ? b.policyUri : void 0,
			tos_uri: urlHasCommonBase(S, b.tosUri) ? b.tosUri : void 0
		}, w = {
			Accept: "application/json",
			"Content-Type": "application/json"
		};
		try {
			var T = yield fetch(e.registration_endpoint, {
				method: Method.Post,
				headers: w,
				body: JSON.stringify(C)
			});
			if (T.status >= 400) throw Error(OidcError.DynamicRegistrationFailed);
			var E = (yield T.json()).client_id;
			if (!E || typeof E != "string") throw Error(OidcError.DynamicRegistrationInvalid);
			return E;
		} catch (e) {
			throw Object.values(OidcError).includes(e.message) ? e : (logger.error("Dynamic registration request failed", e), Error(OidcError.DynamicRegistrationFailed));
		}
	});
	return function(b, x) {
		return e.apply(this, arguments);
	};
}(), OidcTokenRefresher = class {
	constructor(e, b, x, S, C) {
		this.idTokenClaims = C, _defineProperty(this, "oidcClientReady", void 0), _defineProperty(this, "oidcClient", void 0), _defineProperty(this, "inflightRefreshRequest", void 0), this.oidcClientReady = this.initialiseOidcClient(e, b, S, x);
	}
	initialiseOidcClient(e, b, x, S) {
		var C = this;
		return _asyncToGenerator(function* () {
			try {
				var w = yield discoverAndValidateOIDCIssuerWellKnown(e), T = generateScope(x);
				C.oidcClient = new OidcClient({
					metadata: w,
					signingKeys: w.signingKeys ?? void 0,
					client_id: b,
					scope: T,
					redirect_uri: S,
					authority: w.issuer,
					stateStore: new WebStorageStateStore({
						prefix: "mx_oidc_",
						store: window.sessionStorage
					})
				});
			} catch (e) {
				throw logger.error("Failed to initialise OIDC client.", e), Error("Failed to initialise OIDC client.");
			}
		})();
	}
	doRefreshAccessToken(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			b.inflightRefreshRequest ||= b.getNewTokens(e);
			try {
				return yield b.inflightRefreshRequest;
			} catch (e) {
				throw e instanceof ErrorResponse ? new TokenRefreshLogoutError(e) : e;
			} finally {
				b.inflightRefreshRequest = void 0;
			}
		})();
	}
	persistTokens(e) {
		return _asyncToGenerator(function* () {})();
	}
	getNewTokens(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			if (!b.oidcClient) throw Error("Cannot get new token before OIDC client is initialised.");
			var x = {
				refresh_token: e,
				session_state: "test",
				data: void 0,
				profile: b.idTokenClaims
			}, S = Date.now(), C = yield b.oidcClient.useRefreshToken({
				state: x,
				timeoutInSeconds: 300
			}), w = {
				accessToken: C.access_token,
				refreshToken: C.refresh_token,
				expiry: C.expires_in ? new Date(S + C.expires_in * 1e3) : void 0
			};
			return yield b.persistTokens(w), w;
		})();
	}
}, _excluded = [
	"server",
	"limit",
	"since"
];
function ownKeys$1(e, b) {
	var x = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var S = Object.getOwnPropertySymbols(e);
		b && (S = S.filter(function(b) {
			return Object.getOwnPropertyDescriptor(e, b).enumerable;
		})), x.push.apply(x, S);
	}
	return x;
}
function _objectSpread$1(e) {
	for (var b = 1; b < arguments.length; b++) {
		var x = arguments[b] == null ? {} : arguments[b];
		b % 2 ? ownKeys$1(Object(x), !0).forEach(function(b) {
			_defineProperty(e, b, x[b]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(x)) : ownKeys$1(Object(x)).forEach(function(b) {
			Object.defineProperty(e, b, Object.getOwnPropertyDescriptor(x, b));
		});
	}
	return e;
}
var SCROLLBACK_DELAY_MS = 3e3, TURN_CHECK_INTERVAL = 600 * 1e3, UNSTABLE_MSC3852_LAST_SEEN_UA = new UnstableValue("last_seen_user_agent", "org.matrix.msc3852.last_seen_user_agent"), PendingEventOrdering = /* @__PURE__ */ function(e) {
	return e.Chronological = "chronological", e.Detached = "detached", e;
}({}), GET_LOGIN_TOKEN_CAPABILITY = new NamespacedValue("m.get_login_token", "org.matrix.msc3882.get_login_token"), UNSTABLE_MSC2666_SHARED_ROOMS = "uk.half-shot.msc2666", UNSTABLE_MSC2666_MUTUAL_ROOMS = "uk.half-shot.msc2666.mutual_rooms", UNSTABLE_MSC2666_QUERY_MUTUAL_ROOMS = "uk.half-shot.msc2666.query_mutual_rooms", UNSTABLE_MSC4140_DELAYED_EVENTS = "org.matrix.msc4140", UNSTABLE_MSC4354_STICKY_EVENTS = "org.matrix.msc4354", UNSTABLE_MSC4133_EXTENDED_PROFILES = "uk.tcpip.msc4133", STABLE_MSC4133_EXTENDED_PROFILES = "uk.tcpip.msc4133.stable", EVENT_ID_PREFIX = "$", ClientEvent = /* @__PURE__ */ function(e) {
	return e.Sync = "sync", e.Event = "event", e.ToDeviceEvent = "toDeviceEvent", e.ReceivedToDeviceMessage = "receivedToDeviceMessage", e.AccountData = "accountData", e.Room = "Room", e.DeleteRoom = "deleteRoom", e.SyncUnexpectedError = "sync.unexpectedError", e.ClientWellKnown = "WellKnown.client", e.ReceivedVoipEvent = "received_voip_event", e.TurnServers = "turnServers", e.TurnServersError = "turnServers.error", e;
}({}), SSO_ACTION_PARAM = new UnstableValue("action", "org.matrix.msc3824.action"), MatrixClient = class extends TypedEventEmitter {
	constructor(e) {
		var b;
		super(), b = this, _defineProperty(this, "logger", void 0), _defineProperty(this, "reEmitter", new TypedReEmitter(this)), _defineProperty(this, "olmVersion", null), _defineProperty(this, "usingExternalCrypto", !1), _defineProperty(this, "_store", void 0), _defineProperty(this, "deviceId", void 0), _defineProperty(this, "credentials", void 0), _defineProperty(this, "legacyPickleKey", void 0), _defineProperty(this, "scheduler", void 0), _defineProperty(this, "clientRunning", !1), _defineProperty(this, "timelineSupport", !1), _defineProperty(this, "urlPreviewCache", {}), _defineProperty(this, "identityServer", void 0), _defineProperty(this, "http", void 0), _defineProperty(this, "cryptoBackend", void 0), _defineProperty(this, "enableEncryptedStateEvents", void 0), _defineProperty(this, "cryptoCallbacks", void 0), _defineProperty(this, "callEventHandler", void 0), _defineProperty(this, "groupCallEventHandler", void 0), _defineProperty(this, "supportsCallTransfer", !1), _defineProperty(this, "forceTURN", !1), _defineProperty(this, "iceCandidatePoolSize", 0), _defineProperty(this, "idBaseUrl", void 0), _defineProperty(this, "baseUrl", void 0), _defineProperty(this, "isVoipWithNoMediaAllowed", void 0), _defineProperty(this, "disableVoip", void 0), _defineProperty(this, "useLivekitForGroupCalls", void 0), _defineProperty(this, "canSupportVoip", !1), _defineProperty(this, "peekSync", null), _defineProperty(this, "isGuestAccount", !1), _defineProperty(this, "ongoingScrollbacks", {}), _defineProperty(this, "notifTimelineSet", null), _defineProperty(this, "legacyCryptoStore", void 0), _defineProperty(this, "verificationMethods", void 0), _defineProperty(this, "fallbackICEServerAllowed", !1), _defineProperty(this, "syncApi", void 0), _defineProperty(this, "roomNameGenerator", void 0), _defineProperty(this, "pushRules", void 0), _defineProperty(this, "syncLeftRoomsPromise", void 0), _defineProperty(this, "syncedLeftRooms", !1), _defineProperty(this, "clientOpts", void 0), _defineProperty(this, "clientWellKnownIntervalID", void 0), _defineProperty(this, "canResetTimelineCallback", void 0), _defineProperty(this, "canSupport", /* @__PURE__ */ new Map()), _defineProperty(this, "pushProcessor", new PushProcessor(this)), _defineProperty(this, "serverVersionsPromise", void 0), _defineProperty(this, "clientWellKnown", void 0), _defineProperty(this, "clientWellKnownPromise", void 0), _defineProperty(this, "turnServers", []), _defineProperty(this, "turnServersExpiry", 0), _defineProperty(this, "checkTurnServersIntervalID", void 0), _defineProperty(this, "txnCtr", 0), _defineProperty(this, "mediaHandler", new MediaHandler(this)), _defineProperty(this, "sessionId", void 0), _defineProperty(this, "eventsBeingEncrypted", /* @__PURE__ */ new Set()), _defineProperty(this, "useE2eForGroupCall", !0), _defineProperty(this, "toDeviceMessageQueue", void 0), _defineProperty(this, "livekitServiceURL", void 0), _defineProperty(this, "_secretStorage", void 0), _defineProperty(this, "ignoredInvites", void 0), _defineProperty(this, "matrixRTC", void 0), _defineProperty(this, "serverCapabilitiesService", void 0), _defineProperty(this, "startCallEventHandler", () => {
			this.isInitialSyncComplete() && (supportsMatrixCall() && (this.callEventHandler.start(), this.groupCallEventHandler.start()), this.off(ClientEvent.Sync, this.startCallEventHandler));
		}), _defineProperty(this, "startMatrixRTC", () => {
			this.isInitialSyncComplete() && (this.matrixRTC.start(), this.off(ClientEvent.Sync, this.startMatrixRTC));
		}), _defineProperty(this, "fixupRoomNotifications", () => {
			if (this.isInitialSyncComplete()) {
				for (var e of (this.getRooms() ?? []).filter((e) => e.getUnreadNotificationCount(NotificationCountType.Total) > 0)) {
					var b = this.getSafeUserId();
					e.fixupNotifications(b);
				}
				this.off(ClientEvent.Sync, this.fixupRoomNotifications);
			}
		}), this.logger = e.logger ?? logger, e.baseUrl = ensureNoTrailingSlash(e.baseUrl), e.idBaseUrl = ensureNoTrailingSlash(e.idBaseUrl), this.baseUrl = e.baseUrl, this.idBaseUrl = e.idBaseUrl, this.identityServer = e.identityServer, this.usingExternalCrypto = e.usingExternalCrypto ?? !1, this.store = e.store || new StubStore(), this.deviceId = e.deviceId || null, this.sessionId = secureRandomString(10), this.credentials = { userId: e.userId || null }, this.http = new MatrixHttpApi(this, {
			fetchFn: e.fetchFn,
			baseUrl: e.baseUrl,
			idBaseUrl: e.idBaseUrl,
			accessToken: e.accessToken,
			refreshToken: e.refreshToken,
			tokenRefreshFunction: e.tokenRefreshFunction,
			prefix: ClientPrefix.V3,
			onlyData: !0,
			extraParams: e.queryParams,
			localTimeoutMs: e.localTimeoutMs,
			useAuthorizationHeader: e.useAuthorizationHeader,
			logger: this.logger
		}), e.pickleKey && (this.legacyPickleKey = e.pickleKey), this.useLivekitForGroupCalls = !!e.useLivekitForGroupCalls, this.scheduler = e.scheduler, this.scheduler && this.scheduler.setProcessFunction(/* @__PURE__ */ function() {
			var e = _asyncToGenerator(function* (e) {
				var x = b.getRoom(e.getRoomId());
				e.status !== EventStatus.SENDING && b.updatePendingEventStatus(x, e, EventStatus.SENDING);
				var S = yield b.sendEventHttpRequest(e);
				return x && x.updatePendingEvent(e, EventStatus.SENT, S.event_id), S;
			});
			return function(b) {
				return e.apply(this, arguments);
			};
		}()), this.disableVoip = e.disableVoip ?? !1, !this.disableVoip && supportsMatrixCall() && (this.callEventHandler = new CallEventHandler(this), this.groupCallEventHandler = new GroupCallEventHandler(this), this.canSupportVoip = !0, this.on(ClientEvent.Sync, this.startCallEventHandler)), this.matrixRTC = new MatrixRTCSessionManager(this.logger, this), this.serverCapabilitiesService = new ServerCapabilities(this.logger, this.http), this.on(ClientEvent.Sync, this.fixupRoomNotifications), this.timelineSupport = !!e.timelineSupport, this.legacyCryptoStore = e.cryptoStore, this.verificationMethods = e.verificationMethods, this.cryptoCallbacks = e.cryptoCallbacks || {}, this.enableEncryptedStateEvents = e.enableEncryptedStateEvents ?? !1, this.forceTURN = e.forceTURN || !1, this.iceCandidatePoolSize = e.iceCandidatePoolSize === void 0 ? 0 : e.iceCandidatePoolSize, this.supportsCallTransfer = e.supportsCallTransfer || !1, this.fallbackICEServerAllowed = e.fallbackICEServerAllowed || !1, this.isVoipWithNoMediaAllowed = e.isVoipWithNoMediaAllowed || !1, e.useE2eForGroupCall !== void 0 && (this.useE2eForGroupCall = e.useE2eForGroupCall), this.livekitServiceURL = e.livekitServiceURL, this.roomNameGenerator = e.roomNameGenerator, this.toDeviceMessageQueue = new ToDeviceMessageQueue(this, this.logger), this.on(MatrixEventEvent.Decrypted, (e) => {
			fixNotificationCountOnDecryption(this, e);
		}), this.ignoredInvites = new IgnoredInvites(this), this._secretStorage = new ServerSideSecretStorageImpl(this, e.cryptoCallbacks ?? {}), this.setMaxListeners(0);
	}
	set store(e) {
		this._store = e, this._store.setUserCreator((e) => User.createUser(e, this));
	}
	get store() {
		return this._store;
	}
	startClient(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			if (!b.clientRunning) {
				b.clientRunning = !0, b.on(ClientEvent.Sync, b.startMatrixRTC);
				var x = b.getUserId();
				x && b.store.storeUser(new User(x)), b.supportsVoip() && (b.checkTurnServersIntervalID = setInterval(() => {
					b.checkTurnServers();
				}, TURN_CHECK_INTERVAL), b.checkTurnServers()), b.syncApi && (b.logger.error("Still have sync object whilst not running: stopping old one"), b.syncApi.stop());
				try {
					yield b.getVersions();
					var { threads: S, list: C, fwdPagination: w } = yield b.doesServerSupportThread();
					Thread.setServerSideSupport(S), Thread.setServerSideListSupport(C), Thread.setServerSideFwdPaginationSupport(w);
				} catch (e) {
					b.logger.error("Can't fetch server versions, continuing to initialise sync, this will be retried later", e);
				}
				b.clientOpts = e ?? {}, b.clientOpts.slidingSync ? b.syncApi = new SlidingSyncSdk(b.clientOpts.slidingSync, b, b.clientOpts, b.buildSyncApiOptions()) : b.syncApi = new SyncApi(b, b.clientOpts, b.buildSyncApiOptions()), b.syncApi.sync().catch((e) => b.logger.info("Sync startup aborted with an error:", e)), b.clientOpts.clientWellKnownPollPeriod !== void 0 && (b.clientWellKnownIntervalID = setInterval(() => {
					b.fetchClientWellKnown();
				}, 1e3 * b.clientOpts.clientWellKnownPollPeriod), b.fetchClientWellKnown()), b.toDeviceMessageQueue.start(), b.serverCapabilitiesService.start();
			}
		})();
	}
	buildSyncApiOptions() {
		return {
			cryptoCallbacks: this.cryptoBackend,
			canResetEntireTimeline: (e) => this.canResetTimelineCallback ? this.canResetTimelineCallback(e) : !1,
			logger: this.logger.getChild("sync")
		};
	}
	stopClient() {
		var e, b, x, S, C;
		(e = this.cryptoBackend) == null || e.stop(), this.off(ClientEvent.Sync, this.startMatrixRTC), this.clientRunning && (this.logger.debug("stopping MatrixClient"), this.clientRunning = !1, (b = this.syncApi) == null || b.stop(), this.syncApi = void 0, (x = this.peekSync) == null || x.stopPeeking(), (S = this.callEventHandler) == null || S.stop(), (C = this.groupCallEventHandler) == null || C.stop(), this.callEventHandler = void 0, this.groupCallEventHandler = void 0, globalThis.clearInterval(this.checkTurnServersIntervalID), this.checkTurnServersIntervalID = void 0, this.clientWellKnownIntervalID !== void 0 && globalThis.clearInterval(this.clientWellKnownIntervalID), this.toDeviceMessageQueue.stop(), this.matrixRTC.stop(), this.serverCapabilitiesService.stop());
	}
	clearStores() {
		var e = this, b = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
		if (this.clientRunning) throw Error("Cannot clear stores while client is running");
		var x = [];
		x.push(this.store.deleteAllData()), this.legacyCryptoStore && x.push(this.legacyCryptoStore.deleteAllData());
		var S = /* @__PURE__ */ function() {
			var x = _asyncToGenerator(function* () {
				var x;
				try {
					if (x = globalThis.indexedDB, !x) return;
				} catch {
					return;
				}
				var S = function* (b) {
					yield new Promise((S, C) => {
						e.logger.info(`Removing IndexedDB instance ${b}`);
						var w = x.deleteDatabase(b);
						w.onsuccess = (x) => {
							e.logger.info(`Removed IndexedDB instance ${b}`), S(0);
						}, w.onerror = (x) => {
							e.logger.warn(`Failed to remove IndexedDB instance ${b}:`, x), S(0);
						}, w.onblocked = (x) => {
							e.logger.info(`cannot yet remove IndexedDB instance ${b}`);
						};
					});
				};
				for (var C of [`${(w = b.cryptoDatabasePrefix) ?? RUST_SDK_STORE_PREFIX}::matrix-sdk-crypto`, `${(T = b.cryptoDatabasePrefix) ?? RUST_SDK_STORE_PREFIX}::matrix-sdk-crypto-meta`]) {
					var w, T;
					yield* S(C);
				}
			});
			return function() {
				return x.apply(this, arguments);
			};
		}();
		return x.push(S()), Promise.all(x).then();
	}
	getUserId() {
		return this.credentials?.userId ?? null;
	}
	getSafeUserId() {
		var e = this.getUserId();
		if (!e) throw Error("Expected logged in user but found none.");
		return e;
	}
	getDomain() {
		var e;
		return (e = this.credentials) != null && e.userId ? this.credentials.userId.replace(/^.*?:/, "") : null;
	}
	getUserIdLocalpart() {
		var e;
		return ((e = this.credentials) == null || (e = e.userId) == null ? void 0 : e.split(":")[0].substring(1)) ?? null;
	}
	getDeviceId() {
		return this.deviceId;
	}
	getSessionId() {
		return this.sessionId;
	}
	supportsVoip() {
		return !this.disableVoip && this.canSupportVoip;
	}
	getMediaHandler() {
		return this.mediaHandler;
	}
	setForceTURN(e) {
		this.forceTURN = e;
	}
	setSupportsCallTransfer(e) {
		this.supportsCallTransfer = e;
	}
	getUseE2eForGroupCall() {
		return this.useE2eForGroupCall;
	}
	createCall(e) {
		return createNewMatrixCall(this, e);
	}
	createGroupCall(e, b, x, S, C, w) {
		var T = this;
		return _asyncToGenerator(function* () {
			if (T.getGroupCallForRoom(e)) throw Error(`${e} already has an existing group call`);
			var E = T.getRoom(e);
			if (!E) throw Error(`Cannot find room ${e}`);
			return new GroupCall(T, E, b, x, S, void 0, C || T.isVoipWithNoMediaAllowed, w, T.isVoipWithNoMediaAllowed, T.useLivekitForGroupCalls, T.livekitServiceURL).create();
		})();
	}
	getLivekitServiceURL() {
		return this.livekitServiceURL;
	}
	setLivekitServiceURL(e) {
		this.livekitServiceURL = e;
	}
	waitUntilRoomReadyForGroupCalls(e) {
		return this.groupCallEventHandler.waitUntilRoomReadyForGroupCalls(e);
	}
	getGroupCallForRoom(e) {
		return this.groupCallEventHandler.groupCalls.get(e) || null;
	}
	getSyncState() {
		return this.syncApi?.getSyncState() ?? null;
	}
	getSyncStateData() {
		return this.syncApi ? this.syncApi.getSyncStateData() : null;
	}
	isInitialSyncComplete() {
		var e = this.getSyncState();
		return e ? e === SyncState.Prepared || e === SyncState.Syncing : !1;
	}
	isGuest() {
		return this.isGuestAccount;
	}
	setGuest(e) {
		this.isGuestAccount = e;
	}
	getScheduler() {
		return this.scheduler;
	}
	retryImmediately() {
		return this.toDeviceMessageQueue.sendQueue(), this.syncApi?.retryImmediately() ?? !1;
	}
	getNotifTimelineSet() {
		return this.notifTimelineSet;
	}
	setNotifTimelineSet(e) {
		this.notifTimelineSet = e;
	}
	getCapabilities() {
		var e = this;
		return _asyncToGenerator(function* () {
			return e.serverCapabilitiesService.getCachedCapabilities() || e.serverCapabilitiesService.fetchCapabilities();
		})();
	}
	getCachedCapabilities() {
		return this.serverCapabilitiesService.getCachedCapabilities();
	}
	fetchCapabilities() {
		return this.serverCapabilitiesService.fetchCapabilities();
	}
	initRustCrypto() {
		var e = arguments, b = this;
		return _asyncToGenerator(function* () {
			var x = e.length > 0 && e[0] !== void 0 ? e[0] : {};
			if (b.cryptoBackend) {
				b.logger.warn("Attempt to re-initialise e2e encryption on MatrixClient");
				return;
			}
			var S = b.getUserId();
			if (S === null) throw Error("Cannot enable encryption on MatrixClient with unknown userId: ensure userId is passed in createClient().");
			var C = b.getDeviceId();
			if (C === null) throw Error("Cannot enable encryption on MatrixClient with unknown deviceId: ensure deviceId is passed in createClient().");
			b.logger.debug("Downloading Rust crypto library");
			var w = yield (yield import("./rust-crypto-D0oMomof.js")).initRustCrypto({
				logger: b.logger,
				http: b.http,
				userId: S,
				deviceId: C,
				secretStorage: b.secretStorage,
				cryptoCallbacks: b.cryptoCallbacks,
				storePrefix: x.useIndexedDB === !1 ? null : x.cryptoDatabasePrefix ?? RUST_SDK_STORE_PREFIX,
				storeKey: x.storageKey,
				storePassphrase: x.storagePassword,
				legacyCryptoStore: b.legacyCryptoStore,
				legacyPickleKey: b.legacyPickleKey ?? "DEFAULT_KEY",
				legacyMigrationProgressListener: (e, x) => {
					b.emit(CryptoEvent.LegacyCryptoStoreMigrationProgress, e, x);
				},
				enableEncryptedStateEvents: b.enableEncryptedStateEvents
			});
			w.setSupportedVerificationMethods(b.verificationMethods), b.cryptoBackend = w, b.on(RoomMemberEvent.Membership, w.onRoomMembership.bind(w)), b.on(ClientEvent.Event, (e) => {
				w.onLiveEventFromSync(e);
			}), b.reEmitter.reEmit(w, [
				CryptoEvent.VerificationRequestReceived,
				CryptoEvent.UserTrustStatusChanged,
				CryptoEvent.KeyBackupStatus,
				CryptoEvent.KeyBackupSessionsRemaining,
				CryptoEvent.KeyBackupFailed,
				CryptoEvent.KeyBackupDecryptionKeyCached,
				CryptoEvent.KeysChanged,
				CryptoEvent.DevicesUpdated,
				CryptoEvent.WillUpdateDevices,
				CryptoEvent.DehydratedDeviceCreated,
				CryptoEvent.DehydratedDeviceUploaded,
				CryptoEvent.RehydrationStarted,
				CryptoEvent.RehydrationProgress,
				CryptoEvent.RehydrationCompleted,
				CryptoEvent.RehydrationError,
				CryptoEvent.DehydrationKeyCached,
				CryptoEvent.DehydratedDeviceRotationError
			]);
		})();
	}
	get secretStorage() {
		return this._secretStorage;
	}
	getCrypto() {
		return this.cryptoBackend;
	}
	isRoomEncrypted(e) {
		var b = this.getRoom(e);
		return b ? b.hasEncryptionStateEvent() : !1;
	}
	isKeyBackupKeyStored() {
		return Promise.resolve(this.secretStorage.isStored("m.megolm_backup.v1"));
	}
	makeKeyBackupPath(e, b, x) {
		return {
			path: b === void 0 ? e === void 0 ? "/room_keys/keys" : encodeUri("/room_keys/keys/$roomId", { $roomId: e }) : encodeUri("/room_keys/keys/$roomId/$sessionId", {
				$roomId: e,
				$sessionId: b
			}),
			queryData: x === void 0 ? void 0 : { version: x }
		};
	}
	deleteKeysFromBackup(e, b, x) {
		var S = this;
		return _asyncToGenerator(function* () {
			var C = S.makeKeyBackupPath(e, b, x);
			yield S.http.authedRequest(Method.Delete, C.path, C.queryData, void 0, { prefix: ClientPrefix.V3 });
		})();
	}
	getMediaConfig() {
		var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, b = e ? "/media/config" : "/config";
		return this.http.authedRequest(Method.Get, b, void 0, void 0, { prefix: e ? ClientPrefix.V1 : MediaPrefix.V3 });
	}
	getRoom(e) {
		return e ? this.store.getRoom(e) : null;
	}
	getRooms() {
		return this.store.getRooms();
	}
	getVisibleRooms() {
		var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, b = this.store.getRooms(), x = new Set(b);
		for (var S of x) for (var C of this.findPredecessorRooms(S, !0, e)) x.delete(C);
		return Array.from(x);
	}
	getUser(e) {
		return this.store.getUser(e);
	}
	getUsers() {
		return this.store.getUsers();
	}
	setAccountData(e, b) {
		var x = this;
		return _asyncToGenerator(function* () {
			if (!x.clientRunning) return x.logger.warn("Calling `setAccountData` before the client is started: `getAccountData` may return inconsistent results."), yield retryNetworkOperation(5, () => x.setAccountDataRaw(e, b));
			var S = x.store.getAccountData(e);
			if (S && deepCompare(S.event.content, b)) return {};
			var C = Promise.withResolvers();
			function w(b) {
				b.getType() === e && C.resolve();
			}
			x.addListener(ClientEvent.AccountData, w);
			try {
				var T = yield retryNetworkOperation(5, () => x.setAccountDataRaw(e, b));
				return yield C.promise, T;
			} finally {
				x.removeListener(ClientEvent.AccountData, w);
			}
		})();
	}
	setAccountDataRaw(e, b) {
		var x = encodeUri("/user/$userId/account_data/$type", {
			$userId: this.credentials.userId,
			$type: e
		});
		return this.http.authedRequest(Method.Put, x, void 0, b);
	}
	getAccountData(e) {
		return this.store.getAccountData(e);
	}
	getAccountDataFromServer(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			if (b.isInitialSyncComplete()) {
				var x = b.store.getAccountData(e);
				return x ? x.getContent() : null;
			}
			var S = encodeUri("/user/$userId/account_data/$type", {
				$userId: b.credentials.userId,
				$type: e
			});
			try {
				return yield b.http.authedRequest(Method.Get, S);
			} catch (e) {
				if (e.data?.errcode === "M_NOT_FOUND") return null;
				throw e;
			}
		})();
	}
	deleteAccountData(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			var x = b.canSupport.get(Feature.AccountDataDeletion);
			if (x === ServerSupport.Unsupported) {
				yield b.setAccountData(e, {});
				return;
			}
			var S = encodeUri("/user/$userId/account_data/$type", {
				$userId: b.getSafeUserId(),
				$type: e
			}), C = x === ServerSupport.Unstable ? { prefix: "/_matrix/client/unstable/org.matrix.msc3391" } : void 0;
			return yield b.http.authedRequest(Method.Delete, S, void 0, void 0, C);
		})();
	}
	getIgnoredUsers() {
		var e = this.getAccountData(EventType.IgnoredUserList);
		return e != null && e.getContent().ignored_users ? Object.keys(e.getContent().ignored_users) : [];
	}
	setIgnoredUsers(e) {
		var b = { ignored_users: {} };
		return e.forEach((e) => {
			b.ignored_users[e] = {};
		}), this.setAccountData(EventType.IgnoredUserList, b);
	}
	isUserIgnored(e) {
		return this.getIgnoredUsers().includes(e);
	}
	joinRoom(e) {
		var b = arguments, x = this;
		return _asyncToGenerator(function* () {
			var S, C = b.length > 1 && b[1] !== void 0 ? b[1] : {}, w = x.getRoom(e), T = w?.getMember(x.getSafeUserId()), E = T?.membership, D = E == KnownMembership.Invite ? (T == null || (S = T.events.member) == null ? void 0 : S.getSender()) ?? null : null;
			if (x.logger.debug(`joinRoom[${e}]: preJoinMembership=${E}, inviter=${D}, opts=${JSON.stringify(C)}`), E == KnownMembership.Join) return w;
			var O = Promise.resolve();
			if (C.inviteSignUrl) {
				var k = new URL(C.inviteSignUrl);
				k.searchParams.set("mxid", x.credentials.userId), O = x.http.requestOtherUrl(Method.Post, k);
			}
			var A = {};
			C.viaServers && (A.via = A.server_name = C.viaServers.slice(0, 3));
			var j = {}, M = yield O;
			M && (j.third_party_signed = M);
			var N = encodeUri("/join/$roomid", { $roomid: e }), P = (yield x.http.authedRequest(Method.Post, N, A, j)).room_id;
			C.acceptSharedHistory && D && x.cryptoBackend && ((yield x.cryptoBackend.maybeAcceptKeyBundle(P, D)) || x.cryptoBackend.markRoomAsPendingKeyBundle(P, D));
			var F = x.getRoom(P);
			return F != null && F.hasMembershipState(x.credentials.userId, KnownMembership.Join) ? F : new SyncApi(x, x.clientOpts, x.buildSyncApiOptions()).createRoom(P);
		})();
	}
	knockRoom(e) {
		var b = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, x = this.getRoom(e);
		if (x != null && x.hasMembershipState(this.credentials.userId, KnownMembership.Knock)) return Promise.resolve({ room_id: x.roomId });
		var S = encodeUri("/knock/$roomIdOrAlias", { $roomIdOrAlias: e }), C = {};
		if (b.viaServers) {
			var w = Array.isArray(b.viaServers) ? b.viaServers.slice(0, 3) : [b.viaServers];
			C.server_name = w, C.via = w;
		}
		var T = {};
		return b.reason && (T.reason = b.reason), this.http.authedRequest(Method.Post, S, C, T);
	}
	resendEvent(e, b) {
		return this.toDeviceMessageQueue.sendQueue(), this.updatePendingEventStatus(b, e, EventStatus.SENDING), this.encryptAndSendEvent(b, e);
	}
	cancelPendingEvent(e) {
		if (![
			EventStatus.QUEUED,
			EventStatus.NOT_SENT,
			EventStatus.ENCRYPTING
		].includes(e.status)) throw Error("cannot cancel an event with status " + e.status);
		e.status === EventStatus.ENCRYPTING ? this.eventsBeingEncrypted.delete(e.getId()) : this.scheduler && e.status === EventStatus.QUEUED && this.scheduler.removeEventFromQueue(e);
		var b = this.getRoom(e.getRoomId());
		this.updatePendingEventStatus(b, e, EventStatus.CANCELLED);
	}
	setRoomName(e, b) {
		return this.sendStateEvent(e, EventType.RoomName, { name: b });
	}
	setRoomTopic(e, b, x) {
		var S = makeTopicContent(b, x);
		return this.sendStateEvent(e, EventType.RoomTopic, S);
	}
	getRoomTags(e) {
		var b = encodeUri("/user/$userId/rooms/$roomId/tags", {
			$userId: this.credentials.userId,
			$roomId: e
		});
		return this.http.authedRequest(Method.Get, b);
	}
	setRoomTag(e, b) {
		var x = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, S = encodeUri("/user/$userId/rooms/$roomId/tags/$tag", {
			$userId: this.credentials.userId,
			$roomId: e,
			$tag: b
		});
		return this.http.authedRequest(Method.Put, S, void 0, x);
	}
	deleteRoomTag(e, b) {
		var x = encodeUri("/user/$userId/rooms/$roomId/tags/$tag", {
			$userId: this.credentials.userId,
			$roomId: e,
			$tag: b
		});
		return this.http.authedRequest(Method.Delete, x);
	}
	setRoomAccountData(e, b, x) {
		var S = encodeUri("/user/$userId/rooms/$roomId/account_data/$type", {
			$userId: this.credentials.userId,
			$roomId: e,
			$type: b
		});
		return this.http.authedRequest(Method.Put, S, void 0, x);
	}
	setPowerLevel(e, b, x) {
		var S = this;
		return _asyncToGenerator(function* () {
			var C, w;
			if (S.clientRunning && S.isInitialSyncComplete()) {
				var T;
				w = (T = S.getRoom(e)) == null || (T = T.currentState) == null || (T = T.getStateEvents(EventType.RoomPowerLevels, "")) == null ? void 0 : T.getContent();
			}
			if (!w) try {
				w = yield S.getStateEvent(e, EventType.RoomPowerLevels, "");
			} catch (e) {
				if (e instanceof MatrixError && e.errcode === "M_NOT_FOUND") w = {};
				else throw e;
			}
			w = deepCopy(w), (C = w) != null && C.users || (w.users = {});
			for (var E of Array.isArray(b) ? b : [b]) x == null ? delete w.users[E] : w.users[E] = x;
			return S.sendStateEvent(e, EventType.RoomPowerLevels, w, "");
		})();
	}
	unstable_createLiveBeacon(e, b) {
		var x = this;
		return _asyncToGenerator(function* () {
			return x.unstable_setLiveBeacon(e, b);
		})();
	}
	unstable_setLiveBeacon(e, b) {
		var x = this;
		return _asyncToGenerator(function* () {
			return x.sendStateEvent(e, M_BEACON_INFO.name, b, x.getUserId());
		})();
	}
	sendEvent(e, b, x, S, C) {
		var w, T, E, D;
		return !(b != null && b.startsWith(EVENT_ID_PREFIX)) && b !== null ? (D = S, E = x, T = b, w = null) : (D = C, E = S, T = x, w = b), this.addThreadRelationIfNeeded(E, w, e), this.sendCompleteEvent({
			roomId: e,
			threadId: w,
			eventObject: {
				type: T,
				content: E
			},
			txnId: D
		});
	}
	addThreadRelationIfNeeded(e, b, x) {
		var S;
		if (b && !((S = e["m.relates_to"]) != null && S.rel_type)) {
			var C, w = !!((C = e["m.relates_to"]) != null && C["m.in_reply_to"]);
			e["m.relates_to"] = _objectSpread$1(_objectSpread$1({}, e["m.relates_to"]), {}, {
				rel_type: THREAD_RELATION_TYPE.name,
				event_id: b,
				is_falling_back: !w
			});
			var T = this.getRoom(x)?.getThread(b);
			T && !w && (e["m.relates_to"]["m.in_reply_to"] = { event_id: T.lastReply((e) => e.isRelation(THREAD_RELATION_TYPE.name) && !e.status)?.getId() ?? b });
		}
	}
	sendCompleteEvent(e) {
		var { roomId: b, threadId: x, eventObject: S, delayOpts: C, queryDict: w, txnId: T } = e;
		T ||= this.makeTxnId();
		var E = new MatrixEvent(Object.assign(S, {
			event_id: "~" + b + ":" + T,
			user_id: this.credentials.userId,
			sender: this.credentials.userId,
			room_id: b,
			origin_server_ts: (/* @__PURE__ */ new Date()).getTime()
		})), D = this.getRoom(b), O = x ? D?.getThread(x) : void 0;
		O && E.setThread(O), C || (this.reEmitter.reEmit(E, [MatrixEventEvent.Replaced, MatrixEventEvent.VisibilityChange]), D?.reEmitter.reEmit(E, [MatrixEventEvent.BeforeRedaction]));
		var k = E.getAssociatedId();
		if (k != null && k.startsWith("~")) {
			var A = D?.getPendingEvents().find((e) => e.getId() === k);
			A?.once(MatrixEventEvent.LocalEventIdReplaced, () => {
				E.updateAssociatedId(A.getId());
			});
		}
		var j = E.getType();
		return this.logger.debug(`sendEvent of type ${j} in ${b} with txnId ${T}${C ? " (delayed event)" : ""}${w ? " query params: " + JSON.stringify(w) : ""}`), E.setTxnId(T), E.setStatus(EventStatus.SENDING), C ? this.encryptAndSendEvent(D, E, C, w) : (D?.addPendingEvent(E, T), E.status === EventStatus.NOT_SENT ? Promise.reject(/* @__PURE__ */ Error("Event blocked by other events not yet sent")) : this.encryptAndSendEvent(D, E, w));
	}
	encryptAndSendEvent(e, b, x, S) {
		var C = this;
		return _asyncToGenerator(function* () {
			var w = S;
			if (x && isSendDelayedEventRequestOpts(x)) return C.sendEventHttpRequest(b, x, w);
			w ||= x;
			try {
				var T;
				C.eventsBeingEncrypted.add(b.getId());
				try {
					yield C.encryptEventIfNeeded(b, e ?? void 0);
				} finally {
					T = !C.eventsBeingEncrypted.delete(b.getId());
				}
				if (T) return {};
				b.status === EventStatus.ENCRYPTING && C.updatePendingEventStatus(e, b, EventStatus.SENDING);
				var E = null;
				return C.scheduler && (E = C.scheduler.queueEvent(b), E && C.scheduler.getQueueForEvent(b).length > 1 && C.updatePendingEventStatus(e, b, EventStatus.QUEUED)), E || (E = C.sendEventHttpRequest(b, w), e && (E = E.then((x) => (e.updatePendingEvent(b, EventStatus.SENT, x.event_id), x)))), yield E;
			} catch (x) {
				C.logger.error("Error sending event", x);
				try {
					b.error = x, C.updatePendingEventStatus(e, b, EventStatus.NOT_SENT);
				} catch (e) {
					C.logger.error("Exception in error handler!", e);
				}
				throw x instanceof MatrixError && (x.event = b), x;
			}
		})();
	}
	encryptEventIfNeeded(e, b) {
		var x = this;
		return _asyncToGenerator(function* () {
			if (b && (yield x.shouldEncryptEventForRoom(e, b)) && !(!x.cryptoBackend && x.usingExternalCrypto)) {
				if (!x.cryptoBackend) throw Error("This room is configured to use encryption, but your client does not support encryption.");
				x.updatePendingEventStatus(b, e, EventStatus.ENCRYPTING), yield x.cryptoBackend.encryptEvent(e, b);
			}
		})();
	}
	shouldEncryptEventForRoom(e, b) {
		var x = this;
		return _asyncToGenerator(function* () {
			return e.isEncrypted() || e.getType() === EventType.Reaction || e.isRedaction() ? !1 : !!(b.hasEncryptionStateEvent() || (yield x.cryptoBackend?.isEncryptionEnabledInRoom(b.roomId)));
		})();
	}
	getEncryptedIfNeededEventType(e, b) {
		var x;
		return b === EventType.Reaction ? b : (x = this.getRoom(e)) != null && x.hasEncryptionStateEvent() ? EventType.RoomMessageEncrypted : b;
	}
	updatePendingEventStatus(e, b, x) {
		e ? e.updatePendingEvent(b, x) : b.setStatus(x);
	}
	sendEventHttpRequest(e, b, x) {
		var S = e.getTxnId();
		S || (S = this.makeTxnId(), e.setTxnId(S));
		var C = {
			$roomId: e.getRoomId(),
			$eventType: e.getWireType(),
			$stateKey: e.getStateKey(),
			$txnId: S
		}, w;
		if (e.isState()) {
			var T = "/rooms/$roomId/state/$eventType";
			e.getStateKey() && e.getStateKey().length > 0 && (T = "/rooms/$roomId/state/$eventType/$stateKey"), w = encodeUri(T, C);
		} else w = e.isRedaction() && e.event.redacts ? encodeUri("/rooms/$roomId/redact/$redactsEventId/$txnId", _objectSpread$1({ $redactsEventId: e.event.redacts }, C)) : encodeUri("/rooms/$roomId/send/$eventType/$txnId", C);
		var E = b && isSendDelayedEventRequestOpts(b) ? b : void 0, D = E ? x : b, O = e.getWireContent();
		return E ? this.http.authedRequest(Method.Put, w, _objectSpread$1(_objectSpread$1({}, getUnstableDelayQueryOpts(E)), D), O) : this.http.authedRequest(Method.Put, w, D, O).then((b) => (this.logger.debug(`Event sent to ${e.getRoomId()} with event id ${b.event_id}`), b));
	}
	redactEvent(e, b, x, S, C) {
		var w;
		(w = x) != null && w.startsWith(EVENT_ID_PREFIX) || (C = S, S = x, x = b, b = null);
		var T = { reason: C?.reason };
		if (C?.with_rel_types !== void 0) {
			if (this.canSupport.get(Feature.RelationBasedRedactions) === ServerSupport.Unsupported) throw Error(`Server does not support relation based redactions roomId ${e} eventId ${x} txnId: ${S} threadId ${b}`);
			var E = this.canSupport.get(Feature.RelationBasedRedactions) === ServerSupport.Stable ? MSC3912_RELATION_BASED_REDACTIONS_PROP.stable : MSC3912_RELATION_BASED_REDACTIONS_PROP.unstable;
			T[E] = C.with_rel_types;
		}
		return this.sendCompleteEvent({
			roomId: e,
			threadId: b,
			eventObject: {
				type: EventType.RoomRedaction,
				content: T,
				redacts: x
			},
			txnId: S
		});
	}
	sendMessage(e, b, x, S) {
		typeof b != "string" && b !== null && (S = x, x = b, b = null);
		var C = EventType.RoomMessage, w = x;
		return this.sendEvent(e, b, C, w, S);
	}
	sendTextMessage(e, b, x, S) {
		var C;
		!((C = b) != null && C.startsWith(EVENT_ID_PREFIX)) && b !== null && (S = x, x = b, b = null);
		var w = makeTextMessage(x);
		return this.sendMessage(e, b, w, S);
	}
	sendNotice(e, b, x, S) {
		var C;
		!((C = b) != null && C.startsWith(EVENT_ID_PREFIX)) && b !== null && (S = x, x = b, b = null);
		var w = makeNotice(x);
		return this.sendMessage(e, b, w, S);
	}
	sendEmoteMessage(e, b, x, S) {
		var C;
		!((C = b) != null && C.startsWith(EVENT_ID_PREFIX)) && b !== null && (S = x, x = b, b = null);
		var w = makeEmoteMessage(x);
		return this.sendMessage(e, b, w, S);
	}
	sendImageMessage(e, b, x, S) {
		var C, w = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "Image";
		!((C = b) != null && C.startsWith(EVENT_ID_PREFIX)) && b !== null && (w = S || "Image", S = x, x = b, b = null);
		var T = {
			msgtype: MsgType.Image,
			url: x,
			info: S,
			body: w
		};
		return this.sendMessage(e, b, T);
	}
	sendStickerMessage(e, b, x, S) {
		var C, w = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "Sticker";
		!((C = b) != null && C.startsWith(EVENT_ID_PREFIX)) && b !== null && (w = S || "Sticker", S = x, x = b, b = null);
		var T = {
			url: x,
			info: S,
			body: w
		};
		return this.sendEvent(e, b, EventType.Sticker, T);
	}
	sendHtmlMessage(e, b, x, S) {
		var C;
		!((C = b) != null && C.startsWith(EVENT_ID_PREFIX)) && b !== null && (S = x, x = b, b = null);
		var w = makeHtmlMessage(x, S);
		return this.sendMessage(e, b, w);
	}
	sendHtmlNotice(e, b, x, S) {
		var C;
		!((C = b) != null && C.startsWith(EVENT_ID_PREFIX)) && b !== null && (S = x, x = b, b = null);
		var w = makeHtmlNotice(x, S);
		return this.sendMessage(e, b, w);
	}
	sendHtmlEmote(e, b, x, S) {
		var C;
		!((C = b) != null && C.startsWith(EVENT_ID_PREFIX)) && b !== null && (S = x, x = b, b = null);
		var w = makeHtmlEmote(x, S);
		return this.sendMessage(e, b, w);
	}
	_unstable_sendDelayedEvent(e, b, x, S, C, w) {
		var T = this;
		return _asyncToGenerator(function* () {
			if (!(yield T.doesServerSupportUnstableFeature("org.matrix.msc4140"))) throw new UnsupportedDelayedEventsEndpointError("Server does not support the delayed events API", "sendDelayedEvent");
			return T.addThreadRelationIfNeeded(C, x, e), T.sendCompleteEvent({
				roomId: e,
				threadId: x,
				eventObject: {
					type: S,
					content: C
				},
				delayOpts: b,
				txnId: w
			});
		})();
	}
	_unstable_sendStickyDelayedEvent(e, b, x, S, C, w, T) {
		var E = this;
		return _asyncToGenerator(function* () {
			if (!(yield E.doesServerSupportUnstableFeature("org.matrix.msc4140"))) throw new UnsupportedDelayedEventsEndpointError("Server does not support the delayed events API", "getDelayedEvents");
			if (!(yield E.doesServerSupportUnstableFeature("org.matrix.msc4354"))) throw new UnsupportedStickyEventsEndpointError("Server does not support the sticky events", "sendStickyEvent");
			return E.addThreadRelationIfNeeded(w, S, e), E.sendCompleteEvent({
				roomId: e,
				threadId: S,
				eventObject: {
					type: C,
					content: w
				},
				queryDict: { "org.matrix.msc4354.sticky_duration_ms": b },
				delayOpts: x,
				txnId: T
			});
		})();
	}
	_unstable_sendDelayedStateEvent(e, b, x, S) {
		var C = arguments, w = this;
		return _asyncToGenerator(function* () {
			var T = C.length > 4 && C[4] !== void 0 ? C[4] : "", E = C.length > 5 && C[5] !== void 0 ? C[5] : {};
			if (!(yield w.doesServerSupportUnstableFeature("org.matrix.msc4140"))) throw new UnsupportedDelayedEventsEndpointError("Server does not support the delayed events API", "sendDelayedStateEvent");
			var D = {
				$roomId: e,
				$eventType: x,
				$stateKey: T
			}, O = encodeUri("/rooms/$roomId/state/$eventType", D);
			return T !== void 0 && (O = encodeUri(O + "/$stateKey", D)), w.http.authedRequest(Method.Put, O, getUnstableDelayQueryOpts(b), S, E);
		})();
	}
	_unstable_sendStickyEvent(e, b, x, S, C, w) {
		var T = this;
		return _asyncToGenerator(function* () {
			if (!(yield T.doesServerSupportUnstableFeature("org.matrix.msc4354"))) throw new UnsupportedStickyEventsEndpointError("Server does not support the sticky events", "sendStickyEvent");
			return T.addThreadRelationIfNeeded(C, x, e), T.sendCompleteEvent({
				roomId: e,
				threadId: x,
				eventObject: {
					type: S,
					content: C
				},
				queryDict: { "org.matrix.msc4354.sticky_duration_ms": b },
				txnId: w
			});
		})();
	}
	_unstable_getDelayedEvents(e, b, x) {
		var S = this;
		return _asyncToGenerator(function* () {
			if (!(yield S.doesServerSupportUnstableFeature("org.matrix.msc4140"))) throw new UnsupportedDelayedEventsEndpointError("Server does not support the delayed events API", "getDelayedEvents");
			var C = {
				from: x,
				status: e,
				delay_id: b
			};
			return yield S.http.authedRequest(Method.Get, "/delayed_events", C, void 0, { prefix: `${ClientPrefix.Unstable}/${UNSTABLE_MSC4140_DELAYED_EVENTS}` });
		})();
	}
	_unstable_updateDelayedEvent(e, b) {
		var x = arguments, S = this;
		return _asyncToGenerator(function* () {
			var C = x.length > 2 && x[2] !== void 0 ? x[2] : {};
			if (!(yield S.doesServerSupportUnstableFeature("org.matrix.msc4140"))) throw new UnsupportedDelayedEventsEndpointError("Server does not support the delayed events API", "updateDelayedEvent");
			return yield S.updateScheduledDelayedEventWithActionInBody(e, b, C);
		})();
	}
	_unstable_cancelScheduledDelayedEvent(e) {
		var b = arguments, x = this;
		return _asyncToGenerator(function* () {
			var S = b.length > 1 && b[1] !== void 0 ? b[1] : {};
			return yield x.updateScheduledDelayedEvent(e, UpdateDelayedEventAction.Cancel, S);
		})();
	}
	_unstable_restartScheduledDelayedEvent(e) {
		var b = arguments, x = this;
		return _asyncToGenerator(function* () {
			var S = b.length > 1 && b[1] !== void 0 ? b[1] : {};
			return yield x.updateScheduledDelayedEvent(e, UpdateDelayedEventAction.Restart, S);
		})();
	}
	_unstable_sendScheduledDelayedEvent(e) {
		var b = arguments, x = this;
		return _asyncToGenerator(function* () {
			var S = b.length > 1 && b[1] !== void 0 ? b[1] : {};
			return yield x.updateScheduledDelayedEvent(e, UpdateDelayedEventAction.Send, S);
		})();
	}
	updateScheduledDelayedEvent(e, b) {
		var x = arguments, S = this;
		return _asyncToGenerator(function* () {
			var C = x.length > 2 && x[2] !== void 0 ? x[2] : {};
			if (!(yield S.doesServerSupportUnstableFeature("org.matrix.msc4140"))) throw new UnsupportedDelayedEventsEndpointError("Server does not support the delayed events API", `${b}ScheduledDelayedEvent`);
			try {
				var w = encodeUri("/delayed_events/$delayId/$action", {
					$delayId: e,
					$action: b
				});
				return yield S.http.request(Method.Post, w, void 0, void 0, _objectSpread$1(_objectSpread$1({}, C), {}, { prefix: `${ClientPrefix.Unstable}/${UNSTABLE_MSC4140_DELAYED_EVENTS}` }));
			} catch (x) {
				if (x instanceof MatrixError && x.errcode === "M_UNRECOGNIZED") return yield S.updateScheduledDelayedEventWithActionInBody(e, b, C);
				throw x;
			}
		})();
	}
	updateScheduledDelayedEventWithActionInBody(e, b) {
		var x = arguments, S = this;
		return _asyncToGenerator(function* () {
			var C = x.length > 2 && x[2] !== void 0 ? x[2] : {}, w = encodeUri("/delayed_events/$delayId", { $delayId: e }), T = { action: b };
			try {
				return yield S.http.request(Method.Post, w, void 0, T, _objectSpread$1(_objectSpread$1({}, C), {}, { prefix: `${ClientPrefix.Unstable}/${UNSTABLE_MSC4140_DELAYED_EVENTS}` }));
			} catch (e) {
				if (e instanceof MatrixError && e.errcode === "M_MISSING_TOKEN") return yield S.http.authedRequest(Method.Post, w, void 0, T, _objectSpread$1(_objectSpread$1({}, C), {}, { prefix: `${ClientPrefix.Unstable}/${UNSTABLE_MSC4140_DELAYED_EVENTS}` }));
				throw e;
			}
		})();
	}
	sendReceipt(e, b, x) {
		var S = arguments, C = this;
		return _asyncToGenerator(function* () {
			var w = S.length > 3 && S[3] !== void 0 ? S[3] : !1;
			if (C.isGuest()) return Promise.resolve({});
			var T = encodeUri("/rooms/$roomId/receipt/$receiptType/$eventId", {
				$roomId: e.getRoomId(),
				$receiptType: b,
				$eventId: e.getId()
			}), E = !w && C.supportsThreads() ? _objectSpread$1(_objectSpread$1({}, x), {}, { thread_id: threadIdForReceipt(e) }) : x, D = C.http.authedRequest(Method.Post, T, void 0, E || {}), O = C.getRoom(e.getRoomId());
			return O && C.credentials.userId && O.addLocalEchoReceipt(C.credentials.userId, e, b, w), D;
		})();
	}
	sendReadReceipt(e) {
		var b = arguments, x = this;
		return _asyncToGenerator(function* () {
			var S = b.length > 1 && b[1] !== void 0 ? b[1] : ReceiptType.Read, C = b.length > 2 && b[2] !== void 0 ? b[2] : !1;
			if (e) {
				var w = e.getId(), T = x.getRoom(e.getRoomId());
				if (T != null && T.hasPendingEvent(w)) throw Error(`Cannot set read receipt to a pending event (${w})`);
				return x.sendReceipt(e, S, {}, C);
			}
		})();
	}
	setRoomReadMarkers(e, b, x, S) {
		var C = this;
		return _asyncToGenerator(function* () {
			var w = C.getRoom(e);
			if (w != null && w.hasPendingEvent(b)) throw Error(`Cannot set read marker to a pending event (${b})`);
			var T;
			if (x) {
				if (T = x.getId(), w != null && w.hasPendingEvent(T)) throw Error(`Cannot set read receipt to a pending event (${T})`);
				w?.addLocalEchoReceipt(C.credentials.userId, x, ReceiptType.Read);
			}
			var E;
			if (S) {
				if (E = S.getId(), w != null && w.hasPendingEvent(E)) throw Error(`Cannot set read receipt to a pending event (${E})`);
				w?.addLocalEchoReceipt(C.credentials.userId, S, ReceiptType.ReadPrivate);
			}
			return yield C.setRoomReadMarkersHttpRequest(e, b, T, E);
		})();
	}
	sendRtcDecline(e, b) {
		return this.sendEvent(e, EventType.RTCDecline, { "m.relates_to": {
			event_id: b,
			rel_type: RelationType.Reference
		} });
	}
	getUrlPreview(e, b) {
		b = Math.floor(b / 6e4) * 6e4;
		var x = new URL(e);
		x.hash = "", e = x.toString();
		var S = b + "_" + e;
		if (S in this.urlPreviewCache) return this.urlPreviewCache[S];
		var C = this.http.authedRequest(Method.Get, "/preview_url", {
			url: e,
			ts: b.toString()
		}, void 0, {
			prefix: MediaPrefix.V3,
			priority: "low"
		});
		return this.urlPreviewCache[S] = C, C;
	}
	sendTyping(e, b, x) {
		if (this.isGuest()) return Promise.resolve({});
		var S = encodeUri("/rooms/$roomId/typing/$userId", {
			$roomId: e,
			$userId: this.getUserId()
		}), C = { typing: b };
		return b && (C.timeout = x || 2e4), this.http.authedRequest(Method.Put, S, void 0, C);
	}
	getRoomUpgradeHistory(e) {
		var b = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, x = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, S = this.getRoom(e);
		if (!S) return [];
		var C = this.findPredecessorRooms(S, b, x), w = this.findSuccessorRooms(S, b, x);
		return [
			...C,
			S,
			...w
		];
	}
	findPredecessorRooms(e, b, x) {
		for (var S = [], C = new Set([e.roomId]), w = e.findPredecessor(x)?.roomId; w !== null;) {
			if (w) {
				if (C.has(w)) break;
				C.add(w);
			}
			var T = this.getRoom(w);
			if (T === null) break;
			if (b) {
				var E = T.currentState.getStateEvents(EventType.RoomTombstone, "");
				if (!E || E.getContent().replacement_room !== e.roomId) break;
			}
			S.splice(0, 0, T), e = T, w = e.findPredecessor(x)?.roomId;
		}
		return S;
	}
	findSuccessorRooms(e, b, x) {
		for (var S = [], C = e.currentState.getStateEvents(EventType.RoomTombstone, ""); C;) {
			var w = this.getRoom(C.getContent().replacement_room);
			if (!w || w.roomId === e.roomId) break;
			if (b) {
				var T = w.findPredecessor(x)?.roomId;
				if (!T || T !== e.roomId) break;
			}
			if (S.push(w), new Set(S.map((e) => e.roomId)).size < S.length) return S.slice(0, S.length - 1);
			e = w, C = e.currentState.getStateEvents(EventType.RoomTombstone, "");
		}
		return S;
	}
	invite(e, b) {
		var x = arguments, S = this;
		return _asyncToGenerator(function* () {
			var C = x.length > 2 && x[2] !== void 0 ? x[2] : {};
			return typeof C != "object" && (C = { reason: C }), C.shareEncryptedHistory && (yield S.cryptoBackend?.shareRoomHistoryWithUser(e, b)), yield S.membershipChange(e, b, KnownMembership.Invite, C.reason);
		})();
	}
	inviteByEmail(e, b) {
		return this.inviteByThreePid(e, "email", b);
	}
	inviteByThreePid(e, b, x) {
		var S = this;
		return _asyncToGenerator(function* () {
			var C, w = encodeUri("/rooms/$roomId/invite", { $roomId: e }), T = S.getIdentityServerUrl(!0);
			if (!T) return Promise.reject(new MatrixError({
				error: "No supplied identity server URL",
				errcode: "ORG.MATRIX.JSSDK_MISSING_PARAM"
			}));
			var E = {
				id_server: T,
				medium: b,
				address: x
			};
			if ((C = S.identityServer) != null && C.getAccessToken) {
				var D = yield S.identityServer.getAccessToken();
				D && (E.id_access_token = D);
			}
			return S.http.authedRequest(Method.Post, w, void 0, E);
		})();
	}
	leave(e) {
		return this.membershipChange(e, void 0, KnownMembership.Leave);
	}
	leaveRoomChain(e) {
		var b = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, x = this.getRoomUpgradeHistory(e, !0), S = x;
		if (!b) {
			S = [];
			for (var C of x) if (S.push(C), C.roomId === e) break;
		}
		var w = {}, T = [], E = (e) => this.leave(e).then(() => {
			delete w[e];
		}).catch((b) => {
			w[e] = b;
		});
		for (var D of S) T.push(E(D.roomId));
		return Promise.all(T).then(() => w);
	}
	ban(e, b, x) {
		return this.membershipChange(e, b, KnownMembership.Ban, x);
	}
	forget(e) {
		var b = arguments, x = this;
		return _asyncToGenerator(function* () {
			var S = b.length > 1 && b[1] !== void 0 ? b[1] : !0, C = encodeUri("/rooms/$room_id/forget", { $room_id: e }), w = yield x.http.authedRequest(Method.Post, C);
			return S && (x.store.removeRoom(e), x.emit(ClientEvent.DeleteRoom, e)), w;
		})();
	}
	unban(e, b) {
		var x = encodeUri("/rooms/$roomId/unban", { $roomId: e }), S = { user_id: b };
		return this.http.authedRequest(Method.Post, x, void 0, S);
	}
	kick(e, b, x) {
		var S = encodeUri("/rooms/$roomId/kick", { $roomId: e }), C = {
			user_id: b,
			reason: x
		};
		return this.http.authedRequest(Method.Post, S, void 0, C);
	}
	membershipChange(e, b, x, S) {
		var C = encodeUri("/rooms/$room_id/$membership", {
			$room_id: e,
			$membership: x
		});
		return this.http.authedRequest(Method.Post, C, void 0, {
			user_id: b,
			reason: S
		});
	}
	getPushActionsForEvent(e) {
		var b = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
		if (!e.getPushActions() || b) {
			var { actions: x, rule: S } = this.pushProcessor.actionsAndRuleForEvent(e);
			e.setPushDetails(x, S);
		}
		return e.getPushActions();
	}
	getPushDetailsForEvent(e) {
		var b = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
		if (!e.getPushDetails() || b) {
			var { actions: x, rule: S } = this.pushProcessor.actionsAndRuleForEvent(e);
			e.setPushDetails(x, S);
		}
		return e.getPushDetails();
	}
	setProfileInfo(e, b) {
		var x = encodeUri("/profile/$userId/$info", {
			$userId: this.credentials.userId,
			$info: e
		});
		return this.http.authedRequest(Method.Put, x, void 0, b);
	}
	setDisplayName(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			var x = yield b.setProfileInfo("displayname", { displayname: e }), S = b.getUser(b.getUserId());
			return S && (S.displayName = e, S.emit(UserEvent.DisplayName, S.events.presence, S)), x;
		})();
	}
	setAvatarUrl(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			var x = yield b.setProfileInfo("avatar_url", { avatar_url: e }), S = b.getUser(b.getUserId());
			return S && (S.avatarUrl = e, S.emit(UserEvent.AvatarUrl, S.events.presence, S)), x;
		})();
	}
	mxcUrlToHttp(e, b, x, S, C, w, T) {
		return getHttpUriForMxc(this.baseUrl, e, b, x, S, C, w, T);
	}
	setSyncPresence(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			var x;
			(x = b.syncApi) == null || x.setPresence(e);
		})();
	}
	setPresence(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			var x = encodeUri("/presence/$userId/status", { $userId: b.credentials.userId });
			if ([
				"offline",
				"online",
				"unavailable"
			].indexOf(e.presence) === -1) throw Error("Bad presence value: " + e.presence);
			yield b.http.authedRequest(Method.Put, x, void 0, e);
		})();
	}
	getPresence(e) {
		var b = encodeUri("/presence/$userId/status", { $userId: e });
		return this.http.authedRequest(Method.Get, b);
	}
	scrollback(e) {
		var b = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 30, x = 0, S = this.ongoingScrollbacks[e.roomId] || {};
		if (S.promise) return S.promise;
		if (S.errorTs) {
			var C = Date.now() - S.errorTs;
			x = Math.max(SCROLLBACK_DELAY_MS - C, 0);
		}
		if (e.oldState.paginationToken === null) return Promise.resolve(e);
		var w = this.store.scrollback(e, b).length;
		if (w === b) return Promise.resolve(e);
		b -= w;
		var T = new Promise((S, C) => {
			sleep(x).then(() => this.createMessagesRequest(e.roomId, e.oldState.paginationToken, b, Direction.Backward)).then((b) => {
				var x = b.chunk.map(this.getEventMapper());
				if (b.state) {
					var C = b.state.map(this.getEventMapper());
					e.currentState.setUnknownStateEvents(C);
				}
				var [w, T, E] = e.partitionThreadedEvents(x);
				this.processAggregatedTimelineEvents(e, w), e.addEventsToTimeline(w, !0, !0, e.getLiveTimeline()), this.processThreadEvents(e, T, !0), E.forEach((b) => e.relations.aggregateChildEvent(b)), e.oldState.paginationToken = b.end ?? null, b.chunk.length === 0 && (e.oldState.paginationToken = null), this.store.storeEvents(e, x, b.end ?? null, !0), delete this.ongoingScrollbacks[e.roomId], S(e);
			}).catch((b) => {
				this.ongoingScrollbacks[e.roomId] = { errorTs: Date.now() }, C(b);
			});
		});
		return S = { promise: T }, this.ongoingScrollbacks[e.roomId] = S, T;
	}
	getEventMapper(e) {
		return eventMapperFor(this, e || {});
	}
	getEventContext(e, b) {
		var x = this;
		return _asyncToGenerator(function* () {
			var S, C = encodeUri("/rooms/$roomId/context/$eventId", {
				$roomId: e,
				$eventId: b
			}), w = { limit: "0" };
			(S = x.clientOpts) != null && S.lazyLoadMembers && (w.filter = JSON.stringify(Filter.LAZY_LOADING_MESSAGES_FILTER));
			var T = yield x.http.authedRequest(Method.Get, C, w);
			if (T.event) return {
				start: T.start,
				end: T.end,
				event: T.event,
				events_after: T.events_after ?? [],
				events_before: T.events_before ?? [],
				state: T.state ?? []
			};
			throw Error("'event' not in '/context' result - homeserver too old?");
		})();
	}
	getEventTimeline(e, b) {
		var x = this;
		return _asyncToGenerator(function* () {
			if (!x.timelineSupport) throw Error("timeline support is disabled. Set the 'timelineSupport' parameter to true when creating MatrixClient to enable it.");
			if (!(e != null && e.room)) throw Error("getEventTimeline only supports room timelines");
			if (e.getTimelineForEvent(b)) return e.getTimelineForEvent(b);
			if (e.thread && x.supportsThreads()) return (yield x.getThreadTimeline(e, b)) ?? null;
			var S = yield x.getEventContext(e.room.roomId, b);
			if (e.getTimelineForEvent(b)) return e.getTimelineForEvent(b);
			var C = x.getEventMapper(), w = C(S.event);
			if (w.isRelation(THREAD_RELATION_TYPE.name)) return x.logger.warn("Tried loading a regular timeline at the position of a thread event"), null;
			var T = [
				...S.events_after.reverse().map(C),
				w,
				...S.events_before.map(C)
			], E = e.getTimelineForEvent(T[0].getId());
			E ? E.getState(EventTimeline.BACKWARDS).setUnknownStateEvents(S.state.map(C)) : (E = e.addTimeline(), E.initialiseState(S.state.map(C)), E.getState(EventTimeline.FORWARDS).paginationToken = S.end ?? null);
			var [D, O, k] = e.room.partitionThreadedEvents(T);
			return e.addEventsToTimeline(D, !0, !1, E, S.start), x.processThreadEvents(e.room, O, !0), x.processAggregatedTimelineEvents(e.room, D), k.forEach((b) => e.relations.aggregateChildEvent(b)), e.getTimelineForEvent(b) ?? e.room.findThreadForEvent(w)?.liveTimeline ?? E;
		})();
	}
	getThreadTimeline(e, b) {
		var x = this;
		return _asyncToGenerator(function* () {
			if (!x.supportsThreads()) throw Error("could not get thread timeline: no client support");
			if (!e.room) throw Error("could not get thread timeline: not a room timeline");
			if (!e.thread) throw Error("could not get thread timeline: not a thread timeline");
			var S = yield x.getEventContext(e.room.roomId, b), C = x.getEventMapper(), w = C(S.event);
			if (e.canContain(w)) {
				var T = x.canSupport.get(Feature.RelationsRecursion) !== ServerSupport.Unsupported;
				if (Thread.hasServerSideSupport) if (Thread.hasServerSideFwdPaginationSupport) {
					if (!e.thread) throw Error("could not get thread timeline: not a thread timeline");
					var E = e.thread, D = yield x.fetchRelations(e.room.roomId, E.id, null, null, {
						dir: Direction.Backward,
						from: S.start,
						recurse: T || void 0
					}), O = yield x.fetchRelations(e.room.roomId, E.id, null, null, {
						dir: Direction.Forward,
						from: S.end,
						recurse: T || void 0
					}), k = [
						...O.chunk.reverse().filter(getRelationsThreadFilter(E.id)).map(C),
						w,
						...D.chunk.filter(getRelationsThreadFilter(E.id)).map(C)
					];
					for (var A of k) yield e.thread?.processEvent(A);
					var j = e.getTimelineForEvent(w.getId());
					if (j ? j.getState(EventTimeline.BACKWARDS).setUnknownStateEvents(S.state.map(C)) : (j = e.addTimeline(), j.initialiseState(S.state.map(C))), e.addEventsToTimeline(k, !0, !1, j, O.next_batch), !D.next_batch) {
						var M = yield x.fetchRoomEvent(e.room.roomId, E.id);
						e.addEventsToTimeline([C(M)], !0, !1, j, null);
					}
					return j.setPaginationToken(D.next_batch ?? null, Direction.Backward), j.setPaginationToken(O.next_batch ?? null, Direction.Forward), x.processAggregatedTimelineEvents(e.room, k), e.getTimelineForEvent(b) ?? j;
				} else {
					for (var N = e.thread, P = yield x.fetchRelations(e.room.roomId, N.id, THREAD_RELATION_TYPE.name, null, {
						dir: Direction.Backward,
						from: S.start,
						recurse: T || void 0
					}), F = [], I = S.end; I;) {
						var L = yield x.fetchRelations(e.room.roomId, N.id, THREAD_RELATION_TYPE.name, null, {
							dir: Direction.Forward,
							from: I,
							recurse: T || void 0
						});
						I = L.next_batch, F.push(...L.chunk);
					}
					var R = [
						...F.reverse().map(C),
						w,
						...P.chunk.map(C)
					];
					for (var z of R) yield e.thread?.processEvent(z);
					var B = e.getLiveTimeline();
					if (B.getState(EventTimeline.BACKWARDS).setUnknownStateEvents(S.state.map(C)), e.addEventsToTimeline(R, !0, !1, B, null), !P.next_batch) {
						var V = yield x.fetchRoomEvent(e.room.roomId, N.id);
						e.addEventsToTimeline([C(V)], !0, !1, B, null);
					}
					return B.setPaginationToken(P.next_batch ?? null, Direction.Backward), B.setPaginationToken(null, Direction.Forward), x.processAggregatedTimelineEvents(e.room, R), B;
				}
			}
		})();
	}
	getLatestTimeline(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			if (!b.timelineSupport) throw Error("timeline support is disabled. Set the 'timelineSupport' parameter to true when creating MatrixClient to enable it.");
			if (!e.room) throw Error("getLatestTimeline only supports room timelines");
			var x;
			if (e.threadListType !== null) x = (yield b.createThreadListMessagesRequest(e.room.roomId, null, 1, Direction.Backward, e.threadListType, e.getFilter())).chunk?.[0];
			else if (e.thread && Thread.hasServerSideSupport) {
				var S = b.canSupport.get(Feature.RelationsRecursion) !== ServerSupport.Unsupported;
				x = (yield b.fetchRelations(e.room.roomId, e.thread.id, THREAD_RELATION_TYPE.name, null, {
					dir: Direction.Backward,
					limit: 1,
					recurse: S || void 0
				})).chunk?.[0];
			} else {
				var C, w = encodeUri("/rooms/$roomId/messages", { $roomId: e.room.roomId }), T = { dir: "b" };
				(C = b.clientOpts) != null && C.lazyLoadMembers && (T.filter = JSON.stringify(Filter.LAZY_LOADING_MESSAGES_FILTER)), x = (yield b.http.authedRequest(Method.Get, w, T)).chunk?.[0];
			}
			if (!x) throw Error("No message returned when trying to construct getLatestTimeline");
			return b.getEventTimeline(e, x.event_id);
		})();
	}
	createMessagesRequest(e, b) {
		var x, S = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 30, C = arguments.length > 3 ? arguments[3] : void 0, w = arguments.length > 4 ? arguments[4] : void 0, T = encodeUri("/rooms/$roomId/messages", { $roomId: e }), E = {
			limit: S.toString(),
			dir: C
		};
		b && (E.from = b);
		var D = null;
		return (x = this.clientOpts) != null && x.lazyLoadMembers && (D = Object.assign({}, Filter.LAZY_LOADING_MESSAGES_FILTER)), w && (D ||= {}, Object.assign(D, w.getRoomTimelineFilterComponent()?.toJSON())), D && (E.filter = JSON.stringify(D)), this.http.authedRequest(Method.Get, T, E);
	}
	createThreadListMessagesRequest(e, b) {
		var x, S = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 30, C = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : Direction.Backward, w = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : ThreadFilterType.All, T = arguments.length > 5 ? arguments[5] : void 0, E = encodeUri("/rooms/$roomId/threads", { $roomId: e }), D = {
			limit: S.toString(),
			dir: C,
			include: threadFilterTypeToFilter(w)
		};
		b && (D.from = b);
		var O = {};
		(x = this.clientOpts) != null && x.lazyLoadMembers && (O = _objectSpread$1({}, Filter.LAZY_LOADING_MESSAGES_FILTER)), T && (O = _objectSpread$1(_objectSpread$1({}, O), T.getRoomTimelineFilterComponent()?.toJSON())), Object.keys(O).length && (D.filter = JSON.stringify(O));
		var k = { prefix: Thread.hasServerSideListSupport === FeatureSupport.Stable ? ClientPrefix.V1 : "/_matrix/client/unstable/org.matrix.msc3856" };
		return this.http.authedRequest(Method.Get, E, D, void 0, k).then((e) => _objectSpread$1(_objectSpread$1({}, e), {}, {
			chunk: e.chunk?.reverse(),
			start: e.prev_batch,
			end: e.next_batch
		}));
	}
	paginateEventTimeline(e, b) {
		var x = this, S = e.getTimelineSet() === this.notifTimelineSet, C = this.getRoom(e.getRoomId()), w = e.getTimelineSet().threadListType, T = e.getTimelineSet().thread;
		b ||= {};
		var E = b.backwards || !1;
		if (S && !E) throw Error("paginateNotifTimeline can only paginate backwards");
		var D = E ? EventTimeline.BACKWARDS : EventTimeline.FORWARDS, O = e.getPaginationToken(D), k = e.paginationRequests[D];
		if (k) return k;
		var A, j, N;
		if (S) A = "/notifications", j = {
			limit: (b.limit ?? 30).toString(),
			only: "highlight"
		}, O && O !== "end" && (j.from = O), N = this.http.authedRequest(Method.Get, A, j).then(/* @__PURE__ */ function() {
			var b = _asyncToGenerator(function* (b) {
				var S = b.next_token, C = [];
				b.notifications = b.notifications.filter(noUnsafeEventProps);
				for (var w = 0; w < b.notifications.length; w++) {
					var T = b.notifications[w], O = x.getEventMapper()(T.event);
					x.getPushDetailsForEvent(O, !0), O.event.room_id = T.room_id, C[w] = O;
				}
				var k = e.getTimelineSet();
				return k.addEventsToTimeline(C, E, !1, e, S), x.processAggregatedTimelineEvents(k.room, C), E && !b.next_token && e.setPaginationToken(null, D), !!b.next_token;
			});
			return function(e) {
				return b.apply(this, arguments);
			};
		}()).finally(() => {
			e.paginationRequests[D] = null;
		}), e.paginationRequests[D] = N;
		else if (w !== null) {
			if (!C) throw Error("Unknown room " + e.getRoomId());
			if (!Thread.hasServerSideFwdPaginationSupport && D === Direction.Forward) throw Error("Cannot paginate threads forwards without server-side support for MSC 3715");
			N = this.createThreadListMessagesRequest(e.getRoomId(), O, b.limit, D, w, e.getFilter()).then((b) => {
				if (b.state) {
					var x = e.getState(D), S = b.state.filter(noUnsafeEventProps).map(this.getEventMapper());
					x.setUnknownStateEvents(S);
				}
				var w = b.end, T = b.chunk.filter(noUnsafeEventProps).map(this.getEventMapper());
				return e.getTimelineSet().addEventsToTimeline(T, E, !1, e, w), this.processAggregatedTimelineEvents(C, T), this.processThreadRoots(C, T, E), E && b.end == b.start && e.setPaginationToken(null, D), b.end !== b.start;
			}).finally(() => {
				e.paginationRequests[D] = null;
			}), e.paginationRequests[D] = N;
		} else if (T) {
			var P = this.getRoom(e.getRoomId() ?? void 0);
			if (!P) throw Error("Unknown room " + e.getRoomId());
			var F = this.canSupport.get(Feature.RelationsRecursion) !== ServerSupport.Unsupported;
			N = this.fetchRelations(e.getRoomId() ?? "", T.id, null, null, {
				dir: D,
				limit: b.limit,
				from: O ?? void 0,
				recurse: F || void 0
			}).then(/* @__PURE__ */ function() {
				var b = _asyncToGenerator(function* (b) {
					var S = x.getEventMapper(), C = b.chunk.filter(noUnsafeEventProps).filter(getRelationsThreadFilter(T.id)).map(S);
					for (var w of C.slice().reverse()) {
						yield T?.processEvent(w);
						var O = w.getSender();
						(!E || T?.getEventReadUpTo(O) === null) && P.addLocalEchoReceipt(O, w, ReceiptType.Read);
					}
					var k = b.next_batch, A = e.getTimelineSet();
					if (A.addEventsToTimeline(C, E, !1, e, k ?? null), !k && E) {
						var j = T.rootEvent ?? S(yield x.fetchRoomEvent(e.getRoomId() ?? "", T.id));
						A.addEventsToTimeline([j], !0, !1, e, null);
					}
					return x.processAggregatedTimelineEvents(A.room, C), E && !k && e.setPaginationToken(null, D), !!k;
				});
				return function(e) {
					return b.apply(this, arguments);
				};
			}()).finally(() => {
				e.paginationRequests[D] = null;
			}), e.paginationRequests[D] = N;
		} else {
			if (!C) throw Error("Unknown room " + e.getRoomId());
			N = this.createMessagesRequest(e.getRoomId(), O, b.limit, D, e.getFilter()).then((b) => {
				if (b.state) {
					var x = e.getState(D), S = b.state.filter(noUnsafeEventProps).map(this.getEventMapper());
					x.setUnknownStateEvents(S);
				}
				var w = b.end, T = b.chunk.filter(noUnsafeEventProps).map(this.getEventMapper()), O = e.getTimelineSet(), [k, , A] = C.partitionThreadedEvents(T);
				O.addEventsToTimeline(k, E, !1, e, w), this.processAggregatedTimelineEvents(C, k), this.processThreadRoots(C, k.filter((e) => e.getServerAggregatedRelation(THREAD_RELATION_TYPE.name)), !1), A.forEach((e) => C.relations.aggregateChildEvent(e));
				var j = b.end === void 0 || b.end === b.start;
				return E && j && e.setPaginationToken(null, D), !j;
			}).finally(() => {
				e.paginationRequests[D] = null;
			}), e.paginationRequests[D] = N;
		}
		return N;
	}
	resetNotifTimelineSet() {
		this.notifTimelineSet && this.notifTimelineSet.resetLiveTimeline("end");
	}
	peekInRoom(e) {
		var b, x = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 20;
		return (b = this.peekSync) == null || b.stopPeeking(), this.peekSync = new SyncApi(this, this.clientOpts, this.buildSyncApiOptions()), this.peekSync.peek(e, x);
	}
	stopPeeking() {
		this.peekSync &&= (this.peekSync.stopPeeking(), null);
	}
	setGuestAccess(e, b) {
		var x = this.sendStateEvent(e, EventType.RoomGuestAccess, { guest_access: b.allowJoin ? GuestAccess.CanJoin : GuestAccess.Forbidden }, ""), S = Promise.resolve();
		return b.allowRead && (S = this.sendStateEvent(e, EventType.RoomHistoryVisibility, { history_visibility: HistoryVisibility.WorldReadable }, "")), Promise.all([S, x]).then();
	}
	requestRegisterEmailToken(e, b, x, S) {
		return this.requestTokenFromEndpoint("/register/email/requestToken", {
			email: e,
			client_secret: b,
			send_attempt: x,
			next_link: S
		});
	}
	requestRegisterMsisdnToken(e, b, x, S, C) {
		return this.requestTokenFromEndpoint("/register/msisdn/requestToken", {
			country: e,
			phone_number: b,
			client_secret: x,
			send_attempt: S,
			next_link: C
		});
	}
	requestAdd3pidEmailToken(e, b, x, S) {
		return this.requestTokenFromEndpoint("/account/3pid/email/requestToken", {
			email: e,
			client_secret: b,
			send_attempt: x,
			next_link: S
		});
	}
	requestAdd3pidMsisdnToken(e, b, x, S, C) {
		return this.requestTokenFromEndpoint("/account/3pid/msisdn/requestToken", {
			country: e,
			phone_number: b,
			client_secret: x,
			send_attempt: S,
			next_link: C
		});
	}
	requestPasswordEmailToken(e, b, x, S) {
		return this.requestTokenFromEndpoint("/account/password/email/requestToken", {
			email: e,
			client_secret: b,
			send_attempt: x,
			next_link: S
		});
	}
	requestPasswordMsisdnToken(e, b, x, S, C) {
		return this.requestTokenFromEndpoint("/account/password/msisdn/requestToken", {
			country: e,
			phone_number: b,
			client_secret: x,
			send_attempt: S,
			next_link: C
		});
	}
	requestTokenFromEndpoint(e, b) {
		var x = this;
		return _asyncToGenerator(function* () {
			var S = Object.assign({}, b);
			return x.http.request(Method.Post, e, void 0, S);
		})();
	}
	getRoomPushRule(e, b) {
		if (this.pushRules) {
			var x;
			return (x = this.pushRules[e]) == null || (x = x.room) == null ? void 0 : x.find((e) => e.rule_id === b);
		} else throw Error("SyncApi.sync() must be done before accessing to push rules.");
	}
	setRoomMutePushRule(e, b, x) {
		var S, C = !1, w = this.getRoomPushRule(e, b);
		if (w != null && w.actions.includes(PushRuleActionName.DontNotify) && (C = !0), !x) C && (S = this.deletePushRule(e, PushRuleKind.RoomSpecific, w.rule_id));
		else if (!w) S = this.addPushRule(e, PushRuleKind.RoomSpecific, b, { actions: [PushRuleActionName.DontNotify] });
		else if (!C) {
			var T = Promise.withResolvers();
			this.deletePushRule(e, PushRuleKind.RoomSpecific, w.rule_id).then(() => {
				this.addPushRule(e, PushRuleKind.RoomSpecific, b, { actions: [PushRuleActionName.DontNotify] }).then(() => {
					T.resolve();
				}).catch((e) => {
					T.reject(e);
				});
			}).catch((e) => {
				T.reject(e);
			}), S = T.promise;
		}
		if (S) return new Promise((e, b) => {
			S.then(() => {
				this.getPushRules().then((b) => {
					this.pushRules = b, e();
				}).catch((e) => {
					b(e);
				});
			}).catch((e) => {
				this.getPushRules().then((x) => {
					this.pushRules = x, b(e);
				}).catch((x) => {
					b(e);
				});
			});
		});
	}
	searchMessageText(e) {
		var b = { search_term: e.query };
		return "keys" in e && (b.keys = e.keys), this.search({ body: { search_categories: { room_events: b } } });
	}
	searchRoomEvents(e) {
		var b = { search_categories: { room_events: {
			search_term: e.term,
			filter: e.filter,
			order_by: SearchOrderBy.Recent,
			event_context: {
				before_limit: 1,
				after_limit: 1,
				include_profile: !0
			}
		} } }, x = {
			_query: b,
			results: [],
			highlights: []
		};
		return this.search({ body: b }).then((e) => this.processRoomEventsSearch(x, e));
	}
	backPaginateRoomEventsSearch(e) {
		if (!e.next_batch) return Promise.reject(/* @__PURE__ */ Error("Cannot backpaginate event search any further"));
		if (e.pendingRequest) return e.pendingRequest;
		var b = {
			body: e._query,
			next_batch: e.next_batch
		}, x = this.search(b, e.abortSignal).then((b) => this.processRoomEventsSearch(e, b)).finally(() => {
			e.pendingRequest = void 0;
		});
		return e.pendingRequest = x, x;
	}
	processRoomEventsSearch(e, b) {
		var x = b.search_categories.room_events;
		e.count = x.count, e.next_batch = x.next_batch;
		var S = new Set(x.highlights);
		e.highlights.forEach((e) => {
			S.add(e);
		}), e.highlights = Array.from(S);
		for (var C = this.getEventMapper(), w = x.results?.length ?? 0, T = 0; T < w; T++) {
			var E = SearchResult.fromJson(x.results[T], C), D = this.getRoom(E.context.getEvent().getRoomId());
			if (D) for (var O of E.context.getTimeline()) O.setMetadata(D.currentState, !1);
			e.results.push(E);
		}
		return e;
	}
	syncLeftRooms() {
		return this.syncedLeftRooms ? Promise.resolve([]) : this.syncLeftRoomsPromise ? this.syncLeftRoomsPromise : (this.syncLeftRoomsPromise = new SyncApi(this, this.clientOpts, this.buildSyncApiOptions()).syncLeftRooms(), this.syncLeftRoomsPromise.then(() => {
			this.logger.debug("Marking success of sync left room request"), this.syncedLeftRooms = !0;
		}).finally(() => {
			this.syncLeftRoomsPromise = void 0;
		}), this.syncLeftRoomsPromise);
	}
	createFilter(e) {
		var b = encodeUri("/user/$userId/filter", { $userId: this.credentials.userId });
		return this.http.authedRequest(Method.Post, b, void 0, e).then((b) => {
			var x = Filter.fromJson(this.credentials.userId, b.filter_id, e);
			return this.store.storeFilter(x), x;
		});
	}
	getFilter(e, b, x) {
		if (x) {
			var S = this.store.getFilter(e, b);
			if (S) return Promise.resolve(S);
		}
		var C = encodeUri("/user/$userId/filter/$filterId", {
			$userId: e,
			$filterId: b
		});
		return this.http.authedRequest(Method.Get, C).then((x) => {
			var S = Filter.fromJson(e, b, x);
			return this.store.storeFilter(S), S;
		});
	}
	getOrCreateFilter(e, b) {
		var x = this;
		return _asyncToGenerator(function* () {
			var S = x.store.getFilterIdByName(e), C;
			if (S) {
				try {
					var w = yield x.getFilter(x.credentials.userId, S, !0);
					if (w) {
						var T = w.getDefinition(), E = b.getDefinition();
						deepCompare(T, E) && (C = S);
					}
				} catch (e) {
					if (e.errcode !== "M_UNKNOWN" && e.errcode !== "M_NOT_FOUND") throw e;
				}
				C || x.store.setFilterIdByName(e, void 0);
			}
			if (C) return C;
			var D = yield x.createFilter(b.getDefinition());
			return x.store.setFilterIdByName(e, D.filterId), D.filterId;
		})();
	}
	getOpenIdToken() {
		var e = encodeUri("/user/$userId/openid/request_token", { $userId: this.credentials.userId });
		return this.http.authedRequest(Method.Post, e, void 0, {});
	}
	turnServer() {
		return this.http.authedRequest(Method.Get, "/voip/turnServer");
	}
	getTurnServers() {
		return this.turnServers || [];
	}
	getTurnServersExpiry() {
		return this.turnServersExpiry;
	}
	get pollingTurnServers() {
		return this.checkTurnServersIntervalID !== void 0;
	}
	checkTurnServers() {
		var e = this;
		return _asyncToGenerator(function* () {
			if (e.supportsVoip()) {
				var b = !1, x = e.turnServersExpiry - Date.now();
				if (x > TURN_CHECK_INTERVAL) e.logger.debug("TURN creds are valid for another " + x + " ms: not fetching new ones."), b = !0;
				else {
					e.logger.debug("Fetching new TURN credentials");
					try {
						var S = yield e.turnServer();
						S.uris && (e.logger.debug("Got TURN URIs: " + S.uris + " refresh in " + S.ttl + " secs"), e.turnServers = [{
							urls: S.uris,
							username: S.username,
							credential: S.password
						}], e.turnServersExpiry = Date.now() + S.ttl * 1e3, b = !0, e.emit(ClientEvent.TurnServers, e.turnServers));
					} catch (b) {
						e.logger.error("Failed to get TURN URIs", b), b.httpStatus === 403 ? (e.logger.info("TURN access unavailable for this account: stopping credentials checks"), e.checkTurnServersIntervalID !== null && globalThis.clearInterval(e.checkTurnServersIntervalID), e.checkTurnServersIntervalID = void 0, e.emit(ClientEvent.TurnServersError, b, !0)) : e.emit(ClientEvent.TurnServersError, b, !1);
					}
				}
				return b;
			}
		})();
	}
	setFallbackICEServerAllowed(e) {
		this.fallbackICEServerAllowed = e;
	}
	isFallbackICEServerAllowed() {
		return this.fallbackICEServerAllowed;
	}
	isSynapseAdministrator() {
		var e = encodeUri("/_synapse/admin/v1/users/$userId/admin", { $userId: this.getUserId() });
		return this.http.authedRequest(Method.Get, e, void 0, void 0, { prefix: "" }).then((e) => e.admin);
	}
	whoisSynapseUser(e) {
		var b = encodeUri("/_synapse/admin/v1/whois/$userId", { $userId: e });
		return this.http.authedRequest(Method.Get, b, void 0, void 0, { prefix: "" });
	}
	deactivateSynapseUser(e) {
		var b = encodeUri("/_synapse/admin/v1/deactivate/$userId", { $userId: e });
		return this.http.authedRequest(Method.Post, b, void 0, void 0, { prefix: "" });
	}
	fetchClientWellKnown() {
		var e = this;
		return _asyncToGenerator(function* () {
			e.clientWellKnownPromise = AutoDiscovery.getRawClientConfig(e.getDomain() ?? void 0), e.clientWellKnown = yield e.clientWellKnownPromise, e.emit(ClientEvent.ClientWellKnown, e.clientWellKnown);
		})();
	}
	getClientWellKnown() {
		return this.clientWellKnown;
	}
	waitForClientWellKnown() {
		if (!this.clientRunning) throw Error("Client is not running");
		return this.clientWellKnownPromise;
	}
	storeClientOptions() {
		var e = [
			"boolean",
			"string",
			"number"
		], b = Object.entries(this.clientOpts).filter((b) => {
			var [x, S] = b;
			return e.includes(typeof S);
		}).reduce((e, b) => {
			var [x, S] = b;
			return e[x] = S, e;
		}, {});
		return this.store.storeClientOptions(b);
	}
	_unstable_getSharedRooms(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			var x = yield b.doesServerSupportUnstableFeature(UNSTABLE_MSC2666_SHARED_ROOMS), S = yield b.doesServerSupportUnstableFeature(UNSTABLE_MSC2666_MUTUAL_ROOMS), C = yield b.doesServerSupportUnstableFeature(UNSTABLE_MSC2666_QUERY_MUTUAL_ROOMS);
			if (!x && !S && !C) throw Error("Server does not support the Mutual Rooms API");
			var w, T;
			C ? (w = "/uk.half-shot.msc2666/user/mutual_rooms", T = { user_id: e }) : (w = encodeUri(`/uk.half-shot.msc2666/user/${S ? "mutual_rooms" : "shared_rooms"}/\$userId`, { $userId: e }), T = {});
			var E = [], D = null;
			do {
				var O = {};
				D != null && C && (O.batch_token = D);
				var k = yield b.http.authedRequest(Method.Get, w, _objectSpread$1(_objectSpread$1({}, T), O), void 0, { prefix: ClientPrefix.Unstable });
				E.push(...k.joined), D = k.next_batch_token === void 0 ? null : k.next_batch_token;
			} while (D != null);
			return E;
		})();
	}
	getVersions() {
		var e = this;
		return _asyncToGenerator(function* () {
			if (e.serverVersionsPromise) return e.serverVersionsPromise;
			e.serverVersionsPromise = e.http.authedRequest(Method.Get, "/_matrix/client/versions", void 0, void 0, { prefix: "" }).catch((b) => {
				throw e.serverVersionsPromise = void 0, b;
			});
			var b = yield e.serverVersionsPromise;
			return e.canSupport = yield buildFeatureSupportMap(b), e.serverVersionsPromise;
		})();
	}
	isVersionSupported(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			var { versions: x } = yield b.getVersions();
			return x && x.includes(e);
		})();
	}
	doesServerSupportUnstableFeature(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			var x = yield b.getVersions();
			if (!x) return !1;
			var S = x.unstable_features;
			return S && !!S[e];
		})();
	}
	doesServerForceEncryptionForPreset(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			var x = yield b.getVersions();
			if (!x) return !1;
			var S = x.unstable_features, C = e.includes("_chat") ? e.substring(0, e.indexOf("_chat")) : e;
			return S && !!S[`io.element.e2ee_forced.${C}`];
		})();
	}
	doesServerSupportThread() {
		var e = this;
		return _asyncToGenerator(function* () {
			if (yield e.isVersionSupported("v1.4")) return {
				threads: FeatureSupport.Stable,
				list: FeatureSupport.Stable,
				fwdPagination: FeatureSupport.Stable
			};
			try {
				var [b, x, S, C, w, T] = yield Promise.all([
					e.doesServerSupportUnstableFeature("org.matrix.msc3440"),
					e.doesServerSupportUnstableFeature("org.matrix.msc3440.stable"),
					e.doesServerSupportUnstableFeature("org.matrix.msc3856"),
					e.doesServerSupportUnstableFeature("org.matrix.msc3856.stable"),
					e.doesServerSupportUnstableFeature("org.matrix.msc3715"),
					e.doesServerSupportUnstableFeature("org.matrix.msc3715.stable")
				]);
				return {
					threads: determineFeatureSupport(x, b),
					list: determineFeatureSupport(C, S),
					fwdPagination: determineFeatureSupport(T, w)
				};
			} catch {
				return {
					threads: FeatureSupport.None,
					list: FeatureSupport.None,
					fwdPagination: FeatureSupport.None
				};
			}
		})();
	}
	hasLazyLoadMembersEnabled() {
		var e;
		return !!((e = this.clientOpts) != null && e.lazyLoadMembers);
	}
	setCanResetTimelineCallback(e) {
		this.canResetTimelineCallback = e;
	}
	getCanResetTimelineCallback() {
		return this.canResetTimelineCallback;
	}
	relations(e, b, x, S) {
		var C = arguments, w = this;
		return _asyncToGenerator(function* () {
			var T = C.length > 4 && C[4] !== void 0 ? C[4] : { dir: Direction.Backward }, E = S ? w.getEncryptedIfNeededEventType(e, S) : null, [D, O] = yield Promise.all([w.fetchRoomEvent(e, b), w.fetchRelations(e, b, x, E, T)]), k = w.getEventMapper(), A = D ? k(D) : void 0, j = O.chunk.map(k);
			if (E === EventType.RoomMessageEncrypted) {
				var M = A ? j.concat(A) : j;
				yield Promise.all(M.map((e) => w.decryptEventIfNeeded(e))), S !== null && (j = j.filter((e) => e.getType() === S));
			}
			return A && x === RelationType.Replace && (j = j.filter((e) => e.getSender() === A.getSender())), {
				originalEvent: A ?? null,
				events: j,
				nextBatch: O.next_batch ?? null,
				prevBatch: O.prev_batch ?? null
			};
		})();
	}
	generateClientSecret() {
		return secureRandomString(32);
	}
	decryptEventIfNeeded(e, b) {
		return e.isState() && !this.enableEncryptedStateEvents ? Promise.resolve() : (e.shouldAttemptDecryption() && this.getCrypto() && e.attemptDecryption(this.cryptoBackend, b), e.isBeingDecrypted() ? e.getDecryptionPromise() : Promise.resolve());
	}
	termsUrlForService(e, b) {
		switch (e) {
			case SERVICE_TYPES.IS: return this.http.getUrl("/terms", void 0, IdentityPrefix.V2, b);
			case SERVICE_TYPES.IM: return this.http.getUrl("/terms", void 0, "/_matrix/integrations/v1", b);
			default: throw Error("Unsupported service type");
		}
	}
	getHomeserverUrl() {
		return this.baseUrl;
	}
	getIdentityServerUrl() {
		var e, b;
		return arguments.length > 0 && arguments[0] !== void 0 && arguments[0] && ((e = this.idBaseUrl) != null && e.startsWith("http://") || (b = this.idBaseUrl) != null && b.startsWith("https://")) ? this.idBaseUrl.split("://")[1] : this.idBaseUrl;
	}
	setIdentityServerUrl(e) {
		this.idBaseUrl = ensureNoTrailingSlash(e), this.http.setIdBaseUrl(this.idBaseUrl);
	}
	getAccessToken() {
		return this.http.opts.accessToken || null;
	}
	getRefreshToken() {
		return this.http.opts.refreshToken ?? null;
	}
	setAccessToken(e) {
		this.http.opts.accessToken = e, this.serverVersionsPromise = void 0;
	}
	isLoggedIn() {
		return this.http.opts.accessToken !== void 0;
	}
	makeTxnId() {
		return "m" + (/* @__PURE__ */ new Date()).getTime() + "." + this.txnCtr++;
	}
	isUsernameAvailable(e) {
		return this.http.authedRequest(Method.Get, "/register/available", { username: e }).then((e) => e.available).catch((e) => e.errcode === "M_USER_IN_USE" ? !1 : Promise.reject(e));
	}
	register(e, b, x, S, C, w, T) {
		x && (S.session = x);
		var E = {
			auth: S,
			refresh_token: !0
		};
		return e != null && (E.username = e), b != null && (E.password = b), w != null && (E.guest_access_token = w), T != null && (E.inhibit_login = T), this.registerRequest(E);
	}
	registerGuest() {
		var { body: e } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
		return this.registerRequest(e || {}, "guest");
	}
	registerRequest(e, b) {
		var x = {};
		return b && (x.kind = b), this.http.request(Method.Post, "/register", x, e);
	}
	refreshToken(e) {
		var b = (b) => this.http.authedRequest(Method.Post, "/refresh", void 0, { refresh_token: e }, {
			prefix: b,
			inhibitLogoutEmit: !0
		});
		return b(ClientPrefix.V3).catch((e) => {
			if (e.errcode === "M_UNRECOGNIZED") return b(ClientPrefix.V1);
			throw e;
		});
	}
	loginFlows() {
		return this.http.request(Method.Get, "/login");
	}
	login(e, b) {
		return this.loginRequest(_objectSpread$1(_objectSpread$1({}, b), {}, { type: e })).then((e) => (e.access_token && e.user_id && (this.http.opts.accessToken = e.access_token, this.credentials = { userId: e.user_id }), e));
	}
	loginWithPassword(e, b) {
		return this.login("m.login.password", {
			user: e,
			password: b
		});
	}
	getCasLoginUrl(e) {
		return this.getSsoLoginUrl(e, "cas");
	}
	getSsoLoginUrl(e) {
		var b = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "sso", x = arguments.length > 2 ? arguments[2] : void 0, S = arguments.length > 3 ? arguments[3] : void 0, C = "/login/" + b + "/redirect";
		x && (C += "/" + x);
		var w = {
			redirectUrl: e,
			[SSO_ACTION_PARAM.unstable]: S
		};
		return this.http.getUrl(C, w).href;
	}
	loginWithToken(e) {
		return this.login("m.login.token", { token: e });
	}
	loginRequest(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			return yield b.http.authedRequest(Method.Post, "/login", void 0, e);
		})();
	}
	logout() {
		var e = arguments, b = this;
		return _asyncToGenerator(function* () {
			return e.length > 0 && e[0] !== void 0 && e[0] && (b.stopClient(), b.http.abort()), b.http.authedRequest(Method.Post, "/logout");
		})();
	}
	deactivateAccount(e, b) {
		var x = {};
		return e && (x.auth = e), b !== void 0 && (x.erase = b), this.http.authedRequest(Method.Post, "/account/deactivate", void 0, x);
	}
	requestLoginToken(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			var x = { auth: e };
			return b.http.authedRequest(Method.Post, "/login/get_token", void 0, x, { prefix: ClientPrefix.V1 });
		})();
	}
	getFallbackAuthUrl(e, b) {
		var x = encodeUri("/auth/$loginType/fallback/web", { $loginType: e });
		return this.http.getUrl(x, { session: b }).href;
	}
	createRoom(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			var x, S = (e.invite_3pid || []).filter((e) => !e.id_access_token);
			if (S.length > 0 && (x = b.identityServer) != null && x.getAccessToken) {
				var C = yield b.identityServer.getAccessToken();
				if (C) for (var w of S) w.id_access_token = C;
			}
			return b.http.authedRequest(Method.Post, "/createRoom", void 0, e);
		})();
	}
	fetchRelations(e, b, x, S) {
		var C = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : { dir: Direction.Backward };
		Thread.hasServerSideFwdPaginationSupport === FeatureSupport.Experimental && (C = replaceParam("dir", "org.matrix.msc3715.dir", C)), this.canSupport.get(Feature.RelationsRecursion) === ServerSupport.Unstable && (C = replaceParam("recurse", "org.matrix.msc3981.recurse", C));
		var w = encodeParams(C), T = "/rooms/$roomId/relations/$eventId";
		x === null ? S !== null && (this.logger.warn(`eventType: ${S} ignored when fetching
            relations as relationType is null`), S = null) : (T += "/$relationType", S !== null && (T += "/$eventType"));
		var E = encodeUri(T + "?" + w, {
			$roomId: e,
			$eventId: b,
			$relationType: x,
			$eventType: S
		});
		return this.http.authedRequest(Method.Get, E, void 0, void 0, { prefix: ClientPrefix.V1 });
	}
	roomState(e) {
		var b = encodeUri("/rooms/$roomId/state", { $roomId: e });
		return this.http.authedRequest(Method.Get, b);
	}
	fetchRoomEvent(e, b) {
		var x = encodeUri("/rooms/$roomId/event/$eventId", {
			$roomId: e,
			$eventId: b
		});
		return this.http.authedRequest(Method.Get, x);
	}
	members(e, b, x, S) {
		var C = {};
		b && (C.membership = b), x && (C.not_membership = x), S && (C.at = S);
		var w = encodeParams(C), T = encodeUri("/rooms/$roomId/members?" + w, { $roomId: e });
		return this.http.authedRequest(Method.Get, T);
	}
	upgradeRoom(e, b) {
		var x = encodeUri("/rooms/$roomId/upgrade", { $roomId: e });
		return this.http.authedRequest(Method.Post, x, void 0, { new_version: b });
	}
	getStateEvent(e, b, x) {
		var S = {
			$roomId: e,
			$eventType: b,
			$stateKey: x
		}, C = encodeUri("/rooms/$roomId/state/$eventType", S);
		return x !== void 0 && (C = encodeUri(C + "/$stateKey", S)), this.http.authedRequest(Method.Get, C);
	}
	sendStateEvent(e, b, x) {
		var S = arguments, C = this;
		return _asyncToGenerator(function* () {
			var w = S.length > 3 && S[3] !== void 0 ? S[3] : "", T = S.length > 4 && S[4] !== void 0 ? S[4] : {}, E = C.getRoom(e), D = new MatrixEvent({
				room_id: e,
				type: b,
				state_key: w,
				content: x
			});
			yield C.encryptStateEventIfNeeded(D, E ?? void 0);
			var O = {
				$roomId: e,
				$eventType: D.getWireType(),
				$stateKey: D.getWireStateKey()
			}, k = encodeUri("/rooms/$roomId/state/$eventType", O);
			return w !== void 0 && (k = encodeUri(k + "/$stateKey", O)), C.http.authedRequest(Method.Put, k, void 0, D.getWireContent(), T);
		})();
	}
	encryptStateEventIfNeeded(e, b) {
		var x = this;
		return _asyncToGenerator(function* () {
			if (x.enableEncryptedStateEvents && b && !(!x.cryptoBackend && x.usingExternalCrypto)) {
				if (!x.cryptoBackend) throw Error("This room is configured to use encryption, but your client does not support encryption.");
				(yield x.shouldEncryptEventForRoom(e, b)) && (yield x.cryptoBackend.isStateEncryptionEnabledInRoom(b.roomId)) && ([
					"m.room.create",
					"m.room.member",
					"m.room.join_rules",
					"m.room.power_levels",
					"m.room.third_party_invite",
					"m.room.history_visibility",
					"m.room.guest_access",
					"m.room.encryption"
				].includes(e.getType()) || (yield x.cryptoBackend.encryptEvent(e, b)));
			}
		})();
	}
	roomInitialSync(e, b) {
		var x = encodeUri("/rooms/$roomId/initialSync", { $roomId: e });
		return this.http.authedRequest(Method.Get, x, { limit: b?.toString() ?? "30" });
	}
	setRoomReadMarkersHttpRequest(e, b, x, S) {
		var C = this;
		return _asyncToGenerator(function* () {
			var w = encodeUri("/rooms/$roomId/read_markers", { $roomId: e }), T = {
				[ReceiptType.FullyRead]: b,
				[ReceiptType.Read]: x
			};
			return ((yield C.doesServerSupportUnstableFeature("org.matrix.msc2285.stable")) || (yield C.isVersionSupported("v1.4"))) && (T[ReceiptType.ReadPrivate] = S), C.http.authedRequest(Method.Post, w, void 0, T);
		})();
	}
	getJoinedRooms() {
		var e = encodeUri("/joined_rooms", {});
		return this.http.authedRequest(Method.Get, e);
	}
	getJoinedRoomMembers(e) {
		var b = encodeUri("/rooms/$roomId/joined_members", { $roomId: e });
		return this.http.authedRequest(Method.Get, b);
	}
	publicRooms() {
		var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, { server: b, limit: x, since: S } = e, C = _objectWithoutProperties(e, _excluded);
		if (Object.keys(C).length === 0) {
			var w = {
				server: b,
				limit: x,
				since: S
			};
			return this.http.authedRequest(Method.Get, "/publicRooms", w);
		} else {
			var T = { server: b }, E = _objectSpread$1({
				limit: x,
				since: S
			}, C);
			return this.http.authedRequest(Method.Post, "/publicRooms", T, E);
		}
	}
	createAlias(e, b) {
		var x = encodeUri("/directory/room/$alias", { $alias: e }), S = { room_id: b };
		return this.http.authedRequest(Method.Put, x, void 0, S);
	}
	deleteAlias(e) {
		var b = encodeUri("/directory/room/$alias", { $alias: e });
		return this.http.authedRequest(Method.Delete, b);
	}
	getLocalAliases(e) {
		var b = encodeUri("/rooms/$roomId/aliases", { $roomId: e }), x = ClientPrefix.V3;
		return this.http.authedRequest(Method.Get, b, void 0, void 0, { prefix: x });
	}
	getRoomIdForAlias(e) {
		var b = encodeUri("/directory/room/$alias", { $alias: e });
		return this.http.authedRequest(Method.Get, b);
	}
	getRoomDirectoryVisibility(e) {
		var b = encodeUri("/directory/list/room/$roomId", { $roomId: e });
		return this.http.authedRequest(Method.Get, b);
	}
	setRoomDirectoryVisibility(e, b) {
		var x = encodeUri("/directory/list/room/$roomId", { $roomId: e });
		return this.http.authedRequest(Method.Put, x, void 0, { visibility: b });
	}
	searchUserDirectory(e) {
		var { term: b, limit: x } = e, S = { search_term: b };
		return x !== void 0 && (S.limit = x), this.http.authedRequest(Method.Post, "/user_directory/search", void 0, S);
	}
	uploadContent(e, b) {
		return this.http.uploadContent(e, b);
	}
	cancelUpload(e) {
		return this.http.cancelUpload(e);
	}
	getCurrentUploads() {
		return this.http.getCurrentUploads();
	}
	getProfileInfo(e, b) {
		var x = b ? encodeUri("/profile/$userId/$info", {
			$userId: e,
			$info: b
		}) : encodeUri("/profile/$userId", { $userId: e });
		return this.http.authedRequest(Method.Get, x);
	}
	doesServerSupportExtendedProfiles() {
		var e = this;
		return _asyncToGenerator(function* () {
			return (yield e.isVersionSupported("v1.16")) || (yield e.doesServerSupportUnstableFeature("uk.tcpip.msc4133")) || (yield e.doesServerSupportUnstableFeature("uk.tcpip.msc4133.stable"));
		})();
	}
	getExtendedProfileRequestPrefix() {
		var e = this;
		return _asyncToGenerator(function* () {
			return (yield e.isVersionSupported("v1.16")) || (yield e.doesServerSupportUnstableFeature("uk.tcpip.msc4133.stable")) ? ClientPrefix.V3 : "/_matrix/client/unstable/uk.tcpip.msc4133";
		})();
	}
	getExtendedProfile(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			if (!(yield b.doesServerSupportExtendedProfiles())) throw Error("Server does not support extended profiles");
			return b.http.authedRequest(Method.Get, encodeUri("/profile/$userId", { $userId: e }), void 0, void 0, { prefix: yield b.getExtendedProfileRequestPrefix() });
		})();
	}
	getExtendedProfileProperty(e, b) {
		var x = this;
		return _asyncToGenerator(function* () {
			if (!(yield x.doesServerSupportExtendedProfiles())) throw Error("Server does not support extended profiles");
			return (yield x.http.authedRequest(Method.Get, encodeUri("/profile/$userId/$key", {
				$userId: e,
				$key: b
			}), void 0, void 0, { prefix: yield x.getExtendedProfileRequestPrefix() }))[b];
		})();
	}
	setExtendedProfileProperty(e, b) {
		var x = this;
		return _asyncToGenerator(function* () {
			if (!(yield x.doesServerSupportExtendedProfiles())) throw Error("Server does not support extended profiles");
			var S = x.getUserId();
			yield x.http.authedRequest(Method.Put, encodeUri("/profile/$userId/$key", {
				$userId: S,
				$key: e
			}), void 0, { [e]: b }, { prefix: yield x.getExtendedProfileRequestPrefix() });
		})();
	}
	deleteExtendedProfileProperty(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			if (!(yield b.doesServerSupportExtendedProfiles())) throw Error("Server does not support extended profiles");
			var x = b.getUserId();
			yield b.http.authedRequest(Method.Delete, encodeUri("/profile/$userId/$key", {
				$userId: x,
				$key: e
			}), void 0, void 0, { prefix: yield b.getExtendedProfileRequestPrefix() });
		})();
	}
	patchExtendedProfile(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			if (!(yield b.doesServerSupportExtendedProfiles())) throw Error("Server does not support extended profiles");
			var x = b.getUserId();
			return b.http.authedRequest(Method.Patch, encodeUri("/profile/$userId", { $userId: x }), {}, e, { prefix: yield b.getExtendedProfileRequestPrefix() });
		})();
	}
	setExtendedProfile(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			if (!(yield b.doesServerSupportExtendedProfiles())) throw Error("Server does not support extended profiles");
			var x = b.getUserId();
			yield b.http.authedRequest(Method.Put, encodeUri("/profile/$userId", { $userId: x }), {}, e, { prefix: yield b.getExtendedProfileRequestPrefix() });
		})();
	}
	getThreePids() {
		return this.http.authedRequest(Method.Get, "/account/3pid");
	}
	addThreePidOnly(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			return b.http.authedRequest(Method.Post, "/account/3pid/add", void 0, e);
		})();
	}
	bindThreePid(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			return b.http.authedRequest(Method.Post, "/account/3pid/bind", void 0, e);
		})();
	}
	unbindThreePid(e, b) {
		var x = this;
		return _asyncToGenerator(function* () {
			var S = "/account/3pid/unbind", C = {
				medium: e,
				address: b,
				id_server: x.getIdentityServerUrl(!0)
			};
			return x.http.authedRequest(Method.Post, S, void 0, C);
		})();
	}
	deleteThreePid(e, b) {
		return this.http.authedRequest(Method.Post, "/account/3pid/delete", void 0, {
			medium: e,
			address: b
		});
	}
	setPassword(e, b, x) {
		var S = "/account/password", C = {
			auth: e,
			new_password: b,
			logout_devices: x
		};
		return this.http.authedRequest(Method.Post, S, void 0, C);
	}
	getDevices() {
		return this.http.authedRequest(Method.Get, "/devices");
	}
	getDevice(e) {
		var b = encodeUri("/devices/$device_id", { $device_id: e });
		return this.http.authedRequest(Method.Get, b);
	}
	setDeviceDetails(e, b) {
		var x = encodeUri("/devices/$device_id", { $device_id: e });
		return this.http.authedRequest(Method.Put, x, void 0, b);
	}
	deleteDevice(e, b) {
		var x = encodeUri("/devices/$device_id", { $device_id: e }), S = {};
		return b && (S.auth = b), this.http.authedRequest(Method.Delete, x, void 0, S);
	}
	deleteMultipleDevices(e, b) {
		var x = { devices: e };
		return b && (x.auth = b), this.http.authedRequest(Method.Post, "/delete_devices", void 0, x);
	}
	getPushers() {
		var e = this;
		return _asyncToGenerator(function* () {
			var b = yield e.http.authedRequest(Method.Get, "/pushers");
			return (yield e.doesServerSupportUnstableFeature("org.matrix.msc3881")) || (b.pushers = b.pushers.map((e) => (e.hasOwnProperty(PUSHER_ENABLED.name) || (e[PUSHER_ENABLED.name] = !0), e))), b;
		})();
	}
	setPusher(e) {
		return this.http.authedRequest(Method.Post, "/pushers/set", void 0, e);
	}
	removePusher(e, b) {
		var x = "/pushers/set", S = {
			pushkey: e,
			app_id: b,
			kind: null
		};
		return this.http.authedRequest(Method.Post, x, void 0, S);
	}
	setLocalNotificationSettings(e, b) {
		var x = `${LOCAL_NOTIFICATION_SETTINGS_PREFIX.name}.${e}`;
		return this.setAccountData(x, b);
	}
	getPushRules() {
		return this.http.authedRequest(Method.Get, "/pushrules/").then((e) => (this.setPushRules(e), this.pushRules));
	}
	setPushRules(e) {
		this.pushRules = PushProcessor.rewriteDefaultRules(this.logger, e, this.getUserId()), this.pushProcessor.updateCachedPushRuleKeys(this.pushRules);
	}
	addPushRule(e, b, x, S) {
		var C = encodeUri("/pushrules/" + e + "/$kind/$ruleId", {
			$kind: b,
			$ruleId: x
		});
		return this.http.authedRequest(Method.Put, C, void 0, S);
	}
	deletePushRule(e, b, x) {
		var S = encodeUri("/pushrules/" + e + "/$kind/$ruleId", {
			$kind: b,
			$ruleId: x
		});
		return this.http.authedRequest(Method.Delete, S);
	}
	setPushRuleEnabled(e, b, x, S) {
		var C = encodeUri("/pushrules/" + e + "/$kind/$ruleId/enabled", {
			$kind: b,
			$ruleId: x
		});
		return this.http.authedRequest(Method.Put, C, void 0, { enabled: S });
	}
	setPushRuleActions(e, b, x, S) {
		var C = encodeUri("/pushrules/" + e + "/$kind/$ruleId/actions", {
			$kind: b,
			$ruleId: x
		});
		return this.http.authedRequest(Method.Put, C, void 0, { actions: S });
	}
	search(e, b) {
		var { body: x, next_batch: S } = e, C = {};
		return S && (C.next_batch = S), this.http.authedRequest(Method.Post, "/search", C, x, { abortSignal: b });
	}
	uploadKeysRequest(e, b) {
		return this.http.authedRequest(Method.Post, "/keys/upload", void 0, e);
	}
	uploadKeySignatures(e) {
		return this.http.authedRequest(Method.Post, "/keys/signatures/upload", void 0, e);
	}
	downloadKeysForUsers(e) {
		var { token: b } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, x = { device_keys: {} };
		return b !== void 0 && (x.token = b), e.forEach((e) => {
			x.device_keys[e] = [];
		}), this.http.authedRequest(Method.Post, "/keys/query", void 0, x);
	}
	claimOneTimeKeys(e) {
		var b = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "signed_curve25519", x = arguments.length > 2 ? arguments[2] : void 0, S = {};
		b === void 0 && (b = "signed_curve25519");
		for (var [C, w] of e) {
			var T = S[C] || {};
			safeSet(S, C, T), safeSet(T, w, b);
		}
		var E = { one_time_keys: S };
		return x && (E.timeout = x), this.http.authedRequest(Method.Post, "/keys/claim", void 0, E);
	}
	getKeyChanges(e, b) {
		var x = {
			from: e,
			to: b
		};
		return this.http.authedRequest(Method.Get, "/keys/changes", x);
	}
	uploadDeviceSigningKeys(e, b) {
		var x = Object.assign({}, b);
		return e && Object.assign(x, { auth: e }), this.http.authedRequest(Method.Post, "/keys/device_signing/upload", void 0, x, { prefix: ClientPrefix.Unstable });
	}
	registerWithIdentityServer(e) {
		if (!this.idBaseUrl) throw Error("No identity server base URL set");
		var b = this.http.getUrl("/account/register", void 0, IdentityPrefix.V2, this.idBaseUrl);
		return this.http.requestOtherUrl(Method.Post, b, e);
	}
	requestEmailToken(e, b, x, S, C) {
		var w = {
			client_secret: b,
			email: e,
			send_attempt: x?.toString()
		};
		return S && (w.next_link = S), this.http.idServerRequest(Method.Post, "/validate/email/requestToken", w, IdentityPrefix.V2, C);
	}
	requestMsisdnToken(e, b, x, S, C, w) {
		var T = {
			client_secret: x,
			country: e,
			phone_number: b,
			send_attempt: S?.toString()
		};
		return C && (T.next_link = C), this.http.idServerRequest(Method.Post, "/validate/msisdn/requestToken", T, IdentityPrefix.V2, w);
	}
	submitMsisdnToken(e, b, x, S) {
		var C = {
			sid: e,
			client_secret: b,
			token: x
		};
		return this.http.idServerRequest(Method.Post, "/validate/msisdn/submitToken", C, IdentityPrefix.V2, S ?? void 0);
	}
	submitMsisdnTokenOtherUrl(e, b, x, S) {
		var C = {
			sid: b,
			client_secret: x,
			token: S
		};
		return this.http.requestOtherUrl(Method.Post, e, C);
	}
	getIdentityHashDetails(e) {
		return this.http.idServerRequest(Method.Get, "/hash_details", void 0, IdentityPrefix.V2, e);
	}
	identityHashedLookup(e, b) {
		var x = this;
		return _asyncToGenerator(function* () {
			var S = {}, C = yield x.getIdentityHashDetails(b);
			if (!C || !C.lookup_pepper || !C.algorithms) throw Error("Unsupported identity server: bad response");
			S.pepper = C.lookup_pepper;
			var w = {};
			if (C.algorithms.includes("sha256")) S.addresses = yield Promise.all(e.map(/* @__PURE__ */ function() {
				var e = _asyncToGenerator(function* (e) {
					var b = e[0].toLowerCase(), x = e[1].toLowerCase(), C = yield sha256(`${b} ${x} ${S.pepper}`), T = encodeUnpaddedBase64Url(C);
					return w[T] = e[0], T;
				});
				return function(b) {
					return e.apply(this, arguments);
				};
			}())), S.algorithm = "sha256";
			else if (C.algorithms.includes("none")) S.addresses = e.map((e) => {
				var b = e[0].toLowerCase(), x = e[1].toLowerCase(), S = `${b} ${x}`;
				return w[S] = e[0], S;
			}), S.algorithm = "none";
			else throw Error("Unsupported identity server: unknown hash algorithm");
			var T = yield x.http.idServerRequest(Method.Post, "/lookup", S, IdentityPrefix.V2, b);
			if (!(T != null && T.mappings)) return [];
			var E = [];
			for (var D of Object.keys(T.mappings)) {
				var O = T.mappings[D], k = w[D];
				if (!k) throw Error("Identity server returned more results than expected");
				E.push({
					address: k,
					mxid: O
				});
			}
			return E;
		})();
	}
	lookupThreePid(e, b, x) {
		var S = this;
		return _asyncToGenerator(function* () {
			var C = (yield S.identityHashedLookup([[b, e]], x)).find((e) => e.address === b);
			return C ? {
				address: b,
				medium: e,
				mxid: C.mxid
			} : {};
		})();
	}
	bulkLookupThreePids(e, b) {
		var x = this;
		return _asyncToGenerator(function* () {
			var S = yield x.identityHashedLookup(e.map((e) => [e[1], e[0]]), b), C = [], w = function* (b) {
				var x = e.find((e) => e[1] === b.address);
				if (!x) throw Error("Identity sever returned unexpected results");
				C.push([
					x[0],
					b.address,
					b.mxid
				]);
			};
			for (var T of S) yield* w(T);
			return { threepids: C };
		})();
	}
	getIdentityAccount(e) {
		return this.http.idServerRequest(Method.Get, "/account", void 0, IdentityPrefix.V2, e);
	}
	sendToDevice(e, b, x) {
		var S = encodeUri("/sendToDevice/$eventType/$txnId", {
			$eventType: e,
			$txnId: x || this.makeTxnId()
		}), C = { messages: recursiveMapToObject(b) }, w = /* @__PURE__ */ new Map();
		for (var [T, E] of b) w.set(T, Array.from(E.keys()));
		return this.logger.debug(`PUT ${S}`, w), this.http.authedRequest(Method.Put, S, void 0, C);
	}
	encryptAndSendToDevice(e, b, x) {
		var S = this;
		return _asyncToGenerator(function* () {
			if (!S.cryptoBackend) throw Error("Cannot encrypt to device event, your client does not support encryption.");
			var C = yield S.cryptoBackend.encryptToDeviceMessages(e, b, x);
			yield S.queueToDevice(C);
		})();
	}
	queueToDevice(e) {
		return this.toDeviceMessageQueue.queueBatch(e);
	}
	getThirdpartyProtocols() {
		return this.http.authedRequest(Method.Get, "/thirdparty/protocols").then((e) => {
			if (!e || typeof e != "object") throw Error(`/thirdparty/protocols did not return an object: ${e}`);
			return e;
		});
	}
	getThirdpartyLocation(e, b) {
		var x = encodeUri("/thirdparty/location/$protocol", { $protocol: e });
		return this.http.authedRequest(Method.Get, x, b);
	}
	getThirdpartyUser(e, b) {
		var x = encodeUri("/thirdparty/user/$protocol", { $protocol: e });
		return this.http.authedRequest(Method.Get, x, b);
	}
	getTerms(e, b) {
		var x = this.termsUrlForService(e, b);
		return this.http.requestOtherUrl(Method.Get, x);
	}
	agreeToTerms(e, b, x, S) {
		var C = this.termsUrlForService(e, b), w = { Authorization: "Bearer " + x };
		return this.http.requestOtherUrl(Method.Post, C, { user_accepts: S }, { headers: w });
	}
	reportEvent(e, b, x, S) {
		var C = encodeUri("/rooms/$roomId/report/$eventId", {
			$roomId: e,
			$eventId: b
		});
		return this.http.authedRequest(Method.Post, C, void 0, {
			score: x,
			reason: S
		});
	}
	reportRoom(e, b) {
		var x = encodeUri("/rooms/$roomId/report", { $roomId: e });
		return this.http.authedRequest(Method.Post, x, void 0, { reason: b });
	}
	getRoomHierarchy(e, b, x) {
		var S = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1, C = arguments.length > 4 ? arguments[4] : void 0, w = encodeUri("/rooms/$roomId/hierarchy", { $roomId: e }), T = {
			suggested_only: String(S),
			max_depth: x?.toString(),
			from: C,
			limit: b?.toString()
		};
		return this.http.authedRequest(Method.Get, w, T, void 0, { prefix: ClientPrefix.V1 }).catch((e) => {
			if (e.errcode === "M_UNRECOGNIZED") return this.http.authedRequest(Method.Get, w, T, void 0, { prefix: "/_matrix/client/unstable/org.matrix.msc2946" });
			throw e;
		});
	}
	unstableCreateFileTree(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			var { room_id: x } = yield b.createRoom({
				name: e,
				preset: Preset.PrivateChat,
				power_level_content_override: _objectSpread$1(_objectSpread$1({}, DEFAULT_TREE_POWER_LEVELS_TEMPLATE), {}, { users: { [b.getUserId()]: 100 } }),
				creation_content: { [RoomCreateTypeField]: RoomType.Space },
				initial_state: [{
					type: UNSTABLE_MSC3088_PURPOSE.name,
					state_key: UNSTABLE_MSC3089_TREE_SUBTYPE.name,
					content: { [UNSTABLE_MSC3088_ENABLED.name]: !0 }
				}, {
					type: EventType.RoomEncryption,
					state_key: "",
					content: { algorithm: "m.megolm.v1.aes-sha2" }
				}]
			});
			return new MSC3089TreeSpace(b, x);
		})();
	}
	unstableGetFileTreeSpace(e) {
		var b, x = this.getRoom(e);
		if (x?.getMyMembership() !== KnownMembership.Join) return null;
		var S = x.currentState.getStateEvents(EventType.RoomCreate, ""), C = x.currentState.getStateEvents(UNSTABLE_MSC3088_PURPOSE.name, UNSTABLE_MSC3089_TREE_SUBTYPE.name);
		if (!S) throw Error("Expected single room create event");
		return !(C != null && (b = C.getContent()) != null && b[UNSTABLE_MSC3088_ENABLED.name]) || S.getContent()?.type !== RoomType.Space ? null : new MSC3089TreeSpace(this, e);
	}
	slidingSync(e, b, x) {
		var S = {};
		e.pos && (S.pos = e.pos, delete e.pos), e.timeout && (S.timeout = e.timeout, delete e.timeout);
		var C = e.clientTimeout;
		return delete e.clientTimeout, this.http.authedRequest(Method.Post, "/sync", S, e, {
			prefix: "/_matrix/client/unstable/org.matrix.simplified_msc3575",
			baseUrl: b,
			localTimeoutMs: C,
			abortSignal: x
		});
	}
	supportsThreads() {
		return this.clientOpts?.threadSupport || !1;
	}
	supportsIntentionalMentions() {
		return this.canSupport.get(Feature.IntentionalMentions) !== ServerSupport.Unsupported;
	}
	getRoomSummary(e, b) {
		var x = this;
		return _asyncToGenerator(function* () {
			var S = { prefix: "/_matrix/client/unstable/im.nheko.summary" };
			try {
				var C = encodeUri("/summary/$roomid", { $roomid: e });
				return yield x.http.authedRequest(Method.Get, C, { via: b }, void 0, S);
			} catch (C) {
				if (C instanceof MatrixError && C.errcode === "M_UNRECOGNIZED") {
					var w = encodeUri("/rooms/$roomid/summary", { $roomid: e });
					return yield x.http.authedRequest(Method.Get, w, { via: b }, void 0, S);
				} else throw C;
			}
		})();
	}
	processThreadEvents(e, b, x) {
		e.processThreadedEvents(b, x);
	}
	processThreadRoots(e, b, x) {
		this.supportsThreads() && e.processThreadRoots(b, x);
	}
	processBeaconEvents(e, b) {
		this.processAggregatedTimelineEvents(e, b);
	}
	processAggregatedTimelineEvents(e, b) {
		b != null && b.length && e && (e.currentState.processBeaconEvents(b, this), e.processPollEvents(b));
	}
	whoami() {
		var e = this;
		return _asyncToGenerator(function* () {
			return e.http.authedRequest(Method.Get, "/account/whoami");
		})();
	}
	timestampToEvent(e, b, x) {
		var S = this;
		return _asyncToGenerator(function* () {
			var C = encodeUri("/rooms/$roomId/timestamp_to_event", { $roomId: e }), w = {
				ts: b.toString(),
				dir: x
			};
			try {
				return yield S.http.authedRequest(Method.Get, C, w, void 0, { prefix: ClientPrefix.V1 });
			} catch (e) {
				if (e.errcode === "M_UNRECOGNIZED" && (e.httpStatus === 400 || e.httpStatus === 404 || e.httpStatus === 405)) return yield S.http.authedRequest(Method.Get, C, w, void 0, { prefix: "/_matrix/client/unstable/org.matrix.msc3030" });
				throw e;
			}
		})();
	}
	getAuthMetadata() {
		var e = this;
		return _asyncToGenerator(function* () {
			var b;
			try {
				b = yield e.http.request(Method.Get, "/auth_metadata", void 0, void 0, { prefix: ClientPrefix.Unstable + "/org.matrix.msc2965" });
			} catch (b) {
				if (b instanceof MatrixError && b.errcode === "M_UNRECOGNIZED") {
					var { issuer: x } = yield e.http.request(Method.Get, "/auth_issuer", void 0, void 0, { prefix: ClientPrefix.Unstable + "/org.matrix.msc2965" });
					return discoverAndValidateOIDCIssuerWellKnown(x);
				}
				throw b;
			}
			return validateAuthMetadataAndKeys(b);
		})();
	}
};
_defineProperty(MatrixClient, "RESTORE_BACKUP_ERROR_BAD_KEY", "RESTORE_BACKUP_ERROR_BAD_KEY");
function getUnstableDelayQueryOpts(e) {
	return Object.fromEntries(Object.entries(e).map((e) => {
		var [b, x] = e;
		return [`${UNSTABLE_MSC4140_DELAYED_EVENTS}.${b}`, x];
	}));
}
function fixNotificationCountOnDecryption(e, b) {
	var x, S = e.getUserId(), C = b.getId(), w = e.getRoom(b.getRoomId());
	if (!(!w || !S || !C)) {
		if (!w.findEventById(C)) {
			logger.info(`Decrypted event ${b.getId()} is not in room ${w.roomId}: ignoring`);
			return;
		}
		var T = !!b.threadRootId && !b.isThreadRoot, E;
		if (T) {
			var D = w.getThread(b.threadRootId);
			E = D ? D.hasUserReadEvent(S, C) : !0;
		} else E = w.hasUserReadEvent(S, C);
		if (!E) {
			var O = e.getPushActionsForEvent(b, !0);
			if (O != null && (x = O.tweaks) != null && x.highlight) {
				var k = w.getUnreadCountForEventContext(NotificationCountType.Highlight, b) + 1;
				T ? w.setThreadUnreadNotificationCount(b.threadRootId, NotificationCountType.Highlight, k) : w.setUnreadNotificationCount(NotificationCountType.Highlight, k);
			}
			if (O != null && O.notify) {
				var A = w.getUnreadCountForEventContext(NotificationCountType.Total, b) + 1;
				T ? w.setThreadUnreadNotificationCount(b.threadRootId, NotificationCountType.Total, A) : w.setUnreadNotificationCount(NotificationCountType.Total, A);
			}
		}
	}
}
function threadIdForReceipt(e) {
	return inMainTimelineForReceipt(e) ? MAIN_ROOM_TIMELINE : e.threadRootId;
}
function inMainTimelineForReceipt(e) {
	return !e.threadRootId || e.isThreadRoot ? !0 : e.isRelation() ? e.isRelation(THREAD_RELATION_TYPE.name) ? !1 : e.relationEventId === e.threadRootId : (logger.warn(`Event is not a relation or a thread root, but still has a threadRootId! id=${e.getId()}`), !0);
}
function ownKeys(e, b) {
	var x = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var S = Object.getOwnPropertySymbols(e);
		b && (S = S.filter(function(b) {
			return Object.getOwnPropertyDescriptor(e, b).enumerable;
		})), x.push.apply(x, S);
	}
	return x;
}
function _objectSpread(e) {
	for (var b = 1; b < arguments.length; b++) {
		var x = arguments[b] == null ? {} : arguments[b];
		b % 2 ? ownKeys(Object(x), !0).forEach(function(b) {
			_defineProperty(e, b, x[b]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(x)) : ownKeys(Object(x)).forEach(function(b) {
			Object.defineProperty(e, b, Object.getOwnPropertyDescriptor(x, b));
		});
	}
	return e;
}
var ThreadEvent = /* @__PURE__ */ function(e) {
	return e.New = "Thread.new", e.Update = "Thread.update", e.NewReply = "Thread.newReply", e.ViewThread = "Thread.viewThread", e.Delete = "Thread.delete", e;
}({}), FeatureSupport = /* @__PURE__ */ function(e) {
	return e[e.None = 0] = "None", e[e.Experimental = 1] = "Experimental", e[e.Stable = 2] = "Stable", e;
}({});
function determineFeatureSupport(e, b) {
	return e ? FeatureSupport.Stable : b ? FeatureSupport.Experimental : FeatureSupport.None;
}
var Thread = class e extends ReadReceipt {
	constructor(b, x, S) {
		var C;
		if (super(), C = this, this.id = b, this.rootEvent = x, _defineProperty(this, "timelineSet", void 0), _defineProperty(this, "_currentUserParticipated", !1), _defineProperty(this, "reEmitter", void 0), _defineProperty(this, "lastEvent", void 0), _defineProperty(this, "replyCount", 0), _defineProperty(this, "lastPendingEvent", void 0), _defineProperty(this, "pendingReplyCount", 0), _defineProperty(this, "room", void 0), _defineProperty(this, "client", void 0), _defineProperty(this, "pendingEventOrdering", void 0), _defineProperty(this, "processRootEventPromise", void 0), _defineProperty(this, "initialEventsFetched", !e.hasServerSideSupport), _defineProperty(this, "initalEventFetchProm", void 0), _defineProperty(this, "replayEvents", []), _defineProperty(this, "onTimelineReset", /* @__PURE__ */ _asyncToGenerator(function* () {
			yield C.processRootEventPromise, C.processRootEventPromise = void 0;
		})), _defineProperty(this, "onBeforeRedaction", (e, b) => {
			e != null && e.isRelation(THREAD_RELATION_TYPE.name) && this.room.eventShouldLiveIn(e).threadId === this.id && e.getId() !== this.id && !b.status && (this.replyCount--, this.updatePendingReplyCount(), this.emit(ThreadEvent.Update, this));
		}), _defineProperty(this, "onRedaction", /* @__PURE__ */ function() {
			var e = _asyncToGenerator(function* (e, b, x) {
				if (x === C.id) if (C.replyCount <= 0) {
					for (var S of C.timeline) C.clearEventMetadata(S);
					C.lastEvent = C.rootEvent, C._currentUserParticipated = !1, C.emit(ThreadEvent.Delete, C);
				} else C.lastEvent?.getId() === e.getAssociatedId() && (yield C.processRootEventPromise, C.processRootEventPromise = void 0), yield C.updateThreadMetadata();
			});
			return function(b, x, S) {
				return e.apply(this, arguments);
			};
		}()), _defineProperty(this, "onTimelineEvent", (e, b, x) => {
			if (!x) {
				var S = e.getSender();
				S && b && this.shouldSendLocalEchoReceipt(S, e) && b.addLocalEchoReceipt(S, e, ReceiptType.Read), e.getId() !== this.id && e.isRelation(THREAD_RELATION_TYPE.name) && this.replyCount++;
			}
			this.onEcho(e, x ?? !1);
		}), _defineProperty(this, "onLocalEcho", (e) => {
			this.onEcho(e, !1);
		}), _defineProperty(this, "onEcho", /* @__PURE__ */ function() {
			var e = _asyncToGenerator(function* (e, b) {
				e.threadRootId === C.id && C.lastEvent !== e && (yield C.updateThreadMetadata(), e.isRelation(THREAD_RELATION_TYPE.name) && (b || (C.lastEvent = void 0, C.emit(ThreadEvent.NewReply, C, e))));
			});
			return function(b, x) {
				return e.apply(this, arguments);
			};
		}()), this.setMaxListeners(1e3), !(S != null && S.room)) throw Error("element-web#22141: A thread requires a room in order to function");
		this.room = S.room, this.client = S.client, this.pendingEventOrdering = S.pendingEventOrdering ?? PendingEventOrdering.Chronological, this.timelineSet = new EventTimelineSet(this.room, {
			timelineSupport: !0,
			pendingEvents: !0
		}, this.client, this), this.reEmitter = new TypedReEmitter(this), this.reEmitter.reEmit(this.timelineSet, [RoomEvent.Timeline, RoomEvent.TimelineReset]), this.room.on(MatrixEventEvent.BeforeRedaction, this.onBeforeRedaction), this.room.on(RoomEvent.Redaction, this.onRedaction), this.room.on(RoomEvent.LocalEchoUpdated, this.onLocalEcho), this.room.on(RoomEvent.TimelineReset, this.onTimelineReset), this.timelineSet.on(RoomEvent.Timeline, this.onTimelineEvent), this.processReceipts(S.receipts), this.updateThreadMetadata(), this.setEventMetadata(this.rootEvent);
	}
	fetchRootEvent() {
		var e = this;
		return _asyncToGenerator(function* () {
			try {
				var b = yield e.client.fetchRoomEvent(e.roomId, e.id);
				e.rootEvent = e.client.getEventMapper()(b);
			} catch (e) {
				logger.error("Failed to fetch thread root to construct thread with", e);
			}
			yield e.processEvent(e.rootEvent);
		})();
	}
	static setServerSideSupport(b) {
		e.hasServerSideSupport = b, b !== FeatureSupport.Stable && (FILTER_RELATED_BY_SENDERS.setPreferUnstable(!0), FILTER_RELATED_BY_REL_TYPES.setPreferUnstable(!0), THREAD_RELATION_TYPE.setPreferUnstable(!0));
	}
	static setServerSideListSupport(b) {
		e.hasServerSideListSupport = b;
	}
	static setServerSideFwdPaginationSupport(b) {
		e.hasServerSideFwdPaginationSupport = b;
	}
	shouldSendLocalEchoReceipt(e, b) {
		if ((this.client.canSupport.get(Feature.RelationsRecursion) ?? ServerSupport.Unsupported) === ServerSupport.Unsupported) {
			var x = this.getReadReceiptForUserId(e)?.eventId;
			if (x) {
				var S = this.findEventById(x);
				if (S && S.getTs() > b.getTs()) return !1;
			}
		}
		return !0;
	}
	get roomState() {
		return this.room.getLiveTimeline().getState(EventTimeline.FORWARDS);
	}
	addEventToTimeline(e, b) {
		this.findEventById(e.getId()) || this.timelineSet.addEventToTimeline(e, this.liveTimeline, {
			toStartOfTimeline: b,
			fromCache: !1,
			roomState: this.roomState,
			addToState: !1
		});
	}
	insertEventIntoTimeline(e) {
		var b = e.getId();
		b && (this.findEventById(b) || this.timelineSet.insertEventIntoTimeline(e, this.liveTimeline, this.roomState, !1));
	}
	addEvents(e, b) {
		e.forEach((e) => this.addEvent(e, b, !1)), this.updateThreadMetadata();
	}
	addEvent(b, x) {
		var S = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
		this.setEventMetadata(b);
		var C = this.lastReply(), w = !C || b.localTimestamp >= C.localTimestamp;
		if (!e.hasServerSideSupport) this.addEventToTimeline(b, x), this.client.decryptEventIfNeeded(b);
		else if (b.isRelation(RelationType.Annotation) || b.isRelation(RelationType.Replace)) {
			this.addRelatedThreadEvent(b, x);
			return;
		} else !x && w ? (this.addEventToTimeline(b, !1), this.fetchEditsWhereNeeded(b)) : x ? this.addEventToTimeline(b, x) : this.insertEventIntoTimeline(b);
		b.getId() !== this.id && b.isRelation(THREAD_RELATION_TYPE.name) && !x && w && (this.lastEvent = void 0), S && (this.emit(ThreadEvent.NewReply, this, b), this.updateThreadMetadata());
	}
	addRelatedThreadEvent(e, b) {
		if (this.initialEventsFetched) (this.client.canSupport.get(Feature.RelationsRecursion) ?? ServerSupport.Unsupported) === ServerSupport.Unsupported ? this.insertEventIntoTimeline(e) : this.addEventToTimeline(e, b);
		else {
			var x;
			if ((x = this.replayEvents) == null || x.push(e), e.isRelation(RelationType.Annotation)) {
				var S;
				(S = this.timelineSet.relations) == null || S.aggregateChildEvent(e, this.timelineSet);
			}
		}
	}
	processEvent(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			e && (b.setEventMetadata(e), yield b.fetchEditsWhereNeeded(e));
		})();
	}
	processReceipts() {
		for (var { eventId: e, receiptType: b, userId: x, receipt: S, synthetic: C } of arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : []) this.addReceiptToStructure(e, b, x, S, C);
	}
	getRootEventBundledRelationship() {
		return (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.rootEvent)?.getServerAggregatedRelation(THREAD_RELATION_TYPE.name);
	}
	processRootEvent() {
		var b = this;
		return _asyncToGenerator(function* () {
			var x = b.getRootEventBundledRelationship();
			e.hasServerSideSupport && x && (b.replyCount = x.count, b._currentUserParticipated = !!x.current_user_participated, b.lastEvent = b.client.getEventMapper()(_objectSpread(_objectSpread({}, x.latest_event), {}, { room_id: b.roomId })), b.updatePendingReplyCount(), yield b.processEvent(b.lastEvent));
		})();
	}
	updatePendingReplyCount() {
		var e = (this.pendingEventOrdering === PendingEventOrdering.Detached ? this.room.getPendingEvents() : this.events).filter((e) => e.threadRootId === this.id && e.isRelation(THREAD_RELATION_TYPE.name) && e.status !== null && e.getId() !== this.lastEvent?.getId());
		this.lastPendingEvent = e.length ? e[e.length - 1] : void 0, this.pendingReplyCount = e.length;
	}
	resetLiveTimeline(e, b) {
		var x = this;
		return _asyncToGenerator(function* () {
			var S = x.liveTimeline;
			x.timelineSet.resetLiveTimeline(e ?? void 0, b ?? void 0);
			var C = x.liveTimeline, w, T;
			e && (w = (yield x.client.createMessagesRequest(x.roomId, e, 1, Direction.Forward)).end), b && (T = (yield x.client.createMessagesRequest(x.roomId, b, 1, Direction.Backward)).start), b && S.getPaginationToken(Direction.Forward) === b && S.setPaginationToken(T ?? null, Direction.Forward), e && C.getPaginationToken(Direction.Backward) === e && C.setPaginationToken(w ?? null, Direction.Backward);
		})();
	}
	updateThreadFromRootEvent() {
		var b = this;
		return _asyncToGenerator(function* () {
			e.hasServerSideSupport && (!b.initialEventsFetched && !b.lastEvent && (yield b.processRootEvent()), yield b.fetchRootEvent()), yield b.processRootEvent();
		})();
	}
	updateThreadMetadata() {
		var e = this;
		return _asyncToGenerator(function* () {
			if (e.updatePendingReplyCount(), e.processRootEventPromise ||= e.updateThreadFromRootEvent(), yield e.processRootEventPromise, !e.initialEventsFetched) if (e.initalEventFetchProm) yield e.initalEventFetchProm;
			else try {
				e.timelineSet.resetLiveTimeline(), e.replyCount === 0 && e.rootEvent ? (e.timelineSet.addEventsToTimeline([e.rootEvent], !0, !1, e.liveTimeline, null), e.liveTimeline.setPaginationToken(null, Direction.Backward)) : (e.initalEventFetchProm = e.client.paginateEventTimeline(e.liveTimeline, { backwards: !0 }), yield e.initalEventFetchProm), e.initialEventsFetched = !0;
				for (var b of e.replayEvents) e.addEvent(b, !1);
				e.replayEvents = null, e.emit(RoomEvent.TimelineReset, e.room, e.timelineSet, !0);
			} catch (b) {
				logger.error("Failed to load start of newly created thread: ", b), e.initialEventsFetched = !1;
			}
			e.emit(ThreadEvent.Update, e);
		})();
	}
	fetchEditsWhereNeeded() {
		var e = arguments, b = this;
		return _asyncToGenerator(function* () {
			if ((b.client.canSupport.get(Feature.RelationsRecursion) ?? ServerSupport.Unsupported) === ServerSupport.Unsupported) {
				for (var x = e.length, S = Array(x), C = 0; C < x; C++) S[C] = e[C];
				return Promise.all(S.filter(isAnEncryptedThreadMessage).map(/* @__PURE__ */ function() {
					var e = _asyncToGenerator(function* (e) {
						try {
							var x = yield b.client.relations(b.roomId, e.getId(), RelationType.Replace, e.getType(), { limit: 1 });
							if (x.events.length) {
								var S = x.events[0];
								e.makeReplaced(S), b.insertEventIntoTimeline(S);
							}
						} catch (e) {
							logger.error("Failed to load edits for encrypted thread event", e);
						}
					});
					return function(b) {
						return e.apply(this, arguments);
					};
				}()));
			}
		})();
	}
	setEventMetadata(e) {
		e && (EventTimeline.setEventMetadata(e, this.roomState, !1), e.setThread(this));
	}
	clearEventMetadata(e) {
		if (e) {
			var b;
			e.setThread(void 0), (b = e.event) == null || (b = b.unsigned) == null || (b = b["m.relations"]) == null || delete b[THREAD_RELATION_TYPE.name];
		}
	}
	findEventById(e) {
		return this.timelineSet.findEventById(e);
	}
	lastReply() {
		for (var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (e) => e.isRelation(THREAD_RELATION_TYPE.name), b = this.timeline.length - 1; b >= 0; b--) {
			var x = this.timeline[b];
			if (e(x)) return x;
		}
		return null;
	}
	get roomId() {
		return this.room.roomId;
	}
	get length() {
		return this.replyCount + this.pendingReplyCount;
	}
	get replyToEvent() {
		return this.lastPendingEvent ?? this.lastEvent ?? this.lastReply();
	}
	get timeline() {
		return this.events;
	}
	get events() {
		return this.liveTimeline.getEvents();
	}
	has(e) {
		return this.timelineSet.findEventById(e) instanceof MatrixEvent;
	}
	get hasCurrentUserParticipated() {
		return this._currentUserParticipated;
	}
	get liveTimeline() {
		return this.timelineSet.getLiveTimeline();
	}
	getUnfilteredTimelineSet() {
		return this.timelineSet;
	}
	addReceipt(e, b) {
		throw Error("Unsupported function on the thread model");
	}
	getEventReadUpTo(e, b) {
		var x = e === this.client.getUserId(), S = this.timeline[this.timeline.length - 1];
		if (x && S) {
			var C = S.getTs() < this.room.getOldestThreadedReceiptTs(), w = S.getId();
			if (C && w) return w;
		}
		var T = super.getEventReadUpTo(e, b);
		if (S) {
			var E = this.room.getLastUnthreadedReceiptFor(e);
			if (!E) return T;
			for (var D = (O = this.timeline)?.length - 1; D >= 0; --D) {
				var O, k = this.timeline[D];
				if (k.getId() === T) return T;
				if (k.getTs() < E.ts) return k.getId() ?? T;
			}
		}
		return T;
	}
	hasUserReadEvent(e, b) {
		if (e === this.client.getUserId()) {
			var x, S = (this.lastReply()?.getTs() ?? 0) < this.room.getOldestThreadedReceiptTs(), C = this.room.getLastUnthreadedReceiptFor(e)?.ts ?? 0, w = ((this === null || this === void 0 || (x = this.lastReply()) == null ? void 0 : x.getTs()) ?? 0) < C;
			if (S || w) return !0;
		}
		return this.room.hasUserReadEvent(e, b);
	}
	setUnread(e, b) {
		return this.room.setThreadUnreadNotificationCount(this.id, e, b);
	}
	getLastUnthreadedReceiptFor(e) {
		return this.room.getLastUnthreadedReceiptFor(e);
	}
};
_defineProperty(Thread, "hasServerSideSupport", FeatureSupport.None), _defineProperty(Thread, "hasServerSideListSupport", FeatureSupport.None), _defineProperty(Thread, "hasServerSideFwdPaginationSupport", FeatureSupport.None);
function isAnEncryptedThreadMessage(e) {
	return e.isEncrypted() && (e.isRelation(THREAD_RELATION_TYPE.name) || e.isThreadRoot);
}
var FILTER_RELATED_BY_SENDERS = new ServerControlledNamespacedValue("related_by_senders", "io.element.relation_senders"), FILTER_RELATED_BY_REL_TYPES = new ServerControlledNamespacedValue("related_by_rel_types", "io.element.relation_types"), THREAD_RELATION_TYPE = new ServerControlledNamespacedValue("m.thread", "io.element.thread"), ThreadFilterType = /* @__PURE__ */ function(e) {
	return e[e.My = 0] = "My", e[e.All = 1] = "All", e;
}({});
function threadFilterTypeToFilter(e) {
	switch (e) {
		case ThreadFilterType.My: return "participated";
		default: return "all";
	}
}
var DecryptionError = class extends Error {
	constructor(e, b, x) {
		super(b), this.code = e, _defineProperty(this, "detailedString", void 0), this.name = "DecryptionError", this.detailedString = detailedStringForDecryptionError(this, x);
	}
};
function detailedStringForDecryptionError(e, b) {
	var x = e.name + "[msg: " + e.message;
	return b && (x += ", " + Object.keys(b).map((e) => e + ": " + b[e]).join(", ")), x += "]", x;
}
var import_lib = /* @__PURE__ */ __toESM(require_lib$1()), MESSAGE_VISIBLE = Object.freeze({ visible: !0 }), MAX_STICKY_DURATION_MS = 36e5, MatrixEventEvent = /* @__PURE__ */ function(e) {
	return e.Decrypted = "Event.decrypted", e.BeforeRedaction = "Event.beforeRedaction", e.VisibilityChange = "Event.visibilityChange", e.LocalEventIdReplaced = "Event.localEventIdReplaced", e.Status = "Event.status", e.Replaced = "Event.replaced", e.RelationsCreated = "Event.relationsCreated", e.SentinelUpdated = "Event.sentinelUpdated", e;
}({}), MatrixEvent = class e extends TypedEventEmitter {
	setMetadata(e, b) {
		var x, S, C = this.isState() && this.getType() === EventType.RoomMember && this.getSender() === this.getStateKey(), w = !1;
		if (C || !((x = this.sender) != null && (x = x.events) != null && x.member)) {
			var T = e.getSentinelMember(this.getSender());
			T !== this.sender && (w = !0), this.sender = T;
		}
		if (C || !((S = this.target) != null && (S = S.events) != null && S.member) && this.getType() === EventType.RoomMember) {
			var E = e.getSentinelMember(this.getStateKey());
			E !== this.target && (w = !0), this.target = E;
		}
		this.isState() && b && (this.forwardLooking = !1), w && this.emit(MatrixEventEvent.SentinelUpdated);
	}
	constructor() {
		var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
		super(), this.event = e, _defineProperty(this, "pushDetails", {}), _defineProperty(this, "_replacingEvent", null), _defineProperty(this, "_localRedactionEvent", null), _defineProperty(this, "_isCancelled", !1), _defineProperty(this, "clearEvent", void 0), _defineProperty(this, "visibility", MESSAGE_VISIBLE), _defineProperty(this, "_hasCachedExtEv", !1), _defineProperty(this, "_cachedExtEv", void 0), _defineProperty(this, "_decryptionFailureReason", null), _defineProperty(this, "senderCurve25519Key", null), _defineProperty(this, "claimedEd25519Key", null), _defineProperty(this, "forwardingCurve25519KeyChain", []), _defineProperty(this, "untrusted", null), _defineProperty(this, "decryptionPromise", null), _defineProperty(this, "retryDecryption", !1), _defineProperty(this, "txnId", void 0), _defineProperty(this, "thread", void 0), _defineProperty(this, "threadId", void 0), _defineProperty(this, "localTimestamp", void 0), _defineProperty(this, "sender", null), _defineProperty(this, "target", null), _defineProperty(this, "status", null), _defineProperty(this, "error", null), _defineProperty(this, "forwardLooking", !0), _defineProperty(this, "reEmitter", void 0), _defineProperty(this, "unstableStickyExpiresAt", void 0), [
			"state_key",
			"type",
			"sender",
			"room_id",
			"membership"
		].forEach((b) => {
			typeof e[b] == "string" && (e[b] = internaliseString(e[b]));
		}), [
			"membership",
			"avatar_url",
			"displayname"
		].forEach((b) => {
			typeof e.content?.[b] == "string" && (e.content[b] = internaliseString(e.content[b]));
		}), ["rel_type"].forEach((b) => {
			var x;
			typeof ((x = e.content) == null || (x = x["m.relates_to"]) == null ? void 0 : x[b]) == "string" && (e.content["m.relates_to"][b] = internaliseString(e.content["m.relates_to"][b]));
		}), this.txnId = e.txn_id;
		var b = this.getAge(), x = Date.now();
		this.localTimestamp = b === void 0 ? this.getTs() ?? x : x - b, this.reEmitter = new TypedReEmitter(this), this.unstableStickyInfo && (this.unstableStickyInfo.duration_ttl_ms ? this.unstableStickyExpiresAt = x + this.unstableStickyInfo.duration_ttl_ms : this.unstableStickyExpiresAt = Math.min(x, this.getTs()) + this.unstableStickyInfo.duration_ms);
	}
	get unstableExtensibleEvent() {
		return this._hasCachedExtEv || (this._cachedExtEv = import_lib.ExtensibleEvents.parse(this.getEffectiveEvent()) ?? void 0), this._cachedExtEv;
	}
	invalidateExtensibleEvent() {
		this._hasCachedExtEv = !1;
	}
	getEffectiveEvent() {
		var e = Object.assign({}, this.getContent());
		if (this.getWireType() === EventType.RoomMessageEncrypted) for (var [b, x] of Object.entries(this.getWireContent())) [
			"algorithm",
			"ciphertext",
			"device_id",
			"sender_key",
			"session_id"
		].includes(b) || e[b] === void 0 && (e[b] = x);
		return Object.assign({}, this.event, this.clearEvent, { content: e });
	}
	getId() {
		return this.event.event_id;
	}
	getSender() {
		return this.event.sender;
	}
	getType() {
		return this.clearEvent ? this.clearEvent.type : this.event.type;
	}
	getWireType() {
		return this.event.type;
	}
	getRoomId() {
		return this.event.room_id;
	}
	getTs() {
		return this.event.origin_server_ts;
	}
	getDate() {
		return this.event.origin_server_ts ? new Date(this.event.origin_server_ts) : null;
	}
	getDetails() {
		var e = this.getRoomId();
		return e ? `id=${this.getId()} type=${this.getWireType()} sender=${this.getSender()} room=${e} ts=${this.getDate()?.toISOString()}` : `msgid=${this.getContent()[ToDeviceMessageId]} type=${this.getWireType()} sender=${this.getSender()}`;
	}
	getOriginalContent() {
		return this._localRedactionEvent ? {} : this.clearEvent ? this.clearEvent.content ?? {} : this.event.content ?? {};
	}
	getContent() {
		return this._localRedactionEvent ? {} : this._replacingEvent ? this._replacingEvent.getContent()["m.new_content"] ?? {} : this.getOriginalContent();
	}
	getWireContent() {
		return this.event.content || {};
	}
	get threadRootId() {
		if (!this.isState()) {
			var e = this.getWireContent()?.["m.relates_to"];
			if (e?.rel_type === THREAD_RELATION_TYPE.name) return e.event_id;
			if (this.thread) return this.thread.id;
			if (this.threadId !== void 0) return this.threadId;
			var b = this.getUnsigned();
			if (typeof b[UNSIGNED_THREAD_ID_FIELD.name] == "string") return b[UNSIGNED_THREAD_ID_FIELD.name];
		}
	}
	get isThreadRoot() {
		return this.isState() ? !1 : !!this.getServerAggregatedRelation(THREAD_RELATION_TYPE.name) || this.threadRootId === this.getId();
	}
	get replyEventId() {
		var e;
		return (e = this.getWireContent()["m.relates_to"]) == null || (e = e["m.in_reply_to"]) == null ? void 0 : e.event_id;
	}
	get relationEventId() {
		var e;
		return (e = this.getWireContent()) == null || (e = e["m.relates_to"]) == null ? void 0 : e.event_id;
	}
	getPrevContent() {
		return this.getUnsigned().prev_content || {};
	}
	getDirectionalContent() {
		return this.forwardLooking ? this.getContent() : this.getPrevContent();
	}
	getAge() {
		return this.getUnsigned().age;
	}
	getLocalAge() {
		return Date.now() - this.localTimestamp;
	}
	getStateKey() {
		return this.clearEvent ? this.clearEvent.state_key : this.event.state_key;
	}
	getWireStateKey() {
		return this.event.state_key;
	}
	isState() {
		return this.event.state_key !== void 0;
	}
	getMembershipAtEvent() {
		var e = this.getUnsigned();
		return UNSIGNED_MEMBERSHIP_FIELD.findIn(e);
	}
	makeEncrypted(e, b, x, S) {
		this.clearEvent = {
			type: this.event.type,
			content: this.event.content,
			state_key: this.event.state_key
		}, this.event.type = e, this.event.content = b, this.senderCurve25519Key = x, this.claimedEd25519Key = S, this.isState() && (this.event.state_key = `${this.clearEvent.type}:${this.clearEvent.state_key}`);
	}
	isBeingDecrypted() {
		return this.decryptionPromise != null;
	}
	getDecryptionPromise() {
		return this.decryptionPromise;
	}
	isDecryptionFailure() {
		return this._decryptionFailureReason !== null;
	}
	get decryptionFailureReason() {
		return this._decryptionFailureReason;
	}
	shouldAttemptDecryption() {
		return !(this.isRedacted() || this.isBeingDecrypted() || this.clearEvent || !this.isEncrypted());
	}
	attemptDecryption(e) {
		var b = arguments, x = this;
		return _asyncToGenerator(function* () {
			var S = b.length > 1 && b[1] !== void 0 ? b[1] : {};
			if (!x.isEncrypted()) throw Error("Attempt to decrypt event which isn't encrypted");
			var C = x.clearEvent && !x.isDecryptionFailure(), w = S.forceRedecryptIfUntrusted && x.isKeySourceUntrusted();
			if (C && !w) throw Error("Attempt to decrypt event which has already been decrypted");
			return x.decryptionPromise ? (logger.log(`Event ${x.getId()} already being decrypted; queueing a retry`), x.retryDecryption = !0, x.decryptionPromise) : (x.decryptionPromise = x.decryptionLoop(e, S), x.decryptionPromise);
		})();
	}
	getKeyRequestRecipients(e) {
		return [{
			userId: e,
			deviceId: "*"
		}];
	}
	decryptionLoop(e) {
		var b = arguments, x = this;
		return _asyncToGenerator(function* () {
			var S = b.length > 1 && b[1] !== void 0 ? b[1] : {};
			for (yield Promise.resolve();;) {
				x.retryDecryption = !1;
				var C = void 0;
				try {
					var w = yield e.decryptEvent(x);
					S.isRetry === !0 && logger.info(`Decrypted event on retry (${x.getDetails()})`), x.setClearData(w), x._decryptionFailureReason = null;
				} catch (e) {
					var T = e instanceof DecryptionError ? e.detailedString : String(e);
					if (C = e, x.retryDecryption) {
						logger.log(`Error decrypting event (${x.getDetails()}), but retrying: ${T}`);
						continue;
					}
					logger.warn(`Error decrypting event (${x.getDetails()}): ${T}`), x.setClearDataForDecryptionFailure(String(e)), x._decryptionFailureReason = e instanceof DecryptionError ? e.code : DecryptionFailureCode.UNKNOWN_ERROR;
				}
				x.decryptionPromise = null, x.retryDecryption = !1, x.setPushDetails(), S.emit !== !1 && x.emit(MatrixEventEvent.Decrypted, x, C);
				return;
			}
		})();
	}
	setClearData(e) {
		this.clearEvent = e.clearEvent, this.senderCurve25519Key = e.senderCurve25519Key ?? null, this.claimedEd25519Key = e.claimedEd25519Key ?? null, this.forwardingCurve25519KeyChain = e.forwardingCurve25519KeyChain || [], this.untrusted = e.untrusted || !1, this.invalidateExtensibleEvent();
	}
	setClearDataForDecryptionFailure(e) {
		this.clearEvent = {
			type: EventType.RoomMessage,
			content: {
				msgtype: "m.bad.encrypted",
				body: `** Unable to decrypt: ${e} **`
			}
		}, this.senderCurve25519Key = null, this.claimedEd25519Key = null, this.forwardingCurve25519KeyChain = [], this.untrusted = !1, this.invalidateExtensibleEvent();
	}
	getClearContent() {
		return this.clearEvent ? this.clearEvent.content : null;
	}
	isEncrypted() {
		return this.event.type === EventType.RoomMessageEncrypted;
	}
	getSenderKey() {
		return this.senderCurve25519Key;
	}
	getKeysClaimed() {
		return this.claimedEd25519Key ? { ed25519: this.claimedEd25519Key } : {};
	}
	getClaimedEd25519Key() {
		return this.claimedEd25519Key;
	}
	getForwardingCurve25519KeyChain() {
		return this.forwardingCurve25519KeyChain;
	}
	isKeySourceUntrusted() {
		return !!this.untrusted;
	}
	getUnsigned() {
		return this.event.unsigned || {};
	}
	setUnsigned(e) {
		this.event.unsigned = e;
	}
	unmarkLocallyRedacted() {
		var e = this._localRedactionEvent;
		return this._localRedactionEvent = null, this.event.unsigned && (this.event.unsigned.redacted_because = void 0), !!e;
	}
	markLocallyRedacted(e) {
		this._localRedactionEvent || (this.emit(MatrixEventEvent.BeforeRedaction, this, e), this._localRedactionEvent = e, this.event.unsigned || (this.event.unsigned = {}), this.event.unsigned.redacted_because = e.event);
	}
	applyVisibilityEvent(e) {
		var b = e?.visible ?? !0, x = e?.reason ?? null, S = !1;
		this.visibility.visible === b ? !this.visibility.visible && this.visibility.reason !== x && (S = !0) : S = !0, S && (b ? this.visibility = MESSAGE_VISIBLE : this.visibility = Object.freeze({
			visible: !1,
			reason: x
		}), this.emit(MatrixEventEvent.VisibilityChange, this, b));
	}
	messageVisibility() {
		return this.visibility;
	}
	makeRedacted(e, b) {
		if (!e.event) throw Error("invalid redactionEvent in makeRedacted");
		for (var x in this._localRedactionEvent = null, this.emit(MatrixEventEvent.BeforeRedaction, this, e), this._replacingEvent = null, this.event.unsigned || (this.event.unsigned = {}), this.event.unsigned.redacted_because = e.event, this.event) this.event.hasOwnProperty(x) && !REDACT_KEEP_KEYS.has(x) && delete this.event[x];
		this.isEncrypted() && (this.clearEvent = void 0);
		var S = this.getType() in REDACT_KEEP_CONTENT_MAP ? REDACT_KEEP_CONTENT_MAP[this.getType()] : {}, C = this.getContent();
		for (var w in C) C.hasOwnProperty(w) && !S[w] && delete C[w];
		!this.isThreadRoot && this.threadRootId && this.threadRootId !== this.getId() && (this.moveAllRelatedToMainTimeline(b), e.moveToMainTimeline(b)), this.invalidateExtensibleEvent();
	}
	moveAllRelatedToMainTimeline(e) {
		var b = this.thread;
		if (this.moveToMainTimeline(e), b) for (var x of b.events) x.getRelation()?.event_id === this.getId() && x.moveAllRelatedToMainTimeline(e);
	}
	moveToMainTimeline(e) {
		var b;
		(b = this.thread) == null || b.timelineSet.removeEvent(this.getId()), this.setThread(void 0);
		var x = e.getLiveTimeline();
		x.getTimelineSet().insertEventIntoTimeline(this, x, x.getState(EventTimeline.FORWARDS), !1);
	}
	isRedacted() {
		return !!this.getUnsigned().redacted_because;
	}
	isRedaction() {
		return this.getType() === EventType.RoomRedaction;
	}
	asVisibilityChange() {
		if (!EVENT_VISIBILITY_CHANGE_TYPE.matches(this.getType())) return null;
		var e = this.getRelation();
		if (!e || e.rel_type != "m.reference") return null;
		var b = e.event_id;
		if (!b) return null;
		var x = this.getWireContent(), S = !!x.visible, C = x.reason;
		return C && typeof C != "string" ? null : {
			visible: S,
			reason: C,
			eventId: b
		};
	}
	isVisibilityEvent() {
		return EVENT_VISIBILITY_CHANGE_TYPE.matches(this.getType());
	}
	getRedactionEvent() {
		var e, b;
		return this.isRedacted() ? (e = this.clearEvent) != null && e.unsigned ? this.clearEvent?.unsigned.redacted_because ?? null : (b = this.event.unsigned) != null && b.redacted_because ? this.event.unsigned.redacted_because : {} : null;
	}
	getPushActions() {
		return this.pushDetails.actions || null;
	}
	getPushDetails() {
		return this.pushDetails;
	}
	setPushDetails(e, b) {
		this.pushDetails = {
			actions: e,
			rule: b
		};
	}
	handleRemoteEcho(e) {
		var b = this.getUnsigned(), x = this.getId();
		this.event = e, b.redacted_because && (this.event.unsigned || (this.event.unsigned = {}), this.event.unsigned.redacted_because = b.redacted_because), this.setStatus(null), this.getId() !== x && this.emit(MatrixEventEvent.LocalEventIdReplaced, this), this.localTimestamp = Date.now() - (this.getAge() ?? 0);
	}
	isSending() {
		return !!this.status;
	}
	setStatus(e) {
		this.status = e, this.emit(MatrixEventEvent.Status, this, e);
	}
	replaceLocalEventId(e) {
		this.event.event_id = e, this.emit(MatrixEventEvent.LocalEventIdReplaced, this);
	}
	isRelation(e) {
		var b = this.getWireContent()?.["m.relates_to"];
		return this.isState() && b != null && b.rel_type && [RelationType.Replace, RelationType.Thread].includes(b.rel_type) ? !1 : !!(b != null && b.rel_type && b.event_id && (!e || b.rel_type === e));
	}
	getRelation() {
		return this.isRelation() ? this.getWireContent()["m.relates_to"] ?? null : null;
	}
	makeReplaced(e) {
		this.isRedacted() && e || this.isState() || this._replacingEvent !== e && (this._replacingEvent = e ?? null, this.emit(MatrixEventEvent.Replaced, this), this.invalidateExtensibleEvent());
	}
	getAssociatedStatus() {
		return this._replacingEvent ? this._replacingEvent.status : this._localRedactionEvent ? this._localRedactionEvent.status : this.status;
	}
	getServerAggregatedRelation(e) {
		return this.getUnsigned()["m.relations"]?.[e];
	}
	replacingEventId() {
		var e = this.getServerAggregatedRelation(RelationType.Replace);
		if (e) return e.event_id;
		if (this._replacingEvent) return this._replacingEvent.getId();
	}
	replacingEvent() {
		return this._replacingEvent;
	}
	replacingEventDate() {
		var e = this.getServerAggregatedRelation(RelationType.Replace);
		if (e) {
			var b = e.origin_server_ts;
			if (Number.isFinite(b)) return new Date(b);
		} else if (this._replacingEvent) return this._replacingEvent.getDate() ?? void 0;
	}
	localRedactionEvent() {
		return this._localRedactionEvent;
	}
	getAssociatedId() {
		var e = this.getRelation();
		if (this.replyEventId) return this.replyEventId;
		if (e) return e.event_id;
		if (this.isRedaction()) return this.event.redacts;
	}
	hasAssociation() {
		return !!this.getAssociatedId();
	}
	updateAssociatedId(e) {
		var b = this.getRelation();
		b ? b.event_id = e : this.isRedaction() && (this.event.redacts = e);
	}
	flagCancelled() {
		this._isCancelled = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
	}
	isCancelled() {
		return this._isCancelled;
	}
	toSnapshot() {
		var b = new e(JSON.parse(JSON.stringify(this.event)));
		for (var [x, S] of Object.entries(this)) x !== "event" && (b[x] = S);
		return b;
	}
	isEquivalentTo(e) {
		if (!e) return !1;
		if (e === this) return !0;
		var b = deepSortedObjectEntries(this.event), x = deepSortedObjectEntries(e.event);
		return JSON.stringify(b) === JSON.stringify(x);
	}
	toJSON() {
		var e = this.getEffectiveEvent();
		return this.isEncrypted() ? {
			decrypted: e,
			encrypted: this.event
		} : e;
	}
	setTxnId(e) {
		this.txnId = e;
	}
	getTxnId() {
		return this.txnId;
	}
	setThread(e) {
		this.isState() || (this.thread && this.reEmitter.stopReEmitting(this.thread, [ThreadEvent.Update]), this.thread = e, this.setThreadId(e?.id), e && this.reEmitter.reEmit(e, [ThreadEvent.Update]));
	}
	getThread() {
		return this.thread;
	}
	setThreadId(e) {
		this.threadId = e;
	}
	get unstableStickyInfo() {
		var e;
		if ((e = this.event.msc4354_sticky) != null && e.duration_ms) return {
			duration_ms: Math.min(MAX_STICKY_DURATION_MS, this.event.msc4354_sticky.duration_ms),
			duration_ttl_ms: this.event.unsigned?.msc4354_sticky_duration_ttl_ms
		};
	}
}, REDACT_KEEP_KEYS = new Set([
	"event_id",
	"type",
	"room_id",
	"user_id",
	"sender",
	"state_key",
	"prev_state",
	"content",
	"unsigned",
	"origin_server_ts"
]), REDACT_KEEP_CONTENT_MAP = {
	[EventType.RoomMember]: { membership: 1 },
	[EventType.RoomJoinRules]: { join_rule: 1 },
	[EventType.RoomPowerLevels]: {
		ban: 1,
		events: 1,
		events_default: 1,
		kick: 1,
		redact: 1,
		state_default: 1,
		users: 1,
		users_default: 1
	}
}, PRE_HYDRA_ROOM_VERSIONS = [
	"1",
	"2",
	"3",
	"4",
	"5",
	"6",
	"7",
	"8",
	"9",
	"10",
	"11"
];
function shouldUseHydraForRoomVersion(e) {
	return !PRE_HYDRA_ROOM_VERSIONS.includes(e);
}
var OobStatus = /* @__PURE__ */ function(e) {
	return e[e.NotStarted = 0] = "NotStarted", e[e.InProgress = 1] = "InProgress", e[e.Finished = 2] = "Finished", e;
}(OobStatus || {}), RoomStateEvent = /* @__PURE__ */ function(e) {
	return e.Events = "RoomState.events", e.Members = "RoomState.members", e.NewMember = "RoomState.newMember", e.Update = "RoomState.update", e.BeaconLiveness = "RoomState.BeaconLiveness", e.Marker = "RoomState.Marker", e;
}({}), RoomState = class e extends TypedEventEmitter {
	constructor(e) {
		var b = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : { status: OobStatus.NotStarted };
		super(), this.roomId = e, this.oobMemberFlags = b, _defineProperty(this, "reEmitter", new TypedReEmitter(this)), _defineProperty(this, "sentinels", {}), _defineProperty(this, "displayNameToUserIds", /* @__PURE__ */ new Map()), _defineProperty(this, "userIdsToDisplayNames", {}), _defineProperty(this, "tokenToInvite", {}), _defineProperty(this, "joinedMemberCount", null), _defineProperty(this, "summaryJoinedMemberCount", null), _defineProperty(this, "invitedMemberCount", null), _defineProperty(this, "summaryInvitedMemberCount", null), _defineProperty(this, "modified", -1), _defineProperty(this, "members", {}), _defineProperty(this, "events", /* @__PURE__ */ new Map()), _defineProperty(this, "paginationToken", null), _defineProperty(this, "beacons", /* @__PURE__ */ new Map()), _defineProperty(this, "_liveBeaconIds", []), _defineProperty(this, "getVersionWarning", !1), this.updateModifiedTime();
	}
	getRoomVersion() {
		var e = this.getStateEvents(EventType.RoomCreate, "");
		return e ? e.getContent().room_version ?? "1" : (this.getVersionWarning ||= (logger.warn("[getVersion] Room " + this.roomId + " does not have an m.room.create event"), !0), "1");
	}
	getJoinedMemberCount() {
		return this.summaryJoinedMemberCount === null ? (this.joinedMemberCount === null && (this.joinedMemberCount = this.getMembers().reduce((e, b) => b.membership === KnownMembership.Join ? e + 1 : e, 0)), this.joinedMemberCount) : this.summaryJoinedMemberCount;
	}
	setJoinedMemberCount(e) {
		this.summaryJoinedMemberCount = e;
	}
	getInvitedMemberCount() {
		return this.summaryInvitedMemberCount === null ? (this.invitedMemberCount === null && (this.invitedMemberCount = this.getMembers().reduce((e, b) => b.membership === KnownMembership.Invite ? e + 1 : e, 0)), this.invitedMemberCount) : this.summaryInvitedMemberCount;
	}
	setInvitedMemberCount(e) {
		this.summaryInvitedMemberCount = e;
	}
	getMembers() {
		return Object.values(this.members);
	}
	getMembersExcept(e) {
		return this.getMembers().filter((b) => !e.includes(b.userId));
	}
	getMember(e) {
		return this.members[e] || null;
	}
	getSentinelMember(e) {
		if (!e) return null;
		var b = this.sentinels[e];
		if (b === void 0) {
			b = new RoomMember(this.roomId, e);
			var x = this.members[e];
			x != null && x.events.member && b.setMembershipEvent(x.events.member, this), this.sentinels[e] = b;
		}
		return b;
	}
	getStateEvents(e, b) {
		return this.events.has(e) ? b === void 0 ? Array.from(this.events.get(e).values()) : this.events.get(e).get(b) || null : b === void 0 ? [] : null;
	}
	get hasLiveBeacons() {
		var e;
		return !!((e = this.liveBeaconIds) != null && e.length);
	}
	get liveBeaconIds() {
		return this._liveBeaconIds;
	}
	clone() {
		var b = new e(this.roomId, this.oobMemberFlags), x = this.oobMemberFlags.status;
		return this.oobMemberFlags.status = OobStatus.NotStarted, Array.from(this.events.values()).forEach((e) => {
			b.setStateEvents(Array.from(e.values()));
		}), this.oobMemberFlags.status = x, this.summaryInvitedMemberCount !== null && b.setInvitedMemberCount(this.getInvitedMemberCount()), this.summaryJoinedMemberCount !== null && b.setJoinedMemberCount(this.getJoinedMemberCount()), this.oobMemberFlags.status == OobStatus.Finished && this.getMembers().forEach((e) => {
			if (e.isOutOfBand()) {
				var x;
				(x = b.getMember(e.userId)) == null || x.markOutOfBand();
			}
		}), b;
	}
	setUnknownStateEvents(e) {
		var b = e.filter((e) => !this.events.has(e.getType()) || !this.events.get(e.getType()).has(e.getStateKey()));
		this.setStateEvents(b);
	}
	setStateEvents(e, b) {
		this.updateModifiedTime(), e.forEach((e) => {
			if (!(e.getRoomId() !== this.roomId || !e.isState())) {
				M_BEACON_INFO.matches(e.getType()) && this.setBeacon(e);
				var b = this.getStateEventMatching(e);
				this.setStateEvent(e), e.getType() === EventType.RoomMember && (this.updateDisplayNameCache(e.getStateKey(), e.getContent().displayname ?? ""), this.updateThirdPartyTokenCache(e)), this.emit(RoomStateEvent.Events, e, this, b);
			}
		}), this.onBeaconLivenessChange(), e.forEach((e) => {
			if (!(e.getRoomId() !== this.roomId || !e.isState())) if (e.getType() === EventType.RoomMember) {
				var x = e.getStateKey();
				(e.getContent().membership === KnownMembership.Leave || e.getContent().membership === KnownMembership.Ban) && (e.getContent().avatar_url = e.getContent().avatar_url || e.getPrevContent().avatar_url, e.getContent().displayname = e.getContent().displayname || e.getPrevContent().displayname);
				var S = this.getOrCreateMember(x, e);
				S.setMembershipEvent(e, this), this.updateMember(S), this.emit(RoomStateEvent.Members, e, this, S);
			} else if (e.getType() === EventType.RoomPowerLevels) {
				if (e.getStateKey() !== "") return;
				var C = Object.values(this.members), w = this.getStateEvents(EventType.RoomCreate, ""), T = getCreators(this.getRoomVersion(), w);
				C.forEach((b) => {
					var x = b.getLastModifiedTime();
					if (w) {
						var S = powerLevelForUserId(b.userId, e, T);
						b.setPowerLevel(S, e);
					}
					x !== b.getLastModifiedTime() && this.emit(RoomStateEvent.Members, e, this, b);
				}), this.sentinels = {};
			} else UNSTABLE_MSC2716_MARKER.matches(e.getType()) && this.emit(RoomStateEvent.Marker, e, b);
		}), this.emit(RoomStateEvent.Update, this);
	}
	processBeaconEvents(e, b) {
		var x = this;
		return _asyncToGenerator(function* () {
			if (!(!e.length || !x.beacons.size)) {
				var S = [...x.beacons.values()].reduce((e, b) => (e[b.beaconInfoId] = b, e), {}), C = (e, b) => {
					if (M_BEACON.matches(b.getType())) {
						var x = S[e];
						x && x.addLocations([b]);
					}
				}, w = function* (e) {
					var x = e.getRelation()?.event_id;
					if (!x || !S[x] || !M_BEACON.matches(e.getType()) && !e.isEncrypted()) return { v: void 0 };
					try {
						yield b.decryptEventIfNeeded(e), C(x, e);
					} catch {
						e.isDecryptionFailure() && e.once(MatrixEventEvent.Decrypted, /* @__PURE__ */ _asyncToGenerator(function* () {
							C(x, e);
						}));
					}
				}, T;
				for (var E of e) if (T = yield* w(E), T) return T.v;
			}
		})();
	}
	getOrCreateMember(e, b) {
		var x = this.members[e];
		return x || (x = new RoomMember(this.roomId, e), this.members[e] = x, this.emit(RoomStateEvent.NewMember, b, this, x)), x;
	}
	setStateEvent(e) {
		this.events.has(e.getType()) || this.events.set(e.getType(), /* @__PURE__ */ new Map()), this.events.get(e.getType()).set(e.getStateKey(), e);
	}
	setBeacon(e) {
		var b = getBeaconInfoIdentifier(e);
		if (this.beacons.has(b)) {
			var x = this.beacons.get(b);
			if (e.isRedacted()) {
				x.beaconInfoId === e.getRedactionEvent()?.redacts && (x.destroy(), this.beacons.delete(b));
				return;
			}
			return x.update(e);
		}
		if (!e.isRedacted()) {
			var S = new Beacon(e);
			this.reEmitter.reEmit(S, [
				BeaconEvent.New,
				BeaconEvent.Update,
				BeaconEvent.Destroy,
				BeaconEvent.LivenessChange
			]), this.emit(BeaconEvent.New, e, S), S.on(BeaconEvent.LivenessChange, this.onBeaconLivenessChange.bind(this)), S.on(BeaconEvent.Destroy, this.onBeaconLivenessChange.bind(this)), this.beacons.set(S.identifier, S);
		}
	}
	onBeaconLivenessChange() {
		this._liveBeaconIds = Array.from(this.beacons.values()).filter((e) => e.isLive).map((e) => e.identifier), this.emit(RoomStateEvent.BeaconLiveness, this, this.hasLiveBeacons);
	}
	getStateEventMatching(e) {
		return this.events.get(e.getType())?.get(e.getStateKey()) ?? null;
	}
	updateMember(e) {
		var b = this.getStateEvents(EventType.RoomCreate, ""), x = this.getStateEvents(EventType.RoomPowerLevels, "");
		if (x && b) {
			var S = powerLevelForUserId(e.userId, x, getCreators(this.getRoomVersion(), b));
			e.setPowerLevel(S, x);
		}
		delete this.sentinels[e.userId], this.members[e.userId] = e, this.joinedMemberCount = null, this.invitedMemberCount = null;
	}
	needsOutOfBandMembers() {
		return this.oobMemberFlags.status === OobStatus.NotStarted;
	}
	outOfBandMembersReady() {
		return this.oobMemberFlags.status === OobStatus.Finished;
	}
	markOutOfBandMembersStarted() {
		this.oobMemberFlags.status === OobStatus.NotStarted && (this.oobMemberFlags.status = OobStatus.InProgress);
	}
	markOutOfBandMembersFailed() {
		this.oobMemberFlags.status === OobStatus.InProgress && (this.oobMemberFlags.status = OobStatus.NotStarted);
	}
	clearOutOfBandMembers() {
		var e = 0;
		Object.keys(this.members).forEach((b) => {
			this.members[b].isOutOfBand() && (++e, delete this.members[b]);
		}), logger.log(`LL: RoomState removed ${e} members...`), this.oobMemberFlags.status = OobStatus.NotStarted;
	}
	setOutOfBandMembers(e) {
		logger.log(`LL: RoomState about to set ${e.length} OOB members ...`), this.oobMemberFlags.status === OobStatus.InProgress && (logger.log("LL: RoomState put in finished state ..."), this.oobMemberFlags.status = OobStatus.Finished, e.forEach((e) => this.setOutOfBandMember(e)), this.emit(RoomStateEvent.Update, this));
	}
	setOutOfBandMember(e) {
		if (e.getType() === EventType.RoomMember) {
			var b = e.getStateKey(), x = this.getMember(b);
			if (!(x && !x.isOutOfBand())) {
				var S = this.getOrCreateMember(b, e);
				S.setMembershipEvent(e, this), S.markOutOfBand(), this.updateDisplayNameCache(S.userId, S.name), this.setStateEvent(e), this.updateMember(S), this.emit(RoomStateEvent.Members, e, this, S);
			}
		}
	}
	setTypingEvent(e) {
		Object.values(this.members).forEach(function(b) {
			b.setTypingEvent(e);
		});
	}
	getInviteForThreePidToken(e) {
		return this.tokenToInvite[e] || null;
	}
	updateModifiedTime() {
		this.modified = Date.now();
	}
	getLastModifiedTime() {
		return this.modified;
	}
	getUserIdsWithDisplayName(e) {
		return this.displayNameToUserIds.get(removeHiddenChars(e)) ?? [];
	}
	maySendRedactionForEvent(e, b) {
		var x = this.getMember(b);
		return !x || x.membership === KnownMembership.Leave || e.status || e.isRedacted() || !this.maySendEvent(EventType.RoomRedaction, b) ? !1 : e.getSender() === b ? !0 : this.hasSufficientPowerLevelFor("redact", x.powerLevel);
	}
	hasSufficientPowerLevelFor(e, b) {
		var x = this.getStateEvents(EventType.RoomPowerLevels, ""), S = {};
		x && (S = x.getContent());
		var C = 50;
		return isNumber(S[e]) && (C = S[e]), b >= C;
	}
	maySendMessage(e) {
		return this.maySendEventOfType(EventType.RoomMessage, e, !1);
	}
	maySendEvent(e, b) {
		return this.maySendEventOfType(e, b, !1);
	}
	mayClientSendStateEvent(e, b) {
		return b.isGuest() || !b.credentials.userId ? !1 : this.maySendStateEvent(e, b.credentials.userId);
	}
	maySendStateEvent(e, b) {
		return this.maySendEventOfType(e, b, !0);
	}
	maySendEventOfType(e, b, x) {
		var S = this.getStateEvents(EventType.RoomPowerLevels, ""), C, w = {}, T = 0, E = 0;
		S && (C = S.getContent(), w = C.events || {}, T = Number.isSafeInteger(C.state_default) ? C.state_default : 50, Number.isSafeInteger(C.events_default) && (E = C.events_default));
		var D = x ? T : E;
		return Number.isSafeInteger(w[e]) && (D = w[e]), (this.getMember(b)?.powerLevel ?? 0) >= D;
	}
	mayTriggerNotifOfType(e, b) {
		var x = this.getMember(b);
		if (!x) return !1;
		var S = this.getStateEvents(EventType.RoomPowerLevels, ""), C = 50;
		return S && S.getContent() && S.getContent().notifications && isNumber(S.getContent().notifications[e]) && (C = S.getContent().notifications[e]), x.powerLevel >= C;
	}
	getJoinRule() {
		return (this.getStateEvents(EventType.RoomJoinRules, "")?.getContent() ?? {}).join_rule || JoinRule.Invite;
	}
	getHistoryVisibility() {
		return (this.getStateEvents(EventType.RoomHistoryVisibility, "")?.getContent() ?? {}).history_visibility || HistoryVisibility.Shared;
	}
	getGuestAccess() {
		return (this.getStateEvents(EventType.RoomGuestAccess, "")?.getContent() ?? {}).guest_access || GuestAccess.Forbidden;
	}
	findPredecessor() {
		if (arguments.length > 0 && arguments[0] !== void 0 && arguments[0]) {
			var e = this.getStateEvents(EventType.RoomPredecessor, "");
			if (e) {
				var b = e.getContent(), x = b.predecessor_room_id, S = b.last_known_event_id;
				typeof S != "string" && (S = void 0);
				var C = b.via_servers;
				if (Array.isArray(C) || (C = void 0), typeof x == "string") return {
					roomId: x,
					eventId: S,
					viaServers: C
				};
			}
		}
		var w = this.getStateEvents(EventType.RoomCreate, "");
		if (w) {
			var T = w.getContent().predecessor;
			if (T) {
				var E = T.room_id;
				if (typeof E == "string") {
					var D = T.event_id;
					return (typeof D != "string" || D === "") && (D = void 0), {
						roomId: E,
						eventId: D
					};
				}
			}
		}
		return null;
	}
	updateThirdPartyTokenCache(e) {
		if (e.getContent().third_party_invite) {
			var b = (e.getContent().third_party_invite.signed || {}).token;
			b && this.getStateEvents(EventType.RoomThirdPartyInvite, b) && (this.tokenToInvite[b] = e);
		}
	}
	updateDisplayNameCache(e, b) {
		var x = this.userIdsToDisplayNames[e];
		if (delete this.userIdsToDisplayNames[e], x) {
			var S = removeHiddenChars(x), C = this.displayNameToUserIds.get(S);
			if (C) {
				var w = C.filter((b) => b !== e);
				this.displayNameToUserIds.set(S, w);
			}
		}
		this.userIdsToDisplayNames[e] = b;
		var T = b && removeHiddenChars(b);
		if (T) {
			var E = this.displayNameToUserIds.get(T) ?? [];
			E.push(e), this.displayNameToUserIds.set(T, E);
		}
	}
};
function getCreators(e, b) {
	var x = /* @__PURE__ */ new Set();
	if (shouldUseHydraForRoomVersion(e) && b) {
		var S = b.getSender();
		S && x.add(S);
		var C = b.getDirectionalContent().additional_creators;
		Array.isArray(C) && C.forEach((e) => x.add(e));
	}
	return x;
}
function powerLevelForUserId(e, b, x) {
	if (x.has(e)) return Infinity;
	var S = b.getDirectionalContent(), C = S.users || {};
	return C[e] !== void 0 && Number.isInteger(C[e]) ? C[e] : S.users_default === void 0 ? 0 : S.users_default;
}
var DeviceVerification = /* @__PURE__ */ function(e) {
	return e[e.Blocked = -1] = "Blocked", e[e.Unverified = 0] = "Unverified", e[e.Verified = 1] = "Verified", e;
}({}), Device = class {
	constructor(e) {
		_defineProperty(this, "deviceId", void 0), _defineProperty(this, "userId", void 0), _defineProperty(this, "algorithms", void 0), _defineProperty(this, "keys", void 0), _defineProperty(this, "verified", void 0), _defineProperty(this, "signatures", void 0), _defineProperty(this, "displayName", void 0), _defineProperty(this, "dehydrated", !1), this.deviceId = e.deviceId, this.userId = e.userId, this.algorithms = e.algorithms, this.keys = e.keys, this.verified = e.verified || DeviceVerification.Unverified, this.signatures = e.signatures || /* @__PURE__ */ new Map(), this.displayName = e.displayName, this.dehydrated = !!e.dehydrated;
	}
	getFingerprint() {
		return this.keys.get(`ed25519:${this.deviceId}`);
	}
	getIdentityKey() {
		return this.keys.get(`curve25519:${this.deviceId}`);
	}
};
function exists(e, b) {
	return new Promise((x, S) => {
		var C = !0, w = e.open(b);
		w.onupgradeneeded = () => {
			C = !1;
		}, w.onblocked = () => S(w.error), w.onsuccess = () => {
			w.result.close(), C || e.deleteDatabase(b), x(C);
		}, w.onerror = () => S(w.error);
	});
}
var E2E_PREFIX = "crypto.", KEY_END_TO_END_MIGRATION_STATE = E2E_PREFIX + "migration", KEY_END_TO_END_ACCOUNT = E2E_PREFIX + "account", KEY_CROSS_SIGNING_KEYS = E2E_PREFIX + "cross_signing_keys", KEY_INBOUND_SESSION_PREFIX = E2E_PREFIX + "inboundgroupsessions/", KEY_INBOUND_SESSION_WITHHELD_PREFIX = E2E_PREFIX + "inboundgroupsessions.withheld/", KEY_ROOMS_PREFIX = E2E_PREFIX + "rooms/", KEY_SESSIONS_NEEDING_BACKUP = E2E_PREFIX + "sessionsneedingbackup";
function keyEndToEndSessions(e) {
	return E2E_PREFIX + "sessions/" + e;
}
function keyEndToEndInboundGroupSession(e, b) {
	return KEY_INBOUND_SESSION_PREFIX + e + "/" + b;
}
function keyEndToEndInboundGroupSessionWithheld(e, b) {
	return KEY_INBOUND_SESSION_WITHHELD_PREFIX + e + "/" + b;
}
function keyEndToEndRoomsPrefix(e) {
	return KEY_ROOMS_PREFIX + e;
}
var LocalStorageCryptoStore = class e extends MemoryCryptoStore {
	static exists(e) {
		for (var b = e.length, x = 0; x < b; x++) {
			var S;
			if ((S = e.key(x)) != null && S.startsWith(E2E_PREFIX)) return !0;
		}
		return !1;
	}
	constructor(e) {
		super(), this.store = e;
	}
	containsData() {
		var b = this;
		return _asyncToGenerator(function* () {
			return e.exists(b.store);
		})();
	}
	getMigrationState() {
		var e = this;
		return _asyncToGenerator(function* () {
			return getJsonItem(e.store, KEY_END_TO_END_MIGRATION_STATE) ?? MigrationState.NOT_STARTED;
		})();
	}
	setMigrationState(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			setJsonItem(b.store, KEY_END_TO_END_MIGRATION_STATE, e);
		})();
	}
	countEndToEndSessions(e, b) {
		for (var x = 0, S = 0; S < this.store.length; ++S) {
			var C = this.store.key(S);
			if (C != null && C.startsWith(keyEndToEndSessions(""))) {
				var w = getJsonItem(this.store, C);
				x += Object.keys(w ?? {}).length;
			}
		}
		b(x);
	}
	_getEndToEndSessions(e) {
		var b = getJsonItem(this.store, keyEndToEndSessions(e)), x = {};
		for (var [S, C] of Object.entries(b || {})) typeof C == "string" ? x[S] = { session: C } : x[S] = C;
		return x;
	}
	getEndToEndSession(e, b, x, S) {
		var C = this._getEndToEndSessions(e);
		S(C[b] ?? {});
	}
	getEndToEndSessions(e, b, x) {
		x(this._getEndToEndSessions(e) ?? {});
	}
	storeEndToEndSession(e, b, x, S) {
		var C = this._getEndToEndSessions(e) || {};
		C[b] = x, setJsonItem(this.store, keyEndToEndSessions(e), C);
	}
	getEndToEndSessionsBatch() {
		var e = this;
		return _asyncToGenerator(function* () {
			for (var b = [], x = 0; x < e.store.length; ++x) {
				var S;
				if ((S = e.store.key(x)) != null && S.startsWith(keyEndToEndSessions(""))) {
					var C = e.store.key(x).split("/")[1];
					for (var w of Object.values(e._getEndToEndSessions(C))) if (b.push(w), b.length >= 50) return b;
				}
			}
			return b.length === 0 ? null : b;
		})();
	}
	deleteEndToEndSessionsBatch(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			for (var { deviceKey: x, sessionId: S } of e) {
				var C = b._getEndToEndSessions(x) || {};
				delete C[S], Object.keys(C).length === 0 ? b.store.removeItem(keyEndToEndSessions(x)) : setJsonItem(b.store, keyEndToEndSessions(x), C);
			}
		})();
	}
	getEndToEndInboundGroupSession(e, b, x, S) {
		S(getJsonItem(this.store, keyEndToEndInboundGroupSession(e, b)), getJsonItem(this.store, keyEndToEndInboundGroupSessionWithheld(e, b)));
	}
	storeEndToEndInboundGroupSession(e, b, x, S) {
		setJsonItem(this.store, keyEndToEndInboundGroupSession(e, b), x);
	}
	countEndToEndInboundGroupSessions() {
		var e = this;
		return _asyncToGenerator(function* () {
			for (var b = 0, x = 0; x < e.store.length; ++x) {
				var S = e.store.key(x);
				S != null && S.startsWith(KEY_INBOUND_SESSION_PREFIX) && (b += 1);
			}
			return b;
		})();
	}
	getEndToEndInboundGroupSessionsBatch() {
		var e = this;
		return _asyncToGenerator(function* () {
			for (var b = getJsonItem(e.store, KEY_SESSIONS_NEEDING_BACKUP) || {}, x = [], S = 0; S < e.store.length; ++S) {
				var C = e.store.key(S);
				if (C != null && C.startsWith(KEY_INBOUND_SESSION_PREFIX)) {
					var w = C.slice(KEY_INBOUND_SESSION_PREFIX.length);
					if (x.push({
						senderKey: w.slice(0, 43),
						sessionId: w.slice(44),
						sessionData: getJsonItem(e.store, C),
						needsBackup: w in b
					}), x.length >= 50) return x;
				}
			}
			return x.length === 0 ? null : x;
		})();
	}
	deleteEndToEndInboundGroupSessionsBatch(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			for (var { senderKey: x, sessionId: S } of e) {
				var C = keyEndToEndInboundGroupSession(x, S);
				b.store.removeItem(C);
			}
		})();
	}
	getEndToEndRooms(e, b) {
		for (var x = {}, S = keyEndToEndRoomsPrefix(""), C = 0; C < this.store.length; ++C) {
			var w = this.store.key(C);
			if (w != null && w.startsWith(S)) {
				var T = w.slice(S.length);
				x[T] = getJsonItem(this.store, w);
			}
		}
		b(x);
	}
	markSessionsNeedingBackup(e) {
		var b = getJsonItem(this.store, KEY_SESSIONS_NEEDING_BACKUP) || {};
		for (var x of e) b[x.senderKey + "/" + x.sessionId] = !0;
		return setJsonItem(this.store, KEY_SESSIONS_NEEDING_BACKUP, b), Promise.resolve();
	}
	deleteAllData() {
		return this.store.removeItem(KEY_END_TO_END_ACCOUNT), Promise.resolve();
	}
	getAccount(e, b) {
		var x = getJsonItem(this.store, KEY_END_TO_END_ACCOUNT);
		b(x);
	}
	storeAccount(e, b) {
		setJsonItem(this.store, KEY_END_TO_END_ACCOUNT, b);
	}
	getCrossSigningKeys(e, b) {
		var x = getJsonItem(this.store, KEY_CROSS_SIGNING_KEYS);
		b(x);
	}
	getSecretStorePrivateKey(e, b, x) {
		var S = getJsonItem(this.store, E2E_PREFIX + `ssss_cache.${x}`);
		b(S);
	}
	storeSecretStorePrivateKey(e, b, x) {
		setJsonItem(this.store, E2E_PREFIX + `ssss_cache.${b}`, x);
	}
	doTxn(e, b, x) {
		return Promise.resolve(x(null));
	}
};
function getJsonItem(e, b) {
	try {
		return JSON.parse(e.getItem(b));
	} catch (e) {
		logger.log("Error: Failed to get key %s: %s", b, e.message), logger.log(e.stack);
	}
	return null;
}
function setJsonItem(e, b, x) {
	e.setItem(b, JSON.stringify(x));
}
var PROFILE_TRANSACTIONS = !1, Backend = class {
	constructor(e) {
		this.db = e, _defineProperty(this, "nextTxnId", 0), e.onversionchange = () => {
			logger.log(`versionchange for indexeddb ${this.db.name}: closing`), e.close();
		};
	}
	containsData() {
		return _asyncToGenerator(function* () {
			throw Error("Not implemented for Backend");
		})();
	}
	startup() {
		var e = this;
		return _asyncToGenerator(function* () {
			return e;
		})();
	}
	deleteAllData() {
		return _asyncToGenerator(function* () {
			throw Error("This is not implemented, call IDBFactory::deleteDatabase(dbName) instead.");
		})();
	}
	getMigrationState() {
		var e = this;
		return _asyncToGenerator(function* () {
			var b = MigrationState.NOT_STARTED;
			return yield e.doTxn("readonly", [IndexedDBCryptoStore.STORE_ACCOUNT], (e) => {
				var x = e.objectStore(IndexedDBCryptoStore.STORE_ACCOUNT).get(ACCOUNT_OBJECT_KEY_MIGRATION_STATE);
				x.onsuccess = () => {
					b = x.result ?? MigrationState.NOT_STARTED;
				};
			}), b;
		})();
	}
	setMigrationState(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			yield b.doTxn("readwrite", [IndexedDBCryptoStore.STORE_ACCOUNT], (b) => {
				b.objectStore(IndexedDBCryptoStore.STORE_ACCOUNT).put(e, ACCOUNT_OBJECT_KEY_MIGRATION_STATE);
			});
		})();
	}
	getAccount(e, b) {
		var x = e.objectStore("account").get("-");
		x.onsuccess = function() {
			try {
				b(x.result || null);
			} catch (b) {
				abortWithException(e, b);
			}
		};
	}
	storeAccount(e, b) {
		e.objectStore("account").put(b, "-");
	}
	getCrossSigningKeys(e, b) {
		var x = e.objectStore("account").get("crossSigningKeys");
		x.onsuccess = function() {
			try {
				b(x.result || null);
			} catch (b) {
				abortWithException(e, b);
			}
		};
	}
	getSecretStorePrivateKey(e, b, x) {
		var S = e.objectStore("account").get(`ssss_cache:${x}`);
		S.onsuccess = function() {
			try {
				b(S.result || null);
			} catch (b) {
				abortWithException(e, b);
			}
		};
	}
	storeSecretStorePrivateKey(e, b, x) {
		e.objectStore("account").put(x, `ssss_cache:${b}`);
	}
	countEndToEndSessions(e, b) {
		var x = e.objectStore("sessions").count();
		x.onsuccess = function() {
			try {
				b(x.result);
			} catch (b) {
				abortWithException(e, b);
			}
		};
	}
	getEndToEndSessions(e, b, x) {
		var S = b.objectStore("sessions").index("deviceKey").openCursor(e), C = {};
		S.onsuccess = function() {
			var e = S.result;
			if (e) C[e.value.sessionId] = {
				session: e.value.session,
				lastReceivedMessageTs: e.value.lastReceivedMessageTs
			}, e.continue();
			else try {
				x(C);
			} catch (e) {
				abortWithException(b, e);
			}
		};
	}
	getEndToEndSession(e, b, x, S) {
		var C = x.objectStore("sessions").get([e, b]);
		C.onsuccess = function() {
			try {
				C.result ? S({
					session: C.result.session,
					lastReceivedMessageTs: C.result.lastReceivedMessageTs
				}) : S(null);
			} catch (e) {
				abortWithException(x, e);
			}
		};
	}
	storeEndToEndSession(e, b, x, S) {
		S.objectStore("sessions").put({
			deviceKey: e,
			sessionId: b,
			session: x.session,
			lastReceivedMessageTs: x.lastReceivedMessageTs
		});
	}
	getEndToEndSessionsBatch() {
		var e = this;
		return _asyncToGenerator(function* () {
			var b = [];
			return yield e.doTxn("readonly", [IndexedDBCryptoStore.STORE_SESSIONS], (e) => {
				var x = e.objectStore(IndexedDBCryptoStore.STORE_SESSIONS).openCursor();
				x.onsuccess = function() {
					try {
						var S = x.result;
						S && (b.push(S.value), b.length < 50 && S.continue());
					} catch (b) {
						abortWithException(e, b);
					}
				};
			}), b.length === 0 ? null : b;
		})();
	}
	deleteEndToEndSessionsBatch(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			yield b.doTxn("readwrite", [IndexedDBCryptoStore.STORE_SESSIONS], /* @__PURE__ */ function() {
				var b = _asyncToGenerator(function* (b) {
					try {
						var x = b.objectStore(IndexedDBCryptoStore.STORE_SESSIONS), S = function* () {
							var e = x.delete([C, w]);
							yield new Promise((b) => {
								e.onsuccess = b;
							});
						};
						for (var { deviceKey: C, sessionId: w } of e) yield* S();
					} catch (e) {
						abortWithException(b, e);
					}
				});
				return function(e) {
					return b.apply(this, arguments);
				};
			}());
		})();
	}
	getEndToEndInboundGroupSession(e, b, x, S) {
		var C = !1, w = !1, T = x.objectStore("inbound_group_sessions").get([e, b]);
		T.onsuccess = function() {
			try {
				C = T.result ? T.result.session : null, w !== !1 && S(C, w);
			} catch (e) {
				abortWithException(x, e);
			}
		};
		var E = x.objectStore("inbound_group_sessions_withheld").get([e, b]);
		E.onsuccess = function() {
			try {
				w = E.result ? E.result.session : null, C !== !1 && S(C, w);
			} catch (e) {
				abortWithException(x, e);
			}
		};
	}
	storeEndToEndInboundGroupSession(e, b, x, S) {
		S.objectStore("inbound_group_sessions").put({
			senderCurve25519Key: e,
			sessionId: b,
			session: x
		});
	}
	countEndToEndInboundGroupSessions() {
		var e = this;
		return _asyncToGenerator(function* () {
			var b = 0;
			return yield e.doTxn("readonly", [IndexedDBCryptoStore.STORE_INBOUND_GROUP_SESSIONS], (e) => {
				var x = e.objectStore(IndexedDBCryptoStore.STORE_INBOUND_GROUP_SESSIONS).count();
				x.onsuccess = () => {
					b = x.result;
				};
			}), b;
		})();
	}
	getEndToEndInboundGroupSessionsBatch() {
		var e = this;
		return _asyncToGenerator(function* () {
			var b = [];
			return yield e.doTxn("readonly", [IndexedDBCryptoStore.STORE_INBOUND_GROUP_SESSIONS, IndexedDBCryptoStore.STORE_BACKUP], (e) => {
				var x = e.objectStore(IndexedDBCryptoStore.STORE_INBOUND_GROUP_SESSIONS), S = e.objectStore(IndexedDBCryptoStore.STORE_BACKUP), C = x.openCursor();
				C.onsuccess = function() {
					try {
						var x = C.result;
						if (x) {
							var w = S.get(x.key);
							w.onsuccess = () => {
								b.push({
									senderKey: x.value.senderCurve25519Key,
									sessionId: x.value.sessionId,
									sessionData: x.value.session,
									needsBackup: w.result !== void 0
								}), b.length < 50 && x.continue();
							};
						}
					} catch (b) {
						abortWithException(e, b);
					}
				};
			}), b.length === 0 ? null : b;
		})();
	}
	deleteEndToEndInboundGroupSessionsBatch(e) {
		var b = this;
		return _asyncToGenerator(function* () {
			yield b.doTxn("readwrite", [IndexedDBCryptoStore.STORE_INBOUND_GROUP_SESSIONS], /* @__PURE__ */ function() {
				var b = _asyncToGenerator(function* (b) {
					try {
						var x = b.objectStore(IndexedDBCryptoStore.STORE_INBOUND_GROUP_SESSIONS), S = function* () {
							var e = x.delete([C, w]);
							yield new Promise((b) => {
								e.onsuccess = b;
							});
						};
						for (var { senderKey: C, sessionId: w } of e) yield* S();
					} catch (e) {
						abortWithException(b, e);
					}
				});
				return function(e) {
					return b.apply(this, arguments);
				};
			}());
		})();
	}
	getEndToEndDeviceData(e, b) {
		var x = e.objectStore("device_data").get("-");
		x.onsuccess = function() {
			try {
				b(x.result || null);
			} catch (b) {
				abortWithException(e, b);
			}
		};
	}
	getEndToEndRooms(e, b) {
		var x = {}, S = e.objectStore("rooms").openCursor();
		S.onsuccess = function() {
			var C = S.result;
			if (C) x[C.key] = C.value, C.continue();
			else try {
				b(x);
			} catch (b) {
				abortWithException(e, b);
			}
		};
	}
	markSessionsNeedingBackup(e, b) {
		var x = this;
		return _asyncToGenerator(function* () {
			b ||= x.db.transaction("sessions_needing_backup", "readwrite");
			var S = b.objectStore("sessions_needing_backup");
			yield Promise.all(e.map((e) => new Promise((b, x) => {
				var C = S.put({
					senderCurve25519Key: e.senderKey,
					sessionId: e.sessionId
				});
				C.onsuccess = b, C.onerror = x;
			})));
		})();
	}
	doTxn(e, b, x) {
		var S = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : logger, C, w;
		if (PROFILE_TRANSACTIONS) {
			var T = this.nextTxnId++;
			C = Date.now(), w = `${e} crypto store transaction ${T} in ${b}`, S.debug(`Starting ${w}`);
		}
		var E = this.db.transaction(b, e), D = promiseifyTxn(E), O = x(E);
		return PROFILE_TRANSACTIONS && D.then(() => {
			var e = Date.now() - C;
			S.debug(`Finished ${w}, took ${e} ms`);
		}, () => {
			var e = Date.now() - C;
			S.error(`Failed ${w}, took ${e} ms`);
		}), D.then(() => O);
	}
}, DB_MIGRATIONS = [
	(e) => {
		createDatabase(e);
	},
	(e) => {
		e.createObjectStore("account");
	},
	(e) => {
		e.createObjectStore("sessions", { keyPath: ["deviceKey", "sessionId"] }).createIndex("deviceKey", "deviceKey");
	},
	(e) => {
		e.createObjectStore("inbound_group_sessions", { keyPath: ["senderCurve25519Key", "sessionId"] });
	},
	(e) => {
		e.createObjectStore("device_data");
	},
	(e) => {
		e.createObjectStore("rooms");
	},
	(e) => {
		e.createObjectStore("sessions_needing_backup", { keyPath: ["senderCurve25519Key", "sessionId"] });
	},
	(e) => {
		e.createObjectStore("inbound_group_sessions_withheld", { keyPath: ["senderCurve25519Key", "sessionId"] });
	},
	(e) => {
		e.createObjectStore("session_problems", { keyPath: ["deviceKey", "time"] }).createIndex("deviceKey", "deviceKey"), e.createObjectStore("notified_error_devices", { keyPath: ["userId", "deviceId"] });
	},
	(e) => {
		e.createObjectStore("shared_history_inbound_group_sessions", { keyPath: ["roomId"] });
	},
	(e) => {
		e.createObjectStore("parked_shared_history", { keyPath: ["roomId"] });
	}
], VERSION = DB_MIGRATIONS.length;
function upgradeDatabase(e, b) {
	logger.log(`Upgrading IndexedDBCryptoStore from version ${b} to ${VERSION}`), DB_MIGRATIONS.forEach((x, S) => {
		b <= S && x(e);
	});
}
function createDatabase(e) {
	var b = e.createObjectStore("outgoingRoomKeyRequests", { keyPath: "requestId" });
	b.createIndex("session", ["requestBody.room_id", "requestBody.session_id"]), b.createIndex("state", "state");
}
function abortWithException(e, b) {
	e._mx_abortexception = b;
	try {
		e.abort();
	} catch {}
}
function promiseifyTxn(e) {
	return new Promise((b, x) => {
		e.oncomplete = () => {
			e._mx_abortexception !== void 0 && x(e._mx_abortexception), b(null);
		}, e.onerror = (b) => {
			e._mx_abortexception === void 0 ? (logger.log("Error performing indexeddb txn", b), x(e.error)) : x(e._mx_abortexception);
		}, e.onabort = (b) => {
			e._mx_abortexception === void 0 ? (logger.log("Error performing indexeddb txn", b), x(e.error)) : x(e._mx_abortexception);
		};
	});
}
var IndexedDBCryptoStore = class e {
	static exists(e, b) {
		return exists(e, b);
	}
	static existsAndIsNotMigrated(b, x) {
		return new Promise((S, C) => {
			var w = !0, T = b.open(x);
			T.onupgradeneeded = () => {
				w = !1;
			}, T.onblocked = () => C(T.error), T.onsuccess = () => {
				var E = T.result;
				if (!w) E.close(), b.deleteDatabase(x), S(!1);
				else {
					var D = E.transaction([e.STORE_ACCOUNT], "readonly").objectStore(e.STORE_ACCOUNT).get(ACCOUNT_OBJECT_KEY_MIGRATION_STATE);
					D.onsuccess = () => {
						var e = D.result ?? MigrationState.NOT_STARTED;
						S(e === MigrationState.NOT_STARTED);
					}, D.onerror = () => {
						C(D.error);
					}, E.close();
				}
			}, T.onerror = () => C(T.error);
		});
	}
	constructor(e, b) {
		this.indexedDB = e, this.dbName = b, _defineProperty(this, "backendPromise", void 0), _defineProperty(this, "backend", void 0);
	}
	containsData() {
		var b = this;
		return _asyncToGenerator(function* () {
			return e.exists(b.indexedDB, b.dbName);
		})();
	}
	startup() {
		return this.backendPromise ||= new Promise((e, b) => {
			if (!this.indexedDB) {
				b(/* @__PURE__ */ Error("no indexeddb support available"));
				return;
			}
			logger.log(`connecting to indexeddb ${this.dbName}`);
			var x = this.indexedDB.open(this.dbName, VERSION);
			x.onupgradeneeded = (e) => {
				var b = x.result, S = e.oldVersion;
				upgradeDatabase(b, S);
			}, x.onblocked = () => {
				logger.log("can't yet open IndexedDBCryptoStore because it is open elsewhere");
			}, x.onerror = (e) => {
				logger.log("Error connecting to indexeddb", e), b(x.error);
			}, x.onsuccess = () => {
				var b = x.result;
				logger.log(`connected to indexeddb ${this.dbName}`), e(new Backend(b));
			};
		}).then((b) => b.doTxn("readonly", [e.STORE_INBOUND_GROUP_SESSIONS, e.STORE_INBOUND_GROUP_SESSIONS_WITHHELD], (e) => {
			b.getEndToEndInboundGroupSession("", "", e, () => {});
		}).then(() => b)).catch((e) => {
			if (e.name === "VersionError") throw logger.warn("Crypto DB is too new for us to use!", e), new InvalidCryptoStoreError(InvalidCryptoStoreState.TooNew);
			logger.warn(`unable to connect to indexeddb ${this.dbName}: falling back to localStorage store: ${e}`);
			try {
				if (!(globalThis.localStorage instanceof Storage)) throw Error("localStorage is not available");
				return new LocalStorageCryptoStore(globalThis.localStorage);
			} catch (e) {
				return logger.warn(`Unable to open localStorage: falling back to in-memory store: ${e}`), new MemoryCryptoStore();
			}
		}).then((e) => (this.backend = e, e)), this.backendPromise;
	}
	deleteAllData() {
		return new Promise((e, b) => {
			if (!this.indexedDB) {
				b(/* @__PURE__ */ Error("no indexeddb support available"));
				return;
			}
			logger.log(`Removing indexeddb instance: ${this.dbName}`);
			var x = this.indexedDB.deleteDatabase(this.dbName);
			x.onblocked = () => {
				logger.log("can't yet delete IndexedDBCryptoStore because it is open elsewhere");
			}, x.onerror = (e) => {
				logger.log("Error deleting data from indexeddb", e), b(x.error);
			}, x.onsuccess = () => {
				logger.log(`Removed indexeddb instance: ${this.dbName}`), e();
			};
		}).catch((e) => {
			logger.warn(`unable to delete IndexedDBCryptoStore: ${e}`);
		});
	}
	getMigrationState() {
		return this.backend.getMigrationState();
	}
	setMigrationState(e) {
		return this.backend.setMigrationState(e);
	}
	getAccount(e, b) {
		this.backend.getAccount(e, b);
	}
	storeAccount(e, b) {
		this.backend.storeAccount(e, b);
	}
	getCrossSigningKeys(e, b) {
		this.backend.getCrossSigningKeys(e, b);
	}
	getSecretStorePrivateKey(e, b, x) {
		this.backend.getSecretStorePrivateKey(e, b, x);
	}
	storeSecretStorePrivateKey(e, b, x) {
		this.backend.storeSecretStorePrivateKey(e, b, x);
	}
	countEndToEndSessions(e, b) {
		this.backend.countEndToEndSessions(e, b);
	}
	getEndToEndSession(e, b, x, S) {
		this.backend.getEndToEndSession(e, b, x, S);
	}
	getEndToEndSessions(e, b, x) {
		this.backend.getEndToEndSessions(e, b, x);
	}
	storeEndToEndSession(e, b, x, S) {
		this.backend.storeEndToEndSession(e, b, x, S);
	}
	countEndToEndInboundGroupSessions() {
		return this.backend.countEndToEndInboundGroupSessions();
	}
	getEndToEndSessionsBatch() {
		return this.backend.getEndToEndSessionsBatch();
	}
	deleteEndToEndSessionsBatch(e) {
		return this.backend.deleteEndToEndSessionsBatch(e);
	}
	getEndToEndInboundGroupSession(e, b, x, S) {
		this.backend.getEndToEndInboundGroupSession(e, b, x, S);
	}
	storeEndToEndInboundGroupSession(e, b, x, S) {
		this.backend.storeEndToEndInboundGroupSession(e, b, x, S);
	}
	getEndToEndInboundGroupSessionsBatch() {
		return this.backend.getEndToEndInboundGroupSessionsBatch();
	}
	deleteEndToEndInboundGroupSessionsBatch(e) {
		return this.backend.deleteEndToEndInboundGroupSessionsBatch(e);
	}
	getEndToEndRooms(e, b) {
		this.backend.getEndToEndRooms(e, b);
	}
	markSessionsNeedingBackup(e, b) {
		return this.backend.markSessionsNeedingBackup(e, b);
	}
	doTxn(e, b, x, S) {
		return this.backend.doTxn(e, b, x, S);
	}
};
_defineProperty(IndexedDBCryptoStore, "STORE_ACCOUNT", "account"), _defineProperty(IndexedDBCryptoStore, "STORE_SESSIONS", "sessions"), _defineProperty(IndexedDBCryptoStore, "STORE_INBOUND_GROUP_SESSIONS", "inbound_group_sessions"), _defineProperty(IndexedDBCryptoStore, "STORE_INBOUND_GROUP_SESSIONS_WITHHELD", "inbound_group_sessions_withheld"), _defineProperty(IndexedDBCryptoStore, "STORE_SHARED_HISTORY_INBOUND_GROUP_SESSIONS", "shared_history_inbound_group_sessions"), _defineProperty(IndexedDBCryptoStore, "STORE_PARKED_SHARED_HISTORY", "parked_shared_history"), _defineProperty(IndexedDBCryptoStore, "STORE_DEVICE_DATA", "device_data"), _defineProperty(IndexedDBCryptoStore, "STORE_ROOMS", "rooms"), _defineProperty(IndexedDBCryptoStore, "STORE_BACKUP", "sessions_needing_backup");
export { InvalidCryptoStoreError as $, content_helpers_exports as $n, deepCopy as $r, CallEvent as $t, UNSTABLE_MSC4133_EXTENDED_PROFILES as A, parseErrorResponse as An, RelationType as Ar, HistoryVisibility as At, validateAuthMetadataAndKeys as B, Method as Bn, UNSTABLE_MSC3089_BRANCH as Br, AutoDiscoveryAction as Bt, MatrixClient as C, ServerCapabilities as Cn, EVENT_VISIBILITY_CHANGE_TYPE as Cr, M_BEACON as Ct, UNSTABLE_MSC2666_QUERY_MUTUAL_ROOMS as D, MediaPrefix as Dn, MsgType as Dr, MediaHandlerEvent as Dt, UNSTABLE_MSC2666_MUTUAL_ROOMS as E, IdentityPrefix as En, MSC3912_RELATION_BASED_REDACTIONS_PROP as Er, SlidingSyncEvent as Et, threadIdForReceipt as F, HTTPError as Fn, UNSIGNED_THREAD_ID_FIELD as Fr, UpdateDelayedEventAction as Ft, generateScope as G, M_POLL_KIND_DISCLOSED as Gn, require_events$1 as Gr, ConditionKind as Gt, generateAuthorizationParams as H, PollEvent as Hn, UNSTABLE_MSC3089_TREE_SUBTYPE as Hr, MAXIMUM_MATRIX_VERSION as Ht, OidcTokenRefresher as I, MatrixError as In, UNSTABLE_ELEMENT_FUNCTIONAL_USERS as Ir, isSendDelayedEventRequestOpts as It, validateBearerTokenResponse as J, M_POLL_START$2 as Jn, logger as Jr, PushRuleActionName as Jt, decodeIdToken as K, M_POLL_KIND_UNDISCLOSED as Kn, DebugLogger as Kr, ConditionOperator as Kt, DEVICE_CODE_SCOPE as L, TokenRefreshError as Ln, UNSTABLE_MSC2716_MARKER as Lr, SearchResult as Lt, UNSTABLE_MSC4354_STICKY_EVENTS as M, timeoutSignal as Mn, RoomType as Mr, Preset as Mt, fixNotificationCountOnDecryption as N, HttpApiEvent as Nn, ToDeviceMessageId as Nr, RestrictedAllowType as Nt, UNSTABLE_MSC2666_SHARED_ROOMS as O, anySignal as On, PUSHER_DEVICE_ID as Or, SearchOrderBy as Ot, inMainTimelineForReceipt as P, ConnectionError as Pn, UNSIGNED_MEMBERSHIP_FIELD as Pr, Visibility as Pt, ClientStoppedError as Q, isTimestampInDuration as Qn, MapWithDefault as Qr, isDmMemberCountCondition as Qt, registerOidcClient as R, TokenRefreshLogoutError as Rn, UNSTABLE_MSC3088_ENABLED as Rr, SERVICE_TYPES as Rt, GET_LOGIN_TOKEN_CAPABILITY as S, RoomVersionStability as Sn, KnownMembership as Sr, MatrixScheduler as St, STABLE_MSC4133_EXTENDED_PROFILES as T, ClientPrefix as Tn, LOCAL_NOTIFICATION_SETTINGS_PREFIX as Tr, SlidingSyncSdk as Tt, generateAuthorizationUrl as U, isPollEvent as Un, EventEmitterEvents as Ur, MINIMUM_MATRIX_VERSION as Ut, completeAuthorizationCodeGrant as V, Poll as Vn, UNSTABLE_MSC3089_LEAF as Vr, AutoDiscoveryError as Vt, generateOidcAuthorizationUrl as W, M_POLL_END as Wn, TypedEventEmitter as Wr, SUPPORTED_MATRIX_VERSIONS as Wt, validateStoredUserState as X, BeaconEvent as Xn, MemoryCryptoStore as Xr, RuleId as Xt, validateIdToken as Y, Beacon as Yn, getHttpUriForMxc as Yr, PushRuleKind as Yt, OidcError as Z, getBeaconInfoIdentifier as Zn, MigrationState as Zr, TweakName as Zt, ThreadEvent as _, __toESM as _i, KNOWN_SAFE_ROOM_VERSION as _n, User as _r, deriveRecoveryKeyFromPassphrase as _t, DeviceVerification as a, sleep as ai, GroupCallStatsReportEvent as an, isEventTypeSame as ar, secret_storage_exports as at, threadFilterTypeToFilter as b, RoomEvent as bn, RoomMember as br, VerificationRequestEvent as bt, MAX_STICKY_DURATION_MS as c, LocationAssetType as ci, CallFeedEvent as cn, TypedReEmitter as cr, CrossSigningKey as ct, DecryptionError as d, M_TIMESTAMP as di, encodeBase64 as dn, DuplicateStrategy as dr, DeviceVerificationStatus as dt, encodeUri as ei, createNewMatrixCall as en, M_TOPIC as er, InvalidCryptoStoreState as et, FILTER_RELATED_BY_REL_TYPES as f, UnstableValue as fi, encodeUnpaddedBase64 as fn, EventTimelineSet as fr, EventShieldColour as ft, Thread as g, __export as gi, SyncState as gn, EventTimeline as gr, CryptoEvent as gt, THREAD_RELATION_TYPE as h, __commonJSMin as hi, SyncApi as hn, Direction as hr, UserVerificationStatus as ht, Device as i, recursiveMapToObject as ii, GroupCallState as in, REFERENCE_RELATION as ir, SECRET_STORAGE_ALGORITHM_V1_AES as it, UNSTABLE_MSC4140_DELAYED_EVENTS as j, retryNetworkOperation as jn, RoomCreateTypeField as jr, JoinRule as jt, UNSTABLE_MSC3852_LAST_SEEN_UA as k, calculateRetryBackoff as kn, PUSHER_ENABLED as kr, GuestAccess as kt, MatrixEvent as l, M_ASSET as li, secureRandomString as ln, RoomSummary as lr, DecryptionFailureCode as lt, FeatureSupport as m, _asyncToGenerator as mi, SetPresence as mn, RelationsEvent as mr, ImportRoomKeyStage as mt, LocalStorageCryptoStore as n, logDuration as ni, GroupCallEvent as nn, M_MESSAGE as nr, UnsupportedDelayedEventsEndpointError as nt, RoomState as o, MAIN_ROOM_TIMELINE as oi, GroupCallType as on, Filter as or, decryptAESSecretStorageItem as ot, FILTER_RELATED_BY_SENDERS as p, _defineProperty as pi, encodeUnpaddedBase64Url as pn, Relations as pr, EventShieldReason as pt, validateAuthMetadata as q, M_POLL_RESPONSE as qn, LogSpan as qr, DMMemberCountCondition as qt, exists as r, promiseTry as ri, GroupCallIntent as rn, M_TEXT as rr, UnsupportedStickyEventsEndpointError as rt, RoomStateEvent as s, ReceiptType as si, StatsReport as sn, UNREAD_THREAD_NOTIFICATIONS as sr, AllDevicesIsolationMode as st, IndexedDBCryptoStore as t, isSupportedReceiptType as ti, GroupCall as tn, M_HTML as tr, KeySignatureUploadError as tt, MatrixEventEvent as u, M_LOCATION as ui, decodeBase64 as un, EventStatus as ur, DeviceIsolationModeKind as ut, ThreadFilterType as v, NotificationCountType as vn, UserEvent as vr, encodeRecoveryKey as vt, PendingEventOrdering as w, MatrixHttpApi as wn, EventType as wr, M_BEACON_INFO as wt, ClientEvent as x, RoomNameType as xn, RoomMemberEvent as xr, VerifierEvent as xt, determineFeatureSupport as y, Room as yn, MXID_PATTERN as yr, VerificationPhase as yt, discoverAndValidateOIDCIssuerWellKnown as z, safeGetRetryAfterMs as zn, UNSTABLE_MSC3088_PURPOSE as zr, AutoDiscovery as zt };
